import * as React$1 from "react";
import React__default, { useMemo, useState, useCallback, useRef, useEffect, createContext, forwardRef, useContext, Children, isValidElement, cloneElement } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a2 = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
    );
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var _pt = propTypes.exports;
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames() {
      var classes = "";
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key in arg) {
        if (hasOwn2.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module2.exports) {
      classNames.default = classNames;
      module2.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var cx = classnames.exports;
var _excluded$W = ["top", "left", "transform", "className", "children", "innerRef"];
function _extends$P() {
  _extends$P = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$P.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$A(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Group(_ref) {
  var _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, transform2 = _ref.transform, className = _ref.className, children2 = _ref.children, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose$A(_ref, _excluded$W);
  return /* @__PURE__ */ React__default.createElement("g", _extends$P({
    ref: innerRef,
    className: cx("visx-group", className),
    transform: transform2 || "translate(" + left2 + ", " + top2 + ")"
  }, restProps), children2);
}
Group.propTypes = {
  top: _pt.number,
  left: _pt.number,
  transform: _pt.string,
  className: _pt.string,
  children: _pt.node,
  innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object])
};
var esm$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Group
}, Symbol.toStringTag, { value: "Module" }));
var pi$6 = Math.PI, tau$7 = 2 * pi$6, epsilon$7 = 1e-6, tauEpsilon$1 = tau$7 - epsilon$7;
function Path$2() {
  this._x0 = this._y0 = this._x1 = this._y1 = null;
  this._ = "";
}
function path$1() {
  return new Path$2();
}
Path$2.prototype = path$1.prototype = {
  constructor: Path$2,
  moveTo: function(x2, y2) {
    this._ += "M" + (this._x0 = this._x1 = +x2) + "," + (this._y0 = this._y1 = +y2);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x2, y2) {
    this._ += "L" + (this._x1 = +x2) + "," + (this._y1 = +y2);
  },
  quadraticCurveTo: function(x12, y12, x2, y2) {
    this._ += "Q" + +x12 + "," + +y12 + "," + (this._x1 = +x2) + "," + (this._y1 = +y2);
  },
  bezierCurveTo: function(x12, y12, x2, y2, x3, y3) {
    this._ += "C" + +x12 + "," + +y12 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x3) + "," + (this._y1 = +y3);
  },
  arcTo: function(x12, y12, x2, y2, r2) {
    x12 = +x12, y12 = +y12, x2 = +x2, y2 = +y2, r2 = +r2;
    var x02 = this._x1, y02 = this._y1, x21 = x2 - x12, y21 = y2 - y12, x01 = x02 - x12, y01 = y02 - y12, l01_2 = x01 * x01 + y01 * y01;
    if (r2 < 0)
      throw new Error("negative radius: " + r2);
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x12) + "," + (this._y1 = y12);
    } else if (!(l01_2 > epsilon$7))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$7) || !r2) {
      this._ += "L" + (this._x1 = x12) + "," + (this._y1 = y12);
    } else {
      var x20 = x2 - x02, y20 = y2 - y02, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi$6 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon$7) {
        this._ += "L" + (x12 + t01 * x01) + "," + (y12 + t01 * y01);
      }
      this._ += "A" + r2 + "," + r2 + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x12 + t21 * x21) + "," + (this._y1 = y12 + t21 * y21);
    }
  },
  arc: function(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    var dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x02 = x2 + dx, y02 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (r2 < 0)
      throw new Error("negative radius: " + r2);
    if (this._x1 === null) {
      this._ += "M" + x02 + "," + y02;
    } else if (Math.abs(this._x1 - x02) > epsilon$7 || Math.abs(this._y1 - y02) > epsilon$7) {
      this._ += "L" + x02 + "," + y02;
    }
    if (!r2)
      return;
    if (da < 0)
      da = da % tau$7 + tau$7;
    if (da > tauEpsilon$1) {
      this._ += "A" + r2 + "," + r2 + ",0,1," + cw + "," + (x2 - dx) + "," + (y2 - dy) + "A" + r2 + "," + r2 + ",0,1," + cw + "," + (this._x1 = x02) + "," + (this._y1 = y02);
    } else if (da > epsilon$7) {
      this._ += "A" + r2 + "," + r2 + ",0," + +(da >= pi$6) + "," + cw + "," + (this._x1 = x2 + r2 * Math.cos(a1)) + "," + (this._y1 = y2 + r2 * Math.sin(a1));
    }
  },
  rect: function(x2, y2, w2, h2) {
    this._ += "M" + (this._x0 = this._x1 = +x2) + "," + (this._y0 = this._y1 = +y2) + "h" + +w2 + "v" + +h2 + "h" + -w2 + "Z";
  },
  toString: function() {
    return this._;
  }
};
function constant$h(x2) {
  return function constant2() {
    return x2;
  };
}
var abs$5 = Math.abs;
var atan2$2 = Math.atan2;
var cos$3 = Math.cos;
var max$7 = Math.max;
var min$5 = Math.min;
var sin$3 = Math.sin;
var sqrt$4 = Math.sqrt;
var epsilon$6 = 1e-12;
var pi$5 = Math.PI;
var halfPi$4 = pi$5 / 2;
var tau$6 = 2 * pi$5;
function acos$2(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi$5 : Math.acos(x2);
}
function asin$2(x2) {
  return x2 >= 1 ? halfPi$4 : x2 <= -1 ? -halfPi$4 : Math.asin(x2);
}
function arcInnerRadius$1(d2) {
  return d2.innerRadius;
}
function arcOuterRadius$1(d2) {
  return d2.outerRadius;
}
function arcStartAngle$1(d2) {
  return d2.startAngle;
}
function arcEndAngle$1(d2) {
  return d2.endAngle;
}
function arcPadAngle$1(d2) {
  return d2 && d2.padAngle;
}
function intersect$1(x02, y02, x12, y12, x2, y2, x3, y3) {
  var x10 = x12 - x02, y10 = y12 - y02, x32 = x3 - x2, y32 = y3 - y2, t4 = y32 * x10 - x32 * y10;
  if (t4 * t4 < epsilon$6)
    return;
  t4 = (x32 * (y02 - y2) - y32 * (x02 - x2)) / t4;
  return [x02 + t4 * x10, y02 + t4 * y10];
}
function cornerTangents$1(x02, y02, x12, y12, r1, rc, cw) {
  var x01 = x02 - x12, y01 = y02 - y12, lo = (cw ? rc : -rc) / sqrt$4(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x02 + ox, y11 = y02 + oy, x10 = x12 + ox, y10 = y12 + oy, x002 = (x11 + x10) / 2, y002 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r2 = r1 - rc, D2 = x11 * y10 - x10 * y11, d4 = (dy < 0 ? -1 : 1) * sqrt$4(max$7(0, r2 * r2 * d2 - D2 * D2)), cx0 = (D2 * dy - dx * d4) / d2, cy0 = (-D2 * dx - dy * d4) / d2, cx1 = (D2 * dy + dx * d4) / d2, cy1 = (-D2 * dx + dy * d4) / d2, dx0 = cx0 - x002, dy0 = cy0 - y002, dx1 = cx1 - x002, dy1 = cy1 - y002;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
    cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r2 - 1),
    y11: cy0 * (r1 / r2 - 1)
  };
}
function d3Arc() {
  var innerRadius = arcInnerRadius$1, outerRadius = arcOuterRadius$1, cornerRadius = constant$h(0), padRadius = null, startAngle = arcStartAngle$1, endAngle = arcEndAngle$1, padAngle = arcPadAngle$1, context = null;
  function arc2() {
    var buffer2, r2, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi$4, a1 = endAngle.apply(this, arguments) - halfPi$4, da = abs$5(a1 - a0), cw = a1 > a0;
    if (!context)
      context = buffer2 = path$1();
    if (r1 < r0)
      r2 = r1, r1 = r0, r0 = r2;
    if (!(r1 > epsilon$6))
      context.moveTo(0, 0);
    else if (da > tau$6 - epsilon$6) {
      context.moveTo(r1 * cos$3(a0), r1 * sin$3(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$6) {
        context.moveTo(r0 * cos$3(a1), r0 * sin$3(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon$6 && (padRadius ? +padRadius.apply(this, arguments) : sqrt$4(r0 * r0 + r1 * r1)), rc = min$5(abs$5(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t02, t12;
      if (rp > epsilon$6) {
        var p02 = asin$2(rp / r0 * sin$3(ap)), p1 = asin$2(rp / r1 * sin$3(ap));
        if ((da0 -= p02 * 2) > epsilon$6)
          p02 *= cw ? 1 : -1, a00 += p02, a10 -= p02;
        else
          da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$6)
          p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else
          da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos$3(a01), y01 = r1 * sin$3(a01), x10 = r0 * cos$3(a10), y10 = r0 * sin$3(a10);
      if (rc > epsilon$6) {
        var x11 = r1 * cos$3(a11), y11 = r1 * sin$3(a11), x002 = r0 * cos$3(a00), y002 = r0 * sin$3(a00), oc;
        if (da < pi$5 && (oc = intersect$1(x01, y01, x002, y002, x11, y11, x10, y10))) {
          var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin$3(acos$2((ax * bx + ay * by) / (sqrt$4(ax * ax + ay * ay) * sqrt$4(bx * bx + by * by))) / 2), lc = sqrt$4(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$5(rc, (r0 - lc) / (kc - 1));
          rc1 = min$5(rc, (r1 - lc) / (kc + 1));
        }
      }
      if (!(da1 > epsilon$6))
        context.moveTo(x01, y01);
      else if (rc1 > epsilon$6) {
        t02 = cornerTangents$1(x002, y002, x01, y01, r1, rc1, cw);
        t12 = cornerTangents$1(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc1 < rc)
          context.arc(t02.cx, t02.cy, rc1, atan2$2(t02.y01, t02.x01), atan2$2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc1, atan2$2(t02.y01, t02.x01), atan2$2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r1, atan2$2(t02.cy + t02.y11, t02.cx + t02.x11), atan2$2(t12.cy + t12.y11, t12.cx + t12.x11), !cw);
          context.arc(t12.cx, t12.cy, rc1, atan2$2(t12.y11, t12.x11), atan2$2(t12.y01, t12.x01), !cw);
        }
      } else
        context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon$6) || !(da0 > epsilon$6))
        context.lineTo(x10, y10);
      else if (rc0 > epsilon$6) {
        t02 = cornerTangents$1(x10, y10, x11, y11, r0, -rc0, cw);
        t12 = cornerTangents$1(x01, y01, x002, y002, r0, -rc0, cw);
        context.lineTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc0 < rc)
          context.arc(t02.cx, t02.cy, rc0, atan2$2(t02.y01, t02.x01), atan2$2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc0, atan2$2(t02.y01, t02.x01), atan2$2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r0, atan2$2(t02.cy + t02.y11, t02.cx + t02.x11), atan2$2(t12.cy + t12.y11, t12.cx + t12.x11), cw);
          context.arc(t12.cx, t12.cy, rc0, atan2$2(t12.y11, t12.x11), atan2$2(t12.y01, t12.x01), !cw);
        }
      } else
        context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  arc2.centroid = function() {
    var r2 = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a2 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$5 / 2;
    return [cos$3(a2) * r2, sin$3(a2) * r2];
  };
  arc2.innerRadius = function(_2) {
    return arguments.length ? (innerRadius = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_2) {
    return arguments.length ? (outerRadius = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_2) {
    return arguments.length ? (cornerRadius = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_2) {
    return arguments.length ? (padRadius = _2 == null ? null : typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : padRadius;
  };
  arc2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : startAngle;
  };
  arc2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : endAngle;
  };
  arc2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$h(+_2), arc2) : padAngle;
  };
  arc2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, arc2) : context;
  };
  return arc2;
}
function Linear$1(context) {
  this._context = context;
}
Linear$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear$1(context) {
  return new Linear$1(context);
}
function x$5(p2) {
  return p2[0];
}
function y$5(p2) {
  return p2[1];
}
function d3Line() {
  var x2 = x$5, y2 = y$5, defined = constant$h(true), context = null, curve = curveLinear$1, output = null;
  function line2(data) {
    var i, n2 = data.length, d2, defined0 = false, buffer2;
    if (context == null)
      output = curve(buffer2 = path$1());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data[i], i, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x2(d2, i, data), +y2(d2, i, data));
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  line2.x = function(_2) {
    return arguments.length ? (x2 = typeof _2 === "function" ? _2 : constant$h(+_2), line2) : x2;
  };
  line2.y = function(_2) {
    return arguments.length ? (y2 = typeof _2 === "function" ? _2 : constant$h(+_2), line2) : y2;
  };
  line2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$h(!!_2), line2) : defined;
  };
  line2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), line2) : context;
  };
  return line2;
}
function d3Area() {
  var x02 = x$5, x12 = null, y02 = constant$h(0), y12 = y$5, defined = constant$h(true), context = null, curve = curveLinear$1, output = null;
  function area2(data) {
    var i, j, k2, n2 = data.length, d2, defined0 = false, buffer2, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null)
      output = curve(buffer2 = path$1());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i - 1; k2 >= j; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x02(d2, i, data), y0z[i] = +y02(d2, i, data);
        output.point(x12 ? +x12(d2, i, data) : x0z[i], y12 ? +y12(d2, i, data) : y0z[i]);
      }
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  function arealine() {
    return d3Line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_2) {
    return arguments.length ? (x02 = typeof _2 === "function" ? _2 : constant$h(+_2), x12 = null, area2) : x02;
  };
  area2.x0 = function(_2) {
    return arguments.length ? (x02 = typeof _2 === "function" ? _2 : constant$h(+_2), area2) : x02;
  };
  area2.x1 = function(_2) {
    return arguments.length ? (x12 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$h(+_2), area2) : x12;
  };
  area2.y = function(_2) {
    return arguments.length ? (y02 = typeof _2 === "function" ? _2 : constant$h(+_2), y12 = null, area2) : y02;
  };
  area2.y0 = function(_2) {
    return arguments.length ? (y02 = typeof _2 === "function" ? _2 : constant$h(+_2), area2) : y02;
  };
  area2.y1 = function(_2) {
    return arguments.length ? (y12 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$h(+_2), area2) : y12;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x02).y(y02);
  };
  area2.lineY1 = function() {
    return arealine().x(x02).y(y12);
  };
  area2.lineX1 = function() {
    return arealine().x(x12).y(y02);
  };
  area2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$h(!!_2), area2) : defined;
  };
  area2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), area2) : context;
  };
  return area2;
}
function descending$4(a2, b10) {
  return b10 < a2 ? -1 : b10 > a2 ? 1 : b10 >= a2 ? 0 : NaN;
}
function identity$g(d2) {
  return d2;
}
function d3Pie() {
  var value = identity$g, sortValues = descending$4, sort2 = null, startAngle = constant$h(0), endAngle = constant$h(tau$6), padAngle = constant$h(0);
  function pie2(data) {
    var i, n2 = data.length, j, k2, sum2 = 0, index2 = new Array(n2), arcs = new Array(n2), a0 = +startAngle.apply(this, arguments), da = Math.min(tau$6, Math.max(-tau$6, endAngle.apply(this, arguments) - a0)), a1, p2 = Math.min(Math.abs(da) / n2, padAngle.apply(this, arguments)), pa = p2 * (da < 0 ? -1 : 1), v2;
    for (i = 0; i < n2; ++i) {
      if ((v2 = arcs[index2[i] = i] = +value(data[i], i, data)) > 0) {
        sum2 += v2;
      }
    }
    if (sortValues != null)
      index2.sort(function(i2, j2) {
        return sortValues(arcs[i2], arcs[j2]);
      });
    else if (sort2 != null)
      index2.sort(function(i2, j2) {
        return sort2(data[i2], data[j2]);
      });
    for (i = 0, k2 = sum2 ? (da - n2 * pa) / sum2 : 0; i < n2; ++i, a0 = a1) {
      j = index2[i], v2 = arcs[j], a1 = a0 + (v2 > 0 ? v2 * k2 : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v2,
        startAngle: a0,
        endAngle: a1,
        padAngle: p2
      };
    }
    return arcs;
  }
  pie2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$h(+_2), pie2) : value;
  };
  pie2.sortValues = function(_2) {
    return arguments.length ? (sortValues = _2, sort2 = null, pie2) : sortValues;
  };
  pie2.sort = function(_2) {
    return arguments.length ? (sort2 = _2, sortValues = null, pie2) : sort2;
  };
  pie2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$h(+_2), pie2) : startAngle;
  };
  pie2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$h(+_2), pie2) : endAngle;
  };
  pie2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$h(+_2), pie2) : padAngle;
  };
  return pie2;
}
var curveRadialLinear$1 = curveRadial$3(curveLinear$1);
function Radial$1(curve) {
  this._curve = curve;
}
Radial$1.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a2, r2) {
    this._curve.point(r2 * Math.sin(a2), r2 * -Math.cos(a2));
  }
};
function curveRadial$3(curve) {
  function radial2(context) {
    return new Radial$1(curve(context));
  }
  radial2._curve = curve;
  return radial2;
}
function lineRadial$2(l2) {
  var c2 = l2.curve;
  l2.angle = l2.x, delete l2.x;
  l2.radius = l2.y, delete l2.y;
  l2.curve = function(_2) {
    return arguments.length ? c2(curveRadial$3(_2)) : c2()._curve;
  };
  return l2;
}
function d3RadialLine() {
  return lineRadial$2(d3Line().curve(curveRadialLinear$1));
}
function areaRadial$1() {
  var a2 = d3Area().curve(curveRadialLinear$1), c2 = a2.curve, x02 = a2.lineX0, x12 = a2.lineX1, y02 = a2.lineY0, y12 = a2.lineY1;
  a2.angle = a2.x, delete a2.x;
  a2.startAngle = a2.x0, delete a2.x0;
  a2.endAngle = a2.x1, delete a2.x1;
  a2.radius = a2.y, delete a2.y;
  a2.innerRadius = a2.y0, delete a2.y0;
  a2.outerRadius = a2.y1, delete a2.y1;
  a2.lineStartAngle = function() {
    return lineRadial$2(x02());
  }, delete a2.lineX0;
  a2.lineEndAngle = function() {
    return lineRadial$2(x12());
  }, delete a2.lineX1;
  a2.lineInnerRadius = function() {
    return lineRadial$2(y02());
  }, delete a2.lineY0;
  a2.lineOuterRadius = function() {
    return lineRadial$2(y12());
  }, delete a2.lineY1;
  a2.curve = function(_2) {
    return arguments.length ? c2(curveRadial$3(_2)) : c2()._curve;
  };
  return a2;
}
function pointRadial$1(x2, y2) {
  return [(y2 = +y2) * Math.cos(x2 -= Math.PI / 2), y2 * Math.sin(x2)];
}
var slice$6 = Array.prototype.slice;
function linkSource$1(d2) {
  return d2.source;
}
function linkTarget$1(d2) {
  return d2.target;
}
function link$3(curve) {
  var source = linkSource$1, target = linkTarget$1, x2 = x$5, y2 = y$5, context = null;
  function link2() {
    var buffer2, argv = slice$6.call(arguments), s2 = source.apply(this, argv), t4 = target.apply(this, argv);
    if (!context)
      context = buffer2 = path$1();
    curve(context, +x2.apply(this, (argv[0] = s2, argv)), +y2.apply(this, argv), +x2.apply(this, (argv[0] = t4, argv)), +y2.apply(this, argv));
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  link2.source = function(_2) {
    return arguments.length ? (source = _2, link2) : source;
  };
  link2.target = function(_2) {
    return arguments.length ? (target = _2, link2) : target;
  };
  link2.x = function(_2) {
    return arguments.length ? (x2 = typeof _2 === "function" ? _2 : constant$h(+_2), link2) : x2;
  };
  link2.y = function(_2) {
    return arguments.length ? (y2 = typeof _2 === "function" ? _2 : constant$h(+_2), link2) : y2;
  };
  link2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, link2) : context;
  };
  return link2;
}
function curveHorizontal$1(context, x02, y02, x12, y12) {
  context.moveTo(x02, y02);
  context.bezierCurveTo(x02 = (x02 + x12) / 2, y02, x02, y12, x12, y12);
}
function curveVertical$1(context, x02, y02, x12, y12) {
  context.moveTo(x02, y02);
  context.bezierCurveTo(x02, y02 = (y02 + y12) / 2, x12, y02, x12, y12);
}
function curveRadial$2(context, x02, y02, x12, y12) {
  var p02 = pointRadial$1(x02, y02), p1 = pointRadial$1(x02, y02 = (y02 + y12) / 2), p2 = pointRadial$1(x12, y02), p3 = pointRadial$1(x12, y12);
  context.moveTo(p02[0], p02[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function linkHorizontal$1() {
  return link$3(curveHorizontal$1);
}
function linkVertical$1() {
  return link$3(curveVertical$1);
}
function linkRadial$1() {
  var l2 = link$3(curveRadial$2);
  l2.angle = l2.x, delete l2.x;
  l2.radius = l2.y, delete l2.y;
  return l2;
}
var circle$3 = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / pi$5);
    context.moveTo(r2, 0);
    context.arc(0, 0, r2, 0, tau$6);
  }
};
var cross$3 = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r2, -r2);
    context.lineTo(-r2, -r2);
    context.lineTo(-r2, -3 * r2);
    context.lineTo(r2, -3 * r2);
    context.lineTo(r2, -r2);
    context.lineTo(3 * r2, -r2);
    context.lineTo(3 * r2, r2);
    context.lineTo(r2, r2);
    context.lineTo(r2, 3 * r2);
    context.lineTo(-r2, 3 * r2);
    context.lineTo(-r2, r2);
    context.lineTo(-3 * r2, r2);
    context.closePath();
  }
};
var tan30$1 = Math.sqrt(1 / 3), tan30_2$1 = tan30$1 * 2;
var diamond$1 = {
  draw: function(context, size) {
    var y2 = Math.sqrt(size / tan30_2$1), x2 = y2 * tan30$1;
    context.moveTo(0, -y2);
    context.lineTo(x2, 0);
    context.lineTo(0, y2);
    context.lineTo(-x2, 0);
    context.closePath();
  }
};
var ka$1 = 0.8908130915292852, kr$1 = Math.sin(pi$5 / 10) / Math.sin(7 * pi$5 / 10), kx$1 = Math.sin(tau$6 / 10) * kr$1, ky$1 = -Math.cos(tau$6 / 10) * kr$1;
var star$1 = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size * ka$1), x2 = kx$1 * r2, y2 = ky$1 * r2;
    context.moveTo(0, -r2);
    context.lineTo(x2, y2);
    for (var i = 1; i < 5; ++i) {
      var a2 = tau$6 * i / 5, c2 = Math.cos(a2), s2 = Math.sin(a2);
      context.lineTo(s2 * r2, -c2 * r2);
      context.lineTo(c2 * x2 - s2 * y2, s2 * x2 + c2 * y2);
    }
    context.closePath();
  }
};
var square$3 = {
  draw: function(context, size) {
    var w2 = Math.sqrt(size), x2 = -w2 / 2;
    context.rect(x2, x2, w2, w2);
  }
};
var sqrt3$1 = Math.sqrt(3);
var triangle$1 = {
  draw: function(context, size) {
    var y2 = -Math.sqrt(size / (sqrt3$1 * 3));
    context.moveTo(0, y2 * 2);
    context.lineTo(-sqrt3$1 * y2, -y2);
    context.lineTo(sqrt3$1 * y2, -y2);
    context.closePath();
  }
};
var c$5 = -0.5, s$1 = Math.sqrt(3) / 2, k$3 = 1 / Math.sqrt(12), a$2 = (k$3 / 2 + 1) * 3;
var wye$1 = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / a$2), x02 = r2 / 2, y02 = r2 * k$3, x12 = x02, y12 = r2 * k$3 + r2, x2 = -x12, y2 = y12;
    context.moveTo(x02, y02);
    context.lineTo(x12, y12);
    context.lineTo(x2, y2);
    context.lineTo(c$5 * x02 - s$1 * y02, s$1 * x02 + c$5 * y02);
    context.lineTo(c$5 * x12 - s$1 * y12, s$1 * x12 + c$5 * y12);
    context.lineTo(c$5 * x2 - s$1 * y2, s$1 * x2 + c$5 * y2);
    context.lineTo(c$5 * x02 + s$1 * y02, c$5 * y02 - s$1 * x02);
    context.lineTo(c$5 * x12 + s$1 * y12, c$5 * y12 - s$1 * x12);
    context.lineTo(c$5 * x2 + s$1 * y2, c$5 * y2 - s$1 * x2);
    context.closePath();
  }
};
var symbols$1 = [
  circle$3,
  cross$3,
  diamond$1,
  square$3,
  star$1,
  triangle$1,
  wye$1
];
function symbol$1() {
  var type2 = constant$h(circle$3), size = constant$h(64), context = null;
  function symbol2() {
    var buffer2;
    if (!context)
      context = buffer2 = path$1();
    type2.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  symbol2.type = function(_2) {
    return arguments.length ? (type2 = typeof _2 === "function" ? _2 : constant$h(_2), symbol2) : type2;
  };
  symbol2.size = function(_2) {
    return arguments.length ? (size = typeof _2 === "function" ? _2 : constant$h(+_2), symbol2) : size;
  };
  symbol2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, symbol2) : context;
  };
  return symbol2;
}
function noop$6() {
}
function point$9(that, x2, y2) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x2) / 6,
    (that._y0 + 4 * that._y1 + y2) / 6
  );
}
function Basis$1(context) {
  this._context = context;
}
Basis$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$9(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point$9(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basis$7(context) {
  return new Basis$1(context);
}
function BasisClosed$1(context) {
  this._context = context;
}
BasisClosed$1.prototype = {
  areaStart: noop$6,
  areaEnd: noop$6,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x2, this._y2 = y2;
        break;
      case 1:
        this._point = 2;
        this._x3 = x2, this._y3 = y2;
        break;
      case 2:
        this._point = 3;
        this._x4 = x2, this._y4 = y2;
        this._context.moveTo((this._x0 + 4 * this._x1 + x2) / 6, (this._y0 + 4 * this._y1 + y2) / 6);
        break;
      default:
        point$9(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisClosed$3(context) {
  return new BasisClosed$1(context);
}
function BasisOpen$1(context) {
  this._context = context;
}
BasisOpen$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x02 = (this._x0 + 4 * this._x1 + x2) / 6, y02 = (this._y0 + 4 * this._y1 + y2) / 6;
        this._line ? this._context.lineTo(x02, y02) : this._context.moveTo(x02, y02);
        break;
      case 3:
        this._point = 4;
      default:
        point$9(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisOpen$1(context) {
  return new BasisOpen$1(context);
}
function Bundle$1(context, beta2) {
  this._basis = new Basis$1(context);
  this._beta = beta2;
}
Bundle$1.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, j = x2.length - 1;
    if (j > 0) {
      var x02 = x2[0], y02 = y2[0], dx = x2[j] - x02, dy = y2[j] - y02, i = -1, t4;
      while (++i <= j) {
        t4 = i / j;
        this._basis.point(
          this._beta * x2[i] + (1 - this._beta) * (x02 + t4 * dx),
          this._beta * y2[i] + (1 - this._beta) * (y02 + t4 * dy)
        );
      }
    }
    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
var bundle$1 = function custom(beta2) {
  function bundle2(context) {
    return beta2 === 1 ? new Basis$1(context) : new Bundle$1(context, beta2);
  }
  bundle2.beta = function(beta3) {
    return custom(+beta3);
  };
  return bundle2;
}(0.85);
function point$8(that, x2, y2) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x2),
    that._y2 + that._k * (that._y1 - y2),
    that._x2,
    that._y2
  );
}
function Cardinal$1(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
Cardinal$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$8(this, this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        this._x1 = x2, this._y1 = y2;
        break;
      case 2:
        this._point = 3;
      default:
        point$8(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinal$1 = function custom2(tension) {
  function cardinal2(context) {
    return new Cardinal$1(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom2(+tension2);
  };
  return cardinal2;
}(0);
function CardinalClosed$1(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalClosed$1.prototype = {
  areaStart: noop$6,
  areaEnd: noop$6,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x2, this._y3 = y2;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x2, this._y4 = y2);
        break;
      case 2:
        this._point = 3;
        this._x5 = x2, this._y5 = y2;
        break;
      default:
        point$8(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinalClosed$1 = function custom3(tension) {
  function cardinal2(context) {
    return new CardinalClosed$1(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom3(+tension2);
  };
  return cardinal2;
}(0);
function CardinalOpen$1(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalOpen$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$8(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinalOpen$1 = function custom4(tension) {
  function cardinal2(context) {
    return new CardinalOpen$1(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom4(+tension2);
  };
  return cardinal2;
}(0);
function point$7(that, x2, y2) {
  var x12 = that._x1, y12 = that._y1, x22 = that._x2, y22 = that._y2;
  if (that._l01_a > epsilon$6) {
    var a2 = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n2 = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x12 = (x12 * a2 - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n2;
    y12 = (y12 * a2 - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n2;
  }
  if (that._l23_a > epsilon$6) {
    var b10 = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m2 = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x22 = (x22 * b10 + that._x1 * that._l23_2a - x2 * that._l12_2a) / m2;
    y22 = (y22 * b10 + that._y1 * that._l23_2a - y2 * that._l12_2a) / m2;
  }
  that._context.bezierCurveTo(x12, y12, x22, y22, that._x2, that._y2);
}
function CatmullRom$1(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRom$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        point$7(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRom$1 = function custom5(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRom$1(context, alpha2) : new Cardinal$1(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom5(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomClosed$1(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomClosed$1.prototype = {
  areaStart: noop$6,
  areaEnd: noop$6,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x2, this._y3 = y2;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x2, this._y4 = y2);
        break;
      case 2:
        this._point = 3;
        this._x5 = x2, this._y5 = y2;
        break;
      default:
        point$7(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRomClosed$1 = function custom6(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomClosed$1(context, alpha2) : new CardinalClosed$1(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom6(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomOpen$1(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomOpen$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$7(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRomOpen$1 = function custom7(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomOpen$1(context, alpha2) : new CardinalOpen$1(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom7(+alpha3);
  };
  return catmullRom2;
}(0.5);
function LinearClosed$1(context) {
  this._context = context;
}
LinearClosed$1.prototype = {
  areaStart: noop$6,
  areaEnd: noop$6,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point)
      this._context.closePath();
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point)
      this._context.lineTo(x2, y2);
    else
      this._point = 1, this._context.moveTo(x2, y2);
  }
};
function linearClosed$1(context) {
  return new LinearClosed$1(context);
}
function sign$2(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3$1(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p2 = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$2(s0) + sign$2(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p2)) || 0;
}
function slope2$1(that, t4) {
  var h2 = that._x1 - that._x0;
  return h2 ? (3 * (that._y1 - that._y0) / h2 - t4) / 2 : t4;
}
function point$6(that, t02, t12) {
  var x02 = that._x0, y02 = that._y0, x12 = that._x1, y12 = that._y1, dx = (x12 - x02) / 3;
  that._context.bezierCurveTo(x02 + dx, y02 + dx * t02, x12 - dx, y12 - dx * t12, x12, y12);
}
function MonotoneX$1(context) {
  this._context = context;
}
MonotoneX$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$6(this, this._t0, slope2$1(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t12 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1)
      return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point$6(this, slope2$1(this, t12 = slope3$1(this, x2, y2)), t12);
        break;
      default:
        point$6(this, this._t0, t12 = slope3$1(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t12;
  }
};
function MonotoneY$1(context) {
  this._context = new ReflectContext$1(context);
}
(MonotoneY$1.prototype = Object.create(MonotoneX$1.prototype)).point = function(x2, y2) {
  MonotoneX$1.prototype.point.call(this, y2, x2);
};
function ReflectContext$1(context) {
  this._context = context;
}
ReflectContext$1.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x12, y12, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y12, x12, y2, x2, y3, x3);
  }
};
function monotoneX$1(context) {
  return new MonotoneX$1(context);
}
function monotoneY$1(context) {
  return new MonotoneY$1(context);
}
function Natural$1(context) {
  this._context = context;
}
Natural$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, n2 = x2.length;
    if (n2) {
      this._line ? this._context.lineTo(x2[0], y2[0]) : this._context.moveTo(x2[0], y2[0]);
      if (n2 === 2) {
        this._context.lineTo(x2[1], y2[1]);
      } else {
        var px = controlPoints$1(x2), py = controlPoints$1(y2);
        for (var i0 = 0, i1 = 1; i1 < n2; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x2[i1], y2[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n2 === 1)
      this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
function controlPoints$1(x2) {
  var i, n2 = x2.length - 1, m2, a2 = new Array(n2), b10 = new Array(n2), r2 = new Array(n2);
  a2[0] = 0, b10[0] = 2, r2[0] = x2[0] + 2 * x2[1];
  for (i = 1; i < n2 - 1; ++i)
    a2[i] = 1, b10[i] = 4, r2[i] = 4 * x2[i] + 2 * x2[i + 1];
  a2[n2 - 1] = 2, b10[n2 - 1] = 7, r2[n2 - 1] = 8 * x2[n2 - 1] + x2[n2];
  for (i = 1; i < n2; ++i)
    m2 = a2[i] / b10[i - 1], b10[i] -= m2, r2[i] -= m2 * r2[i - 1];
  a2[n2 - 1] = r2[n2 - 1] / b10[n2 - 1];
  for (i = n2 - 2; i >= 0; --i)
    a2[i] = (r2[i] - a2[i + 1]) / b10[i];
  b10[n2 - 1] = (x2[n2] + a2[n2 - 1]) / 2;
  for (i = 0; i < n2 - 1; ++i)
    b10[i] = 2 * x2[i + 1] - a2[i + 1];
  return [a2, b10];
}
function natural$1(context) {
  return new Natural$1(context);
}
function Step$1(context, t4) {
  this._context = context;
  this._t = t4;
}
Step$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2)
      this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    if (this._line >= 0)
      this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x12 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x12, this._y);
          this._context.lineTo(x12, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function step$1(context) {
  return new Step$1(context, 0.5);
}
function stepBefore$1(context) {
  return new Step$1(context, 0);
}
function stepAfter$1(context) {
  return new Step$1(context, 1);
}
function stackOffsetNone(series, order2) {
  if (!((n2 = series.length) > 1))
    return;
  for (var i = 1, j, s0, s1 = series[order2[0]], n2, m2 = s1.length; i < n2; ++i) {
    s0 = s1, s1 = series[order2[i]];
    for (j = 0; j < m2; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
function stackOrderNone(series) {
  var n2 = series.length, o = new Array(n2);
  while (--n2 >= 0)
    o[n2] = n2;
  return o;
}
function stackValue$1(d2, key) {
  return d2[key];
}
function d3stack() {
  var keys2 = constant$h([]), order2 = stackOrderNone, offset2 = stackOffsetNone, value = stackValue$1;
  function stack2(data) {
    var kz = keys2.apply(this, arguments), i, m2 = data.length, n2 = kz.length, sz = new Array(n2), oz;
    for (i = 0; i < n2; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m2), j = 0, sij; j < m2; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }
    for (i = 0, oz = order2(sz); i < n2; ++i) {
      sz[oz[i]].index = i;
    }
    offset2(sz, oz);
    return sz;
  }
  stack2.keys = function(_2) {
    return arguments.length ? (keys2 = typeof _2 === "function" ? _2 : constant$h(slice$6.call(_2)), stack2) : keys2;
  };
  stack2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$h(+_2), stack2) : value;
  };
  stack2.order = function(_2) {
    return arguments.length ? (order2 = _2 == null ? stackOrderNone : typeof _2 === "function" ? _2 : constant$h(slice$6.call(_2)), stack2) : order2;
  };
  stack2.offset = function(_2) {
    return arguments.length ? (offset2 = _2 == null ? stackOffsetNone : _2, stack2) : offset2;
  };
  return stack2;
}
function stackOffsetExpand(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var i, n2, j = 0, m2 = series[0].length, y2; j < m2; ++j) {
    for (y2 = i = 0; i < n2; ++i)
      y2 += series[i][j][1] || 0;
    if (y2)
      for (i = 0; i < n2; ++i)
        series[i][j][1] /= y2;
  }
  stackOffsetNone(series, order2);
}
function stackOffsetDiverging(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var i, j = 0, d2, dy, yp, yn, n2, m2 = series[order2[0]].length; j < m2; ++j) {
    for (yp = yn = 0, i = 0; i < n2; ++i) {
      if ((dy = (d2 = series[order2[i]][j])[1] - d2[0]) > 0) {
        d2[0] = yp, d2[1] = yp += dy;
      } else if (dy < 0) {
        d2[1] = yn, d2[0] = yn += dy;
      } else {
        d2[0] = 0, d2[1] = dy;
      }
    }
  }
}
function stackOffsetSilhouette(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var j = 0, s0 = series[order2[0]], n2, m2 = s0.length; j < m2; ++j) {
    for (var i = 0, y2 = 0; i < n2; ++i)
      y2 += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y2 / 2;
  }
  stackOffsetNone(series, order2);
}
function stackOffsetWiggle(series, order2) {
  if (!((n2 = series.length) > 0) || !((m2 = (s0 = series[order2[0]]).length) > 0))
    return;
  for (var y2 = 0, j = 1, s0, m2, n2; j < m2; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n2; ++i) {
      var si = series[order2[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
      for (var k2 = 0; k2 < i; ++k2) {
        var sk = series[order2[k2]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y2;
    if (s1)
      y2 -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y2;
  stackOffsetNone(series, order2);
}
function appearance$1(series) {
  var peaks = series.map(peak$1);
  return stackOrderNone(series).sort(function(a2, b10) {
    return peaks[a2] - peaks[b10];
  });
}
function peak$1(series) {
  var i = -1, j = 0, n2 = series.length, vi, vj = -Infinity;
  while (++i < n2)
    if ((vi = +series[i][1]) > vj)
      vj = vi, j = i;
  return j;
}
function stackOrderAscending(series) {
  var sums = series.map(sum$4);
  return stackOrderNone(series).sort(function(a2, b10) {
    return sums[a2] - sums[b10];
  });
}
function sum$4(series) {
  var s2 = 0, i = -1, n2 = series.length, v2;
  while (++i < n2)
    if (v2 = +series[i][1])
      s2 += v2;
  return s2;
}
function stackOrderDescending(series) {
  return stackOrderAscending(series).reverse();
}
function stackOrderInsideOut(series) {
  var n2 = series.length, i, j, sums = series.map(sum$4), order2 = appearance$1(series), top2 = 0, bottom2 = 0, tops = [], bottoms = [];
  for (i = 0; i < n2; ++i) {
    j = order2[i];
    if (top2 < bottom2) {
      top2 += sums[j];
      tops.push(j);
    } else {
      bottom2 += sums[j];
      bottoms.push(j);
    }
  }
  return bottoms.reverse().concat(tops);
}
function stackOrderReverse(series) {
  return stackOrderNone(series).reverse();
}
var src = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arc: d3Arc,
  area: d3Area,
  line: d3Line,
  pie: d3Pie,
  areaRadial: areaRadial$1,
  radialArea: areaRadial$1,
  lineRadial: d3RadialLine,
  radialLine: d3RadialLine,
  pointRadial: pointRadial$1,
  linkHorizontal: linkHorizontal$1,
  linkVertical: linkVertical$1,
  linkRadial: linkRadial$1,
  symbol: symbol$1,
  symbols: symbols$1,
  symbolCircle: circle$3,
  symbolCross: cross$3,
  symbolDiamond: diamond$1,
  symbolSquare: square$3,
  symbolStar: star$1,
  symbolTriangle: triangle$1,
  symbolWye: wye$1,
  curveBasisClosed: basisClosed$3,
  curveBasisOpen: basisOpen$1,
  curveBasis: basis$7,
  curveBundle: bundle$1,
  curveCardinalClosed: cardinalClosed$1,
  curveCardinalOpen: cardinalOpen$1,
  curveCardinal: cardinal$1,
  curveCatmullRomClosed: catmullRomClosed$1,
  curveCatmullRomOpen: catmullRomOpen$1,
  curveCatmullRom: catmullRom$1,
  curveLinearClosed: linearClosed$1,
  curveLinear: curveLinear$1,
  curveMonotoneX: monotoneX$1,
  curveMonotoneY: monotoneY$1,
  curveNatural: natural$1,
  curveStep: step$1,
  curveStepAfter: stepAfter$1,
  curveStepBefore: stepBefore$1,
  stack: d3stack,
  stackOffsetExpand,
  stackOffsetDiverging,
  stackOffsetNone,
  stackOffsetSilhouette,
  stackOffsetWiggle,
  stackOrderAppearance: appearance$1,
  stackOrderAscending,
  stackOrderDescending,
  stackOrderInsideOut,
  stackOrderNone,
  stackOrderReverse
}, Symbol.toStringTag, { value: "Module" }));
function setNumberOrNumberAccessor$2(func, value) {
  if (typeof value === "number")
    func(value);
  else
    func(value);
}
var STACK_ORDERS$1 = {
  ascending: stackOrderAscending,
  descending: stackOrderDescending,
  insideout: stackOrderInsideOut,
  none: stackOrderNone,
  reverse: stackOrderReverse
};
function stackOrder$2(order2) {
  return order2 && STACK_ORDERS$1[order2] || STACK_ORDERS$1.none;
}
var STACK_OFFSETS$1 = {
  expand: stackOffsetExpand,
  diverging: stackOffsetDiverging,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  wiggle: stackOffsetWiggle
};
function stackOffset$2(offset2) {
  return offset2 && STACK_OFFSETS$1[offset2] || STACK_OFFSETS$1.none;
}
function arc$2(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, cornerRadius = _ref.cornerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, padAngle = _ref.padAngle, padRadius = _ref.padRadius;
  var path2 = d3Arc();
  if (innerRadius != null)
    setNumberOrNumberAccessor$2(path2.innerRadius, innerRadius);
  if (outerRadius != null)
    setNumberOrNumberAccessor$2(path2.outerRadius, outerRadius);
  if (cornerRadius != null)
    setNumberOrNumberAccessor$2(path2.cornerRadius, cornerRadius);
  if (startAngle != null)
    setNumberOrNumberAccessor$2(path2.startAngle, startAngle);
  if (endAngle != null)
    setNumberOrNumberAccessor$2(path2.endAngle, endAngle);
  if (padAngle != null)
    setNumberOrNumberAccessor$2(path2.padAngle, padAngle);
  if (padRadius != null)
    setNumberOrNumberAccessor$2(path2.padRadius, padRadius);
  return path2;
}
function area$5(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2, x2 = _ref2.x, x02 = _ref2.x0, x12 = _ref2.x1, y2 = _ref2.y, y02 = _ref2.y0, y12 = _ref2.y1, defined = _ref2.defined, curve = _ref2.curve;
  var path2 = d3Area();
  if (x2)
    setNumberOrNumberAccessor$2(path2.x, x2);
  if (x02)
    setNumberOrNumberAccessor$2(path2.x0, x02);
  if (x12)
    setNumberOrNumberAccessor$2(path2.x1, x12);
  if (y2)
    setNumberOrNumberAccessor$2(path2.y, y2);
  if (y02)
    setNumberOrNumberAccessor$2(path2.y0, y02);
  if (y12)
    setNumberOrNumberAccessor$2(path2.y1, y12);
  if (defined)
    path2.defined(defined);
  if (curve)
    path2.curve(curve);
  return path2;
}
function line$3(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3, x2 = _ref3.x, y2 = _ref3.y, defined = _ref3.defined, curve = _ref3.curve;
  var path2 = d3Line();
  if (x2)
    setNumberOrNumberAccessor$2(path2.x, x2);
  if (y2)
    setNumberOrNumberAccessor$2(path2.y, y2);
  if (defined)
    path2.defined(defined);
  if (curve)
    path2.curve(curve);
  return path2;
}
function pie$2(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4, startAngle = _ref4.startAngle, endAngle = _ref4.endAngle, padAngle = _ref4.padAngle, value = _ref4.value, sort2 = _ref4.sort, sortValues = _ref4.sortValues;
  var path2 = d3Pie();
  if (sort2 === null)
    path2.sort(sort2);
  else if (sort2 != null)
    path2.sort(sort2);
  if (sortValues === null)
    path2.sortValues(sortValues);
  else if (sortValues != null)
    path2.sortValues(sortValues);
  if (value != null)
    path2.value(value);
  if (padAngle != null)
    setNumberOrNumberAccessor$2(path2.padAngle, padAngle);
  if (startAngle != null)
    setNumberOrNumberAccessor$2(path2.startAngle, startAngle);
  if (endAngle != null)
    setNumberOrNumberAccessor$2(path2.endAngle, endAngle);
  return path2;
}
var _excluded$V = ["className", "top", "left", "data", "centroid", "innerRadius", "outerRadius", "cornerRadius", "startAngle", "endAngle", "padAngle", "padRadius", "pieSort", "pieSortValues", "pieValue", "children", "fill"];
function _extends$O() {
  _extends$O = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$O.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$z(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Pie(_ref) {
  var className = _ref.className, top2 = _ref.top, left2 = _ref.left, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, centroid2 = _ref.centroid, _ref$innerRadius = _ref.innerRadius, innerRadius = _ref$innerRadius === void 0 ? 0 : _ref$innerRadius, outerRadius = _ref.outerRadius, cornerRadius = _ref.cornerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, padAngle = _ref.padAngle, padRadius = _ref.padRadius, pieSort = _ref.pieSort, pieSortValues = _ref.pieSortValues, pieValue = _ref.pieValue, children2 = _ref.children, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "" : _ref$fill, restProps = _objectWithoutPropertiesLoose$z(_ref, _excluded$V);
  var path2 = arc$2({
    innerRadius,
    outerRadius,
    cornerRadius,
    padRadius
  });
  var pie2 = pie$2({
    startAngle,
    endAngle,
    padAngle,
    value: pieValue,
    sort: pieSort,
    sortValues: pieSortValues
  });
  var arcs = pie2(data);
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2({
      arcs,
      path: path2,
      pie: pie2
    }));
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: "visx-pie-arcs-group",
    top: top2,
    left: left2
  }, arcs.map(function(arc2, i) {
    return /* @__PURE__ */ React__default.createElement("g", {
      key: "pie-arc-" + i
    }, /* @__PURE__ */ React__default.createElement("path", _extends$O({
      className: cx("visx-pie-arc", className),
      d: path2(arc2) || "",
      fill: fill == null || typeof fill === "string" ? fill : fill(arc2)
    }, restProps)), centroid2 == null ? void 0 : centroid2(path2.centroid(arc2), arc2));
  }));
}
var _excluded$U = ["from", "to", "fill", "className", "innerRef"];
function _extends$N() {
  _extends$N = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$N.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$y(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Line$2(_ref) {
  var _ref$from = _ref.from, from2 = _ref$from === void 0 ? {
    x: 0,
    y: 0
  } : _ref$from, _ref$to = _ref.to, to = _ref$to === void 0 ? {
    x: 1,
    y: 1
  } : _ref$to, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose$y(_ref, _excluded$U);
  var isRectilinear = from2.x === to.x || from2.y === to.y;
  return /* @__PURE__ */ React__default.createElement("line", _extends$N({
    ref: innerRef,
    className: cx("visx-line", className),
    x1: from2.x,
    y1: from2.y,
    x2: to.x,
    y2: to.y,
    fill,
    shapeRendering: isRectilinear ? "crispEdges" : "auto"
  }, restProps));
}
var _excluded$T = ["children", "data", "x", "y", "fill", "className", "curve", "innerRef", "defined"];
function _extends$M() {
  _extends$M = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$M.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$x(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function LinePath$1(_ref) {
  var children2 = _ref.children, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, x2 = _ref.x, y2 = _ref.y, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, curve = _ref.curve, innerRef = _ref.innerRef, _ref$defined = _ref.defined, defined = _ref$defined === void 0 ? function() {
    return true;
  } : _ref$defined, restProps = _objectWithoutPropertiesLoose$x(_ref, _excluded$T);
  var path2 = line$3({
    x: x2,
    y: y2,
    defined,
    curve
  });
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2({
      path: path2
    }));
  return /* @__PURE__ */ React__default.createElement("path", _extends$M({
    ref: innerRef,
    className: cx("visx-linepath", className),
    d: path2(data) || "",
    fill,
    strokeLinecap: "round"
  }, restProps));
}
var _excluded$S = ["x", "x0", "x1", "y", "y1", "y0", "yScale", "data", "defined", "className", "curve", "innerRef", "children"];
function _extends$L() {
  _extends$L = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$L.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$w(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function AreaClosed(_ref) {
  var x2 = _ref.x, x02 = _ref.x0, x12 = _ref.x1, y2 = _ref.y, y12 = _ref.y1, y02 = _ref.y0, yScale = _ref.yScale, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, _ref$defined = _ref.defined, defined = _ref$defined === void 0 ? function() {
    return true;
  } : _ref$defined, className = _ref.className, curve = _ref.curve, innerRef = _ref.innerRef, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$w(_ref, _excluded$S);
  var path2 = area$5({
    x: x2,
    x0: x02,
    x1: x12,
    defined,
    curve
  });
  if (y02 == null) {
    path2.y0(yScale.range()[0]);
  } else {
    setNumberOrNumberAccessor$2(path2.y0, y02);
  }
  if (y2 && !y12)
    setNumberOrNumberAccessor$2(path2.y1, y2);
  if (y12 && !y2)
    setNumberOrNumberAccessor$2(path2.y1, y12);
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2({
      path: path2
    }));
  return /* @__PURE__ */ React__default.createElement("path", _extends$L({
    ref: innerRef,
    className: cx("visx-area-closed", className),
    d: path2(data) || ""
  }, restProps));
}
var _excluded$R = ["className", "innerRef"];
function _extends$K() {
  _extends$K = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$K.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$v(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Bar(_ref) {
  var className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose$v(_ref, _excluded$R);
  return /* @__PURE__ */ React__default.createElement("rect", _extends$K({
    ref: innerRef,
    className: cx("visx-bar", className)
  }, restProps));
}
function getBandwidth(scale) {
  if ("bandwidth" in scale) {
    return scale.bandwidth();
  }
  var range2 = scale.range();
  var domain2 = scale.domain();
  return Math.abs(range2[range2.length - 1] - range2[0]) / domain2.length;
}
var _excluded$Q = ["data", "className", "top", "left", "x0", "x0Scale", "x1Scale", "yScale", "color", "keys", "height", "children"];
function _extends$J() {
  _extends$J = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$J.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$u(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BarGroup(_ref) {
  var data = _ref.data, className = _ref.className, top2 = _ref.top, left2 = _ref.left, x02 = _ref.x0, x0Scale = _ref.x0Scale, x1Scale = _ref.x1Scale, yScale = _ref.yScale, color2 = _ref.color, keys2 = _ref.keys, height2 = _ref.height, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$u(_ref, _excluded$Q);
  var barWidth = getBandwidth(x1Scale);
  var barGroups = data.map(function(group2, i) {
    return {
      index: i,
      x0: x0Scale(x02(group2)),
      bars: keys2.map(function(key, j) {
        var value = group2[key];
        return {
          index: j,
          key,
          value,
          width: barWidth,
          x: x1Scale(key) || 0,
          y: yScale(value) || 0,
          color: color2(key, j),
          height: height2 - (yScale(value) || 0)
        };
      })
    };
  });
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2(barGroups));
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-bar-group", className),
    top: top2,
    left: left2
  }, barGroups.map(function(barGroup) {
    return /* @__PURE__ */ React__default.createElement(Group, {
      key: "bar-group-" + barGroup.index + "-" + barGroup.x0,
      left: barGroup.x0
    }, barGroup.bars.map(function(bar) {
      return /* @__PURE__ */ React__default.createElement(Bar, _extends$J({
        key: "bar-group-bar-" + barGroup.index + "-" + bar.index + "-" + bar.value + "-" + bar.key,
        x: bar.x,
        y: bar.y,
        width: bar.width,
        height: bar.height,
        fill: bar.color
      }, restProps));
    }));
  }));
}
var _excluded$P = ["data", "className", "top", "left", "x", "y0", "y0Scale", "y1Scale", "xScale", "color", "keys", "width", "children"];
function _extends$I() {
  _extends$I = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$I.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$t(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BarGroupHorizontal(_ref) {
  var data = _ref.data, className = _ref.className, top2 = _ref.top, left2 = _ref.left, _ref$x = _ref.x, x2 = _ref$x === void 0 ? function() {
    return 0;
  } : _ref$x, y02 = _ref.y0, y0Scale = _ref.y0Scale, y1Scale = _ref.y1Scale, xScale = _ref.xScale, color2 = _ref.color, keys2 = _ref.keys;
  _ref.width;
  var children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$t(_ref, _excluded$P);
  var barHeight = getBandwidth(y1Scale);
  var barGroups = data.map(function(group2, i) {
    return {
      index: i,
      y0: y0Scale(y02(group2)) || 0,
      bars: keys2.map(function(key, j) {
        var value = group2[key];
        return {
          index: j,
          key,
          value,
          height: barHeight,
          x: x2(value) || 0,
          y: y1Scale(key) || 0,
          color: color2(key, j),
          width: xScale(value) || 0
        };
      })
    };
  });
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2(barGroups));
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-bar-group-horizontal", className),
    top: top2,
    left: left2
  }, barGroups.map(function(barGroup) {
    return /* @__PURE__ */ React__default.createElement(Group, {
      key: "bar-group-" + barGroup.index + "-" + barGroup.y0,
      top: barGroup.y0
    }, barGroup.bars.map(function(bar) {
      return /* @__PURE__ */ React__default.createElement(Bar, _extends$I({
        key: "bar-group-bar-" + barGroup.index + "-" + bar.index + "-" + bar.value + "-" + bar.key,
        x: bar.x,
        y: bar.y,
        width: bar.width,
        height: bar.height,
        fill: bar.color
      }, restProps));
    }));
  }));
}
function getFirstItem(d2) {
  return d2 == null ? void 0 : d2[0];
}
function getSecondItem(d2) {
  return d2 == null ? void 0 : d2[1];
}
var _excluded$O = ["data", "className", "top", "left", "x", "y0", "y1", "xScale", "yScale", "color", "keys", "value", "order", "offset", "children"];
function _extends$H() {
  _extends$H = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$H.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$s(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BarStack(_ref) {
  var data = _ref.data, className = _ref.className, top2 = _ref.top, left2 = _ref.left, x2 = _ref.x, _ref$y = _ref.y0, y02 = _ref$y === void 0 ? getFirstItem : _ref$y, _ref$y2 = _ref.y1, y12 = _ref$y2 === void 0 ? getSecondItem : _ref$y2, xScale = _ref.xScale, yScale = _ref.yScale, color2 = _ref.color, keys2 = _ref.keys, value = _ref.value, order2 = _ref.order, offset2 = _ref.offset, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$s(_ref, _excluded$O);
  var stack2 = d3stack();
  if (keys2)
    stack2.keys(keys2);
  if (value)
    setNumberOrNumberAccessor$2(stack2.value, value);
  if (order2)
    stack2.order(stackOrder$2(order2));
  if (offset2)
    stack2.offset(stackOffset$2(offset2));
  var stacks = stack2(data);
  var barWidth = getBandwidth(xScale);
  var barStacks = stacks.map(function(barStack, i) {
    var key = barStack.key;
    return {
      index: i,
      key,
      bars: barStack.map(function(bar, j) {
        var barHeight = (yScale(y02(bar)) || 0) - (yScale(y12(bar)) || 0);
        var barY = yScale(y12(bar));
        var barX = "bandwidth" in xScale ? xScale(x2(bar.data)) : Math.max((xScale(x2(bar.data)) || 0) - barWidth / 2);
        return {
          bar,
          key,
          index: j,
          height: barHeight,
          width: barWidth,
          x: barX || 0,
          y: barY || 0,
          color: color2(barStack.key, j)
        };
      })
    };
  });
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2(barStacks));
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-bar-stack", className),
    top: top2,
    left: left2
  }, barStacks.map(function(barStack) {
    return barStack.bars.map(function(bar) {
      return /* @__PURE__ */ React__default.createElement(Bar, _extends$H({
        key: "bar-stack-" + barStack.index + "-" + bar.index,
        x: bar.x,
        y: bar.y,
        height: bar.height,
        width: bar.width,
        fill: bar.color
      }, restProps));
    });
  }));
}
var _excluded$N = ["data", "className", "top", "left", "y", "x0", "x1", "xScale", "yScale", "color", "keys", "value", "order", "offset", "children"];
function _extends$G() {
  _extends$G = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$G.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$r(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BarStackHorizontal(_ref) {
  var data = _ref.data, className = _ref.className, top2 = _ref.top, left2 = _ref.left, y2 = _ref.y, _ref$x = _ref.x0, x02 = _ref$x === void 0 ? getFirstItem : _ref$x, _ref$x2 = _ref.x1, x12 = _ref$x2 === void 0 ? getSecondItem : _ref$x2, xScale = _ref.xScale, yScale = _ref.yScale, color2 = _ref.color, keys2 = _ref.keys, value = _ref.value, order2 = _ref.order, offset2 = _ref.offset, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$r(_ref, _excluded$N);
  var stack2 = d3stack();
  if (keys2)
    stack2.keys(keys2);
  if (value)
    setNumberOrNumberAccessor$2(stack2.value, value);
  if (order2)
    stack2.order(stackOrder$2(order2));
  if (offset2)
    stack2.offset(stackOffset$2(offset2));
  var stacks = stack2(data);
  var barHeight = getBandwidth(yScale);
  var barStacks = stacks.map(function(barStack, i) {
    var key = barStack.key;
    return {
      index: i,
      key,
      bars: barStack.map(function(bar, j) {
        var barWidth = (xScale(x12(bar)) || 0) - (xScale(x02(bar)) || 0);
        var barX = xScale(x02(bar));
        var barY = "bandwidth" in yScale ? yScale(y2(bar.data)) : Math.max((yScale(y2(bar.data)) || 0) - barWidth / 2);
        return {
          bar,
          key,
          index: j,
          height: barHeight,
          width: barWidth,
          x: barX || 0,
          y: barY || 0,
          color: color2(barStack.key, j)
        };
      })
    };
  });
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2(barStacks));
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-bar-stack-horizontal", className),
    top: top2,
    left: left2
  }, barStacks.map(function(barStack) {
    return barStack.bars.map(function(bar) {
      return /* @__PURE__ */ React__default.createElement(Bar, _extends$G({
        key: "bar-stack-" + barStack.index + "-" + bar.index,
        x: bar.x,
        y: bar.y,
        height: bar.height,
        width: bar.width,
        fill: bar.color
      }, restProps));
    });
  }));
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, k$2 = Symbol.for("react.element"), l$1 = Symbol.for("react.fragment"), m$2 = Object.prototype.hasOwnProperty, n$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a2, g2) {
  var b10, d2 = {}, e3 = null, h2 = null;
  void 0 !== g2 && (e3 = "" + g2);
  void 0 !== a2.key && (e3 = "" + a2.key);
  void 0 !== a2.ref && (h2 = a2.ref);
  for (b10 in a2)
    m$2.call(a2, b10) && !p$1.hasOwnProperty(b10) && (d2[b10] = a2[b10]);
  if (c2 && c2.defaultProps)
    for (b10 in a2 = c2.defaultProps, a2)
      void 0 === d2[b10] && (d2[b10] = a2[b10]);
  return { $$typeof: k$2, type: c2, key: e3, ref: h2, props: d2, _owner: n$1.current };
}
reactJsxRuntime_production_min.Fragment = l$1;
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
function ascending$4(a2, b10) {
  return a2 == null || b10 == null ? NaN : a2 < b10 ? -1 : a2 > b10 ? 1 : a2 >= b10 ? 0 : NaN;
}
function descending$3(a2, b10) {
  return a2 == null || b10 == null ? NaN : b10 < a2 ? -1 : b10 > a2 ? 1 : b10 >= a2 ? 0 : NaN;
}
function bisector$1(f2) {
  let compare1, compare2, delta;
  if (f2.length !== 2) {
    compare1 = ascending$4;
    compare2 = (d2, x2) => ascending$4(f2(d2), x2);
    delta = (d2, x2) => f2(d2) - x2;
  } else {
    compare1 = f2 === ascending$4 || f2 === descending$3 ? f2 : zero$5;
    compare2 = f2;
    delta = f2;
  }
  function left2(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) < 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right2(a2, x2, lo = 0, hi = a2.length) {
    if (lo < hi) {
      if (compare1(x2, x2) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a2[mid], x2) <= 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center2(a2, x2, lo = 0, hi = a2.length) {
    const i = left2(a2, x2, lo, hi - 1);
    return i > lo && delta(a2[i - 1], x2) > -delta(a2[i], x2) ? i - 1 : i;
  }
  return { left: left2, center: center2, right: right2 };
}
function zero$5() {
  return 0;
}
function number$7(x2) {
  return x2 === null ? NaN : +x2;
}
function* numbers$1(values2, valueof) {
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
const ascendingBisect$1 = bisector$1(ascending$4);
const bisectRight$1 = ascendingBisect$1.right;
const bisectLeft$1 = ascendingBisect$1.left;
bisector$1(number$7).center;
var bisect$1 = bisectRight$1;
function extent$3(values2, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
class InternMap$1 extends Map {
  constructor(entries, key = keyof$1) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null)
      for (const [key2, value] of entries)
        this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get$1(this, key));
  }
  has(key) {
    return super.has(intern_get$1(this, key));
  }
  set(key, value) {
    return super.set(intern_set$1(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete$1(this, key));
  }
}
function intern_get$1({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set$1({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key))
    return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete$1({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof$1(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function compareDefined(compare = ascending$4) {
  if (compare === ascending$4)
    return ascendingDefined;
  if (typeof compare !== "function")
    throw new TypeError("compare is not a function");
  return (a2, b10) => {
    const x2 = compare(a2, b10);
    if (x2 || x2 === 0)
      return x2;
    return (compare(b10, b10) === 0) - (compare(a2, a2) === 0);
  };
}
function ascendingDefined(a2, b10) {
  return (a2 == null || !(a2 >= a2)) - (b10 == null || !(b10 >= b10)) || (a2 < b10 ? -1 : a2 > b10 ? 1 : 0);
}
var e10$2 = Math.sqrt(50), e5$2 = Math.sqrt(10), e2$2 = Math.sqrt(2);
function ticks$1(start2, stop, count2) {
  var reverse2, i = -1, n2, ticks2, step2;
  stop = +stop, start2 = +start2, count2 = +count2;
  if (start2 === stop && count2 > 0)
    return [start2];
  if (reverse2 = stop < start2)
    n2 = start2, start2 = stop, stop = n2;
  if ((step2 = tickIncrement$1(start2, stop, count2)) === 0 || !isFinite(step2))
    return [];
  if (step2 > 0) {
    let r0 = Math.round(start2 / step2), r1 = Math.round(stop / step2);
    if (r0 * step2 < start2)
      ++r0;
    if (r1 * step2 > stop)
      --r1;
    ticks2 = new Array(n2 = r1 - r0 + 1);
    while (++i < n2)
      ticks2[i] = (r0 + i) * step2;
  } else {
    step2 = -step2;
    let r0 = Math.round(start2 * step2), r1 = Math.round(stop * step2);
    if (r0 / step2 < start2)
      ++r0;
    if (r1 / step2 > stop)
      --r1;
    ticks2 = new Array(n2 = r1 - r0 + 1);
    while (++i < n2)
      ticks2[i] = (r0 + i) / step2;
  }
  if (reverse2)
    ticks2.reverse();
  return ticks2;
}
function tickIncrement$1(start2, stop, count2) {
  var step2 = (stop - start2) / Math.max(0, count2), power = Math.floor(Math.log(step2) / Math.LN10), error = step2 / Math.pow(10, power);
  return power >= 0 ? (error >= e10$2 ? 10 : error >= e5$2 ? 5 : error >= e2$2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10$2 ? 10 : error >= e5$2 ? 5 : error >= e2$2 ? 2 : 1);
}
function tickStep$2(start2, stop, count2) {
  var step0 = Math.abs(stop - start2) / Math.max(0, count2), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
  if (error >= e10$2)
    step1 *= 10;
  else if (error >= e5$2)
    step1 *= 5;
  else if (error >= e2$2)
    step1 *= 2;
  return stop < start2 ? -step1 : step1;
}
function max$6(values2, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$4(values2, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function quickselect$1(array2, k2, left2 = 0, right2 = Infinity, compare) {
  k2 = Math.floor(k2);
  left2 = Math.floor(Math.max(0, left2));
  right2 = Math.floor(Math.min(array2.length - 1, right2));
  if (!(left2 <= k2 && k2 <= right2))
    return array2;
  compare = compare === void 0 ? ascendingDefined : compareDefined(compare);
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n2 = right2 - left2 + 1;
      const m2 = k2 - left2 + 1;
      const z2 = Math.log(n2);
      const s2 = 0.5 * Math.exp(2 * z2 / 3);
      const sd = 0.5 * Math.sqrt(z2 * s2 * (n2 - s2) / n2) * (m2 - n2 / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k2 - m2 * s2 / n2 + sd));
      const newRight = Math.min(right2, Math.floor(k2 + (n2 - m2) * s2 / n2 + sd));
      quickselect$1(array2, k2, newLeft, newRight, compare);
    }
    const t4 = array2[k2];
    let i = left2;
    let j = right2;
    swap$2(array2, left2, k2);
    if (compare(array2[right2], t4) > 0)
      swap$2(array2, left2, right2);
    while (i < j) {
      swap$2(array2, i, j), ++i, --j;
      while (compare(array2[i], t4) < 0)
        ++i;
      while (compare(array2[j], t4) > 0)
        --j;
    }
    if (compare(array2[left2], t4) === 0)
      swap$2(array2, left2, j);
    else
      ++j, swap$2(array2, j, right2);
    if (j <= k2)
      left2 = j + 1;
    if (k2 <= j)
      right2 = j - 1;
  }
  return array2;
}
function swap$2(array2, i, j) {
  const t4 = array2[i];
  array2[i] = array2[j];
  array2[j] = t4;
}
function quantile$3(values2, p2, valueof) {
  values2 = Float64Array.from(numbers$1(values2, valueof));
  if (!(n2 = values2.length) || isNaN(p2 = +p2))
    return;
  if (p2 <= 0 || n2 < 2)
    return min$4(values2);
  if (p2 >= 1)
    return max$6(values2);
  var n2, i = (n2 - 1) * p2, i0 = Math.floor(i), value0 = max$6(quickselect$1(values2, i0).subarray(0, i0 + 1)), value1 = min$4(values2.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted$1(values2, p2, valueof = number$7) {
  if (!(n2 = values2.length) || isNaN(p2 = +p2))
    return;
  if (p2 <= 0 || n2 < 2)
    return +valueof(values2[0], 0, values2);
  if (p2 >= 1)
    return +valueof(values2[n2 - 1], n2 - 1, values2);
  var n2, i = (n2 - 1) * p2, i0 = Math.floor(i), value0 = +valueof(values2[i0], i0, values2), value1 = +valueof(values2[i0 + 1], i0 + 1, values2);
  return value0 + (value1 - value0) * (i - i0);
}
function range$6(start2, stop, step2) {
  start2 = +start2, stop = +stop, step2 = (n2 = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n2 < 3 ? 1 : +step2;
  var i = -1, n2 = Math.max(0, Math.ceil((stop - start2) / step2)) | 0, range2 = new Array(n2);
  while (++i < n2) {
    range2[i] = start2 + i * step2;
  }
  return range2;
}
function initRange$1(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator$1(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function")
        this.interpolator(domain2);
      else
        this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function")
        this.interpolator(interpolator);
      else
        this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit$1 = Symbol("implicit");
function ordinal$1() {
  var index2 = new InternMap$1(), domain2 = [], range2 = [], unknown2 = implicit$1;
  function scale(d2) {
    let i = index2.get(d2);
    if (i === void 0) {
      if (unknown2 !== implicit$1)
        return unknown2;
      index2.set(d2, i = domain2.push(d2) - 1);
    }
    return range2[i % range2.length];
  }
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [], index2 = new InternMap$1();
    for (const value of _2) {
      if (index2.has(value))
        continue;
      index2.set(value, domain2.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), scale) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return ordinal$1(domain2, range2).unknown(unknown2);
  };
  initRange$1.apply(scale, arguments);
  return scale;
}
function band$1() {
  var scale = ordinal$1().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step2, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align2 = 0.5;
  delete scale.unknown;
  function rescale() {
    var n2 = domain2().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop = reverse2 ? r0 : r1;
    step2 = (stop - start2) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round2)
      step2 = Math.floor(step2);
    start2 += (stop - start2 - step2 * (n2 - paddingInner)) * align2;
    bandwidth = step2 * (1 - paddingInner);
    if (round2)
      start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values2 = range$6(n2).map(function(i) {
      return start2 + step2 * i;
    });
    return ordinalRange(reverse2 ? values2.reverse() : values2);
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.range = function(_2) {
    return arguments.length ? ([r0, r1] = _2, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_2) {
    return [r0, r1] = _2, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step2;
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, rescale()) : round2;
  };
  scale.padding = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_2), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, _2), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_2) {
    return arguments.length ? (paddingOuter = +_2, rescale()) : paddingOuter;
  };
  scale.align = function(_2) {
    return arguments.length ? (align2 = Math.max(0, Math.min(1, _2)), rescale()) : align2;
  };
  scale.copy = function() {
    return band$1(domain2(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align2);
  };
  return initRange$1.apply(rescale(), arguments);
}
function pointish$1(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish$1(copy2());
  };
  return scale;
}
function point$5() {
  return pointish$1(band$1.apply(null, arguments).paddingInner(1));
}
function define$4(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$4(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color$4() {
}
var darker$4 = 0.7;
var brighter$4 = 1 / darker$4;
var reI$4 = "\\s*([+-]?\\d+)\\s*", reN$4 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP$4 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex$4 = /^#([0-9a-f]{3,8})$/, reRgbInteger$4 = new RegExp(`^rgb\\(${reI$4},${reI$4},${reI$4}\\)$`), reRgbPercent$4 = new RegExp(`^rgb\\(${reP$4},${reP$4},${reP$4}\\)$`), reRgbaInteger$4 = new RegExp(`^rgba\\(${reI$4},${reI$4},${reI$4},${reN$4}\\)$`), reRgbaPercent$4 = new RegExp(`^rgba\\(${reP$4},${reP$4},${reP$4},${reN$4}\\)$`), reHslPercent$4 = new RegExp(`^hsl\\(${reN$4},${reP$4},${reP$4}\\)$`), reHslaPercent$4 = new RegExp(`^hsla\\(${reN$4},${reP$4},${reP$4},${reN$4}\\)$`);
var named$4 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$4(Color$4, color$5, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$4,
  formatHex: color_formatHex$4,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl$4,
  formatRgb: color_formatRgb$4,
  toString: color_formatRgb$4
});
function color_formatHex$4() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl$4() {
  return hslConvert$4(this).formatHsl();
}
function color_formatRgb$4() {
  return this.rgb().formatRgb();
}
function color$5(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex$4.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn$4(m2) : l2 === 3 ? new Rgb$4(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba$4(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba$4(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger$4.exec(format2)) ? new Rgb$4(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent$4.exec(format2)) ? new Rgb$4(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger$4.exec(format2)) ? rgba$4(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent$4.exec(format2)) ? rgba$4(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent$4.exec(format2)) ? hsla$4(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent$4.exec(format2)) ? hsla$4(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named$4.hasOwnProperty(format2) ? rgbn$4(named$4[format2]) : format2 === "transparent" ? new Rgb$4(NaN, NaN, NaN, 0) : null;
}
function rgbn$4(n2) {
  return new Rgb$4(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba$4(r2, g2, b10, a2) {
  if (a2 <= 0)
    r2 = g2 = b10 = NaN;
  return new Rgb$4(r2, g2, b10, a2);
}
function rgbConvert$4(o) {
  if (!(o instanceof Color$4))
    o = color$5(o);
  if (!o)
    return new Rgb$4();
  o = o.rgb();
  return new Rgb$4(o.r, o.g, o.b, o.opacity);
}
function rgb$6(r2, g2, b10, opacity) {
  return arguments.length === 1 ? rgbConvert$4(r2) : new Rgb$4(r2, g2, b10, opacity == null ? 1 : opacity);
}
function Rgb$4(r2, g2, b10, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$4(Rgb$4, rgb$6, extend$4(Color$4, {
  brighter(k2) {
    k2 = k2 == null ? brighter$4 : Math.pow(brighter$4, k2);
    return new Rgb$4(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker$4 : Math.pow(darker$4, k2);
    return new Rgb$4(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb$4(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$4,
  formatHex: rgb_formatHex$4,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb$4,
  toString: rgb_formatRgb$4
}));
function rgb_formatHex$4() {
  return `#${hex$4(this.r)}${hex$4(this.g)}${hex$4(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex$4(this.r)}${hex$4(this.g)}${hex$4(this.b)}${hex$4((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb$4() {
  const a2 = clampa(this.opacity);
  return `${a2 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a2 === 1 ? ")" : `, ${a2})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex$4(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$4(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl$4(h2, s2, l2, a2);
}
function hslConvert$4(o) {
  if (o instanceof Hsl$4)
    return new Hsl$4(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$4))
    o = color$5(o);
  if (!o)
    return new Hsl$4();
  if (o instanceof Hsl$4)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r2, g2, b10), max2 = Math.max(r2, g2, b10), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g2 - b10) / s2 + (g2 < b10) * 6;
    else if (g2 === max2)
      h2 = (b10 - r2) / s2 + 2;
    else
      h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl$4(h2, s2, l2, o.opacity);
}
function hsl$7(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert$4(h2) : new Hsl$4(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl$4(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$4(Hsl$4, hsl$7, extend$4(Color$4, {
  brighter(k2) {
    k2 = k2 == null ? brighter$4 : Math.pow(brighter$4, k2);
    return new Hsl$4(this.h, this.s, this.l * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker$4 : Math.pow(darker$4, k2);
    return new Hsl$4(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb$4(
      hsl2rgb$4(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb$4(h2, m1, m2),
      hsl2rgb$4(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl$4(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a2 = clampa(this.opacity);
    return `${a2 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a2 === 1 ? ")" : `, ${a2})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb$4(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const radians$3 = Math.PI / 180;
const degrees$6 = 180 / Math.PI;
const K$1 = 18, Xn$1 = 0.96422, Yn$1 = 1, Zn$1 = 0.82521, t0$3 = 4 / 29, t1$3 = 6 / 29, t2$1 = 3 * t1$3 * t1$3, t3$1 = t1$3 * t1$3 * t1$3;
function labConvert$1(o) {
  if (o instanceof Lab$1)
    return new Lab$1(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl$1)
    return hcl2lab$1(o);
  if (!(o instanceof Rgb$4))
    o = rgbConvert$4(o);
  var r2 = rgb2lrgb$1(o.r), g2 = rgb2lrgb$1(o.g), b10 = rgb2lrgb$1(o.b), y2 = xyz2lab$1((0.2225045 * r2 + 0.7168786 * g2 + 0.0606169 * b10) / Yn$1), x2, z2;
  if (r2 === g2 && g2 === b10)
    x2 = z2 = y2;
  else {
    x2 = xyz2lab$1((0.4360747 * r2 + 0.3850649 * g2 + 0.1430804 * b10) / Xn$1);
    z2 = xyz2lab$1((0.0139322 * r2 + 0.0971045 * g2 + 0.7141733 * b10) / Zn$1);
  }
  return new Lab$1(116 * y2 - 16, 500 * (x2 - y2), 200 * (y2 - z2), o.opacity);
}
function lab$3(l2, a2, b10, opacity) {
  return arguments.length === 1 ? labConvert$1(l2) : new Lab$1(l2, a2, b10, opacity == null ? 1 : opacity);
}
function Lab$1(l2, a2, b10, opacity) {
  this.l = +l2;
  this.a = +a2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$4(Lab$1, lab$3, extend$4(Color$4, {
  brighter(k2) {
    return new Lab$1(this.l + K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  darker(k2) {
    return new Lab$1(this.l - K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  rgb() {
    var y2 = (this.l + 16) / 116, x2 = isNaN(this.a) ? y2 : y2 + this.a / 500, z2 = isNaN(this.b) ? y2 : y2 - this.b / 200;
    x2 = Xn$1 * lab2xyz$1(x2);
    y2 = Yn$1 * lab2xyz$1(y2);
    z2 = Zn$1 * lab2xyz$1(z2);
    return new Rgb$4(
      lrgb2rgb$1(3.1338561 * x2 - 1.6168667 * y2 - 0.4906146 * z2),
      lrgb2rgb$1(-0.9787684 * x2 + 1.9161415 * y2 + 0.033454 * z2),
      lrgb2rgb$1(0.0719453 * x2 - 0.2289914 * y2 + 1.4052427 * z2),
      this.opacity
    );
  }
}));
function xyz2lab$1(t4) {
  return t4 > t3$1 ? Math.pow(t4, 1 / 3) : t4 / t2$1 + t0$3;
}
function lab2xyz$1(t4) {
  return t4 > t1$3 ? t4 * t4 * t4 : t2$1 * (t4 - t0$3);
}
function lrgb2rgb$1(x2) {
  return 255 * (x2 <= 31308e-7 ? 12.92 * x2 : 1.055 * Math.pow(x2, 1 / 2.4) - 0.055);
}
function rgb2lrgb$1(x2) {
  return (x2 /= 255) <= 0.04045 ? x2 / 12.92 : Math.pow((x2 + 0.055) / 1.055, 2.4);
}
function hclConvert$1(o) {
  if (o instanceof Hcl$1)
    return new Hcl$1(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab$1))
    o = labConvert$1(o);
  if (o.a === 0 && o.b === 0)
    return new Hcl$1(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h2 = Math.atan2(o.b, o.a) * degrees$6;
  return new Hcl$1(h2 < 0 ? h2 + 360 : h2, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function hcl$4(h2, c2, l2, opacity) {
  return arguments.length === 1 ? hclConvert$1(h2) : new Hcl$1(h2, c2, l2, opacity == null ? 1 : opacity);
}
function Hcl$1(h2, c2, l2, opacity) {
  this.h = +h2;
  this.c = +c2;
  this.l = +l2;
  this.opacity = +opacity;
}
function hcl2lab$1(o) {
  if (isNaN(o.h))
    return new Lab$1(o.l, 0, 0, o.opacity);
  var h2 = o.h * radians$3;
  return new Lab$1(o.l, Math.cos(h2) * o.c, Math.sin(h2) * o.c, o.opacity);
}
define$4(Hcl$1, hcl$4, extend$4(Color$4, {
  brighter(k2) {
    return new Hcl$1(this.h, this.c, this.l + K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  darker(k2) {
    return new Hcl$1(this.h, this.c, this.l - K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  rgb() {
    return hcl2lab$1(this).rgb();
  }
}));
var A$3 = -0.14861, B$2 = 1.78277, C$2 = -0.29227, D$2 = -0.90649, E$2 = 1.97294, ED$2 = E$2 * D$2, EB$2 = E$2 * B$2, BC_DA$2 = B$2 * C$2 - D$2 * A$3;
function cubehelixConvert$2(o) {
  if (o instanceof Cubehelix$2)
    return new Cubehelix$2(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb$4))
    o = rgbConvert$4(o);
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, l2 = (BC_DA$2 * b10 + ED$2 * r2 - EB$2 * g2) / (BC_DA$2 + ED$2 - EB$2), bl = b10 - l2, k2 = (E$2 * (g2 - l2) - C$2 * bl) / D$2, s2 = Math.sqrt(k2 * k2 + bl * bl) / (E$2 * l2 * (1 - l2)), h2 = s2 ? Math.atan2(k2, bl) * degrees$6 - 120 : NaN;
  return new Cubehelix$2(h2 < 0 ? h2 + 360 : h2, s2, l2, o.opacity);
}
function cubehelix$7(h2, s2, l2, opacity) {
  return arguments.length === 1 ? cubehelixConvert$2(h2) : new Cubehelix$2(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Cubehelix$2(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$4(Cubehelix$2, cubehelix$7, extend$4(Color$4, {
  brighter(k2) {
    k2 = k2 == null ? brighter$4 : Math.pow(brighter$4, k2);
    return new Cubehelix$2(this.h, this.s, this.l * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker$4 : Math.pow(darker$4, k2);
    return new Cubehelix$2(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb() {
    var h2 = isNaN(this.h) ? 0 : (this.h + 120) * radians$3, l2 = +this.l, a2 = isNaN(this.s) ? 0 : this.s * l2 * (1 - l2), cosh2 = Math.cos(h2), sinh2 = Math.sin(h2);
    return new Rgb$4(
      255 * (l2 + a2 * (A$3 * cosh2 + B$2 * sinh2)),
      255 * (l2 + a2 * (C$2 * cosh2 + D$2 * sinh2)),
      255 * (l2 + a2 * (E$2 * cosh2)),
      this.opacity
    );
  }
}));
function basis$5(t12, v0, v1, v2, v3) {
  var t22 = t12 * t12, t32 = t22 * t12;
  return ((1 - 3 * t12 + 3 * t22 - t32) * v0 + (4 - 6 * t22 + 3 * t32) * v1 + (1 + 3 * t12 + 3 * t22 - 3 * t32) * v2 + t32 * v3) / 6;
}
function basis$6(values2) {
  var n2 = values2.length - 1;
  return function(t4) {
    var i = t4 <= 0 ? t4 = 0 : t4 >= 1 ? (t4 = 1, n2 - 1) : Math.floor(t4 * n2), v1 = values2[i], v2 = values2[i + 1], v0 = i > 0 ? values2[i - 1] : 2 * v1 - v2, v3 = i < n2 - 1 ? values2[i + 2] : 2 * v2 - v1;
    return basis$5((t4 - i / n2) * n2, v0, v1, v2, v3);
  };
}
function basisClosed$2(values2) {
  var n2 = values2.length;
  return function(t4) {
    var i = Math.floor(((t4 %= 1) < 0 ? ++t4 : t4) * n2), v0 = values2[(i + n2 - 1) % n2], v1 = values2[i % n2], v2 = values2[(i + 1) % n2], v3 = values2[(i + 2) % n2];
    return basis$5((t4 - i / n2) * n2, v0, v1, v2, v3);
  };
}
var constant$g = (x2) => () => x2;
function linear$7(a2, d2) {
  return function(t4) {
    return a2 + t4 * d2;
  };
}
function exponential$5(a2, b10, y2) {
  return a2 = Math.pow(a2, y2), b10 = Math.pow(b10, y2) - a2, y2 = 1 / y2, function(t4) {
    return Math.pow(a2 + t4 * b10, y2);
  };
}
function hue$4(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$7(a2, d2 > 180 || d2 < -180 ? d2 - 360 * Math.round(d2 / 360) : d2) : constant$g(isNaN(a2) ? b10 : a2);
}
function gamma$5(y2) {
  return (y2 = +y2) === 1 ? nogamma$4 : function(a2, b10) {
    return b10 - a2 ? exponential$5(a2, b10, y2) : constant$g(isNaN(a2) ? b10 : a2);
  };
}
function nogamma$4(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$7(a2, d2) : constant$g(isNaN(a2) ? b10 : a2);
}
var interpolateRgb$1 = function rgbGamma(y2) {
  var color2 = gamma$5(y2);
  function rgb2(start2, end2) {
    var r2 = color2((start2 = rgb$6(start2)).r, (end2 = rgb$6(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity = nogamma$4(start2.opacity, end2.opacity);
    return function(t4) {
      start2.r = r2(t4);
      start2.g = g2(t4);
      start2.b = b10(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);
function rgbSpline$2(spline) {
  return function(colors2) {
    var n2 = colors2.length, r2 = new Array(n2), g2 = new Array(n2), b10 = new Array(n2), i, color2;
    for (i = 0; i < n2; ++i) {
      color2 = rgb$6(colors2[i]);
      r2[i] = color2.r || 0;
      g2[i] = color2.g || 0;
      b10[i] = color2.b || 0;
    }
    r2 = spline(r2);
    g2 = spline(g2);
    b10 = spline(b10);
    color2.opacity = 1;
    return function(t4) {
      color2.r = r2(t4);
      color2.g = g2(t4);
      color2.b = b10(t4);
      return color2 + "";
    };
  };
}
var rgbBasis$2 = rgbSpline$2(basis$6);
var rgbBasisClosed$1 = rgbSpline$2(basisClosed$2);
function numberArray$2(a2, b10) {
  if (!b10)
    b10 = [];
  var n2 = a2 ? Math.min(b10.length, a2.length) : 0, c2 = b10.slice(), i;
  return function(t4) {
    for (i = 0; i < n2; ++i)
      c2[i] = a2[i] * (1 - t4) + b10[i] * t4;
    return c2;
  };
}
function isNumberArray$2(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function array$6(a2, b10) {
  return (isNumberArray$2(b10) ? numberArray$2 : genericArray$2)(a2, b10);
}
function genericArray$2(a2, b10) {
  var nb = b10 ? b10.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i)
    x2[i] = interpolate$5(a2[i], b10[i]);
  for (; i < nb; ++i)
    c2[i] = b10[i];
  return function(t4) {
    for (i = 0; i < na; ++i)
      c2[i] = x2[i](t4);
    return c2;
  };
}
function date$4(a2, b10) {
  var d2 = new Date();
  return a2 = +a2, b10 = +b10, function(t4) {
    return d2.setTime(a2 * (1 - t4) + b10 * t4), d2;
  };
}
function interpolateNumber$2(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return a2 * (1 - t4) + b10 * t4;
  };
}
function object$3(a2, b10) {
  var i = {}, c2 = {}, k2;
  if (a2 === null || typeof a2 !== "object")
    a2 = {};
  if (b10 === null || typeof b10 !== "object")
    b10 = {};
  for (k2 in b10) {
    if (k2 in a2) {
      i[k2] = interpolate$5(a2[k2], b10[k2]);
    } else {
      c2[k2] = b10[k2];
    }
  }
  return function(t4) {
    for (k2 in i)
      c2[k2] = i[k2](t4);
    return c2;
  };
}
var reA$3 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB$3 = new RegExp(reA$3.source, "g");
function zero$4(b10) {
  return function() {
    return b10;
  };
}
function one$3(b10) {
  return function(t4) {
    return b10(t4) + "";
  };
}
function string$2(a2, b10) {
  var bi = reA$3.lastIndex = reB$3.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q2 = [];
  a2 = a2 + "", b10 = b10 + "";
  while ((am = reA$3.exec(a2)) && (bm = reB$3.exec(b10))) {
    if ((bs = bm.index) > bi) {
      bs = b10.slice(bi, bs);
      if (s2[i])
        s2[i] += bs;
      else
        s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i])
        s2[i] += bm;
      else
        s2[++i] = bm;
    } else {
      s2[++i] = null;
      q2.push({ i, x: interpolateNumber$2(am, bm) });
    }
    bi = reB$3.lastIndex;
  }
  if (bi < b10.length) {
    bs = b10.slice(bi);
    if (s2[i])
      s2[i] += bs;
    else
      s2[++i] = bs;
  }
  return s2.length < 2 ? q2[0] ? one$3(q2[0].x) : zero$4(b10) : (b10 = q2.length, function(t4) {
    for (var i2 = 0, o; i2 < b10; ++i2)
      s2[(o = q2[i2]).i] = o.x(t4);
    return s2.join("");
  });
}
function interpolate$5(a2, b10) {
  var t4 = typeof b10, c2;
  return b10 == null || t4 === "boolean" ? constant$g(b10) : (t4 === "number" ? interpolateNumber$2 : t4 === "string" ? (c2 = color$5(b10)) ? (b10 = c2, interpolateRgb$1) : string$2 : b10 instanceof color$5 ? interpolateRgb$1 : b10 instanceof Date ? date$4 : isNumberArray$2(b10) ? numberArray$2 : Array.isArray(b10) ? genericArray$2 : typeof b10.valueOf !== "function" && typeof b10.toString !== "function" || isNaN(b10) ? object$3 : interpolateNumber$2)(a2, b10);
}
function discrete$1(range2) {
  var n2 = range2.length;
  return function(t4) {
    return range2[Math.max(0, Math.min(n2 - 1, Math.floor(t4 * n2)))];
  };
}
function hue$3(a2, b10) {
  var i = hue$4(+a2, +b10);
  return function(t4) {
    var x2 = i(t4);
    return x2 - 360 * Math.floor(x2 / 360);
  };
}
function interpolateRound$1(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return Math.round(a2 * (1 - t4) + b10 * t4);
  };
}
var degrees$5 = 180 / Math.PI;
var identity$f = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose$2(a2, b10, c2, d2, e3, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a2 * a2 + b10 * b10))
    a2 /= scaleX, b10 /= scaleX;
  if (skewX = a2 * c2 + b10 * d2)
    c2 -= a2 * skewX, d2 -= b10 * skewX;
  if (scaleY = Math.sqrt(c2 * c2 + d2 * d2))
    c2 /= scaleY, d2 /= scaleY, skewX /= scaleY;
  if (a2 * d2 < b10 * c2)
    a2 = -a2, b10 = -b10, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e3,
    translateY: f2,
    rotate: Math.atan2(b10, a2) * degrees$5,
    skewX: Math.atan(skewX) * degrees$5,
    scaleX,
    scaleY
  };
}
var svgNode$2;
function parseCss$2(value) {
  const m2 = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m2.isIdentity ? identity$f : decompose$2(m2.a, m2.b, m2.c, m2.d, m2.e, m2.f);
}
function parseSvg$2(value) {
  if (value == null)
    return identity$f;
  if (!svgNode$2)
    svgNode$2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode$2.setAttribute("transform", value);
  if (!(value = svgNode$2.transform.baseVal.consolidate()))
    return identity$f;
  value = value.matrix;
  return decompose$2(value.a, value.b, value.c, value.d, value.e, value.f);
}
function interpolateTransform$2(parse2, pxComma, pxParen, degParen) {
  function pop(s2) {
    return s2.length ? s2.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push("translate(", null, pxComma, null, pxParen);
      q2.push({ i: i - 4, x: interpolateNumber$2(xa, xb) }, { i: i - 2, x: interpolateNumber$2(ya, yb) });
    } else if (xb || yb) {
      s2.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a2, b10, s2, q2) {
    if (a2 !== b10) {
      if (a2 - b10 > 180)
        b10 += 360;
      else if (b10 - a2 > 180)
        a2 += 360;
      q2.push({ i: s2.push(pop(s2) + "rotate(", null, degParen) - 2, x: interpolateNumber$2(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "rotate(" + b10 + degParen);
    }
  }
  function skewX(a2, b10, s2, q2) {
    if (a2 !== b10) {
      q2.push({ i: s2.push(pop(s2) + "skewX(", null, degParen) - 2, x: interpolateNumber$2(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "skewX(" + b10 + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push(pop(s2) + "scale(", null, ",", null, ")");
      q2.push({ i: i - 4, x: interpolateNumber$2(xa, xb) }, { i: i - 2, x: interpolateNumber$2(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s2.push(pop(s2) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a2, b10) {
    var s2 = [], q2 = [];
    a2 = parse2(a2), b10 = parse2(b10);
    translate(a2.translateX, a2.translateY, b10.translateX, b10.translateY, s2, q2);
    rotate(a2.rotate, b10.rotate, s2, q2);
    skewX(a2.skewX, b10.skewX, s2, q2);
    scale(a2.scaleX, a2.scaleY, b10.scaleX, b10.scaleY, s2, q2);
    a2 = b10 = null;
    return function(t4) {
      var i = -1, n2 = q2.length, o;
      while (++i < n2)
        s2[(o = q2[i]).i] = o.x(t4);
      return s2.join("");
    };
  };
}
var interpolateTransformCss$2 = interpolateTransform$2(parseCss$2, "px, ", "px)", "deg)");
var interpolateTransformSvg$2 = interpolateTransform$2(parseSvg$2, ", ", ")", ")");
var epsilon2$3 = 1e-12;
function cosh$2(x2) {
  return ((x2 = Math.exp(x2)) + 1 / x2) / 2;
}
function sinh$2(x2) {
  return ((x2 = Math.exp(x2)) - 1 / x2) / 2;
}
function tanh$2(x2) {
  return ((x2 = Math.exp(2 * x2)) - 1) / (x2 + 1);
}
var zoom$2 = function zoomRho(rho, rho2, rho4) {
  function zoom2(p02, p1) {
    var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < epsilon2$3) {
      S = Math.log(w1 / w0) / rho;
      i = function(t4) {
        return [
          ux0 + t4 * dx,
          uy0 + t4 * dy,
          w0 * Math.exp(rho * t4 * S)
        ];
      };
    } else {
      var d1 = Math.sqrt(d2), b02 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b12 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b02 * b02 + 1) - b02), r1 = Math.log(Math.sqrt(b12 * b12 + 1) - b12);
      S = (r1 - r0) / rho;
      i = function(t4) {
        var s2 = t4 * S, coshr0 = cosh$2(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh$2(rho * s2 + r0) - sinh$2(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh$2(rho * s2 + r0)
        ];
      };
    }
    i.duration = S * 1e3 * rho / Math.SQRT2;
    return i;
  }
  zoom2.rho = function(_2) {
    var _1 = Math.max(1e-3, +_2), _22 = _1 * _1, _4 = _22 * _22;
    return zoomRho(_1, _22, _4);
  };
  return zoom2;
}(Math.SQRT2, 2, 4);
function hsl$6(hue2) {
  return function(start2, end2) {
    var h2 = hue2((start2 = hsl$7(start2)).h, (end2 = hsl$7(end2)).h), s2 = nogamma$4(start2.s, end2.s), l2 = nogamma$4(start2.l, end2.l), opacity = nogamma$4(start2.opacity, end2.opacity);
    return function(t4) {
      start2.h = h2(t4);
      start2.s = s2(t4);
      start2.l = l2(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  };
}
var interpolateHsl = hsl$6(hue$4);
var hslLong$1 = hsl$6(nogamma$4);
function lab$2(start2, end2) {
  var l2 = nogamma$4((start2 = lab$3(start2)).l, (end2 = lab$3(end2)).l), a2 = nogamma$4(start2.a, end2.a), b10 = nogamma$4(start2.b, end2.b), opacity = nogamma$4(start2.opacity, end2.opacity);
  return function(t4) {
    start2.l = l2(t4);
    start2.a = a2(t4);
    start2.b = b10(t4);
    start2.opacity = opacity(t4);
    return start2 + "";
  };
}
function hcl$3(hue2) {
  return function(start2, end2) {
    var h2 = hue2((start2 = hcl$4(start2)).h, (end2 = hcl$4(end2)).h), c2 = nogamma$4(start2.c, end2.c), l2 = nogamma$4(start2.l, end2.l), opacity = nogamma$4(start2.opacity, end2.opacity);
    return function(t4) {
      start2.h = h2(t4);
      start2.c = c2(t4);
      start2.l = l2(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  };
}
var interpolateHcl = hcl$3(hue$4);
var hclLong$1 = hcl$3(nogamma$4);
function cubehelix$6(hue2) {
  return function cubehelixGamma(y2) {
    y2 = +y2;
    function cubehelix2(start2, end2) {
      var h2 = hue2((start2 = cubehelix$7(start2)).h, (end2 = cubehelix$7(end2)).h), s2 = nogamma$4(start2.s, end2.s), l2 = nogamma$4(start2.l, end2.l), opacity = nogamma$4(start2.opacity, end2.opacity);
      return function(t4) {
        start2.h = h2(t4);
        start2.s = s2(t4);
        start2.l = l2(Math.pow(t4, y2));
        start2.opacity = opacity(t4);
        return start2 + "";
      };
    }
    cubehelix2.gamma = cubehelixGamma;
    return cubehelix2;
  }(1);
}
var interpolateCubehelix = cubehelix$6(hue$4);
var cubehelixLong$2 = cubehelix$6(nogamma$4);
function piecewise$1(interpolate2, values2) {
  if (values2 === void 0)
    values2 = interpolate2, interpolate2 = interpolate$5;
  var i = 0, n2 = values2.length - 1, v2 = values2[0], I = new Array(n2 < 0 ? 0 : n2);
  while (i < n2)
    I[i] = interpolate2(v2, v2 = values2[++i]);
  return function(t4) {
    var i2 = Math.max(0, Math.min(n2 - 1, Math.floor(t4 *= n2)));
    return I[i2](t4 - i2);
  };
}
function quantize$3(interpolator, n2) {
  var samples = new Array(n2);
  for (var i = 0; i < n2; ++i)
    samples[i] = interpolator(i / (n2 - 1));
  return samples;
}
function constants$1(x2) {
  return function() {
    return x2;
  };
}
function number$6(x2) {
  return +x2;
}
var unit$1 = [0, 1];
function identity$e(x2) {
  return x2;
}
function normalize$1(a2, b10) {
  return (b10 -= a2 = +a2) ? function(x2) {
    return (x2 - a2) / b10;
  } : constants$1(isNaN(b10) ? NaN : 0.5);
}
function clamper$1(a2, b10) {
  var t4;
  if (a2 > b10)
    t4 = a2, a2 = b10, b10 = t4;
  return function(x2) {
    return Math.max(a2, Math.min(b10, x2));
  };
}
function bimap$1(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0)
    d0 = normalize$1(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize$1(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap$1(domain2, range2, interpolate2) {
  var j = Math.min(domain2.length, range2.length) - 1, d2 = new Array(j), r2 = new Array(j), i = -1;
  if (domain2[j] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i < j) {
    d2[i] = normalize$1(domain2[i], domain2[i + 1]);
    r2[i] = interpolate2(range2[i], range2[i + 1]);
  }
  return function(x2) {
    var i2 = bisect$1(domain2, x2, 1, j) - 1;
    return r2[i2](d2[i2](x2));
  };
}
function copy$4(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$6() {
  var domain2 = unit$1, range2 = unit$1, interpolate2 = interpolate$5, transform2, untransform, unknown2, clamp2 = identity$e, piecewise2, output, input;
  function rescale() {
    var n2 = Math.min(domain2.length, range2.length);
    if (clamp2 !== identity$e)
      clamp2 = clamper$1(domain2[0], domain2[n2 - 1]);
    piecewise2 = n2 > 2 ? polymap$1 : bimap$1;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : (output || (output = piecewise2(domain2.map(transform2), range2, interpolate2)))(transform2(clamp2(x2)));
  }
  scale.invert = function(y2) {
    return clamp2(untransform((input || (input = piecewise2(range2, domain2.map(transform2), interpolateNumber$2)))(y2)));
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$6), rescale()) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return range2 = Array.from(_2), interpolate2 = interpolateRound$1, rescale();
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = _2 ? true : identity$e, rescale()) : clamp2 !== identity$e;
  };
  scale.interpolate = function(_2) {
    return arguments.length ? (interpolate2 = _2, rescale()) : interpolate2;
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4, u) {
    transform2 = t4, untransform = u;
    return rescale();
  };
}
function continuous$1() {
  return transformer$6()(identity$e, identity$e);
}
function formatDecimal$1(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts$1(x2, p2) {
  if ((i = (x2 = p2 ? x2.toExponential(p2 - 1) : x2.toExponential()).indexOf("e")) < 0)
    return null;
  var i, coefficient = x2.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i + 1)
  ];
}
function exponent$3(x2) {
  return x2 = formatDecimalParts$1(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup$1(grouping, thousands) {
  return function(value, width2) {
    var i = value.length, t4 = [], j = 0, g2 = grouping[0], length2 = 0;
    while (i > 0 && g2 > 0) {
      if (length2 + g2 + 1 > width2)
        g2 = Math.max(1, width2 - length2);
      t4.push(value.substring(i -= g2, i + g2));
      if ((length2 += g2 + 1) > width2)
        break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t4.reverse().join(thousands);
  };
}
function formatNumerals$1(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier$1(specifier) {
  if (!(match2 = re$1.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier$1({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier$1.prototype = FormatSpecifier$1.prototype;
function FormatSpecifier$1(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier$1.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim$1(s2) {
  out:
    for (var n2 = s2.length, i = 1, i0 = -1, i1; i < n2; ++i) {
      switch (s2[i]) {
        case ".":
          i0 = i1 = i;
          break;
        case "0":
          if (i0 === 0)
            i0 = i;
          i1 = i;
          break;
        default:
          if (!+s2[i])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}
var prefixExponent$1;
function formatPrefixAuto$1(x2, p2) {
  var d2 = formatDecimalParts$1(x2, p2);
  if (!d2)
    return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1], i = exponent2 - (prefixExponent$1 = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i === n2 ? coefficient : i > n2 ? coefficient + new Array(i - n2 + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts$1(x2, Math.max(0, p2 + i - 1))[0];
}
function formatRounded$1(x2, p2) {
  var d2 = formatDecimalParts$1(x2, p2);
  if (!d2)
    return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var formatTypes$1 = {
  "%": (x2, p2) => (x2 * 100).toFixed(p2),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal$1,
  "e": (x2, p2) => x2.toExponential(p2),
  "f": (x2, p2) => x2.toFixed(p2),
  "g": (x2, p2) => x2.toPrecision(p2),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p2) => formatRounded$1(x2 * 100, p2),
  "r": formatRounded$1,
  "s": formatPrefixAuto$1,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$d(x2) {
  return x2;
}
var map$2 = Array.prototype.map, prefixes$1 = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$3(locale2) {
  var group2 = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$d : formatGroup$1(map$2.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$d : formatNumerals$1(map$2.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "\u2212" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier$1(specifier);
    var fill = specifier.fill, align2 = specifier.align, sign2 = specifier.sign, symbol2 = specifier.symbol, zero2 = specifier.zero, width2 = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type2 = specifier.type;
    if (type2 === "n")
      comma = true, type2 = "g";
    else if (!formatTypes$1[type2])
      precision === void 0 && (precision = 12), trim2 = true, type2 = "g";
    if (zero2 || fill === "0" && align2 === "=")
      zero2 = true, fill = "0", align2 = "=";
    var prefix2 = symbol2 === "$" ? currencyPrefix : symbol2 === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : "", suffix = symbol2 === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "";
    var formatType = formatTypes$1[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i, n2, c2;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2)
          value = formatTrim$1(value);
        if (valueNegative && +value === 0 && sign2 !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type2 === "s" ? prefixes$1[8 + prefixExponent$1 / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n2 = value.length;
          while (++i < n2) {
            if (c2 = value.charCodeAt(i), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value = group2(value, Infinity);
      var length2 = valuePrefix.length + value.length + valueSuffix.length, padding2 = length2 < width2 ? new Array(width2 - length2 + 1).join(fill) : "";
      if (comma && zero2)
        value = group2(padding2 + value, padding2.length ? width2 - valueSuffix.length : Infinity), padding2 = "";
      switch (align2) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding2;
          break;
        case "=":
          value = valuePrefix + padding2 + value + valueSuffix;
          break;
        case "^":
          value = padding2.slice(0, length2 = padding2.length >> 1) + valuePrefix + value + valueSuffix + padding2.slice(length2);
          break;
        default:
          value = padding2 + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier$1(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent$3(value) / 3))) * 3, k2 = Math.pow(10, -e3), prefix2 = prefixes$1[8 + e3 / 3];
    return function(value2) {
      return f2(k2 * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$3;
var format$1;
var formatPrefix$1;
defaultLocale$3({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$3(definition) {
  locale$3 = formatLocale$3(definition);
  format$1 = locale$3.format;
  formatPrefix$1 = locale$3.formatPrefix;
  return locale$3;
}
function precisionFixed$1(step2) {
  return Math.max(0, -exponent$3(Math.abs(step2)));
}
function precisionPrefix$1(step2, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$3(value) / 3))) * 3 - exponent$3(Math.abs(step2)));
}
function precisionRound$1(step2, max2) {
  step2 = Math.abs(step2), max2 = Math.abs(max2) - step2;
  return Math.max(0, exponent$3(max2) - exponent$3(step2)) + 1;
}
function tickFormat$1(start2, stop, count2, specifier) {
  var step2 = tickStep$2(start2, stop, count2), precision;
  specifier = formatSpecifier$1(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix$1(step2, value)))
        specifier.precision = precision;
      return formatPrefix$1(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound$1(step2, Math.max(Math.abs(start2), Math.abs(stop)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed$1(step2)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}
function linearish$1(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d2 = domain2();
    return ticks$1(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d2 = domain2();
    return tickFormat$1(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null)
      count2 = 10;
    var d2 = domain2();
    var i0 = 0;
    var i1 = d2.length - 1;
    var start2 = d2[i0];
    var stop = d2[i1];
    var prestep;
    var step2;
    var maxIter = 10;
    if (stop < start2) {
      step2 = start2, start2 = stop, stop = step2;
      step2 = i0, i0 = i1, i1 = step2;
    }
    while (maxIter-- > 0) {
      step2 = tickIncrement$1(start2, stop, count2);
      if (step2 === prestep) {
        d2[i0] = start2;
        d2[i1] = stop;
        return domain2(d2);
      } else if (step2 > 0) {
        start2 = Math.floor(start2 / step2) * step2;
        stop = Math.ceil(stop / step2) * step2;
      } else if (step2 < 0) {
        start2 = Math.ceil(start2 * step2) / step2;
        stop = Math.floor(stop * step2) / step2;
      } else {
        break;
      }
      prestep = step2;
    }
    return scale;
  };
  return scale;
}
function linear$6() {
  var scale = continuous$1();
  scale.copy = function() {
    return copy$4(scale, linear$6());
  };
  initRange$1.apply(scale, arguments);
  return linearish$1(scale);
}
function identity$c(domain2) {
  var unknown2;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : x2;
  }
  scale.invert = scale;
  scale.domain = scale.range = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$6), scale) : domain2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return identity$c(domain2).unknown(unknown2);
  };
  domain2 = arguments.length ? Array.from(domain2, number$6) : [0, 1];
  return linearish$1(scale);
}
function nice$3(domain2, interval2) {
  domain2 = domain2.slice();
  var i0 = 0, i1 = domain2.length - 1, x02 = domain2[i0], x12 = domain2[i1], t4;
  if (x12 < x02) {
    t4 = i0, i0 = i1, i1 = t4;
    t4 = x02, x02 = x12, x12 = t4;
  }
  domain2[i0] = interval2.floor(x02);
  domain2[i1] = interval2.ceil(x12);
  return domain2;
}
function transformLog$1(x2) {
  return Math.log(x2);
}
function transformExp$1(x2) {
  return Math.exp(x2);
}
function transformLogn$1(x2) {
  return -Math.log(-x2);
}
function transformExpn$1(x2) {
  return -Math.exp(-x2);
}
function pow10$1(x2) {
  return isFinite(x2) ? +("1e" + x2) : x2 < 0 ? 0 : x2;
}
function powp$1(base2) {
  return base2 === 10 ? pow10$1 : base2 === Math.E ? Math.exp : (x2) => Math.pow(base2, x2);
}
function logp$1(base2) {
  return base2 === Math.E ? Math.log : base2 === 10 && Math.log10 || base2 === 2 && Math.log2 || (base2 = Math.log(base2), (x2) => Math.log(x2) / base2);
}
function reflect$1(f2) {
  return (x2, k2) => -f2(-x2, k2);
}
function loggish$1(transform2) {
  const scale = transform2(transformLog$1, transformExp$1);
  const domain2 = scale.domain;
  let base2 = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp$1(base2), pows = powp$1(base2);
    if (domain2()[0] < 0) {
      logs = reflect$1(logs), pows = reflect$1(pows);
      transform2(transformLogn$1, transformExpn$1);
    } else {
      transform2(transformLog$1, transformExp$1);
    }
    return scale;
  }
  scale.base = function(_2) {
    return arguments.length ? (base2 = +_2, rescale()) : base2;
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.ticks = (count2) => {
    const d2 = domain2();
    let u = d2[0];
    let v2 = d2[d2.length - 1];
    const r2 = v2 < u;
    if (r2)
      [u, v2] = [v2, u];
    let i = logs(u);
    let j = logs(v2);
    let k2;
    let t4;
    const n2 = count2 == null ? 10 : +count2;
    let z2 = [];
    if (!(base2 % 1) && j - i < n2) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0)
        for (; i <= j; ++i) {
          for (k2 = 1; k2 < base2; ++k2) {
            t4 = i < 0 ? k2 / pows(-i) : k2 * pows(i);
            if (t4 < u)
              continue;
            if (t4 > v2)
              break;
            z2.push(t4);
          }
        }
      else
        for (; i <= j; ++i) {
          for (k2 = base2 - 1; k2 >= 1; --k2) {
            t4 = i > 0 ? k2 / pows(-i) : k2 * pows(i);
            if (t4 < u)
              continue;
            if (t4 > v2)
              break;
            z2.push(t4);
          }
        }
      if (z2.length * 2 < n2)
        z2 = ticks$1(u, v2, n2);
    } else {
      z2 = ticks$1(i, j, Math.min(j - i, n2)).map(pows);
    }
    return r2 ? z2.reverse() : z2;
  };
  scale.tickFormat = (count2, specifier) => {
    if (count2 == null)
      count2 = 10;
    if (specifier == null)
      specifier = base2 === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base2 % 1) && (specifier = formatSpecifier$1(specifier)).precision == null)
        specifier.trim = true;
      specifier = format$1(specifier);
    }
    if (count2 === Infinity)
      return specifier;
    const k2 = Math.max(1, base2 * count2 / scale.ticks().length);
    return (d2) => {
      let i = d2 / pows(Math.round(logs(d2)));
      if (i * base2 < base2 - 0.5)
        i *= base2;
      return i <= k2 ? specifier(d2) : "";
    };
  };
  scale.nice = () => {
    return domain2(nice$3(domain2(), {
      floor: (x2) => pows(Math.floor(logs(x2))),
      ceil: (x2) => pows(Math.ceil(logs(x2)))
    }));
  };
  return scale;
}
function log$2() {
  const scale = loggish$1(transformer$6()).domain([1, 10]);
  scale.copy = () => copy$4(scale, log$2()).base(scale.base());
  initRange$1.apply(scale, arguments);
  return scale;
}
function transformSymlog$1(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.log1p(Math.abs(x2 / c2));
  };
}
function transformSymexp$1(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.expm1(Math.abs(x2)) * c2;
  };
}
function symlogish$1(transform2) {
  var c2 = 1, scale = transform2(transformSymlog$1(c2), transformSymexp$1(c2));
  scale.constant = function(_2) {
    return arguments.length ? transform2(transformSymlog$1(c2 = +_2), transformSymexp$1(c2)) : c2;
  };
  return linearish$1(scale);
}
function symlog$1() {
  var scale = symlogish$1(transformer$6());
  scale.copy = function() {
    return copy$4(scale, symlog$1()).constant(scale.constant());
  };
  return initRange$1.apply(scale, arguments);
}
function transformPow$1(exponent2) {
  return function(x2) {
    return x2 < 0 ? -Math.pow(-x2, exponent2) : Math.pow(x2, exponent2);
  };
}
function transformSqrt$1(x2) {
  return x2 < 0 ? -Math.sqrt(-x2) : Math.sqrt(x2);
}
function transformSquare$1(x2) {
  return x2 < 0 ? -x2 * x2 : x2 * x2;
}
function powish$1(transform2) {
  var scale = transform2(identity$e, identity$e), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform2(identity$e, identity$e) : exponent2 === 0.5 ? transform2(transformSqrt$1, transformSquare$1) : transform2(transformPow$1(exponent2), transformPow$1(1 / exponent2));
  }
  scale.exponent = function(_2) {
    return arguments.length ? (exponent2 = +_2, rescale()) : exponent2;
  };
  return linearish$1(scale);
}
function pow$3() {
  var scale = powish$1(transformer$6());
  scale.copy = function() {
    return copy$4(scale, pow$3()).exponent(scale.exponent());
  };
  initRange$1.apply(scale, arguments);
  return scale;
}
function sqrt$3() {
  return pow$3.apply(null, arguments).exponent(0.5);
}
function square$2(x2) {
  return Math.sign(x2) * x2 * x2;
}
function unsquare$1(x2) {
  return Math.sign(x2) * Math.sqrt(Math.abs(x2));
}
function radial$2() {
  var squared = continuous$1(), range2 = [0, 1], round2 = false, unknown2;
  function scale(x2) {
    var y2 = unsquare$1(squared(x2));
    return isNaN(y2) ? unknown2 : round2 ? Math.round(y2) : y2;
  }
  scale.invert = function(y2) {
    return squared.invert(square$2(y2));
  };
  scale.domain = function(_2) {
    return arguments.length ? (squared.domain(_2), scale) : squared.domain();
  };
  scale.range = function(_2) {
    return arguments.length ? (squared.range((range2 = Array.from(_2, number$6)).map(square$2)), scale) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return scale.range(_2).round(true);
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, scale) : round2;
  };
  scale.clamp = function(_2) {
    return arguments.length ? (squared.clamp(_2), scale) : squared.clamp();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return radial$2(squared.domain(), range2).round(round2).clamp(squared.clamp()).unknown(unknown2);
  };
  initRange$1.apply(scale, arguments);
  return linearish$1(scale);
}
function quantile$2() {
  var domain2 = [], range2 = [], thresholds = [], unknown2;
  function rescale() {
    var i = 0, n2 = Math.max(1, range2.length);
    thresholds = new Array(n2 - 1);
    while (++i < n2)
      thresholds[i - 1] = quantileSorted$1(domain2, i / n2);
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : range2[bisect$1(thresholds, x2)];
  }
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain2[0],
      i < thresholds.length ? thresholds[i] : domain2[domain2.length - 1]
    ];
  };
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d2 of _2)
      if (d2 != null && !isNaN(d2 = +d2))
        domain2.push(d2);
    domain2.sort(ascending$4);
    return rescale();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.quantiles = function() {
    return thresholds.slice();
  };
  scale.copy = function() {
    return quantile$2().domain(domain2).range(range2).unknown(unknown2);
  };
  return initRange$1.apply(scale, arguments);
}
function quantize$2() {
  var x02 = 0, x12 = 1, n2 = 1, domain2 = [0.5], range2 = [0, 1], unknown2;
  function scale(x2) {
    return x2 != null && x2 <= x2 ? range2[bisect$1(domain2, x2, 0, n2)] : unknown2;
  }
  function rescale() {
    var i = -1;
    domain2 = new Array(n2);
    while (++i < n2)
      domain2[i] = ((i + 1) * x12 - (i - n2) * x02) / (n2 + 1);
    return scale;
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12] = _2, x02 = +x02, x12 = +x12, rescale()) : [x02, x12];
  };
  scale.range = function(_2) {
    return arguments.length ? (n2 = (range2 = Array.from(_2)).length - 1, rescale()) : range2.slice();
  };
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x02, domain2[0]] : i >= n2 ? [domain2[n2 - 1], x12] : [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : scale;
  };
  scale.thresholds = function() {
    return domain2.slice();
  };
  scale.copy = function() {
    return quantize$2().domain([x02, x12]).range(range2).unknown(unknown2);
  };
  return initRange$1.apply(linearish$1(scale), arguments);
}
function threshold$1() {
  var domain2 = [0.5], range2 = [0, 1], unknown2, n2 = 1;
  function scale(x2) {
    return x2 != null && x2 <= x2 ? range2[bisect$1(domain2, x2, 0, n2)] : unknown2;
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2), n2 = Math.min(domain2.length, range2.length - 1), scale) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), n2 = Math.min(domain2.length, range2.length - 1), scale) : range2.slice();
  };
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return threshold$1().domain(domain2).range(range2).unknown(unknown2);
  };
  return initRange$1.apply(scale, arguments);
}
const t0$2 = new Date(), t1$2 = new Date();
function timeInterval(floori, offseti, count2, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? new Date() : new Date(+date2)), date2;
  }
  interval2.floor = (date2) => {
    return floori(date2 = new Date(+date2)), date2;
  };
  interval2.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = (date2) => {
    const d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = (date2, step2) => {
    return offseti(date2 = new Date(+date2), step2 == null ? 1 : Math.floor(step2)), date2;
  };
  interval2.range = (start2, stop, step2) => {
    const range2 = [];
    start2 = interval2.ceil(start2);
    step2 = step2 == null ? 1 : Math.floor(step2);
    if (!(start2 < stop) || !(step2 > 0))
      return range2;
    let previous;
    do
      range2.push(previous = new Date(+start2)), offseti(start2, step2), floori(start2);
    while (previous < start2 && start2 < stop);
    return range2;
  };
  interval2.filter = (test) => {
    return timeInterval((date2) => {
      if (date2 >= date2)
        while (floori(date2), !test(date2))
          date2.setTime(date2 - 1);
    }, (date2, step2) => {
      if (date2 >= date2) {
        if (step2 < 0)
          while (++step2 <= 0) {
            while (offseti(date2, -1), !test(date2)) {
            }
          }
        else
          while (--step2 >= 0) {
            while (offseti(date2, 1), !test(date2)) {
            }
          }
      }
    });
  };
  if (count2) {
    interval2.count = (start2, end2) => {
      t0$2.setTime(+start2), t1$2.setTime(+end2);
      floori(t0$2), floori(t1$2);
      return Math.floor(count2(t0$2, t1$2));
    };
    interval2.every = (step2) => {
      step2 = Math.floor(step2);
      return !isFinite(step2) || !(step2 > 0) ? null : !(step2 > 1) ? interval2 : interval2.filter(field ? (d2) => field(d2) % step2 === 0 : (d2) => interval2.count(0, d2) % step2 === 0);
    };
  }
  return interval2;
}
const millisecond$2 = timeInterval(() => {
}, (date2, step2) => {
  date2.setTime(+date2 + step2);
}, (start2, end2) => {
  return end2 - start2;
});
millisecond$2.every = (k2) => {
  k2 = Math.floor(k2);
  if (!isFinite(k2) || !(k2 > 0))
    return null;
  if (!(k2 > 1))
    return millisecond$2;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k2) * k2);
  }, (date2, step2) => {
    date2.setTime(+date2 + step2 * k2);
  }, (start2, end2) => {
    return (end2 - start2) / k2;
  });
};
const milliseconds$1 = millisecond$2.range;
const durationSecond$1 = 1e3;
const durationMinute$1 = durationSecond$1 * 60;
const durationHour$1 = durationMinute$1 * 60;
const durationDay$1 = durationHour$1 * 24;
const durationWeek$1 = durationDay$1 * 7;
const durationMonth$1 = durationDay$1 * 30;
const durationYear$1 = durationDay$1 * 365;
const second$1 = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationSecond$1);
}, (start2, end2) => {
  return (end2 - start2) / durationSecond$1;
}, (date2) => {
  return date2.getUTCSeconds();
});
const seconds$1 = second$1.range;
const timeMinute$1 = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond$1);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationMinute$1);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute$1;
}, (date2) => {
  return date2.getMinutes();
});
const timeMinutes = timeMinute$1.range;
const utcMinute$2 = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationMinute$1);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute$1;
}, (date2) => {
  return date2.getUTCMinutes();
});
const utcMinutes$1 = utcMinute$2.range;
const timeHour$1 = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond$1 - date2.getMinutes() * durationMinute$1);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationHour$1);
}, (start2, end2) => {
  return (end2 - start2) / durationHour$1;
}, (date2) => {
  return date2.getHours();
});
const timeHours = timeHour$1.range;
const utcHour$2 = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationHour$1);
}, (start2, end2) => {
  return (end2 - start2) / durationHour$1;
}, (date2) => {
  return date2.getUTCHours();
});
const utcHours$1 = utcHour$2.range;
const timeDay$1 = timeInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step2) => date2.setDate(date2.getDate() + step2),
  (start2, end2) => (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute$1) / durationDay$1,
  (date2) => date2.getDate() - 1
);
const timeDays = timeDay$1.range;
const utcDay$2 = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCDate(date2.getUTCDate() + step2);
}, (start2, end2) => {
  return (end2 - start2) / durationDay$1;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
const utcDays$1 = utcDay$2.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCDate(date2.getUTCDate() + step2);
}, (start2, end2) => {
  return (end2 - start2) / durationDay$1;
}, (date2) => {
  return Math.floor(date2 / durationDay$1);
});
const unixDays = unixDay.range;
function timeWeekday(i) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setDate(date2.getDate() + step2 * 7);
  }, (start2, end2) => {
    return (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
const timeSundays = timeSunday.range;
const timeMondays = timeMonday.range;
const timeTuesdays = timeTuesday.range;
const timeWednesdays = timeWednesday.range;
const timeThursdays = timeThursday.range;
const timeFridays = timeFriday.range;
const timeSaturdays = timeSaturday.range;
function utcWeekday$1(i) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setUTCDate(date2.getUTCDate() + step2 * 7);
  }, (start2, end2) => {
    return (end2 - start2) / durationWeek$1;
  });
}
const utcSunday$1 = utcWeekday$1(0);
const utcMonday$1 = utcWeekday$1(1);
const utcTuesday$1 = utcWeekday$1(2);
const utcWednesday$1 = utcWeekday$1(3);
const utcThursday$1 = utcWeekday$1(4);
const utcFriday$1 = utcWeekday$1(5);
const utcSaturday$1 = utcWeekday$1(6);
const utcSundays$1 = utcSunday$1.range;
const utcMondays$1 = utcMonday$1.range;
const utcTuesdays$1 = utcTuesday$1.range;
const utcWednesdays$1 = utcWednesday$1.range;
const utcThursdays$1 = utcThursday$1.range;
const utcFridays$1 = utcFriday$1.range;
const utcSaturdays$1 = utcSaturday$1.range;
const timeMonth$1 = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setMonth(date2.getMonth() + step2);
}, (start2, end2) => {
  return end2.getMonth() - start2.getMonth() + (end2.getFullYear() - start2.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
const timeMonths = timeMonth$1.range;
const utcMonth$2 = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCMonth(date2.getUTCMonth() + step2);
}, (start2, end2) => {
  return end2.getUTCMonth() - start2.getUTCMonth() + (end2.getUTCFullYear() - start2.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
const utcMonths$1 = utcMonth$2.range;
const timeYear$1 = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setFullYear(date2.getFullYear() + step2);
}, (start2, end2) => {
  return end2.getFullYear() - start2.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear$1.every = (k2) => {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k2) * k2);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setFullYear(date2.getFullYear() + step2 * k2);
  });
};
const timeYears = timeYear$1.range;
const utcYear$2 = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step2);
}, (start2, end2) => {
  return end2.getUTCFullYear() - start2.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear$2.every = (k2) => {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k2) * k2);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step2 * k2);
  });
};
const utcYears$1 = utcYear$2.range;
function ticker$1(year2, month2, week, day2, hour2, minute2) {
  const tickIntervals = [
    [second$1, 1, durationSecond$1],
    [second$1, 5, 5 * durationSecond$1],
    [second$1, 15, 15 * durationSecond$1],
    [second$1, 30, 30 * durationSecond$1],
    [minute2, 1, durationMinute$1],
    [minute2, 5, 5 * durationMinute$1],
    [minute2, 15, 15 * durationMinute$1],
    [minute2, 30, 30 * durationMinute$1],
    [hour2, 1, durationHour$1],
    [hour2, 3, 3 * durationHour$1],
    [hour2, 6, 6 * durationHour$1],
    [hour2, 12, 12 * durationHour$1],
    [day2, 1, durationDay$1],
    [day2, 2, 2 * durationDay$1],
    [week, 1, durationWeek$1],
    [month2, 1, durationMonth$1],
    [month2, 3, 3 * durationMonth$1],
    [year2, 1, durationYear$1]
  ];
  function ticks2(start2, stop, count2) {
    const reverse2 = stop < start2;
    if (reverse2)
      [start2, stop] = [stop, start2];
    const interval2 = count2 && typeof count2.range === "function" ? count2 : tickInterval(start2, stop, count2);
    const ticks3 = interval2 ? interval2.range(start2, +stop + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop, count2) {
    const target = Math.abs(stop - start2) / count2;
    const i = bisector$1(([, , step3]) => step3).right(tickIntervals, target);
    if (i === tickIntervals.length)
      return year2.every(tickStep$2(start2 / durationYear$1, stop / durationYear$1, count2));
    if (i === 0)
      return millisecond$2.every(Math.max(tickStep$2(start2, stop, count2), 1));
    const [t4, step2] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t4.every(step2);
  }
  return [ticks2, tickInterval];
}
const [utcTicks$1, utcTickInterval$1] = ticker$1(utcYear$2, utcMonth$2, utcSunday$1, unixDay, utcHour$2, utcMinute$2);
const [timeTicks$1, timeTickInterval$1] = ticker$1(timeYear$1, timeMonth$1, timeSunday, timeDay$1, timeHour$1, timeMinute$1);
function localDate$1(d2) {
  if (0 <= d2.y && d2.y < 100) {
    var date2 = new Date(-1, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L);
    date2.setFullYear(d2.y);
    return date2;
  }
  return new Date(d2.y, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L);
}
function utcDate$1(d2) {
  if (0 <= d2.y && d2.y < 100) {
    var date2 = new Date(Date.UTC(-1, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L));
    date2.setUTCFullYear(d2.y);
    return date2;
  }
  return new Date(Date.UTC(d2.y, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L));
}
function newDate$1(y2, m2, d2) {
  return { y: y2, m: m2, d: d2, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale$2(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe$1(locale_periods), periodLookup = formatLookup$1(locale_periods), weekdayRe = formatRe$1(locale_weekdays), weekdayLookup = formatLookup$1(locale_weekdays), shortWeekdayRe = formatRe$1(locale_shortWeekdays), shortWeekdayLookup = formatLookup$1(locale_shortWeekdays), monthRe = formatRe$1(locale_months), monthLookup = formatLookup$1(locale_months), shortMonthRe = formatRe$1(locale_shortMonths), shortMonthLookup = formatLookup$1(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth$1,
    "e": formatDayOfMonth$1,
    "f": formatMicroseconds$1,
    "g": formatYearISO$1,
    "G": formatFullYearISO$1,
    "H": formatHour24$1,
    "I": formatHour12$1,
    "j": formatDayOfYear$1,
    "L": formatMilliseconds$1,
    "m": formatMonthNumber$1,
    "M": formatMinutes$1,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp$1,
    "s": formatUnixTimestampSeconds$1,
    "S": formatSeconds$1,
    "u": formatWeekdayNumberMonday$1,
    "U": formatWeekNumberSunday$1,
    "V": formatWeekNumberISO$1,
    "w": formatWeekdayNumberSunday$1,
    "W": formatWeekNumberMonday$1,
    "x": null,
    "X": null,
    "y": formatYear$2,
    "Y": formatFullYear$1,
    "Z": formatZone$1,
    "%": formatLiteralPercent$1
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth$1,
    "e": formatUTCDayOfMonth$1,
    "f": formatUTCMicroseconds$1,
    "g": formatUTCYearISO$1,
    "G": formatUTCFullYearISO$1,
    "H": formatUTCHour24$1,
    "I": formatUTCHour12$1,
    "j": formatUTCDayOfYear$1,
    "L": formatUTCMilliseconds$1,
    "m": formatUTCMonthNumber$1,
    "M": formatUTCMinutes$1,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp$1,
    "s": formatUnixTimestampSeconds$1,
    "S": formatUTCSeconds$1,
    "u": formatUTCWeekdayNumberMonday$1,
    "U": formatUTCWeekNumberSunday$1,
    "V": formatUTCWeekNumberISO$1,
    "w": formatUTCWeekdayNumberSunday$1,
    "W": formatUTCWeekNumberMonday$1,
    "x": null,
    "X": null,
    "y": formatUTCYear$1,
    "Y": formatUTCFullYear$1,
    "Z": formatUTCZone$1,
    "%": formatLiteralPercent$1
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth$1,
    "e": parseDayOfMonth$1,
    "f": parseMicroseconds$1,
    "g": parseYear$1,
    "G": parseFullYear$1,
    "H": parseHour24$1,
    "I": parseHour24$1,
    "j": parseDayOfYear$1,
    "L": parseMilliseconds$1,
    "m": parseMonthNumber$1,
    "M": parseMinutes$1,
    "p": parsePeriod,
    "q": parseQuarter$1,
    "Q": parseUnixTimestamp$1,
    "s": parseUnixTimestampSeconds$1,
    "S": parseSeconds$1,
    "u": parseWeekdayNumberMonday$1,
    "U": parseWeekNumberSunday$1,
    "V": parseWeekNumberISO$1,
    "w": parseWeekdayNumberSunday$1,
    "W": parseWeekNumberMonday$1,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$1,
    "Y": parseFullYear$1,
    "Z": parseZone$1,
    "%": parseLiteralPercent$1
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string2 = [], i = -1, j = 0, n2 = specifier.length, c2, pad2, format2;
      if (!(date2 instanceof Date))
        date2 = new Date(+date2);
      while (++i < n2) {
        if (specifier.charCodeAt(i) === 37) {
          string2.push(specifier.slice(j, i));
          if ((pad2 = pads$1[c2 = specifier.charAt(++i)]) != null)
            c2 = specifier.charAt(++i);
          else
            pad2 = c2 === "e" ? " " : "0";
          if (format2 = formats2[c2])
            c2 = format2(date2, pad2);
          string2.push(c2);
          j = i + 1;
        }
      }
      string2.push(specifier.slice(j, i));
      return string2.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string2) {
      var d2 = newDate$1(1900, void 0, 1), i = parseSpecifier(d2, specifier, string2 += "", 0), week, day2;
      if (i != string2.length)
        return null;
      if ("Q" in d2)
        return new Date(d2.Q);
      if ("s" in d2)
        return new Date(d2.s * 1e3 + ("L" in d2 ? d2.L : 0));
      if (Z && !("Z" in d2))
        d2.Z = 0;
      if ("p" in d2)
        d2.H = d2.H % 12 + d2.p * 12;
      if (d2.m === void 0)
        d2.m = "q" in d2 ? d2.q : 0;
      if ("V" in d2) {
        if (d2.V < 1 || d2.V > 53)
          return null;
        if (!("w" in d2))
          d2.w = 1;
        if ("Z" in d2) {
          week = utcDate$1(newDate$1(d2.y, 0, 1)), day2 = week.getUTCDay();
          week = day2 > 4 || day2 === 0 ? utcMonday$1.ceil(week) : utcMonday$1(week);
          week = utcDay$2.offset(week, (d2.V - 1) * 7);
          d2.y = week.getUTCFullYear();
          d2.m = week.getUTCMonth();
          d2.d = week.getUTCDate() + (d2.w + 6) % 7;
        } else {
          week = localDate$1(newDate$1(d2.y, 0, 1)), day2 = week.getDay();
          week = day2 > 4 || day2 === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay$1.offset(week, (d2.V - 1) * 7);
          d2.y = week.getFullYear();
          d2.m = week.getMonth();
          d2.d = week.getDate() + (d2.w + 6) % 7;
        }
      } else if ("W" in d2 || "U" in d2) {
        if (!("w" in d2))
          d2.w = "u" in d2 ? d2.u % 7 : "W" in d2 ? 1 : 0;
        day2 = "Z" in d2 ? utcDate$1(newDate$1(d2.y, 0, 1)).getUTCDay() : localDate$1(newDate$1(d2.y, 0, 1)).getDay();
        d2.m = 0;
        d2.d = "W" in d2 ? (d2.w + 6) % 7 + d2.W * 7 - (day2 + 5) % 7 : d2.w + d2.U * 7 - (day2 + 6) % 7;
      }
      if ("Z" in d2) {
        d2.H += d2.Z / 100 | 0;
        d2.M += d2.Z % 100;
        return utcDate$1(d2);
      }
      return localDate$1(d2);
    };
  }
  function parseSpecifier(d2, specifier, string2, j) {
    var i = 0, n2 = specifier.length, m2 = string2.length, c2, parse2;
    while (i < n2) {
      if (j >= m2)
        return -1;
      c2 = specifier.charCodeAt(i++);
      if (c2 === 37) {
        c2 = specifier.charAt(i++);
        parse2 = parses[c2 in pads$1 ? specifier.charAt(i++) : c2];
        if (!parse2 || (j = parse2(d2, string2, j)) < 0)
          return -1;
      } else if (c2 != string2.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d2, string2, i) {
    var n2 = periodRe.exec(string2.slice(i));
    return n2 ? (d2.p = periodLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortWeekday(d2, string2, i) {
    var n2 = shortWeekdayRe.exec(string2.slice(i));
    return n2 ? (d2.w = shortWeekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseWeekday(d2, string2, i) {
    var n2 = weekdayRe.exec(string2.slice(i));
    return n2 ? (d2.w = weekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortMonth(d2, string2, i) {
    var n2 = shortMonthRe.exec(string2.slice(i));
    return n2 ? (d2.m = shortMonthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseMonth(d2, string2, i) {
    var n2 = monthRe.exec(string2.slice(i));
    return n2 ? (d2.m = monthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseLocaleDateTime(d2, string2, i) {
    return parseSpecifier(d2, locale_dateTime, string2, i);
  }
  function parseLocaleDate(d2, string2, i) {
    return parseSpecifier(d2, locale_date, string2, i);
  }
  function parseLocaleTime(d2, string2, i) {
    return parseSpecifier(d2, locale_time, string2, i);
  }
  function formatShortWeekday(d2) {
    return locale_shortWeekdays[d2.getDay()];
  }
  function formatWeekday(d2) {
    return locale_weekdays[d2.getDay()];
  }
  function formatShortMonth(d2) {
    return locale_shortMonths[d2.getMonth()];
  }
  function formatMonth(d2) {
    return locale_months[d2.getMonth()];
  }
  function formatPeriod(d2) {
    return locale_periods[+(d2.getHours() >= 12)];
  }
  function formatQuarter(d2) {
    return 1 + ~~(d2.getMonth() / 3);
  }
  function formatUTCShortWeekday(d2) {
    return locale_shortWeekdays[d2.getUTCDay()];
  }
  function formatUTCWeekday(d2) {
    return locale_weekdays[d2.getUTCDay()];
  }
  function formatUTCShortMonth(d2) {
    return locale_shortMonths[d2.getUTCMonth()];
  }
  function formatUTCMonth(d2) {
    return locale_months[d2.getUTCMonth()];
  }
  function formatUTCPeriod(d2) {
    return locale_periods[+(d2.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d2) {
    return 1 + ~~(d2.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p2 = newParse(specifier += "", false);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p2 = newParse(specifier += "", true);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    }
  };
}
var pads$1 = { "-": "", "_": " ", "0": "0" }, numberRe$1 = /^\s*\d+/, percentRe$1 = /^%/, requoteRe$1 = /[\\^$*+?|[\]().{}]/g;
function pad$2(value, fill, width2) {
  var sign2 = value < 0 ? "-" : "", string2 = (sign2 ? -value : value) + "", length2 = string2.length;
  return sign2 + (length2 < width2 ? new Array(width2 - length2 + 1).join(fill) + string2 : string2);
}
function requote$1(s2) {
  return s2.replace(requoteRe$1, "\\$&");
}
function formatRe$1(names) {
  return new RegExp("^(?:" + names.map(requote$1).join("|") + ")", "i");
}
function formatLookup$1(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 1));
  return n2 ? (d2.w = +n2[0], i + n2[0].length) : -1;
}
function parseWeekdayNumberMonday$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 1));
  return n2 ? (d2.u = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberSunday$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.U = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberISO$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.V = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberMonday$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.W = +n2[0], i + n2[0].length) : -1;
}
function parseFullYear$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 4));
  return n2 ? (d2.y = +n2[0], i + n2[0].length) : -1;
}
function parseYear$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.y = +n2[0] + (+n2[0] > 68 ? 1900 : 2e3), i + n2[0].length) : -1;
}
function parseZone$1(d2, string2, i) {
  var n2 = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string2.slice(i, i + 6));
  return n2 ? (d2.Z = n2[1] ? 0 : -(n2[2] + (n2[3] || "00")), i + n2[0].length) : -1;
}
function parseQuarter$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 1));
  return n2 ? (d2.q = n2[0] * 3 - 3, i + n2[0].length) : -1;
}
function parseMonthNumber$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.m = n2[0] - 1, i + n2[0].length) : -1;
}
function parseDayOfMonth$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.d = +n2[0], i + n2[0].length) : -1;
}
function parseDayOfYear$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 3));
  return n2 ? (d2.m = 0, d2.d = +n2[0], i + n2[0].length) : -1;
}
function parseHour24$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.H = +n2[0], i + n2[0].length) : -1;
}
function parseMinutes$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.M = +n2[0], i + n2[0].length) : -1;
}
function parseSeconds$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 2));
  return n2 ? (d2.S = +n2[0], i + n2[0].length) : -1;
}
function parseMilliseconds$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 3));
  return n2 ? (d2.L = +n2[0], i + n2[0].length) : -1;
}
function parseMicroseconds$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i, i + 6));
  return n2 ? (d2.L = Math.floor(n2[0] / 1e3), i + n2[0].length) : -1;
}
function parseLiteralPercent$1(d2, string2, i) {
  var n2 = percentRe$1.exec(string2.slice(i, i + 1));
  return n2 ? i + n2[0].length : -1;
}
function parseUnixTimestamp$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i));
  return n2 ? (d2.Q = +n2[0], i + n2[0].length) : -1;
}
function parseUnixTimestampSeconds$1(d2, string2, i) {
  var n2 = numberRe$1.exec(string2.slice(i));
  return n2 ? (d2.s = +n2[0], i + n2[0].length) : -1;
}
function formatDayOfMonth$1(d2, p2) {
  return pad$2(d2.getDate(), p2, 2);
}
function formatHour24$1(d2, p2) {
  return pad$2(d2.getHours(), p2, 2);
}
function formatHour12$1(d2, p2) {
  return pad$2(d2.getHours() % 12 || 12, p2, 2);
}
function formatDayOfYear$1(d2, p2) {
  return pad$2(1 + timeDay$1.count(timeYear$1(d2), d2), p2, 3);
}
function formatMilliseconds$1(d2, p2) {
  return pad$2(d2.getMilliseconds(), p2, 3);
}
function formatMicroseconds$1(d2, p2) {
  return formatMilliseconds$1(d2, p2) + "000";
}
function formatMonthNumber$1(d2, p2) {
  return pad$2(d2.getMonth() + 1, p2, 2);
}
function formatMinutes$1(d2, p2) {
  return pad$2(d2.getMinutes(), p2, 2);
}
function formatSeconds$1(d2, p2) {
  return pad$2(d2.getSeconds(), p2, 2);
}
function formatWeekdayNumberMonday$1(d2) {
  var day2 = d2.getDay();
  return day2 === 0 ? 7 : day2;
}
function formatWeekNumberSunday$1(d2, p2) {
  return pad$2(timeSunday.count(timeYear$1(d2) - 1, d2), p2, 2);
}
function dISO$1(d2) {
  var day2 = d2.getDay();
  return day2 >= 4 || day2 === 0 ? timeThursday(d2) : timeThursday.ceil(d2);
}
function formatWeekNumberISO$1(d2, p2) {
  d2 = dISO$1(d2);
  return pad$2(timeThursday.count(timeYear$1(d2), d2) + (timeYear$1(d2).getDay() === 4), p2, 2);
}
function formatWeekdayNumberSunday$1(d2) {
  return d2.getDay();
}
function formatWeekNumberMonday$1(d2, p2) {
  return pad$2(timeMonday.count(timeYear$1(d2) - 1, d2), p2, 2);
}
function formatYear$2(d2, p2) {
  return pad$2(d2.getFullYear() % 100, p2, 2);
}
function formatYearISO$1(d2, p2) {
  d2 = dISO$1(d2);
  return pad$2(d2.getFullYear() % 100, p2, 2);
}
function formatFullYear$1(d2, p2) {
  return pad$2(d2.getFullYear() % 1e4, p2, 4);
}
function formatFullYearISO$1(d2, p2) {
  var day2 = d2.getDay();
  d2 = day2 >= 4 || day2 === 0 ? timeThursday(d2) : timeThursday.ceil(d2);
  return pad$2(d2.getFullYear() % 1e4, p2, 4);
}
function formatZone$1(d2) {
  var z2 = d2.getTimezoneOffset();
  return (z2 > 0 ? "-" : (z2 *= -1, "+")) + pad$2(z2 / 60 | 0, "0", 2) + pad$2(z2 % 60, "0", 2);
}
function formatUTCDayOfMonth$1(d2, p2) {
  return pad$2(d2.getUTCDate(), p2, 2);
}
function formatUTCHour24$1(d2, p2) {
  return pad$2(d2.getUTCHours(), p2, 2);
}
function formatUTCHour12$1(d2, p2) {
  return pad$2(d2.getUTCHours() % 12 || 12, p2, 2);
}
function formatUTCDayOfYear$1(d2, p2) {
  return pad$2(1 + utcDay$2.count(utcYear$2(d2), d2), p2, 3);
}
function formatUTCMilliseconds$1(d2, p2) {
  return pad$2(d2.getUTCMilliseconds(), p2, 3);
}
function formatUTCMicroseconds$1(d2, p2) {
  return formatUTCMilliseconds$1(d2, p2) + "000";
}
function formatUTCMonthNumber$1(d2, p2) {
  return pad$2(d2.getUTCMonth() + 1, p2, 2);
}
function formatUTCMinutes$1(d2, p2) {
  return pad$2(d2.getUTCMinutes(), p2, 2);
}
function formatUTCSeconds$1(d2, p2) {
  return pad$2(d2.getUTCSeconds(), p2, 2);
}
function formatUTCWeekdayNumberMonday$1(d2) {
  var dow = d2.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday$1(d2, p2) {
  return pad$2(utcSunday$1.count(utcYear$2(d2) - 1, d2), p2, 2);
}
function UTCdISO$1(d2) {
  var day2 = d2.getUTCDay();
  return day2 >= 4 || day2 === 0 ? utcThursday$1(d2) : utcThursday$1.ceil(d2);
}
function formatUTCWeekNumberISO$1(d2, p2) {
  d2 = UTCdISO$1(d2);
  return pad$2(utcThursday$1.count(utcYear$2(d2), d2) + (utcYear$2(d2).getUTCDay() === 4), p2, 2);
}
function formatUTCWeekdayNumberSunday$1(d2) {
  return d2.getUTCDay();
}
function formatUTCWeekNumberMonday$1(d2, p2) {
  return pad$2(utcMonday$1.count(utcYear$2(d2) - 1, d2), p2, 2);
}
function formatUTCYear$1(d2, p2) {
  return pad$2(d2.getUTCFullYear() % 100, p2, 2);
}
function formatUTCYearISO$1(d2, p2) {
  d2 = UTCdISO$1(d2);
  return pad$2(d2.getUTCFullYear() % 100, p2, 2);
}
function formatUTCFullYear$1(d2, p2) {
  return pad$2(d2.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCFullYearISO$1(d2, p2) {
  var day2 = d2.getUTCDay();
  d2 = day2 >= 4 || day2 === 0 ? utcThursday$1(d2) : utcThursday$1.ceil(d2);
  return pad$2(d2.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCZone$1() {
  return "+0000";
}
function formatLiteralPercent$1() {
  return "%";
}
function formatUnixTimestamp$1(d2) {
  return +d2;
}
function formatUnixTimestampSeconds$1(d2) {
  return Math.floor(+d2 / 1e3);
}
var locale$2;
var timeFormat$1;
var utcFormat$1;
defaultLocale$2({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale$2(definition) {
  locale$2 = formatLocale$2(definition);
  timeFormat$1 = locale$2.format;
  locale$2.parse;
  utcFormat$1 = locale$2.utcFormat;
  locale$2.utcParse;
  return locale$2;
}
function date$3(t4) {
  return new Date(t4);
}
function number$5(t4) {
  return t4 instanceof Date ? +t4 : +new Date(+t4);
}
function calendar$1(ticks2, tickInterval, year2, month2, week, day2, hour2, minute2, second2, format2) {
  var scale = continuous$1(), invert = scale.invert, domain2 = scale.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute2(date2) < date2 ? formatSecond : hour2(date2) < date2 ? formatMinute : day2(date2) < date2 ? formatHour : month2(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year2(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale.invert = function(y2) {
    return new Date(invert(y2));
  };
  scale.domain = function(_2) {
    return arguments.length ? domain2(Array.from(_2, number$5)) : domain2().map(date$3);
  };
  scale.ticks = function(interval2) {
    var d2 = domain2();
    return ticks2(d2[0], d2[d2.length - 1], interval2 == null ? 10 : interval2);
  };
  scale.tickFormat = function(count2, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale.nice = function(interval2) {
    var d2 = domain2();
    if (!interval2 || typeof interval2.range !== "function")
      interval2 = tickInterval(d2[0], d2[d2.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain2(nice$3(d2, interval2)) : scale;
  };
  scale.copy = function() {
    return copy$4(scale, calendar$1(ticks2, tickInterval, year2, month2, week, day2, hour2, minute2, second2, format2));
  };
  return scale;
}
function time$1() {
  return initRange$1.apply(calendar$1(timeTicks$1, timeTickInterval$1, timeYear$1, timeMonth$1, timeSunday, timeDay$1, timeHour$1, timeMinute$1, second$1, timeFormat$1).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime$1() {
  return initRange$1.apply(calendar$1(utcTicks$1, utcTickInterval$1, utcYear$2, utcMonth$2, utcSunday$1, utcDay$2, utcHour$2, utcMinute$2, second$1, utcFormat$1).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$5() {
  var x02 = 0, x12 = 1, t02, t12, k10, transform2, interpolator = identity$e, clamp2 = false, unknown2;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : interpolator(k10 === 0 ? 0.5 : (x2 = (transform2(x2) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x2)) : x2));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12] = _2, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x02, x12];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _2, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$5);
  scale.rangeRound = range2(interpolateRound$1);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4) {
    transform2 = t4, t02 = t4(x02), t12 = t4(x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy$3(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential$1() {
  var scale = linearish$1(transformer$5()(identity$e));
  scale.copy = function() {
    return copy$3(scale, sequential$1());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function sequentialLog$1() {
  var scale = loggish$1(transformer$5()).domain([1, 10]);
  scale.copy = function() {
    return copy$3(scale, sequentialLog$1()).base(scale.base());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function sequentialSymlog$1() {
  var scale = symlogish$1(transformer$5());
  scale.copy = function() {
    return copy$3(scale, sequentialSymlog$1()).constant(scale.constant());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function sequentialPow$1() {
  var scale = powish$1(transformer$5());
  scale.copy = function() {
    return copy$3(scale, sequentialPow$1()).exponent(scale.exponent());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function sequentialSqrt$1() {
  return sequentialPow$1.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile$1() {
  var domain2 = [], interpolator = identity$e;
  function scale(x2) {
    if (x2 != null && !isNaN(x2 = +x2))
      return interpolator((bisect$1(domain2, x2, 1) - 1) / (domain2.length - 1));
  }
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d2 of _2)
      if (d2 != null && !isNaN(d2 = +d2))
        domain2.push(d2);
    domain2.sort(ascending$4);
    return scale;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  scale.range = function() {
    return domain2.map((d2, i) => interpolator(i / (domain2.length - 1)));
  };
  scale.quantiles = function(n2) {
    return Array.from({ length: n2 + 1 }, (_2, i) => quantile$3(domain2, i / n2));
  };
  scale.copy = function() {
    return sequentialQuantile$1(interpolator).domain(domain2);
  };
  return initInterpolator$1.apply(scale, arguments);
}
function transformer$4() {
  var x02 = 0, x12 = 0.5, x2 = 1, s2 = 1, t02, t12, t22, k10, k21, interpolator = identity$e, transform2, clamp2 = false, unknown2;
  function scale(x3) {
    return isNaN(x3 = +x3) ? unknown2 : (x3 = 0.5 + ((x3 = +transform2(x3)) - t12) * (s2 * x3 < s2 * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12, x2] = _2, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), t22 = transform2(x2 = +x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s2 = t12 < t02 ? -1 : 1, scale) : [x02, x12, x2];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _2, interpolator = piecewise$1(interpolate2, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range2(interpolate$5);
  scale.rangeRound = range2(interpolateRound$1);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4) {
    transform2 = t4, t02 = t4(x02), t12 = t4(x12), t22 = t4(x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s2 = t12 < t02 ? -1 : 1;
    return scale;
  };
}
function diverging$2() {
  var scale = linearish$1(transformer$4()(identity$e));
  scale.copy = function() {
    return copy$3(scale, diverging$2());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function divergingLog$1() {
  var scale = loggish$1(transformer$4()).domain([0.1, 1, 10]);
  scale.copy = function() {
    return copy$3(scale, divergingLog$1()).base(scale.base());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function divergingSymlog$1() {
  var scale = symlogish$1(transformer$4());
  scale.copy = function() {
    return copy$3(scale, divergingSymlog$1()).constant(scale.constant());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function divergingPow$1() {
  var scale = powish$1(transformer$4());
  scale.copy = function() {
    return copy$3(scale, divergingPow$1()).exponent(scale.exponent());
  };
  return initInterpolator$1.apply(scale, arguments);
}
function divergingSqrt$1() {
  return divergingPow$1.apply(null, arguments).exponent(0.5);
}
var d3Scale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band$1,
  scalePoint: point$5,
  scaleIdentity: identity$c,
  scaleLinear: linear$6,
  scaleLog: log$2,
  scaleSymlog: symlog$1,
  scaleOrdinal: ordinal$1,
  scaleImplicit: implicit$1,
  scalePow: pow$3,
  scaleSqrt: sqrt$3,
  scaleRadial: radial$2,
  scaleQuantile: quantile$2,
  scaleQuantize: quantize$2,
  scaleThreshold: threshold$1,
  scaleTime: time$1,
  scaleUtc: utcTime$1,
  scaleSequential: sequential$1,
  scaleSequentialLog: sequentialLog$1,
  scaleSequentialPow: sequentialPow$1,
  scaleSequentialSqrt: sequentialSqrt$1,
  scaleSequentialSymlog: sequentialSymlog$1,
  scaleSequentialQuantile: sequentialQuantile$1,
  scaleDiverging: diverging$2,
  scaleDivergingLog: divergingLog$1,
  scaleDivergingPow: divergingPow$1,
  scaleDivergingSqrt: divergingSqrt$1,
  scaleDivergingSymlog: divergingSymlog$1,
  tickFormat: tickFormat$1
}, Symbol.toStringTag, { value: "Module" }));
function applyDomain$1(scale, config2) {
  if (config2.domain) {
    if ("nice" in scale || "quantiles" in scale) {
      scale.domain(config2.domain);
    } else if ("padding" in scale) {
      scale.domain(config2.domain);
    } else {
      scale.domain(config2.domain);
    }
  }
}
function applyRange$1(scale, config2) {
  if (config2.range) {
    if ("padding" in scale) {
      scale.range(config2.range);
    } else {
      scale.range(config2.range);
    }
  }
}
function applyAlign$1(scale, config2) {
  if ("align" in scale && "align" in config2 && typeof config2.align !== "undefined") {
    scale.align(config2.align);
  }
}
function applyBase$1(scale, config2) {
  if ("base" in scale && "base" in config2 && typeof config2.base !== "undefined") {
    scale.base(config2.base);
  }
}
function applyClamp$1(scale, config2) {
  if ("clamp" in scale && "clamp" in config2 && typeof config2.clamp !== "undefined") {
    scale.clamp(config2.clamp);
  }
}
function applyConstant$1(scale, config2) {
  if ("constant" in scale && "constant" in config2 && typeof config2.constant !== "undefined") {
    scale.constant(config2.constant);
  }
}
function applyExponent$1(scale, config2) {
  if ("exponent" in scale && "exponent" in config2 && typeof config2.exponent !== "undefined") {
    scale.exponent(config2.exponent);
  }
}
var d3Interpolate = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  interpolate: interpolate$5,
  interpolateArray: array$6,
  interpolateBasis: basis$6,
  interpolateBasisClosed: basisClosed$2,
  interpolateDate: date$4,
  interpolateDiscrete: discrete$1,
  interpolateHue: hue$3,
  interpolateNumber: interpolateNumber$2,
  interpolateNumberArray: numberArray$2,
  interpolateObject: object$3,
  interpolateRound: interpolateRound$1,
  interpolateString: string$2,
  interpolateTransformCss: interpolateTransformCss$2,
  interpolateTransformSvg: interpolateTransformSvg$2,
  interpolateZoom: zoom$2,
  interpolateRgb: interpolateRgb$1,
  interpolateRgbBasis: rgbBasis$2,
  interpolateRgbBasisClosed: rgbBasisClosed$1,
  interpolateHsl,
  interpolateHslLong: hslLong$1,
  interpolateLab: lab$2,
  interpolateHcl,
  interpolateHclLong: hclLong$1,
  interpolateCubehelix,
  interpolateCubehelixLong: cubehelixLong$2,
  piecewise: piecewise$1,
  quantize: quantize$3
}, Symbol.toStringTag, { value: "Module" }));
var interpolatorMap$1 = {
  lab: lab$2,
  hcl: interpolateHcl,
  "hcl-long": hclLong$1,
  hsl: interpolateHsl,
  "hsl-long": hslLong$1,
  cubehelix: interpolateCubehelix,
  "cubehelix-long": cubehelixLong$2,
  rgb: interpolateRgb$1
};
function createColorInterpolator$2(interpolate2) {
  switch (interpolate2) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return interpolatorMap$1[interpolate2];
  }
  var type2 = interpolate2.type, gamma2 = interpolate2.gamma;
  var interpolator = interpolatorMap$1[type2];
  return typeof gamma2 === "undefined" ? interpolator : interpolator.gamma(gamma2);
}
function applyInterpolate$1(scale, config2) {
  if ("interpolate" in config2 && "interpolate" in scale && typeof config2.interpolate !== "undefined") {
    var interpolator = createColorInterpolator$2(config2.interpolate);
    scale.interpolate(interpolator);
  }
}
var d3Time = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  timeInterval,
  utcMillisecond: millisecond$2,
  utcMilliseconds: milliseconds$1,
  timeMillisecond: millisecond$2,
  timeMilliseconds: milliseconds$1,
  utcSecond: second$1,
  utcSeconds: seconds$1,
  timeSecond: second$1,
  timeSeconds: seconds$1,
  timeMinute: timeMinute$1,
  timeMinutes,
  utcMinute: utcMinute$2,
  utcMinutes: utcMinutes$1,
  timeHour: timeHour$1,
  timeHours,
  utcHour: utcHour$2,
  utcHours: utcHours$1,
  timeDay: timeDay$1,
  timeDays,
  utcDay: utcDay$2,
  utcDays: utcDays$1,
  unixDay,
  unixDays,
  timeWeek: timeSunday,
  timeWeeks: timeSundays,
  timeSunday,
  timeSundays,
  timeMonday,
  timeMondays,
  timeTuesday,
  timeTuesdays,
  timeWednesday,
  timeWednesdays,
  timeThursday,
  timeThursdays,
  timeFriday,
  timeFridays,
  timeSaturday,
  timeSaturdays,
  utcWeek: utcSunday$1,
  utcWeeks: utcSundays$1,
  utcSunday: utcSunday$1,
  utcSundays: utcSundays$1,
  utcMonday: utcMonday$1,
  utcMondays: utcMondays$1,
  utcTuesday: utcTuesday$1,
  utcTuesdays: utcTuesdays$1,
  utcWednesday: utcWednesday$1,
  utcWednesdays: utcWednesdays$1,
  utcThursday: utcThursday$1,
  utcThursdays: utcThursdays$1,
  utcFriday: utcFriday$1,
  utcFridays: utcFridays$1,
  utcSaturday: utcSaturday$1,
  utcSaturdays: utcSaturdays$1,
  timeMonth: timeMonth$1,
  timeMonths,
  utcMonth: utcMonth$2,
  utcMonths: utcMonths$1,
  timeYear: timeYear$1,
  timeYears,
  utcYear: utcYear$2,
  utcYears: utcYears$1,
  utcTicks: utcTicks$1,
  utcTickInterval: utcTickInterval$1,
  timeTicks: timeTicks$1,
  timeTickInterval: timeTickInterval$1
}, Symbol.toStringTag, { value: "Module" }));
var TEST_TIME$1 = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var TEST_FORMAT$1 = "%Y-%m-%d %H:%M";
function isUtcScale$2(scale) {
  var output = scale.tickFormat(1, TEST_FORMAT$1)(TEST_TIME$1);
  return output === "2020-02-02 03:04";
}
var localTimeIntervals$1 = {
  day: timeDay$1,
  hour: timeHour$1,
  minute: timeMinute$1,
  month: timeMonth$1,
  second: second$1,
  week: timeSunday,
  year: timeYear$1
};
var utcIntervals$1 = {
  day: utcDay$2,
  hour: utcHour$2,
  minute: utcMinute$2,
  month: utcMonth$2,
  second: second$1,
  week: utcSunday$1,
  year: utcYear$2
};
function applyNice$1(scale, config2) {
  if ("nice" in config2 && typeof config2.nice !== "undefined" && "nice" in scale) {
    var nice2 = config2.nice;
    if (typeof nice2 === "boolean") {
      if (nice2) {
        scale.nice();
      }
    } else if (typeof nice2 === "number") {
      scale.nice(nice2);
    } else {
      var timeScale = scale;
      var isUtc = isUtcScale$2(timeScale);
      if (typeof nice2 === "string") {
        timeScale.nice(isUtc ? utcIntervals$1[nice2] : localTimeIntervals$1[nice2]);
      } else {
        var interval2 = nice2.interval, step2 = nice2.step;
        var parsedInterval = (isUtc ? utcIntervals$1[interval2] : localTimeIntervals$1[interval2]).every(step2);
        if (parsedInterval != null) {
          timeScale.nice(parsedInterval);
        }
      }
    }
  }
}
function applyPadding$1(scale, config2) {
  if ("padding" in scale && "padding" in config2 && typeof config2.padding !== "undefined") {
    scale.padding(config2.padding);
  }
  if ("paddingInner" in scale && "paddingInner" in config2 && typeof config2.paddingInner !== "undefined") {
    scale.paddingInner(config2.paddingInner);
  }
  if ("paddingOuter" in scale && "paddingOuter" in config2 && typeof config2.paddingOuter !== "undefined") {
    scale.paddingOuter(config2.paddingOuter);
  }
}
function applyReverse$1(scale, config2) {
  if (config2.reverse) {
    var reversedRange = scale.range().slice().reverse();
    if ("padding" in scale) {
      scale.range(reversedRange);
    } else {
      scale.range(reversedRange);
    }
  }
}
function applyRound$1(scale, config2) {
  if ("round" in config2 && typeof config2.round !== "undefined") {
    if (config2.round && "interpolate" in config2 && typeof config2.interpolate !== "undefined") {
      console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config2);
    } else if ("round" in scale) {
      scale.round(config2.round);
    } else if ("interpolate" in scale && config2.round) {
      scale.interpolate(interpolateRound$1);
    }
  }
}
function applyUnknown$1(scale, config2) {
  if ("unknown" in scale && "unknown" in config2 && typeof config2.unknown !== "undefined") {
    scale.unknown(config2.unknown);
  }
}
function applyZero$1(scale, config2) {
  if ("zero" in config2 && config2.zero === true) {
    var domain2 = scale.domain();
    var a2 = domain2[0], b10 = domain2[1];
    var isDescending = b10 < a2;
    var _ref = isDescending ? [b10, a2] : [a2, b10], min2 = _ref[0], max2 = _ref[1];
    var domainWithZero = [Math.min(0, min2), Math.max(0, max2)];
    scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
  }
}
var ALL_OPERATORS$1 = [
  "domain",
  "nice",
  "zero",
  "interpolate",
  "round",
  "range",
  "reverse",
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
];
var operators$1 = {
  domain: applyDomain$1,
  nice: applyNice$1,
  zero: applyZero$1,
  interpolate: applyInterpolate$1,
  round: applyRound$1,
  align: applyAlign$1,
  base: applyBase$1,
  clamp: applyClamp$1,
  constant: applyConstant$1,
  exponent: applyExponent$1,
  padding: applyPadding$1,
  range: applyRange$1,
  reverse: applyReverse$1,
  unknown: applyUnknown$1
};
function scaleOperator$2() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }
  var selection2 = new Set(ops);
  var selectedOps = ALL_OPERATORS$1.filter(function(o) {
    return selection2.has(o);
  });
  return function applyOperators(scale, config2) {
    if (typeof config2 !== "undefined") {
      selectedOps.forEach(function(op) {
        operators$1[op](scale, config2);
      });
    }
    return scale;
  };
}
var updateBandScale = scaleOperator$2("domain", "range", "reverse", "align", "padding", "round");
function createBandScale(config2) {
  return updateBandScale(band$1(), config2);
}
var updatePointScale = scaleOperator$2("domain", "range", "reverse", "align", "padding", "round");
function createPointScale(config2) {
  return updatePointScale(point$5(), config2);
}
var updateLinearScale = scaleOperator$2("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function createLinearScale(config2) {
  return updateLinearScale(linear$6(), config2);
}
var updateRadialScale = scaleOperator$2("domain", "range", "clamp", "nice", "round", "unknown");
function createRadialScale(config2) {
  return updateRadialScale(radial$2(), config2);
}
var updateTimeScale = scaleOperator$2("domain", "range", "reverse", "clamp", "interpolate", "nice", "round");
function createTimeScale(config2) {
  return updateTimeScale(time$1(), config2);
}
var updateUtcScale = scaleOperator$2("domain", "range", "reverse", "clamp", "interpolate", "nice", "round");
function createUtcScale(config2) {
  return updateUtcScale(utcTime$1(), config2);
}
var updateLogScale = scaleOperator$2("domain", "range", "reverse", "base", "clamp", "interpolate", "nice", "round");
function createLogScale(config2) {
  return updateLogScale(log$2(), config2);
}
var updatePowScale = scaleOperator$2("domain", "range", "reverse", "clamp", "exponent", "interpolate", "nice", "round", "zero");
function createPowScale(config2) {
  return updatePowScale(pow$3(), config2);
}
var updateOrdinalScale$1 = scaleOperator$2("domain", "range", "reverse", "unknown");
function createOrdinalScale$1(config2) {
  return updateOrdinalScale$1(ordinal$1(), config2);
}
var updateQuantizeScale = scaleOperator$2("domain", "range", "reverse", "nice", "zero");
function createQuantizeScale(config2) {
  return updateQuantizeScale(quantize$2(), config2);
}
var updateQuantileScale = scaleOperator$2("domain", "range", "reverse");
function createQuantileScale(config2) {
  return updateQuantileScale(quantile$2(), config2);
}
var updateSymlogScale = scaleOperator$2("domain", "range", "reverse", "clamp", "constant", "nice", "zero", "round");
function createSymlogScale(config2) {
  return updateSymlogScale(symlog$1(), config2);
}
var updateThresholdScale = scaleOperator$2("domain", "range", "reverse");
function createThresholdScale(config2) {
  return updateThresholdScale(threshold$1(), config2);
}
var updateSqrtScale = scaleOperator$2("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function createSqrtScale(config2) {
  return updateSqrtScale(sqrt$3(), config2);
}
function createScale(config2) {
  if (typeof config2 !== "undefined" && "type" in config2) {
    switch (config2.type) {
      case "linear":
        return createLinearScale(config2);
      case "log":
        return createLogScale(config2);
      case "pow":
        return createPowScale(config2);
      case "sqrt":
        return createSqrtScale(config2);
      case "symlog":
        return createSymlogScale(config2);
      case "time":
        return createTimeScale(config2);
      case "utc":
        return createUtcScale(config2);
      case "quantile":
        return createQuantileScale(config2);
      case "quantize":
        return createQuantizeScale(config2);
      case "threshold":
        return createThresholdScale(config2);
      case "ordinal":
        return createOrdinalScale$1(config2);
      case "point":
        return createPointScale(config2);
      case "band":
        return createBandScale(config2);
    }
  }
  return createLinearScale(config2);
}
var applyAllOperators = scaleOperator$2.apply(void 0, ALL_OPERATORS$1);
function updateScale(scale, config2) {
  return applyAllOperators(scale.copy(), config2);
}
function inferScaleType(scale) {
  if ("paddingInner" in scale) {
    return "band";
  }
  if ("padding" in scale) {
    return "point";
  }
  if ("quantiles" in scale) {
    return "quantile";
  }
  if ("base" in scale) {
    return "log";
  }
  if ("exponent" in scale) {
    return scale.exponent() === 0.5 ? "sqrt" : "pow";
  }
  if ("constant" in scale) {
    return "symlog";
  }
  if ("clamp" in scale) {
    if (scale.ticks()[0] instanceof Date) {
      return isUtcScale$2(scale) ? "utc" : "time";
    }
    return "linear";
  }
  if ("nice" in scale) {
    return "quantize";
  }
  if ("invertExtent" in scale) {
    return "threshold";
  }
  return "ordinal";
}
function coerceNumber(val) {
  if ((typeof val === "function" || typeof val === "object" && !!val) && "valueOf" in val) {
    var num = val.valueOf();
    if (typeof num === "number")
      return num;
  }
  return val;
}
function getTicks(scale, numTicks) {
  var s2 = scale;
  if ("ticks" in s2) {
    return s2.ticks(numTicks);
  }
  return s2.domain().filter(function(_2, index2, arr) {
    return numTicks == null || arr.length <= numTicks || index2 % Math.round((arr.length - 1) / numTicks) === 0;
  });
}
function toString(x2) {
  return x2 == null ? void 0 : x2.toString();
}
var zeroableScaleTypes = /* @__PURE__ */ new Set(["linear", "pow", "quantize", "sqrt", "symlog"]);
function scaleCanBeZeroed(scaleConfig) {
  return zeroableScaleTypes.has(scaleConfig.type);
}
var esm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: createBandScale,
  scalePoint: createPointScale,
  scaleLinear: createLinearScale,
  scaleRadial: createRadialScale,
  scaleTime: createTimeScale,
  scaleUtc: createUtcScale,
  scaleLog: createLogScale,
  scalePower: createPowScale,
  scaleOrdinal: createOrdinalScale$1,
  scaleQuantize: createQuantizeScale,
  scaleQuantile: createQuantileScale,
  scaleSymlog: createSymlogScale,
  scaleThreshold: createThresholdScale,
  scaleSqrt: createSqrtScale,
  createScale,
  updateScale,
  inferScaleType,
  coerceNumber,
  getTicks,
  toString,
  scaleCanBeZeroed
}, Symbol.toStringTag, { value: "Module" }));
var balancedMatch$1 = balanced$3;
function balanced$3(a2, b10, str) {
  if (a2 instanceof RegExp)
    a2 = maybeMatch$1(a2, str);
  if (b10 instanceof RegExp)
    b10 = maybeMatch$1(b10, str);
  var r2 = range$5(a2, b10, str);
  return r2 && {
    start: r2[0],
    end: r2[1],
    pre: str.slice(0, r2[0]),
    body: str.slice(r2[0] + a2.length, r2[1]),
    post: str.slice(r2[1] + b10.length)
  };
}
function maybeMatch$1(reg, str) {
  var m2 = str.match(reg);
  return m2 ? m2[0] : null;
}
balanced$3.range = range$5;
function range$5(a2, b10, str) {
  var begs, beg, left2, right2, result;
  var ai = str.indexOf(a2);
  var bi = str.indexOf(b10, ai + 1);
  var i = ai;
  if (ai >= 0 && bi > 0) {
    begs = [];
    left2 = str.length;
    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a2, i + 1);
      } else if (begs.length == 1) {
        result = [begs.pop(), bi];
      } else {
        beg = begs.pop();
        if (beg < left2) {
          left2 = beg;
          right2 = bi;
        }
        bi = str.indexOf(b10, i + 1);
      }
      i = ai < bi && ai >= 0 ? ai : bi;
    }
    if (begs.length) {
      result = [left2, right2];
    }
  }
  return result;
}
var balancedMatch = balanced$2;
function balanced$2(a2, b10, str) {
  if (a2 instanceof RegExp)
    a2 = maybeMatch(a2, str);
  if (b10 instanceof RegExp)
    b10 = maybeMatch(b10, str);
  var r2 = range$4(a2, b10, str);
  return r2 && {
    start: r2[0],
    end: r2[1],
    pre: str.slice(0, r2[0]),
    body: str.slice(r2[0] + a2.length, r2[1]),
    post: str.slice(r2[1] + b10.length)
  };
}
function maybeMatch(reg, str) {
  var m2 = str.match(reg);
  return m2 ? m2[0] : null;
}
balanced$2.range = range$4;
function range$4(a2, b10, str) {
  var begs, beg, left2, right2, result;
  var ai = str.indexOf(a2);
  var bi = str.indexOf(b10, ai + 1);
  var i = ai;
  if (ai >= 0 && bi > 0) {
    if (a2 === b10) {
      return [ai, bi];
    }
    begs = [];
    left2 = str.length;
    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a2, i + 1);
      } else if (begs.length == 1) {
        result = [begs.pop(), bi];
      } else {
        beg = begs.pop();
        if (beg < left2) {
          left2 = beg;
          right2 = bi;
        }
        bi = str.indexOf(b10, i + 1);
      }
      i = ai < bi && ai >= 0 ? ai : bi;
    }
    if (begs.length) {
      result = [left2, right2];
    }
  }
  return result;
}
var balanced$1 = balancedMatch;
var reduceFunctionCall_1 = reduceFunctionCall$1;
function reduceFunctionCall$1(string2, functionRE, callback) {
  var call = string2;
  return getFunctionCalls(string2, functionRE).reduce(function(string3, obj) {
    return string3.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE));
  }, string2);
}
function getFunctionCalls(call, functionRE) {
  var expressions = [];
  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE;
  do {
    var searchMatch = fnRE.exec(call);
    if (!searchMatch) {
      return expressions;
    }
    if (searchMatch[1] === void 0) {
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE);
    }
    var fn2 = searchMatch[1];
    var startIndex = searchMatch.index;
    var matches = balanced$1("(", ")", call.substring(startIndex));
    if (!matches || matches.start !== searchMatch[0].length - 1) {
      throw new SyntaxError(fn2 + "(): missing closing ')' in the value '" + call + "'");
    }
    expressions.push({ matches, functionIdentifier: fn2 });
    call = matches.post;
  } while (fnRE.test(call));
  return expressions;
}
function evalFunctionCall(string2, functionIdentifier, callback, call, functionRE) {
  return callback(reduceFunctionCall$1(string2, functionRE, callback), functionIdentifier, call);
}
var Mexp$4 = function(parsed) {
  this.value = parsed;
};
Mexp$4.math = {
  isDegree: true,
  acos: function(x2) {
    return Mexp$4.math.isDegree ? 180 / Math.PI * Math.acos(x2) : Math.acos(x2);
  },
  add: function(a2, b10) {
    return a2 + b10;
  },
  asin: function(x2) {
    return Mexp$4.math.isDegree ? 180 / Math.PI * Math.asin(x2) : Math.asin(x2);
  },
  atan: function(x2) {
    return Mexp$4.math.isDegree ? 180 / Math.PI * Math.atan(x2) : Math.atan(x2);
  },
  acosh: function(x2) {
    return Math.log(x2 + Math.sqrt(x2 * x2 - 1));
  },
  asinh: function(x2) {
    return Math.log(x2 + Math.sqrt(x2 * x2 + 1));
  },
  atanh: function(x2) {
    return Math.log((1 + x2) / (1 - x2));
  },
  C: function(n2, r2) {
    var pro = 1;
    var other = n2 - r2;
    var choice = r2;
    if (choice < other) {
      choice = other;
      other = r2;
    }
    for (var i = choice + 1; i <= n2; i++) {
      pro *= i;
    }
    return pro / Mexp$4.math.fact(other);
  },
  changeSign: function(x2) {
    return -x2;
  },
  cos: function(x2) {
    if (Mexp$4.math.isDegree)
      x2 = Mexp$4.math.toRadian(x2);
    return Math.cos(x2);
  },
  cosh: function(x2) {
    return (Math.pow(Math.E, x2) + Math.pow(Math.E, -1 * x2)) / 2;
  },
  div: function(a2, b10) {
    return a2 / b10;
  },
  fact: function(n2) {
    if (n2 % 1 !== 0)
      return "NaN";
    var pro = 1;
    for (var i = 2; i <= n2; i++) {
      pro *= i;
    }
    return pro;
  },
  inverse: function(x2) {
    return 1 / x2;
  },
  log: function(i) {
    return Math.log(i) / Math.log(10);
  },
  mod: function(a2, b10) {
    return a2 % b10;
  },
  mul: function(a2, b10) {
    return a2 * b10;
  },
  P: function(n2, r2) {
    var pro = 1;
    for (var i = Math.floor(n2) - Math.floor(r2) + 1; i <= Math.floor(n2); i++) {
      pro *= i;
    }
    return pro;
  },
  Pi: function(low, high, ex) {
    var pro = 1;
    for (var i = low; i <= high; i++) {
      pro *= Number(ex.postfixEval({
        n: i
      }));
    }
    return pro;
  },
  pow10x: function(e3) {
    var x2 = 1;
    while (e3--) {
      x2 *= 10;
    }
    return x2;
  },
  sigma: function(low, high, ex) {
    var sum2 = 0;
    for (var i = low; i <= high; i++) {
      sum2 += Number(ex.postfixEval({
        n: i
      }));
    }
    return sum2;
  },
  sin: function(x2) {
    if (Mexp$4.math.isDegree)
      x2 = Mexp$4.math.toRadian(x2);
    return Math.sin(x2);
  },
  sinh: function(x2) {
    return (Math.pow(Math.E, x2) - Math.pow(Math.E, -1 * x2)) / 2;
  },
  sub: function(a2, b10) {
    return a2 - b10;
  },
  tan: function(x2) {
    if (Mexp$4.math.isDegree)
      x2 = Mexp$4.math.toRadian(x2);
    return Math.tan(x2);
  },
  tanh: function(x2) {
    return Mexp$4.sinha(x2) / Mexp$4.cosha(x2);
  },
  toRadian: function(x2) {
    return x2 * Math.PI / 180;
  },
  and: function(a2, b10) {
    return a2 & b10;
  }
};
Mexp$4.Exception = function(message) {
  this.message = message;
};
var math_function = Mexp$4;
var Mexp$3 = math_function;
function inc$1(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    arr[i] += val;
  }
  return arr;
}
var tokens = [
  { token: "sin", show: "sin", type: 0, value: Mexp$3.math.sin },
  { token: "cos", show: "cos", type: 0, value: Mexp$3.math.cos },
  { token: "tan", show: "tan", type: 0, value: Mexp$3.math.tan },
  { token: "pi", show: "&pi;", type: 3, value: "PI" },
  { token: "(", show: "(", type: 4, value: "(" },
  { token: ")", show: ")", type: 5, value: ")" },
  { token: "P", show: "P", type: 10, value: Mexp$3.math.P },
  { token: "C", show: "C", type: 10, value: Mexp$3.math.C },
  { token: " ", show: " ", type: 14, value: " ".anchor },
  { token: "asin", show: "asin", type: 0, value: Mexp$3.math.asin },
  { token: "acos", show: "acos", type: 0, value: Mexp$3.math.acos },
  { token: "atan", show: "atan", type: 0, value: Mexp$3.math.atan },
  { token: "7", show: "7", type: 1, value: "7" },
  { token: "8", show: "8", type: 1, value: "8" },
  { token: "9", show: "9", type: 1, value: "9" },
  { token: "int", show: "Int", type: 0, value: Math.floor },
  { token: "cosh", show: "cosh", type: 0, value: Mexp$3.math.cosh },
  { token: "acosh", show: "acosh", type: 0, value: Mexp$3.math.acosh },
  { token: "ln", show: " ln", type: 0, value: Math.log },
  { token: "^", show: "^", type: 10, value: Math.pow },
  { token: "root", show: "root", type: 0, value: Math.sqrt },
  { token: "4", show: "4", type: 1, value: "4" },
  { token: "5", show: "5", type: 1, value: "5" },
  { token: "6", show: "6", type: 1, value: "6" },
  { token: "/", show: "&divide;", type: 2, value: Mexp$3.math.div },
  { token: "!", show: "!", type: 7, value: Mexp$3.math.fact },
  { token: "tanh", show: "tanh", type: 0, value: Mexp$3.math.tanh },
  { token: "atanh", show: "atanh", type: 0, value: Mexp$3.math.atanh },
  { token: "Mod", show: " Mod ", type: 2, value: Mexp$3.math.mod },
  { token: "1", show: "1", type: 1, value: "1" },
  { token: "2", show: "2", type: 1, value: "2" },
  { token: "3", show: "3", type: 1, value: "3" },
  { token: "*", show: "&times;", type: 2, value: Mexp$3.math.mul },
  { token: "sinh", show: "sinh", type: 0, value: Mexp$3.math.sinh },
  { token: "asinh", show: "asinh", type: 0, value: Mexp$3.math.asinh },
  { token: "e", show: "e", type: 3, value: "E" },
  { token: "log", show: " log", type: 0, value: Mexp$3.math.log },
  { token: "0", show: "0", type: 1, value: "0" },
  { token: ".", show: ".", type: 6, value: "." },
  { token: "+", show: "+", type: 9, value: Mexp$3.math.add },
  { token: "-", show: "-", type: 9, value: Mexp$3.math.sub },
  { token: ",", show: ",", type: 11, value: "," },
  { token: "Sigma", show: "&Sigma;", type: 12, value: Mexp$3.math.sigma },
  { token: "n", show: "n", type: 13, value: "n" },
  { token: "Pi", show: "&Pi;", type: 12, value: Mexp$3.math.Pi },
  { token: "pow", show: "pow", type: 8, value: Math.pow, numberOfArguments: 2 },
  { token: "&", show: "&", type: 9, value: Mexp$3.math.and }
];
var preced = {
  0: 11,
  1: 0,
  2: 3,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 11,
  8: 11,
  9: 1,
  10: 10,
  11: 0,
  12: 11,
  13: 0,
  14: -1,
  15: 11
};
for (var i = 0; i < tokens.length; i++) {
  tokens[i].precedence = preced[tokens[i].type];
}
var type0 = {
  0: true,
  1: true,
  3: true,
  4: true,
  6: true,
  8: true,
  9: true,
  12: true,
  13: true,
  14: true,
  15: true
};
var type1 = {
  0: true,
  1: true,
  2: true,
  3: true,
  4: true,
  5: true,
  6: true,
  7: true,
  8: true,
  9: true,
  10: true,
  11: true,
  12: true,
  13: true,
  15: true
};
var type1Asterick = {
  0: true,
  3: true,
  4: true,
  8: true,
  12: true,
  13: true,
  15: true
};
var empty$3 = {};
var type3Asterick = {
  0: true,
  1: true,
  3: true,
  4: true,
  6: true,
  8: true,
  12: true,
  13: true,
  15: true
};
var type6 = {
  1: true
};
var newAr = [
  [],
  [
    "1",
    "2",
    "3",
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "^",
    "!",
    "P",
    "C",
    "e",
    "0",
    ".",
    ",",
    "n",
    " ",
    "&"
  ],
  ["pi", "ln", "Pi"],
  ["sin", "cos", "tan", "Del", "int", "Mod", "log", "pow"],
  ["asin", "acos", "atan", "cosh", "root", "tanh", "sinh"],
  ["acosh", "atanh", "asinh", "Sigma"]
];
function match$1(str1, str2, i, x2) {
  for (var f2 = 0; f2 < x2; f2++) {
    if (str1[i + f2] !== str2[f2]) {
      return false;
    }
  }
  return true;
}
Mexp$3.tokenTypes = {
  FUNCTION_WITH_ONE_ARG: 0,
  NUMBER: 1,
  BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
  CONSTANT: 3,
  OPENING_PARENTHESIS: 4,
  CLOSING_PARENTHESIS: 5,
  DECIMAL: 6,
  POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
  FUNCTION_WITH_N_ARGS: 8,
  BINARY_OPERATOR_LOW_PRECENDENCE: 9,
  BINARY_OPERATOR_PERMUTATION: 10,
  COMMA: 11,
  EVALUATED_FUNCTION: 12,
  EVALUATED_FUNCTION_PARAMETER: 13,
  SPACE: 14
};
Mexp$3.addToken = function(newTokens) {
  for (var i = 0; i < newTokens.length; i++) {
    var x2 = newTokens[i].token.length;
    var temp = -1;
    if (newTokens[i].type === Mexp$3.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === void 0) {
      newTokens[i].numberOfArguments = 2;
    }
    newAr[x2] = newAr[x2] || [];
    for (var y2 = 0; y2 < newAr[x2].length; y2++) {
      if (newTokens[i].token === newAr[x2][y2]) {
        temp = indexOfToken(newAr[x2][y2], tokens);
        break;
      }
    }
    if (temp === -1) {
      tokens.push(newTokens[i]);
      newTokens[i].precedence = preced[newTokens[i].type];
      if (newAr.length <= newTokens[i].token.length) {
        newAr[newTokens[i].token.length] = [];
      }
      newAr[newTokens[i].token.length].push(newTokens[i].token);
    } else {
      tokens[temp] = newTokens[i];
      newTokens[i].precedence = preced[newTokens[i].type];
    }
  }
};
function indexOfToken(key, tokens2) {
  for (var search = 0; search < tokens2.length; search++) {
    if (tokens2[search].token === key)
      return search;
  }
  return -1;
}
function tokenize(string2) {
  var nodes = [];
  var length2 = string2.length;
  var key, x2, y2;
  for (var i = 0; i < length2; i++) {
    if (i < length2 - 1 && string2[i] === " " && string2[i + 1] === " ") {
      continue;
    }
    key = "";
    for (x2 = string2.length - i > newAr.length - 2 ? newAr.length - 1 : string2.length - i; x2 > 0; x2--) {
      if (newAr[x2] === void 0)
        continue;
      for (y2 = 0; y2 < newAr[x2].length; y2++) {
        if (match$1(string2, newAr[x2][y2], i, x2)) {
          key = newAr[x2][y2];
          y2 = newAr[x2].length;
          x2 = 0;
        }
      }
    }
    i += key.length - 1;
    if (key === "") {
      throw new Mexp$3.Exception("Can't understand after " + string2.slice(i));
    }
    nodes.push(tokens[indexOfToken(key, tokens)]);
  }
  return nodes;
}
var changeSignObj = {
  value: Mexp$3.math.changeSign,
  type: 0,
  pre: 21,
  show: "-"
};
var closingParObj = {
  value: ")",
  show: ")",
  type: 5,
  pre: 0
};
var openingParObj = {
  value: "(",
  type: 4,
  pre: 0,
  show: "("
};
Mexp$3.lex = function(inp, tokens2) {
  var str = [openingParObj];
  var ptc = [];
  var inpStr = inp;
  var allowed = type0;
  var bracToClose = 0;
  var asterick = empty$3;
  var prevKey = "";
  var i;
  if (typeof tokens2 !== "undefined") {
    Mexp$3.addToken(tokens2);
  }
  var obj = {};
  var nodes = tokenize(inpStr);
  for (i = 0; i < nodes.length; i++) {
    var node2 = nodes[i];
    if (node2.type === 14) {
      if (i > 0 && i < nodes.length - 1 && nodes[i + 1].type === 1 && (nodes[i - 1].type === 1 || nodes[i - 1].type === 6)) {
        throw new Mexp$3.Exception("Unexpected Space");
      }
      continue;
    }
    var cToken = node2.token;
    var cType = node2.type;
    var cEv = node2.value;
    var cPre = node2.precedence;
    var cShow = node2.show;
    var pre = str[str.length - 1];
    var j;
    for (j = ptc.length; j--; ) {
      if (ptc[j] === 0) {
        if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
          if (allowed[cType] !== true) {
            throw new Mexp$3.Exception(cToken + " is not allowed after " + prevKey);
          }
          str.push(closingParObj);
          allowed = type1;
          asterick = type3Asterick;
          ptc.pop();
        }
      } else
        break;
    }
    if (allowed[cType] !== true) {
      throw new Mexp$3.Exception(cToken + " is not allowed after " + prevKey);
    }
    if (asterick[cType] === true) {
      cType = 2;
      cEv = Mexp$3.math.mul;
      cShow = "&times;";
      cPre = 3;
      i = i - 1;
    }
    obj = {
      value: cEv,
      type: cType,
      pre: cPre,
      show: cShow,
      numberOfArguments: node2.numberOfArguments
    };
    if (cType === 0) {
      allowed = type0;
      asterick = empty$3;
      inc$1(ptc, 2);
      str.push(obj);
      if (nodes[i + 1].type !== 4) {
        str.push(openingParObj);
        ptc.push(2);
      }
    } else if (cType === 1) {
      if (pre.type === 1) {
        pre.value += cEv;
        inc$1(ptc, 1);
      } else {
        str.push(obj);
      }
      allowed = type1;
      asterick = type1Asterick;
    } else if (cType === 2) {
      allowed = type0;
      asterick = empty$3;
      inc$1(ptc, 2);
      str.push(obj);
    } else if (cType === 3) {
      str.push(obj);
      allowed = type1;
      asterick = type3Asterick;
    } else if (cType === 4) {
      inc$1(ptc, 1);
      bracToClose++;
      allowed = type0;
      asterick = empty$3;
      str.push(obj);
    } else if (cType === 5) {
      if (!bracToClose) {
        throw new Mexp$3.Exception("Closing parenthesis are more than opening one, wait What!!!");
      }
      bracToClose--;
      allowed = type1;
      asterick = type3Asterick;
      str.push(obj);
      inc$1(ptc, 1);
    } else if (cType === 6) {
      if (pre.hasDec) {
        throw new Mexp$3.Exception("Two decimals are not allowed in one number");
      }
      if (pre.type !== 1) {
        pre = {
          value: 0,
          type: 1,
          pre: 0
        };
        str.push(pre);
      }
      allowed = type6;
      inc$1(ptc, 1);
      asterick = empty$3;
      pre.value += cEv;
      pre.hasDec = true;
    } else if (cType === 7) {
      allowed = type1;
      asterick = type3Asterick;
      inc$1(ptc, 1);
      str.push(obj);
    }
    if (cType === 8) {
      allowed = type0;
      asterick = empty$3;
      inc$1(ptc, node2.numberOfArguments + 2);
      str.push(obj);
      if (nodes[i + 1].type !== 4) {
        str.push(openingParObj);
        ptc.push(node2.numberOfArguments + 2);
      }
    } else if (cType === 9) {
      if (pre.type === 9) {
        if (pre.value === Mexp$3.math.add) {
          pre.value = cEv;
          pre.show = cShow;
          inc$1(ptc, 1);
        } else if (pre.value === Mexp$3.math.sub && cShow === "-") {
          pre.value = Mexp$3.math.add;
          pre.show = "+";
          inc$1(ptc, 1);
        }
      } else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
        if (cToken === "-") {
          allowed = type0;
          asterick = empty$3;
          inc$1(ptc, 2).push(2);
          str.push(changeSignObj);
          str.push(openingParObj);
        }
      } else {
        str.push(obj);
        inc$1(ptc, 2);
      }
      allowed = type0;
      asterick = empty$3;
    } else if (cType === 10) {
      allowed = type0;
      asterick = empty$3;
      inc$1(ptc, 2);
      str.push(obj);
    } else if (cType === 11) {
      allowed = type0;
      asterick = empty$3;
      str.push(obj);
    } else if (cType === 12) {
      allowed = type0;
      asterick = empty$3;
      inc$1(ptc, 6);
      str.push(obj);
      if (nodes[i + 1].type !== 4) {
        str.push(openingParObj);
        ptc.push(6);
      }
    } else if (cType === 13) {
      allowed = type1;
      asterick = type3Asterick;
      str.push(obj);
    }
    inc$1(ptc, -1);
    prevKey = cToken;
  }
  for (j = ptc.length; j--; ) {
    str.push(closingParObj);
  }
  if (allowed[5] !== true) {
    throw new Mexp$3.Exception("complete the expression");
  }
  while (bracToClose--) {
    str.push(closingParObj);
  }
  str.push(closingParObj);
  return new Mexp$3(str);
};
var lexer = Mexp$3;
var Mexp$2 = lexer;
Mexp$2.prototype.toPostfix = function() {
  var post = [], elem, popped, prep, pre, ele;
  var stack2 = [{ value: "(", type: 4, pre: 0 }];
  var arr = this.value;
  for (var i = 1; i < arr.length; i++) {
    if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {
      if (arr[i].type === 1)
        arr[i].value = Number(arr[i].value);
      post.push(arr[i]);
    } else if (arr[i].type === 4) {
      stack2.push(arr[i]);
    } else if (arr[i].type === 5) {
      while ((popped = stack2.pop()).type !== 4) {
        post.push(popped);
      }
    } else if (arr[i].type === 11) {
      while ((popped = stack2.pop()).type !== 4) {
        post.push(popped);
      }
      stack2.push(popped);
    } else {
      elem = arr[i];
      pre = elem.pre;
      ele = stack2[stack2.length - 1];
      prep = ele.pre;
      var flag = ele.value == "Math.pow" && elem.value == "Math.pow";
      if (pre > prep)
        stack2.push(elem);
      else {
        while (prep >= pre && !flag || flag && pre < prep) {
          popped = stack2.pop();
          ele = stack2[stack2.length - 1];
          post.push(popped);
          prep = ele.pre;
          flag = elem.value == "Math.pow" && ele.value == "Math.pow";
        }
        stack2.push(elem);
      }
    }
  }
  return new Mexp$2(post);
};
var postfix = Mexp$2;
var Mexp$1 = postfix;
Mexp$1.prototype.postfixEval = function(UserDefined) {
  UserDefined = UserDefined || {};
  UserDefined.PI = Math.PI;
  UserDefined.E = Math.E;
  var stack2 = [], pop1, pop2, pop3;
  var arr = this.value;
  var bool = typeof UserDefined.n !== "undefined";
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].type === 1) {
      stack2.push({ value: arr[i].value, type: 1 });
    } else if (arr[i].type === 3) {
      stack2.push({ value: UserDefined[arr[i].value], type: 1 });
    } else if (arr[i].type === 0) {
      if (typeof stack2[stack2.length - 1].type === "undefined") {
        stack2[stack2.length - 1].value.push(arr[i]);
      } else
        stack2[stack2.length - 1].value = arr[i].value(stack2[stack2.length - 1].value);
    } else if (arr[i].type === 7) {
      if (typeof stack2[stack2.length - 1].type === "undefined") {
        stack2[stack2.length - 1].value.push(arr[i]);
      } else
        stack2[stack2.length - 1].value = arr[i].value(stack2[stack2.length - 1].value);
    } else if (arr[i].type === 8) {
      var popped = [];
      for (var x2 = 0; x2 < arr[i].numberOfArguments; x2++) {
        popped.push(stack2.pop().value);
      }
      stack2.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) });
    } else if (arr[i].type === 10) {
      pop1 = stack2.pop();
      pop2 = stack2.pop();
      if (typeof pop2.type === "undefined") {
        pop2.value = pop2.concat(pop1);
        pop2.value.push(arr[i]);
        stack2.push(pop2);
      } else if (typeof pop1.type === "undefined") {
        pop1.unshift(pop2);
        pop1.push(arr[i]);
        stack2.push(pop1);
      } else {
        stack2.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) });
      }
    } else if (arr[i].type === 2 || arr[i].type === 9) {
      pop1 = stack2.pop();
      pop2 = stack2.pop();
      if (typeof pop2.type === "undefined") {
        pop2 = pop2.concat(pop1);
        pop2.push(arr[i]);
        stack2.push(pop2);
      } else if (typeof pop1.type === "undefined") {
        pop1.unshift(pop2);
        pop1.push(arr[i]);
        stack2.push(pop1);
      } else {
        stack2.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) });
      }
    } else if (arr[i].type === 12) {
      pop1 = stack2.pop();
      if (typeof pop1.type !== "undefined") {
        pop1 = [pop1];
      }
      pop2 = stack2.pop();
      pop3 = stack2.pop();
      stack2.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp$1(pop1)) });
    } else if (arr[i].type === 13) {
      if (bool) {
        stack2.push({ value: UserDefined[arr[i].value], type: 3 });
      } else
        stack2.push([arr[i]]);
    }
  }
  if (stack2.length > 1) {
    throw new Mexp$1.Exception("Uncaught Syntax error");
  }
  return stack2[0].value > 1e15 ? "Infinity" : parseFloat(stack2[0].value.toFixed(15));
};
Mexp$1.eval = function(str, tokens2, obj) {
  if (typeof tokens2 === "undefined") {
    return this.lex(str).toPostfix().postfixEval();
  } else if (typeof obj === "undefined") {
    if (typeof tokens2.length !== "undefined")
      return this.lex(str, tokens2).toPostfix().postfixEval();
    else
      return this.lex(str).toPostfix().postfixEval(tokens2);
  } else
    return this.lex(str, tokens2).toPostfix().postfixEval(obj);
};
var postfix_evaluator = Mexp$1;
var Mexp = postfix_evaluator;
Mexp.prototype.formulaEval = function() {
  var pop1, pop2, pop3;
  var disp = [];
  var arr = this.value;
  for (var i = 0; i < arr.length; i++) {
    if (arr[i].type === 1 || arr[i].type === 3) {
      disp.push({ value: arr[i].type === 3 ? arr[i].show : arr[i].value, type: 1 });
    } else if (arr[i].type === 13) {
      disp.push({ value: arr[i].show, type: 1 });
    } else if (arr[i].type === 0) {
      disp[disp.length - 1] = { value: arr[i].show + (arr[i].show != "-" ? "(" : "") + disp[disp.length - 1].value + (arr[i].show != "-" ? ")" : ""), type: 0 };
    } else if (arr[i].type === 7) {
      disp[disp.length - 1] = { value: (disp[disp.length - 1].type != 1 ? "(" : "") + disp[disp.length - 1].value + (disp[disp.length - 1].type != 1 ? ")" : "") + arr[i].show, type: 7 };
    } else if (arr[i].type === 10) {
      pop1 = disp.pop();
      pop2 = disp.pop();
      if (arr[i].show === "P" || arr[i].show === "C")
        disp.push({ value: "<sup>" + pop2.value + "</sup>" + arr[i].show + "<sub>" + pop1.value + "</sub>", type: 10 });
      else
        disp.push({ value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + "<sup>" + pop1.value + "</sup>", type: 1 });
    } else if (arr[i].type === 2 || arr[i].type === 9) {
      pop1 = disp.pop();
      pop2 = disp.pop();
      disp.push({ value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + arr[i].show + (pop1.type != 1 ? "(" : "") + pop1.value + (pop1.type != 1 ? ")" : ""), type: arr[i].type });
    } else if (arr[i].type === 12) {
      pop1 = disp.pop();
      pop2 = disp.pop();
      pop3 = disp.pop();
      disp.push({ value: arr[i].show + "(" + pop3.value + "," + pop2.value + "," + pop1.value + ")", type: 12 });
    }
  }
  return disp[0].value;
};
var formula_evaluator = Mexp;
var balanced = balancedMatch$1;
var reduceFunctionCall = reduceFunctionCall_1;
var mexp = formula_evaluator;
var MAX_STACK = 100;
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g;
var stack$2;
var reduceCssCalc = reduceCSSCalc;
function reduceCSSCalc(value, decimalPrecision) {
  stack$2 = 0;
  decimalPrecision = Math.pow(10, decimalPrecision === void 0 ? 5 : decimalPrecision);
  value = value.replace(/\n+/g, " ");
  function evaluateExpression(expression, functionIdentifier, call) {
    if (stack$2++ > MAX_STACK) {
      stack$2 = 0;
      throw new Error("Call stack overflow for " + call);
    }
    if (expression === "") {
      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string");
    }
    expression = evaluateNestedExpression(expression, call);
    var units = getUnitsInExpression(expression);
    if (units.length > 1 || expression.indexOf("var(") > -1) {
      return functionIdentifier + "(" + expression + ")";
    }
    var unit2 = units[0] || "";
    if (unit2 === "%") {
      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
        return parseFloat(percent.slice(0, -1)) * 0.01;
      });
    }
    var toEvaluate = expression.replace(new RegExp(unit2, "gi"), "");
    var result;
    try {
      result = mexp.eval(toEvaluate);
    } catch (e3) {
      return functionIdentifier + "(" + expression + ")";
    }
    if (unit2 === "%") {
      result *= 100;
    }
    if (functionIdentifier.length || unit2 === "%") {
      result = Math.round(result * decimalPrecision) / decimalPrecision;
    }
    result += unit2;
    return result;
  }
  function evaluateNestedExpression(expression, call) {
    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "");
    var evaluatedPart = "";
    var nonEvaluatedPart = expression;
    var matches;
    while (matches = NESTED_CALC_RE.exec(nonEvaluatedPart)) {
      if (matches[0].index > 0) {
        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index);
      }
      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index));
      if (balancedExpr.body === "") {
        throw new Error("'" + expression + "' must contain a non-whitespace string");
      }
      var evaluated = evaluateExpression(balancedExpr.body, "", call);
      evaluatedPart += balancedExpr.pre + evaluated;
      nonEvaluatedPart = balancedExpr.post;
    }
    return evaluatedPart + nonEvaluatedPart;
  }
  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression);
}
function getUnitsInExpression(expression) {
  var uniqueUnits = [];
  var uniqueLowerCaseUnits = [];
  var unitRegEx = /[\.0-9]([%a-z]+)/gi;
  var matches = unitRegEx.exec(expression);
  while (matches) {
    if (!matches || !matches[1]) {
      continue;
    }
    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
      uniqueUnits.push(matches[1]);
      uniqueLowerCaseUnits.push(matches[1].toLowerCase());
    }
    matches = unitRegEx.exec(expression);
  }
  return uniqueUnits;
}
var reduceCSSCalc$1 = reduceCssCalc;
var freeGlobal$3 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$3;
var freeGlobal$2 = _freeGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal$2 || freeSelf$1 || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$5 = root$7.Symbol;
var _Symbol = Symbol$5;
var Symbol$4 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$3 = objectProto$b.toString;
var symToStringTag$3 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$3), tag = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}
var _getRawTag = getRawTag$2;
var objectProto$a = Object.prototype;
var nativeObjectToString$2 = objectProto$a.toString;
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}
var _objectToString = objectToString$2;
var Symbol$3 = _Symbol, getRawTag$1 = _getRawTag, objectToString$1 = _objectToString;
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]";
var symToStringTag$2 = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$3(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$3;
function isObject$5(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$5;
var baseGetTag$2 = _baseGetTag, isObject$4 = isObject_1;
var asyncTag$1 = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  }
  var tag = baseGetTag$2(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag$1 || tag == proxyTag$1;
}
var isFunction_1 = isFunction$2;
var root$6 = _root;
var coreJsData$3 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$3;
var coreJsData$2 = _coreJsData;
var maskSrcKey$1 = function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$2(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}
var _isMasked = isMasked$2;
var funcProto$3 = Function.prototype;
var funcToString$3 = funcProto$3.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$3.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked$1 = _isMasked, isObject$3 = isObject_1, toSource$1 = _toSource;
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var funcProto$2 = Function.prototype, objectProto$9 = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative$1 = RegExp(
  "^" + funcToString$2.call(hasOwnProperty$7).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(value) {
  if (!isObject$3(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$2;
function getValue$3(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
var _getValue = getValue$3;
var baseIsNative$1 = _baseIsNative, getValue$2 = _getValue;
function getNative$3(object2, key) {
  var value = getValue$2(object2, key);
  return baseIsNative$1(value) ? value : void 0;
}
var _getNative = getNative$3;
var getNative$2 = _getNative;
var nativeCreate$4 = getNative$2(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$1;
var eq = eq_1;
function assocIndexOf$4(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$1(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$1.prototype.clear = listCacheClear;
ListCache$1.prototype["delete"] = listCacheDelete;
ListCache$1.prototype.get = listCacheGet;
ListCache$1.prototype.has = listCacheHas;
ListCache$1.prototype.set = listCacheSet;
var _ListCache = ListCache$1;
var getNative$1 = _getNative, root$5 = _root;
var Map$4 = getNative$1(root$5, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map2, key) {
  var data = map2.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$1(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$1.prototype.clear = mapCacheClear;
MapCache$1.prototype["delete"] = mapCacheDelete;
MapCache$1.prototype.get = mapCacheGet;
MapCache$1.prototype.has = mapCacheHas;
MapCache$1.prototype.set = mapCacheSet;
var _MapCache = MapCache$1;
var MapCache = _MapCache;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$2(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache)();
  return memoized;
}
memoize$2.Cache = MapCache;
var memoize_1 = memoize$2;
var memoize$3 = memoize_1;
var MEASUREMENT_ELEMENT_ID = "__react_svg_text_measurement_id";
function getStringWidth(str, style2) {
  try {
    var textEl = document.getElementById(MEASUREMENT_ELEMENT_ID);
    if (!textEl) {
      var svg2 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg2.setAttribute("aria-hidden", "true");
      svg2.style.width = "0";
      svg2.style.height = "0";
      svg2.style.position = "absolute";
      svg2.style.top = "-100%";
      svg2.style.left = "-100%";
      textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
      textEl.setAttribute("id", MEASUREMENT_ELEMENT_ID);
      svg2.appendChild(textEl);
      document.body.appendChild(svg2);
    }
    Object.assign(textEl.style, style2);
    textEl.textContent = str;
    return textEl.getComputedTextLength();
  } catch (e3) {
    return null;
  }
}
var getStringWidth$1 = memoize$3(getStringWidth, function(str, style2) {
  return str + "_" + JSON.stringify(style2);
});
var _excluded$M = ["verticalAnchor", "scaleToFit", "angle", "width", "lineHeight", "capHeight", "children", "style"];
function _objectWithoutPropertiesLoose$q(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function isNumber$2(val) {
  return typeof val === "number";
}
function isXOrYInValid(xOrY) {
  return typeof xOrY === "number" && Number.isFinite(xOrY) || typeof xOrY === "string";
}
function useText(props) {
  var _props$verticalAnchor = props.verticalAnchor, verticalAnchor = _props$verticalAnchor === void 0 ? "end" : _props$verticalAnchor, _props$scaleToFit = props.scaleToFit, scaleToFit = _props$scaleToFit === void 0 ? false : _props$scaleToFit, angle2 = props.angle, width2 = props.width, _props$lineHeight = props.lineHeight, lineHeight = _props$lineHeight === void 0 ? "1em" : _props$lineHeight, _props$capHeight = props.capHeight, capHeight = _props$capHeight === void 0 ? "0.71em" : _props$capHeight, children2 = props.children, style2 = props.style, textProps = _objectWithoutPropertiesLoose$q(props, _excluded$M);
  var _textProps$x = textProps.x, x2 = _textProps$x === void 0 ? 0 : _textProps$x, _textProps$y = textProps.y, y2 = _textProps$y === void 0 ? 0 : _textProps$y;
  var isXOrYNotValid = !isXOrYInValid(x2) || !isXOrYInValid(y2);
  var _useMemo = useMemo(function() {
    var words = children2 == null ? [] : children2.toString().split(/(?:(?!\u00A0+)\s+)/);
    return {
      wordsWithWidth: words.map(function(word) {
        return {
          word,
          wordWidth: getStringWidth$1(word, style2) || 0
        };
      }),
      spaceWidth: getStringWidth$1("\xA0", style2) || 0
    };
  }, [children2, style2]), wordsWithWidth = _useMemo.wordsWithWidth, spaceWidth = _useMemo.spaceWidth;
  var wordsByLines = useMemo(function() {
    if (isXOrYNotValid) {
      return [];
    }
    if (width2 || scaleToFit) {
      return wordsWithWidth.reduce(function(result, _ref) {
        var word = _ref.word, wordWidth = _ref.wordWidth;
        var currentLine = result[result.length - 1];
        if (currentLine && (width2 == null || scaleToFit || (currentLine.width || 0) + wordWidth + spaceWidth < width2)) {
          currentLine.words.push(word);
          currentLine.width = currentLine.width || 0;
          currentLine.width += wordWidth + spaceWidth;
        } else {
          var newLine = {
            words: [word],
            width: wordWidth
          };
          result.push(newLine);
        }
        return result;
      }, []);
    }
    return [{
      words: children2 == null ? [] : children2.toString().split(/(?:(?!\u00A0+)\s+)/)
    }];
  }, [isXOrYNotValid, width2, scaleToFit, children2, wordsWithWidth, spaceWidth]);
  var startDy = useMemo(function() {
    var startDyStr = isXOrYNotValid ? "" : verticalAnchor === "start" ? reduceCSSCalc$1("calc(" + capHeight + ")") : verticalAnchor === "middle" ? reduceCSSCalc$1("calc(" + (wordsByLines.length - 1) / 2 + " * -" + lineHeight + " + (" + capHeight + " / 2))") : reduceCSSCalc$1("calc(" + (wordsByLines.length - 1) + " * -" + lineHeight + ")");
    return startDyStr;
  }, [isXOrYNotValid, verticalAnchor, capHeight, wordsByLines.length, lineHeight]);
  var transform2 = useMemo(function() {
    var transforms = [];
    if (isXOrYNotValid) {
      return "";
    }
    if (isNumber$2(x2) && isNumber$2(y2) && isNumber$2(width2) && scaleToFit && wordsByLines.length > 0) {
      var lineWidth = wordsByLines[0].width || 1;
      var sx = scaleToFit === "shrink-only" ? Math.min(width2 / lineWidth, 1) : width2 / lineWidth;
      var sy = sx;
      var originX = x2 - sx * x2;
      var originY = y2 - sy * y2;
      transforms.push("matrix(" + sx + ", 0, 0, " + sy + ", " + originX + ", " + originY + ")");
    }
    if (angle2) {
      transforms.push("rotate(" + angle2 + ", " + x2 + ", " + y2 + ")");
    }
    return transforms.length > 0 ? transforms.join(" ") : "";
  }, [isXOrYNotValid, x2, y2, width2, scaleToFit, wordsByLines, angle2]);
  return {
    wordsByLines,
    startDy,
    transform: transform2
  };
}
var _excluded$L = ["dx", "dy", "textAnchor", "innerRef", "innerTextRef", "verticalAnchor", "angle", "lineHeight", "scaleToFit", "capHeight", "width"];
function _extends$F() {
  _extends$F = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$F.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$p(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SVG_STYLE = {
  overflow: "visible"
};
function Text(props) {
  var _props$dx = props.dx, dx = _props$dx === void 0 ? 0 : _props$dx, _props$dy = props.dy, dy = _props$dy === void 0 ? 0 : _props$dy, _props$textAnchor = props.textAnchor, textAnchor = _props$textAnchor === void 0 ? "start" : _props$textAnchor, innerRef = props.innerRef, innerTextRef = props.innerTextRef;
  props.verticalAnchor;
  props.angle;
  var _props$lineHeight = props.lineHeight, lineHeight = _props$lineHeight === void 0 ? "1em" : _props$lineHeight;
  props.scaleToFit;
  props.capHeight;
  props.width;
  var textProps = _objectWithoutPropertiesLoose$p(props, _excluded$L);
  var _textProps$x = textProps.x, x2 = _textProps$x === void 0 ? 0 : _textProps$x, fontSize = textProps.fontSize;
  var _useText = useText(props), wordsByLines = _useText.wordsByLines, startDy = _useText.startDy, transform2 = _useText.transform;
  return /* @__PURE__ */ React__default.createElement("svg", {
    ref: innerRef,
    x: dx,
    y: dy,
    fontSize,
    style: SVG_STYLE
  }, wordsByLines.length > 0 ? /* @__PURE__ */ React__default.createElement("text", _extends$F({
    ref: innerTextRef,
    transform: transform2
  }, textProps, {
    textAnchor
  }), wordsByLines.map(function(line2, index2) {
    return /* @__PURE__ */ React__default.createElement("tspan", {
      key: index2,
      x: x2,
      dy: index2 === 0 ? startDy : lineHeight
    }, line2.words.join(" "));
  })) : null);
}
var Orientation = {
  top: "top",
  left: "left",
  right: "right",
  bottom: "bottom"
};
var Orientation$1 = Orientation;
function getLabelTransform(_ref) {
  var labelOffset = _ref.labelOffset, labelProps = _ref.labelProps, orientation = _ref.orientation, range2 = _ref.range, tickLabelFontSize = _ref.tickLabelFontSize, tickLength = _ref.tickLength;
  var sign2 = orientation === Orientation$1.left || orientation === Orientation$1.top ? -1 : 1;
  var x2;
  var y2;
  var transform2;
  if (orientation === Orientation$1.top || orientation === Orientation$1.bottom) {
    var yBottomOffset = orientation === Orientation$1.bottom && typeof labelProps.fontSize === "number" ? labelProps.fontSize : 0;
    x2 = (Number(range2[0]) + Number(range2[range2.length - 1])) / 2;
    y2 = sign2 * (tickLength + labelOffset + tickLabelFontSize + yBottomOffset);
  } else {
    x2 = sign2 * ((Number(range2[0]) + Number(range2[range2.length - 1])) / 2);
    y2 = -(tickLength + labelOffset);
    transform2 = "rotate(" + sign2 * 90 + ")";
  }
  return {
    x: x2,
    y: y2,
    transform: transform2
  };
}
function _extends$E() {
  _extends$E = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$E.apply(this, arguments);
}
function Ticks(_ref) {
  var hideTicks = _ref.hideTicks, horizontal = _ref.horizontal, orientation = _ref.orientation, tickClassName = _ref.tickClassName, tickComponent = _ref.tickComponent, allTickLabelProps = _ref.tickLabelProps, _ref$tickStroke = _ref.tickStroke, tickStroke = _ref$tickStroke === void 0 ? "#222" : _ref$tickStroke, tickTransform = _ref.tickTransform, ticks2 = _ref.ticks, strokeWidth = _ref.strokeWidth, tickLineProps = _ref.tickLineProps;
  return ticks2.map(function(_ref2) {
    var _allTickLabelProps$in;
    var value = _ref2.value, index2 = _ref2.index, from2 = _ref2.from, to = _ref2.to, formattedValue = _ref2.formattedValue;
    var tickLabelProps = (_allTickLabelProps$in = allTickLabelProps[index2]) != null ? _allTickLabelProps$in : {};
    var tickLabelFontSize = Math.max(10, typeof tickLabelProps.fontSize === "number" && tickLabelProps.fontSize || 0);
    var tickYCoord = to.y + (horizontal && orientation !== Orientation$1.top ? tickLabelFontSize : 0);
    return /* @__PURE__ */ React__default.createElement(Group, {
      key: "visx-tick-" + value + "-" + index2,
      className: cx("visx-axis-tick", tickClassName),
      transform: tickTransform
    }, !hideTicks && /* @__PURE__ */ React__default.createElement(Line$2, _extends$E({
      from: from2,
      to,
      stroke: tickStroke,
      strokeWidth,
      strokeLinecap: "square"
    }, tickLineProps)), tickComponent ? tickComponent(_extends$E({}, tickLabelProps, {
      x: to.x,
      y: tickYCoord,
      formattedValue
    })) : /* @__PURE__ */ React__default.createElement(Text, _extends$E({
      x: to.x,
      y: tickYCoord
    }, tickLabelProps), formattedValue));
  });
}
function _extends$D() {
  _extends$D = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$D.apply(this, arguments);
}
var defaultTextProps = {
  textAnchor: "middle",
  fontFamily: "Arial",
  fontSize: 10,
  fill: "#222"
};
function AxisRenderer(_ref) {
  var axisFromPoint = _ref.axisFromPoint, axisLineClassName = _ref.axisLineClassName, axisToPoint = _ref.axisToPoint, hideAxisLine = _ref.hideAxisLine, hideTicks = _ref.hideTicks, horizontal = _ref.horizontal, _ref$label = _ref.label, label = _ref$label === void 0 ? "" : _ref$label, labelClassName = _ref.labelClassName, _ref$labelOffset = _ref.labelOffset, labelOffset = _ref$labelOffset === void 0 ? 14 : _ref$labelOffset, labelProps = _ref.labelProps, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? Orientation$1.bottom : _ref$orientation, scale = _ref.scale, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#222" : _ref$stroke, strokeDasharray = _ref.strokeDasharray, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, tickClassName = _ref.tickClassName, tickComponent = _ref.tickComponent, tickLineProps = _ref.tickLineProps, tickLabelProps = _ref.tickLabelProps, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, _ref$tickStroke = _ref.tickStroke, tickStroke = _ref$tickStroke === void 0 ? "#222" : _ref$tickStroke, tickTransform = _ref.tickTransform, ticks2 = _ref.ticks, _ref$ticksComponent = _ref.ticksComponent, ticksComponent = _ref$ticksComponent === void 0 ? Ticks : _ref$ticksComponent;
  var combinedLabelProps = _extends$D({}, defaultTextProps, labelProps);
  var tickLabelPropsDefault = _extends$D({}, defaultTextProps, typeof tickLabelProps === "object" ? tickLabelProps : null);
  var allTickLabelProps = ticks2.map(function(_ref2) {
    var value = _ref2.value, index2 = _ref2.index;
    return typeof tickLabelProps === "function" ? tickLabelProps(value, index2, ticks2) : tickLabelPropsDefault;
  });
  var maxTickLabelFontSize = Math.max.apply(Math, [10].concat(allTickLabelProps.map(function(props) {
    return typeof props.fontSize === "number" ? props.fontSize : 0;
  })));
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, ticksComponent({
    hideTicks,
    horizontal,
    orientation,
    scale,
    tickClassName,
    tickComponent,
    tickLabelProps: allTickLabelProps,
    tickStroke,
    tickTransform,
    ticks: ticks2,
    strokeWidth,
    tickLineProps
  }), !hideAxisLine && /* @__PURE__ */ React__default.createElement(Line$2, {
    className: cx("visx-axis-line", axisLineClassName),
    from: axisFromPoint,
    to: axisToPoint,
    stroke,
    strokeWidth,
    strokeDasharray
  }), label && /* @__PURE__ */ React__default.createElement(Text, _extends$D({
    className: cx("visx-axis-label", labelClassName)
  }, getLabelTransform({
    labelOffset,
    labelProps: combinedLabelProps,
    orientation,
    range: scale.range(),
    tickLabelFontSize: maxTickLabelFontSize,
    tickLength
  }), combinedLabelProps), label));
}
function getTickPosition(scale, align2) {
  if (align2 === void 0) {
    align2 = "center";
  }
  var s2 = scale;
  if (align2 !== "start" && "bandwidth" in s2) {
    var offset2 = s2.bandwidth();
    if (align2 === "center")
      offset2 /= 2;
    if (s2.round())
      offset2 = Math.round(offset2);
    return function(d2) {
      var scaledValue = s2(d2);
      return typeof scaledValue === "number" ? scaledValue + offset2 : scaledValue;
    };
  }
  return scale;
}
function getTickFormatter(scale) {
  var s2 = scale;
  if ("tickFormat" in s2) {
    return s2.tickFormat();
  }
  return toString;
}
var Point = /* @__PURE__ */ function() {
  function Point2(_ref) {
    var _ref$x = _ref.x, x2 = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y2 = _ref$y === void 0 ? 0 : _ref$y;
    this.x = 0;
    this.y = 0;
    this.x = x2;
    this.y = y2;
  }
  var _proto = Point2.prototype;
  _proto.value = function value() {
    return {
      x: this.x,
      y: this.y
    };
  };
  _proto.toArray = function toArray() {
    return [this.x, this.y];
  };
  return Point2;
}();
function sumPoints(point1, point2) {
  return new Point({
    x: point1.x + point2.x,
    y: point1.y + point2.y
  });
}
function subtractPoints(point1, point2) {
  return new Point({
    x: point1.x - point2.x,
    y: point1.y - point2.y
  });
}
var esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Point,
  sumPoints,
  subtractPoints
}, Symbol.toStringTag, { value: "Module" }));
function createPoint(_ref, horizontal) {
  var x2 = _ref.x, y2 = _ref.y;
  return new Point(horizontal ? {
    x: x2,
    y: y2
  } : {
    x: y2,
    y: x2
  });
}
function _extends$C() {
  _extends$C = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$C.apply(this, arguments);
}
var defaultAxisRangePadding = 0;
function getAxisRangePaddingConfig(originalRangePadding) {
  if (originalRangePadding === void 0) {
    originalRangePadding = defaultAxisRangePadding;
  }
  return typeof originalRangePadding === "number" ? {
    start: originalRangePadding,
    end: originalRangePadding
  } : _extends$C({
    start: defaultAxisRangePadding,
    end: defaultAxisRangePadding
  }, originalRangePadding);
}
var _excluded$K = ["children", "axisClassName", "hideAxisLine", "hideTicks", "hideZero", "innerRef", "left", "numTicks", "orientation", "rangePadding", "scale", "tickFormat", "tickLength", "tickValues", "top"];
function _extends$B() {
  _extends$B = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$B.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$o(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Axis$1(_ref) {
  var _ref$children = _ref.children, children2 = _ref$children === void 0 ? AxisRenderer : _ref$children, axisClassName = _ref.axisClassName, _ref$hideAxisLine = _ref.hideAxisLine, hideAxisLine = _ref$hideAxisLine === void 0 ? false : _ref$hideAxisLine, _ref$hideTicks = _ref.hideTicks, hideTicks = _ref$hideTicks === void 0 ? false : _ref$hideTicks, _ref$hideZero = _ref.hideZero, hideZero = _ref$hideZero === void 0 ? false : _ref$hideZero, innerRef = _ref.innerRef, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? Orientation$1.bottom : _ref$orientation, _ref$rangePadding = _ref.rangePadding, rangePadding = _ref$rangePadding === void 0 ? 0 : _ref$rangePadding, scale = _ref.scale, tickFormat2 = _ref.tickFormat, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, tickValues = _ref.tickValues, _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, restProps = _objectWithoutPropertiesLoose$o(_ref, _excluded$K);
  var format2 = tickFormat2 != null ? tickFormat2 : getTickFormatter(scale);
  var isLeft = orientation === Orientation$1.left;
  var isTop = orientation === Orientation$1.top;
  var horizontal = isTop || orientation === Orientation$1.bottom;
  var tickPosition = getTickPosition(scale);
  var tickSign = isLeft || isTop ? -1 : 1;
  var range2 = scale.range();
  var rangePaddingConfig = getAxisRangePaddingConfig(rangePadding);
  var axisFromPoint = createPoint({
    x: Number(range2[0]) + 0.5 - rangePaddingConfig.start,
    y: 0
  }, horizontal);
  var axisToPoint = createPoint({
    x: Number(range2[range2.length - 1]) + 0.5 + rangePaddingConfig.end,
    y: 0
  }, horizontal);
  var filteredTickValues = (tickValues != null ? tickValues : getTicks(scale, numTicks)).filter(function(value) {
    return !hideZero || value !== 0 && value !== "0";
  }).map(function(value, index2) {
    return {
      value,
      index: index2
    };
  });
  var ticks2 = filteredTickValues.map(function(_ref2) {
    var value = _ref2.value, index2 = _ref2.index;
    var scaledValue = coerceNumber(tickPosition(value));
    return {
      value,
      index: index2,
      from: createPoint({
        x: scaledValue,
        y: 0
      }, horizontal),
      to: createPoint({
        x: scaledValue,
        y: tickLength * tickSign
      }, horizontal),
      formattedValue: format2(value, index2, filteredTickValues)
    };
  });
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-axis", axisClassName),
    innerRef,
    top: top2,
    left: left2
  }, children2(_extends$B({}, restProps, {
    axisFromPoint,
    axisToPoint,
    hideAxisLine,
    hideTicks,
    hideZero,
    horizontal,
    numTicks,
    orientation,
    rangePadding,
    scale,
    tickFormat: format2,
    tickLength,
    tickPosition,
    tickSign,
    ticks: ticks2
  })));
}
var _excluded$J = ["axisClassName", "labelOffset", "tickLength", "tickLabelProps"];
function _extends$A() {
  _extends$A = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$A.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$n(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var leftTickLabelProps = {
  dx: "-0.25em",
  dy: "0.25em",
  fill: "#222",
  fontFamily: "Arial",
  fontSize: 10,
  textAnchor: "end"
};
function AxisLeft(_ref) {
  var axisClassName = _ref.axisClassName, _ref$labelOffset = _ref.labelOffset, labelOffset = _ref$labelOffset === void 0 ? 36 : _ref$labelOffset, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, tickLabelProps = _ref.tickLabelProps, restProps = _objectWithoutPropertiesLoose$n(_ref, _excluded$J);
  var tickLabelPropsFinal = typeof tickLabelProps === "function" ? tickLabelProps : _extends$A({}, leftTickLabelProps, tickLabelProps);
  return /* @__PURE__ */ React__default.createElement(Axis$1, _extends$A({
    axisClassName: cx("visx-axis-left", axisClassName),
    labelOffset,
    orientation: Orientation$1.left,
    tickLabelProps: tickLabelPropsFinal,
    tickLength
  }, restProps));
}
var _excluded$I = ["axisClassName", "labelOffset", "tickLength", "tickLabelProps"];
function _extends$z() {
  _extends$z = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$z.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$m(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var bottomTickLabelProps = {
  dy: "0.25em",
  fill: "#222",
  fontFamily: "Arial",
  fontSize: 10,
  textAnchor: "middle"
};
function AxisBottom(_ref) {
  var axisClassName = _ref.axisClassName, _ref$labelOffset = _ref.labelOffset, labelOffset = _ref$labelOffset === void 0 ? 8 : _ref$labelOffset, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, tickLabelProps = _ref.tickLabelProps, restProps = _objectWithoutPropertiesLoose$m(_ref, _excluded$I);
  var tickLabelPropsFinal = typeof tickLabelProps === "function" ? tickLabelProps : _extends$z({}, bottomTickLabelProps, tickLabelProps);
  return /* @__PURE__ */ React__default.createElement(Axis$1, _extends$z({
    axisClassName: cx("visx-axis-bottom", axisClassName),
    labelOffset,
    orientation: Orientation$1.bottom,
    tickLabelProps: tickLabelPropsFinal,
    tickLength
  }, restProps));
}
const LeftAxis = ({
  value,
  yScale,
  theme,
  leftMargin
}) => {
  const isBandScale = typeof yScale.bandwidth === "function";
  return /* @__PURE__ */ jsx$1(AxisLeft, {
    numTicks: isBandScale ? yScale.domain().length : void 0,
    scale: yScale,
    top: 0,
    label: value.main.leftLabel,
    tickStroke: "none",
    strokeWidth: "0.3px",
    labelOffset: leftMargin - 30,
    tickLabelProps: (e3) => ({
      fill: theme.myTheme.palette.text.primary,
      fontSize: 14,
      textAnchor: "end",
      dy: "0.33em"
    })
  });
};
const BottomAxis = ({
  yMax,
  value,
  xScale,
  left: left2,
  theme
}) => {
  const isBandScale = typeof xScale.bandwidth === "function";
  return /* @__PURE__ */ jsx$1(AxisBottom, {
    numTicks: isBandScale ? xScale.domain().length : void 0,
    top: yMax,
    left: left2,
    scale: xScale,
    labelOffset: value.main.bottomAxisAngle ? 45 : 5,
    label: value.main.bottomLabel,
    tickLabelProps: () => ({
      fill: theme.myTheme.palette.text.primary,
      fontSize: "14px",
      textAnchor: value.main.bottomAxisAngle ? "start" : "middle",
      angle: value.main.bottomAxisAngle ? 45 : 0
    })
  });
};
var _excluded$H = ["tooltipOpen"];
function _objectWithoutPropertiesLoose$l(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$y() {
  _extends$y = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$y.apply(this, arguments);
}
function useTooltip(initialTooltipState) {
  var _useState = useState(_extends$y({
    tooltipOpen: false
  }, initialTooltipState)), tooltipState = _useState[0], setTooltipState = _useState[1];
  var showTooltip = useCallback(function(showArgs) {
    return setTooltipState(typeof showArgs === "function" ? function(_ref) {
      _ref.tooltipOpen;
      var show = _objectWithoutPropertiesLoose$l(_ref, _excluded$H);
      return _extends$y({}, showArgs(show), {
        tooltipOpen: true
      });
    } : {
      tooltipOpen: true,
      tooltipLeft: showArgs.tooltipLeft,
      tooltipTop: showArgs.tooltipTop,
      tooltipData: showArgs.tooltipData
    });
  }, [setTooltipState]);
  var hideTooltip = useCallback(function() {
    return setTooltipState({
      tooltipOpen: false,
      tooltipLeft: void 0,
      tooltipTop: void 0,
      tooltipData: void 0
    });
  }, [setTooltipState]);
  return {
    tooltipOpen: tooltipState.tooltipOpen,
    tooltipLeft: tooltipState.tooltipLeft,
    tooltipTop: tooltipState.tooltipTop,
    tooltipData: tooltipState.tooltipData,
    updateTooltip: setTooltipState,
    showTooltip,
    hideTooltip
  };
}
function debounce$3(func, wait, immediate) {
  var timeout2, args, context, timestamp, result;
  if (null == wait)
    wait = 100;
  function later() {
    var last2 = Date.now() - timestamp;
    if (last2 < wait && last2 >= 0) {
      timeout2 = setTimeout(later, wait - last2);
    } else {
      timeout2 = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function() {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout2;
    if (!timeout2)
      timeout2 = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
  debounced.clear = function() {
    if (timeout2) {
      clearTimeout(timeout2);
      timeout2 = null;
    }
  };
  debounced.flush = function() {
    if (timeout2) {
      result = func.apply(context, args);
      context = args = null;
      clearTimeout(timeout2);
      timeout2 = null;
    }
  };
  return debounced;
}
debounce$3.debounce = debounce$3;
var debounce_1$1 = debounce$3;
function useMeasure(_temp) {
  let {
    debounce: debounce2,
    scroll,
    polyfill,
    offsetSize
  } = _temp === void 0 ? {
    debounce: 0,
    scroll: false,
    offsetSize: false
  } : _temp;
  const ResizeObserver = polyfill || (typeof window === "undefined" ? class ResizeObserver {
  } : window.ResizeObserver);
  if (!ResizeObserver) {
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  }
  const [bounds2, set2] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  });
  const state = useRef({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: bounds2
  });
  const scrollDebounce = debounce2 ? typeof debounce2 === "number" ? debounce2 : debounce2.scroll : null;
  const resizeDebounce = debounce2 ? typeof debounce2 === "number" ? debounce2 : debounce2.resize : null;
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => void (mounted.current = false);
  });
  const [forceRefresh, resizeChange, scrollChange] = useMemo(() => {
    const callback = () => {
      if (!state.current.element)
        return;
      const {
        left: left2,
        top: top2,
        width: width2,
        height: height2,
        bottom: bottom2,
        right: right2,
        x: x2,
        y: y2
      } = state.current.element.getBoundingClientRect();
      const size = {
        left: left2,
        top: top2,
        width: width2,
        height: height2,
        bottom: bottom2,
        right: right2,
        x: x2,
        y: y2
      };
      if (state.current.element instanceof HTMLElement && offsetSize) {
        size.height = state.current.element.offsetHeight;
        size.width = state.current.element.offsetWidth;
      }
      Object.freeze(size);
      if (mounted.current && !areBoundsEqual(state.current.lastBounds, size))
        set2(state.current.lastBounds = size);
    };
    return [callback, resizeDebounce ? debounce_1$1(callback, resizeDebounce) : callback, scrollDebounce ? debounce_1$1(callback, scrollDebounce) : callback];
  }, [set2, offsetSize, scrollDebounce, resizeDebounce]);
  function removeListeners() {
    if (state.current.scrollContainers) {
      state.current.scrollContainers.forEach((element) => element.removeEventListener("scroll", scrollChange, true));
      state.current.scrollContainers = null;
    }
    if (state.current.resizeObserver) {
      state.current.resizeObserver.disconnect();
      state.current.resizeObserver = null;
    }
  }
  function addListeners() {
    if (!state.current.element)
      return;
    state.current.resizeObserver = new ResizeObserver(scrollChange);
    state.current.resizeObserver.observe(state.current.element);
    if (scroll && state.current.scrollContainers) {
      state.current.scrollContainers.forEach((scrollContainer) => scrollContainer.addEventListener("scroll", scrollChange, {
        capture: true,
        passive: true
      }));
    }
  }
  const ref = (node2) => {
    if (!node2 || node2 === state.current.element)
      return;
    removeListeners();
    state.current.element = node2;
    state.current.scrollContainers = findScrollContainers(node2);
    addListeners();
  };
  useOnWindowScroll(scrollChange, Boolean(scroll));
  useOnWindowResize(resizeChange);
  useEffect(() => {
    removeListeners();
    addListeners();
  }, [scroll, scrollChange, resizeChange]);
  useEffect(() => removeListeners, []);
  return [ref, bounds2, forceRefresh];
}
function useOnWindowResize(onWindowResize) {
  useEffect(() => {
    const cb = onWindowResize;
    window.addEventListener("resize", cb);
    return () => void window.removeEventListener("resize", cb);
  }, [onWindowResize]);
}
function useOnWindowScroll(onScroll, enabled) {
  useEffect(() => {
    if (enabled) {
      const cb = onScroll;
      window.addEventListener("scroll", cb, {
        capture: true,
        passive: true
      });
      return () => void window.removeEventListener("scroll", cb, true);
    }
  }, [onScroll, enabled]);
}
function findScrollContainers(element) {
  const result = [];
  if (!element || element === document.body)
    return result;
  const {
    overflow,
    overflowX,
    overflowY
  } = window.getComputedStyle(element);
  if ([overflow, overflowX, overflowY].some((prop) => prop === "auto" || prop === "scroll"))
    result.push(element);
  return [...result, ...findScrollContainers(element.parentElement)];
}
const keys = ["x", "y", "top", "bottom", "left", "right", "width", "height"];
const areBoundsEqual = (a2, b10) => keys.every((key) => a2[key] === b10[key]);
function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$2(o, p2);
}
var Portal$2 = /* @__PURE__ */ function(_React$PureComponent) {
  _inheritsLoose$2(Portal3, _React$PureComponent);
  function Portal3() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  var _proto = Portal3.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.node && document.body) {
      document.body.removeChild(this.node);
      delete this.node;
    }
  };
  _proto.render = function render2() {
    if (!this.node && typeof document !== "undefined") {
      this.node = document.createElement("div");
      if (this.props.zIndex != null)
        this.node.style.zIndex = "" + this.props.zIndex;
      document.body.append(this.node);
    }
    if (!this.node) {
      return null;
    }
    return /* @__PURE__ */ ReactDOM__default.createPortal(this.props.children, this.node);
  };
  return Portal3;
}(React__default.PureComponent);
Portal$2.propTypes = {
  zIndex: _pt.oneOfType([_pt.number, _pt.string])
};
var _excluded$G = ["className", "top", "left", "offsetLeft", "offsetTop", "style", "children", "unstyled", "applyPositionStyle"];
function _extends$x() {
  _extends$x = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$x.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$k(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var defaultStyles = {
  position: "absolute",
  backgroundColor: "white",
  color: "#666666",
  padding: ".3rem .5rem",
  borderRadius: "3px",
  fontSize: "14px",
  boxShadow: "0 1px 2px rgba(33,33,33,0.2)",
  lineHeight: "1em",
  pointerEvents: "none"
};
var Tooltip$3 = /* @__PURE__ */ React__default.forwardRef(function(_ref, ref) {
  var className = _ref.className, top2 = _ref.top, left2 = _ref.left, _ref$offsetLeft = _ref.offsetLeft, offsetLeft = _ref$offsetLeft === void 0 ? 10 : _ref$offsetLeft, _ref$offsetTop = _ref.offsetTop, offsetTop = _ref$offsetTop === void 0 ? 10 : _ref$offsetTop, _ref$style = _ref.style, style2 = _ref$style === void 0 ? defaultStyles : _ref$style, children2 = _ref.children, _ref$unstyled = _ref.unstyled, unstyled = _ref$unstyled === void 0 ? false : _ref$unstyled, _ref$applyPositionSty = _ref.applyPositionStyle, applyPositionStyle = _ref$applyPositionSty === void 0 ? false : _ref$applyPositionSty, restProps = _objectWithoutPropertiesLoose$k(_ref, _excluded$G);
  return /* @__PURE__ */ React__default.createElement("div", _extends$x({
    ref,
    className: cx("visx-tooltip", className),
    style: _extends$x({
      top: top2 == null || offsetTop == null ? top2 : top2 + offsetTop,
      left: left2 == null || offsetLeft == null ? left2 : left2 + offsetLeft
    }, applyPositionStyle && {
      position: "absolute"
    }, !unstyled && style2)
  }, restProps), children2);
});
Tooltip$3.propTypes = {
  children: _pt.node,
  className: _pt.string,
  left: _pt.number,
  offsetLeft: _pt.number,
  offsetTop: _pt.number,
  top: _pt.number,
  applyPositionStyle: _pt.bool,
  unstyled: _pt.bool
};
Tooltip$3.displayName = "Tooltip";
function _extends$w() {
  _extends$w = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$w.apply(this, arguments);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
var emptyRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: 0,
  height: 0
};
function withBoundingRects(BaseComponent) {
  var _class;
  return _class = /* @__PURE__ */ function(_React$PureComponent) {
    _inheritsLoose$1(WrappedComponent, _React$PureComponent);
    function WrappedComponent(props) {
      var _this;
      _this = _React$PureComponent.call(this, props) || this;
      _this.state = {
        rect: void 0,
        parentRect: void 0
      };
      _this.nodeRef = /* @__PURE__ */ React__default.createRef();
      _this.getRects = _this.getRects.bind(_assertThisInitialized$1(_this));
      return _this;
    }
    var _proto = WrappedComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
      var _this$nodeRef, _this2 = this;
      this.node = (_this$nodeRef = this.nodeRef) != null && _this$nodeRef.current ? this.nodeRef.current : ReactDOM__default.findDOMNode(this);
      this.setState(function() {
        return _this2.getRects();
      });
    };
    _proto.getRects = function getRects() {
      if (!this.node)
        return this.state;
      var node2 = this.node;
      var parentNode = node2.parentNode;
      var rect = node2.getBoundingClientRect ? node2.getBoundingClientRect() : emptyRect;
      var parentRect = parentNode != null && parentNode.getBoundingClientRect ? parentNode.getBoundingClientRect() : emptyRect;
      return {
        rect,
        parentRect
      };
    };
    _proto.render = function render2() {
      return /* @__PURE__ */ React__default.createElement(BaseComponent, _extends$w({
        nodeRef: this.nodeRef,
        getRects: this.getRects
      }, this.state, this.props));
    };
    return WrappedComponent;
  }(React__default.PureComponent), _class.displayName = "withBoundingRects(" + (BaseComponent.displayName || "") + ")", _class;
}
var TooltipPositionContext = /* @__PURE__ */ createContext({
  isFlippedVertically: false,
  isFlippedHorizontally: false
});
var TooltipPositionProvider = TooltipPositionContext.Provider;
TooltipPositionContext.Consumer;
var _excluded$F = ["children", "getRects", "left", "offsetLeft", "offsetTop", "parentRect", "rect", "style", "top", "unstyled", "nodeRef"];
function _extends$v() {
  _extends$v = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$v.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$j(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function TooltipWithBounds(_ref) {
  var children2 = _ref.children;
  _ref.getRects;
  var _ref$left = _ref.left, initialLeft = _ref$left === void 0 ? 0 : _ref$left, _ref$offsetLeft = _ref.offsetLeft, offsetLeft = _ref$offsetLeft === void 0 ? 10 : _ref$offsetLeft, _ref$offsetTop = _ref.offsetTop, offsetTop = _ref$offsetTop === void 0 ? 10 : _ref$offsetTop, parentBounds = _ref.parentRect, ownBounds = _ref.rect, _ref$style = _ref.style, style2 = _ref$style === void 0 ? defaultStyles : _ref$style, _ref$top = _ref.top, initialTop = _ref$top === void 0 ? 0 : _ref$top, _ref$unstyled = _ref.unstyled, unstyled = _ref$unstyled === void 0 ? false : _ref$unstyled, nodeRef = _ref.nodeRef, otherProps = _objectWithoutPropertiesLoose$j(_ref, _excluded$F);
  var transform2;
  var placeTooltipLeft = false;
  var placeTooltipUp = false;
  if (ownBounds && parentBounds) {
    var left2 = initialLeft;
    var top2 = initialTop;
    if (parentBounds.width) {
      var rightPlacementClippedPx = left2 + offsetLeft + ownBounds.width - parentBounds.width;
      var leftPlacementClippedPx = ownBounds.width - left2 - offsetLeft;
      placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
    } else {
      var _rightPlacementClippedPx = left2 + offsetLeft + ownBounds.width - window.innerWidth;
      var _leftPlacementClippedPx = ownBounds.width - left2 - offsetLeft;
      placeTooltipLeft = _rightPlacementClippedPx > 0 && _rightPlacementClippedPx > _leftPlacementClippedPx;
    }
    if (parentBounds.height) {
      var bottomPlacementClippedPx = top2 + offsetTop + ownBounds.height - parentBounds.height;
      var topPlacementClippedPx = ownBounds.height - top2 - offsetTop;
      placeTooltipUp = bottomPlacementClippedPx > 0 && bottomPlacementClippedPx > topPlacementClippedPx;
    } else {
      placeTooltipUp = top2 + offsetTop + ownBounds.height > window.innerHeight;
    }
    left2 = placeTooltipLeft ? left2 - ownBounds.width - offsetLeft : left2 + offsetLeft;
    top2 = placeTooltipUp ? top2 - ownBounds.height - offsetTop : top2 + offsetTop;
    left2 = Math.round(left2);
    top2 = Math.round(top2);
    transform2 = "translate(" + left2 + "px, " + top2 + "px)";
  }
  return /* @__PURE__ */ React__default.createElement(Tooltip$3, _extends$v({
    ref: nodeRef,
    style: _extends$v({
      left: 0,
      top: 0,
      transform: transform2
    }, !unstyled && style2)
  }, otherProps), /* @__PURE__ */ React__default.createElement(TooltipPositionProvider, {
    value: {
      isFlippedVertically: !placeTooltipUp,
      isFlippedHorizontally: !placeTooltipLeft
    }
  }, children2));
}
TooltipWithBounds.propTypes = {
  nodeRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object])
};
var TooltipWithBounds$1 = withBoundingRects(TooltipWithBounds);
var _excluded$E = ["detectBounds", "zIndex"], _excluded2$5 = ["left", "top", "detectBounds", "zIndex"];
function _objectWithoutPropertiesLoose$i(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function useTooltipInPortal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$detectBounds = _ref.detectBounds, detectBoundsOption = _ref$detectBounds === void 0 ? true : _ref$detectBounds, zIndexOption = _ref.zIndex, useMeasureOptions = _objectWithoutPropertiesLoose$i(_ref, _excluded$E);
  var _useMeasure = useMeasure(useMeasureOptions), containerRef = _useMeasure[0], containerBounds = _useMeasure[1], forceRefreshBounds = _useMeasure[2];
  var _useState = useState(false), isSsr = _useState[0], setIsSsr = _useState[1];
  useEffect(function() {
    setIsSsr(false);
  }, []);
  var TooltipInPortal = useMemo(function() {
    return function(_ref2) {
      var _ref2$left = _ref2.left, containerLeft = _ref2$left === void 0 ? 0 : _ref2$left, _ref2$top = _ref2.top, containerTop = _ref2$top === void 0 ? 0 : _ref2$top, detectBoundsProp = _ref2.detectBounds, zIndexProp = _ref2.zIndex, tooltipProps = _objectWithoutPropertiesLoose$i(_ref2, _excluded2$5);
      var detectBounds = detectBoundsProp == null ? detectBoundsOption : detectBoundsProp;
      var zIndex2 = zIndexProp == null ? zIndexOption : zIndexProp;
      var TooltipComponent = detectBounds ? TooltipWithBounds$1 : Tooltip$3;
      var scrollX = isSsr ? 0 : window.scrollX;
      var scrollY = isSsr ? 0 : window.scrollY;
      var portalLeft = containerLeft + (containerBounds.left || 0) + scrollX;
      var portalTop = containerTop + (containerBounds.top || 0) + scrollY;
      return /* @__PURE__ */ jsx$1(Portal$2, {
        zIndex: zIndex2,
        children: /* @__PURE__ */ jsx$1(TooltipComponent, {
          left: portalLeft,
          top: portalTop,
          ...tooltipProps
        })
      });
    };
  }, [detectBoundsOption, zIndexOption, containerBounds.left, containerBounds.top, isSsr]);
  return {
    containerRef,
    containerBounds,
    forceRefreshBounds,
    TooltipInPortal
  };
}
const ToolTip = ({
  value,
  theme,
  top: top2,
  left: left2,
  tooltipData,
  colorScale
}) => {
  const barData = tooltipData == null ? void 0 : tooltipData.barData;
  const hoveredSubBar = tooltipData == null ? void 0 : tooltipData.hoveredSubBar;
  const {
    TooltipInPortal
  } = useTooltipInPortal({
    detectBounds: true,
    scroll: true
  });
  return /* @__PURE__ */ jsx$1(TooltipInPortal, {
    style: {
      ...defaultStyles,
      backgroundColor: theme.myTheme.palette.secondary.main
    },
    top: top2,
    left: left2,
    children: Object.keys(barData).map((bar) => bar === value.main.xAxisValue ? null : /* @__PURE__ */ jsxs("div", {
      style: {
        display: "flex",
        marginBottom: "2.5px",
        marginTop: "2.5px"
      },
      children: [/* @__PURE__ */ jsx$1("span", {
        style: {
          backgroundColor: colorScale(bar),
          width: "15px",
          height: "15px",
          marginRight: "5px",
          border: (hoveredSubBar == null ? void 0 : hoveredSubBar.key) === bar ? "1px solid black" : "1px solid transparent"
        }
      }), /* @__PURE__ */ jsx$1("span", {
        style: {
          marginRight: "5px"
        },
        children: /* @__PURE__ */ jsxs("span", {
          style: {
            fontWeight: (hoveredSubBar == null ? void 0 : hoveredSubBar.key) === bar ? "bold" : "normal",
            color: "black"
          },
          children: [bar, ": "]
        })
      }), /* @__PURE__ */ jsx$1("span", {
        style: {
          fontWeight: (hoveredSubBar == null ? void 0 : hoveredSubBar.key) === bar ? "bold" : "normal",
          color: "black"
        },
        children: barData[bar]
      })]
    }))
  }, Math.random());
};
var _excluded$D = ["flexDirection", "alignItems", "margin", "display", "children"];
function _extends$u() {
  _extends$u = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$u.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$h(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function LegendItem(_ref) {
  var _ref$flexDirection = _ref.flexDirection, flexDirection = _ref$flexDirection === void 0 ? "row" : _ref$flexDirection, _ref$alignItems = _ref.alignItems, alignItems = _ref$alignItems === void 0 ? "center" : _ref$alignItems, _ref$margin = _ref.margin, margin2 = _ref$margin === void 0 ? "0" : _ref$margin, _ref$display = _ref.display, display = _ref$display === void 0 ? "flex" : _ref$display, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$h(_ref, _excluded$D);
  return /* @__PURE__ */ React__default.createElement("div", _extends$u({
    className: "visx-legend-item",
    style: {
      display,
      alignItems,
      flexDirection,
      margin: margin2
    }
  }, restProps), children2);
}
LegendItem.propTypes = {
  alignItems: _pt.string,
  margin: _pt.oneOfType([_pt.string, _pt.number]),
  children: _pt.node,
  display: _pt.string
};
var _excluded$C = ["flex", "label", "margin", "align", "children"];
function _extends$t() {
  _extends$t = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$t.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$g(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function LegendLabel(_ref) {
  var _ref$flex = _ref.flex, flex = _ref$flex === void 0 ? "1" : _ref$flex, label = _ref.label, _ref$margin = _ref.margin, margin2 = _ref$margin === void 0 ? "5px 0" : _ref$margin, _ref$align = _ref.align, align2 = _ref$align === void 0 ? "left" : _ref$align, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$g(_ref, _excluded$C);
  return /* @__PURE__ */ React__default.createElement("div", _extends$t({
    className: "visx-legend-label",
    style: {
      justifyContent: align2,
      display: "flex",
      flex,
      margin: margin2
    }
  }, restProps), children2 || label);
}
LegendLabel.propTypes = {
  align: _pt.string,
  label: _pt.node,
  flex: _pt.oneOfType([_pt.string, _pt.number]),
  margin: _pt.oneOfType([_pt.string, _pt.number]),
  children: _pt.node
};
function _extends$s() {
  _extends$s = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$s.apply(this, arguments);
}
function ShapeRect(_ref) {
  var fill = _ref.fill, width2 = _ref.width, height2 = _ref.height, style2 = _ref.style;
  return /* @__PURE__ */ React__default.createElement("div", {
    style: _extends$s({
      width: width2,
      height: height2,
      background: fill
    }, style2)
  });
}
ShapeRect.propTypes = {
  fill: _pt.string,
  width: _pt.oneOfType([_pt.string, _pt.number]),
  height: _pt.oneOfType([_pt.string, _pt.number])
};
function ShapeCircle(_ref) {
  var fill = _ref.fill, width2 = _ref.width, height2 = _ref.height, style2 = _ref.style;
  var cleanWidth = typeof width2 === "string" || typeof width2 === "undefined" ? 0 : width2;
  var cleanHeight = typeof height2 === "string" || typeof height2 === "undefined" ? 0 : height2;
  var size = Math.max(cleanWidth, cleanHeight);
  var radius = size / 2;
  return /* @__PURE__ */ React__default.createElement("svg", {
    width: size,
    height: size
  }, /* @__PURE__ */ React__default.createElement(Group, {
    top: radius,
    left: radius
  }, /* @__PURE__ */ React__default.createElement("circle", {
    r: radius,
    fill,
    style: style2
  })));
}
ShapeCircle.propTypes = {
  fill: _pt.string,
  width: _pt.oneOfType([_pt.string, _pt.number]),
  height: _pt.oneOfType([_pt.string, _pt.number])
};
function ShapeLine(_ref) {
  var fill = _ref.fill, width2 = _ref.width, height2 = _ref.height, style2 = _ref.style;
  var cleanHeight = typeof height2 === "string" || typeof height2 === "undefined" ? 0 : height2;
  var lineThickness = typeof (style2 == null ? void 0 : style2.strokeWidth) === "number" ? style2 == null ? void 0 : style2.strokeWidth : 2;
  return /* @__PURE__ */ React__default.createElement("svg", {
    width: width2,
    height: height2
  }, /* @__PURE__ */ React__default.createElement(Group, {
    top: cleanHeight / 2 - lineThickness / 2
  }, /* @__PURE__ */ React__default.createElement("line", {
    x1: 0,
    x2: width2,
    y1: 0,
    y2: 0,
    stroke: fill,
    strokeWidth: lineThickness,
    style: style2
  })));
}
ShapeLine.propTypes = {
  fill: _pt.string,
  width: _pt.oneOfType([_pt.string, _pt.number]),
  height: _pt.oneOfType([_pt.string, _pt.number])
};
function _extends$r() {
  _extends$r = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$r.apply(this, arguments);
}
var NO_OP = function NO_OP2() {
  return void 0;
};
function renderShape(_ref) {
  var _ref$shape = _ref.shape, shape2 = _ref$shape === void 0 ? "rect" : _ref$shape, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? NO_OP : _ref$fill, _ref$size = _ref.size, size = _ref$size === void 0 ? NO_OP : _ref$size, width2 = _ref.width, height2 = _ref.height, label = _ref.label, item = _ref.item, itemIndex = _ref.itemIndex, _ref$shapeStyle = _ref.shapeStyle, shapeStyle = _ref$shapeStyle === void 0 ? NO_OP : _ref$shapeStyle;
  var props = {
    width: width2,
    height: height2,
    item,
    itemIndex,
    label,
    fill: fill(_extends$r({}, label)),
    size: size(_extends$r({}, label)),
    style: shapeStyle(_extends$r({}, label))
  };
  if (typeof shape2 === "string") {
    if (shape2 === "circle") {
      return /* @__PURE__ */ React__default.createElement(ShapeCircle, props);
    }
    if (shape2 === "line") {
      return /* @__PURE__ */ React__default.createElement(ShapeLine, props);
    }
    return /* @__PURE__ */ React__default.createElement(ShapeRect, props);
  }
  if (/* @__PURE__ */ React__default.isValidElement(shape2)) {
    return /* @__PURE__ */ React__default.cloneElement(shape2, props);
  }
  if (shape2) {
    return /* @__PURE__ */ React__default.createElement(shape2, props);
  }
  return null;
}
function _extends$q() {
  _extends$q = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$q.apply(this, arguments);
}
function LegendShape(_ref) {
  var _ref$shape = _ref.shape, shape2 = _ref$shape === void 0 ? ShapeRect : _ref$shape, width2 = _ref.width, height2 = _ref.height, margin2 = _ref.margin, label = _ref.label, item = _ref.item, itemIndex = _ref.itemIndex, fill = _ref.fill, size = _ref.size, shapeStyle = _ref.shapeStyle;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "visx-legend-shape",
    style: {
      display: "flex",
      width: size ? size(_extends$q({}, label)) : width2,
      height: size ? size(_extends$q({}, label)) : height2,
      margin: margin2
    }
  }, renderShape({
    shape: shape2,
    item,
    itemIndex,
    label,
    width: width2,
    height: height2,
    fill,
    shapeStyle
  }));
}
LegendShape.propTypes = {
  itemIndex: _pt.number.isRequired,
  margin: _pt.oneOfType([_pt.string, _pt.number]),
  width: _pt.oneOfType([_pt.string, _pt.number]),
  height: _pt.oneOfType([_pt.string, _pt.number])
};
function valueOrIdentity(_2) {
  if (_2 && typeof _2 === "object" && "value" in _2 && typeof _2.value !== "undefined")
    return _2.value;
  return _2;
}
function valueOrIdentityString(_2) {
  return String(valueOrIdentity(_2));
}
function labelTransformFactory(_ref) {
  var scale = _ref.scale, labelFormat = _ref.labelFormat;
  return function(d2, i) {
    return {
      datum: d2,
      index: i,
      text: "" + labelFormat(d2, i),
      value: scale(d2)
    };
  };
}
var _excluded$B = ["className", "style", "scale", "shape", "domain", "fill", "size", "labelFormat", "labelTransform", "shapeWidth", "shapeHeight", "shapeMargin", "shapeStyle", "labelAlign", "labelFlex", "labelMargin", "itemMargin", "direction", "itemDirection", "legendLabelProps", "children"];
function _extends$p() {
  _extends$p = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$p.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$f(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var defaultStyle = {
  display: "flex"
};
function Legend$1(_ref) {
  var className = _ref.className, _ref$style = _ref.style, style2 = _ref$style === void 0 ? defaultStyle : _ref$style, scale = _ref.scale, shape2 = _ref.shape, inputDomain = _ref.domain, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? valueOrIdentityString : _ref$fill, _ref$size = _ref.size, size = _ref$size === void 0 ? valueOrIdentityString : _ref$size, _ref$labelFormat = _ref.labelFormat, labelFormat = _ref$labelFormat === void 0 ? valueOrIdentity : _ref$labelFormat, _ref$labelTransform = _ref.labelTransform, labelTransform = _ref$labelTransform === void 0 ? labelTransformFactory : _ref$labelTransform, _ref$shapeWidth = _ref.shapeWidth, shapeWidth = _ref$shapeWidth === void 0 ? 15 : _ref$shapeWidth, _ref$shapeHeight = _ref.shapeHeight, shapeHeight = _ref$shapeHeight === void 0 ? 15 : _ref$shapeHeight, _ref$shapeMargin = _ref.shapeMargin, shapeMargin = _ref$shapeMargin === void 0 ? "2px 4px 2px 0" : _ref$shapeMargin, shapeStyle = _ref.shapeStyle, _ref$labelAlign = _ref.labelAlign, labelAlign = _ref$labelAlign === void 0 ? "left" : _ref$labelAlign, _ref$labelFlex = _ref.labelFlex, labelFlex = _ref$labelFlex === void 0 ? "1" : _ref$labelFlex, _ref$labelMargin = _ref.labelMargin, labelMargin = _ref$labelMargin === void 0 ? "0 4px" : _ref$labelMargin, _ref$itemMargin = _ref.itemMargin, itemMargin = _ref$itemMargin === void 0 ? "0" : _ref$itemMargin, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "column" : _ref$direction, _ref$itemDirection = _ref.itemDirection, itemDirection = _ref$itemDirection === void 0 ? "row" : _ref$itemDirection, legendLabelProps = _ref.legendLabelProps, children2 = _ref.children, legendItemProps = _objectWithoutPropertiesLoose$f(_ref, _excluded$B);
  var domain2 = inputDomain || ("domain" in scale ? scale.domain() : []);
  var labelFormatter = labelTransform({
    scale,
    labelFormat
  });
  var labels = domain2.map(labelFormatter);
  if (children2)
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children2(labels));
  return /* @__PURE__ */ React__default.createElement("div", {
    className: cx("visx-legend", className),
    style: _extends$p({}, style2, {
      flexDirection: direction
    })
  }, labels.map(function(label, i) {
    return /* @__PURE__ */ React__default.createElement(LegendItem, _extends$p({
      key: "legend-" + label.text + "-" + i,
      margin: itemMargin,
      flexDirection: itemDirection
    }, legendItemProps), /* @__PURE__ */ React__default.createElement(LegendShape, {
      shape: shape2,
      height: shapeHeight,
      width: shapeWidth,
      margin: shapeMargin,
      item: domain2[i],
      itemIndex: i,
      label,
      fill,
      size,
      shapeStyle
    }), /* @__PURE__ */ React__default.createElement(LegendLabel, _extends$p({
      label: label.text,
      flex: labelFlex,
      margin: labelMargin,
      align: labelAlign
    }, legendLabelProps)));
  }));
}
Legend$1.propTypes = {
  children: _pt.func,
  className: _pt.string,
  domain: _pt.array,
  shapeWidth: _pt.oneOfType([_pt.string, _pt.number]),
  shapeHeight: _pt.oneOfType([_pt.string, _pt.number]),
  shapeMargin: _pt.oneOfType([_pt.string, _pt.number]),
  labelAlign: _pt.string,
  labelFlex: _pt.oneOfType([_pt.string, _pt.number]),
  labelMargin: _pt.oneOfType([_pt.string, _pt.number]),
  itemMargin: _pt.oneOfType([_pt.string, _pt.number]),
  fill: _pt.func,
  size: _pt.func,
  shapeStyle: _pt.func
};
function Ordinal(props) {
  return /* @__PURE__ */ React__default.createElement(Legend$1, props);
}
const common = {
  black: "#000",
  white: "#fff"
};
var common$1 = common;
const red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
var red$1 = red;
const purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
var purple$1 = purple;
const blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
var blue$1 = blue;
const lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
var lightBlue$1 = lightBlue;
const green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
var green$1 = green;
const orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
var orange$1 = orange;
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
var grey$1 = grey;
function formatMuiErrorMessage$1(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}
var formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" }));
var THEME_ID = "$$material";
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t4 = arguments[e3];
      for (var r2 in t4)
        ({}).hasOwnProperty.call(t4, r2) && (n2[r2] = t4[r2]);
    }
    return n2;
  }, _extends$o.apply(null, arguments);
}
function _objectWithoutPropertiesLoose$e(r2, e3) {
  if (null == r2)
    return {};
  var t4 = {};
  for (var n2 in r2)
    if ({}.hasOwnProperty.call(r2, n2)) {
      if (e3.includes(n2))
        continue;
      t4[n2] = r2[n2];
    }
  return t4;
}
var isDevelopment$3 = false;
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? !isDevelopment$3 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e3) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs$4 = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash$2(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array2) {
  return array2.push(value), value;
}
function combine(array2, callback) {
  return array2.map(callback).join("");
}
var line$2 = 1;
var column = 1;
var length$4 = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent, type2, props, children2, length2) {
  return { value, root: root2, parent, type: type2, props, children: children2, line: line$2, column, length: length2, return: "" };
}
function copy$2(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line$2--;
  return character;
}
function next() {
  character = position < length$4 ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line$2++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice$5(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line$2 = column = 1, length$4 = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim(slice$5(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice$5(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice$5(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice$5(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children2 = rulesets;
  var reference2 = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1)
              characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference2 = ruleset(characters2, root2, parent, index2, offset2, rules, points, type2, props = [], children2 = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children2);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type2, rules, props = [], length2), children2), rules, children2, length2, points, rule ? props : children2);
                    break;
                  default:
                    parse(characters2, reference2, reference2, reference2, [""], children2, 0, points, children2);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset2, rules, points, type2, props, children2, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs$4(j = points[i])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root2, parent, offset2 === 0 ? RULESET : type2, props, children2, length2);
}
function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children2, callback) {
  var output = "";
  var length2 = sizeof(children2);
  for (var i = 0; i < length2; i++)
    output += callback(children2[i], i, children2, callback) || "";
  return output;
}
function stringify(element, index2, children2, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children2 = serialize(element.children, callback)) ? element.return = element.value + "{" + children2 + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children2, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children2, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize$1(fn2) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice$5(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash$2(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children2, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy$2(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy$2(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector2, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector2 ? selector2 + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var reactIs$2 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c$4 = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k$1 = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m$1 = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r$1 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x$4 = b ? Symbol.for("react.responder") : 60118, y$4 = b ? Symbol.for("react.scope") : 60119;
function z(a2) {
  if ("object" === typeof a2 && null !== a2) {
    var u = a2.$$typeof;
    switch (u) {
      case c$4:
        switch (a2 = a2.type, a2) {
          case l:
          case m$1:
          case e:
          case g:
          case f:
          case p:
            return a2;
          default:
            switch (a2 = a2 && a2.$$typeof, a2) {
              case k$1:
              case n:
              case t:
              case r$1:
              case h:
                return a2;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A$2(a2) {
  return z(a2) === m$1;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m$1;
reactIs_production_min.ContextConsumer = k$1;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c$4;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r$1;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function(a2) {
  return A$2(a2) || z(a2) === l;
};
reactIs_production_min.isConcurrentMode = A$2;
reactIs_production_min.isContextConsumer = function(a2) {
  return z(a2) === k$1;
};
reactIs_production_min.isContextProvider = function(a2) {
  return z(a2) === h;
};
reactIs_production_min.isElement = function(a2) {
  return "object" === typeof a2 && null !== a2 && a2.$$typeof === c$4;
};
reactIs_production_min.isForwardRef = function(a2) {
  return z(a2) === n;
};
reactIs_production_min.isFragment = function(a2) {
  return z(a2) === e;
};
reactIs_production_min.isLazy = function(a2) {
  return z(a2) === t;
};
reactIs_production_min.isMemo = function(a2) {
  return z(a2) === r$1;
};
reactIs_production_min.isPortal = function(a2) {
  return z(a2) === d;
};
reactIs_production_min.isProfiler = function(a2) {
  return z(a2) === g;
};
reactIs_production_min.isStrictMode = function(a2) {
  return z(a2) === f;
};
reactIs_production_min.isSuspense = function(a2) {
  return z(a2) === p;
};
reactIs_production_min.isValidElementType = function(a2) {
  return "string" === typeof a2 || "function" === typeof a2 || a2 === e || a2 === m$1 || a2 === g || a2 === f || a2 === p || a2 === q || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t || a2.$$typeof === r$1 || a2.$$typeof === h || a2.$$typeof === k$1 || a2.$$typeof === n || a2.$$typeof === w || a2.$$typeof === x$4 || a2.$$typeof === y$4 || a2.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$2.exports = reactIs_production_min;
}
var reactIs$1 = reactIs$2.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag2) {
  var className = cache2.key + "-" + serialized.name;
  if ((isStringTag2 === false || isBrowser === false) && cache2.registered[className] === void 0) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag2) {
  registerStyles(cache2, serialized, isStringTag2);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var isDevelopment$2 = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== void 0 ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== "object") {
        var asString = value;
        if (registered != null && registered[asString] !== void 0) {
          string2 += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string2 += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === "NO_COMPONENT_SELECTOR" && isDevelopment$2) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string2 += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string2 += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React$1["useInsertionEffect"] ? React$1["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React$1.useLayoutEffect;
var isDevelopment$1 = false;
var EmotionCacheContext = /* @__PURE__ */ React$1.createContext(
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref);
  });
};
var ThemeContext$2 = /* @__PURE__ */ React$1.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type2, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type2;
  return newProps;
};
var Insertion$1 = function Insertion(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React$1.useContext(ThemeContext$2));
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && !isDevelopment$1) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref) {
    newProps.ref = ref;
  }
  return /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion$1, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React$1.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var _extends$n = { exports: {} };
(function(module2) {
  function _extends3() {
    return module2.exports = _extends3 = Object.assign ? Object.assign.bind() : function(n2) {
      for (var e3 = 1; e3 < arguments.length; e3++) {
        var t4 = arguments[e3];
        for (var r2 in t4)
          ({}).hasOwnProperty.call(t4, r2) && (n2[r2] = t4[r2]);
      }
      return n2;
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _extends3.apply(null, arguments);
  }
  module2.exports = _extends3, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(_extends$n);
var jsx = function jsx2(type2, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React$1.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type2, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React$1.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache2) {
  var styles2 = props.styles;
  var serialized = serializeStyles([styles2], void 0, React$1.useContext(ThemeContext$2));
  var sheetRef = React$1.useRef();
  useInsertionEffectWithLayoutFallback(function() {
    var key = cache2.key + "-global";
    var sheet = new cache2.sheet.constructor({
      key,
      nonce: cache2.sheet.nonce,
      container: cache2.sheet.container,
      speedy: cache2.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    if (cache2.sheet.tags.length) {
      sheet.before = cache2.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache2]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache2, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache2.insert("", serialized, sheet, false);
  }, [cache2, serialized.name]);
  return null;
});
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString2() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$1(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
);
var isDevelopment = false;
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp2;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp2 = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp2 !== "function" && isReal) {
    shouldForwardProp2 = tag.__emotion_forwardProp;
  }
  return shouldForwardProp2;
};
var Insertion2 = function Insertion3(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag2 = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag2);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag2);
  });
  return null;
};
var createStyled$2 = function createStyled(tag, options) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp2 = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      var templateStringsArr = args[0];
      styles2.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles2.push(args[i], templateStringsArr[i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache2, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React$1.useContext(ThemeContext$2);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as")
          continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref) {
        newProps.ref = ref;
      }
      return /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion2, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ React$1.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp2;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        if (targetClassName === void 0 && isDevelopment) {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      var newStyled2 = createStyled(nextTag, _extends$o({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled2.apply(void 0, styles2);
    };
    return Styled;
  };
};
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var newStyled = createStyled$2.bind(null);
tags.forEach(function(tagName) {
  newStyled[tagName] = newStyled(tagName);
});
let cache;
if (typeof document === "object") {
  cache = createCache({
    key: "css",
    prepend: true
  });
}
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children: children2
  } = props;
  return injectFirst && cache ? /* @__PURE__ */ jsx$1(CacheProvider, {
    value: cache,
    children: children2
  }) : children2;
}
function isEmpty$3(obj) {
  return obj === void 0 || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles: styles2,
    defaultTheme: defaultTheme2 = {}
  } = props;
  const globalStyles = typeof styles2 === "function" ? (themeInput) => styles2(isEmpty$3(themeInput) ? defaultTheme2 : themeInput) : styles2;
  return /* @__PURE__ */ jsx$1(Global, {
    styles: globalStyles
  });
}
/**
 * @mui/styled-engine v5.16.13
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(tag, options) {
  const stylesFactory = newStyled(tag, options);
  return stylesFactory;
}
const internal_processStyles = (tag, processor) => {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};
var styledEngine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": styled$2,
  internal_processStyles,
  ThemeContext: ThemeContext$2,
  keyframes,
  css,
  StyledEngineProvider,
  GlobalStyles
}, Symbol.toStringTag, { value: "Module" }));
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/* @__PURE__ */ React$1.isValidElement(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge$1(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$o({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ React$1.isValidElement(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) && Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        output[key] = deepmerge$1(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
var deepmerge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": deepmerge$1,
  isPlainObject
}, Symbol.toStringTag, { value: "Module" }));
const _excluded$A = ["values", "unit", "step"];
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$o({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints) {
  const {
    values: values2 = {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    },
    unit: unit2 = "px",
    step: step2 = 5
  } = breakpoints, other = _objectWithoutPropertiesLoose$e(breakpoints, _excluded$A);
  const sortedValues = sortBreakpointsValues(values2);
  const keys2 = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value}${unit2})`;
  }
  function down(key) {
    const value = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value - step2 / 100}${unit2})`;
  }
  function between(start2, end2) {
    const endIndex = keys2.indexOf(end2);
    return `@media (min-width:${typeof values2[start2] === "number" ? values2[start2] : start2}${unit2}) and (max-width:${(endIndex !== -1 && typeof values2[keys2[endIndex]] === "number" ? values2[keys2[endIndex]] : end2) - step2 / 100}${unit2})`;
  }
  function only(key) {
    if (keys2.indexOf(key) + 1 < keys2.length) {
      return between(key, keys2[keys2.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys2.indexOf(key);
    if (keyIndex === 0) {
      return up(keys2[1]);
    }
    if (keyIndex === keys2.length - 1) {
      return down(keys2[keyIndex]);
    }
    return between(key, keys2[keys2.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends$o({
    keys: keys2,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit: unit2
  }, other);
}
const shape = {
  borderRadius: 4
};
var shape$1 = shape;
function merge$1(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge$1(acc, item, {
    clone: false
  });
}
const values$1 = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};
const defaultBreakpoints = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values$1[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index2) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index2])] = styleFromPropValue(propValue[index2]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values$1).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  if (typeof breakpointValues !== "object") {
    return {};
  }
  const base2 = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base2[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach((breakpoint) => {
      if (breakpointValues[breakpoint] != null) {
        base2[breakpoint] = true;
      }
    });
  }
  return base2;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base2 = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys2 = Object.keys(base2);
  if (keys2.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys2.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === "object") {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
function capitalize$1(string2) {
  if (typeof string2 !== "string") {
    throw new Error(formatMuiErrorMessage$1(7));
  }
  return string2.charAt(0).toUpperCase() + string2.slice(1);
}
var capitalize = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": capitalize$1
}, Symbol.toStringTag, { value: "Module" }));
function getPath(obj, path2, checkVars = true) {
  if (!path2 || typeof path2 !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path2}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path2.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform2, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === "function") {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform2) {
    value = transform2(value, userValue, themeMapping);
  }
  return value;
}
function style$3(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform: transform2
  } = options;
  const fn2 = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform2, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform2, `${prop}${propValueFinal === "default" ? "" : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn2.propTypes = {};
  fn2.filterProps = [prop];
  return fn2;
}
function memoize(fn2) {
  const cache2 = {};
  return (arg) => {
    if (cache2[arg] === void 0) {
      cache2[arg] = fn2(arg);
    }
    return cache2[arg];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a2, b10] = prop.split("");
  const property = properties[a2];
  const direction = directions[b10] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      return themeSpacing * abs2;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      return themeSpacing[abs2];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8);
}
function getValue$1(transformer2, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs2 = Math.abs(propValue);
  const transformed = transformer2(abs2);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer2) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$1(transformer2, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys2, prop, transformer2) {
  if (keys2.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer2);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style$2(props, keys2) {
  const transformer2 = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys2, prop, transformer2)).reduce(merge$1, {});
}
function margin(props) {
  return style$2(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding$1(props) {
  return style$2(props, paddingKeys);
}
padding$1.propTypes = {};
padding$1.filterProps = paddingKeys;
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform2 = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform2(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
function compose$1(...styles2) {
  const handlers = styles2.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn2 = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge$1(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn2.propTypes = {};
  fn2.filterProps = styles2.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn2;
}
function borderTransform(value) {
  if (typeof value !== "number") {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform2) {
  return style$3({
    prop,
    themeKey: "borders",
    transform: transform2
  });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer2 = createUnaryUnit(props.theme, "shape.borderRadius", 4);
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue$1(transformer2, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = ["borderRadius"];
compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer2 = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      gap: getValue$1(transformer2, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer2 = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue$1(transformer2, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer2 = createUnaryUnit(props.theme, "spacing", 8);
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue$1(transformer2, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$3({
  prop: "gridColumn"
});
const gridRow = style$3({
  prop: "gridRow"
});
const gridAutoFlow = style$3({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$3({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$3({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$3({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$3({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$3({
  prop: "gridTemplateAreas"
});
const gridArea = style$3({
  prop: "gridArea"
});
compose$1(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value;
}
const color$4 = style$3({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$3({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$3({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose$1(color$4, bgcolor, backgroundColor);
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = style$3({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$3({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$3({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$3({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$3({
  prop: "minHeight",
  transform: sizingTransform
});
style$3({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$3({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$3({
  prop: "boxSizing"
});
compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  p: {
    style: padding$1
  },
  pt: {
    style: padding$1
  },
  pr: {
    style: padding$1
  },
  pb: {
    style: padding$1
  },
  pl: {
    style: padding$1
  },
  px: {
    style: padding$1
  },
  py: {
    style: padding$1
  },
  padding: {
    style: padding$1
  },
  paddingTop: {
    style: padding$1
  },
  paddingRight: {
    style: padding$1
  },
  paddingBottom: {
    style: padding$1
  },
  paddingLeft: {
    style: padding$1
  },
  paddingX: {
    style: padding$1
  },
  paddingY: {
    style: padding$1
  },
  paddingInline: {
    style: padding$1
  },
  paddingInlineStart: {
    style: padding$1
  },
  paddingInlineEnd: {
    style: padding$1
  },
  paddingBlock: {
    style: padding$1
  },
  paddingBlockStart: {
    style: padding$1
  },
  paddingBlockEnd: {
    style: padding$1
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  displayPrint: {
    cssProperty: false,
    transform: (value) => ({
      "@media print": {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  boxShadow: {
    themeKey: "shadows"
  },
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
var defaultSxConfig$1 = defaultSxConfig;
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys2, object2) => keys2.concat(Object.keys(object2)), []);
  const union2 = new Set(allKeys);
  return objects.every((object2) => union2.size === Object.keys(object2).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config2) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config2[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform: transform2,
      style: style2
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value = getStyleValue(themeMapping, transform2, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === "string") {
        value = getStyleValue(themeMapping, transform2, `${prop}${propValueFinal === "default" ? "" : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    const config2 = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig$1;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css2 = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== void 0) {
          if (typeof value === "object") {
            if (config2[styleKey]) {
              css2 = merge$1(css2, getThemeValue(styleKey, value, theme, config2));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value, (x2) => ({
                [styleKey]: x2
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css2[styleKey] = styleFunctionSx2({
                  sx: value,
                  theme
                });
              } else {
                css2 = merge$1(css2, breakpointsValues);
              }
            }
          } else {
            css2 = merge$1(css2, getThemeValue(styleKey, value, theme, config2));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css2);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ["sx"];
var styleFunctionSx$2 = styleFunctionSx$1;
function applyStyles$2(key, styles2) {
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
    const selector2 = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
    return {
      [selector2]: styles2
    };
  }
  if (theme.palette.mode === key) {
    return styles2;
  }
  return {};
}
const _excluded$z = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose$e(options, _excluded$z);
  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$1({
    breakpoints,
    direction: "ltr",
    components: {},
    palette: _extends$o({
      mode: "light"
    }, paletteInput),
    spacing,
    shape: _extends$o({}, shape$1, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles$2;
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$o({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
var createTheme$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles$2
}, Symbol.toStringTag, { value: "Module" }));
function isObjectEmpty$1(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$3(defaultTheme2 = null) {
  const contextTheme = React$1.useContext(ThemeContext$2);
  return !contextTheme || isObjectEmpty$1(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme$1 = createTheme$2();
function useTheme$2(defaultTheme2 = systemDefaultTheme$1) {
  return useTheme$3(defaultTheme2);
}
const _excluded$y = ["sx"];
const splitProps = (props) => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config2 = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig$1;
  Object.keys(props).forEach((prop) => {
    if (config2[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
    sx: inSx
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$y);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === "function") {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return _extends$o({}, systemProps, result);
    };
  } else {
    finalSx = _extends$o({}, systemProps, inSx);
  }
  return _extends$o({}, otherProps, {
    sx: finalSx
  });
}
var styleFunctionSx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": styleFunctionSx$2,
  unstable_createStyleFunctionSx,
  extendSxProp,
  unstable_defaultSxConfig: defaultSxConfig$1
}, Symbol.toStringTag, { value: "Module" }));
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
var ClassNameGenerator$1 = ClassNameGenerator;
function r(e3) {
  var t4, f2, n2 = "";
  if ("string" == typeof e3 || "number" == typeof e3)
    n2 += e3;
  else if ("object" == typeof e3)
    if (Array.isArray(e3)) {
      var o = e3.length;
      for (t4 = 0; t4 < o; t4++)
        e3[t4] && (f2 = r(e3[t4])) && (n2 && (n2 += " "), n2 += f2);
    } else
      for (f2 in e3)
        e3[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e3, t4, f2 = 0, n2 = "", o = arguments.length; f2 < o; f2++)
    (e3 = arguments[f2]) && (t4 = r(e3)) && (n2 && (n2 += " "), n2 += t4);
  return n2;
}
const _excluded$x = ["className", "component"];
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2,
    defaultClassName = "MuiBox-root",
    generateClassName
  } = options;
  const BoxRoot = styled$2("div", {
    shouldForwardProp: (prop) => prop !== "theme" && prop !== "sx" && prop !== "as"
  })(styleFunctionSx$2);
  const Box2 = /* @__PURE__ */ React$1.forwardRef(function Box3(inProps, ref) {
    const theme = useTheme$2(defaultTheme2);
    const _extendSxProp = extendSxProp(inProps), {
      className,
      component = "div"
    } = _extendSxProp, other = _objectWithoutPropertiesLoose$e(_extendSxProp, _excluded$x);
    return /* @__PURE__ */ jsx$1(BoxRoot, _extends$o({
      as: component,
      ref,
      className: clsx(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box2;
}
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator$1.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}
var reactIs = { exports: {} };
var reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object2) {
  if ("object" === typeof object2 && null !== object2) {
    var $$typeof = object2.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        switch (object2 = object2.type, object2) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return object2;
          default:
            switch (object2 = object2 && object2.$$typeof, object2) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
                return object2;
              case REACT_CONSUMER_TYPE:
                return object2;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
}
reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
reactIs_production.Element = REACT_ELEMENT_TYPE;
reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
reactIs_production.Lazy = REACT_LAZY_TYPE;
reactIs_production.Memo = REACT_MEMO_TYPE;
reactIs_production.Portal = REACT_PORTAL_TYPE;
reactIs_production.Profiler = REACT_PROFILER_TYPE;
reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
reactIs_production.isContextConsumer = function(object2) {
  return typeOf(object2) === REACT_CONSUMER_TYPE;
};
reactIs_production.isContextProvider = function(object2) {
  return typeOf(object2) === REACT_CONTEXT_TYPE;
};
reactIs_production.isElement = function(object2) {
  return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
};
reactIs_production.isForwardRef = function(object2) {
  return typeOf(object2) === REACT_FORWARD_REF_TYPE;
};
reactIs_production.isFragment = function(object2) {
  return typeOf(object2) === REACT_FRAGMENT_TYPE;
};
reactIs_production.isLazy = function(object2) {
  return typeOf(object2) === REACT_LAZY_TYPE;
};
reactIs_production.isMemo = function(object2) {
  return typeOf(object2) === REACT_MEMO_TYPE;
};
reactIs_production.isPortal = function(object2) {
  return typeOf(object2) === REACT_PORTAL_TYPE;
};
reactIs_production.isProfiler = function(object2) {
  return typeOf(object2) === REACT_PROFILER_TYPE;
};
reactIs_production.isStrictMode = function(object2) {
  return typeOf(object2) === REACT_STRICT_MODE_TYPE;
};
reactIs_production.isSuspense = function(object2) {
  return typeOf(object2) === REACT_SUSPENSE_TYPE;
};
reactIs_production.isSuspenseList = function(object2) {
  return typeOf(object2) === REACT_SUSPENSE_LIST_TYPE;
};
reactIs_production.isValidElementType = function(type2) {
  return "string" === typeof type2 || "function" === typeof type2 || type2 === REACT_FRAGMENT_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || type2 === REACT_OFFSCREEN_TYPE || "object" === typeof type2 && null !== type2 && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_CONSUMER_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type2.getModuleId) ? true : false;
};
reactIs_production.typeOf = typeOf;
{
  reactIs.exports = reactIs_production;
}
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn2) {
  const match2 = `${fn2}`.match(fnNameMatchRegex);
  const name = match2 && match2[1];
  return name || "";
}
function getFunctionComponentName(Component, fallback = "") {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName$1(Component) {
  if (Component == null) {
    return void 0;
  }
  if (typeof Component === "string") {
    return Component;
  }
  if (typeof Component === "function") {
    return getFunctionComponentName(Component, "Component");
  }
  if (typeof Component === "object") {
    switch (Component.$$typeof) {
      case reactIs.exports.ForwardRef:
        return getWrappedName(Component, Component.render, "ForwardRef");
      case reactIs.exports.Memo:
        return getWrappedName(Component, Component.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
var getDisplayName = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": getDisplayName$1,
  getFunctionName
}, Symbol.toStringTag, { value: "Module" }));
function resolveProps(defaultProps2, props) {
  const output = _extends$o({}, props);
  Object.keys(defaultProps2).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$o({}, defaultProps2[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps2[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$o({}, slotProps);
        Object.keys(defaultSlotProps).forEach((slotPropName) => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === void 0) {
      output[propName] = defaultProps2[propName];
    }
  });
  return output;
}
function getThemeProps$1(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}
const useEnhancedEffect = typeof window !== "undefined" ? React$1.useLayoutEffect : React$1.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match2, setMatch] = React$1.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }
    return defaultMatches;
  });
  useEnhancedEffect$1(() => {
    let active2 = true;
    if (!matchMedia) {
      return void 0;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      if (active2) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    queryList.addListener(updateMatch);
    return () => {
      active2 = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match2;
}
const maybeReactUseSyncExternalStore = React$1["useSyncExternalStore"];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = React$1.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = React$1.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = React$1.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {
      }];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, (notify) => {
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match2 = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match2;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = useTheme$3();
  const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = getThemeProps$1({
    name: "MuiUseMediaQuery",
    props: options,
    theme
  });
  let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, "");
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld;
  const match2 = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  return match2;
}
function clamp$2(val, min2 = Number.MIN_SAFE_INTEGER, max2 = Number.MAX_SAFE_INTEGER) {
  return Math.max(min2, Math.min(val, max2));
}
var clamp$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": clamp$2
}, Symbol.toStringTag, { value: "Module" }));
function ownerDocument(node2) {
  return node2 && node2.ownerDocument || document;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId2, setDefaultId] = React$1.useState(idOverride);
  const id2 = idOverride || defaultId2;
  React$1.useEffect(() => {
    if (defaultId2 == null) {
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId2]);
  return id2;
}
const maybeReactUseId = React$1["useId".toString()];
function useId(idOverride) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  return useGlobalId(idOverride);
}
function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = "value"
}) {
  const {
    current: isControlled
  } = React$1.useRef(controlled !== void 0);
  const [valueState, setValue] = React$1.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  const setValueIfUncontrolled = React$1.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
function useEventCallback(fn2) {
  const ref = React$1.useRef(fn2);
  useEnhancedEffect$1(() => {
    ref.current = fn2;
  });
  return React$1.useRef((...args) => (0, ref.current)(...args)).current;
}
function useForkRef(...refs) {
  return React$1.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}
const UNINITIALIZED = {};
function useLazyRef(init2, initArg) {
  const ref = React$1.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init2(initArg);
  }
  return ref;
}
const EMPTY = [];
function useOnMount(fn2) {
  React$1.useEffect(fn2, EMPTY);
}
class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  start(delay, fn2) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn2();
    }, delay);
  }
}
function useTimeout() {
  const timeout2 = useLazyRef(Timeout.create).current;
  useOnMount(timeout2.disposeEffect);
  return timeout2;
}
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node2) {
  const {
    type: type2,
    tagName
  } = node2;
  if (tagName === "INPUT" && inputTypesWhitelist[type2] && !node2.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node2.readOnly) {
    return true;
  }
  if (node2.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(":focus-visible");
  } catch (error) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React$1.useCallback((node2) => {
    if (node2 != null) {
      prepare(node2.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React$1.useRef(false);
  function handleBlurVisible() {
    if (isFocusVisibleRef.current) {
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}
function isHostComponent(element) {
  return typeof element === "string";
}
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$o({}, otherProps, {
    ownerState: _extends$o({}, otherProps.ownerState, ownerState)
  });
}
function extractEventHandlers(object2, excludeKeys = []) {
  if (object2 === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object2).filter((prop) => prop.match(/^on[A-Z]/) && typeof object2[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
    result[prop] = object2[prop];
  });
  return result;
}
function omitEventHandlers(object2) {
  if (object2 === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object2).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object2[prop] === "function")).forEach((prop) => {
    result[prop] = object2[prop];
  });
  return result;
}
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    const joinedClasses2 = clsx(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle2 = _extends$o({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props2 = _extends$o({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses2.length > 0) {
      props2.className = joinedClasses2;
    }
    if (Object.keys(mergedStyle2).length > 0) {
      props2.style = mergedStyle2;
    }
    return {
      props: props2,
      internalRef: void 0
    };
  }
  const eventHandlers = extractEventHandlers(_extends$o({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);
  const joinedClasses = clsx(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends$o({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends$o({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === "function") {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
const _excluded$w = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
    elementType,
    externalSlotProps,
    ownerState,
    skipResolvingSlotProps = false
  } = parameters, rest = _objectWithoutPropertiesLoose$e(parameters, _excluded$w);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : resolveComponentProps(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = mergeSlotProps(_extends$o({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = appendOwnerState(elementType, _extends$o({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
function getReactElementRef(element) {
  if (parseInt(React$1.version, 10) >= 19) {
    var _element$props;
    return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
  }
  return (element == null ? void 0 : element.ref) || null;
}
const RtlContext = /* @__PURE__ */ React$1.createContext();
const useRtl = () => {
  const value = React$1.useContext(RtlContext);
  return value != null ? value : false;
};
const PropsContext = /* @__PURE__ */ React$1.createContext(void 0);
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config2 = theme.components[name];
  if (config2.defaultProps) {
    return resolveProps(config2.defaultProps, props);
  }
  if (!config2.styleOverrides && !config2.variants) {
    return resolveProps(config2, props);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name
}) {
  const ctx = React$1.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
function createMixins(breakpoints, mixins) {
  return _extends$o({
    toolbar: {
      minHeight: 56,
      [breakpoints.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints.up("sm")]: {
        minHeight: 64
      }
    }
  }, mixins);
}
var colorManipulator = {};
var interopRequireDefault = { exports: {} };
(function(module2) {
  function _interopRequireDefault2(e3) {
    return e3 && e3.__esModule ? e3 : {
      "default": e3
    };
  }
  module2.exports = _interopRequireDefault2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(interopRequireDefault);
var require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage);
var require$$2$2 = /* @__PURE__ */ getAugmentedNamespace(clamp$1);
var _interopRequireDefault$c = interopRequireDefault.exports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
var alpha_1 = colorManipulator.alpha = alpha;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb;
var lighten_1 = colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$c(require$$1$3);
var _clamp$1 = _interopRequireDefault$c(require$$2$2);
function clampWrapper(value, min2 = 0, max2 = 1) {
  return (0, _clamp$1.default)(value, min2, max2);
}
function hexToRgb(color2) {
  color2 = color2.slice(1);
  const re2 = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
  let colors2 = color2.match(re2);
  if (colors2 && colors2[0].length === 1) {
    colors2 = colors2.map((n2) => n2 + n2);
  }
  return colors2 ? `rgb${colors2.length === 4 ? "a" : ""}(${colors2.map((n2, index2) => {
    return index2 < 3 ? parseInt(n2, 16) : Math.round(parseInt(n2, 16) / 255 * 1e3) / 1e3;
  }).join(", ")})` : "";
}
function intToHex(int2) {
  const hex2 = int2.toString(16);
  return hex2.length === 1 ? `0${hex2}` : hex2;
}
function decomposeColor(color2) {
  if (color2.type) {
    return color2;
  }
  if (color2.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color2));
  }
  const marker = color2.indexOf("(");
  const type2 = color2.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type2) === -1) {
    throw new Error((0, _formatMuiErrorMessage2.default)(9, color2));
  }
  let values2 = color2.substring(marker + 1, color2.length - 1);
  let colorSpace;
  if (type2 === "color") {
    values2 = values2.split(" ");
    colorSpace = values2.shift();
    if (values2.length === 4 && values2[3].charAt(0) === "/") {
      values2[3] = values2[3].slice(1);
    }
    if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
      throw new Error((0, _formatMuiErrorMessage2.default)(10, colorSpace));
    }
  } else {
    values2 = values2.split(",");
  }
  values2 = values2.map((value) => parseFloat(value));
  return {
    type: type2,
    values: values2,
    colorSpace
  };
}
const colorChannel = (color2) => {
  const decomposedColor = decomposeColor(color2);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (color2, warning) => {
  try {
    return colorChannel(color2);
  } catch (error) {
    if (warning && false) {
      console.warn(warning);
    }
    return color2;
  }
};
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color2) {
  const {
    type: type2,
    colorSpace
  } = color2;
  let {
    values: values2
  } = color2;
  if (type2.indexOf("rgb") !== -1) {
    values2 = values2.map((n2, i) => i < 3 ? parseInt(n2, 10) : n2);
  } else if (type2.indexOf("hsl") !== -1) {
    values2[1] = `${values2[1]}%`;
    values2[2] = `${values2[2]}%`;
  }
  if (type2.indexOf("color") !== -1) {
    values2 = `${colorSpace} ${values2.join(" ")}`;
  } else {
    values2 = `${values2.join(", ")}`;
  }
  return `${type2}(${values2})`;
}
function rgbToHex(color2) {
  if (color2.indexOf("#") === 0) {
    return color2;
  }
  const {
    values: values2
  } = decomposeColor(color2);
  return `#${values2.map((n2, i) => intToHex(i === 3 ? Math.round(255 * n2) : n2)).join("")}`;
}
function hslToRgb(color2) {
  color2 = decomposeColor(color2);
  const {
    values: values2
  } = color2;
  const h2 = values2[0];
  const s2 = values2[1] / 100;
  const l2 = values2[2] / 100;
  const a2 = s2 * Math.min(l2, 1 - l2);
  const f2 = (n2, k2 = (n2 + h2 / 30) % 12) => l2 - a2 * Math.max(Math.min(k2 - 3, 9 - k2, 1), -1);
  let type2 = "rgb";
  const rgb2 = [Math.round(f2(0) * 255), Math.round(f2(8) * 255), Math.round(f2(4) * 255)];
  if (color2.type === "hsla") {
    type2 += "a";
    rgb2.push(values2[3]);
  }
  return recomposeColor({
    type: type2,
    values: rgb2
  });
}
function getLuminance(color2) {
  color2 = decomposeColor(color2);
  let rgb2 = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
  rgb2 = rgb2.map((val) => {
    if (color2.type !== "color") {
      val /= 255;
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });
  return Number((0.2126 * rgb2[0] + 0.7152 * rgb2[1] + 0.0722 * rgb2[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color2, value) {
  color2 = decomposeColor(color2);
  value = clampWrapper(value);
  if (color2.type === "rgb" || color2.type === "hsl") {
    color2.type += "a";
  }
  if (color2.type === "color") {
    color2.values[3] = `/${value}`;
  } else {
    color2.values[3] = value;
  }
  return recomposeColor(color2);
}
function private_safeAlpha(color2, value, warning) {
  try {
    return alpha(color2, value);
  } catch (error) {
    if (warning && false) {
      console.warn(warning);
    }
    return color2;
  }
}
function darken(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] *= 1 - coefficient;
  } else if (color2.type.indexOf("rgb") !== -1 || color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeDarken(color2, coefficient, warning) {
  try {
    return darken(color2, coefficient);
  } catch (error) {
    if (warning && false) {
      console.warn(warning);
    }
    return color2;
  }
}
function lighten(color2, coefficient) {
  color2 = decomposeColor(color2);
  coefficient = clampWrapper(coefficient);
  if (color2.type.indexOf("hsl") !== -1) {
    color2.values[2] += (100 - color2.values[2]) * coefficient;
  } else if (color2.type.indexOf("rgb") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (255 - color2.values[i]) * coefficient;
    }
  } else if (color2.type.indexOf("color") !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color2.values[i] += (1 - color2.values[i]) * coefficient;
    }
  }
  return recomposeColor(color2);
}
function private_safeLighten(color2, coefficient, warning) {
  try {
    return lighten(color2, coefficient);
  } catch (error) {
    if (warning && false) {
      console.warn(warning);
    }
    return color2;
  }
}
function emphasize(color2, coefficient = 0.15) {
  return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
}
function private_safeEmphasize(color2, coefficient, warning) {
  try {
    return emphasize(color2, coefficient);
  } catch (error) {
    if (warning && false) {
      console.warn(warning);
    }
    return color2;
  }
}
function blend(background, overlay, opacity, gamma2 = 1) {
  const blendChannel = (b10, o) => Math.round((b10 ** (1 / gamma2) * (1 - opacity) + o ** (1 / gamma2) * opacity) ** gamma2);
  const backgroundColor2 = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb2 = [blendChannel(backgroundColor2.values[0], overlayColor.values[0]), blendChannel(backgroundColor2.values[1], overlayColor.values[1]), blendChannel(backgroundColor2.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: "rgb",
    values: rgb2
  });
}
const _excluded$v = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common$1.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = lighten_1(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = darken_1(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }
  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }
  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }
  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }
  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }
  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }
  return {
    main: "#ed6c02",
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(palette) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette, other = _objectWithoutPropertiesLoose$e(palette, _excluded$v);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    const contrastText = getContrastRatio_1(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = _extends$o({}, color2);
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(formatMuiErrorMessage$1(11, name ? ` (${name})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(formatMuiErrorMessage$1(12, name ? ` (${name})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  const modes = {
    dark,
    light
  };
  const paletteOutput = deepmerge$1(_extends$o({
    common: _extends$o({}, common$1),
    mode,
    primary: augmentColor({
      color: primary,
      name: "primary"
    }),
    secondary: augmentColor({
      color: secondary,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    error: augmentColor({
      color: error,
      name: "error"
    }),
    warning: augmentColor({
      color: warning,
      name: "warning"
    }),
    info: augmentColor({
      color: info,
      name: "info"
    }),
    success: augmentColor({
      color: success,
      name: "success"
    }),
    grey: grey$1,
    contrastThreshold,
    getContrastText,
    augmentColor,
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
const _excluded$u = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$3(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  const _ref = typeof typography === "function" ? typography(palette) : typography, {
    fontFamily = defaultFontFamily,
    fontSize = 14,
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    htmlFontSize = 16,
    allVariants,
    pxToRem: pxToRem2
  } = _ref, other = _objectWithoutPropertiesLoose$e(_ref, _excluded$u);
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$o({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round$3(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1(_extends$o({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;
const _excluded$t = ["duration", "easing", "delay"];
const easing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function formatMs(milliseconds2) {
  return `${Math.round(milliseconds2)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant2 = height2 / 36;
  return Math.round((4 + 15 * constant2 ** 0.25 + constant2 / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$o({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$o({}, duration, inputTransitions.duration);
  const create2 = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options;
    _objectWithoutPropertiesLoose$e(options, _excluded$t);
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return _extends$o({
    getAutoHeightDuration,
    create: create2
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;
const _excluded$s = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options, other = _objectWithoutPropertiesLoose$e(options, _excluded$s);
  if (options.vars) {
    throw new Error(formatMuiErrorMessage$1(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$2(options);
  let muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    shadows: shadows$1.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$o({}, zIndex$1)
  });
  muiTheme = deepmerge$1(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$o({}, defaultSxConfig$1, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$2({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const defaultTheme$1 = createTheme();
var defaultTheme$2 = defaultTheme$1;
function useTheme$1() {
  const theme = useTheme$2(defaultTheme$2);
  return theme[THEME_ID] || theme;
}
var createStyled$1 = {};
var objectWithoutPropertiesLoose = { exports: {} };
(function(module2) {
  function _objectWithoutPropertiesLoose3(r2, e3) {
    if (null == r2)
      return {};
    var t4 = {};
    for (var n2 in r2)
      if ({}.hasOwnProperty.call(r2, n2)) {
        if (e3.includes(n2))
          continue;
        t4[n2] = r2[n2];
      }
    return t4;
  }
  module2.exports = _objectWithoutPropertiesLoose3, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(objectWithoutPropertiesLoose);
var require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(styledEngine);
var require$$4$1 = /* @__PURE__ */ getAugmentedNamespace(deepmerge);
var require$$5$2 = /* @__PURE__ */ getAugmentedNamespace(capitalize);
var require$$6$2 = /* @__PURE__ */ getAugmentedNamespace(getDisplayName);
var require$$7$1 = /* @__PURE__ */ getAugmentedNamespace(createTheme$1);
var require$$8$1 = /* @__PURE__ */ getAugmentedNamespace(styleFunctionSx);
var _interopRequireDefault$b = interopRequireDefault.exports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: true
});
var _default$6 = createStyled$1.default = createStyled2;
createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault$b(_extends$n.exports);
var _objectWithoutPropertiesLoose2 = _interopRequireDefault$b(objectWithoutPropertiesLoose.exports);
var _styledEngine$1 = _interopRequireWildcard$1(require$$1$2);
var _deepmerge = require$$4$1;
_interopRequireDefault$b(require$$5$2);
_interopRequireDefault$b(require$$6$2);
var _createTheme = _interopRequireDefault$b(require$$7$1);
var _styleFunctionSx = _interopRequireDefault$b(require$$8$1);
const _excluded$r = ["ownerState"], _excluded2$4 = ["variants"], _excluded3 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function _getRequireWildcardCache$1(e3) {
  if ("function" != typeof WeakMap)
    return null;
  var r2 = /* @__PURE__ */ new WeakMap(), t4 = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(e4) {
    return e4 ? t4 : r2;
  })(e3);
}
function _interopRequireWildcard$1(e3, r2) {
  if (!r2 && e3 && e3.__esModule)
    return e3;
  if (null === e3 || "object" != typeof e3 && "function" != typeof e3)
    return { default: e3 };
  var t4 = _getRequireWildcardCache$1(r2);
  if (t4 && t4.has(e3))
    return t4.get(e3);
  var n2 = { __proto__: null }, a2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e3)
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e3, u)) {
      var i = a2 ? Object.getOwnPropertyDescriptor(e3, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
    }
  return n2.default = e3, t4 && t4.set(e3, n2), n2;
}
function isEmpty$2(obj) {
  return Object.keys(obj).length === 0;
}
function isStringTag(tag) {
  return typeof tag === "string" && tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter = (string2) => {
  if (!string2) {
    return string2;
  }
  return string2.charAt(0).toLowerCase() + string2.slice(1);
};
function resolveTheme({
  defaultTheme: defaultTheme2,
  theme,
  themeId
}) {
  return isEmpty$2(theme) ? defaultTheme2 : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles2) => styles2[slot];
}
function processStyleArg(callableStyle, _ref) {
  let {
    ownerState
  } = _ref, props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded$r);
  const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, _extends2.default)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap((resolvedStyle) => processStyleArg(resolvedStyle, (0, _extends2.default)({
      ownerState
    }, props)));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
    const {
      variants = []
    } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2$4);
    let result = otherStyles;
    variants.forEach((variant) => {
      let isMatch = true;
      if (typeof variant.props === "function") {
        isMatch = variant.props((0, _extends2.default)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach((key) => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        result.push(typeof variant.style === "function" ? variant.style((0, _extends2.default)({
          ownerState
        }, props, ownerState)) : variant.style);
      }
    });
    return result;
  }
  return resolvedStylesArg;
}
function createStyled2(input = {}) {
  const {
    themeId,
    defaultTheme: defaultTheme2 = systemDefaultTheme,
    rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
    slotShouldForwardProp: slotShouldForwardProp2 = shouldForwardProp
  } = input;
  const systemSx = (props) => {
    return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
      theme: resolveTheme((0, _extends2.default)({}, props, {
        defaultTheme: defaultTheme2,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    (0, _styledEngine$1.internal_processStyles)(tag, (styles2) => styles2.filter((style2) => !(style2 != null && style2.__mui_systemSx)));
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
    } = inputOptions, options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3);
    const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
    const skipSx = inputSkipSx || false;
    let label;
    let shouldForwardPropOption = shouldForwardProp;
    if (componentSlot === "Root" || componentSlot === "root") {
      shouldForwardPropOption = rootShouldForwardProp2;
    } else if (componentSlot) {
      shouldForwardPropOption = slotShouldForwardProp2;
    } else if (isStringTag(tag)) {
      shouldForwardPropOption = void 0;
    }
    const defaultStyledResolver = (0, _styledEngine$1.default)(tag, (0, _extends2.default)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = (stylesArg) => {
      if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) {
        return (props) => processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
          theme: resolveTheme({
            theme: props.theme,
            defaultTheme: defaultTheme2,
            themeId
          })
        }));
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push((props) => {
          const theme = resolveTheme((0, _extends2.default)({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
              theme
            }));
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push((props) => {
          var _theme$components;
          const theme = resolveTheme((0, _extends2.default)({}, props, {
            defaultTheme: defaultTheme2,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0, _extends2.default)({}, props, {
            theme
          }));
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill("");
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}
function slotShouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
var rootShouldForwardProp$1 = rootShouldForwardProp;
const styled = _default$6({
  themeId: THEME_ID,
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp: rootShouldForwardProp$1
});
var styled$1 = styled;
const getOverlayAlpha = (elevation) => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
var getOverlayAlpha$1 = getOverlayAlpha;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}
function _setPrototypeOf(t4, e3) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t5, e4) {
    return t5.__proto__ = e4, t5;
  }, _setPrototypeOf(t4, e3);
}
function _inheritsLoose(t4, o) {
  t4.prototype = Object.create(o.prototype), t4.prototype.constructor = t4, _setPrototypeOf(t4, o);
}
var config$1 = {
  disabled: false
};
var TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition$1 = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          if (node2)
            forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config$1.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!exit || config$1.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active2 = true;
    this.nextCallback = function(event) {
      if (active2) {
        active2 = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active2 = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render2() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children2 = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose$e(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: null
    }, typeof children2 === "function" ? children2(status, childProps) : React__default.cloneElement(React__default.Children.only(children2), childProps));
  };
  return Transition2;
}(React__default.Component);
Transition$1.contextType = TransitionGroupContext;
Transition$1.propTypes = {};
function noop$5() {
}
Transition$1.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5
};
Transition$1.UNMOUNTED = UNMOUNTED;
Transition$1.EXITED = EXITED;
Transition$1.ENTERING = ENTERING;
Transition$1.ENTERED = ENTERED;
Transition$1.EXITING = EXITING;
var Transition$2 = Transition$1;
function _assertThisInitialized(e3) {
  if (void 0 === e3)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e3;
}
function getChildMapping(children2, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children2)
    Children.map(children2, function(c2) {
      return c2;
    }).forEach(function(child) {
      result[child.key] = mapper(child);
    });
  return result;
}
function mergeChildMappings(prev2, next2) {
  prev2 = prev2 || {};
  next2 = next2 || {};
  function getValueForKey(key) {
    return key in next2 ? next2[key] : prev2[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev2) {
    if (prevKey in next2) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next2) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children2 = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children2).forEach(function(key) {
    var child = children2[key];
    if (!isValidElement(child))
      return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children2[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children2[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children2[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children2;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k2) {
    return obj[k2];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node2) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping)
      return;
    if (child.props.onExited) {
      child.props.onExited(node2);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children2 = _extends$o({}, state.children);
        delete children2[child.key];
        return {
          children: children2
        };
      });
    }
  };
  _proto.render = function render2() {
    var _this$props = this.props, Component = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose$e(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children2 = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children2);
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React__default.createElement(Component, props, children2));
  };
  return TransitionGroup2;
}(React__default.Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;
const reflow = (node2) => node2.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout: timeout2,
    easing: easing2,
    style: style2 = {}
  } = props;
  return {
    duration: (_style$transitionDura = style2.transitionDuration) != null ? _style$transitionDura : typeof timeout2 === "number" ? timeout2 : timeout2[options.mode] || 0,
    easing: (_style$transitionTimi = style2.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing2 === "object" ? easing2[options.mode] : easing2,
    delay: style2.transitionDelay
  };
}
function getPaperUtilityClass(slot) {
  return generateUtilityClass("MuiPaper", slot);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const _excluded$q = ["className", "component", "elevation", "square", "variant"];
const useUtilityClasses$9 = (ownerState) => {
  const {
    square: square2,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, !square2 && "rounded", variant === "elevation" && `elevation${elevation}`]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};
const PaperRoot = styled$1("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], !ownerState.square && styles2.rounded, ownerState.variant === "elevation" && styles2[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return _extends$o({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create("box-shadow")
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === "outlined" && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === "elevation" && _extends$o({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${alpha_1("#fff", getOverlayAlpha$1(ownerState.elevation))}, ${alpha_1("#fff", getOverlayAlpha$1(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /* @__PURE__ */ React$1.forwardRef(function Paper2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPaper"
  });
  const {
    className,
    component = "div",
    elevation = 1,
    square: square2 = false,
    variant = "elevation"
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$q);
  const ownerState = _extends$o({}, props, {
    component,
    elevation,
    square: square2,
    variant
  });
  const classes = useUtilityClasses$9(ownerState);
  return /* @__PURE__ */ jsx$1(PaperRoot, _extends$o({
    as: component,
    ownerState,
    className: clsx(classes.root, className),
    ref
  }, other));
});
var Paper$1 = Paper;
function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout: timeout2
  } = props;
  const [leaving, setLeaving] = React$1.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React$1.useEffect(() => {
    if (!inProp && onExited != null) {
      const timeoutId = setTimeout(onExited, timeout2);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return void 0;
  }, [onExited, inProp, timeout2]);
  return /* @__PURE__ */ jsx$1("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /* @__PURE__ */ jsx$1("span", {
      className: childClassName
    })
  });
}
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
var touchRippleClasses$1 = touchRippleClasses;
const _excluded$p = ["center", "classes", "className"];
let _ = (t4) => t4, _t, _t2, _t3, _t4;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = keyframes(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = styled$1("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
});
const TouchRippleRipple = styled$1(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);
const TouchRipple = /* @__PURE__ */ React$1.forwardRef(function TouchRipple2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTouchRipple"
  });
  const {
    center: centerProp = false,
    classes = {},
    className
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$p);
  const [ripples, setRipples] = React$1.useState([]);
  const nextKey = React$1.useRef(0);
  const rippleCallback = React$1.useRef(null);
  React$1.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);
  const ignoringMouseDown = React$1.useRef(false);
  const startTimer = useTimeout();
  const startTimerCommit = React$1.useRef(null);
  const container = React$1.useRef(null);
  const startCommit = React$1.useCallback((params) => {
    const {
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples((oldRipples) => [...oldRipples, /* @__PURE__ */ jsx$1(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses$1.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start2 = React$1.useCallback((event = {}, options = {}, cb = () => {
  }) => {
    const {
      pulsate: pulsate2 = false,
      center: center2 = centerProp || options.pulsate,
      fakeElement = false
    } = options;
    if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === "touchstart") {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center2 || event === void 0 || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center2) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    if (event != null && event.touches) {
      if (startTimerCommit.current === null) {
        startTimerCommit.current = () => {
          startCommit({
            pulsate: pulsate2,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = React$1.useCallback(() => {
    start2({}, {
      pulsate: true
    });
  }, [start2]);
  const stop = React$1.useCallback((event, cb) => {
    startTimer.clear();
    if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples((oldRipples) => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React$1.useImperativeHandle(ref, () => ({
    pulsate,
    start: start2,
    stop
  }), [pulsate, start2, stop]);
  return /* @__PURE__ */ jsx$1(TouchRippleRoot, _extends$o({
    className: clsx(touchRippleClasses$1.root, classes.root, className),
    ref: container
  }, other, {
    children: /* @__PURE__ */ jsx$1(TransitionGroup$1, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
var TouchRipple$1 = TouchRipple;
function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass("MuiButtonBase", slot);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]);
var buttonBaseClasses$1 = buttonBaseClasses;
const _excluded$o = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];
const useUtilityClasses$8 = (ownerState) => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ["root", disabled && "disabled", focusVisible && "focusVisible"]
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = styled$1("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  outline: 0,
  border: 0,
  margin: 0,
  borderRadius: 0,
  padding: 0,
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  WebkitAppearance: "none",
  textDecoration: "none",
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: "none",
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
});
const ButtonBase = /* @__PURE__ */ React$1.forwardRef(function ButtonBase2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiButtonBase"
  });
  const {
    action,
    centerRipple = false,
    children: children2,
    className,
    component = "button",
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    LinkComponent = "a",
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type: type2
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$o);
  const buttonRef = React$1.useRef(null);
  const rippleRef = React$1.useRef(null);
  const handleRippleRef = useForkRef(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React$1.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  React$1.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = React$1.useState(false);
  React$1.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  React$1.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return useEventCallback((event) => {
      if (eventCallback) {
        eventCallback(event);
      }
      const ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  const handleMouseDown = useRippleHandler("start", onMouseDown);
  const handleContextMenu = useRippleHandler("stop", onContextMenu);
  const handleDragLeave = useRippleHandler("stop", onDragLeave);
  const handleMouseUp = useRippleHandler("stop", onMouseUp);
  const handleMouseLeave = useRippleHandler("stop", (event) => {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler("start", onTouchStart);
  const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
  const handleTouchMove = useRippleHandler("stop", onTouchMove);
  const handleBlur = useRippleHandler("stop", (event) => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = useEventCallback((event) => {
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== "button" && !(button.tagName === "A" && button.href);
  };
  const keydownRef = React$1.useRef(false);
  const handleKeyDown2 = useEventCallback((event) => {
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = useEventCallback((event) => {
    if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === "button" && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === "button") {
    buttonProps.type = type2 === void 0 ? "button" : type2;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = "button";
    }
    if (disabled) {
      buttonProps["aria-disabled"] = disabled;
    }
  }
  const handleRef = useForkRef(ref, focusVisibleRef, buttonRef);
  const ownerState = _extends$o({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });
  const classes = useUtilityClasses$8(ownerState);
  return /* @__PURE__ */ jsxs(ButtonBaseRoot, _extends$o({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState,
    onBlur: handleBlur,
    onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown2,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type2
  }, buttonProps, other, {
    children: [children2, enableTouchRipple ? /* @__PURE__ */ jsx$1(TouchRipple$1, _extends$o({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
var ButtonBase$1 = ButtonBase;
function getTypographyUtilityClass(slot) {
  return generateUtilityClass("MuiTypography", slot);
}
generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const _excluded$n = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];
const useUtilityClasses$7 = (ownerState) => {
  const {
    align: align2,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, ownerState.align !== "inherit" && `align${capitalize$1(align2)}`, gutterBottom && "gutterBottom", noWrap && "noWrap", paragraph && "paragraph"]
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = styled$1("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.variant && styles2[ownerState.variant], ownerState.align !== "inherit" && styles2[`align${capitalize$1(ownerState.align)}`], ownerState.noWrap && styles2.noWrap, ownerState.gutterBottom && styles2.gutterBottom, ownerState.paragraph && styles2.paragraph];
  }
})(({
  theme,
  ownerState
}) => _extends$o({
  margin: 0
}, ownerState.variant === "inherit" && {
  font: "inherit"
}, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, ownerState.gutterBottom && {
  marginBottom: "0.35em"
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
};
const colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
};
const transformDeprecatedColors = (color2) => {
  return colorTransformations[color2] || color2;
};
const Typography = /* @__PURE__ */ React$1.forwardRef(function Typography2(inProps, ref) {
  const themeProps = useDefaultProps({
    props: inProps,
    name: "MuiTypography"
  });
  const color2 = transformDeprecatedColors(themeProps.color);
  const props = extendSxProp(_extends$o({}, themeProps, {
    color: color2
  }));
  const {
    align: align2 = "inherit",
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = "body1",
    variantMapping = defaultVariantMapping
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$n);
  const ownerState = _extends$o({}, props, {
    align: align2,
    color: color2,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
  const classes = useUtilityClasses$7(ownerState);
  return /* @__PURE__ */ jsx$1(TypographyRoot, _extends$o({
    as: Component,
    ref,
    ownerState,
    className: clsx(classes.root, className)
  }, other));
});
var Typography$1 = Typography;
var useThemeWithoutDefault = {};
Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: true
});
var default_1 = useThemeWithoutDefault.default = void 0;
var React = _interopRequireWildcard(React__default);
var _styledEngine = require$$1$2;
function _getRequireWildcardCache(e3) {
  if ("function" != typeof WeakMap)
    return null;
  var r2 = /* @__PURE__ */ new WeakMap(), t4 = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(e4) {
    return e4 ? t4 : r2;
  })(e3);
}
function _interopRequireWildcard(e3, r2) {
  if (!r2 && e3 && e3.__esModule)
    return e3;
  if (null === e3 || "object" != typeof e3 && "function" != typeof e3)
    return { default: e3 };
  var t4 = _getRequireWildcardCache(r2);
  if (t4 && t4.has(e3))
    return t4.get(e3);
  var n2 = { __proto__: null }, a2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e3)
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e3, u)) {
      var i = a2 ? Object.getOwnPropertyDescriptor(e3, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
    }
  return n2.default = e3, t4 && t4.set(e3, n2), n2;
}
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme2 = null) {
  const contextTheme = React.useContext(_styledEngine.ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
default_1 = useThemeWithoutDefault.default = useTheme;
var top$1 = "top";
var bottom$1 = "bottom";
var right$1 = "right";
var left$1 = "left";
var auto = "auto";
var basePlacements = [top$1, bottom$1, right$1, left$1];
var start$1 = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start$1, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start$1, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument2 = node2.ownerDocument;
    return ownerDocument2 ? ownerDocument2.defaultView || window : window;
  }
  return node2;
}
function isElement$1(node2) {
  var OwnElement = getWindow(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement$1(node2) {
  var OwnElement = getWindow(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement$1(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max$5 = Math.max;
var min$3 = Math.min;
var round$2 = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$2(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$2(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x2 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y2 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width2 = clientRect.width / scaleX;
  var height2 = clientRect.height / scaleY;
  return {
    width: width2,
    height: height2,
    top: y2,
    right: x2 + width2,
    bottom: y2 + height2,
    left: x2,
    x: x2,
    y: y2
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width2 = element.offsetWidth;
  var height2 = element.offsetHeight;
  if (Math.abs(clientRect.width - width2) <= 1) {
    width2 = clientRect.width;
  }
  if (Math.abs(clientRect.height - height2) <= 1) {
    height2 = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width2,
    height: height2
  };
}
function contains$3(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement$1(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$1(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].indexOf(css2.willChange) !== -1 || isFirefox && css2.willChange === "filter" || isFirefox && css2.filter && css2.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within$1(min2, value, max2) {
  return max$5(min2, min$3(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v2 = within$1(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding2, state) {
  padding2 = typeof padding2 === "function" ? padding2(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding2;
  return mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis2 = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left$1, right$1].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis2 === "y" ? top$1 : left$1;
  var maxProp = axis2 === "y" ? bottom$1 : right$1;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis2] - popperOffsets2[axis2] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis2] - state.rects.reference[axis2];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis2 === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center2 = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within$1(min2, center2, max2);
  var axisProp = axis2;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center2, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains$3(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
  var x2 = _ref.x, y2 = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(x2 * dpr) / dpr || 0,
    y: round$2(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position2 = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x2 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y2 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };
  x2 = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left$1;
  var sideY = top$1;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top$1 || (placement === left$1 || placement === right$1) && variation === end) {
      sideY = bottom$1;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left$1 || (placement === top$1 || placement === bottom$1) && variation === end) {
      sideX = right$1;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y: y2
  }, getWindow(popper2)) : {
    x: x2,
    y: y2
  };
  x2 = _ref4.x;
  y2 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y2 + "px)" : "translate3d(" + x2 + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html2 = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width2 = html2.clientWidth;
  var height2 = html2.clientHeight;
  var x2 = 0;
  var y2 = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2 + getWindowScrollBarX(element),
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html2 = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width2 = max$5(html2.scrollWidth, html2.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height2 = max$5(html2.scrollHeight, html2.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle(body || html2).direction === "rtl") {
    x2 += max$5(html2.clientWidth, body ? body.clientWidth : 0) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$1(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$1(clippingParent) && contains$3(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$5(rect.top, accRect.top);
    accRect.right = min$3(rect.right, accRect.right);
    accRect.bottom = min$3(rect.bottom, accRect.bottom);
    accRect.left = max$5(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top$1:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom$1:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right$1:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left$1:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start$1:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right$1, bottom$1].indexOf(key) >= 0 ? 1 : -1;
      var axis2 = [top$1, bottom$1].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis2] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a2, b10) {
    return overflows[a2] - overflows[b10];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding2 = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start$1;
    var isVertical = [top$1, bottom$1].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical ? isStartVariation ? right$1 : left$1 : isStartVariation ? bottom$1 : top$1;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top$1, right$1, bottom$1, left$1].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left$1, top$1].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance2 = _ref[1];
  skidding = skidding || 0;
  distance2 = (distance2 || 0) * invertDistance;
  return [left$1, right$1].indexOf(basePlacement) >= 0 ? {
    x: distance2,
    y: skidding
  } : {
    x: skidding,
    y: distance2
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x2 = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis2) {
  return axis2 === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding2 = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top$1 : left$1;
    var altSide = mainAxis === "y" ? bottom$1 : right$1;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start$1 ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start$1 ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within$1(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within$1(tether ? min$3(min2, tetherMin) : min2, offset2, tether ? max$5(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top$1 : left$1;
    var _altSide = mainAxis === "x" ? bottom$1 : right$1;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top$1, left$1].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within$1(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow(node2) || !isHTMLElement$1(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$2(rect.width) / element.offsetWidth || 1;
  var scaleY = round$2(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort2(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort2(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort2(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$2(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement$1(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce$2(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref) {
        var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function getContainer(container) {
  return typeof container === "function" ? container() : container;
}
const Portal = /* @__PURE__ */ React$1.forwardRef(function Portal2(props, forwardedRef) {
  const {
    children: children2,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = React$1.useState(null);
  const handleRef = useForkRef(/* @__PURE__ */ React$1.isValidElement(children2) ? getReactElementRef(children2) : null, forwardedRef);
  useEnhancedEffect$1(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$1(() => {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return () => {
        setRef(forwardedRef, null);
      };
    }
    return void 0;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if (/* @__PURE__ */ React$1.isValidElement(children2)) {
      const newProps = {
        ref: handleRef
      };
      return /* @__PURE__ */ React$1.cloneElement(children2, newProps);
    }
    return /* @__PURE__ */ jsx$1(React$1.Fragment, {
      children: children2
    });
  }
  return /* @__PURE__ */ jsx$1(React$1.Fragment, {
    children: mountNode ? /* @__PURE__ */ ReactDOM.createPortal(children2, mountNode) : mountNode
  });
});
var Portal$1 = Portal;
function getPopperUtilityClass(slot) {
  return generateUtilityClass("MuiPopper", slot);
}
generateUtilityClasses("MuiPopper", ["root"]);
const _excluded$m = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2$3 = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(placement, direction) {
  if (direction === "ltr") {
    return placement;
  }
  switch (placement) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return placement;
  }
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
  return element.nodeType !== void 0;
}
const useUtilityClasses$6 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /* @__PURE__ */ React$1.forwardRef(function PopperTooltip2(props, forwardedRef) {
  var _slots$root;
  const {
    anchorEl,
    children: children2,
    direction,
    disablePortal,
    modifiers,
    open,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    slotProps = {},
    slots = {},
    TransitionProps
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$m);
  const tooltipRef = React$1.useRef(null);
  const ownRef = useForkRef(tooltipRef, forwardedRef);
  const popperRef = React$1.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = React$1.useRef(handlePopperRef);
  useEnhancedEffect$1(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React$1.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  const [placement, setPlacement] = React$1.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = React$1.useState(resolveAnchorEl(anchorEl));
  React$1.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  React$1.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }
  }, [anchorEl]);
  useEnhancedEffect$1(() => {
    if (!resolvedAnchorElement || !open) {
      return void 0;
    }
    const handlePopperUpdate = (data) => {
      setPlacement(data.placement);
    };
    let popperModifiers = [{
      name: "preventOverflow",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "flip",
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: "onUpdate",
      enabled: true,
      phase: "afterWrite",
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper2 = createPopper(resolvedAnchorElement, tooltipRef.current, _extends$o({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper2);
    return () => {
      popper2.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses$6(props);
  const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: "tooltip",
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /* @__PURE__ */ jsx$1(Root, _extends$o({}, rootProps, {
    children: typeof children2 === "function" ? children2(childProps) : children2
  }));
});
const Popper$2 = /* @__PURE__ */ React$1.forwardRef(function Popper(props, forwardedRef) {
  const {
    anchorEl,
    children: children2,
    container: containerProp,
    direction = "ltr",
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open,
    placement = "bottom",
    popperOptions = defaultPopperOptions,
    popperRef,
    style: style2,
    transition: transition2 = false,
    slotProps = {},
    slots = {}
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded2$3);
  const [exited, setExited] = React$1.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition2 || exited)) {
    return null;
  }
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);
    container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? ownerDocument(resolvedAnchorEl).body : ownerDocument(null).body;
  }
  const display = !open && keepMounted && (!transition2 || exited) ? "none" : void 0;
  const transitionProps = transition2 ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : void 0;
  return /* @__PURE__ */ jsx$1(Portal$1, {
    disablePortal,
    container,
    children: /* @__PURE__ */ jsx$1(PopperTooltip, _extends$o({
      anchorEl,
      direction,
      disablePortal,
      modifiers,
      ref: forwardedRef,
      open: transition2 ? !exited : open,
      placement,
      popperOptions,
      popperRef,
      slotProps,
      slots
    }, other, {
      style: _extends$o({
        position: "fixed",
        top: 0,
        left: 0,
        display
      }, style2),
      TransitionProps: transitionProps,
      children: children2
    }))
  });
});
var BasePopper = Popper$2;
const _excluded$l = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"];
const PopperRoot = styled$1(BasePopper, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})({});
const Popper2 = /* @__PURE__ */ React$1.forwardRef(function Popper3(inProps, ref) {
  var _slots$root;
  const theme = default_1();
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPopper"
  });
  const {
    anchorEl,
    component,
    components,
    componentsProps,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open,
    placement,
    popperOptions,
    popperRef,
    transition: transition2,
    slots,
    slotProps
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$l);
  const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
  const otherProps = _extends$o({
    anchorEl,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open,
    placement,
    popperOptions,
    popperRef,
    transition: transition2
  }, other);
  return /* @__PURE__ */ jsx$1(PopperRoot, _extends$o({
    as: component,
    direction: theme == null ? void 0 : theme.direction,
    slots: {
      root: RootComponent
    },
    slotProps: slotProps != null ? slotProps : componentsProps
  }, otherProps, {
    ref
  }));
});
var Popper$1 = Popper2;
const boxClasses = generateUtilityClasses("MuiBox", ["root"]);
var boxClasses$1 = boxClasses;
const defaultTheme = createTheme();
const Box = createBox({
  themeId: THEME_ID,
  defaultTheme,
  defaultClassName: boxClasses$1.root,
  generateClassName: ClassNameGenerator$1.generate
});
var Box$1 = Box;
function getCardUtilityClass(slot) {
  return generateUtilityClass("MuiCard", slot);
}
generateUtilityClasses("MuiCard", ["root"]);
const _excluded$k = ["className", "raised"];
const useUtilityClasses$5 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getCardUtilityClass, classes);
};
const CardRoot = styled$1(Paper$1, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})(() => {
  return {
    overflow: "hidden"
  };
});
const Card = /* @__PURE__ */ React$1.forwardRef(function Card2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCard"
  });
  const {
    className,
    raised = false
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$k);
  const ownerState = _extends$o({}, props, {
    raised
  });
  const classes = useUtilityClasses$5(ownerState);
  return /* @__PURE__ */ jsx$1(CardRoot, _extends$o({
    className: clsx(classes.root, className),
    elevation: raised ? 8 : void 0,
    ref,
    ownerState
  }, other));
});
var Card$1 = Card;
function getCardActionAreaUtilityClass(slot) {
  return generateUtilityClass("MuiCardActionArea", slot);
}
const cardActionAreaClasses = generateUtilityClasses("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]);
var cardActionAreaClasses$1 = cardActionAreaClasses;
const _excluded$j = ["children", "className", "focusVisibleClassName"];
const useUtilityClasses$4 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  };
  return composeClasses(slots, getCardActionAreaUtilityClass, classes);
};
const CardActionAreaRoot = styled$1(ButtonBase$1, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})(({
  theme
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  width: "100%",
  [`&:hover .${cardActionAreaClasses$1.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${cardActionAreaClasses$1.focusVisible} .${cardActionAreaClasses$1.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.focusOpacity
  }
}));
const CardActionAreaFocusHighlight = styled$1("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (props, styles2) => styles2.focusHighlight
})(({
  theme
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.short
  })
}));
const CardActionArea = /* @__PURE__ */ React$1.forwardRef(function CardActionArea2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardActionArea"
  });
  const {
    children: children2,
    className,
    focusVisibleClassName
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$j);
  const ownerState = props;
  const classes = useUtilityClasses$4(ownerState);
  return /* @__PURE__ */ jsxs(CardActionAreaRoot, _extends$o({
    className: clsx(classes.root, className),
    focusVisibleClassName: clsx(focusVisibleClassName, classes.focusVisible),
    ref,
    ownerState
  }, other, {
    children: [children2, /* @__PURE__ */ jsx$1(CardActionAreaFocusHighlight, {
      className: classes.focusHighlight,
      ownerState
    })]
  }));
});
var CardActionArea$1 = CardActionArea;
function getCardContentUtilityClass(slot) {
  return generateUtilityClass("MuiCardContent", slot);
}
generateUtilityClasses("MuiCardContent", ["root"]);
const _excluded$i = ["className", "component"];
const useUtilityClasses$3 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = styled$1("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})(() => {
  return {
    padding: 16,
    "&:last-child": {
      paddingBottom: 24
    }
  };
});
const CardContent = /* @__PURE__ */ React$1.forwardRef(function CardContent2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardContent"
  });
  const {
    className,
    component = "div"
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$i);
  const ownerState = _extends$o({}, props, {
    component
  });
  const classes = useUtilityClasses$3(ownerState);
  return /* @__PURE__ */ jsx$1(CardContentRoot, _extends$o({
    as: component,
    className: clsx(classes.root, className),
    ownerState,
    ref
  }, other));
});
var CardContent$1 = CardContent;
function getCardMediaUtilityClass(slot) {
  return generateUtilityClass("MuiCardMedia", slot);
}
generateUtilityClasses("MuiCardMedia", ["root", "media", "img"]);
const _excluded$h = ["children", "className", "component", "image", "src", "style"];
const useUtilityClasses$2 = (ownerState) => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ["root", isMediaComponent && "media", isImageComponent && "img"]
  };
  return composeClasses(slots, getCardMediaUtilityClass, classes);
};
const CardMediaRoot = styled$1("div", {
  name: "MuiCardMedia",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles2.root, isMediaComponent && styles2.media, isImageComponent && styles2.img];
  }
})(({
  ownerState
}) => _extends$o({
  display: "block",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
}, ownerState.isMediaComponent && {
  width: "100%"
}, ownerState.isImageComponent && {
  objectFit: "cover"
}));
const MEDIA_COMPONENTS = ["video", "audio", "picture", "iframe", "img"];
const IMAGE_COMPONENTS = ["picture", "img"];
const CardMedia = /* @__PURE__ */ React$1.forwardRef(function CardMedia2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCardMedia"
  });
  const {
    children: children2,
    className,
    component = "div",
    image: image2,
    src: src2,
    style: style2
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$h);
  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image2 ? _extends$o({
    backgroundImage: `url("${image2}")`
  }, style2) : style2;
  const ownerState = _extends$o({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });
  const classes = useUtilityClasses$2(ownerState);
  return /* @__PURE__ */ jsx$1(CardMediaRoot, _extends$o({
    className: clsx(classes.root, className),
    as: component,
    role: !isMediaComponent && image2 ? "img" : void 0,
    ref,
    style: composedStyle,
    ownerState,
    src: isMediaComponent ? image2 || src2 : void 0
  }, other, {
    children: children2
  }));
});
var CardMedia$1 = CardMedia;
const GridContext = /* @__PURE__ */ React$1.createContext();
var GridContext$1 = GridContext;
function getGridUtilityClass(slot) {
  return generateUtilityClass("MuiGrid", slot);
}
const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS = ["column-reverse", "column", "row-reverse", "row"];
const WRAPS = ["nowrap", "wrap-reverse", "wrap"];
const GRID_SIZES = ["auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const gridClasses = generateUtilityClasses("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  ...SPACINGS.map((spacing) => `spacing-xs-${spacing}`),
  ...DIRECTIONS.map((direction) => `direction-xs-${direction}`),
  ...WRAPS.map((wrap) => `wrap-xs-${wrap}`),
  ...GRID_SIZES.map((size) => `grid-xs-${size}`),
  ...GRID_SIZES.map((size) => `grid-sm-${size}`),
  ...GRID_SIZES.map((size) => `grid-md-${size}`),
  ...GRID_SIZES.map((size) => `grid-lg-${size}`),
  ...GRID_SIZES.map((size) => `grid-xl-${size}`)
]);
const _excluded$g = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function getOffset(val) {
  const parse2 = parseFloat(val);
  return `${parse2}${String(val).replace(String(parse2), "") || "px"}`;
}
function generateGrid({
  theme,
  ownerState
}) {
  let size;
  return theme.breakpoints.keys.reduce((globalStyles, breakpoint) => {
    let styles2 = {};
    if (ownerState[breakpoint]) {
      size = ownerState[breakpoint];
    }
    if (!size) {
      return globalStyles;
    }
    if (size === true) {
      styles2 = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    } else if (size === "auto") {
      styles2 = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    } else {
      const columnsBreakpointValues = resolveBreakpointValues({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
      });
      const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
      if (columnValue === void 0 || columnValue === null) {
        return globalStyles;
      }
      const width2 = `${Math.round(size / columnValue * 1e8) / 1e6}%`;
      let more = {};
      if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
        const themeSpacing = theme.spacing(ownerState.columnSpacing);
        if (themeSpacing !== "0px") {
          const fullWidth = `calc(${width2} + ${getOffset(themeSpacing)})`;
          more = {
            flexBasis: fullWidth,
            maxWidth: fullWidth
          };
        }
      }
      styles2 = _extends$o({
        flexBasis: width2,
        flexGrow: 0,
        maxWidth: width2
      }, more);
    }
    if (theme.breakpoints.values[breakpoint] === 0) {
      Object.assign(globalStyles, styles2);
    } else {
      globalStyles[theme.breakpoints.up(breakpoint)] = styles2;
    }
    return globalStyles;
  }, {});
}
function generateDirection({
  theme,
  ownerState
}) {
  const directionValues = resolveBreakpointValues({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  });
  return handleBreakpoints({
    theme
  }, directionValues, (propValue) => {
    const output = {
      flexDirection: propValue
    };
    if (propValue.indexOf("column") === 0) {
      output[`& > .${gridClasses.item}`] = {
        maxWidth: "none"
      };
    }
    return output;
  });
}
function extractZeroValueBreakpointKeys({
  breakpoints,
  values: values2
}) {
  let nonZeroKey = "";
  Object.keys(values2).forEach((key) => {
    if (nonZeroKey !== "") {
      return;
    }
    if (values2[key] !== 0) {
      nonZeroKey = key;
    }
  });
  const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a2, b10) => {
    return breakpoints[a2] - breakpoints[b10];
  });
  return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function generateRowGap({
  theme,
  ownerState
}) {
  const {
    container,
    rowSpacing
  } = ownerState;
  let styles2 = {};
  if (container && rowSpacing !== 0) {
    const rowSpacingValues = resolveBreakpointValues({
      values: rowSpacing,
      breakpoints: theme.breakpoints.values
    });
    let zeroValueBreakpointKeys;
    if (typeof rowSpacingValues === "object") {
      zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
        breakpoints: theme.breakpoints.values,
        values: rowSpacingValues
      });
    }
    styles2 = handleBreakpoints({
      theme
    }, rowSpacingValues, (propValue, breakpoint) => {
      var _zeroValueBreakpointK;
      const themeSpacing = theme.spacing(propValue);
      if (themeSpacing !== "0px") {
        return {
          marginTop: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingTop: getOffset(themeSpacing)
          }
        };
      }
      if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) {
        return {};
      }
      return {
        marginTop: 0,
        [`& > .${gridClasses.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return styles2;
}
function generateColumnGap({
  theme,
  ownerState
}) {
  const {
    container,
    columnSpacing
  } = ownerState;
  let styles2 = {};
  if (container && columnSpacing !== 0) {
    const columnSpacingValues = resolveBreakpointValues({
      values: columnSpacing,
      breakpoints: theme.breakpoints.values
    });
    let zeroValueBreakpointKeys;
    if (typeof columnSpacingValues === "object") {
      zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
        breakpoints: theme.breakpoints.values,
        values: columnSpacingValues
      });
    }
    styles2 = handleBreakpoints({
      theme
    }, columnSpacingValues, (propValue, breakpoint) => {
      var _zeroValueBreakpointK2;
      const themeSpacing = theme.spacing(propValue);
      if (themeSpacing !== "0px") {
        return {
          width: `calc(100% + ${getOffset(themeSpacing)})`,
          marginLeft: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingLeft: getOffset(themeSpacing)
          }
        };
      }
      if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) {
        return {};
      }
      return {
        width: "100%",
        marginLeft: 0,
        [`& > .${gridClasses.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return styles2;
}
function resolveSpacingStyles(spacing, breakpoints, styles2 = {}) {
  if (!spacing || spacing <= 0) {
    return [];
  }
  if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") {
    return [styles2[`spacing-xs-${String(spacing)}`]];
  }
  const spacingStyles = [];
  breakpoints.forEach((breakpoint) => {
    const value = spacing[breakpoint];
    if (Number(value) > 0) {
      spacingStyles.push(styles2[`spacing-${breakpoint}-${String(value)}`]);
    }
  });
  return spacingStyles;
}
const GridRoot = styled$1("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    const {
      container,
      direction,
      item,
      spacing,
      wrap,
      zeroMinWidth,
      breakpoints
    } = ownerState;
    let spacingStyles = [];
    if (container) {
      spacingStyles = resolveSpacingStyles(spacing, breakpoints, styles2);
    }
    const breakpointsStyles = [];
    breakpoints.forEach((breakpoint) => {
      const value = ownerState[breakpoint];
      if (value) {
        breakpointsStyles.push(styles2[`grid-${breakpoint}-${String(value)}`]);
      }
    });
    return [styles2.root, container && styles2.container, item && styles2.item, zeroMinWidth && styles2.zeroMinWidth, ...spacingStyles, direction !== "row" && styles2[`direction-xs-${String(direction)}`], wrap !== "wrap" && styles2[`wrap-xs-${String(wrap)}`], ...breakpointsStyles];
  }
})(({
  ownerState
}) => _extends$o({
  boxSizing: "border-box"
}, ownerState.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, ownerState.item && {
  margin: 0
}, ownerState.zeroMinWidth && {
  minWidth: 0
}, ownerState.wrap !== "wrap" && {
  flexWrap: ownerState.wrap
}), generateDirection, generateRowGap, generateColumnGap, generateGrid);
function resolveSpacingClasses(spacing, breakpoints) {
  if (!spacing || spacing <= 0) {
    return [];
  }
  if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") {
    return [`spacing-xs-${String(spacing)}`];
  }
  const classes = [];
  breakpoints.forEach((breakpoint) => {
    const value = spacing[breakpoint];
    if (Number(value) > 0) {
      const className = `spacing-${breakpoint}-${String(value)}`;
      classes.push(className);
    }
  });
  return classes;
}
const useUtilityClasses$1 = (ownerState) => {
  const {
    classes,
    container,
    direction,
    item,
    spacing,
    wrap,
    zeroMinWidth,
    breakpoints
  } = ownerState;
  let spacingClasses = [];
  if (container) {
    spacingClasses = resolveSpacingClasses(spacing, breakpoints);
  }
  const breakpointsClasses = [];
  breakpoints.forEach((breakpoint) => {
    const value = ownerState[breakpoint];
    if (value) {
      breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    }
  });
  const slots = {
    root: ["root", container && "container", item && "item", zeroMinWidth && "zeroMinWidth", ...spacingClasses, direction !== "row" && `direction-xs-${String(direction)}`, wrap !== "wrap" && `wrap-xs-${String(wrap)}`, ...breakpointsClasses]
  };
  return composeClasses(slots, getGridUtilityClass, classes);
};
const Grid$2 = /* @__PURE__ */ React$1.forwardRef(function Grid(inProps, ref) {
  const themeProps = useDefaultProps({
    props: inProps,
    name: "MuiGrid"
  });
  const {
    breakpoints
  } = useTheme$1();
  const props = extendSxProp(themeProps);
  const {
    className,
    columns: columnsProp,
    columnSpacing: columnSpacingProp,
    component = "div",
    container = false,
    direction = "row",
    item = false,
    rowSpacing: rowSpacingProp,
    spacing = 0,
    wrap = "wrap",
    zeroMinWidth = false
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$g);
  const rowSpacing = rowSpacingProp || spacing;
  const columnSpacing = columnSpacingProp || spacing;
  const columnsContext = React$1.useContext(GridContext$1);
  const columns = container ? columnsProp || 12 : columnsContext;
  const breakpointsValues = {};
  const otherFiltered = _extends$o({}, other);
  breakpoints.keys.forEach((breakpoint) => {
    if (other[breakpoint] != null) {
      breakpointsValues[breakpoint] = other[breakpoint];
      delete otherFiltered[breakpoint];
    }
  });
  const ownerState = _extends$o({}, props, {
    columns,
    container,
    direction,
    item,
    rowSpacing,
    columnSpacing,
    wrap,
    zeroMinWidth,
    spacing
  }, breakpointsValues, {
    breakpoints: breakpoints.keys
  });
  const classes = useUtilityClasses$1(ownerState);
  return /* @__PURE__ */ jsx$1(GridContext$1.Provider, {
    value: columns,
    children: /* @__PURE__ */ jsx$1(GridRoot, _extends$o({
      ownerState,
      className: clsx(classes.root, className),
      as: component,
      ref
    }, otherFiltered))
  });
});
var Grid$3 = Grid$2;
const _excluded$f = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
};
const isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
const Grow = /* @__PURE__ */ React$1.forwardRef(function Grow2(props, ref) {
  const {
    addEndListener,
    appear = true,
    children: children2,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style: style2,
    timeout: timeout2 = "auto",
    TransitionComponent = Transition$2
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$f);
  const timer2 = useTimeout();
  const autoTimeout = React$1.useRef();
  const theme = useTheme$1();
  const nodeRef = React$1.useRef(null);
  const handleRef = useForkRef(nodeRef, getReactElementRef(children2), ref);
  const normalizedTransitionCallback = (callback) => (maybeIsAppearing) => {
    if (callback) {
      const node2 = nodeRef.current;
      if (maybeIsAppearing === void 0) {
        callback(node2);
      } else {
        callback(node2, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node2, isAppearing) => {
    reflow(node2);
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    let duration2;
    if (timeout2 === "auto") {
      duration2 = theme.transitions.getAutoHeightDuration(node2.clientHeight);
      autoTimeout.current = duration2;
    } else {
      duration2 = transitionDuration;
    }
    node2.style.transition = [theme.transitions.create("opacity", {
      duration: duration2,
      delay
    }), theme.transitions.create("transform", {
      duration: isWebKit154 ? duration2 : duration2 * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(",");
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback((node2) => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    let duration2;
    if (timeout2 === "auto") {
      duration2 = theme.transitions.getAutoHeightDuration(node2.clientHeight);
      autoTimeout.current = duration2;
    } else {
      duration2 = transitionDuration;
    }
    node2.style.transition = [theme.transitions.create("opacity", {
      duration: duration2,
      delay
    }), theme.transitions.create("transform", {
      duration: isWebKit154 ? duration2 : duration2 * 0.666,
      delay: isWebKit154 ? delay : delay || duration2 * 0.333,
      easing: transitionTimingFunction
    })].join(",");
    node2.style.opacity = 0;
    node2.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = (next2) => {
    if (timeout2 === "auto") {
      timer2.start(autoTimeout.current || 0, next2);
    }
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  return /* @__PURE__ */ jsx$1(TransitionComponent, _extends$o({
    appear,
    in: inProp,
    nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout2 === "auto" ? null : timeout2
  }, other, {
    children: (state, childProps) => {
      return /* @__PURE__ */ React$1.cloneElement(children2, _extends$o({
        style: _extends$o({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === "exited" && !inProp ? "hidden" : void 0
        }, styles[state], style2, children2.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
Grow.muiSupportAuto = true;
var Grow$1 = Grow;
function getTooltipUtilityClass(slot) {
  return generateUtilityClass("MuiTooltip", slot);
}
const tooltipClasses = generateUtilityClasses("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
var tooltipClasses$1 = tooltipClasses;
const _excluded$e = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = (ownerState) => {
  const {
    classes,
    disableInteractive,
    arrow: arrow2,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ["popper", !disableInteractive && "popperInteractive", arrow2 && "popperArrow"],
    tooltip: ["tooltip", arrow2 && "tooltipArrow", touch && "touch", `tooltipPlacement${capitalize$1(placement.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(slots, getTooltipUtilityClass, classes);
};
const TooltipPopper = styled$1(Popper$1, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.popper, !ownerState.disableInteractive && styles2.popperInteractive, ownerState.arrow && styles2.popperArrow, !ownerState.open && styles2.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => _extends$o({
  zIndex: (theme.vars || theme).zIndex.tooltip,
  pointerEvents: "none"
}, !ownerState.disableInteractive && {
  pointerEvents: "auto"
}, !open && {
  pointerEvents: "none"
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends$o({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends$o({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
}));
const TooltipTooltip = styled$1("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.tooltip, ownerState.touch && styles2.touch, ownerState.arrow && styles2.tooltipArrow, styles2[`tooltipPlacement${capitalize$1(ownerState.placement.split("-")[0])}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$o({
  backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : alpha_1(theme.palette.grey[700], 0.92),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  color: (theme.vars || theme).palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: "4px 8px",
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: "relative",
  margin: 0
}, ownerState.touch && {
  padding: "8px 16px",
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round$1(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends$o({
    transformOrigin: "right center"
  }, !ownerState.isRtl ? _extends$o({
    marginRight: "14px"
  }, ownerState.touch && {
    marginRight: "24px"
  }) : _extends$o({
    marginLeft: "14px"
  }, ownerState.touch && {
    marginLeft: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends$o({
    transformOrigin: "left center"
  }, !ownerState.isRtl ? _extends$o({
    marginLeft: "14px"
  }, ownerState.touch && {
    marginLeft: "24px"
  }) : _extends$o({
    marginRight: "14px"
  }, ownerState.touch && {
    marginRight: "24px"
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends$o({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, ownerState.touch && {
    marginBottom: "24px"
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends$o({
    transformOrigin: "center top",
    marginTop: "14px"
  }, ownerState.touch && {
    marginTop: "24px"
  })
}));
const TooltipArrow = styled$1("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (props, styles2) => styles2.arrow
})(({
  theme
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: theme.vars ? theme.vars.palette.Tooltip.bg : alpha_1(theme.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let hystersisOpen = false;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(handler, eventHandler) {
  return (event, ...params) => {
    if (eventHandler) {
      eventHandler(event, ...params);
    }
    handler(event, ...params);
  };
}
const Tooltip$1 = /* @__PURE__ */ React$1.forwardRef(function Tooltip(inProps, ref) {
  var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTooltip"
  });
  const {
    arrow: arrow2 = false,
    children: childrenProp,
    components = {},
    componentsProps = {},
    describeChild = false,
    disableFocusListener = false,
    disableHoverListener = false,
    disableInteractive: disableInteractiveProp = false,
    disableTouchListener = false,
    enterDelay = 100,
    enterNextDelay = 0,
    enterTouchDelay = 700,
    followCursor = false,
    id: idProp,
    leaveDelay = 0,
    leaveTouchDelay = 1500,
    onClose,
    onOpen,
    open: openProp,
    placement = "bottom",
    PopperComponent: PopperComponentProp,
    PopperProps = {},
    slotProps = {},
    slots = {},
    title,
    TransitionComponent: TransitionComponentProp = Grow$1,
    TransitionProps
  } = props, other = _objectWithoutPropertiesLoose$e(props, _excluded$e);
  const children2 = /* @__PURE__ */ React$1.isValidElement(childrenProp) ? childrenProp : /* @__PURE__ */ jsx$1("span", {
    children: childrenProp
  });
  const theme = useTheme$1();
  const isRtl = useRtl();
  const [childNode, setChildNode] = React$1.useState();
  const [arrowRef, setArrowRef] = React$1.useState(null);
  const ignoreNonTouchEvents = React$1.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = useTimeout();
  const enterTimer = useTimeout();
  const leaveTimer = useTimeout();
  const touchTimer = useTimeout();
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: "Tooltip",
    state: "open"
  });
  let open = openState;
  const id2 = useId(idProp);
  const prevUserSelect = React$1.useRef();
  const stopTouchInteraction = useEventCallback(() => {
    if (prevUserSelect.current !== void 0) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = void 0;
    }
    touchTimer.clear();
  });
  React$1.useEffect(() => stopTouchInteraction, [stopTouchInteraction]);
  const handleOpen = (event) => {
    hystersisTimer.clear();
    hystersisOpen = true;
    setOpenState(true);
    if (onOpen && !open) {
      onOpen(event);
    }
  };
  const handleClose = useEventCallback(
    (event) => {
      hystersisTimer.start(800 + leaveDelay, () => {
        hystersisOpen = false;
      });
      setOpenState(false);
      if (onClose && open) {
        onClose(event);
      }
      closeTimer.start(theme.transitions.duration.shortest, () => {
        ignoreNonTouchEvents.current = false;
      });
    }
  );
  const handleMouseOver = (event) => {
    if (ignoreNonTouchEvents.current && event.type !== "touchstart") {
      return;
    }
    if (childNode) {
      childNode.removeAttribute("title");
    }
    enterTimer.clear();
    leaveTimer.clear();
    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, () => {
        handleOpen(event);
      });
    } else {
      handleOpen(event);
    }
  };
  const handleMouseLeave = (event) => {
    enterTimer.clear();
    leaveTimer.start(leaveDelay, () => {
      handleClose(event);
    });
  };
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [, setChildIsFocusVisible] = React$1.useState(false);
  const handleBlur = (event) => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleMouseLeave(event);
    }
  };
  const handleFocus = (event) => {
    if (!childNode) {
      setChildNode(event.currentTarget);
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleMouseOver(event);
    }
  };
  const detectTouchStart = (event) => {
    ignoreNonTouchEvents.current = true;
    const childrenProps2 = children2.props;
    if (childrenProps2.onTouchStart) {
      childrenProps2.onTouchStart(event);
    }
  };
  const handleTouchStart = (event) => {
    detectTouchStart(event);
    leaveTimer.clear();
    closeTimer.clear();
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect;
    document.body.style.WebkitUserSelect = "none";
    touchTimer.start(enterTouchDelay, () => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleMouseOver(event);
    });
  };
  const handleTouchEnd = (event) => {
    if (children2.props.onTouchEnd) {
      children2.props.onTouchEnd(event);
    }
    stopTouchInteraction();
    leaveTimer.start(leaveTouchDelay, () => {
      handleClose(event);
    });
  };
  React$1.useEffect(() => {
    if (!open) {
      return void 0;
    }
    function handleKeyDown2(nativeEvent) {
      if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") {
        handleClose(nativeEvent);
      }
    }
    document.addEventListener("keydown", handleKeyDown2);
    return () => {
      document.removeEventListener("keydown", handleKeyDown2);
    };
  }, [handleClose, open]);
  const handleRef = useForkRef(getReactElementRef(children2), focusVisibleRef, setChildNode, ref);
  if (!title && title !== 0) {
    open = false;
  }
  const popperRef = React$1.useRef();
  const handleMouseMove = (event) => {
    const childrenProps2 = children2.props;
    if (childrenProps2.onMouseMove) {
      childrenProps2.onMouseMove(event);
    }
    cursorPosition = {
      x: event.clientX,
      y: event.clientY
    };
    if (popperRef.current) {
      popperRef.current.update();
    }
  };
  const nameOrDescProps = {};
  const titleIsString = typeof title === "string";
  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps["aria-describedby"] = open ? id2 : null;
  } else {
    nameOrDescProps["aria-label"] = titleIsString ? title : null;
    nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id2 : null;
  }
  const childrenProps = _extends$o({}, nameOrDescProps, other, children2.props, {
    className: clsx(other.className, children2.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});
  const interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }
  const popperOptions = React$1.useMemo(() => {
    var _PopperProps$popperOp;
    let tooltipModifiers = [{
      name: "arrow",
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];
    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }
    return _extends$o({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);
  const ownerState = _extends$o({}, props, {
    isRtl,
    arrow: arrow2,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });
  const classes = useUtilityClasses(ownerState);
  const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
  const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : Grow$1;
  const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
  const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
  const popperProps = appendOwnerState(PopperComponent, _extends$o({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
    className: clsx(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
  }), ownerState);
  const transitionProps = appendOwnerState(TransitionComponent, _extends$o({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
  const tooltipProps = appendOwnerState(TooltipComponent, _extends$o({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
    className: clsx(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
  }), ownerState);
  const tooltipArrowProps = appendOwnerState(ArrowComponent, _extends$o({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
    className: clsx(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
  }), ownerState);
  return /* @__PURE__ */ jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ React$1.cloneElement(children2, childrenProps), /* @__PURE__ */ jsx$1(PopperComponent, _extends$o({
      as: PopperComponentProp != null ? PopperComponentProp : Popper$1,
      placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef,
      open: childNode ? open : false,
      id: id2,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => /* @__PURE__ */ jsx$1(TransitionComponent, _extends$o({
        timeout: theme.transitions.duration.shorter
      }, TransitionPropsInner, transitionProps, {
        children: /* @__PURE__ */ jsxs(TooltipComponent, _extends$o({}, tooltipProps, {
          children: [title, arrow2 ? /* @__PURE__ */ jsx$1(ArrowComponent, _extends$o({}, tooltipArrowProps, {
            ref: setArrowRef
          })) : null]
        }))
      }))
    }))]
  });
});
var Tooltip$2 = Tooltip$1;
function Legend({
  value,
  labelsArray,
  legendLabels,
  colorMap,
  theme,
  style: style2
}) {
  var _a, _b, _c, _d;
  const legendGlyphSize = 16;
  const defaultColour = (_b = (_a = theme == null ? void 0 : theme.palette) == null ? void 0 : _a.primary) == null ? void 0 : _b.main;
  const ordinalColorScale = createOrdinalScale$1({
    domain: labelsArray.map((key) => {
      var _a2;
      return (_a2 = legendLabels == null ? void 0 : legendLabels[key]) != null ? _a2 : key;
    }),
    range: labelsArray.map((key) => {
      var _a2;
      return (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour;
    })
  });
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return /* @__PURE__ */ jsxs("div", {
    className: "legend",
    style: {
      top: 20,
      width: value.main.legendDirection !== "column" || smallScreen ? "100%" : void 0,
      justifyContent: smallScreen ? "flex-start" : "center",
      display: "flex"
    },
    children: [/* @__PURE__ */ jsx$1("div", {
      className: "title",
      children: (_d = (_c = value.main) == null ? void 0 : _c.legend) == null ? void 0 : _d.legendTitle
    }), /* @__PURE__ */ jsx$1(Ordinal, {
      scale: ordinalColorScale,
      labelFormat: (label) => `${label}`,
      children: (labels) => /* @__PURE__ */ jsx$1("div", {
        style: {
          display: "flex",
          flexDirection: value.main.legendDirection === "column" && !smallScreen ? "column" : "row",
          columnGap: "5px",
          marginBottom: "1px",
          margin: smallScreen ? "auto" : void 0,
          paddingLeft: smallScreen ? "25px" : void 0,
          ...style2
        },
        children: labels.map((label, i) => {
          var _a2, _b2;
          return /* @__PURE__ */ jsxs(LegendItem, {
            margin: "0 5px",
            ...value.main.legendDirection === "column" && !smallScreen ? {
              style: {
                display: "flex",
                flexDirection: "row"
              }
            } : {},
            children: [/* @__PURE__ */ jsx$1("div", {
              style: {
                minWidth: smallScreen ? 20 : void 0
              },
              children: /* @__PURE__ */ jsx$1("svg", {
                width: legendGlyphSize,
                height: legendGlyphSize,
                children: /* @__PURE__ */ jsx$1("rect", {
                  fill: label.value,
                  width: legendGlyphSize,
                  height: legendGlyphSize,
                  rx: legendGlyphSize / 2,
                  ry: legendGlyphSize / 2
                })
              })
            }), /* @__PURE__ */ jsx$1(LegendLabel, {
              align: `${((_b2 = (_a2 = value.main) == null ? void 0 : _a2.legend) == null ? void 0 : _b2.align) || "left"}`,
              margin: "0 0 0 4px",
              style: {
                fontSize: "13px",
                marginLeft: "5px",
                color: label.value,
                marginBottom: smallScreen ? "5px" : void 0
              },
              children: label.text
            })]
          }, `legend-quantile-${i}`);
        })
      })
    })]
  });
}
var Line$1 = {};
Line$1.__esModule = true;
var _default$5 = Line$1.default = Line;
var _react$5 = _interopRequireDefault$a(React__default);
var _classnames$3 = _interopRequireDefault$a(classnames.exports);
var _excluded$d = ["from", "to", "fill", "className", "innerRef"];
function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$m() {
  _extends$m = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$m.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$d(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Line(_ref) {
  var _ref$from = _ref.from, from2 = _ref$from === void 0 ? {
    x: 0,
    y: 0
  } : _ref$from, _ref$to = _ref.to, to = _ref$to === void 0 ? {
    x: 1,
    y: 1
  } : _ref$to, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose$d(_ref, _excluded$d);
  var isRectilinear = from2.x === to.x || from2.y === to.y;
  return /* @__PURE__ */ _react$5.default.createElement("line", _extends$m({
    ref: innerRef,
    className: (0, _classnames$3.default)("visx-line", className),
    x1: from2.x,
    y1: from2.y,
    x2: to.x,
    y2: to.y,
    fill,
    shapeRendering: isRectilinear ? "crispEdges" : "auto"
  }, restProps));
}
function getScaleBandwidth$3(scale) {
  return "bandwidth" in scale ? scale.bandwidth() : 0;
}
var _excluded$c = ["top", "left", "scale", "width", "stroke", "strokeWidth", "strokeDasharray", "className", "children", "numTicks", "lineStyle", "offset", "tickValues"];
function _extends$l() {
  _extends$l = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$l.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$c(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function GridRows$1(_ref) {
  var _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, width2 = _ref.width, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, children2 = _ref.children, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset2 = _ref.offset, tickValues = _ref.tickValues, restProps = _objectWithoutPropertiesLoose$c(_ref, _excluded$c);
  var ticks2 = tickValues != null ? tickValues : getTicks(scale, numTicks);
  var scaleOffset = (offset2 != null ? offset2 : 0) + getScaleBandwidth$3(scale) / 2;
  var tickLines = ticks2.map(function(d2, index2) {
    var _coerceNumber;
    var y2 = ((_coerceNumber = coerceNumber(scale(d2))) != null ? _coerceNumber : 0) + scaleOffset;
    return {
      index: index2,
      from: new Point({
        x: 0,
        y: y2
      }),
      to: new Point({
        x: width2,
        y: y2
      })
    };
  });
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-rows", className),
    top: top2,
    left: left2
  }, children2 ? children2({
    lines: tickLines
  }) : tickLines.map(function(_ref2) {
    var from2 = _ref2.from, to = _ref2.to, index2 = _ref2.index;
    return /* @__PURE__ */ React__default.createElement(_default$5, _extends$l({
      key: "row-line-" + index2,
      from: from2,
      to,
      stroke,
      strokeWidth,
      strokeDasharray,
      style: lineStyle
    }, restProps));
  }));
}
GridRows$1.propTypes = {
  tickValues: _pt.array,
  width: _pt.number.isRequired
};
var _excluded$b = ["top", "left", "scale", "height", "stroke", "strokeWidth", "strokeDasharray", "className", "numTicks", "lineStyle", "offset", "tickValues", "children"];
function _extends$k() {
  _extends$k = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$k.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$b(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function GridColumns$1(_ref) {
  var _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, height2 = _ref.height, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset2 = _ref.offset, tickValues = _ref.tickValues, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$b(_ref, _excluded$b);
  var ticks2 = tickValues != null ? tickValues : getTicks(scale, numTicks);
  var scaleOffset = (offset2 != null ? offset2 : 0) + getScaleBandwidth$3(scale) / 2;
  var tickLines = ticks2.map(function(d2, index2) {
    var _coerceNumber;
    var x2 = ((_coerceNumber = coerceNumber(scale(d2))) != null ? _coerceNumber : 0) + scaleOffset;
    return {
      index: index2,
      from: new Point({
        x: x2,
        y: 0
      }),
      to: new Point({
        x: x2,
        y: height2
      })
    };
  });
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-columns", className),
    top: top2,
    left: left2
  }, children2 ? children2({
    lines: tickLines
  }) : tickLines.map(function(_ref2) {
    var from2 = _ref2.from, to = _ref2.to, index2 = _ref2.index;
    return /* @__PURE__ */ React__default.createElement(_default$5, _extends$k({
      key: "column-line-" + index2,
      from: from2,
      to,
      stroke,
      strokeWidth,
      strokeDasharray,
      style: lineStyle
    }, restProps));
  }));
}
GridColumns$1.propTypes = {
  tickValues: _pt.array,
  height: _pt.number.isRequired
};
var _excluded$a = ["top", "left", "xScale", "yScale", "width", "height", "className", "stroke", "strokeWidth", "strokeDasharray", "numTicksRows", "numTicksColumns", "rowLineStyle", "columnLineStyle", "xOffset", "yOffset", "rowTickValues", "columnTickValues"];
function _extends$j() {
  _extends$j = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$j.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function Grid$1(_ref) {
  var top2 = _ref.top, left2 = _ref.left, xScale = _ref.xScale, yScale = _ref.yScale, width2 = _ref.width, height2 = _ref.height, className = _ref.className, stroke = _ref.stroke, strokeWidth = _ref.strokeWidth, strokeDasharray = _ref.strokeDasharray, numTicksRows = _ref.numTicksRows, numTicksColumns = _ref.numTicksColumns, rowLineStyle = _ref.rowLineStyle, columnLineStyle = _ref.columnLineStyle, xOffset = _ref.xOffset, yOffset = _ref.yOffset, rowTickValues = _ref.rowTickValues, columnTickValues = _ref.columnTickValues, restProps = _objectWithoutPropertiesLoose$a(_ref, _excluded$a);
  return /* @__PURE__ */ React__default.createElement(Group, {
    className: cx("visx-grid", className),
    top: top2,
    left: left2
  }, /* @__PURE__ */ React__default.createElement(GridRows$1, _extends$j({
    className,
    scale: yScale,
    width: width2,
    stroke,
    strokeWidth,
    strokeDasharray,
    numTicks: numTicksRows,
    lineStyle: rowLineStyle,
    offset: yOffset,
    tickValues: rowTickValues
  }, restProps)), /* @__PURE__ */ React__default.createElement(GridColumns$1, _extends$j({
    className,
    scale: xScale,
    height: height2,
    stroke,
    strokeWidth,
    strokeDasharray,
    numTicks: numTicksColumns,
    lineStyle: columnLineStyle,
    offset: xOffset,
    tickValues: columnTickValues
  }, restProps)));
}
Grid$1.propTypes = {
  rowTickValues: _pt.array,
  columnTickValues: _pt.array
};
var D3ShapeFactories = {};
var require$$0$3 = /* @__PURE__ */ getAugmentedNamespace(src);
var setNumberOrNumberAccessor$1 = {};
setNumberOrNumberAccessor$1.__esModule = true;
setNumberOrNumberAccessor$1.default = setNumberOrNumberAccessor;
function setNumberOrNumberAccessor(func, value) {
  if (typeof value === "number")
    func(value);
  else
    func(value);
}
var stackOrder$1 = {};
stackOrder$1.__esModule = true;
stackOrder$1.STACK_ORDER_NAMES = stackOrder$1.STACK_ORDERS = void 0;
stackOrder$1.default = stackOrder;
var _d3Shape$2 = require$$0$3;
var STACK_ORDERS = {
  ascending: _d3Shape$2.stackOrderAscending,
  descending: _d3Shape$2.stackOrderDescending,
  insideout: _d3Shape$2.stackOrderInsideOut,
  none: _d3Shape$2.stackOrderNone,
  reverse: _d3Shape$2.stackOrderReverse
};
stackOrder$1.STACK_ORDERS = STACK_ORDERS;
var STACK_ORDER_NAMES = Object.keys(STACK_ORDERS);
stackOrder$1.STACK_ORDER_NAMES = STACK_ORDER_NAMES;
function stackOrder(order2) {
  return order2 && STACK_ORDERS[order2] || STACK_ORDERS.none;
}
var stackOffset$1 = {};
stackOffset$1.__esModule = true;
stackOffset$1.STACK_OFFSET_NAMES = stackOffset$1.STACK_OFFSETS = void 0;
stackOffset$1.default = stackOffset;
var _d3Shape$1 = require$$0$3;
var STACK_OFFSETS = {
  expand: _d3Shape$1.stackOffsetExpand,
  diverging: _d3Shape$1.stackOffsetDiverging,
  none: _d3Shape$1.stackOffsetNone,
  silhouette: _d3Shape$1.stackOffsetSilhouette,
  wiggle: _d3Shape$1.stackOffsetWiggle
};
stackOffset$1.STACK_OFFSETS = STACK_OFFSETS;
var STACK_OFFSET_NAMES = Object.keys(STACK_OFFSETS);
stackOffset$1.STACK_OFFSET_NAMES = STACK_OFFSET_NAMES;
function stackOffset(offset2) {
  return offset2 && STACK_OFFSETS[offset2] || STACK_OFFSETS.none;
}
D3ShapeFactories.__esModule = true;
D3ShapeFactories.arc = arc$1;
D3ShapeFactories.area = area$4;
D3ShapeFactories.line = line$1;
D3ShapeFactories.pie = pie$1;
D3ShapeFactories.radialLine = radialLine;
D3ShapeFactories.stack = stack$1;
var _d3Shape = require$$0$3;
var _setNumberOrNumberAccessor = _interopRequireDefault$9(setNumberOrNumberAccessor$1);
var _stackOrder = _interopRequireDefault$9(stackOrder$1);
var _stackOffset = _interopRequireDefault$9(stackOffset$1);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function arc$1(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, cornerRadius = _ref.cornerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, padAngle = _ref.padAngle, padRadius = _ref.padRadius;
  var path2 = (0, _d3Shape.arc)();
  if (innerRadius != null)
    (0, _setNumberOrNumberAccessor.default)(path2.innerRadius, innerRadius);
  if (outerRadius != null)
    (0, _setNumberOrNumberAccessor.default)(path2.outerRadius, outerRadius);
  if (cornerRadius != null)
    (0, _setNumberOrNumberAccessor.default)(path2.cornerRadius, cornerRadius);
  if (startAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.startAngle, startAngle);
  if (endAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.endAngle, endAngle);
  if (padAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.padAngle, padAngle);
  if (padRadius != null)
    (0, _setNumberOrNumberAccessor.default)(path2.padRadius, padRadius);
  return path2;
}
function area$4(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2, x2 = _ref2.x, x02 = _ref2.x0, x12 = _ref2.x1, y2 = _ref2.y, y02 = _ref2.y0, y12 = _ref2.y1, defined = _ref2.defined, curve = _ref2.curve;
  var path2 = (0, _d3Shape.area)();
  if (x2)
    (0, _setNumberOrNumberAccessor.default)(path2.x, x2);
  if (x02)
    (0, _setNumberOrNumberAccessor.default)(path2.x0, x02);
  if (x12)
    (0, _setNumberOrNumberAccessor.default)(path2.x1, x12);
  if (y2)
    (0, _setNumberOrNumberAccessor.default)(path2.y, y2);
  if (y02)
    (0, _setNumberOrNumberAccessor.default)(path2.y0, y02);
  if (y12)
    (0, _setNumberOrNumberAccessor.default)(path2.y1, y12);
  if (defined)
    path2.defined(defined);
  if (curve)
    path2.curve(curve);
  return path2;
}
function line$1(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3, x2 = _ref3.x, y2 = _ref3.y, defined = _ref3.defined, curve = _ref3.curve;
  var path2 = (0, _d3Shape.line)();
  if (x2)
    (0, _setNumberOrNumberAccessor.default)(path2.x, x2);
  if (y2)
    (0, _setNumberOrNumberAccessor.default)(path2.y, y2);
  if (defined)
    path2.defined(defined);
  if (curve)
    path2.curve(curve);
  return path2;
}
function pie$1(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4, startAngle = _ref4.startAngle, endAngle = _ref4.endAngle, padAngle = _ref4.padAngle, value = _ref4.value, sort2 = _ref4.sort, sortValues = _ref4.sortValues;
  var path2 = (0, _d3Shape.pie)();
  if (sort2 === null)
    path2.sort(sort2);
  else if (sort2 != null)
    path2.sort(sort2);
  if (sortValues === null)
    path2.sortValues(sortValues);
  else if (sortValues != null)
    path2.sortValues(sortValues);
  if (value != null)
    path2.value(value);
  if (padAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.padAngle, padAngle);
  if (startAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.startAngle, startAngle);
  if (endAngle != null)
    (0, _setNumberOrNumberAccessor.default)(path2.endAngle, endAngle);
  return path2;
}
function radialLine(_temp5) {
  var _ref5 = _temp5 === void 0 ? {} : _temp5, angle2 = _ref5.angle, radius = _ref5.radius, defined = _ref5.defined, curve = _ref5.curve;
  var path2 = (0, _d3Shape.radialLine)();
  if (angle2)
    (0, _setNumberOrNumberAccessor.default)(path2.angle, angle2);
  if (radius)
    (0, _setNumberOrNumberAccessor.default)(path2.radius, radius);
  if (defined)
    path2.defined(defined);
  if (curve)
    path2.curve(curve);
  return path2;
}
function stack$1(_ref6) {
  var keys2 = _ref6.keys, value = _ref6.value, order2 = _ref6.order, offset2 = _ref6.offset;
  var path2 = (0, _d3Shape.stack)();
  if (keys2)
    path2.keys(keys2);
  if (value)
    (0, _setNumberOrNumberAccessor.default)(path2.value, value);
  if (order2)
    path2.order((0, _stackOrder.default)(order2));
  if (offset2)
    path2.offset((0, _stackOffset.default)(offset2));
  return path2;
}
function DrawBarGraph({
  theme,
  width: width2,
  height: height2,
  margin: margin2,
  value
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const graphData = ((_b = (_a = value.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) ? value.main.data : [{}];
  const disableLeftLabel = (_c = value.main) == null ? void 0 : _c.disableLeftLabel;
  const xAxisValue = ((_d = value.main) == null ? void 0 : _d.xAxisValue) || "label";
  const labelsArray = Object.keys(graphData[0]).filter((d2) => d2 !== xAxisValue);
  const colorMap = (_e = value.style) == null ? void 0 : _e.colorMap;
  const legendLabels = (_f = value.main) == null ? void 0 : _f.legendLabels;
  const legendAvailable = (_h = (_g = value == null ? void 0 : value.main) == null ? void 0 : _g.legendAvailable) != null ? _h : true;
  const defaultColour = (_j = (_i = theme.myTheme.palette) == null ? void 0 : _i.primary) == null ? void 0 : _j.main;
  const [hoveredBar, setHoveredBar] = useState({});
  const getDataLabel = (d2) => d2[xAxisValue];
  const labelsValueSum = graphData.map((currentBar) => labelsArray.reduce((sum2, k2) => sum2 += Number(currentBar[k2]), 0));
  const horizontalScale = createBandScale({
    domain: graphData.map(getDataLabel),
    padding: 0.4
  });
  const horizontalSubScale = createBandScale({
    domain: labelsArray
  });
  const verticalScale = createLinearScale({
    domain: value.main.type === "StackBarGraph" ? [0, Math.max(...labelsValueSum)] : [0, Math.max(...graphData.flatMap((d2) => labelsArray.map((key) => Number(d2[key]))))],
    nice: true
  });
  const colorScale = createOrdinalScale$1({
    domain: labelsArray,
    range: labelsArray.map((key) => {
      var _a2;
      return (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour;
    })
  });
  const maxHorizontalSpace = width2 - margin2.left - margin2.right;
  const maxVerticalSpace = height2 - margin2.top - margin2.bottom;
  horizontalScale.rangeRound([0, maxHorizontalSpace]);
  horizontalSubScale.rangeRound([0, horizontalScale.bandwidth()]);
  verticalScale.range([maxVerticalSpace, 0]);
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const handleMouseIn = (event, bar, barGroup) => {
    setHoveredBar({
      bar: barGroup,
      subBarIndex: bar.index
    });
    showTooltip({
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
      tooltipData: {
        barData: graphData[barGroup.index],
        hoveredSubBar: bar
      }
    });
  };
  const handleMouseOut = (event) => {
    setHoveredBar({
      bar: null,
      subBarIndex: null
    });
    hideTooltip();
  };
  const stackhHandleMouseIn = (event, bar, barGroup) => {
    setHoveredBar({
      bar: barGroup,
      subBarIndex: bar.index
    });
    showTooltip({
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
      tooltipData: {
        barData: graphData[bar.index],
        hoveredSubBar: bar
      }
    });
  };
  function calcWidthofBar(bar) {
    return bar == null ? void 0 : bar.bars.reduce((totalWidth, subBar) => totalWidth + Math.min(subBar.width, 15), 0);
  }
  function calcPositionofBar(bar, subBar, graphType) {
    var _a2, _b2, _c2;
    const actualBarWidth = Math.min(subBar == null ? void 0 : subBar.width, 15);
    if (graphType === "stack") {
      return (subBar == null ? void 0 : subBar.x) - (actualBarWidth - (subBar == null ? void 0 : subBar.width)) / 2;
    }
    if (graphType === "grouphov") {
      return (bar == null ? void 0 : bar.x0) + ((subBar == null ? void 0 : subBar.width) - actualBarWidth) * ((_a2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _a2.length) / 2;
    }
    if ((subBar == null ? void 0 : subBar.index) === 0) {
      return (subBar == null ? void 0 : subBar.x) + ((subBar == null ? void 0 : subBar.width) - actualBarWidth) * ((_b2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _b2.length) / 2;
    }
    return (subBar == null ? void 0 : subBar.x) - ((subBar == null ? void 0 : subBar.width) - actualBarWidth) * ((subBar == null ? void 0 : subBar.index) - ((_c2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _c2.length) / 2);
  }
  return width2 < 10 ? null : /* @__PURE__ */ jsx$1("div", {
    style: {
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      ...value == null ? void 0 : value.style
    },
    children: /* @__PURE__ */ jsxs("div", {
      style: {
        minWidth: `${width2}px`,
        width: `${width2}px`
      },
      children: [legendAvailable && labelsArray.length > 1 && /* @__PURE__ */ jsx$1(Legend, {
        labelsArray,
        legendLabels,
        colorMap,
        value,
        theme: theme.myTheme
      }), /* @__PURE__ */ jsxs("svg", {
        width: width2,
        height: height2,
        children: [/* @__PURE__ */ jsx$1("rect", {
          x: 0,
          y: 0,
          width: width2,
          height: height2,
          fill: theme.myTheme.palette.background.default
        }), /* @__PURE__ */ jsx$1(Grid$1, {
          top: margin2.top,
          left: margin2.left,
          xScale: horizontalScale,
          yScale: verticalScale,
          width: width2 - margin2.left - margin2.right,
          height: maxVerticalSpace,
          stroke: "black",
          xOffset: horizontalScale.bandwidth() / 50,
          strokeDasharray: "8 3",
          strokeOpacity: 0.2,
          strokeWidth: 0.3
        }), /* @__PURE__ */ jsxs(Group, {
          top: margin2.top,
          left: margin2.left,
          children: [hoveredBar && /* @__PURE__ */ jsx$1("rect", {
            style: {
              display: hoveredBar.bar ? "block" : "none"
            },
            x: value.main.type === "StackBarGraph" ? calcPositionofBar(hoveredBar.bar, (_k = hoveredBar.bar) == null ? void 0 : _k.bars[hoveredBar.subBarIndex], "stack") : calcPositionofBar(hoveredBar.bar, (_l = hoveredBar.bar) == null ? void 0 : _l.bars[hoveredBar.subBarIndex], "grouphov"),
            width: value.main.type !== "StackBarGraph" ? calcWidthofBar(hoveredBar.bar) : Math.min((_m = hoveredBar.bar) == null ? void 0 : _m.bars[0].width, 15),
            height: maxVerticalSpace,
            fill: theme.myTheme.palette.secondary.main,
            opacity: 1
          }), /* @__PURE__ */ jsx$1(LeftAxis, {
            value: {
              ...value,
              main: {
                ...value.main,
                leftLabel: !disableLeftLabel ? value.main.leftLabel : void 0
              }
            },
            yScale: verticalScale,
            parentWidth: width2,
            theme,
            leftMargin: margin2.left
          }), value.main.type === "StackBarGraph" ? /* @__PURE__ */ jsx$1(BarStack, {
            data: graphData,
            keys: labelsArray,
            x: getDataLabel,
            xScale: horizontalScale,
            yScale: verticalScale,
            color: colorScale,
            children: (barStacks) => barStacks.map((barStack) => barStack.bars.map((bar) => /* @__PURE__ */ jsx$1("rect", {
              x: calcPositionofBar(barStack, bar, "stack"),
              y: bar.y,
              height: bar.height,
              width: Math.min(bar.width, 15),
              fill: bar.color,
              onMouseOver: (e3) => stackhHandleMouseIn(e3, bar, barStack),
              onMouseOut: (e3) => handleMouseOut(),
              stroke: hoveredBar.subBarIndex === bar.index ? "black" : "transparent"
            }, `bar-stack-${barStack.index}-${bar.index}`)))
          }) : /* @__PURE__ */ jsx$1(BarGroup, {
            data: graphData,
            keys: labelsArray,
            height: maxVerticalSpace,
            x0: getDataLabel,
            x0Scale: horizontalScale,
            x1Scale: horizontalSubScale,
            yScale: verticalScale,
            color: (key, index2) => {
              return (hoveredBar == null ? void 0 : hoveredBar.subBarIndex) == null || (hoveredBar == null ? void 0 : hoveredBar.subBarIndex) === index2 ? colorScale(key) : `${colorScale(key)}50`;
            },
            children: (barGroups) => barGroups.map((barGroup) => /* @__PURE__ */ jsx$1(Group, {
              left: barGroup.x0,
              children: barGroup.bars.map((bar) => {
                return /* @__PURE__ */ jsx$1("rect", {
                  x: calcPositionofBar(barGroup, bar, "group"),
                  y: bar.y,
                  width: Math.min(bar.width, 15),
                  height: bar.height,
                  fill: bar.color,
                  onMouseOver: (e3) => handleMouseIn(e3, bar, barGroup),
                  onMouseOut: (e3) => handleMouseOut(),
                  stroke: hoveredBar.subBarIndex === bar.index ? "black" : "transparent"
                }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.value}-${bar.key}`);
              })
            }, `bar-group-${barGroup.index}-${barGroup.x0}`))
          })]
        }), /* @__PURE__ */ jsx$1(BottomAxis, {
          yMax: maxVerticalSpace + margin2.top,
          value,
          left: margin2.left,
          xScale: horizontalScale,
          parentWidth: width2,
          theme
        })]
      }), tooltipOpen && /* @__PURE__ */ jsx$1(ToolTip, {
        value,
        theme,
        top: tooltipTop,
        left: tooltipLeft,
        tooltipData,
        colorScale
      })]
    })
  });
}
var root$4 = _root;
var now$2 = function() {
  return root$4.Date.now();
};
var now_1 = now$2;
var reWhitespace$1 = /\s/;
function trimmedEndIndex$2(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace$1.test(string2.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$2;
var trimmedEndIndex$1 = _trimmedEndIndex;
var reTrimStart$1 = /^\s+/;
function baseTrim$2(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex$1(string2) + 1).replace(reTrimStart$1, "") : string2;
}
var _baseTrim = baseTrim$2;
function isObjectLike$2(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$2;
var baseGetTag$1 = _baseGetTag, isObjectLike$1 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$2(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$2;
var baseTrim$1 = _baseTrim, isObject$2 = isObject_1, isSymbol$1 = isSymbol_1;
var NAN$1 = 0 / 0;
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary$1 = /^0b[01]+$/i;
var reIsOctal$1 = /^0o[0-7]+$/i;
var freeParseInt$1 = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim$1(value);
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
var toNumber_1 = toNumber$2;
var isObject$1 = isObject_1, now$1 = now_1, toNumber$1 = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin$1 = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$1();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time2 = now$1(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
var debounce$1 = debounce_1;
function _extends$i() {
  _extends$i = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$i.apply(this, arguments);
}
var defaultIgnoreDimensions$1 = [];
var defaultInitialSize$1 = {
  width: 0,
  height: 0,
  top: 0,
  left: 0
};
function useParentSize$2(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$initialSize = _ref.initialSize, initialSize = _ref$initialSize === void 0 ? defaultInitialSize$1 : _ref$initialSize, _ref$debounceTime = _ref.debounceTime, debounceTime = _ref$debounceTime === void 0 ? 300 : _ref$debounceTime, _ref$ignoreDimensions = _ref.ignoreDimensions, ignoreDimensions = _ref$ignoreDimensions === void 0 ? defaultIgnoreDimensions$1 : _ref$ignoreDimensions, _ref$enableDebounceLe = _ref.enableDebounceLeadingCall, enableDebounceLeadingCall = _ref$enableDebounceLe === void 0 ? true : _ref$enableDebounceLe, resizeObserverPolyfill = _ref.resizeObserverPolyfill;
  var parentRef = useRef(null);
  var animationFrameID = useRef(0);
  var _useState = useState(_extends$i({}, defaultInitialSize$1, initialSize)), state = _useState[0], setState = _useState[1];
  var resize = useMemo(function() {
    var normalized = Array.isArray(ignoreDimensions) ? ignoreDimensions : [ignoreDimensions];
    return debounce$1(function(incoming) {
      setState(function(existing) {
        var stateKeys = Object.keys(existing);
        var keysWithChanges = stateKeys.filter(function(key) {
          return existing[key] !== incoming[key];
        });
        var shouldBail = keysWithChanges.every(function(key) {
          return normalized.includes(key);
        });
        return shouldBail ? existing : incoming;
      });
    }, debounceTime, {
      leading: enableDebounceLeadingCall
    });
  }, [debounceTime, enableDebounceLeadingCall, ignoreDimensions]);
  useEffect(function() {
    var LocalResizeObserver = resizeObserverPolyfill || window.ResizeObserver;
    var observer = new LocalResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        var _entry$contentRect;
        var _ref2 = (_entry$contentRect = entry == null ? void 0 : entry.contentRect) != null ? _entry$contentRect : {}, left2 = _ref2.left, top2 = _ref2.top, width2 = _ref2.width, height2 = _ref2.height;
        animationFrameID.current = window.requestAnimationFrame(function() {
          resize({
            width: width2,
            height: height2,
            top: top2,
            left: left2
          });
        });
      });
    });
    if (parentRef.current)
      observer.observe(parentRef.current);
    return function() {
      window.cancelAnimationFrame(animationFrameID.current);
      observer.disconnect();
      resize.cancel();
    };
  }, [resize, resizeObserverPolyfill]);
  return _extends$i({
    parentRef,
    resize
  }, state);
}
var _excluded$9 = ["className", "children", "debounceTime", "ignoreDimensions", "initialSize", "parentSizeStyles", "enableDebounceLeadingCall", "resizeObserverPolyfill"], _excluded2$2 = ["parentRef", "resize"];
function _extends$h() {
  _extends$h = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$h.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var defaultParentSizeStyles$1 = {
  width: "100%",
  height: "100%"
};
function ParentSize$1(_ref) {
  var className = _ref.className, children2 = _ref.children, debounceTime = _ref.debounceTime, ignoreDimensions = _ref.ignoreDimensions, initialSize = _ref.initialSize, _ref$parentSizeStyles = _ref.parentSizeStyles, parentSizeStyles = _ref$parentSizeStyles === void 0 ? defaultParentSizeStyles$1 : _ref$parentSizeStyles, _ref$enableDebounceLe = _ref.enableDebounceLeadingCall, enableDebounceLeadingCall = _ref$enableDebounceLe === void 0 ? true : _ref$enableDebounceLe, resizeObserverPolyfill = _ref.resizeObserverPolyfill, restProps = _objectWithoutPropertiesLoose$9(_ref, _excluded$9);
  var _useParentSize = useParentSize$2({
    initialSize,
    debounceTime,
    ignoreDimensions,
    enableDebounceLeadingCall,
    resizeObserverPolyfill
  }), parentRef = _useParentSize.parentRef, resize = _useParentSize.resize, dimensions = _objectWithoutPropertiesLoose$9(_useParentSize, _excluded2$2);
  return /* @__PURE__ */ React__default.createElement("div", _extends$h({
    style: parentSizeStyles,
    ref: parentRef,
    className
  }, restProps), children2(_extends$h({}, dimensions, {
    ref: parentRef.current,
    resize
  })));
}
ParentSize$1.propTypes = {
  className: _pt.string,
  children: _pt.func.isRequired
};
const BarGraph = ({
  value,
  theme
}) => {
  var _a, _b;
  const GraphRender = /* @__PURE__ */ jsx$1(ParentSize$1, {
    children: (parent) => {
      var _a2, _b2, _c, _d, _e, _f;
      return /* @__PURE__ */ jsx$1(DrawBarGraph, {
        theme,
        width: Math.max(parent.width, 500),
        height: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || "300")),
        margin: {
          top: 10,
          right: 10,
          bottom: ((_c = value.main) == null ? void 0 : _c.bottomAxisAngle) ? 90 : 40,
          left: ((_f = (_e = (_d = value.style) == null ? void 0 : _d.labelStyle) == null ? void 0 : _e.margin) == null ? void 0 : _f.left) || 60
        },
        value
      });
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_b = value.main) == null ? void 0 : _b.header
    }), GraphRender]
  });
};
const DrawPieGraph = ({
  theme,
  value,
  parentWidth,
  parentHeight
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const {
    TooltipInPortal
  } = useTooltipInPortal({
    detectBounds: true,
    scroll: true
  });
  const smallScreen = useMediaQuery(theme.myTheme.breakpoints.down("md"));
  const [active2, setActive] = useState(null);
  const pieData = ((_b = (_a = value.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) > 0 ? value.main.data : [{
    label: "No Data",
    value: 100
  }];
  const legendAvailable = (_d = (_c = value == null ? void 0 : value.main) == null ? void 0 : _c.legendAvailable) != null ? _d : true;
  const xAxisValue = ((_e = value.main) == null ? void 0 : _e.xAxisValue) || "label";
  const keyLabel = value.main.xAxisValue || Object.keys(pieData[0])[0];
  const valueLabel = value.main.yAxisValue || Object.keys(pieData[0])[1];
  const getValue2 = (d2) => d2[valueLabel];
  const dataKeyArray = pieData.map((data) => data[keyLabel]);
  const colorMap = (_f = value.style) == null ? void 0 : _f.colorMap;
  const defaultColour = (_h = (_g = theme.myTheme.palette) == null ? void 0 : _g.primary) == null ? void 0 : _h.main;
  const legendLabels = (_i = value.main) == null ? void 0 : _i.legendLabels;
  const outerRadius = 117;
  const innerRadius = 63;
  const getPieColor = createOrdinalScale$1({
    domain: pieData.map((l2) => l2[keyLabel]),
    range: dataKeyArray.map((key) => {
      var _a2;
      return (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour;
    })
  });
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const handleMouse = (event, datum2) => {
    setActive(datum2);
    const currKey = datum2[keyLabel] + "";
    const currVal = datum2[valueLabel] + "";
    showTooltip({
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
      tooltipData: {
        [currKey]: currVal
      }
    });
  };
  const innerWidth = smallScreen ? parentWidth : 0.7 * parentWidth;
  const innerHeight = parentHeight;
  const centerX = innerWidth / 2;
  const centerY = innerHeight / 2;
  const pieSortValues = (a2, b10) => a2 - b10;
  return parentWidth < 10 ? null : /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        ...value == null ? void 0 : value.style,
        flexDirection: smallScreen || value.main.legendDirection === "row" ? "column" : "row"
      },
      children: [/* @__PURE__ */ jsx$1("svg", {
        width: smallScreen ? parentWidth : 0.7 * parentWidth,
        height: parentHeight,
        className: "pieGraphContainer",
        children: /* @__PURE__ */ jsxs(Group, {
          top: centerY + 5,
          left: centerX,
          children: [/* @__PURE__ */ jsx$1(Pie, {
            data: pieData,
            pieValue: getValue2,
            pieSortValues,
            outerRadius: innerRadius - 5,
            innerRadius: innerRadius - 10,
            padAngle: 0.05,
            children: (pie2) => {
              return pie2.arcs.map((arc2, index2) => {
                return /* @__PURE__ */ jsx$1("g", {
                  children: /* @__PURE__ */ jsx$1("path", {
                    d: pie2.path(arc2),
                    fill: getPieColor(arc2.data[keyLabel])
                  })
                }, `arc-${arc2.data[keyLabel]}-${index2}`);
              });
            }
          }), /* @__PURE__ */ jsx$1(Pie, {
            data: pieData,
            pieSortValues,
            pieValue: getValue2,
            outerRadius: ({
              data
            }) => {
              const size = active2 && active2[xAxisValue] == data[xAxisValue] ? outerRadius + 3 : outerRadius;
              return size;
            },
            innerRadius,
            cornerRadius: 2,
            children: (pie2) => {
              return pie2.arcs.map((arc2, index2) => {
                return /* @__PURE__ */ jsx$1("g", {
                  onMouseOut: hideTooltip,
                  onMouseLeave: () => setActive(null),
                  onMouseOver: (e3) => handleMouse(e3, arc2.data),
                  className: "pieTooltipHolder",
                  children: /* @__PURE__ */ jsx$1("path", {
                    d: pie2.path(arc2),
                    fill: getPieColor(arc2.data[keyLabel])
                  })
                }, `arc-${arc2.data[keyLabel]}-${index2}`);
              });
            }
          })]
        })
      }), tooltipOpen && /* @__PURE__ */ jsx$1(TooltipInPortal, {
        style: {
          ...defaultStyles,
          backgroundColor: theme.myTheme.palette.secondary.main
        },
        top: tooltipTop,
        left: tooltipLeft,
        children: Object.keys(tooltipData).map((bar) => /* @__PURE__ */ jsxs("div", {
          style: {
            display: "flex",
            marginBottom: "2.5px",
            marginTop: "2.5px"
          },
          children: [/* @__PURE__ */ jsx$1("span", {
            style: {
              backgroundColor: getPieColor(bar),
              width: "15px",
              height: "15px",
              marginRight: "5px"
            }
          }), /* @__PURE__ */ jsx$1("span", {
            style: {
              marginRight: "5px"
            },
            children: /* @__PURE__ */ jsxs("strong", {
              style: {
                color: "black"
              },
              children: [bar, ": "]
            })
          }), /* @__PURE__ */ jsx$1("span", {
            style: {
              color: "black"
            },
            children: tooltipData[bar]
          })]
        }))
      }, Math.random()), legendAvailable && (smallScreen || value.main.legendDirection === "row") && /* @__PURE__ */ jsx$1(Legend, {
        labelsArray: dataKeyArray,
        legendLabels,
        colorMap,
        value,
        theme: theme.myTheme,
        style: {
          flexWrap: "wrap",
          paddingLeft: "0px"
        }
      }), /* @__PURE__ */ jsx$1("div", {
        style: {
          display: smallScreen || value.main.legendDirection === "row" ? "none" : "flex"
        },
        children: legendAvailable && /* @__PURE__ */ jsx$1(Legend, {
          labelsArray: dataKeyArray,
          legendLabels,
          colorMap,
          value,
          theme: theme.myTheme
        })
      })]
    })
  });
};
const PieGraph = ({
  value,
  theme
}) => {
  var _a, _b;
  const PieRender = /* @__PURE__ */ jsx$1(ParentSize$1, {
    children: (parent) => {
      var _a2, _b2;
      return /* @__PURE__ */ jsx$1(DrawPieGraph, {
        theme,
        parentWidth: parent.width,
        parentHeight: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || "300")),
        parentRef: parent.ref,
        resizeParent: parent.resize,
        value
      });
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_b = value.main) == null ? void 0 : _b.header
    }), PieRender]
  });
};
var require$$5$1 = /* @__PURE__ */ getAugmentedNamespace(esm);
function isElement(elem) {
  return !!elem && elem instanceof Element;
}
function isSVGElement(elem) {
  return !!elem && (elem instanceof SVGElement || "ownerSVGElement" in elem);
}
function isSVGSVGElement(elem) {
  return !!elem && "createSVGPoint" in elem;
}
function isSVGGraphicsElement(elem) {
  return !!elem && "getScreenCTM" in elem;
}
function isTouchEvent(event) {
  return !!event && "changedTouches" in event;
}
function isMouseEvent(event) {
  return !!event && "clientX" in event;
}
function isEvent(event) {
  return !!event && (event instanceof Event || "nativeEvent" in event && event.nativeEvent instanceof Event);
}
function _extends$g() {
  _extends$g = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$g.apply(this, arguments);
}
var DEFAULT_POINT = {
  x: 0,
  y: 0
};
function getXAndYFromEvent(event) {
  if (!event)
    return _extends$g({}, DEFAULT_POINT);
  if (isTouchEvent(event)) {
    return event.changedTouches.length > 0 ? {
      x: event.changedTouches[0].clientX,
      y: event.changedTouches[0].clientY
    } : _extends$g({}, DEFAULT_POINT);
  }
  if (isMouseEvent(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  var target = event == null ? void 0 : event.target;
  var boundingClientRect = target && "getBoundingClientRect" in target ? target.getBoundingClientRect() : null;
  if (!boundingClientRect)
    return _extends$g({}, DEFAULT_POINT);
  return {
    x: boundingClientRect.x + boundingClientRect.width / 2,
    y: boundingClientRect.y + boundingClientRect.height / 2
  };
}
function localPoint$1(node2, event) {
  if (!node2 || !event)
    return null;
  var coords = getXAndYFromEvent(event);
  var svg2 = isSVGElement(node2) ? node2.ownerSVGElement : node2;
  var screenCTM = isSVGGraphicsElement(svg2) ? svg2.getScreenCTM() : null;
  if (isSVGSVGElement(svg2) && screenCTM) {
    var point2 = svg2.createSVGPoint();
    point2.x = coords.x;
    point2.y = coords.y;
    point2 = point2.matrixTransform(screenCTM.inverse());
    return new Point({
      x: point2.x,
      y: point2.y
    });
  }
  var rect = node2.getBoundingClientRect();
  return new Point({
    x: coords.x - rect.left - node2.clientLeft,
    y: coords.y - rect.top - node2.clientTop
  });
}
function localPoint(nodeOrEvent, maybeEvent) {
  if (isElement(nodeOrEvent) && maybeEvent) {
    return localPoint$1(nodeOrEvent, maybeEvent);
  }
  if (isEvent(nodeOrEvent)) {
    var event = nodeOrEvent;
    var node2 = event.target;
    if (node2)
      return localPoint$1(node2, event);
  }
  return null;
}
var DataContext = /* @__PURE__ */ React__default.createContext({});
var DataContext$1 = DataContext;
function getScaleBandwidth$2(scale) {
  var _s$bandwidth;
  var s2 = scale;
  return s2 && "bandwidth" in s2 ? (_s$bandwidth = s2 == null ? void 0 : s2.bandwidth()) != null ? _s$bandwidth : 0 : 0;
}
function isValidNumber(_2) {
  return _2 != null && typeof _2 === "number" && !Number.isNaN(_2) && Number.isFinite(_2);
}
var require$$4 = /* @__PURE__ */ getAugmentedNamespace(esm$2);
var require$$6$1 = /* @__PURE__ */ getAugmentedNamespace(esm$1);
var _excluded$8 = ["AxisComponent"];
function _extends$f() {
  _extends$f = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$f.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BaseAxis(_ref) {
  var _margin$bottom, _margin$top, _margin$left, _margin$right, _axisStyles$axisLine, _axisStyles$axisLine2, _axisStyles$tickLine;
  var AxisComponent = _ref.AxisComponent, props = _objectWithoutPropertiesLoose$8(_ref, _excluded$8);
  var _useContext = useContext(DataContext$1), theme = _useContext.theme, xScale = _useContext.xScale, yScale = _useContext.yScale, margin2 = _useContext.margin, width2 = _useContext.width, height2 = _useContext.height;
  var orientation = props.orientation;
  var axisStyles = useMemo(function() {
    var _theme$axisStyles, _theme$axisStyles$y, _theme$axisStyles2, _theme$axisStyles2$x;
    return orientation === "left" || orientation === "right" ? theme == null ? void 0 : (_theme$axisStyles = theme.axisStyles) == null ? void 0 : (_theme$axisStyles$y = _theme$axisStyles.y) == null ? void 0 : _theme$axisStyles$y[orientation] : theme == null ? void 0 : (_theme$axisStyles2 = theme.axisStyles) == null ? void 0 : (_theme$axisStyles2$x = _theme$axisStyles2.x) == null ? void 0 : _theme$axisStyles2$x[orientation];
  }, [theme, orientation]);
  var maybeTickLabelProps = props.tickLabelProps;
  var tickLabelProps = useMemo(function() {
    return maybeTickLabelProps || axisStyles ? function(value, index2, values2) {
      return _extends$f({}, axisStyles == null ? void 0 : axisStyles.tickLabel, {
        width: orientation === "left" || orientation === "right" ? margin2 == null ? void 0 : margin2[orientation] : void 0
      }, typeof maybeTickLabelProps === "function" ? maybeTickLabelProps(value, index2, values2) : maybeTickLabelProps);
    } : void 0;
  }, [maybeTickLabelProps, axisStyles, orientation, margin2]);
  var topOffset = orientation === "bottom" ? (height2 != null ? height2 : 0) - ((_margin$bottom = margin2 == null ? void 0 : margin2.bottom) != null ? _margin$bottom : 0) : orientation === "top" ? (_margin$top = margin2 == null ? void 0 : margin2.top) != null ? _margin$top : 0 : 0;
  var leftOffset = orientation === "left" ? (_margin$left = margin2 == null ? void 0 : margin2.left) != null ? _margin$left : 0 : orientation === "right" ? (width2 != null ? width2 : 0) - ((_margin$right = margin2 == null ? void 0 : margin2.right) != null ? _margin$right : 0) : 0;
  var scale = orientation === "left" || orientation === "right" ? yScale : xScale;
  return scale ? /* @__PURE__ */ jsx$1(AxisComponent, {
    top: topOffset,
    left: leftOffset,
    labelProps: axisStyles == null ? void 0 : axisStyles.axisLabel,
    stroke: axisStyles == null ? void 0 : (_axisStyles$axisLine = axisStyles.axisLine) == null ? void 0 : _axisStyles$axisLine.stroke,
    strokeWidth: axisStyles == null ? void 0 : (_axisStyles$axisLine2 = axisStyles.axisLine) == null ? void 0 : _axisStyles$axisLine2.strokeWidth,
    tickLength: axisStyles == null ? void 0 : axisStyles.tickLength,
    tickStroke: axisStyles == null ? void 0 : (_axisStyles$tickLine = axisStyles.tickLine) == null ? void 0 : _axisStyles$tickLine.stroke,
    ...props,
    tickLabelProps,
    scale
  }) : null;
}
var getScaleBandwidth$1 = {};
getScaleBandwidth$1.__esModule = true;
getScaleBandwidth$1.default = getScaleBandwidth;
function getScaleBandwidth(scale) {
  return "bandwidth" in scale ? scale.bandwidth() : 0;
}
var _default$4 = GridRows;
var _propTypes$2 = _interopRequireDefault$8(propTypes.exports);
var _react$4 = _interopRequireDefault$8(React__default);
var _classnames$2 = _interopRequireDefault$8(classnames.exports);
var _Line$1 = _interopRequireDefault$8(Line$1);
var _group$1 = require$$4;
var _point$1 = require$$5$1;
var _scale$1 = require$$6$1;
var _getScaleBandwidth$1 = _interopRequireDefault$8(getScaleBandwidth$1);
var _excluded$7 = ["top", "left", "scale", "width", "stroke", "strokeWidth", "strokeDasharray", "className", "children", "numTicks", "lineStyle", "offset", "tickValues"];
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$e() {
  _extends$e = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$e.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function GridRows(_ref) {
  var _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, width2 = _ref.width, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, children2 = _ref.children, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset2 = _ref.offset, tickValues = _ref.tickValues, restProps = _objectWithoutPropertiesLoose$7(_ref, _excluded$7);
  var ticks2 = tickValues != null ? tickValues : (0, _scale$1.getTicks)(scale, numTicks);
  var scaleOffset = (offset2 != null ? offset2 : 0) + (0, _getScaleBandwidth$1.default)(scale) / 2;
  var tickLines = ticks2.map(function(d2, index2) {
    var _coerceNumber;
    var y2 = ((_coerceNumber = (0, _scale$1.coerceNumber)(scale(d2))) != null ? _coerceNumber : 0) + scaleOffset;
    return {
      index: index2,
      from: new _point$1.Point({
        x: 0,
        y: y2
      }),
      to: new _point$1.Point({
        x: width2,
        y: y2
      })
    };
  });
  return /* @__PURE__ */ _react$4.default.createElement(_group$1.Group, {
    className: (0, _classnames$2.default)("visx-rows", className),
    top: top2,
    left: left2
  }, children2 ? children2({
    lines: tickLines
  }) : tickLines.map(function(_ref2) {
    var from2 = _ref2.from, to = _ref2.to, index2 = _ref2.index;
    return /* @__PURE__ */ _react$4.default.createElement(_Line$1.default, _extends$e({
      key: "row-line-" + index2,
      from: from2,
      to,
      stroke,
      strokeWidth,
      strokeDasharray,
      style: lineStyle
    }, restProps));
  }));
}
GridRows.propTypes = {
  tickValues: _propTypes$2.default.array,
  width: _propTypes$2.default.number.isRequired
};
var _default$3 = GridColumns;
var _propTypes$1 = _interopRequireDefault$7(propTypes.exports);
var _react$3 = _interopRequireDefault$7(React__default);
var _classnames$1 = _interopRequireDefault$7(classnames.exports);
var _Line = _interopRequireDefault$7(Line$1);
var _group = require$$4;
var _point = require$$5$1;
var _scale = require$$6$1;
var _getScaleBandwidth = _interopRequireDefault$7(getScaleBandwidth$1);
var _excluded$6 = ["top", "left", "scale", "height", "stroke", "strokeWidth", "strokeDasharray", "className", "numTicks", "lineStyle", "offset", "tickValues", "children"];
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$d.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function GridColumns(_ref) {
  var _ref$top = _ref.top, top2 = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left2 = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, height2 = _ref.height, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset2 = _ref.offset, tickValues = _ref.tickValues, children2 = _ref.children, restProps = _objectWithoutPropertiesLoose$6(_ref, _excluded$6);
  var ticks2 = tickValues != null ? tickValues : (0, _scale.getTicks)(scale, numTicks);
  var scaleOffset = (offset2 != null ? offset2 : 0) + (0, _getScaleBandwidth.default)(scale) / 2;
  var tickLines = ticks2.map(function(d2, index2) {
    var _coerceNumber;
    var x2 = ((_coerceNumber = (0, _scale.coerceNumber)(scale(d2))) != null ? _coerceNumber : 0) + scaleOffset;
    return {
      index: index2,
      from: new _point.Point({
        x: x2,
        y: 0
      }),
      to: new _point.Point({
        x: x2,
        y: height2
      })
    };
  });
  return /* @__PURE__ */ _react$3.default.createElement(_group.Group, {
    className: (0, _classnames$1.default)("visx-columns", className),
    top: top2,
    left: left2
  }, children2 ? children2({
    lines: tickLines
  }) : tickLines.map(function(_ref2) {
    var from2 = _ref2.from, to = _ref2.to, index2 = _ref2.index;
    return /* @__PURE__ */ _react$3.default.createElement(_Line.default, _extends$d({
      key: "column-line-" + index2,
      from: from2,
      to,
      stroke,
      strokeWidth,
      strokeDasharray,
      style: lineStyle
    }, restProps));
  }));
}
GridColumns.propTypes = {
  tickValues: _propTypes$1.default.array,
  height: _propTypes$1.default.number.isRequired
};
var _excluded$5 = ["rows", "columns", "GridRowsComponent", "GridColumnsComponent"];
function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BaseGrid(_ref) {
  var _ref$rows = _ref.rows, rows = _ref$rows === void 0 ? true : _ref$rows, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? true : _ref$columns, GridRowsComponent = _ref.GridRowsComponent, GridColumnsComponent = _ref.GridColumnsComponent, props = _objectWithoutPropertiesLoose$5(_ref, _excluded$5);
  var _useContext = useContext(DataContext$1), theme = _useContext.theme, columnsScale = _useContext.xScale, rowsScale = _useContext.yScale, margin2 = _useContext.margin, innerWidth = _useContext.innerWidth, innerHeight = _useContext.innerHeight;
  var gridLineStyles = theme == null ? void 0 : theme.gridStyles;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [rows && rowsScale && innerWidth != null && /* @__PURE__ */ jsx$1(GridRowsComponent, {
      left: margin2 == null ? void 0 : margin2.left,
      lineStyle: gridLineStyles,
      width: innerWidth,
      scale: rowsScale,
      ...props
    }), columns && columnsScale && innerHeight != null && /* @__PURE__ */ jsx$1(GridColumnsComponent, {
      top: margin2 == null ? void 0 : margin2.top,
      lineStyle: gridLineStyles,
      height: innerHeight,
      scale: columnsScale,
      ...props
    })]
  });
}
BaseGrid.propTypes = {
  rows: _pt.bool,
  columns: _pt.bool
};
function _extends$c() {
  _extends$c = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$c.apply(this, arguments);
}
function Axis(props) {
  return /* @__PURE__ */ React__default.createElement(BaseAxis, _extends$c({
    AxisComponent: Axis$1
  }, props));
}
function _extends$b() {
  _extends$b = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$b.apply(this, arguments);
}
function Grid2(props) {
  return /* @__PURE__ */ React__default.createElement(BaseGrid, _extends$b({
    GridRowsComponent: _default$4,
    GridColumnsComponent: _default$3
  }, props));
}
var TooltipContext = /* @__PURE__ */ createContext(null);
var TooltipContext$1 = TooltipContext;
var _excluded$4 = ["debounce", "detectBounds", "horizontalCrosshairStyle", "glyphStyle", "renderTooltip", "renderGlyph", "resizeObserverPolyfill", "scroll", "showDatumGlyph", "showHorizontalCrosshair", "showSeriesGlyphs", "showVerticalCrosshair", "snapTooltipToDatumX", "snapTooltipToDatumY", "verticalCrosshairStyle", "zIndex"], _excluded2$1 = ["x", "y"];
function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$a.apply(this, arguments);
}
var TOOLTIP_NO_STYLE = {
  position: "absolute",
  pointerEvents: "none",
  fontSize: 0,
  lineHeight: 0
};
var INVISIBLE_STYLES = {
  position: "absolute",
  left: 0,
  top: 0,
  opacity: 0,
  width: 0,
  height: 0,
  pointerEvents: "none"
};
function DefaultGlyph(props) {
  var _ref = useContext(DataContext$1) || {}, theme = _ref.theme;
  return /* @__PURE__ */ jsx$1("circle", {
    cx: props.x,
    cy: props.y,
    r: props.size,
    fill: props.color,
    stroke: theme == null ? void 0 : theme.backgroundColor,
    strokeWidth: 1.5,
    paintOrder: "fill",
    ...props.glyphStyle
  });
}
DefaultGlyph.propTypes = {
  isNearestDatum: _pt.bool.isRequired
};
function defaultRenderGlyph$1(props) {
  return /* @__PURE__ */ jsx$1(DefaultGlyph, {
    ...props
  });
}
function TooltipInner(_ref2) {
  var _tooltipContext$toolt, _nearestDatum$key, _ref12, _theme$gridStyles$str, _theme$gridStyles2, _theme$htmlLabel3, _ref13, _theme$gridStyles$str2, _theme$gridStyles3, _theme$htmlLabel4, _theme$backgroundColo, _theme$htmlLabel5, _theme$htmlLabel6;
  var debounce2 = _ref2.debounce, detectBounds = _ref2.detectBounds, horizontalCrosshairStyle = _ref2.horizontalCrosshairStyle, glyphStyle = _ref2.glyphStyle, renderTooltip = _ref2.renderTooltip, _ref2$renderGlyph = _ref2.renderGlyph, renderGlyph = _ref2$renderGlyph === void 0 ? defaultRenderGlyph$1 : _ref2$renderGlyph, resizeObserverPolyfillProp = _ref2.resizeObserverPolyfill, _ref2$scroll = _ref2.scroll, scroll = _ref2$scroll === void 0 ? true : _ref2$scroll, _ref2$showDatumGlyph = _ref2.showDatumGlyph, showDatumGlyph = _ref2$showDatumGlyph === void 0 ? false : _ref2$showDatumGlyph, _ref2$showHorizontalC = _ref2.showHorizontalCrosshair, showHorizontalCrosshair = _ref2$showHorizontalC === void 0 ? false : _ref2$showHorizontalC, _ref2$showSeriesGlyph = _ref2.showSeriesGlyphs, showSeriesGlyphs = _ref2$showSeriesGlyph === void 0 ? false : _ref2$showSeriesGlyph, _ref2$showVerticalCro = _ref2.showVerticalCrosshair, showVerticalCrosshair = _ref2$showVerticalCro === void 0 ? false : _ref2$showVerticalCro, _ref2$snapTooltipToDa = _ref2.snapTooltipToDatumX, snapTooltipToDatumX = _ref2$snapTooltipToDa === void 0 ? false : _ref2$snapTooltipToDa, _ref2$snapTooltipToDa2 = _ref2.snapTooltipToDatumY, snapTooltipToDatumY = _ref2$snapTooltipToDa2 === void 0 ? false : _ref2$snapTooltipToDa2, verticalCrosshairStyle = _ref2.verticalCrosshairStyle, zIndex2 = _ref2.zIndex, tooltipProps = _objectWithoutPropertiesLoose$4(_ref2, _excluded$4);
  var _ref3 = useContext(DataContext$1) || {}, colorScale = _ref3.colorScale, theme = _ref3.theme, innerHeight = _ref3.innerHeight, innerWidth = _ref3.innerWidth, margin2 = _ref3.margin, xScale = _ref3.xScale, yScale = _ref3.yScale, dataRegistry = _ref3.dataRegistry, resizeObserverPolyfill = _ref3.resizeObserverPolyfill;
  var tooltipContext = useContext(TooltipContext$1);
  var _useTooltipInPortal = useTooltipInPortal({
    debounce: debounce2,
    detectBounds,
    polyfill: resizeObserverPolyfill || resizeObserverPolyfillProp,
    scroll,
    zIndex: zIndex2
  }), containerRef = _useTooltipInPortal.containerRef, TooltipInPortal = _useTooltipInPortal.TooltipInPortal, forceRefreshBounds = _useTooltipInPortal.forceRefreshBounds;
  var setContainerRef = useCallback(function(ownRef) {
    var _ownRef$parentElement;
    containerRef((_ownRef$parentElement = ownRef == null ? void 0 : ownRef.parentElement) != null ? _ownRef$parentElement : null);
  }, [containerRef]);
  var tooltipContent = tooltipContext != null && tooltipContext.tooltipOpen ? renderTooltip(_extends$a({}, tooltipContext, {
    colorScale
  })) : null;
  var showTooltip = (tooltipContext == null ? void 0 : tooltipContext.tooltipOpen) && tooltipContent != null;
  var lastShowTooltip = useRef(false);
  useEffect(function() {
    if (showTooltip && !lastShowTooltip.current) {
      forceRefreshBounds();
    }
    lastShowTooltip.current = showTooltip;
  }, [showTooltip, forceRefreshBounds]);
  var tooltipLeft = tooltipContext == null ? void 0 : tooltipContext.tooltipLeft;
  var tooltipTop = tooltipContext == null ? void 0 : tooltipContext.tooltipTop;
  var xScaleBandwidth = xScale ? getScaleBandwidth$2(xScale) : 0;
  var yScaleBandwidth = yScale ? getScaleBandwidth$2(yScale) : 0;
  var getDatumLeftTop = useCallback(function(key, datum2) {
    var _ref4, _ref5;
    var entry = dataRegistry == null ? void 0 : dataRegistry.get(key);
    var xAccessor = entry == null ? void 0 : entry.xAccessor;
    var yAccessor = entry == null ? void 0 : entry.yAccessor;
    var left3 = xScale && xAccessor ? (_ref4 = Number(xScale(xAccessor(datum2))) + xScaleBandwidth / 2) != null ? _ref4 : 0 : void 0;
    var top3 = yScale && yAccessor ? (_ref5 = Number(yScale(yAccessor(datum2))) + yScaleBandwidth / 2) != null ? _ref5 : 0 : void 0;
    return {
      left: left3,
      top: top3
    };
  }, [dataRegistry, xScaleBandwidth, yScaleBandwidth, xScale, yScale]);
  var nearestDatum = tooltipContext == null ? void 0 : (_tooltipContext$toolt = tooltipContext.tooltipData) == null ? void 0 : _tooltipContext$toolt.nearestDatum;
  var nearestDatumKey = (_nearestDatum$key = nearestDatum == null ? void 0 : nearestDatum.key) != null ? _nearestDatum$key : "";
  if (showTooltip && nearestDatum && (snapTooltipToDatumX || snapTooltipToDatumY)) {
    var _getDatumLeftTop = getDatumLeftTop(nearestDatumKey, nearestDatum.datum), left2 = _getDatumLeftTop.left, top2 = _getDatumLeftTop.top;
    tooltipLeft = snapTooltipToDatumX && isValidNumber(left2) ? left2 : tooltipLeft;
    tooltipTop = snapTooltipToDatumY && isValidNumber(top2) ? top2 : tooltipTop;
  }
  var glyphProps = [];
  if (showTooltip && (showDatumGlyph || showSeriesGlyphs)) {
    var _glyphStyle$radius;
    var size = Number((_glyphStyle$radius = glyphStyle == null ? void 0 : glyphStyle.radius) != null ? _glyphStyle$radius : 4);
    if (showSeriesGlyphs) {
      var _tooltipContext$toolt2, _tooltipContext$toolt3;
      Object.values((_tooltipContext$toolt2 = tooltipContext == null ? void 0 : (_tooltipContext$toolt3 = tooltipContext.tooltipData) == null ? void 0 : _tooltipContext$toolt3.datumByKey) != null ? _tooltipContext$toolt2 : {}).forEach(function(_ref6) {
        var _ref7, _colorScale, _theme$htmlLabel;
        var key = _ref6.key, datum2 = _ref6.datum, index2 = _ref6.index;
        var color3 = (_ref7 = (_colorScale = colorScale == null ? void 0 : colorScale(key)) != null ? _colorScale : theme == null ? void 0 : (_theme$htmlLabel = theme.htmlLabel) == null ? void 0 : _theme$htmlLabel.color) != null ? _ref7 : "#222";
        var _getDatumLeftTop2 = getDatumLeftTop(key, datum2), left3 = _getDatumLeftTop2.left, top3 = _getDatumLeftTop2.top;
        if (!isValidNumber(left3) || !isValidNumber(top3))
          return;
        glyphProps.push({
          key,
          color: color3,
          datum: datum2,
          index: index2,
          size,
          x: left3,
          y: top3,
          glyphStyle,
          isNearestDatum: nearestDatum ? nearestDatum.key === key : false
        });
      });
    } else if (nearestDatum) {
      var _getDatumLeftTop3 = getDatumLeftTop(nearestDatumKey, nearestDatum.datum), _left = _getDatumLeftTop3.left, _top = _getDatumLeftTop3.top;
      if (isValidNumber(_left) && isValidNumber(_top)) {
        var _ref8, _ref9, _ref10, _ref11, _theme$gridStyles, _theme$htmlLabel2;
        var color2 = (_ref8 = (_ref9 = (_ref10 = (_ref11 = nearestDatumKey && (colorScale == null ? void 0 : colorScale(nearestDatumKey))) != null ? _ref11 : null) != null ? _ref10 : theme == null ? void 0 : (_theme$gridStyles = theme.gridStyles) == null ? void 0 : _theme$gridStyles.stroke) != null ? _ref9 : theme == null ? void 0 : (_theme$htmlLabel2 = theme.htmlLabel) == null ? void 0 : _theme$htmlLabel2.color) != null ? _ref8 : "#222";
        glyphProps.push({
          key: nearestDatumKey,
          color: color2,
          datum: nearestDatum.datum,
          index: nearestDatum.index,
          size,
          x: _left,
          y: _top,
          glyphStyle,
          isNearestDatum: true
        });
      }
    }
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1("svg", {
      ref: setContainerRef,
      style: INVISIBLE_STYLES
    }), showTooltip && /* @__PURE__ */ jsxs(Fragment, {
      children: [showVerticalCrosshair && /* @__PURE__ */ jsx$1(TooltipInPortal, {
        className: "visx-crosshair visx-crosshair-vertical",
        left: tooltipLeft,
        top: margin2 == null ? void 0 : margin2.top,
        offsetLeft: 0,
        offsetTop: 0,
        detectBounds: false,
        style: TOOLTIP_NO_STYLE,
        children: /* @__PURE__ */ jsx$1("svg", {
          width: "1",
          height: innerHeight,
          overflow: "visible",
          children: /* @__PURE__ */ jsx$1("line", {
            x1: 0,
            x2: 0,
            y1: 0,
            y2: innerHeight,
            strokeWidth: 1.5,
            stroke: (_ref12 = (_theme$gridStyles$str = theme == null ? void 0 : (_theme$gridStyles2 = theme.gridStyles) == null ? void 0 : _theme$gridStyles2.stroke) != null ? _theme$gridStyles$str : theme == null ? void 0 : (_theme$htmlLabel3 = theme.htmlLabel) == null ? void 0 : _theme$htmlLabel3.color) != null ? _ref12 : "#222",
            ...verticalCrosshairStyle
          })
        })
      }), showHorizontalCrosshair && /* @__PURE__ */ jsx$1(TooltipInPortal, {
        className: "visx-crosshair visx-crosshair-horizontal",
        left: margin2 == null ? void 0 : margin2.left,
        top: tooltipTop,
        offsetLeft: 0,
        offsetTop: 0,
        detectBounds: false,
        style: TOOLTIP_NO_STYLE,
        children: /* @__PURE__ */ jsx$1("svg", {
          width: innerWidth,
          height: "1",
          overflow: "visible",
          children: /* @__PURE__ */ jsx$1("line", {
            x1: 0,
            x2: innerWidth,
            y1: 0,
            y2: 0,
            strokeWidth: 1.5,
            stroke: (_ref13 = (_theme$gridStyles$str2 = theme == null ? void 0 : (_theme$gridStyles3 = theme.gridStyles) == null ? void 0 : _theme$gridStyles3.stroke) != null ? _theme$gridStyles$str2 : theme == null ? void 0 : (_theme$htmlLabel4 = theme.htmlLabel) == null ? void 0 : _theme$htmlLabel4.color) != null ? _ref13 : "#222",
            ...horizontalCrosshairStyle
          })
        })
      }), glyphProps.map(function(_ref14, i) {
        var x2 = _ref14.x, y2 = _ref14.y, props = _objectWithoutPropertiesLoose$4(_ref14, _excluded2$1);
        return /* @__PURE__ */ jsx$1(TooltipInPortal, {
          className: "visx-tooltip-glyph",
          left: x2,
          top: y2,
          offsetLeft: 0,
          offsetTop: 0,
          detectBounds: false,
          style: TOOLTIP_NO_STYLE,
          children: /* @__PURE__ */ jsx$1("svg", {
            overflow: "visible",
            children: renderGlyph(_extends$a({
              x: 0,
              y: 0
            }, props))
          })
        }, i);
      }), /* @__PURE__ */ jsx$1(TooltipInPortal, {
        left: tooltipLeft,
        top: tooltipTop,
        style: _extends$a({}, defaultStyles, {
          background: (_theme$backgroundColo = theme == null ? void 0 : theme.backgroundColor) != null ? _theme$backgroundColo : "white",
          boxShadow: "0 1px 2px " + (theme != null && (_theme$htmlLabel5 = theme.htmlLabel) != null && _theme$htmlLabel5.color ? (theme == null ? void 0 : (_theme$htmlLabel6 = theme.htmlLabel) == null ? void 0 : _theme$htmlLabel6.color) + "55" : "#22222255")
        }, theme == null ? void 0 : theme.htmlLabel),
        ...tooltipProps,
        children: tooltipContent
      })]
    })]
  });
}
TooltipInner.propTypes = {
  renderTooltip: _pt.func.isRequired,
  renderGlyph: _pt.func,
  snapTooltipToDatumX: _pt.bool,
  snapTooltipToDatumY: _pt.bool,
  showVerticalCrosshair: _pt.bool,
  showHorizontalCrosshair: _pt.bool,
  showDatumGlyph: _pt.bool,
  showSeriesGlyphs: _pt.bool
};
function Tooltip2(props) {
  var tooltipContext = useContext(TooltipContext$1);
  if (!(tooltipContext != null && tooltipContext.tooltipOpen))
    return null;
  return /* @__PURE__ */ jsx$1(TooltipInner, {
    ...props
  });
}
Tooltip2.propTypes = {
  renderTooltip: _pt.func.isRequired,
  renderGlyph: _pt.func,
  snapTooltipToDatumX: _pt.bool,
  snapTooltipToDatumY: _pt.bool,
  showVerticalCrosshair: _pt.bool,
  showHorizontalCrosshair: _pt.bool,
  showDatumGlyph: _pt.bool,
  showSeriesGlyphs: _pt.bool
};
var useParentSize$1 = {};
useParentSize$1.__esModule = true;
useParentSize$1.default = useParentSize;
var _debounce = _interopRequireDefault$6(debounce_1);
var _react$2 = React__default;
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
var defaultIgnoreDimensions = [];
var defaultInitialSize = {
  width: 0,
  height: 0,
  top: 0,
  left: 0
};
function useParentSize(_temp) {
  var _ref = _temp === void 0 ? {} : _temp, _ref$initialSize = _ref.initialSize, initialSize = _ref$initialSize === void 0 ? defaultInitialSize : _ref$initialSize, _ref$debounceTime = _ref.debounceTime, debounceTime = _ref$debounceTime === void 0 ? 300 : _ref$debounceTime, _ref$ignoreDimensions = _ref.ignoreDimensions, ignoreDimensions = _ref$ignoreDimensions === void 0 ? defaultIgnoreDimensions : _ref$ignoreDimensions, _ref$enableDebounceLe = _ref.enableDebounceLeadingCall, enableDebounceLeadingCall = _ref$enableDebounceLe === void 0 ? true : _ref$enableDebounceLe, resizeObserverPolyfill = _ref.resizeObserverPolyfill;
  var parentRef = (0, _react$2.useRef)(null);
  var animationFrameID = (0, _react$2.useRef)(0);
  var _useState = (0, _react$2.useState)(_extends$9({}, defaultInitialSize, initialSize)), state = _useState[0], setState = _useState[1];
  var resize = (0, _react$2.useMemo)(function() {
    var normalized = Array.isArray(ignoreDimensions) ? ignoreDimensions : [ignoreDimensions];
    return (0, _debounce.default)(function(incoming) {
      setState(function(existing) {
        var stateKeys = Object.keys(existing);
        var keysWithChanges = stateKeys.filter(function(key) {
          return existing[key] !== incoming[key];
        });
        var shouldBail = keysWithChanges.every(function(key) {
          return normalized.includes(key);
        });
        return shouldBail ? existing : incoming;
      });
    }, debounceTime, {
      leading: enableDebounceLeadingCall
    });
  }, [debounceTime, enableDebounceLeadingCall, ignoreDimensions]);
  (0, _react$2.useEffect)(function() {
    var LocalResizeObserver = resizeObserverPolyfill || window.ResizeObserver;
    var observer = new LocalResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        var _entry$contentRect;
        var _ref2 = (_entry$contentRect = entry == null ? void 0 : entry.contentRect) != null ? _entry$contentRect : {}, left2 = _ref2.left, top2 = _ref2.top, width2 = _ref2.width, height2 = _ref2.height;
        animationFrameID.current = window.requestAnimationFrame(function() {
          resize({
            width: width2,
            height: height2,
            top: top2,
            left: left2
          });
        });
      });
    });
    if (parentRef.current)
      observer.observe(parentRef.current);
    return function() {
      window.cancelAnimationFrame(animationFrameID.current);
      observer.disconnect();
      resize.cancel();
    };
  }, [resize, resizeObserverPolyfill]);
  return _extends$9({
    parentRef,
    resize
  }, state);
}
var _default$2 = ParentSize;
var _propTypes = _interopRequireDefault$5(propTypes.exports);
var _react$1 = _interopRequireDefault$5(React__default);
var _useParentSize2 = _interopRequireDefault$5(useParentSize$1);
var _excluded$3 = ["className", "children", "debounceTime", "ignoreDimensions", "initialSize", "parentSizeStyles", "enableDebounceLeadingCall", "resizeObserverPolyfill"], _excluded2 = ["parentRef", "resize"];
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$8() {
  _extends$8 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var defaultParentSizeStyles = {
  width: "100%",
  height: "100%"
};
function ParentSize(_ref) {
  var className = _ref.className, children2 = _ref.children, debounceTime = _ref.debounceTime, ignoreDimensions = _ref.ignoreDimensions, initialSize = _ref.initialSize, _ref$parentSizeStyles = _ref.parentSizeStyles, parentSizeStyles = _ref$parentSizeStyles === void 0 ? defaultParentSizeStyles : _ref$parentSizeStyles, _ref$enableDebounceLe = _ref.enableDebounceLeadingCall, enableDebounceLeadingCall = _ref$enableDebounceLe === void 0 ? true : _ref$enableDebounceLe, resizeObserverPolyfill = _ref.resizeObserverPolyfill, restProps = _objectWithoutPropertiesLoose$3(_ref, _excluded$3);
  var _useParentSize = (0, _useParentSize2.default)({
    initialSize,
    debounceTime,
    ignoreDimensions,
    enableDebounceLeadingCall,
    resizeObserverPolyfill
  }), parentRef = _useParentSize.parentRef, resize = _useParentSize.resize, dimensions = _objectWithoutPropertiesLoose$3(_useParentSize, _excluded2);
  return /* @__PURE__ */ _react$1.default.createElement("div", _extends$8({
    style: parentSizeStyles,
    ref: parentRef,
    className
  }, restProps), children2(_extends$8({}, dimensions, {
    ref: parentRef.current,
    resize
  })));
}
ParentSize.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.func.isRequired
};
var EventEmitterContext = /* @__PURE__ */ createContext(null);
var EventEmitterContext$1 = EventEmitterContext;
function useEventEmitter(eventType, handler, allowedSources) {
  var emitter = useContext(EventEmitterContext$1);
  var allowedSourcesRef = useRef();
  allowedSourcesRef.current = allowedSources;
  var emit = useCallback(function(type2, event, source) {
    if (emitter) {
      emitter.emit(type2, {
        event,
        svgPoint: localPoint(event),
        source
      });
    }
  }, [emitter]);
  useEffect(function() {
    if (emitter && eventType && handler) {
      var handlerWithSourceFilter = function handlerWithSourceFilter2(params) {
        var _allowedSourcesRef$cu;
        if (!allowedSourcesRef.current || params != null && params.source && (_allowedSourcesRef$cu = allowedSourcesRef.current) != null && _allowedSourcesRef$cu.includes(params.source)) {
          handler(params);
        }
      };
      emitter.on(eventType, handlerWithSourceFilter);
      return function() {
        return emitter == null ? void 0 : emitter.off(eventType, handlerWithSourceFilter);
      };
    }
    return void 0;
  }, [emitter, eventType, handler]);
  return emitter ? emit : null;
}
function mitt(n2) {
  return { all: n2 = n2 || /* @__PURE__ */ new Map(), on: function(t4, e3) {
    var i = n2.get(t4);
    i && i.push(e3) || n2.set(t4, [e3]);
  }, off: function(t4, e3) {
    var i = n2.get(t4);
    i && i.splice(i.indexOf(e3) >>> 0, 1);
  }, emit: function(t4, e3) {
    (n2.get(t4) || []).slice().map(function(n3) {
      n3(e3);
    }), (n2.get("*") || []).slice().map(function(n3) {
      n3(t4, e3);
    });
  } };
}
function EventEmitterProvider(_ref) {
  var children2 = _ref.children;
  var emitter = useMemo(function() {
    return mitt();
  }, []);
  return /* @__PURE__ */ jsx$1(EventEmitterContext$1.Provider, {
    value: emitter,
    children: children2
  });
}
function _extends$7() {
  _extends$7 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
function TooltipProvider(_ref) {
  var _ref$hideTooltipDebou = _ref.hideTooltipDebounceMs, hideTooltipDebounceMs = _ref$hideTooltipDebou === void 0 ? 400 : _ref$hideTooltipDebou, children2 = _ref.children;
  var _useTooltip = useTooltip(void 0), tooltipOpen = _useTooltip.tooltipOpen, tooltipLeft = _useTooltip.tooltipLeft, tooltipTop = _useTooltip.tooltipTop, tooltipData = _useTooltip.tooltipData, updateTooltip = _useTooltip.updateTooltip, privateHideTooltip = _useTooltip.hideTooltip;
  var debouncedHideTooltip = useRef(null);
  function cancelDeboundedHideTooltip() {
    if (debouncedHideTooltip.current) {
      debouncedHideTooltip.current.cancel();
      debouncedHideTooltip.current = null;
    }
  }
  useEffect(function() {
    return cancelDeboundedHideTooltip;
  }, []);
  var showTooltip = useRef(function(_ref2) {
    var svgPoint = _ref2.svgPoint, index2 = _ref2.index, key = _ref2.key, datum2 = _ref2.datum, distanceX = _ref2.distanceX, distanceY = _ref2.distanceY;
    cancelDeboundedHideTooltip();
    var cleanDistanceX = isValidNumber(distanceX) ? distanceX : Infinity;
    var cleanDistanceY = isValidNumber(distanceY) ? distanceY : Infinity;
    var distance2 = Math.sqrt(Math.pow(cleanDistanceX, 2) + Math.pow(cleanDistanceY, 2));
    updateTooltip(function(_ref3) {
      var _currData$nearestDatu, _currData$nearestDatu2, _extends22;
      var currData = _ref3.tooltipData;
      var currNearestDatumDistance = currData != null && currData.nearestDatum && isValidNumber(currData.nearestDatum.distance) ? currData.nearestDatum.distance : Infinity;
      return {
        tooltipOpen: true,
        tooltipLeft: svgPoint == null ? void 0 : svgPoint.x,
        tooltipTop: svgPoint == null ? void 0 : svgPoint.y,
        tooltipData: {
          nearestDatum: ((_currData$nearestDatu = currData == null ? void 0 : (_currData$nearestDatu2 = currData.nearestDatum) == null ? void 0 : _currData$nearestDatu2.key) != null ? _currData$nearestDatu : "") !== key && currNearestDatumDistance < distance2 ? currData == null ? void 0 : currData.nearestDatum : {
            key,
            index: index2,
            datum: datum2,
            distance: distance2
          },
          datumByKey: _extends$7({}, currData == null ? void 0 : currData.datumByKey, (_extends22 = {}, _extends22[key] = {
            datum: datum2,
            index: index2,
            key
          }, _extends22))
        }
      };
    });
  });
  var hideTooltip = useCallback(function() {
    debouncedHideTooltip.current = debounce$1(privateHideTooltip, hideTooltipDebounceMs);
    debouncedHideTooltip.current();
  }, [privateHideTooltip, hideTooltipDebounceMs]);
  var value = useMemo(function() {
    return {
      tooltipOpen,
      tooltipLeft,
      tooltipTop,
      tooltipData,
      updateTooltip,
      showTooltip: showTooltip.current,
      hideTooltip
    };
  }, [hideTooltip, tooltipData, tooltipLeft, tooltipOpen, tooltipTop, updateTooltip]);
  return /* @__PURE__ */ jsx$1(TooltipContext$1.Provider, {
    value,
    children: children2
  });
}
TooltipProvider.propTypes = {
  hideTooltipDebounceMs: _pt.number,
  children: _pt.node.isRequired
};
var require$$0$2 = /* @__PURE__ */ getAugmentedNamespace(d3Scale);
var scaleOperator$1 = {};
var domain = {};
domain.__esModule = true;
domain.default = applyDomain;
function applyDomain(scale, config2) {
  if (config2.domain) {
    if ("nice" in scale || "quantiles" in scale) {
      scale.domain(config2.domain);
    } else if ("padding" in scale) {
      scale.domain(config2.domain);
    } else {
      scale.domain(config2.domain);
    }
  }
}
var range$3 = {};
range$3.__esModule = true;
range$3.default = applyRange;
function applyRange(scale, config2) {
  if (config2.range) {
    if ("padding" in scale) {
      scale.range(config2.range);
    } else {
      scale.range(config2.range);
    }
  }
}
var align = {};
align.__esModule = true;
align.default = applyAlign;
function applyAlign(scale, config2) {
  if ("align" in scale && "align" in config2 && typeof config2.align !== "undefined") {
    scale.align(config2.align);
  }
}
var base = {};
base.__esModule = true;
base.default = applyBase;
function applyBase(scale, config2) {
  if ("base" in scale && "base" in config2 && typeof config2.base !== "undefined") {
    scale.base(config2.base);
  }
}
var clamp = {};
clamp.__esModule = true;
clamp.default = applyClamp;
function applyClamp(scale, config2) {
  if ("clamp" in scale && "clamp" in config2 && typeof config2.clamp !== "undefined") {
    scale.clamp(config2.clamp);
  }
}
var constant$f = {};
constant$f.__esModule = true;
constant$f.default = applyConstant;
function applyConstant(scale, config2) {
  if ("constant" in scale && "constant" in config2 && typeof config2.constant !== "undefined") {
    scale.constant(config2.constant);
  }
}
var exponent$2 = {};
exponent$2.__esModule = true;
exponent$2.default = applyExponent;
function applyExponent(scale, config2) {
  if ("exponent" in scale && "exponent" in config2 && typeof config2.exponent !== "undefined") {
    scale.exponent(config2.exponent);
  }
}
var interpolate$4 = {};
var createColorInterpolator$1 = {};
var require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(d3Interpolate);
createColorInterpolator$1.__esModule = true;
createColorInterpolator$1.default = createColorInterpolator;
var _d3Interpolate$1 = require$$0$1;
var interpolatorMap = {
  lab: _d3Interpolate$1.interpolateLab,
  hcl: _d3Interpolate$1.interpolateHcl,
  "hcl-long": _d3Interpolate$1.interpolateHclLong,
  hsl: _d3Interpolate$1.interpolateHsl,
  "hsl-long": _d3Interpolate$1.interpolateHslLong,
  cubehelix: _d3Interpolate$1.interpolateCubehelix,
  "cubehelix-long": _d3Interpolate$1.interpolateCubehelixLong,
  rgb: _d3Interpolate$1.interpolateRgb
};
function createColorInterpolator(interpolate2) {
  switch (interpolate2) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return interpolatorMap[interpolate2];
  }
  var type2 = interpolate2.type, gamma2 = interpolate2.gamma;
  var interpolator = interpolatorMap[type2];
  return typeof gamma2 === "undefined" ? interpolator : interpolator.gamma(gamma2);
}
interpolate$4.__esModule = true;
interpolate$4.default = applyInterpolate;
var _createColorInterpolator = _interopRequireDefault$4(createColorInterpolator$1);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function applyInterpolate(scale, config2) {
  if ("interpolate" in config2 && "interpolate" in scale && typeof config2.interpolate !== "undefined") {
    var interpolator = (0, _createColorInterpolator.default)(config2.interpolate);
    scale.interpolate(interpolator);
  }
}
var nice$2 = {};
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(d3Time);
var isUtcScale$1 = {};
isUtcScale$1.__esModule = true;
isUtcScale$1.default = isUtcScale;
var TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var TEST_FORMAT = "%Y-%m-%d %H:%M";
function isUtcScale(scale) {
  var output = scale.tickFormat(1, TEST_FORMAT)(TEST_TIME);
  return output === "2020-02-02 03:04";
}
nice$2.__esModule = true;
nice$2.default = applyNice;
var _d3Time = require$$0;
var _isUtcScale = _interopRequireDefault$3(isUtcScale$1);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var localTimeIntervals = {
  day: _d3Time.timeDay,
  hour: _d3Time.timeHour,
  minute: _d3Time.timeMinute,
  month: _d3Time.timeMonth,
  second: _d3Time.timeSecond,
  week: _d3Time.timeWeek,
  year: _d3Time.timeYear
};
var utcIntervals = {
  day: _d3Time.utcDay,
  hour: _d3Time.utcHour,
  minute: _d3Time.utcMinute,
  month: _d3Time.utcMonth,
  second: _d3Time.utcSecond,
  week: _d3Time.utcWeek,
  year: _d3Time.utcYear
};
function applyNice(scale, config2) {
  if ("nice" in config2 && typeof config2.nice !== "undefined" && "nice" in scale) {
    var nice2 = config2.nice;
    if (typeof nice2 === "boolean") {
      if (nice2) {
        scale.nice();
      }
    } else if (typeof nice2 === "number") {
      scale.nice(nice2);
    } else {
      var timeScale = scale;
      var isUtc = (0, _isUtcScale.default)(timeScale);
      if (typeof nice2 === "string") {
        timeScale.nice(isUtc ? utcIntervals[nice2] : localTimeIntervals[nice2]);
      } else {
        var interval2 = nice2.interval, step2 = nice2.step;
        var parsedInterval = (isUtc ? utcIntervals[interval2] : localTimeIntervals[interval2]).every(step2);
        if (parsedInterval != null) {
          timeScale.nice(parsedInterval);
        }
      }
    }
  }
}
var padding = {};
padding.__esModule = true;
padding.default = applyPadding;
function applyPadding(scale, config2) {
  if ("padding" in scale && "padding" in config2 && typeof config2.padding !== "undefined") {
    scale.padding(config2.padding);
  }
  if ("paddingInner" in scale && "paddingInner" in config2 && typeof config2.paddingInner !== "undefined") {
    scale.paddingInner(config2.paddingInner);
  }
  if ("paddingOuter" in scale && "paddingOuter" in config2 && typeof config2.paddingOuter !== "undefined") {
    scale.paddingOuter(config2.paddingOuter);
  }
}
var reverse$2 = {};
reverse$2.__esModule = true;
reverse$2.default = applyReverse;
function applyReverse(scale, config2) {
  if (config2.reverse) {
    var reversedRange = scale.range().slice().reverse();
    if ("padding" in scale) {
      scale.range(reversedRange);
    } else {
      scale.range(reversedRange);
    }
  }
}
var round = {};
round.__esModule = true;
round.default = applyRound;
var _d3Interpolate = require$$0$1;
function applyRound(scale, config2) {
  if ("round" in config2 && typeof config2.round !== "undefined") {
    if (config2.round && "interpolate" in config2 && typeof config2.interpolate !== "undefined") {
      console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config2);
    } else if ("round" in scale) {
      scale.round(config2.round);
    } else if ("interpolate" in scale && config2.round) {
      scale.interpolate(_d3Interpolate.interpolateRound);
    }
  }
}
var unknown = {};
unknown.__esModule = true;
unknown.default = applyUnknown;
function applyUnknown(scale, config2) {
  if ("unknown" in scale && "unknown" in config2 && typeof config2.unknown !== "undefined") {
    scale.unknown(config2.unknown);
  }
}
var zero$3 = {};
zero$3.__esModule = true;
zero$3.default = applyZero;
function applyZero(scale, config2) {
  if ("zero" in config2 && config2.zero === true) {
    var domain2 = scale.domain();
    var a2 = domain2[0], b10 = domain2[1];
    var isDescending = b10 < a2;
    var _ref = isDescending ? [b10, a2] : [a2, b10], min2 = _ref[0], max2 = _ref[1];
    var domainWithZero = [Math.min(0, min2), Math.max(0, max2)];
    scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
  }
}
scaleOperator$1.__esModule = true;
scaleOperator$1.ALL_OPERATORS = void 0;
scaleOperator$1.default = scaleOperator;
var _domain = _interopRequireDefault$2(domain);
var _range = _interopRequireDefault$2(range$3);
var _align = _interopRequireDefault$2(align);
var _base = _interopRequireDefault$2(base);
var _clamp = _interopRequireDefault$2(clamp);
var _constant = _interopRequireDefault$2(constant$f);
var _exponent = _interopRequireDefault$2(exponent$2);
var _interpolate = _interopRequireDefault$2(interpolate$4);
var _nice = _interopRequireDefault$2(nice$2);
var _padding = _interopRequireDefault$2(padding);
var _reverse = _interopRequireDefault$2(reverse$2);
var _round = _interopRequireDefault$2(round);
var _unknown = _interopRequireDefault$2(unknown);
var _zero = _interopRequireDefault$2(zero$3);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ALL_OPERATORS = [
  "domain",
  "nice",
  "zero",
  "interpolate",
  "round",
  "range",
  "reverse",
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
];
scaleOperator$1.ALL_OPERATORS = ALL_OPERATORS;
var operators = {
  domain: _domain.default,
  nice: _nice.default,
  zero: _zero.default,
  interpolate: _interpolate.default,
  round: _round.default,
  align: _align.default,
  base: _base.default,
  clamp: _clamp.default,
  constant: _constant.default,
  exponent: _exponent.default,
  padding: _padding.default,
  range: _range.default,
  reverse: _reverse.default,
  unknown: _unknown.default
};
function scaleOperator() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }
  var selection2 = new Set(ops);
  var selectedOps = ALL_OPERATORS.filter(function(o) {
    return selection2.has(o);
  });
  return function applyOperators(scale, config2) {
    if (typeof config2 !== "undefined") {
      selectedOps.forEach(function(op) {
        operators[op](scale, config2);
      });
    }
    return scale;
  };
}
var _default$1 = createOrdinalScale;
var _d3Scale = require$$0$2;
var _scaleOperator = _interopRequireDefault$1(scaleOperator$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var updateOrdinalScale = (0, _scaleOperator.default)("domain", "range", "reverse", "unknown");
function createOrdinalScale(config2) {
  return updateOrdinalScale((0, _d3Scale.scaleOrdinal)(), config2);
}
var allColors = {
  red: ["#fff5f5", "#ffe3e3", "#ffc9c9", "#ffa8a8", "#ff8787", "#ff6b6b", "#fa5252", "#f03e3e", "#e03131", "#c92a2a"],
  pink: ["#fff0f6", "#ffdeeb", "#fcc2d7", "#faa2c1", "#f783ac", "#f06595", "#e64980", "#d6336c", "#c2255c", "#a61e4d"],
  grape: ["#f8f0fc", "#f3d9fa", "#eebefa", "#e599f7", "#da77f2", "#cc5de8", "#be4bdb", "#ae3ec9", "#9c36b5", "#862e9c"],
  violet: ["#f3f0ff", "#e5dbff", "#d0bfff", "#b197fc", "#9775fa", "#845ef7", "#7950f2", "#7048e8", "#6741d9", "#5f3dc4"],
  indigo: ["#edf2ff", "#dbe4ff", "#bac8ff", "#91a7ff", "#748ffc", "#5c7cfa", "#4c6ef5", "#4263eb", "#3b5bdb", "#364fc7"],
  blue: ["#e8f7ff", "#ccedff", "#a3daff", "#72c3fc", "#4dadf7", "#329af0", "#228ae6", "#1c7cd6", "#1b6ec2", "#1862ab"],
  cyan: ["#e3fafc", "#c5f6fa", "#99e9f2", "#66d9e8", "#3bc9db", "#22b8cf", "#15aabf", "#1098ad", "#0c8599", "#0b7285"],
  teal: ["#e6fcf5", "#c3fae8", "#96f2d7", "#63e6be", "#38d9a9", "#20c997", "#12b886", "#0ca678", "#099268", "#087f5b"],
  green: ["#ebfbee", "#d3f9d8", "#b2f2bb", "#8ce99a", "#69db7c", "#51cf66", "#40c057", "#37b24d", "#2f9e44", "#2b8a3e"],
  lime: ["#f4fce3", "#e9fac8", "#d8f5a2", "#c0eb75", "#a9e34b", "#94d82d", "#82c91e", "#74b816", "#66a80f", "#5c940d"],
  yellow: ["#fff9db", "#fff3bf", "#ffec99", "#ffe066", "#ffd43b", "#fcc419", "#fab005", "#f59f00", "#f08c00", "#e67700"],
  orange: ["#fff4e6", "#ffe8cc", "#ffd8a8", "#ffc078", "#ffa94d", "#ff922b", "#fd7e14", "#f76707", "#e8590c", "#d9480f"],
  gray: ["#f8f9fa", "#f1f3f5", "#e9ecef", "#dee2e6", "#ced4da", "#adb5bd", "#868e96", "#495057", "#343a40", "#212529"]
};
var grayColors = allColors.gray;
var textColor = grayColors[7];
var defaultColors = [allColors.cyan[9], allColors.cyan[3], allColors.yellow[5], allColors.red[4], allColors.grape[8], allColors.grape[5], allColors.pink[9]];
function _extends$6() {
  _extends$6 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
var defaultLabelStyles = {
  fontFamily: "-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif",
  fontWeight: 700,
  fontSize: 12,
  textAnchor: "middle",
  pointerEvents: "none",
  letterSpacing: 0.4
};
function buildChartTheme(config2) {
  var _ref, _ref2, _config$htmlLabel$col, _config$htmlLabel, _config$svgLabelBig, _config$svgLabelSmall;
  var baseSvgLabel = _extends$6({}, defaultLabelStyles, {
    fill: textColor,
    stroke: "none"
  }, config2.svgLabelBig);
  var baseTickLabel = _extends$6({}, defaultLabelStyles, {
    fontWeight: 200,
    fontSize: 11,
    fill: textColor,
    stroke: "none"
  }, config2.svgLabelSmall);
  var baseHtmlLabel = _extends$6({
    color: (_ref = (_ref2 = (_config$htmlLabel$col = (_config$htmlLabel = config2.htmlLabel) == null ? void 0 : _config$htmlLabel.color) != null ? _config$htmlLabel$col : (_config$svgLabelBig = config2.svgLabelBig) == null ? void 0 : _config$svgLabelBig.fill) != null ? _ref2 : (_config$svgLabelSmall = config2.svgLabelSmall) == null ? void 0 : _config$svgLabelSmall.fill) != null ? _ref : textColor
  }, defaultLabelStyles, config2.htmlLabel);
  return {
    backgroundColor: config2.backgroundColor,
    colors: [].concat(config2.colors),
    htmlLabel: _extends$6({}, baseHtmlLabel),
    svgLabelSmall: _extends$6({}, baseTickLabel),
    svgLabelBig: _extends$6({}, baseSvgLabel),
    gridStyles: _extends$6({
      stroke: config2.gridColor,
      strokeWidth: 1
    }, config2.gridStyles),
    axisStyles: {
      x: {
        top: {
          axisLabel: _extends$6({}, baseSvgLabel, {
            dy: "-0.25em"
          }),
          axisLine: _extends$6({
            stroke: config2.gridColorDark,
            strokeWidth: 2
          }, config2.xAxisLineStyles),
          tickLabel: _extends$6({}, baseTickLabel, {
            dy: "-0.25em"
          }),
          tickLength: config2.tickLength,
          tickLine: _extends$6({
            strokeWidth: 1,
            stroke: config2.gridColor
          }, config2.xTickLineStyles)
        },
        bottom: {
          axisLabel: _extends$6({}, baseSvgLabel, {
            dy: "-0.25em"
          }),
          axisLine: _extends$6({
            stroke: config2.gridColorDark,
            strokeWidth: 2
          }, config2.xAxisLineStyles),
          tickLabel: _extends$6({}, baseTickLabel, {
            dy: "0.125em"
          }),
          tickLength: config2.tickLength,
          tickLine: _extends$6({
            strokeWidth: 1,
            stroke: config2.gridColor
          }, config2.xTickLineStyles)
        }
      },
      y: {
        left: {
          axisLabel: _extends$6({}, baseSvgLabel, {
            dx: "-1.25em"
          }),
          axisLine: _extends$6({
            stroke: config2.gridColor,
            strokeWidth: 1
          }, config2.yAxisLineStyles),
          tickLabel: _extends$6({}, baseTickLabel, {
            textAnchor: "end",
            dx: "-0.25em",
            dy: "0.25em"
          }),
          tickLength: config2.tickLength,
          tickLine: _extends$6({
            strokeWidth: 1,
            stroke: config2.gridColor
          }, config2.yTickLineStyles)
        },
        right: {
          axisLabel: _extends$6({}, baseSvgLabel, {
            dx: "1.25em"
          }),
          axisLine: _extends$6({
            stroke: config2.gridColor,
            strokeWidth: 1
          }, config2.yAxisLineStyles),
          tickLabel: _extends$6({}, baseTickLabel, {
            textAnchor: "start",
            dx: "0.25em",
            dy: "0.25em"
          }),
          tickLength: config2.tickLength,
          tickLine: _extends$6({
            strokeWidth: 1,
            stroke: config2.gridColor
          }, config2.yTickLineStyles)
        }
      }
    }
  };
}
var lightTheme = buildChartTheme({
  backgroundColor: "#fff",
  colors: defaultColors,
  tickLength: 4,
  svgLabelSmall: {
    fill: grayColors[7]
  },
  svgLabelBig: {
    fill: grayColors[9]
  },
  gridColor: grayColors[5],
  gridColorDark: grayColors[9]
});
var ThemeContext = /* @__PURE__ */ React__default.createContext(lightTheme);
var ThemeContext$1 = ThemeContext;
var DataRegistry = /* @__PURE__ */ function() {
  function DataRegistry2() {
    this.registry = {};
    this.registryKeys = [];
  }
  var _proto = DataRegistry2.prototype;
  _proto.registerData = function registerData(entryOrEntries) {
    var _this = this;
    var entries = Array.isArray(entryOrEntries) ? entryOrEntries : [entryOrEntries];
    entries.forEach(function(currEntry) {
      if (currEntry.key in _this.registry && _this.registry[currEntry.key] != null) {
        console.debug("Overriding data registry key", currEntry.key);
      }
      _this.registry[currEntry.key] = currEntry;
      _this.registryKeys = Object.keys(_this.registry);
    });
  };
  _proto.unregisterData = function unregisterData(keyOrKeys) {
    var _this2 = this;
    var keys2 = Array.isArray(keyOrKeys) ? keyOrKeys : [keyOrKeys];
    keys2.forEach(function(currKey) {
      delete _this2.registry[currKey];
      _this2.registryKeys = Object.keys(_this2.registry);
    });
  };
  _proto.entries = function entries() {
    return Object.values(this.registry);
  };
  _proto.get = function get2(key) {
    return this.registry[key];
  };
  _proto.keys = function keys2() {
    return this.registryKeys;
  };
  return DataRegistry2;
}();
function useDataRegistry() {
  var _useState = useState(Math.random()), forceUpdate = _useState[1];
  var privateRegistry = useMemo(function() {
    return new DataRegistry();
  }, []);
  return useMemo(function() {
    return {
      registerData: function registerData() {
        privateRegistry.registerData.apply(privateRegistry, arguments);
        forceUpdate(Math.random());
      },
      unregisterData: function unregisterData() {
        privateRegistry.unregisterData.apply(privateRegistry, arguments);
        forceUpdate(Math.random());
      },
      entries: function entries() {
        return privateRegistry.entries();
      },
      get: function get2(key) {
        return privateRegistry.get(key);
      },
      keys: function keys2() {
        return privateRegistry.keys();
      }
    };
  }, [privateRegistry]);
}
var DEFAULT_DIMS = {
  width: 0,
  height: 0,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};
function useDimensions(initialDims) {
  var _useState = useState({
    width: (initialDims == null ? void 0 : initialDims.width) == null ? DEFAULT_DIMS.width : initialDims.width,
    height: (initialDims == null ? void 0 : initialDims.height) == null ? DEFAULT_DIMS.height : initialDims.height,
    margin: (initialDims == null ? void 0 : initialDims.margin) == null ? DEFAULT_DIMS.margin : initialDims.margin
  }), dimensions = _useState[0], privateSetDimensions = _useState[1];
  var publicSetDimensions = useCallback(function(dims) {
    if (dims.width !== dimensions.width || dims.height !== dimensions.height || dims.margin.left !== dimensions.margin.left || dims.margin.right !== dimensions.margin.right || dims.margin.top !== dimensions.margin.top || dims.margin.bottom !== dimensions.margin.bottom) {
      privateSetDimensions(dims);
    }
  }, [dimensions.width, dimensions.height, dimensions.margin.left, dimensions.margin.right, dimensions.margin.bottom, dimensions.margin.top]);
  return [dimensions, publicSetDimensions];
}
function isDiscreteScale(scaleConfig) {
  return (scaleConfig == null ? void 0 : scaleConfig.type) === "band" || (scaleConfig == null ? void 0 : scaleConfig.type) === "ordinal" || (scaleConfig == null ? void 0 : scaleConfig.type) === "point";
}
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
function useScales(_ref) {
  var dataRegistry = _ref.dataRegistry, xRange = _ref.xRange, xScaleConfig = _ref.xScaleConfig, yRange = _ref.yRange, yScaleConfig = _ref.yScaleConfig;
  var registryKeys = dataRegistry.keys();
  var xMin = xRange[0], xMax = xRange[1];
  var yMin = yRange[0], yMax = yRange[1];
  var memoizedXScale = useMemo(function() {
    var registryEntries = registryKeys.map(function(key) {
      return dataRegistry.get(key);
    });
    var xValues = registryEntries.reduce(function(combined, entry) {
      return entry ? combined.concat(entry.data.map(function(d2) {
        return entry.xAccessor(d2);
      })) : combined;
    }, []);
    if (xValues.length === 0)
      return void 0;
    var xDomain = isDiscreteScale(xScaleConfig) ? xValues : extent$3(xValues);
    var xScale = scaleCanBeZeroed(xScaleConfig) ? createScale(_extends$5({
      range: [xMin, xMax],
      domain: xDomain,
      zero: true
    }, xScaleConfig)) : createScale(_extends$5({
      range: [xMin, xMax],
      domain: xDomain
    }, xScaleConfig));
    registryEntries.forEach(function(entry) {
      if (entry != null && entry.xScale)
        xScale = entry.xScale(xScale);
    });
    return xScale;
  }, [dataRegistry, xScaleConfig, registryKeys, xMin, xMax]);
  var memoizedYScale = useMemo(function() {
    var registryEntries = registryKeys.map(function(key) {
      return dataRegistry.get(key);
    });
    var yValues = registryEntries.reduce(function(combined, entry) {
      return entry ? combined.concat(entry.data.map(function(d2) {
        return entry.yAccessor(d2);
      })) : combined;
    }, []);
    if (yValues.length === 0)
      return void 0;
    var yDomain = isDiscreteScale(yScaleConfig) ? yValues : extent$3(yValues);
    var yScale = scaleCanBeZeroed(yScaleConfig) ? createScale(_extends$5({
      range: [yMin, yMax],
      domain: yDomain,
      zero: true
    }, yScaleConfig)) : createScale(_extends$5({
      range: [yMin, yMax],
      domain: yDomain
    }, yScaleConfig));
    registryEntries.forEach(function(entry) {
      if (entry != null && entry.yScale)
        yScale = entry.yScale(yScale);
    });
    return yScale;
  }, [dataRegistry, yScaleConfig, registryKeys, yMin, yMax]);
  return {
    xScale: memoizedXScale,
    yScale: memoizedYScale
  };
}
function DataProvider(_ref) {
  var initialDimensions = _ref.initialDimensions, propsTheme = _ref.theme, xScaleConfig = _ref.xScale, yScaleConfig = _ref.yScale, children2 = _ref.children, _ref$horizontal = _ref.horizontal, initialHorizontal = _ref$horizontal === void 0 ? "auto" : _ref$horizontal, resizeObserverPolyfill = _ref.resizeObserverPolyfill;
  var contextTheme = useContext(ThemeContext$1);
  var theme = propsTheme || contextTheme;
  var _useDimensions = useDimensions(initialDimensions), _useDimensions$ = _useDimensions[0], width2 = _useDimensions$.width, height2 = _useDimensions$.height, margin2 = _useDimensions$.margin, setDimensions = _useDimensions[1];
  var innerWidth = Math.max(0, width2 - margin2.left - margin2.right);
  var innerHeight = Math.max(0, height2 - margin2.top - margin2.bottom);
  var dataRegistry = useDataRegistry();
  var _useScales = useScales({
    dataRegistry,
    xScaleConfig,
    yScaleConfig,
    xRange: [margin2.left, Math.max(0, width2 - margin2.right)],
    yRange: [Math.max(0, height2 - margin2.bottom), margin2.top]
  }), xScale = _useScales.xScale, yScale = _useScales.yScale;
  var registryKeys = dataRegistry.keys();
  var colorScale = useMemo(function() {
    return _default$1({
      domain: registryKeys,
      range: theme.colors
    });
  }, [registryKeys, theme.colors]);
  var horizontal = initialHorizontal === "auto" ? isDiscreteScale(yScaleConfig) || yScaleConfig.type === "time" || yScaleConfig.type === "utc" : initialHorizontal;
  var value = useMemo(
    function() {
      return {
        dataRegistry,
        registerData: dataRegistry.registerData,
        unregisterData: dataRegistry.unregisterData,
        xScale,
        yScale,
        colorScale,
        theme,
        width: width2,
        height: height2,
        margin: margin2,
        innerWidth,
        innerHeight,
        setDimensions,
        horizontal,
        resizeObserverPolyfill
      };
    },
    [colorScale, dataRegistry, height2, horizontal, innerHeight, innerWidth, margin2, setDimensions, theme, width2, xScale, yScale, resizeObserverPolyfill]
  );
  return /* @__PURE__ */ jsx$1(DataContext$1.Provider, {
    value,
    children: children2
  });
}
DataProvider.propTypes = {
  children: _pt.node.isRequired,
  horizontal: _pt.oneOfType([_pt.bool, _pt.oneOf(["auto"])])
};
function usePointerEventEmitters(_ref) {
  var source = _ref.source, _ref$onPointerOut = _ref.onPointerOut, onPointerOut = _ref$onPointerOut === void 0 ? true : _ref$onPointerOut, _ref$onPointerMove = _ref.onPointerMove, onPointerMove = _ref$onPointerMove === void 0 ? true : _ref$onPointerMove, _ref$onPointerUp = _ref.onPointerUp, onPointerUp = _ref$onPointerUp === void 0 ? true : _ref$onPointerUp, _ref$onPointerDown = _ref.onPointerDown, onPointerDown = _ref$onPointerDown === void 0 ? true : _ref$onPointerDown, _ref$onFocus = _ref.onFocus, onFocus = _ref$onFocus === void 0 ? false : _ref$onFocus, _ref$onBlur = _ref.onBlur, onBlur = _ref$onBlur === void 0 ? false : _ref$onBlur;
  var emit = useEventEmitter();
  var emitPointerMove = useCallback(function(event) {
    return emit == null ? void 0 : emit("pointermove", event, source);
  }, [emit, source]);
  var emitPointerOut = useCallback(function(event) {
    return emit == null ? void 0 : emit("pointerout", event, source);
  }, [emit, source]);
  var emitPointerUp = useCallback(function(event) {
    return emit == null ? void 0 : emit("pointerup", event, source);
  }, [emit, source]);
  var emitPointerDown = useCallback(function(event) {
    return emit == null ? void 0 : emit("pointerdown", event, source);
  }, [emit, source]);
  var emitFocus = useCallback(function(event) {
    return emit == null ? void 0 : emit("focus", event, source);
  }, [emit, source]);
  var emitBlur = useCallback(function(event) {
    return emit == null ? void 0 : emit("blur", event, source);
  }, [emit, source]);
  return {
    onPointerMove: onPointerMove ? emitPointerMove : void 0,
    onFocus: onFocus ? emitFocus : void 0,
    onBlur: onBlur ? emitBlur : void 0,
    onPointerOut: onPointerOut ? emitPointerOut : void 0,
    onPointerUp: onPointerUp ? emitPointerUp : void 0,
    onPointerDown: onPointerDown ? emitPointerDown : void 0
  };
}
var GLYPHSERIES_EVENT_SOURCE = "GLYPHSERIES_EVENT_SOURCE";
var LINESERIES_EVENT_SOURCE = "LINESERIES_EVENT_SOURCE";
var XYCHART_EVENT_SOURCE = "XYCHART_EVENT_SOURCE";
function isPointerEvent(event) {
  return !!event && ("clientX" in event || "changedTouches" in event);
}
function isFocusEvent(event) {
  return !!event && !isPointerEvent(event);
}
function findNearestDatumSingleDimension(_ref) {
  var scale = _ref.scale, accessor = _ref.accessor, scaledValue = _ref.scaledValue, data = _ref.data;
  var coercedScale = scale;
  var nearestDatum;
  var nearestDatumIndex;
  if ("invert" in coercedScale && typeof coercedScale.invert === "function") {
    var bisect2 = bisector$1(accessor).left;
    var dataValue = Number(coercedScale.invert(scaledValue));
    var index2 = bisect2(data, dataValue);
    var nearestDatum0 = data[index2 - 1];
    var nearestDatum1 = data[index2];
    nearestDatum = !nearestDatum0 || Math.abs(dataValue - accessor(nearestDatum0)) > Math.abs(dataValue - accessor(nearestDatum1)) ? nearestDatum1 : nearestDatum0;
    nearestDatumIndex = nearestDatum === nearestDatum0 ? index2 - 1 : index2;
  } else if ("step" in coercedScale && typeof coercedScale.step !== "undefined") {
    var domain2 = scale.domain();
    var range2 = scale.range().map(Number);
    var sortedRange = [].concat(range2).sort(function(a2, b10) {
      return a2 - b10;
    });
    var rangePoints = range$6(sortedRange[0], sortedRange[1], coercedScale.step());
    var domainIndex = bisectLeft$1(rangePoints, scaledValue);
    var sortedDomain = range2[0] < range2[1] ? domain2 : domain2.reverse();
    var domainValue = sortedDomain[domainIndex - 1];
    var _index = data.findIndex(function(d2) {
      return String(accessor(d2)) === String(domainValue);
    });
    nearestDatum = data[_index];
    nearestDatumIndex = _index;
  } else {
    console.warn("[visx/xychart/findNearestDatum] encountered incompatible scale type, bailing");
    return null;
  }
  if (nearestDatum == null || nearestDatumIndex == null)
    return null;
  var distance2 = Math.abs(Number(coercedScale(accessor(nearestDatum))) - scaledValue);
  return {
    datum: nearestDatum,
    index: nearestDatumIndex,
    distance: distance2
  };
}
function findNearestDatumX(_ref) {
  var scale = _ref.xScale, accessor = _ref.xAccessor, yScale = _ref.yScale, yAccessor = _ref.yAccessor, point2 = _ref.point, data = _ref.data;
  if (!point2)
    return null;
  var nearestDatum = findNearestDatumSingleDimension({
    scale,
    accessor,
    scaledValue: point2.x,
    data
  });
  return nearestDatum ? {
    datum: nearestDatum.datum,
    index: nearestDatum.index,
    distanceX: nearestDatum.distance,
    distanceY: Math.abs(Number(yScale(yAccessor(nearestDatum.datum))) - point2.y)
  } : null;
}
function findNearestDatumY(_ref) {
  var scale = _ref.yScale, accessor = _ref.yAccessor, xScale = _ref.xScale, xAccessor = _ref.xAccessor, point2 = _ref.point, data = _ref.data;
  if (!point2)
    return null;
  var nearestDatum = findNearestDatumSingleDimension({
    scale,
    accessor,
    scaledValue: point2.y,
    data
  });
  return nearestDatum ? {
    datum: nearestDatum.datum,
    index: nearestDatum.index,
    distanceY: nearestDatum.distance,
    distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point2.x)
  } : null;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var POINTER_EVENTS_ALL = "__POINTER_EVENTS_ALL";
var POINTER_EVENTS_NEAREST = "__POINTER_EVENTS_NEAREST";
function usePointerEventHandlers(_ref) {
  var dataKey = _ref.dataKey, findNearestDatumProps = _ref.findNearestDatum, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onPointerMove = _ref.onPointerMove, onPointerOut = _ref.onPointerOut, onPointerUp = _ref.onPointerUp, onPointerDown = _ref.onPointerDown, allowedSources = _ref.allowedSources;
  var _ref2 = useContext(DataContext$1), width2 = _ref2.width, height2 = _ref2.height, horizontal = _ref2.horizontal, dataRegistry = _ref2.dataRegistry, xScale = _ref2.xScale, yScale = _ref2.yScale;
  var findNearestDatum = findNearestDatumProps || (horizontal ? findNearestDatumY : findNearestDatumX);
  var getHandlerParams = useCallback(function(params) {
    var _ref3 = params || {}, svgPoint = _ref3.svgPoint, event = _ref3.event;
    var pointerParamsByKey = {};
    var nearestDatumPointerParams = null;
    var nearestDatumDistance = Infinity;
    if (params && event && svgPoint && width2 && height2 && xScale && yScale) {
      var _dataRegistry$keys;
      var considerAllKeys = dataKey === POINTER_EVENTS_NEAREST || dataKey === POINTER_EVENTS_ALL;
      var dataKeys = considerAllKeys ? (_dataRegistry$keys = dataRegistry == null ? void 0 : dataRegistry.keys()) != null ? _dataRegistry$keys : [] : Array.isArray(dataKey) ? dataKey : [dataKey];
      dataKeys.forEach(function(key) {
        var entry = dataRegistry == null ? void 0 : dataRegistry.get(key);
        if (entry) {
          var nearestDatum = findNearestDatum({
            dataKey: key,
            data: entry.data,
            height: height2,
            point: svgPoint,
            width: width2,
            xAccessor: entry.xAccessor,
            xScale,
            yAccessor: entry.yAccessor,
            yScale
          });
          if (nearestDatum) {
            pointerParamsByKey[key] = _extends$4({
              key,
              svgPoint,
              event
            }, nearestDatum);
            if (dataKey === POINTER_EVENTS_NEAREST) {
              var _nearestDatum$distanc, _nearestDatum$distanc2;
              var distance2 = Math.sqrt(((_nearestDatum$distanc = nearestDatum.distanceX) != null ? _nearestDatum$distanc : Math.pow(Infinity, 2)) + ((_nearestDatum$distanc2 = nearestDatum.distanceY) != null ? _nearestDatum$distanc2 : Math.pow(Infinity, 2)));
              nearestDatumPointerParams = distance2 < nearestDatumDistance ? pointerParamsByKey[key] : nearestDatumPointerParams;
              nearestDatumDistance = Math.min(nearestDatumDistance, distance2);
            }
          }
        }
      });
      var pointerParams = dataKey === POINTER_EVENTS_NEAREST ? [nearestDatumPointerParams] : dataKey === POINTER_EVENTS_ALL || Array.isArray(dataKey) ? Object.values(pointerParamsByKey) : [pointerParamsByKey[dataKey]];
      return pointerParams.filter(function(param) {
        return param;
      });
    }
    return [];
  }, [dataKey, dataRegistry, xScale, yScale, width2, height2, findNearestDatum]);
  var handlePointerMove = useCallback(function(params) {
    if (onPointerMove) {
      getHandlerParams(params).forEach(function(p2) {
        return onPointerMove(p2);
      });
    }
  }, [getHandlerParams, onPointerMove]);
  var handlePointerUp = useCallback(function(params) {
    if (onPointerUp) {
      getHandlerParams(params).forEach(function(p2) {
        return onPointerUp(p2);
      });
    }
  }, [getHandlerParams, onPointerUp]);
  var handlePointerDown2 = useCallback(function(params) {
    if (onPointerDown) {
      getHandlerParams(params).forEach(function(p2) {
        return onPointerDown(p2);
      });
    }
  }, [getHandlerParams, onPointerDown]);
  var handleFocus = useCallback(function(params) {
    if (onFocus) {
      getHandlerParams(params).forEach(function(p2) {
        return onFocus(p2);
      });
    }
  }, [getHandlerParams, onFocus]);
  var handlePointerOut = useCallback(function(params) {
    var event = params == null ? void 0 : params.event;
    if (event && isPointerEvent(event) && onPointerOut)
      onPointerOut(event);
  }, [onPointerOut]);
  var handleBlur = useCallback(function(params) {
    var event = params == null ? void 0 : params.event;
    if (event && isFocusEvent(event) && onBlur)
      onBlur(event);
  }, [onBlur]);
  useEventEmitter("pointermove", onPointerMove ? handlePointerMove : void 0, allowedSources);
  useEventEmitter("pointerout", onPointerOut ? handlePointerOut : void 0, allowedSources);
  useEventEmitter("pointerup", onPointerUp ? handlePointerUp : void 0, allowedSources);
  useEventEmitter("pointerdown", onPointerDown ? handlePointerDown2 : void 0, allowedSources);
  useEventEmitter("focus", onFocus ? handleFocus : void 0, allowedSources);
  useEventEmitter("blur", onBlur ? handleBlur : void 0, allowedSources);
}
var DEFAULT_MARGIN = {
  top: 50,
  right: 50,
  bottom: 50,
  left: 50
};
var allowedEventSources = [XYCHART_EVENT_SOURCE];
function XYChart(props) {
  var _props$accessibilityL = props.accessibilityLabel, accessibilityLabel = _props$accessibilityL === void 0 ? "XYChart" : _props$accessibilityL, _props$captureEvents = props.captureEvents, captureEvents = _props$captureEvents === void 0 ? true : _props$captureEvents, children2 = props.children, height2 = props.height, horizontal = props.horizontal, _props$margin = props.margin, margin2 = _props$margin === void 0 ? DEFAULT_MARGIN : _props$margin, onPointerMove = props.onPointerMove, onPointerOut = props.onPointerOut, onPointerUp = props.onPointerUp, onPointerDown = props.onPointerDown, _props$pointerEventsD = props.pointerEventsDataKey, pointerEventsDataKey = _props$pointerEventsD === void 0 ? "nearest" : _props$pointerEventsD, theme = props.theme, width2 = props.width, xScale = props.xScale, yScale = props.yScale, resizeObserverPolyfillProp = props.resizeObserverPolyfill;
  var _useContext = useContext(DataContext$1), setDimensions = _useContext.setDimensions, resizeObserverPolyfill = _useContext.resizeObserverPolyfill;
  var tooltipContext = useContext(TooltipContext$1);
  var emit = useEventEmitter();
  useEffect(function() {
    if (setDimensions && width2 != null && height2 != null && width2 > 0 && height2 > 0) {
      setDimensions({
        width: width2,
        height: height2,
        margin: margin2
      });
    }
  }, [setDimensions, width2, height2, margin2]);
  var eventEmitters = usePointerEventEmitters({
    source: XYCHART_EVENT_SOURCE
  });
  usePointerEventHandlers({
    dataKey: pointerEventsDataKey === "nearest" ? POINTER_EVENTS_NEAREST : POINTER_EVENTS_ALL,
    onPointerMove,
    onPointerOut,
    onPointerUp,
    onPointerDown,
    allowedSources: allowedEventSources
  });
  if (!setDimensions) {
    if (!xScale || !yScale) {
      console.warn("[@visx/xychart] XYChart: When no DataProvider is available in context, you must pass xScale & yScale config to XYChart.");
      return null;
    }
    return /* @__PURE__ */ jsx$1(DataProvider, {
      xScale,
      yScale,
      theme,
      initialDimensions: {
        width: width2,
        height: height2,
        margin: margin2
      },
      horizontal,
      resizeObserverPolyfill: resizeObserverPolyfillProp,
      children: /* @__PURE__ */ jsx$1(XYChart, {
        ...props
      })
    });
  }
  if (width2 == null || height2 == null) {
    return /* @__PURE__ */ jsx$1(_default$2, {
      resizeObserverPolyfill,
      children: function(dims) {
        return /* @__PURE__ */ jsx$1(XYChart, {
          ...props,
          width: props.width == null ? dims.width : props.width,
          height: props.height == null ? dims.height : props.height
        });
      }
    });
  }
  if (tooltipContext == null) {
    return /* @__PURE__ */ jsx$1(TooltipProvider, {
      children: /* @__PURE__ */ jsx$1(XYChart, {
        ...props
      })
    });
  }
  if (emit == null) {
    return /* @__PURE__ */ jsx$1(EventEmitterProvider, {
      children: /* @__PURE__ */ jsx$1(XYChart, {
        ...props
      })
    });
  }
  if (width2 <= 0 || height2 <= 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs("svg", {
    width: width2,
    height: height2,
    "aria-label": accessibilityLabel,
    children: [children2, captureEvents && /* @__PURE__ */ jsx$1("rect", {
      x: margin2.left,
      y: margin2.top,
      width: width2 - margin2.left - margin2.right,
      height: height2 - margin2.top - margin2.bottom,
      fill: "transparent",
      ...eventEmitters
    })]
  });
}
XYChart.propTypes = {
  accessibilityLabel: _pt.string,
  captureEvents: _pt.bool,
  width: _pt.number,
  height: _pt.number,
  children: _pt.node.isRequired,
  horizontal: _pt.oneOfType([_pt.bool, _pt.oneOf(["auto"])]),
  onPointerMove: _pt.func,
  onPointerOut: _pt.func,
  onPointerUp: _pt.func,
  onPointerDown: _pt.func,
  pointerEventsDataKey: _pt.oneOf(["all", "nearest"])
};
var _default = LinePath;
var _react = _interopRequireDefault(React__default);
var _classnames = _interopRequireDefault(classnames.exports);
var _D3ShapeFactories = D3ShapeFactories;
var _excluded$2 = ["children", "data", "x", "y", "fill", "className", "curve", "innerRef", "defined"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function LinePath(_ref) {
  var children2 = _ref.children, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, x2 = _ref.x, y2 = _ref.y, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, curve = _ref.curve, innerRef = _ref.innerRef, _ref$defined = _ref.defined, defined = _ref$defined === void 0 ? function() {
    return true;
  } : _ref$defined, restProps = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);
  var path2 = (0, _D3ShapeFactories.line)({
    x: x2,
    y: y2,
    defined,
    curve
  });
  if (children2)
    return /* @__PURE__ */ _react.default.createElement(_react.default.Fragment, null, children2({
      path: path2
    }));
  return /* @__PURE__ */ _react.default.createElement("path", _extends$3({
    ref: innerRef,
    className: (0, _classnames.default)("visx-linepath", className),
    d: path2(data) || "",
    fill,
    strokeLinecap: "round"
  }, restProps));
}
function withRegisteredData(BaseSeriesComponent) {
  function WrappedComponent(props) {
    var dataKey = props.dataKey, data = props.data, xAccessor = props.xAccessor, yAccessor = props.yAccessor;
    var _ref = useContext(DataContext$1), xScale = _ref.xScale, yScale = _ref.yScale, dataRegistry = _ref.dataRegistry;
    useEffect(function() {
      if (dataRegistry)
        dataRegistry.registerData({
          key: dataKey,
          data,
          xAccessor,
          yAccessor
        });
      return function() {
        return dataRegistry == null ? void 0 : dataRegistry.unregisterData(dataKey);
      };
    }, [dataRegistry, dataKey, data, xAccessor, yAccessor]);
    var registryEntry = dataRegistry == null ? void 0 : dataRegistry.get(dataKey);
    if (!xScale || !yScale || !registryEntry)
      return null;
    var BaseComponent = BaseSeriesComponent;
    return /* @__PURE__ */ jsx$1(BaseComponent, {
      ...props,
      xScale,
      yScale,
      data: registryEntry.data,
      xAccessor: registryEntry.xAccessor,
      yAccessor: registryEntry.yAccessor
    });
  }
  return WrappedComponent;
}
function getScaledValueFactory(scale, accessor, align2) {
  if (align2 === void 0) {
    align2 = "center";
  }
  return function(d2) {
    var scaledValue = scale(accessor(d2));
    if (isValidNumber(scaledValue)) {
      var bandwidthOffset = (align2 === "start" ? 0 : getScaleBandwidth$2(scale)) / (align2 === "center" ? 2 : 1);
      return scaledValue + bandwidthOffset;
    }
    return NaN;
  };
}
function useSeriesEvents(_ref) {
  var _useContext;
  var dataKey = _ref.dataKey, enableEvents = _ref.enableEvents, findNearestDatum = _ref.findNearestDatum, onBlurProps = _ref.onBlur, onFocusProps = _ref.onFocus, onPointerMoveProps = _ref.onPointerMove, onPointerOutProps = _ref.onPointerOut, onPointerUpProps = _ref.onPointerUp, onPointerDownProps = _ref.onPointerDown, source = _ref.source, allowedSources = _ref.allowedSources;
  var _ref2 = (_useContext = useContext(TooltipContext$1)) != null ? _useContext : {}, showTooltip = _ref2.showTooltip, hideTooltip = _ref2.hideTooltip;
  var onPointerMove = useCallback(function(params) {
    showTooltip(params);
    if (onPointerMoveProps)
      onPointerMoveProps(params);
  }, [showTooltip, onPointerMoveProps]);
  var onFocus = useCallback(function(params) {
    showTooltip(params);
    if (onFocusProps)
      onFocusProps(params);
  }, [showTooltip, onFocusProps]);
  var onPointerOut = useCallback(function(event) {
    hideTooltip();
    if (event && onPointerOutProps)
      onPointerOutProps(event);
  }, [hideTooltip, onPointerOutProps]);
  var onBlur = useCallback(function(event) {
    hideTooltip();
    if (event && onBlurProps)
      onBlurProps(event);
  }, [hideTooltip, onBlurProps]);
  var onPointerDown = useCallback(function(params) {
    showTooltip(params);
    if (onPointerDownProps)
      onPointerDownProps(params);
  }, [showTooltip, onPointerDownProps]);
  usePointerEventHandlers({
    dataKey,
    findNearestDatum,
    onBlur: enableEvents ? onBlur : void 0,
    onFocus: enableEvents ? onFocus : void 0,
    onPointerMove: enableEvents ? onPointerMove : void 0,
    onPointerOut: enableEvents ? onPointerOut : void 0,
    onPointerUp: enableEvents ? onPointerUpProps : void 0,
    onPointerDown: enableEvents ? onPointerDown : void 0,
    allowedSources
  });
  return usePointerEventEmitters({
    source,
    onBlur: !!onBlurProps && enableEvents,
    onFocus: !!onFocusProps && enableEvents,
    onPointerMove: !!onPointerMoveProps && enableEvents,
    onPointerOut: !!onPointerOutProps && enableEvents,
    onPointerUp: !!onPointerUpProps && enableEvents,
    onPointerDown: !!onPointerDownProps && enableEvents
  });
}
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function BaseGlyphSeries(_ref) {
  var _ref2, _colorScale, _theme$colors;
  var colorAccessor = _ref.colorAccessor, data = _ref.data, dataKey = _ref.dataKey, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onPointerMove = _ref.onPointerMove, onPointerOut = _ref.onPointerOut, onPointerUp = _ref.onPointerUp, onPointerDown = _ref.onPointerDown, _ref$enableEvents = _ref.enableEvents, enableEvents = _ref$enableEvents === void 0 ? true : _ref$enableEvents, renderGlyphs = _ref.renderGlyphs, _ref$size = _ref.size, size = _ref$size === void 0 ? 8 : _ref$size, xAccessor = _ref.xAccessor, xScale = _ref.xScale, yAccessor = _ref.yAccessor, yScale = _ref.yScale;
  var _useContext = useContext(DataContext$1), colorScale = _useContext.colorScale, theme = _useContext.theme, horizontal = _useContext.horizontal;
  var getScaledX = useMemo(function() {
    return getScaledValueFactory(xScale, xAccessor);
  }, [xScale, xAccessor]);
  var getScaledY = useMemo(function() {
    return getScaledValueFactory(yScale, yAccessor);
  }, [yScale, yAccessor]);
  var color2 = (_ref2 = (_colorScale = colorScale == null ? void 0 : colorScale(dataKey)) != null ? _colorScale : theme == null ? void 0 : (_theme$colors = theme.colors) == null ? void 0 : _theme$colors[0]) != null ? _ref2 : "#222";
  var ownEventSourceKey = GLYPHSERIES_EVENT_SOURCE + "-" + dataKey;
  var eventEmitters = useSeriesEvents({
    dataKey,
    enableEvents,
    onBlur,
    onFocus,
    onPointerMove,
    onPointerOut,
    onPointerUp,
    onPointerDown,
    source: ownEventSourceKey,
    allowedSources: [XYCHART_EVENT_SOURCE, ownEventSourceKey]
  });
  var glyphs = useMemo(function() {
    return data.map(function(datum2, i) {
      var _colorAccessor;
      var x2 = getScaledX(datum2);
      if (!isValidNumber(x2))
        return null;
      var y2 = getScaledY(datum2);
      if (!isValidNumber(y2))
        return null;
      return {
        key: "" + i,
        x: x2,
        y: y2,
        color: (_colorAccessor = colorAccessor == null ? void 0 : colorAccessor(datum2, i)) != null ? _colorAccessor : color2,
        size: typeof size === "function" ? size(datum2) : size,
        datum: datum2
      };
    }).filter(function(point2) {
      return point2;
    });
  }, [color2, colorAccessor, data, getScaledX, getScaledY, size]);
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: renderGlyphs(_extends$2({
      glyphs,
      xScale,
      yScale,
      horizontal
    }, eventEmitters))
  });
}
BaseGlyphSeries.propTypes = {
  colorAccessor: _pt.func,
  size: _pt.oneOfType([_pt.number, _pt.func]),
  renderGlyphs: _pt.func.isRequired
};
function defaultRenderGlyph(_ref) {
  var key = _ref.key, color2 = _ref.color, x2 = _ref.x, y2 = _ref.y, size = _ref.size, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onPointerMove = _ref.onPointerMove, onPointerOut = _ref.onPointerOut, onPointerUp = _ref.onPointerUp;
  return /* @__PURE__ */ React__default.createElement("circle", {
    className: "visx-circle-glyph",
    key,
    tabIndex: onBlur || onFocus ? 0 : void 0,
    fill: color2,
    r: size / 2,
    cx: x2,
    cy: y2,
    onBlur,
    onFocus,
    onPointerMove,
    onPointerOut,
    onPointerUp
  });
}
var _excluded$1 = ["colorAccessor", "curve", "data", "dataKey", "onBlur", "onFocus", "onPointerMove", "onPointerOut", "onPointerUp", "onPointerDown", "enableEvents", "xAccessor", "xScale", "yAccessor", "yScale", "PathComponent"];
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function BaseLineSeries(_ref) {
  var _ref2, _colorScale, _theme$colors;
  var colorAccessor = _ref.colorAccessor, curve = _ref.curve, data = _ref.data, dataKey = _ref.dataKey, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onPointerMove = _ref.onPointerMove, onPointerOut = _ref.onPointerOut, onPointerUp = _ref.onPointerUp, onPointerDown = _ref.onPointerDown, _ref$enableEvents = _ref.enableEvents, enableEvents = _ref$enableEvents === void 0 ? true : _ref$enableEvents, xAccessor = _ref.xAccessor, xScale = _ref.xScale, yAccessor = _ref.yAccessor, yScale = _ref.yScale, _ref$PathComponent = _ref.PathComponent, PathComponent = _ref$PathComponent === void 0 ? "path" : _ref$PathComponent, lineProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);
  var _useContext = useContext(DataContext$1), colorScale = _useContext.colorScale, theme = _useContext.theme;
  var getScaledX = useMemo(function() {
    return getScaledValueFactory(xScale, xAccessor);
  }, [xScale, xAccessor]);
  var getScaledY = useMemo(function() {
    return getScaledValueFactory(yScale, yAccessor);
  }, [yScale, yAccessor]);
  var isDefined = useCallback(function(d2) {
    return isValidNumber(xScale(xAccessor(d2))) && isValidNumber(yScale(yAccessor(d2)));
  }, [xScale, xAccessor, yScale, yAccessor]);
  var color2 = (_ref2 = (_colorScale = colorScale == null ? void 0 : colorScale(dataKey)) != null ? _colorScale : theme == null ? void 0 : (_theme$colors = theme.colors) == null ? void 0 : _theme$colors[0]) != null ? _ref2 : "#222";
  var ownEventSourceKey = LINESERIES_EVENT_SOURCE + "-" + dataKey;
  var eventEmitters = useSeriesEvents({
    dataKey,
    enableEvents,
    onBlur,
    onFocus,
    onPointerMove,
    onPointerOut,
    onPointerUp,
    onPointerDown,
    source: ownEventSourceKey,
    allowedSources: [XYCHART_EVENT_SOURCE, ownEventSourceKey]
  });
  var captureFocusEvents = Boolean(onFocus || onBlur);
  var renderGlyphs = useCallback(function(_ref3) {
    var glyphs = _ref3.glyphs;
    return captureFocusEvents ? glyphs.map(function(glyph) {
      return /* @__PURE__ */ jsx$1(Fragment, {
        children: defaultRenderGlyph(_extends$1({}, glyph, {
          color: "transparent",
          onFocus: eventEmitters.onFocus,
          onBlur: eventEmitters.onBlur
        }))
      });
    }) : null;
  }, [captureFocusEvents, eventEmitters.onFocus, eventEmitters.onBlur]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(_default, {
      x: getScaledX,
      y: getScaledY,
      defined: isDefined,
      curve,
      ...lineProps,
      children: function(_ref4) {
        var _colorAccessor;
        var path2 = _ref4.path;
        return /* @__PURE__ */ jsx$1(PathComponent, {
          stroke: (_colorAccessor = colorAccessor == null ? void 0 : colorAccessor(dataKey)) != null ? _colorAccessor : color2,
          strokeWidth: 2,
          fill: "transparent",
          strokeLinecap: "round",
          ...lineProps,
          d: path2(data) || "",
          ...eventEmitters
        });
      }
    }), captureFocusEvents && /* @__PURE__ */ jsx$1(BaseGlyphSeries, {
      dataKey,
      data,
      xAccessor,
      yAccessor,
      xScale,
      yScale,
      renderGlyphs
    })]
  });
}
BaseLineSeries.propTypes = {
  colorAccessor: _pt.func
};
var BaseLineSeries$1 = withRegisteredData(BaseLineSeries);
function LineSeries(props) {
  return /* @__PURE__ */ React__default.createElement(BaseLineSeries$1, props);
}
var style$1 = "";
const DrawGraph = ({
  theme,
  width: width2,
  height: height2,
  margin: margin2,
  value
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const graphData = ((_b = (_a = value.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) ? value.main.data : [{
    "No Data": 0
  }];
  const disableLeftLabel = (_c = value.main) == null ? void 0 : _c.disableLeftLabel;
  const xAxisValue = ((_d = value.main) == null ? void 0 : _d.xAxisValue) || "label";
  const legendAvailable = (_f = (_e = value == null ? void 0 : value.main) == null ? void 0 : _e.legendAvailable) != null ? _f : true;
  const labelsArray = Object.keys(graphData[0]).filter((d2) => d2 !== xAxisValue);
  const colorMap = (_g = value.style) == null ? void 0 : _g.colorMap;
  const defaultColour = (_i = (_h = theme.myTheme.palette) == null ? void 0 : _h.primary) == null ? void 0 : _i.main;
  const legendLabels = (_j = value.main) == null ? void 0 : _j.legendLabels;
  const horizontalScale = createBandScale({
    domain: graphData.map((d2) => d2[xAxisValue])
  });
  const verticalScale = createLinearScale({
    domain: [0, Math.max(...graphData.flatMap((d2) => labelsArray.map((key) => d2[key])))]
  });
  const maxHorizontalSpace = width2 - margin2.left - margin2.right;
  const maxVerticalSpace = height2 - margin2.top - margin2.bottom;
  verticalScale.rangeRound([maxVerticalSpace + 10, 10]);
  horizontalScale.rangeRound([Number(margin2.left), maxHorizontalSpace + Number(margin2.left)]);
  return width2 < 10 ? null : /* @__PURE__ */ jsx$1("div", {
    style: {
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      ...value == null ? void 0 : value.style
    },
    children: /* @__PURE__ */ jsxs("div", {
      style: {
        minWidth: `${width2}px`,
        width: `${width2}px`
      },
      children: [legendAvailable && /* @__PURE__ */ jsx$1(Legend, {
        labelsArray,
        legendLabels,
        colorMap,
        value,
        theme: theme.myTheme
      }), /* @__PURE__ */ jsxs(XYChart, {
        margin: margin2,
        width: width2,
        height: height2,
        xScale: {
          type: "band",
          scale: horizontalScale
        },
        yScale: {
          type: "linear",
          scale: verticalScale
        },
        children: [/* @__PURE__ */ jsx$1(Axis, {
          orientation: "left",
          label: !disableLeftLabel ? value.main.leftLabel : void 0,
          labelOffset: margin2.left - 30,
          labelProps: {
            fill: "black",
            fontSize: "12px",
            fontWeight: "normal"
          },
          tickLabelProps: (e3) => ({
            fill: "black",
            fontSize: 10,
            textAnchor: "end",
            dy: "0.33em"
          })
        }), /* @__PURE__ */ jsx$1(Axis, {
          orientation: "bottom",
          label: value.main.bottomLabel,
          labelProps: {
            fill: "black",
            fontSize: "12px",
            fontWeight: "normal"
          },
          tickLabelProps: (e3) => ({
            fill: "black",
            fontSize: 10,
            textAnchor: value.main.bottomAxisAngle ? "start" : "middle",
            angle: value.main.bottomAxisAngle ? 45 : 0
          }),
          tickStroke: "black",
          labelOffset: value.main.bottomAxisAngle ? 45 : 20
        }), /* @__PURE__ */ jsx$1(Grid2, {
          stroke: "black",
          lineStyle: {
            opacity: 0.2
          },
          strokeDasharray: "8 3",
          strokeWidth: 0.3
        }), labelsArray == null ? void 0 : labelsArray.map((elem, i) => {
          var _a2;
          return /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx$1(LineSeries, {
              dataKey: elem,
              data: graphData,
              fill: "none",
              fillOpacity: 0.2,
              stroke: (_a2 = colorMap == null ? void 0 : colorMap[elem]) != null ? _a2 : defaultColour,
              xAccessor: (d2) => d2[xAxisValue],
              yAccessor: (d2) => d2[elem]
            }), graphData.map((datum2, index2) => /* @__PURE__ */ jsx$1("circle", {
              cx: horizontalScale(datum2[xAxisValue]) + horizontalScale.bandwidth() / 2,
              cy: verticalScale(datum2[elem]),
              r: 3,
              fill: "white",
              stroke: "black",
              strokeWidth: 1
            }, index2))]
          });
        }), /* @__PURE__ */ jsx$1(Tooltip2, {
          style: {
            ...defaultStyles,
            backgroundColor: theme.myTheme.palette.secondary.main
          },
          snapTooltipToDatumX: true,
          snapTooltipToDatumY: true,
          showVerticalCrosshair: true,
          showSeriesGlyphs: true,
          renderTooltip: ({
            tooltipData
          }) => {
            return Object.keys(tooltipData.datumByKey).map((d2, i) => {
              var _a2;
              return /* @__PURE__ */ jsxs("div", {
                style: {
                  display: "flex",
                  marginBottom: "2.5px",
                  marginTop: "2.5px"
                },
                children: [/* @__PURE__ */ jsx$1("span", {
                  style: {
                    backgroundColor: (_a2 = colorMap == null ? void 0 : colorMap[d2]) != null ? _a2 : defaultColour,
                    width: "15px",
                    height: "15px",
                    marginRight: "5px"
                  }
                }), /* @__PURE__ */ jsx$1("span", {
                  style: {
                    marginRight: "5px"
                  },
                  children: /* @__PURE__ */ jsxs("span", {
                    style: {
                      fontWeight: "normal",
                      color: "black"
                    },
                    children: [d2, ":", " "]
                  })
                }), /* @__PURE__ */ jsx$1("span", {
                  style: {
                    fontWeight: "normal",
                    color: "black"
                  },
                  children: tooltipData.datumByKey[d2].datum[d2]
                })]
              });
            });
          }
        })]
      })]
    })
  });
};
const LineGraph = ({
  value,
  theme
}) => {
  var _a, _b;
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_b = value.main) == null ? void 0 : _b.header
    }), /* @__PURE__ */ jsx$1(ParentSize$1, {
      children: (parent) => {
        var _a2, _b2, _c, _d, _e, _f;
        return /* @__PURE__ */ jsx$1(DrawGraph, {
          theme,
          width: Math.max(parent.width, 500),
          height: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || 400)),
          margin: {
            top: 10,
            right: 10,
            bottom: ((_c = value.main) == null ? void 0 : _c.bottomAxisAngle) ? 90 : 40,
            left: ((_f = (_e = (_d = value.style) == null ? void 0 : _d.labelStyle) == null ? void 0 : _e.margin) == null ? void 0 : _f.left) || 60
          },
          value
        });
      }
    })]
  });
};
var _excluded = ["children", "id", "from", "to", "x1", "y1", "x2", "y2", "fromOffset", "fromOpacity", "toOffset", "toOpacity", "rotate", "transform", "vertical"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function LinearGradient(_ref) {
  var children2 = _ref.children, id2 = _ref.id, from2 = _ref.from, to = _ref.to, _x1 = _ref.x1, _y1 = _ref.y1, _x2 = _ref.x2, _y2 = _ref.y2, _ref$fromOffset = _ref.fromOffset, fromOffset = _ref$fromOffset === void 0 ? "0%" : _ref$fromOffset, _ref$fromOpacity = _ref.fromOpacity, fromOpacity = _ref$fromOpacity === void 0 ? 1 : _ref$fromOpacity, _ref$toOffset = _ref.toOffset, toOffset = _ref$toOffset === void 0 ? "100%" : _ref$toOffset, _ref$toOpacity = _ref.toOpacity, toOpacity = _ref$toOpacity === void 0 ? 1 : _ref$toOpacity, rotate = _ref.rotate, transform2 = _ref.transform, _ref$vertical = _ref.vertical, vertical = _ref$vertical === void 0 ? true : _ref$vertical, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var x12 = _x1;
  var x2 = _x2;
  var y12 = _y1;
  var y2 = _y2;
  if (vertical && !x12 && !x2 && !y12 && !y2) {
    x12 = "0";
    x2 = "0";
    y12 = "0";
    y2 = "1";
  }
  return /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("linearGradient", _extends({
    id: id2,
    x1: x12,
    y1: y12,
    x2,
    y2,
    gradientTransform: rotate ? "rotate(" + rotate + ")" : transform2
  }, restProps), !!children2 && children2, !children2 && /* @__PURE__ */ React__default.createElement("stop", {
    offset: fromOffset,
    stopColor: from2,
    stopOpacity: fromOpacity
  }), !children2 && /* @__PURE__ */ React__default.createElement("stop", {
    offset: toOffset,
    stopColor: to,
    stopOpacity: toOpacity
  })));
}
LinearGradient.propTypes = {
  id: _pt.string.isRequired,
  from: _pt.string,
  to: _pt.string,
  x1: _pt.oneOfType([_pt.string, _pt.number]),
  x2: _pt.oneOfType([_pt.string, _pt.number]),
  y1: _pt.oneOfType([_pt.string, _pt.number]),
  y2: _pt.oneOfType([_pt.string, _pt.number]),
  fromOffset: _pt.oneOfType([_pt.string, _pt.number]),
  fromOpacity: _pt.oneOfType([_pt.string, _pt.number]),
  toOffset: _pt.oneOfType([_pt.string, _pt.number]),
  toOpacity: _pt.oneOfType([_pt.string, _pt.number]),
  rotate: _pt.oneOfType([_pt.string, _pt.number]),
  transform: _pt.string,
  children: _pt.node,
  vertical: _pt.bool
};
const PX_PER_CHAR$1 = 9;
const LABEL_ROTATION$1 = Math.sin(40 * Math.PI / 180);
const DrawAreaGraph = ({
  width: width2,
  height: height2,
  margin: marginProp,
  areaValue,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const chartData = ((_b = (_a = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) ? areaValue.main.data : [{
    label: "",
    total: 0
  }];
  const xAxisValue = ((_c = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _c.xAxisValue) || "label";
  const xAxisType = ((_d = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _d.xAxisType) || "date";
  const formatType = ((_e = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _e.xAxisSchemaFormat) || ((_f = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _f.xAxisFormatType) || "Date and Month";
  const yAxisTickCount = (_g = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _g.yAxisTickCount;
  const disableLeftLabel = (_h = areaValue.main) == null ? void 0 : _h.disableLeftLabel;
  const legendLabels = (_i = areaValue.main) == null ? void 0 : _i.legendLabels;
  const colorMap = (_j = areaValue.style) == null ? void 0 : _j.colorMap;
  const defaultColour = (_l = (_k = theme.myTheme.palette) == null ? void 0 : _k.primary) == null ? void 0 : _l.main;
  const xAxisTickCount = (_m = areaValue == null ? void 0 : areaValue.main) == null ? void 0 : _m.xAxisTickCount;
  const isSmallScreen = width2 < 600;
  const longestLabelLength = useMemo(() => chartData.length ? Math.max(...chartData.map((d2) => String(d2[xAxisValue]).length)) : 0, [chartData, xAxisValue]);
  const dynamicBottomMargin = Math.ceil(longestLabelLength * PX_PER_CHAR$1 * LABEL_ROTATION$1);
  const margin2 = {
    ...marginProp,
    bottom: isSmallScreen ? Math.max(marginProp.bottom, dynamicBottomMargin) : marginProp.bottom
  };
  const labelsArray = useMemo(() => {
    if (!chartData.length)
      return [];
    return Object.keys(chartData[0]).filter((k2) => k2 !== xAxisValue);
  }, [chartData, xAxisValue]);
  const innerWidth = width2 - margin2.left - margin2.right;
  const innerHeight = height2 - margin2.top - margin2.bottom;
  const parsedData = useMemo(() => {
    if (xAxisType === "date") {
      return chartData.map((dataRow) => ({
        ...dataRow,
        [xAxisValue]: new Date(dataRow[xAxisValue])
      }));
    }
    return chartData;
  }, [chartData, xAxisValue, xAxisType]);
  const xScale = useMemo(() => {
    if (xAxisType === "date") {
      const dates = parsedData.map((dataPoint) => dataPoint[xAxisValue]);
      return createTimeScale({
        range: [0, innerWidth],
        domain: [Math.min(...dates), Math.max(...dates)]
      });
    } else if (xAxisType === "string") {
      const categories = parsedData.map((dataPoint) => dataPoint[xAxisValue]);
      return createPointScale({
        range: [0, innerWidth],
        domain: categories,
        padding: 0
      });
    } else {
      const numbers2 = parsedData.map((dataPoint) => dataPoint[xAxisValue]);
      return createLinearScale({
        range: [0, innerWidth],
        domain: [Math.min(...numbers2), Math.max(...numbers2)],
        nice: true
      });
    }
  }, [parsedData, innerWidth, xAxisValue, xAxisType]);
  const yScale = useMemo(() => {
    const values2 = parsedData.flatMap((dataPoint) => labelsArray.map((key) => dataPoint[key] || 0));
    const maxValue = Math.max(...values2, 0);
    return createLinearScale({
      range: [innerHeight, 0],
      domain: [0, maxValue * 1.1],
      nice: true
    });
  }, [parsedData, labelsArray, innerHeight]);
  const formatXTick = (value) => {
    if (xAxisType === "date") {
      const dateValue = value instanceof Date ? value : new Date(value);
      if (formatType === "Month and Year") {
        return dateValue.toLocaleDateString("en-US", {
          month: "short",
          year: "numeric"
        });
      }
      return dateValue.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short"
      });
    }
    return value;
  };
  const getXPosition = (dataPoint) => {
    var _a2;
    const value = dataPoint[xAxisValue];
    return (_a2 = xScale(value)) != null ? _a2 : 0;
  };
  const handleTooltip = (event) => {
    const {
      x: x2
    } = localPoint(event) || {
      x: 0
    };
    const xValue = x2 - margin2.left;
    const distances = parsedData.map((d2, i) => {
      var _a2;
      return {
        distance: Math.abs(((_a2 = xScale(d2[xAxisValue])) != null ? _a2 : 0) - xValue),
        index: i
      };
    });
    const nearest = distances.reduce((a2, b10) => b10.distance < a2.distance ? b10 : a2);
    const tooltipPoint = parsedData[nearest.index];
    showTooltip({
      tooltipData: tooltipPoint,
      tooltipLeft: getXPosition(tooltipPoint),
      tooltipTop: yScale(tooltipPoint[labelsArray[0]] || 0)
    });
  };
  const tickLabelProps = useCallback(() => isSmallScreen ? {
    fill: "#6B7280",
    fontSize: 12,
    fontWeight: isSmallScreen ? 500 : 600,
    textAnchor: "end",
    angle: -40,
    dx: "-0.2em",
    dy: "0.1em",
    style: {
      transition: "transform 0.2s ease"
    }
  } : {
    fill: "#6B7280",
    fontSize: 12,
    fontWeight: 500,
    textAnchor: "middle",
    style: {
      transition: "transform 0.2s ease"
    }
  }, [isSmallScreen]);
  return /* @__PURE__ */ jsxs("div", {
    style: {
      position: "relative",
      ...(_n = areaValue == null ? void 0 : areaValue.style) == null ? void 0 : _n.wrapperStyle
    },
    children: [/* @__PURE__ */ jsxs("svg", {
      width: width2,
      height: height2,
      children: [labelsArray.map((key) => {
        var _a2, _b2;
        return /* @__PURE__ */ jsx$1(LinearGradient, {
          id: `gradient-${key}`,
          from: (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour,
          to: (_b2 = colorMap == null ? void 0 : colorMap[key]) != null ? _b2 : defaultColour,
          fromOpacity: 0.35,
          toOpacity: 0
        }, key);
      }), /* @__PURE__ */ jsxs(Group, {
        left: margin2.left,
        top: margin2.top,
        children: [/* @__PURE__ */ jsx$1(GridRows$1, {
          scale: yScale,
          width: innerWidth,
          strokeDasharray: "3,3",
          stroke: "#d3d6db",
          strokeOpacity: 0.5
        }), /* @__PURE__ */ jsx$1(GridColumns$1, {
          scale: xScale,
          height: innerHeight,
          strokeDasharray: "3,3",
          stroke: "#d3d6db",
          strokeOpacity: 0.5,
          tickValues: parsedData.map((d2) => d2[xAxisValue])
        }), labelsArray.map((key) => {
          var _a2;
          return /* @__PURE__ */ jsxs(React__default.Fragment, {
            children: [/* @__PURE__ */ jsx$1(AreaClosed, {
              data: parsedData,
              x: (d2) => getXPosition(d2),
              y: (d2) => yScale(d2[key] || 0),
              yScale,
              curve: monotoneX$1,
              fill: `url(#gradient-${key})`
            }), /* @__PURE__ */ jsx$1(LinePath$1, {
              data: parsedData,
              x: (d2) => getXPosition(d2),
              y: (d2) => yScale(d2[key] || 0),
              stroke: (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour,
              strokeWidth: 2,
              curve: monotoneX$1
            }), tooltipOpen && tooltipData && parsedData.map((row, j) => {
              var _a3;
              let isActive = false;
              if (xAxisType === "date") {
                isActive = row[xAxisValue].getTime() === tooltipData[xAxisValue].getTime();
              } else {
                isActive = row[xAxisValue] === tooltipData[xAxisValue];
              }
              if (!isActive)
                return null;
              return /* @__PURE__ */ jsx$1("circle", {
                cx: getXPosition(row),
                cy: yScale(row[key] || 0),
                r: 5,
                fill: (_a3 = colorMap == null ? void 0 : colorMap[key]) != null ? _a3 : defaultColour,
                stroke: "#fff",
                strokeWidth: 2
              }, `${key}-hover-dot-${j}`);
            })]
          }, key);
        }), /* @__PURE__ */ jsx$1(AxisBottom, {
          top: innerHeight,
          scale: xScale,
          label: (_o = areaValue.main) == null ? void 0 : _o.bottomLabel,
          tickFormat: formatXTick,
          stroke: "#d1d5db",
          tickStroke: "#d1d5db",
          tickTransform: xAxisType === "date" ? "translate(8, 0)" : void 0,
          numTicks: xAxisTickCount || 20,
          tickLabelProps
        }), /* @__PURE__ */ jsx$1(AxisLeft, {
          scale: yScale,
          label: !disableLeftLabel ? (_p = areaValue.main) == null ? void 0 : _p.leftLabel : void 0,
          stroke: "#d1d5db",
          tickStroke: "#d1d5db",
          numTicks: yAxisTickCount || 6,
          tickLabelProps: () => ({
            fill: "#6B7280",
            fontSize: 10,
            fontWeight: 600,
            textAnchor: "end",
            dx: -4
          })
        }), /* @__PURE__ */ jsx$1(Bar, {
          width: innerWidth,
          height: innerHeight,
          fill: "transparent",
          onMouseMove: handleTooltip,
          onMouseLeave: hideTooltip,
          onTouchMove: handleTooltip
        }), tooltipData && /* @__PURE__ */ jsx$1(Line$2, {
          from: {
            x: tooltipLeft,
            y: 0
          },
          to: {
            x: tooltipLeft,
            y: innerHeight
          },
          stroke: "#929193",
          strokeWidth: 0.6
        })]
      })]
    }), areaValue.main.legendAvailable && labelsArray.length > 1 && /* @__PURE__ */ jsx$1(Legend, {
      labelsArray,
      legendLabels,
      colorMap,
      value: areaValue,
      theme: theme.myTheme,
      style: {
        flexWrap: "wrap"
      }
    }), tooltipOpen && tooltipData && /* @__PURE__ */ jsxs(TooltipWithBounds$1, {
      top: (tooltipTop != null ? tooltipTop : 0) + margin2.top,
      left: (tooltipLeft != null ? tooltipLeft : 0) + margin2.left,
      style: {
        ...defaultStyles,
        background: "#ffffff",
        borderRadius: "18px",
        padding: "16px 12px 5px 12px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06)",
        fontSize: "12px"
      },
      children: [/* @__PURE__ */ jsx$1("div", {
        style: {
          fontWeight: 600,
          marginBottom: 10
        },
        children: formatXTick(tooltipData[xAxisValue])
      }), labelsArray.map((key, i) => {
        var _a2;
        return /* @__PURE__ */ jsxs("div", {
          style: {
            paddingBottom: "11px",
            fontWeight: 500,
            color: "#756d6d"
          },
          children: [(_a2 = legendLabels == null ? void 0 : legendLabels[key]) != null ? _a2 : key, " : ", tooltipData[key]]
        }, key);
      })]
    })]
  });
};
const AreaGraph = ({
  value,
  theme
}) => {
  var _a, _b, _c, _d, _e;
  const GraphRender = /* @__PURE__ */ jsx$1(ParentSize$1, {
    children: (parent) => {
      var _a2, _b2, _c2, _d2, _e2, _f;
      return /* @__PURE__ */ jsx$1(DrawAreaGraph, {
        theme,
        width: parent.width,
        height: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || "300")),
        margin: {
          top: 40,
          right: 20,
          bottom: ((_c2 = value.main) == null ? void 0 : _c2.bottomAxisAngle) ? 90 : 50,
          left: ((_f = (_e2 = (_d2 = value.style) == null ? void 0 : _d2.labelStyle) == null ? void 0 : _e2.margin) == null ? void 0 : _f.left) || 60
        },
        areaValue: value
      });
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: ((_b = value.main) == null ? void 0 : _b.subHeader) ? "6px" : "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_c = value.main) == null ? void 0 : _c.header
    }), ((_d = value.main) == null ? void 0 : _d.subHeader) && /* @__PURE__ */ jsx$1("div", {
      style: {
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "12px",
        padding: "0 0 0 20px",
        width: "100%",
        fontSize: "12px",
        color: "#979393ff"
      },
      children: (_e = value.main) == null ? void 0 : _e.subHeader
    }), GraphRender]
  });
};
const PX_PER_CHAR = 9;
const LABEL_ROTATION = Math.sin(40 * Math.PI / 180);
const DrawStackBarLineGraph = ({
  width: width2,
  height: height2,
  margin: marginProp,
  stackBarLineValue,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const chartData = ((_b = (_a = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) ? stackBarLineValue.main.data : [];
  const xAxisValue = ((_c = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _c.xAxisValue) || "label";
  const legendAvailable = (_e = (_d = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _d.legendAvailable) != null ? _e : true;
  const legendLabels = (_f = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _f.legendLabels;
  const growthRateKey = ((_g = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _g.growthRateKey) || "growthRate";
  const colorMap = (_h = stackBarLineValue == null ? void 0 : stackBarLineValue.style) == null ? void 0 : _h.colorMap;
  const defaultColour = (_k = (_j = (_i = theme == null ? void 0 : theme.myTheme) == null ? void 0 : _i.palette) == null ? void 0 : _j.primary) == null ? void 0 : _k.main;
  const yAxisTickCount = (_l = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _l.yAxisTickCount;
  const disableLeftLabel = (_m = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _m.disableLeftLabel;
  const tooltipUnit = (_n = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _n.tooltipUnit;
  (_o = colorMap == null ? void 0 : colorMap[growthRateKey]) != null ? _o : "#E24B4A";
  const xAxisTickCount = (_p = stackBarLineValue == null ? void 0 : stackBarLineValue.main) == null ? void 0 : _p.xAxisTickCount;
  const isSmallScreen = width2 < 600;
  const longestLabelLength = useMemo(() => chartData.length ? Math.max(...chartData.map((d2) => String(d2[xAxisValue]).length)) : 0, [chartData, xAxisValue]);
  const dynamicBottomMargin = Math.ceil(longestLabelLength * PX_PER_CHAR * LABEL_ROTATION);
  const margin2 = {
    ...marginProp,
    bottom: isSmallScreen ? Math.max(marginProp.bottom, dynamicBottomMargin) : marginProp.bottom
  };
  const labelsArray = useMemo(() => {
    if (!chartData.length)
      return [];
    return Object.keys(chartData[0]).filter((k2) => k2 !== xAxisValue);
  }, [chartData, xAxisValue]);
  const barKeys = useMemo(() => labelsArray.filter((k2) => k2 !== growthRateKey), [labelsArray, growthRateKey]);
  const barData = useMemo(() => chartData.map((row) => {
    const stripped = {
      [xAxisValue]: row[xAxisValue]
    };
    barKeys.forEach((k2) => {
      stripped[k2] = row[k2];
    });
    return stripped;
  }), [chartData, xAxisValue, barKeys]);
  const innerWidth = width2 - margin2.left - margin2.right;
  const innerHeight = height2 - margin2.top - margin2.bottom;
  const categoryScale = useMemo(() => createBandScale({
    domain: chartData.map((d2) => d2[xAxisValue]),
    range: [0, innerWidth],
    padding: 0.25
  }), [chartData, xAxisValue, innerWidth]);
  const maxStacked = useMemo(() => Math.max(...chartData.map((d2) => barKeys.reduce((sum2, k2) => sum2 + (Number(d2[k2]) || 0), 0))), [chartData, barKeys]);
  const barScale = useMemo(() => createLinearScale({
    domain: [0, maxStacked * 1.15],
    range: [innerHeight, 0],
    nice: true
  }), [innerHeight, maxStacked]);
  const trendScale = useMemo(() => {
    const vals = chartData.map((d2) => Number(d2[growthRateKey]) || 0);
    const min2 = Math.min(...vals);
    const max2 = Math.max(...vals);
    return createLinearScale({
      domain: min2 === max2 ? [min2 - 1, max2 + 1] : [min2, max2],
      range: [innerHeight, 0],
      nice: true
    });
  }, [chartData, innerHeight, growthRateKey]);
  const getBarCentreX = useCallback((cat) => {
    var _a2;
    return ((_a2 = categoryScale(cat)) != null ? _a2 : 0) + categoryScale.bandwidth() / 2;
  }, [categoryScale]);
  useCallback((d2) => getBarCentreX(d2[xAxisValue]), [getBarCentreX, xAxisValue]);
  useCallback((d2) => trendScale(Number(d2[growthRateKey]) || 0), [trendScale, growthRateKey]);
  const handleColumnEnter = useCallback((_e2, cat) => {
    const full = chartData.find((d2) => d2[xAxisValue] === cat);
    const dotX = getBarCentreX(cat) + margin2.left;
    const dotY = trendScale(Number(full[growthRateKey]) || 0) + margin2.top;
    setHoveredCategory(cat);
    showTooltip({
      tooltipData: full,
      tooltipLeft: dotX + 14,
      tooltipTop: dotY - 12
    });
  }, [chartData, xAxisValue, trendScale, margin2, showTooltip, getBarCentreX, growthRateKey]);
  const handleColumnLeave = useCallback(() => {
    setHoveredCategory(null);
    hideTooltip();
  }, [hideTooltip]);
  const tickLabelProps = useCallback(() => isSmallScreen ? {
    fill: "#6B7280",
    fontSize: 12,
    fontWeight: 500,
    textAnchor: "end",
    angle: -40,
    dx: "-0.2em",
    dy: "0.1em",
    style: {
      transition: "transform 0.2s ease"
    }
  } : {
    fill: "#6B7280",
    fontSize: 12,
    fontWeight: 500,
    textAnchor: "middle",
    style: {
      transition: "transform 0.2s ease"
    }
  }, [isSmallScreen]);
  return /* @__PURE__ */ jsxs("div", {
    style: {
      position: "relative",
      ...(_q = stackBarLineValue == null ? void 0 : stackBarLineValue.style) == null ? void 0 : _q.wrapperStyle
    },
    children: [/* @__PURE__ */ jsx$1("svg", {
      width: width2,
      height: height2,
      overflow: "visible",
      children: /* @__PURE__ */ jsxs(Group, {
        left: margin2.left,
        top: margin2.top,
        children: [/* @__PURE__ */ jsx$1(BarStack, {
          data: barData,
          keys: barKeys,
          x: (d2) => d2[xAxisValue],
          xScale: categoryScale,
          yScale: barScale,
          color: (key) => {
            var _a2;
            return (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour;
          },
          children: (barStacks) => {
            const topStackIndex = barStacks.length - 1;
            return barStacks.map((barStack, stackIdx) => barStack.bars.map((bar) => {
              const isTop = stackIdx === topStackIndex;
              const borderRadius2 = 6;
              return isTop ? /* @__PURE__ */ jsx$1("path", {
                d: `
                      M ${bar.x + borderRadius2},${bar.y}
                      h ${bar.width - 2 * borderRadius2}
                      q ${borderRadius2},0 ${borderRadius2},${borderRadius2}
                      v ${bar.height - borderRadius2}
                      h ${-bar.width}
                      v ${-(bar.height - borderRadius2)}
                      q 0,${-borderRadius2} ${borderRadius2},${-borderRadius2}
                      z
                    `,
                fill: bar.color,
                opacity: 0.88
              }, `bar-${barStack.index}-${bar.index}`) : /* @__PURE__ */ jsx$1("rect", {
                x: bar.x,
                y: bar.y,
                width: bar.width,
                height: bar.height,
                fill: bar.color,
                opacity: 0.88
              }, `bar-${barStack.index}-${bar.index}`);
            }));
          }
        }), /* @__PURE__ */ jsx$1(GridRows$1, {
          scale: barScale,
          width: innerWidth,
          stroke: "#989da4",
          strokeDasharray: "3,3",
          strokeWidth: 0.2,
          numTicks: 6
        }), /* @__PURE__ */ jsx$1(GridColumns$1, {
          scale: categoryScale,
          height: innerHeight,
          stroke: "#989da4",
          strokeWidth: 0.2,
          strokeDasharray: "3,3",
          tickValues: chartData.map((d2) => d2[xAxisValue])
        }), hoveredCategory && /* @__PURE__ */ jsx$1("line", {
          x1: getBarCentreX(hoveredCategory),
          x2: getBarCentreX(hoveredCategory),
          y1: 0,
          y2: innerHeight,
          stroke: "#9CA3AF",
          strokeWidth: 1,
          pointerEvents: "none"
        }), chartData.map((d2) => {
          var _a2;
          return /* @__PURE__ */ jsx$1("rect", {
            x: (_a2 = categoryScale(d2[xAxisValue])) != null ? _a2 : 0,
            y: 0,
            width: categoryScale.bandwidth(),
            height: innerHeight,
            fill: "transparent",
            style: {
              cursor: "crosshair"
            },
            onMouseEnter: (e3) => handleColumnEnter(e3, d2[xAxisValue]),
            onMouseLeave: handleColumnLeave
          }, `hit-${d2[xAxisValue]}`);
        }), /* @__PURE__ */ jsx$1(AxisLeft, {
          scale: barScale,
          numTicks: yAxisTickCount || 5,
          stroke: "#9CA3AF",
          tickStroke: "transparent",
          tickLabelProps: () => ({
            fill: "#6B7280",
            fontSize: 11,
            textAnchor: "end",
            dy: "0.33em"
          }),
          label: !disableLeftLabel ? (_r = stackBarLineValue.main) == null ? void 0 : _r.leftLabel : void 0,
          labelProps: {
            fill: "#6B7280",
            fontSize: 11,
            textAnchor: "middle",
            dx: -5
          }
        }), /* @__PURE__ */ jsx$1(AxisBottom, {
          top: innerHeight,
          scale: categoryScale,
          stroke: "#9CA3AF",
          label: (_s = stackBarLineValue.main) == null ? void 0 : _s.bottomLabel,
          numTicks: xAxisTickCount || 20,
          tickStroke: "transparent",
          tickLabelProps
        })]
      })
    }), legendAvailable && labelsArray.length > 0 && /* @__PURE__ */ jsx$1(Legend, {
      labelsArray,
      legendLabels,
      colorMap,
      value: stackBarLineValue,
      theme: theme.myTheme,
      style: {
        flexWrap: "wrap"
      }
    }), tooltipOpen && tooltipData && /* @__PURE__ */ jsxs(TooltipWithBounds$1, {
      top: tooltipTop,
      left: tooltipLeft,
      style: {
        ...defaultStyles,
        background: "#ffffff",
        borderRadius: "18px",
        padding: "16px 12px 5px 12px",
        border: "1px solid #E5E7EB",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06)",
        fontSize: "12px"
      },
      children: [/* @__PURE__ */ jsx$1("div", {
        style: {
          fontWeight: 600,
          marginBottom: 10
        },
        children: tooltipData[xAxisValue]
      }), labelsArray.map((key, i) => {
        var _a2;
        return /* @__PURE__ */ jsxs("div", {
          style: {
            paddingBottom: "11px",
            fontWeight: 500,
            color: "#756d6d"
          },
          children: [(_a2 = legendLabels == null ? void 0 : legendLabels[key]) != null ? _a2 : key, " : ", tooltipData[key], tooltipUnit]
        }, key);
      })]
    })]
  });
};
const StackBarLineGraph = ({
  value,
  theme
}) => {
  var _a, _b, _c, _d, _e;
  const GraphRender = /* @__PURE__ */ jsx$1(ParentSize$1, {
    children: (parent) => {
      var _a2, _b2, _c2, _d2, _e2;
      return /* @__PURE__ */ jsx$1(DrawStackBarLineGraph, {
        theme,
        width: parent.width,
        height: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || "300")),
        margin: {
          top: 40,
          right: 80,
          bottom: 50,
          left: ((_e2 = (_d2 = (_c2 = value.style) == null ? void 0 : _c2.labelStyle) == null ? void 0 : _d2.margin) == null ? void 0 : _e2.left) || 60
        },
        stackBarLineValue: value
      });
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: ((_b = value.main) == null ? void 0 : _b.subHeader) ? "6px" : "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_c = value.main) == null ? void 0 : _c.header
    }), ((_d = value.main) == null ? void 0 : _d.subHeader) && /* @__PURE__ */ jsx$1("div", {
      style: {
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "12px",
        padding: "0 0 0 20px",
        width: "100%",
        fontSize: "12px",
        color: "#979393ff"
      },
      children: (_e = value.main) == null ? void 0 : _e.subHeader
    }), GraphRender]
  });
};
var DrawHorizontalBarGraph = ({
  theme,
  width: width2 = 600,
  height: height2 = 400,
  margin: margin2,
  barValue
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const [hoveredBar, setHoveredBar] = useState({});
  const graphData = ((_b = (_a = barValue.main) == null ? void 0 : _a.data) == null ? void 0 : _b.length) ? barValue.main.data : [{}];
  const disableLeftLabel = (_c = barValue.main) == null ? void 0 : _c.disableLeftLabel;
  const xAxisValue = ((_d = barValue.main) == null ? void 0 : _d.xAxisValue) || "label";
  const labelsArray = graphData.length ? Object.keys(graphData[0]).filter((d2) => d2 !== xAxisValue) : [];
  const legendAvailable = (_f = (_e = barValue == null ? void 0 : barValue.main) == null ? void 0 : _e.legendAvailable) != null ? _f : true;
  const colorMap = (_g = barValue.style) == null ? void 0 : _g.colorMap;
  const legendLabels = (_h = barValue.main) == null ? void 0 : _h.legendLabels;
  const defaultColour = (_j = (_i = theme.myTheme.palette) == null ? void 0 : _i.primary) == null ? void 0 : _j.main;
  const labelsValueSum = graphData.map((currentBar) => labelsArray.reduce((sum2, k2) => sum2 += Number(currentBar[k2]), 0));
  const getDataLabel = (d2) => d2[xAxisValue];
  const horizontalScale = createLinearScale({
    domain: barValue.main.type === "HorizontalStackBarGraph" ? [0, Math.max(...labelsValueSum)] : [0, Math.max(...graphData.flatMap((d2) => labelsArray.map((key) => Number(d2[key]))))],
    nice: true
  });
  const verticalScale = createBandScale({
    domain: graphData.map(getDataLabel),
    padding: 0.4
  });
  const verticalSubScale = createBandScale({
    domain: labelsArray
  });
  const colorScale = createOrdinalScale$1({
    domain: labelsArray,
    range: labelsArray.map((key) => {
      var _a2;
      return (_a2 = colorMap == null ? void 0 : colorMap[key]) != null ? _a2 : defaultColour;
    })
  });
  const maxHorizontalSpace = width2 - margin2.left - margin2.right;
  const maxVerticalSpace = height2 - margin2.top - margin2.bottom;
  horizontalScale.rangeRound([0, maxHorizontalSpace]);
  verticalScale.rangeRound([maxVerticalSpace, 0]);
  verticalSubScale.rangeRound([0, verticalScale.bandwidth()]);
  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const handleMouseIn = (event, bar, barGroup) => {
    setHoveredBar({
      bar: barGroup,
      subBarIndex: bar.index
    });
    showTooltip({
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
      tooltipData: {
        barData: graphData[barGroup.index],
        hoveredSubBar: bar
      }
    });
  };
  const handleMouseOut = (event) => {
    setHoveredBar({
      bar: null,
      subBarIndex: null
    });
    hideTooltip();
  };
  const stackhHandleMouseIn = (event, bar, barGroup) => {
    setHoveredBar({
      bar: barGroup,
      subBarIndex: bar.index
    });
    showTooltip({
      tooltipLeft: event.clientX,
      tooltipTop: event.clientY,
      tooltipData: {
        barData: graphData[bar.index],
        hoveredSubBar: bar
      }
    });
  };
  function calcWidthofBar(y2) {
    return y2 == null ? void 0 : y2.bars.reduce((totalWidth, bar) => totalWidth + Math.min(bar.height, 15), 0);
  }
  function calcPositionofBar(bar, subBar, graphType) {
    var _a2, _b2, _c2;
    const actualBarWidth = Math.min(subBar == null ? void 0 : subBar.height, 15);
    if (graphType === "stack") {
      return (subBar == null ? void 0 : subBar.y) - (actualBarWidth - (subBar == null ? void 0 : subBar.height)) / 2;
    }
    if (graphType === "grouphov") {
      return (bar == null ? void 0 : bar.y0) + ((subBar == null ? void 0 : subBar.height) - actualBarWidth) * ((_a2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _a2.length) / 2;
    }
    if ((subBar == null ? void 0 : subBar.index) === 0) {
      return (subBar == null ? void 0 : subBar.y) + ((subBar == null ? void 0 : subBar.height) - actualBarWidth) * ((_b2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _b2.length) / 2;
    }
    return (subBar == null ? void 0 : subBar.y) - ((subBar == null ? void 0 : subBar.height) - actualBarWidth) * ((subBar == null ? void 0 : subBar.index) - ((_c2 = bar == null ? void 0 : bar.bars) == null ? void 0 : _c2.length) / 2);
  }
  return width2 < 10 ? null : /* @__PURE__ */ jsx$1("div", {
    style: {
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      ...barValue == null ? void 0 : barValue.style
    },
    children: /* @__PURE__ */ jsxs("div", {
      style: {
        minWidth: `${width2}px`,
        width: `${width2}px`
      },
      children: [legendAvailable && labelsArray.length > 1 && /* @__PURE__ */ jsx$1(Legend, {
        labelsArray,
        legendLabels,
        colorMap,
        value: barValue,
        theme: theme.myTheme
      }), /* @__PURE__ */ jsxs("svg", {
        width: width2,
        height: height2,
        children: [/* @__PURE__ */ jsx$1("rect", {
          x: 0,
          y: 0,
          width: width2,
          height: height2,
          fill: theme.myTheme.palette.background.default
        }), /* @__PURE__ */ jsx$1(Grid$1, {
          top: margin2.top,
          left: margin2.left,
          xScale: horizontalScale,
          yScale: verticalScale,
          width: maxHorizontalSpace,
          height: maxVerticalSpace,
          stroke: "black",
          xOffset: verticalScale.bandwidth() / 50,
          strokeDasharray: "8 3",
          strokeOpacity: 0.2,
          strokeWidth: 0.3
        }), /* @__PURE__ */ jsxs(Group, {
          top: margin2.top,
          left: margin2.left,
          children: [hoveredBar && /* @__PURE__ */ jsx$1("rect", {
            style: {
              display: hoveredBar.bar ? "block" : "none"
            },
            y: barValue.main.type === "HorizontalStackBarGraph" ? calcPositionofBar(hoveredBar.bar, (_k = hoveredBar.bar) == null ? void 0 : _k.bars[hoveredBar.subBarIndex], "stack") : calcPositionofBar(hoveredBar.bar, (_l = hoveredBar.bar) == null ? void 0 : _l.bars[hoveredBar.subBarIndex], "grouphov"),
            width: maxHorizontalSpace,
            height: barValue.main.type !== "HorizontalStackBarGraph" ? calcWidthofBar(hoveredBar.bar) : Math.min((_m = hoveredBar.bar) == null ? void 0 : _m.bars[0].height, 15),
            fill: theme.myTheme.palette.secondary.main,
            opacity: 1
          }), barValue.main.type === "HorizontalStackBarGraph" ? /* @__PURE__ */ jsx$1(BarStackHorizontal, {
            data: graphData,
            keys: labelsArray,
            height: maxVerticalSpace,
            y: getDataLabel,
            xScale: horizontalScale,
            yScale: verticalScale,
            color: colorScale,
            children: (barStacks) => barStacks.map((barStack) => barStack.bars.map((bar) => /* @__PURE__ */ jsx$1("rect", {
              x: bar.x,
              y: calcPositionofBar(barStack, bar, "stack"),
              width: bar.width,
              height: Math.min(bar.height, 15),
              fill: bar.color,
              onMouseOver: (e3) => stackhHandleMouseIn(e3, bar, barStack),
              onMouseOut: (e3) => handleMouseOut(),
              stroke: hoveredBar.subBarIndex === bar.index ? "black" : "transparent"
            }, `barstack-horizontal-${barStack.index}-${bar.index}`)))
          }) : /* @__PURE__ */ jsx$1(BarGroupHorizontal, {
            data: graphData,
            keys: labelsArray,
            width: maxHorizontalSpace,
            height: maxVerticalSpace,
            y0: getDataLabel,
            y0Scale: verticalScale,
            y1Scale: verticalSubScale,
            xScale: horizontalScale,
            color: (key, index2) => {
              return (hoveredBar == null ? void 0 : hoveredBar.subBarIndex) == null || (hoveredBar == null ? void 0 : hoveredBar.subBarIndex) === index2 ? colorScale(key) : `${colorScale(key)}50`;
            },
            children: (barGroups) => barGroups.map((barGroup) => /* @__PURE__ */ jsx$1(Group, {
              top: barGroup.y0,
              children: barGroup.bars.map((bar) => {
                return /* @__PURE__ */ jsx$1("rect", {
                  y: calcPositionofBar(barGroup, bar, "group"),
                  x: bar.x,
                  width: bar.width,
                  height: Math.min(bar.height, 15),
                  fill: bar.color,
                  onMouseOver: (e3) => handleMouseIn(e3, bar, barGroup),
                  onMouseOut: (e3) => handleMouseOut(),
                  stroke: hoveredBar.subBarIndex === bar.index ? "black" : "transparent"
                }, `bar-group-bar-${barGroup.index}-${bar.index}-${bar.value}-${bar.key}`);
              })
            }, `bar-group-${barGroup.index}-${barGroup.y0}`))
          }), /* @__PURE__ */ jsx$1(LeftAxis, {
            value: {
              ...barValue,
              main: {
                ...barValue.main,
                leftLabel: !disableLeftLabel ? barValue.main.leftLabel : void 0
              }
            },
            yScale: verticalScale,
            parentWidth: width2,
            theme,
            leftMargin: margin2.left
          }), /* @__PURE__ */ jsx$1(BottomAxis, {
            value: barValue,
            yMax: maxVerticalSpace,
            xScale: horizontalScale,
            parentWidth: width2,
            theme
          })]
        })]
      }), tooltipOpen && tooltipData && /* @__PURE__ */ jsx$1(ToolTip, {
        value: barValue,
        theme,
        top: tooltipTop,
        left: tooltipLeft,
        tooltipData,
        colorScale
      })]
    })
  });
};
const HorizontalBarGraph = ({
  value,
  theme
}) => {
  var _a, _b;
  const GraphRender = /* @__PURE__ */ jsx$1(ParentSize$1, {
    children: (parent) => {
      var _a2, _b2, _c, _d, _e, _f;
      return /* @__PURE__ */ jsx$1(DrawHorizontalBarGraph, {
        theme,
        width: Math.max(parent.width, 500),
        height: parseInt(String(((_b2 = (_a2 = value.style) == null ? void 0 : _a2.containerStyle) == null ? void 0 : _b2.height) || "300")),
        margin: {
          top: 10,
          right: 20,
          bottom: ((_c = value.main) == null ? void 0 : _c.bottomAxisAngle) ? 90 : 40,
          left: ((_f = (_e = (_d = value.style) == null ? void 0 : _d.labelStyle) == null ? void 0 : _e.margin) == null ? void 0 : _f.left) || 60
        },
        barValue: value
      });
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [((_a = value.main) == null ? void 0 : _a.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: "bold",
        textAlign: "left",
        fontFamily: "inherit",
        marginBottom: "20px",
        padding: "15px 0 1px 20px",
        width: "100%",
        fontSize: "22px",
        color: theme.myTheme.palette.text.primary
      },
      children: (_b = value.main) == null ? void 0 : _b.header
    }), GraphRender]
  });
};
var style = "";
const ProgressBar = ({
  value,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t5, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K;
  const [progress, setProgress] = useState(((_a = value.main.data) == null ? void 0 : _a.achieved) / ((_b = value.main.data) == null ? void 0 : _b.total) * 100);
  useEffect(() => {
    var _a2, _b2;
    setProgress(((_a2 = value.main.data) == null ? void 0 : _a2.achieved) / ((_b2 = value.main.data) == null ? void 0 : _b2.total) * 100);
  }, [value.main.data]);
  const getColor = () => {
    return [`${theme.myTheme.palette.grey[300]}`, `${theme.myTheme.palette.primary.dark}`];
  };
  const StyledTooltip = styled$1(({
    className,
    ...props
  }) => /* @__PURE__ */ jsx$1(Tooltip$2, {
    ...props,
    classes: {
      popper: className
    }
  }))(({}) => ({
    [`& .${tooltipClasses$1.tooltip}`]: {
      "& .MuiTooltip-arrow": {
        color: theme.myTheme.palette.secondary.main
      },
      backgroundColor: theme.myTheme.palette.secondary.main,
      color: theme.myTheme.palette.text.primary,
      fontSize: 11,
      boxShadow: `1px 2px ${theme.myTheme.palette.secondary.dark}`
    }
  }));
  if (value.main.developOnlyProgresBar) {
    return /* @__PURE__ */ jsx$1(StyledTooltip, {
      arrow: true,
      title: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs("div", {
          style: {
            fontWeight: "normal",
            textAlign: "center"
          },
          children: [" ", "Target Achieved", " "]
        }), /* @__PURE__ */ jsxs("div", {
          style: {
            fontWeight: "bold",
            textAlign: "center"
          },
          children: [" ", (_c = value.main.data) == null ? void 0 : _c.achieved]
        })]
      }),
      placement: "top-end",
      theme,
      children: /* @__PURE__ */ jsx$1(Box$1, {
        className: "progress-bar-fill",
        sx: {
          width: progress > 100 ? "100%" : `${progress}%`,
          backgroundColor: getColor()[1],
          height: "100%",
          borderRadius: "10px",
          marginBottom: "0px",
          transition: "width 0.5 ease-out",
          position: "relative",
          border: "1px solid transparent",
          "&:hover": {
            border: "1px solid black"
          }
        },
        children: /* @__PURE__ */ jsx$1("div", {
          style: {
            borderRadius: "50%",
            width: "7px",
            height: "7px",
            backgroundColor: `${theme.myTheme.palette.common.white}`,
            position: "absolute",
            top: "2px",
            right: `2px`
          }
        })
      })
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "container",
    style: {
      backgroundColor: (_e = (_d = theme.myTheme) == null ? void 0 : _d.palette) == null ? void 0 : _e.background.main,
      color: (_h = (_g = (_f = theme.myTheme) == null ? void 0 : _f.palette) == null ? void 0 : _g.text) == null ? void 0 : _h.primary,
      width: "auto",
      height: "auto",
      margin: "auto",
      position: "relative",
      top: "50%",
      transform: "translateY(-50%)"
    },
    children: [/* @__PURE__ */ jsxs("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        width: "99%"
      },
      children: [/* @__PURE__ */ jsx$1("div", {
        style: {
          padding: "23px 0px 0px 35px",
          marginBottom: "-13px",
          textAlign: "left",
          fontFamily: "inherit",
          fontSize: "16px",
          color: ((_k = (_j = (_i = theme.myTheme) == null ? void 0 : _i.palette) == null ? void 0 : _j.text) == null ? void 0 : _k.secondary) || "#121926"
        },
        children: value.main.heading
      }), /* @__PURE__ */ jsxs("div", {
        style: {
          padding: "25px 0px 0px 55px",
          marginBottom: "-13px",
          textAlign: "left",
          fontFamily: "inherit",
          fontSize: "16px",
          color: ((_n = (_m = (_l = theme.myTheme) == null ? void 0 : _l.palette) == null ? void 0 : _m.text) == null ? void 0 : _n.primary) || "black"
        },
        children: [progress.toFixed(2), "%"]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      style: {
        padding: "0px",
        height: "auto"
      },
      children: [/* @__PURE__ */ jsxs("div", {
        style: {
          width: "100%",
          height: "6px",
          margin: "auto",
          borderRadius: "10px",
          marginBottom: "15px",
          position: "relative"
        },
        children: [/* @__PURE__ */ jsx$1("div", {
          style: {
            width: "-webkit-fill-available",
            height: "12px",
            margin: "auto",
            borderRadius: "10px",
            backgroundColor: getColor()[0],
            marginBottom: "0px",
            position: "absolute",
            top: "10px",
            left: "12.5px"
          },
          children: /* @__PURE__ */ jsx$1(StyledTooltip, {
            arrow: true,
            title: /* @__PURE__ */ jsxs(Fragment, {
              children: [/* @__PURE__ */ jsxs("div", {
                style: {
                  fontWeight: "normal",
                  textAlign: "center"
                },
                children: [" ", "Target Achieved", " "]
              }), /* @__PURE__ */ jsxs("div", {
                style: {
                  fontWeight: "bold",
                  textAlign: "center"
                },
                children: [" ", (_o = value.main.data) == null ? void 0 : _o.achieved]
              })]
            }),
            placement: "top-end",
            theme,
            children: /* @__PURE__ */ jsx$1(Box$1, {
              className: "progress-bar-fill",
              sx: {
                width: progress > 100 ? "100%" : `${progress}%`,
                backgroundColor: getColor()[1],
                height: "100%",
                borderRadius: "10px",
                marginBottom: "0px",
                transition: "width 0.5 ease-out",
                position: "relative",
                border: "1px solid transparent",
                "&:hover": {
                  border: "1px solid black"
                }
              },
              children: /* @__PURE__ */ jsx$1("div", {
                style: {
                  borderRadius: "50%",
                  width: "7px",
                  height: "7px",
                  backgroundColor: `${theme.myTheme.palette.common.white}`,
                  position: "absolute",
                  top: "2px",
                  right: `2px`
                }
              })
            })
          })
        }), /* @__PURE__ */ jsx$1("div", {
          style: {
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            backgroundColor: `${theme.myTheme.palette.grey[300]}`,
            position: "absolute",
            top: "0px"
          }
        })]
      }), /* @__PURE__ */ jsxs("div", {
        style: {
          display: "flex",
          color: (_r = (_q = (_p = theme.myTheme) == null ? void 0 : _p.palette) == null ? void 0 : _q.text) == null ? void 0 : _r.primary,
          paddingLeft: "25px",
          width: "98%",
          margin: "auto"
        },
        children: [/* @__PURE__ */ jsxs("div", {
          style: {
            width: "33.33%"
          },
          children: [/* @__PURE__ */ jsx$1("div", {
            style: {
              textAlign: "left",
              fontSize: "14px",
              color: (_t5 = (_s = theme.myTheme) == null ? void 0 : _s.palette) == null ? void 0 : _t5.grey[600]
            },
            children: value.main.bottomLabel_1 || "Target"
          }), /* @__PURE__ */ jsx$1("div", {
            style: {
              color: (_v = (_u = theme.myTheme) == null ? void 0 : _u.palette) == null ? void 0 : _v.grey[600],
              textAlign: "left"
            },
            children: ((_w = value.main.data) == null ? void 0 : _w.total) || ((_x = value.main.data) == null ? void 0 : _x.bottomLabel_1_value)
          })]
        }), /* @__PURE__ */ jsxs("div", {
          style: {
            width: "33.33%"
          },
          children: [/* @__PURE__ */ jsx$1("div", {
            style: {
              textAlign: "center",
              fontSize: "14px",
              color: (_z = (_y = theme.myTheme) == null ? void 0 : _y.palette) == null ? void 0 : _z.grey[600]
            },
            children: value.main.bottomLabel_2 || "Achieved"
          }), /* @__PURE__ */ jsx$1("div", {
            style: {
              textAlign: "center",
              color: (_B = (_A = theme.myTheme) == null ? void 0 : _A.palette) == null ? void 0 : _B.grey[600]
            },
            children: ((_C = value.main.data) == null ? void 0 : _C.achieved) || ((_D = value.main.data) == null ? void 0 : _D.bottomLabel_2_value)
          })]
        }), /* @__PURE__ */ jsxs("div", {
          style: {
            width: "33.33%"
          },
          children: [/* @__PURE__ */ jsx$1("div", {
            style: {
              textAlign: "right",
              fontSize: "14px",
              color: (_F = (_E = theme.myTheme) == null ? void 0 : _E.palette) == null ? void 0 : _F.grey[600]
            },
            children: value.main.bottomLabel_3 || "Remaining"
          }), /* @__PURE__ */ jsx$1("div", {
            style: {
              textAlign: "right",
              color: (_H = (_G = theme.myTheme) == null ? void 0 : _G.palette) == null ? void 0 : _H.grey[600]
            },
            children: Math.max(0, ((_I = value.main.data) == null ? void 0 : _I.remaining) || ((_J = value.main.data) == null ? void 0 : _J.total) - ((_K = value.main.data) == null ? void 0 : _K.achieved))
          })]
        })]
      })]
    })]
  });
};
var dist$1 = {};
var interopRequireWildcard = { exports: {} };
var _typeof = { exports: {} };
(function(module2) {
  function _typeof2(o) {
    "@babel/helpers - typeof";
    return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
      return typeof o2;
    } : function(o2) {
      return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(o);
  }
  module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(_typeof);
(function(module2) {
  var _typeof$1 = _typeof.exports["default"];
  function _getRequireWildcardCache2(e3) {
    if ("function" != typeof WeakMap)
      return null;
    var r2 = /* @__PURE__ */ new WeakMap(), t4 = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache2 = function _getRequireWildcardCache3(e4) {
      return e4 ? t4 : r2;
    })(e3);
  }
  function _interopRequireWildcard2(e3, r2) {
    if (!r2 && e3 && e3.__esModule)
      return e3;
    if (null === e3 || "object" != _typeof$1(e3) && "function" != typeof e3)
      return {
        "default": e3
      };
    var t4 = _getRequireWildcardCache2(r2);
    if (t4 && t4.has(e3))
      return t4.get(e3);
    var n2 = {
      __proto__: null
    }, a2 = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in e3)
      if ("default" !== u && {}.hasOwnProperty.call(e3, u)) {
        var i = a2 ? Object.getOwnPropertyDescriptor(e3, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n2, u, i) : n2[u] = e3[u];
      }
    return n2["default"] = e3, t4 && t4.set(e3, n2), n2;
  }
  module2.exports = _interopRequireWildcard2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(interopRequireWildcard);
var classCallCheck = { exports: {} };
(function(module2) {
  function _classCallCheck(a2, n2) {
    if (!(a2 instanceof n2))
      throw new TypeError("Cannot call a class as a function");
  }
  module2.exports = _classCallCheck, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(classCallCheck);
var createClass = { exports: {} };
var toPropertyKey = { exports: {} };
var toPrimitive = { exports: {} };
(function(module2) {
  var _typeof$1 = _typeof.exports["default"];
  function toPrimitive2(t4, r2) {
    if ("object" != _typeof$1(t4) || !t4)
      return t4;
    var e3 = t4[Symbol.toPrimitive];
    if (void 0 !== e3) {
      var i = e3.call(t4, r2 || "default");
      if ("object" != _typeof$1(i))
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r2 ? String : Number)(t4);
  }
  module2.exports = toPrimitive2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(toPrimitive);
(function(module2) {
  var _typeof$1 = _typeof.exports["default"];
  var toPrimitive$1 = toPrimitive.exports;
  function toPropertyKey2(t4) {
    var i = toPrimitive$1(t4, "string");
    return "symbol" == _typeof$1(i) ? i : i + "";
  }
  module2.exports = toPropertyKey2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(toPropertyKey);
(function(module2) {
  var toPropertyKey$1 = toPropertyKey.exports;
  function _defineProperties(e3, r2) {
    for (var t4 = 0; t4 < r2.length; t4++) {
      var o = r2[t4];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e3, toPropertyKey$1(o.key), o);
    }
  }
  function _createClass(e3, r2, t4) {
    return r2 && _defineProperties(e3.prototype, r2), t4 && _defineProperties(e3, t4), Object.defineProperty(e3, "prototype", {
      writable: false
    }), e3;
  }
  module2.exports = _createClass, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(createClass);
var assertThisInitialized = { exports: {} };
(function(module2) {
  function _assertThisInitialized2(e3) {
    if (void 0 === e3)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e3;
  }
  module2.exports = _assertThisInitialized2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(assertThisInitialized);
var inherits = { exports: {} };
var setPrototypeOf = { exports: {} };
(function(module2) {
  function _setPrototypeOf2(t4, e3) {
    return module2.exports = _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t5, e4) {
      return t5.__proto__ = e4, t5;
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _setPrototypeOf2(t4, e3);
  }
  module2.exports = _setPrototypeOf2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(setPrototypeOf);
(function(module2) {
  var setPrototypeOf$1 = setPrototypeOf.exports;
  function _inherits(t4, e3) {
    if ("function" != typeof e3 && null !== e3)
      throw new TypeError("Super expression must either be null or a function");
    t4.prototype = Object.create(e3 && e3.prototype, {
      constructor: {
        value: t4,
        writable: true,
        configurable: true
      }
    }), Object.defineProperty(t4, "prototype", {
      writable: false
    }), e3 && setPrototypeOf$1(t4, e3);
  }
  module2.exports = _inherits, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(inherits);
var possibleConstructorReturn = { exports: {} };
(function(module2) {
  var _typeof$1 = _typeof.exports["default"];
  var assertThisInitialized$1 = assertThisInitialized.exports;
  function _possibleConstructorReturn(t4, e3) {
    if (e3 && ("object" == _typeof$1(e3) || "function" == typeof e3))
      return e3;
    if (void 0 !== e3)
      throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized$1(t4);
  }
  module2.exports = _possibleConstructorReturn, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(possibleConstructorReturn);
var getPrototypeOf = { exports: {} };
(function(module2) {
  function _getPrototypeOf(t4) {
    return module2.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t5) {
      return t5.__proto__ || Object.getPrototypeOf(t5);
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _getPrototypeOf(t4);
  }
  module2.exports = _getPrototypeOf, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(getPrototypeOf);
var defineProperty = { exports: {} };
(function(module2) {
  var toPropertyKey$1 = toPropertyKey.exports;
  function _defineProperty(e3, r2, t4) {
    return (r2 = toPropertyKey$1(r2)) in e3 ? Object.defineProperty(e3, r2, {
      value: t4,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e3[r2] = t4, e3;
  }
  module2.exports = _defineProperty, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(defineProperty);
var version = "6.7.0";
function ascending$3(a2, b10) {
  return a2 < b10 ? -1 : a2 > b10 ? 1 : a2 >= b10 ? 0 : NaN;
}
function bisector(f2) {
  let delta = f2;
  let compare = f2;
  if (f2.length === 1) {
    delta = (d2, x2) => f2(d2) - x2;
    compare = ascendingComparator(f2);
  }
  function left2(a2, x2, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a2.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (compare(a2[mid], x2) < 0)
        lo = mid + 1;
      else
        hi = mid;
    }
    return lo;
  }
  function right2(a2, x2, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a2.length;
    while (lo < hi) {
      const mid = lo + hi >>> 1;
      if (compare(a2[mid], x2) > 0)
        hi = mid;
      else
        lo = mid + 1;
    }
    return lo;
  }
  function center2(a2, x2, lo, hi) {
    if (lo == null)
      lo = 0;
    if (hi == null)
      hi = a2.length;
    const i = left2(a2, x2, lo, hi - 1);
    return i > lo && delta(a2[i - 1], x2) > -delta(a2[i], x2) ? i - 1 : i;
  }
  return { left: left2, center: center2, right: right2 };
}
function ascendingComparator(f2) {
  return (d2, x2) => ascending$3(f2(d2), x2);
}
function number$4(x2) {
  return x2 === null ? NaN : +x2;
}
function* numbers(values2, valueof) {
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
const ascendingBisect = bisector(ascending$3);
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = bisector(number$4).center;
var bisect = bisectRight;
function count$2(values2, valueof) {
  let count2 = 0;
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        ++count2;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        ++count2;
      }
    }
  }
  return count2;
}
function length$3(array2) {
  return array2.length | 0;
}
function empty$2(length2) {
  return !(length2 > 0);
}
function arrayify(values2) {
  return typeof values2 !== "object" || "length" in values2 ? values2 : Array.from(values2);
}
function reducer(reduce2) {
  return (values2) => reduce2(...values2);
}
function cross$2(...values2) {
  const reduce2 = typeof values2[values2.length - 1] === "function" && reducer(values2.pop());
  values2 = values2.map(arrayify);
  const lengths = values2.map(length$3);
  const j = values2.length - 1;
  const index2 = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty$2))
    return product;
  while (true) {
    product.push(index2.map((j2, i2) => values2[i2][j2]));
    let i = j;
    while (++index2[i] === lengths[i]) {
      if (i === 0)
        return reduce2 ? product.map(reduce2) : product;
      index2[i--] = 0;
    }
  }
}
function cumsum(values2, valueof) {
  var sum2 = 0, index2 = 0;
  return Float64Array.from(values2, valueof === void 0 ? (v2) => sum2 += +v2 || 0 : (v2) => sum2 += +valueof(v2, index2++, values2) || 0);
}
function descending$2(a2, b10) {
  return b10 < a2 ? -1 : b10 > a2 ? 1 : b10 >= a2 ? 0 : NaN;
}
function variance(values2, valueof) {
  let count2 = 0;
  let delta;
  let mean2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean2;
        mean2 += delta / ++count2;
        sum2 += delta * (value - mean2);
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        delta = value - mean2;
        mean2 += delta / ++count2;
        sum2 += delta * (value - mean2);
      }
    }
  }
  if (count2 > 1)
    return sum2 / (count2 - 1);
}
function deviation(values2, valueof) {
  const v2 = variance(values2, valueof);
  return v2 ? Math.sqrt(v2) : v2;
}
function extent$2(values2, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
class Adder {
  constructor() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  add(x2) {
    const p2 = this._partials;
    let i = 0;
    for (let j = 0; j < this._n && j < 32; j++) {
      const y2 = p2[j], hi = x2 + y2, lo = Math.abs(x2) < Math.abs(y2) ? x2 - (hi - y2) : y2 - (hi - x2);
      if (lo)
        p2[i++] = lo;
      x2 = hi;
    }
    p2[i] = x2;
    this._n = i + 1;
    return this;
  }
  valueOf() {
    const p2 = this._partials;
    let n2 = this._n, x2, y2, lo, hi = 0;
    if (n2 > 0) {
      hi = p2[--n2];
      while (n2 > 0) {
        x2 = hi;
        y2 = p2[--n2];
        hi = x2 + y2;
        lo = y2 - (hi - x2);
        if (lo)
          break;
      }
      if (n2 > 0 && (lo < 0 && p2[n2 - 1] < 0 || lo > 0 && p2[n2 - 1] > 0)) {
        y2 = lo * 2;
        x2 = hi + y2;
        if (y2 == x2 - hi)
          hi = x2;
      }
    }
    return hi;
  }
}
function fsum(values2, valueof) {
  const adder = new Adder();
  if (valueof === void 0) {
    for (let value of values2) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if (value = +valueof(value, ++index2, values2)) {
        adder.add(value);
      }
    }
  }
  return +adder;
}
function fcumsum(values2, valueof) {
  const adder = new Adder();
  let index2 = -1;
  return Float64Array.from(
    values2,
    valueof === void 0 ? (v2) => adder.add(+v2 || 0) : (v2) => adder.add(+valueof(v2, ++index2, values2) || 0)
  );
}
class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null)
      for (const [key2, value] of entries)
        this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
class InternSet extends Set {
  constructor(values2, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (values2 != null)
      for (const value of values2)
        this.add(value);
  }
  has(value) {
    return super.has(intern_get(this, value));
  }
  add(value) {
    return super.add(intern_set(this, value));
  }
  delete(value) {
    return super.delete(intern_delete(this, value));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key))
    return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(value);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function identity$b(x2) {
  return x2;
}
function group(values2, ...keys2) {
  return nest(values2, identity$b, identity$b, keys2);
}
function groups(values2, ...keys2) {
  return nest(values2, Array.from, identity$b, keys2);
}
function rollup(values2, reduce2, ...keys2) {
  return nest(values2, identity$b, reduce2, keys2);
}
function rollups(values2, reduce2, ...keys2) {
  return nest(values2, Array.from, reduce2, keys2);
}
function index$4(values2, ...keys2) {
  return nest(values2, identity$b, unique, keys2);
}
function indexes(values2, ...keys2) {
  return nest(values2, Array.from, unique, keys2);
}
function unique(values2) {
  if (values2.length !== 1)
    throw new Error("duplicate key");
  return values2[0];
}
function nest(values2, map2, reduce2, keys2) {
  return function regroup(values3, i) {
    if (i >= keys2.length)
      return reduce2(values3);
    const groups2 = new InternMap();
    const keyof2 = keys2[i++];
    let index2 = -1;
    for (const value of values3) {
      const key = keyof2(value, ++index2, values3);
      const group2 = groups2.get(key);
      if (group2)
        group2.push(value);
      else
        groups2.set(key, [value]);
    }
    for (const [key, values4] of groups2) {
      groups2.set(key, regroup(values4, i));
    }
    return map2(groups2);
  }(values2, 0);
}
function permute(source, keys2) {
  return Array.from(keys2, (key) => source[key]);
}
function sort(values2, ...F) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  values2 = Array.from(values2);
  let [f2 = ascending$3] = F;
  if (f2.length === 1 || F.length > 1) {
    const index2 = Uint32Array.from(values2, (d2, i) => i);
    if (F.length > 1) {
      F = F.map((f3) => values2.map(f3));
      index2.sort((i, j) => {
        for (const f3 of F) {
          const c2 = ascending$3(f3[i], f3[j]);
          if (c2)
            return c2;
        }
      });
    } else {
      f2 = values2.map(f2);
      index2.sort((i, j) => ascending$3(f2[i], f2[j]));
    }
    return permute(values2, index2);
  }
  return values2.sort(f2);
}
function groupSort(values2, reduce2, key) {
  return (reduce2.length === 1 ? sort(rollup(values2, reduce2, key), ([ak, av], [bk, bv]) => ascending$3(av, bv) || ascending$3(ak, bk)) : sort(group(values2, key), ([ak, av], [bk, bv]) => reduce2(av, bv) || ascending$3(ak, bk))).map(([key2]) => key2);
}
var array$5 = Array.prototype;
var slice$4 = array$5.slice;
function constant$e(x2) {
  return function() {
    return x2;
  };
}
var e10$1 = Math.sqrt(50), e5$1 = Math.sqrt(10), e2$1 = Math.sqrt(2);
function ticks(start2, stop, count2) {
  var reverse2, i = -1, n2, ticks2, step2;
  stop = +stop, start2 = +start2, count2 = +count2;
  if (start2 === stop && count2 > 0)
    return [start2];
  if (reverse2 = stop < start2)
    n2 = start2, start2 = stop, stop = n2;
  if ((step2 = tickIncrement(start2, stop, count2)) === 0 || !isFinite(step2))
    return [];
  if (step2 > 0) {
    let r0 = Math.round(start2 / step2), r1 = Math.round(stop / step2);
    if (r0 * step2 < start2)
      ++r0;
    if (r1 * step2 > stop)
      --r1;
    ticks2 = new Array(n2 = r1 - r0 + 1);
    while (++i < n2)
      ticks2[i] = (r0 + i) * step2;
  } else {
    step2 = -step2;
    let r0 = Math.round(start2 * step2), r1 = Math.round(stop * step2);
    if (r0 / step2 < start2)
      ++r0;
    if (r1 / step2 > stop)
      --r1;
    ticks2 = new Array(n2 = r1 - r0 + 1);
    while (++i < n2)
      ticks2[i] = (r0 + i) / step2;
  }
  if (reverse2)
    ticks2.reverse();
  return ticks2;
}
function tickIncrement(start2, stop, count2) {
  var step2 = (stop - start2) / Math.max(0, count2), power = Math.floor(Math.log(step2) / Math.LN10), error = step2 / Math.pow(10, power);
  return power >= 0 ? (error >= e10$1 ? 10 : error >= e5$1 ? 5 : error >= e2$1 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10$1 ? 10 : error >= e5$1 ? 5 : error >= e2$1 ? 2 : 1);
}
function tickStep$1(start2, stop, count2) {
  var step0 = Math.abs(stop - start2) / Math.max(0, count2), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
  if (error >= e10$1)
    step1 *= 10;
  else if (error >= e5$1)
    step1 *= 5;
  else if (error >= e2$1)
    step1 *= 2;
  return stop < start2 ? -step1 : step1;
}
function nice$1(start2, stop, count2) {
  let prestep;
  while (true) {
    const step2 = tickIncrement(start2, stop, count2);
    if (step2 === prestep || step2 === 0 || !isFinite(step2)) {
      return [start2, stop];
    } else if (step2 > 0) {
      start2 = Math.floor(start2 / step2) * step2;
      stop = Math.ceil(stop / step2) * step2;
    } else if (step2 < 0) {
      start2 = Math.ceil(start2 * step2) / step2;
      stop = Math.floor(stop * step2) / step2;
    }
    prestep = step2;
  }
}
function sturges(values2) {
  return Math.ceil(Math.log(count$2(values2)) / Math.LN2) + 1;
}
function bin() {
  var value = identity$b, domain2 = extent$2, threshold2 = sturges;
  function histogram(data) {
    if (!Array.isArray(data))
      data = Array.from(data);
    var i, n2 = data.length, x2, values2 = new Array(n2);
    for (i = 0; i < n2; ++i) {
      values2[i] = value(data[i], i, data);
    }
    var xz = domain2(values2), x02 = xz[0], x12 = xz[1], tz = threshold2(values2, x02, x12);
    if (!Array.isArray(tz)) {
      const max2 = x12, tn = +tz;
      if (domain2 === extent$2)
        [x02, x12] = nice$1(x02, x12, tn);
      tz = ticks(x02, x12, tn);
      if (tz[tz.length - 1] >= x12) {
        if (max2 >= x12 && domain2 === extent$2) {
          const step2 = tickIncrement(x02, x12, tn);
          if (isFinite(step2)) {
            if (step2 > 0) {
              x12 = (Math.floor(x12 / step2) + 1) * step2;
            } else if (step2 < 0) {
              x12 = (Math.ceil(x12 * -step2) + 1) / -step2;
            }
          }
        } else {
          tz.pop();
        }
      }
    }
    var m2 = tz.length;
    while (tz[0] <= x02)
      tz.shift(), --m2;
    while (tz[m2 - 1] > x12)
      tz.pop(), --m2;
    var bins = new Array(m2 + 1), bin2;
    for (i = 0; i <= m2; ++i) {
      bin2 = bins[i] = [];
      bin2.x0 = i > 0 ? tz[i - 1] : x02;
      bin2.x1 = i < m2 ? tz[i] : x12;
    }
    for (i = 0; i < n2; ++i) {
      x2 = values2[i];
      if (x02 <= x2 && x2 <= x12) {
        bins[bisect(tz, x2, 0, m2)].push(data[i]);
      }
    }
    return bins;
  }
  histogram.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$e(_2), histogram) : value;
  };
  histogram.domain = function(_2) {
    return arguments.length ? (domain2 = typeof _2 === "function" ? _2 : constant$e([_2[0], _2[1]]), histogram) : domain2;
  };
  histogram.thresholds = function(_2) {
    return arguments.length ? (threshold2 = typeof _2 === "function" ? _2 : Array.isArray(_2) ? constant$e(slice$4.call(_2)) : constant$e(_2), histogram) : threshold2;
  };
  return histogram;
}
function max$4(values2, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$2(values2, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function quickselect(array2, k2, left2 = 0, right2 = array2.length - 1, compare = ascending$3) {
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n2 = right2 - left2 + 1;
      const m2 = k2 - left2 + 1;
      const z2 = Math.log(n2);
      const s2 = 0.5 * Math.exp(2 * z2 / 3);
      const sd = 0.5 * Math.sqrt(z2 * s2 * (n2 - s2) / n2) * (m2 - n2 / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k2 - m2 * s2 / n2 + sd));
      const newRight = Math.min(right2, Math.floor(k2 + (n2 - m2) * s2 / n2 + sd));
      quickselect(array2, k2, newLeft, newRight, compare);
    }
    const t4 = array2[k2];
    let i = left2;
    let j = right2;
    swap$1(array2, left2, k2);
    if (compare(array2[right2], t4) > 0)
      swap$1(array2, left2, right2);
    while (i < j) {
      swap$1(array2, i, j), ++i, --j;
      while (compare(array2[i], t4) < 0)
        ++i;
      while (compare(array2[j], t4) > 0)
        --j;
    }
    if (compare(array2[left2], t4) === 0)
      swap$1(array2, left2, j);
    else
      ++j, swap$1(array2, j, right2);
    if (j <= k2)
      left2 = j + 1;
    if (k2 <= j)
      right2 = j - 1;
  }
  return array2;
}
function swap$1(array2, i, j) {
  const t4 = array2[i];
  array2[i] = array2[j];
  array2[j] = t4;
}
function quantile$1(values2, p2, valueof) {
  values2 = Float64Array.from(numbers(values2, valueof));
  if (!(n2 = values2.length))
    return;
  if ((p2 = +p2) <= 0 || n2 < 2)
    return min$2(values2);
  if (p2 >= 1)
    return max$4(values2);
  var n2, i = (n2 - 1) * p2, i0 = Math.floor(i), value0 = max$4(quickselect(values2, i0).subarray(0, i0 + 1)), value1 = min$2(values2.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values2, p2, valueof = number$4) {
  if (!(n2 = values2.length))
    return;
  if ((p2 = +p2) <= 0 || n2 < 2)
    return +valueof(values2[0], 0, values2);
  if (p2 >= 1)
    return +valueof(values2[n2 - 1], n2 - 1, values2);
  var n2, i = (n2 - 1) * p2, i0 = Math.floor(i), value0 = +valueof(values2[i0], i0, values2), value1 = +valueof(values2[i0 + 1], i0 + 1, values2);
  return value0 + (value1 - value0) * (i - i0);
}
function freedmanDiaconis(values2, min2, max2) {
  return Math.ceil((max2 - min2) / (2 * (quantile$1(values2, 0.75) - quantile$1(values2, 0.25)) * Math.pow(count$2(values2), -1 / 3)));
}
function scott(values2, min2, max2) {
  return Math.ceil((max2 - min2) / (3.5 * deviation(values2) * Math.pow(count$2(values2), -1 / 3)));
}
function maxIndex(values2, valueof) {
  let max2;
  let maxIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value of values2) {
      ++index2;
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value, maxIndex2 = index2;
      }
    }
  } else {
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value, maxIndex2 = index2;
      }
    }
  }
  return maxIndex2;
}
function mean(values2, valueof) {
  let count2 = 0;
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        ++count2, sum2 += value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        ++count2, sum2 += value;
      }
    }
  }
  if (count2)
    return sum2 / count2;
}
function median(values2, valueof) {
  return quantile$1(values2, 0.5, valueof);
}
function* flatten(arrays) {
  for (const array2 of arrays) {
    yield* array2;
  }
}
function merge(arrays) {
  return Array.from(flatten(arrays));
}
function minIndex(values2, valueof) {
  let min2;
  let minIndex2 = -1;
  let index2 = -1;
  if (valueof === void 0) {
    for (const value of values2) {
      ++index2;
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value, minIndex2 = index2;
      }
    }
  } else {
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value, minIndex2 = index2;
      }
    }
  }
  return minIndex2;
}
function pairs(values2, pairof = pair) {
  const pairs2 = [];
  let previous;
  let first = false;
  for (const value of values2) {
    if (first)
      pairs2.push(pairof(previous, value));
    previous = value;
    first = true;
  }
  return pairs2;
}
function pair(a2, b10) {
  return [a2, b10];
}
function sequence(start2, stop, step2) {
  start2 = +start2, stop = +stop, step2 = (n2 = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n2 < 3 ? 1 : +step2;
  var i = -1, n2 = Math.max(0, Math.ceil((stop - start2) / step2)) | 0, range2 = new Array(n2);
  while (++i < n2) {
    range2[i] = start2 + i * step2;
  }
  return range2;
}
function least(values2, compare = ascending$3) {
  let min2;
  let defined = false;
  if (compare.length === 1) {
    let minValue;
    for (const element of values2) {
      const value = compare(element);
      if (defined ? ascending$3(value, minValue) < 0 : ascending$3(value, value) === 0) {
        min2 = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values2) {
      if (defined ? compare(value, min2) < 0 : compare(value, value) === 0) {
        min2 = value;
        defined = true;
      }
    }
  }
  return min2;
}
function leastIndex(values2, compare = ascending$3) {
  if (compare.length === 1)
    return minIndex(values2, compare);
  let minValue;
  let min2 = -1;
  let index2 = -1;
  for (const value of values2) {
    ++index2;
    if (min2 < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
      minValue = value;
      min2 = index2;
    }
  }
  return min2;
}
function greatest(values2, compare = ascending$3) {
  let max2;
  let defined = false;
  if (compare.length === 1) {
    let maxValue;
    for (const element of values2) {
      const value = compare(element);
      if (defined ? ascending$3(value, maxValue) > 0 : ascending$3(value, value) === 0) {
        max2 = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values2) {
      if (defined ? compare(value, max2) > 0 : compare(value, value) === 0) {
        max2 = value;
        defined = true;
      }
    }
  }
  return max2;
}
function greatestIndex(values2, compare = ascending$3) {
  if (compare.length === 1)
    return maxIndex(values2, compare);
  let maxValue;
  let max2 = -1;
  let index2 = -1;
  for (const value of values2) {
    ++index2;
    if (max2 < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
      maxValue = value;
      max2 = index2;
    }
  }
  return max2;
}
function scan(values2, compare) {
  const index2 = leastIndex(values2, compare);
  return index2 < 0 ? void 0 : index2;
}
var shuffle$1 = shuffler(Math.random);
function shuffler(random) {
  return function shuffle2(array2, i0 = 0, i1 = array2.length) {
    let m2 = i1 - (i0 = +i0);
    while (m2) {
      const i = random() * m2-- | 0, t4 = array2[m2 + i0];
      array2[m2 + i0] = array2[i + i0];
      array2[i + i0] = t4;
    }
    return array2;
  };
}
function sum$3(values2, valueof) {
  let sum2 = 0;
  if (valueof === void 0) {
    for (let value of values2) {
      if (value = +value) {
        sum2 += value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if (value = +valueof(value, ++index2, values2)) {
        sum2 += value;
      }
    }
  }
  return sum2;
}
function transpose(matrix) {
  if (!(n2 = matrix.length))
    return [];
  for (var i = -1, m2 = min$2(matrix, length$2), transpose2 = new Array(m2); ++i < m2; ) {
    for (var j = -1, n2, row = transpose2[i] = new Array(n2); ++j < n2; ) {
      row[j] = matrix[j][i];
    }
  }
  return transpose2;
}
function length$2(d2) {
  return d2.length;
}
function zip() {
  return transpose(arguments);
}
function every(values2, test) {
  if (typeof test !== "function")
    throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value of values2) {
    if (!test(value, ++index2, values2)) {
      return false;
    }
  }
  return true;
}
function some(values2, test) {
  if (typeof test !== "function")
    throw new TypeError("test is not a function");
  let index2 = -1;
  for (const value of values2) {
    if (test(value, ++index2, values2)) {
      return true;
    }
  }
  return false;
}
function filter$1(values2, test) {
  if (typeof test !== "function")
    throw new TypeError("test is not a function");
  const array2 = [];
  let index2 = -1;
  for (const value of values2) {
    if (test(value, ++index2, values2)) {
      array2.push(value);
    }
  }
  return array2;
}
function map$1(values2, mapper) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  if (typeof mapper !== "function")
    throw new TypeError("mapper is not a function");
  return Array.from(values2, (value, index2) => mapper(value, index2, values2));
}
function reduce(values2, reducer2, value) {
  if (typeof reducer2 !== "function")
    throw new TypeError("reducer is not a function");
  const iterator = values2[Symbol.iterator]();
  let done, next2, index2 = -1;
  if (arguments.length < 3) {
    ({ done, value } = iterator.next());
    if (done)
      return;
    ++index2;
  }
  while ({ done, value: next2 } = iterator.next(), !done) {
    value = reducer2(value, next2, ++index2, values2);
  }
  return value;
}
function reverse$1(values2) {
  if (typeof values2[Symbol.iterator] !== "function")
    throw new TypeError("values is not iterable");
  return Array.from(values2).reverse();
}
function difference(values2, ...others) {
  values2 = new Set(values2);
  for (const other of others) {
    for (const value of other) {
      values2.delete(value);
    }
  }
  return values2;
}
function disjoint(values2, other) {
  const iterator = other[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const v2 of values2) {
    if (set2.has(v2))
      return false;
    let value, done;
    while ({ value, done } = iterator.next()) {
      if (done)
        break;
      if (Object.is(v2, value))
        return false;
      set2.add(value);
    }
  }
  return true;
}
function set$3(values2) {
  return values2 instanceof Set ? values2 : new Set(values2);
}
function intersection(values2, ...others) {
  values2 = new Set(values2);
  others = others.map(set$3);
  out:
    for (const value of values2) {
      for (const other of others) {
        if (!other.has(value)) {
          values2.delete(value);
          continue out;
        }
      }
    }
  return values2;
}
function superset(values2, other) {
  const iterator = values2[Symbol.iterator](), set2 = /* @__PURE__ */ new Set();
  for (const o of other) {
    if (set2.has(o))
      continue;
    let value, done;
    while ({ value, done } = iterator.next()) {
      if (done)
        return false;
      set2.add(value);
      if (Object.is(o, value))
        break;
    }
  }
  return true;
}
function subset(values2, other) {
  return superset(other, values2);
}
function union(...others) {
  const set2 = /* @__PURE__ */ new Set();
  for (const other of others) {
    for (const o of other) {
      set2.add(o);
    }
  }
  return set2;
}
var slice$3 = Array.prototype.slice;
function identity$a(x2) {
  return x2;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon$5 = 1e-6;
function translateX(x2) {
  return "translate(" + x2 + ",0)";
}
function translateY(y2) {
  return "translate(0," + y2 + ")";
}
function number$3(scale) {
  return (d2) => +scale(d2);
}
function center$1(scale, offset2) {
  offset2 = Math.max(0, scale.bandwidth() - offset2 * 2) / 2;
  if (scale.round())
    offset2 = Math.round(offset2);
  return (d2) => +scale(d2) + offset2;
}
function entering() {
  return !this.__axis;
}
function axis(orient2, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset2 = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k2 = orient2 === top || orient2 === left ? -1 : 1, x2 = orient2 === left || orient2 === right ? "x" : "y", transform2 = orient2 === top || orient2 === bottom ? translateX : translateY;
  function axis2(context) {
    var values2 = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$a : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range2 = scale.range(), range0 = +range2[0] + offset2, range1 = +range2[range2.length - 1] + offset2, position2 = (scale.bandwidth ? center$1 : number$3)(scale.copy(), offset2), selection2 = context.selection ? context.selection() : context, path2 = selection2.selectAll(".domain").data([null]), tick = selection2.selectAll(".tick").data(values2, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line2 = tick.select("line"), text2 = tick.select("text");
    path2 = path2.merge(path2.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line2 = line2.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x2 + "2", k2 * tickSizeInner));
    text2 = text2.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x2, k2 * spacing).attr("dy", orient2 === top ? "0em" : orient2 === bottom ? "0.71em" : "0.32em"));
    if (context !== selection2) {
      path2 = path2.transition(context);
      tick = tick.transition(context);
      line2 = line2.transition(context);
      text2 = text2.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon$5).attr("transform", function(d2) {
        return isFinite(d2 = position2(d2)) ? transform2(d2 + offset2) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon$5).attr("transform", function(d2) {
        var p2 = this.parentNode.__axis;
        return transform2((p2 && isFinite(p2 = p2(d2)) ? p2 : position2(d2)) + offset2);
      });
    }
    tickExit.remove();
    path2.attr("d", orient2 === left || orient2 === right ? tickSizeOuter ? "M" + k2 * tickSizeOuter + "," + range0 + "H" + offset2 + "V" + range1 + "H" + k2 * tickSizeOuter : "M" + offset2 + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k2 * tickSizeOuter + "V" + offset2 + "H" + range1 + "V" + k2 * tickSizeOuter : "M" + range0 + "," + offset2 + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d2) {
      return transform2(position2(d2) + offset2);
    });
    line2.attr(x2 + "2", k2 * tickSizeInner);
    text2.attr(x2, k2 * spacing).text(format2);
    selection2.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient2 === right ? "start" : orient2 === left ? "end" : "middle");
    selection2.each(function() {
      this.__axis = position2;
    });
  }
  axis2.scale = function(_2) {
    return arguments.length ? (scale = _2, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = slice$3.call(arguments), axis2;
  };
  axis2.tickArguments = function(_2) {
    return arguments.length ? (tickArguments = _2 == null ? [] : slice$3.call(_2), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_2) {
    return arguments.length ? (tickValues = _2 == null ? null : slice$3.call(_2), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_2) {
    return arguments.length ? (tickFormat2 = _2, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_2) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_2) {
    return arguments.length ? (tickSizeInner = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_2) {
    return arguments.length ? (tickSizeOuter = +_2, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_2) {
    return arguments.length ? (tickPadding = +_2, axis2) : tickPadding;
  };
  axis2.offset = function(_2) {
    return arguments.length ? (offset2 = +_2, axis2) : offset2;
  };
  return axis2;
}
function axisTop(scale) {
  return axis(top, scale);
}
function axisRight(scale) {
  return axis(right, scale);
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
var noop$4 = { value: function() {
} };
function dispatch$1() {
  for (var i = 0, n2 = arguments.length, _2 = {}, t4; i < n2; ++i) {
    if (!(t4 = arguments[i] + "") || t4 in _2 || /[\s.]/.test(t4))
      throw new Error("illegal type: " + t4);
    _2[t4] = [];
  }
  return new Dispatch$1(_2);
}
function Dispatch$1(_2) {
  this._ = _2;
}
function parseTypenames$2(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t4) {
    var name = "", i = t4.indexOf(".");
    if (i >= 0)
      name = t4.slice(i + 1), t4 = t4.slice(0, i);
    if (t4 && !types.hasOwnProperty(t4))
      throw new Error("unknown type: " + t4);
    return { type: t4, name };
  });
}
Dispatch$1.prototype = dispatch$1.prototype = {
  constructor: Dispatch$1,
  on: function(typename, callback) {
    var _2 = this._, T = parseTypenames$2(typename + "", _2), t4, i = -1, n2 = T.length;
    if (arguments.length < 2) {
      while (++i < n2)
        if ((t4 = (typename = T[i]).type) && (t4 = get$2(_2[t4], typename.name)))
          return t4;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i < n2) {
      if (t4 = (typename = T[i]).type)
        _2[t4] = set$2(_2[t4], typename.name, callback);
      else if (callback == null)
        for (t4 in _2)
          _2[t4] = set$2(_2[t4], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _2 = this._;
    for (var t4 in _2)
      copy2[t4] = _2[t4].slice();
    return new Dispatch$1(copy2);
  },
  call: function(type2, that) {
    if ((n2 = arguments.length - 2) > 0)
      for (var args = new Array(n2), i = 0, n2, t4; i < n2; ++i)
        args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (t4 = this._[type2], i = 0, n2 = t4.length; i < n2; ++i)
      t4[i].value.apply(that, args);
  },
  apply: function(type2, that, args) {
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (var t4 = this._[type2], i = 0, n2 = t4.length; i < n2; ++i)
      t4[i].value.apply(that, args);
  }
};
function get$2(type2, name) {
  for (var i = 0, n2 = type2.length, c2; i < n2; ++i) {
    if ((c2 = type2[i]).name === name) {
      return c2.value;
    }
  }
}
function set$2(type2, name, callback) {
  for (var i = 0, n2 = type2.length; i < n2; ++i) {
    if (type2[i].name === name) {
      type2[i] = noop$4, type2 = type2.slice(0, i).concat(type2.slice(i + 1));
      break;
    }
  }
  if (callback != null)
    type2.push({ name, value: callback });
  return type2;
}
var xhtml = "http://www.w3.org/1999/xhtml";
var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix2 = name += "", i = prefix2.indexOf(":");
  if (i >= 0 && (prefix2 = name.slice(0, i)) !== "xmlns")
    name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix2) ? { space: namespaces[prefix2], local: name } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none$2() {
}
function selector(selector2) {
  return selector2 == null ? none$2 : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, subgroup = subgroups[j] = new Array(n2), node2, subnode, i = 0; i < n2; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2)
          subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection$1(subgroups, this._parents);
}
function array$4(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function empty$1() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty$1 : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    var group2 = select2.apply(this, arguments);
    return group2 == null ? [] : array$4(group2);
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function")
    select2 = arrayAll(select2);
  else
    select2 = selectorAll(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = [], parents = [], j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, node2, i = 0; i < n2; ++i) {
      if (node2 = group2[i]) {
        subgroups.push(select2.call(node2, node2.__data__, i, group2));
        parents.push(node2);
      }
    }
  }
  return new Selection$1(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node2) {
    return node2.matches(selector2);
  };
}
var find$1 = Array.prototype.find;
function childFind(match2) {
  return function() {
    return find$1.call(this.children, match2);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match2) {
  return this.select(match2 == null ? childFirst : childFind(typeof match2 === "function" ? match2 : childMatcher(match2)));
}
var filter = Array.prototype.filter;
function children() {
  return this.children;
}
function childrenFilter(match2) {
  return function() {
    return filter.call(this.children, match2);
  };
}
function selection_selectChildren(match2) {
  return this.selectAll(match2 == null ? children : childrenFilter(typeof match2 === "function" ? match2 : childMatcher(match2)));
}
function selection_filter(match2) {
  if (typeof match2 !== "function")
    match2 = matcher(match2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n2; ++i) {
      if ((node2 = group2[i]) && match2.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Selection$1(subgroups, this._parents);
}
function sparse(update) {
  return new Array(update.length);
}
function selection_enter() {
  return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next2) {
    return this._parent.insertBefore(child, next2);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$d(x2) {
  return function() {
    return x2;
  };
}
function bindIndex(parent, group2, enter, update, exit, data) {
  var i = 0, node2, groupLength = group2.length, dataLength = data.length;
  for (; i < dataLength; ++i) {
    if (node2 = group2[i]) {
      node2.__data__ = data[i];
      update[i] = node2;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      exit[i] = node2;
    }
  }
}
function bindKey(parent, group2, enter, update, exit, data, key) {
  var i, node2, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group2.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node2 = group2[i]) {
      keyValues[i] = keyValue = key.call(node2, node2.__data__, i, group2) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node2;
      } else {
        nodeByKeyValue.set(keyValue, node2);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data[i], i, data) + "";
    if (node2 = nodeByKeyValue.get(keyValue)) {
      update[i] = node2;
      node2.__data__ = data[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node2 = group2[i]) && nodeByKeyValue.get(keyValues[i]) === node2) {
      exit[i] = node2;
    }
  }
}
function datum(node2) {
  return node2.__data__;
}
function selection_data(value, key) {
  if (!arguments.length)
    return Array.from(this, datum);
  var bind = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value !== "function")
    value = constant$d(value);
  for (var m2 = groups2.length, update = new Array(m2), enter = new Array(m2), exit = new Array(m2), j = 0; j < m2; ++j) {
    var parent = parents[j], group2 = groups2[j], groupLength = group2.length, data = array$4(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
    bind(parent, group2, enterGroup, updateGroup, exitGroup, data, key);
    for (var i0 = 0, i1 = 0, previous, next2; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1)
          i1 = i0 + 1;
        while (!(next2 = updateGroup[i1]) && ++i1 < dataLength)
          ;
        previous._next = next2 || null;
      }
    }
  }
  update = new Selection$1(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function selection_exit() {
  return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
  if (onupdate != null)
    update = onupdate(update);
  if (onexit == null)
    exit.remove();
  else
    onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
function selection_merge(selection2) {
  if (!(selection2 instanceof Selection$1))
    throw new Error("invalid merge");
  for (var groups0 = this._groups, groups1 = selection2._groups, m0 = groups0.length, m1 = groups1.length, m2 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m2; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n2 = group0.length, merge2 = merges[j] = new Array(n2), node2, i = 0; i < n2; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Selection$1(merges, this._parents);
}
function selection_order() {
  for (var groups2 = this._groups, j = -1, m2 = groups2.length; ++j < m2; ) {
    for (var group2 = groups2[j], i = group2.length - 1, next2 = group2[i], node2; --i >= 0; ) {
      if (node2 = group2[i]) {
        if (next2 && node2.compareDocumentPosition(next2) ^ 4)
          next2.parentNode.insertBefore(node2, next2);
        next2 = node2;
      }
    }
  }
  return this;
}
function selection_sort(compare) {
  if (!compare)
    compare = ascending$2;
  function compareNode(a2, b10) {
    return a2 && b10 ? compare(a2.__data__, b10.__data__) : !a2 - !b10;
  }
  for (var groups2 = this._groups, m2 = groups2.length, sortgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, sortgroup = sortgroups[j] = new Array(n2), node2, i = 0; i < n2; ++i) {
      if (node2 = group2[i]) {
        sortgroup[i] = node2;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection$1(sortgroups, this._parents).order();
}
function ascending$2(a2, b10) {
  return a2 < b10 ? -1 : a2 > b10 ? 1 : a2 >= b10 ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group2 = groups2[j], i = 0, n2 = group2.length; i < n2; ++i) {
      var node2 = group2[i];
      if (node2)
        return node2;
    }
  }
  return null;
}
function selection_size() {
  let size = 0;
  for (const node2 of this)
    ++size;
  return size;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group2 = groups2[j], i = 0, n2 = group2.length, node2; i < n2; ++i) {
      if (node2 = group2[i])
        callback.call(node2, node2.__data__, i, group2);
    }
  }
  return this;
}
function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant$1(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS$1(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction$1(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null)
      this.removeAttribute(name);
    else
      this.setAttribute(name, v2);
  };
}
function attrFunctionNS$1(fullname, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null)
      this.removeAttributeNS(fullname.space, fullname.local);
    else
      this.setAttributeNS(fullname.space, fullname.local, v2);
  };
}
function selection_attr(name, value) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node2 = this.node();
    return fullname.local ? node2.getAttributeNS(fullname.space, fullname.local) : node2.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
}
function defaultView(node2) {
  return node2.ownerDocument && node2.ownerDocument.defaultView || node2.document && node2 || node2.defaultView;
}
function styleRemove$1(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant$1(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction$1(name, value, priority) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null)
      this.style.removeProperty(name);
    else
      this.style.setProperty(name, v2, priority);
  };
}
function selection_style(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node2, name) {
  return node2.style.getPropertyValue(name) || defaultView(node2).getComputedStyle(node2, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (v2 == null)
      delete this[name];
    else
      this[name] = v2;
  };
}
function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
function classArray(string2) {
  return string2.trim().split(/^|\s+/);
}
function classList(node2) {
  return node2.classList || new ClassList(node2);
}
function ClassList(node2) {
  this._node = node2;
  this._names = classArray(node2.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node2, names) {
  var list = classList(node2), i = -1, n2 = names.length;
  while (++i < n2)
    list.add(names[i]);
}
function classedRemove(node2, names) {
  var list = classList(node2), i = -1, n2 = names.length;
  while (++i < n2)
    list.remove(names[i]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function selection_classed(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n2 = names.length;
    while (++i < n2)
      if (!list.contains(names[i]))
        return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}
function textRemove() {
  this.textContent = "";
}
function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction$1(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.textContent = v2 == null ? "" : v2;
  };
}
function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v2 = value.apply(this, arguments);
    this.innerHTML = v2 == null ? "" : v2;
  };
}
function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling)
    this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling)
    this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create2 = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create2.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before) {
  var create2 = typeof name === "function" ? name : creator(name), select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create2.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove() {
  var parent = this.parentNode;
  if (parent)
    parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove);
}
function selection_cloneShallow() {
  var clone = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
  var clone = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t4) {
    var name = "", i = t4.indexOf(".");
    if (i >= 0)
      name = t4.slice(i + 1), t4 = t4.slice(0, i);
    return { type: t4, name };
  });
}
function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on)
      return;
    for (var j = 0, i = -1, m2 = on.length, o; j < m2; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on[++i] = o;
      }
    }
    if (++i)
      on.length = i;
    else
      delete this.__on;
  };
}
function onAdd(typename, value, options) {
  return function() {
    var on = this.__on, o, listener = contextListener(value);
    if (on)
      for (var j = 0, m2 = on.length; j < m2; ++j) {
        if ((o = on[j]).type === typename.type && o.name === typename.name) {
          this.removeEventListener(o.type, o.listener, o.options);
          this.addEventListener(o.type, o.listener = listener, o.options = options);
          o.value = value;
          return;
        }
      }
    this.addEventListener(typename.type, listener, options);
    o = { type: typename.type, name: typename.name, value, listener, options };
    if (!on)
      this.__on = [o];
    else
      on.push(o);
  };
}
function selection_on(typename, value, options) {
  var typenames = parseTypenames$1(typename + ""), i, n2 = typenames.length, t4;
  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on)
      for (var j = 0, m2 = on.length, o; j < m2; ++j) {
        for (i = 0, o = on[j]; i < n2; ++i) {
          if ((t4 = typenames[i]).type === o.type && t4.name === o.name) {
            return o.value;
          }
        }
      }
    return;
  }
  on = value ? onAdd : onRemove;
  for (i = 0; i < n2; ++i)
    this.each(on(typenames[i], value, options));
  return this;
}
function dispatchEvent(node2, type2, params) {
  var window2 = defaultView(node2), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type2, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params)
      event.initEvent(type2, params.bubbles, params.cancelable), event.detail = params.detail;
    else
      event.initEvent(type2, false, false);
  }
  node2.dispatchEvent(event);
}
function dispatchConstant(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params);
  };
}
function dispatchFunction(type2, params) {
  return function() {
    return dispatchEvent(this, type2, params.apply(this, arguments));
  };
}
function selection_dispatch(type2, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type2, params));
}
function* selection_iterator() {
  for (var groups2 = this._groups, j = 0, m2 = groups2.length; j < m2; ++j) {
    for (var group2 = groups2[j], i = 0, n2 = group2.length, node2; i < n2; ++i) {
      if (node2 = group2[i])
        yield node2;
    }
  }
}
var root$3 = [null];
function Selection$1(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection() {
  return new Selection$1([[document.documentElement]], root$3);
}
function selection_selection() {
  return this;
}
Selection$1.prototype = selection.prototype = {
  constructor: Selection$1,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(selector2) {
  return typeof selector2 === "string" ? new Selection$1([[document.querySelector(selector2)]], [document.documentElement]) : new Selection$1([[selector2]], root$3);
}
function create$1(name) {
  return select(creator(name).call(document.documentElement));
}
var nextId = 0;
function local$1() {
  return new Local();
}
function Local() {
  this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node2) {
    var id2 = this._;
    while (!(id2 in node2))
      if (!(node2 = node2.parentNode))
        return;
    return node2[id2];
  },
  set: function(node2, value) {
    return node2[this._] = value;
  },
  remove: function(node2) {
    return this._ in node2 && delete node2[this._];
  },
  toString: function() {
    return this._;
  }
};
function sourceEvent(event) {
  let sourceEvent2;
  while (sourceEvent2 = event.sourceEvent)
    event = sourceEvent2;
  return event;
}
function pointer(event, node2) {
  event = sourceEvent(event);
  if (node2 === void 0)
    node2 = event.currentTarget;
  if (node2) {
    var svg2 = node2.ownerSVGElement || node2;
    if (svg2.createSVGPoint) {
      var point2 = svg2.createSVGPoint();
      point2.x = event.clientX, point2.y = event.clientY;
      point2 = point2.matrixTransform(node2.getScreenCTM().inverse());
      return [point2.x, point2.y];
    }
    if (node2.getBoundingClientRect) {
      var rect = node2.getBoundingClientRect();
      return [event.clientX - rect.left - node2.clientLeft, event.clientY - rect.top - node2.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
function pointers(events, node2) {
  if (events.target) {
    events = sourceEvent(events);
    if (node2 === void 0)
      node2 = events.currentTarget;
    events = events.touches || [events];
  }
  return Array.from(events, (event) => pointer(event, node2));
}
function selectAll(selector2) {
  return typeof selector2 === "string" ? new Selection$1([document.querySelectorAll(selector2)], [document.documentElement]) : new Selection$1([selector2 == null ? [] : array$4(selector2)], root$3);
}
function nopropagation$2(event) {
  event.stopImmediatePropagation();
}
function noevent$2(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function dragDisable(view) {
  var root2 = view.document.documentElement, selection2 = select(view).on("dragstart.drag", noevent$2, true);
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", noevent$2, true);
  } else {
    root2.__noselect = root2.style.MozUserSelect;
    root2.style.MozUserSelect = "none";
  }
}
function yesdrag(view, noclick) {
  var root2 = view.document.documentElement, selection2 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection2.on("click.drag", noevent$2, true);
    setTimeout(function() {
      selection2.on("click.drag", null);
    }, 0);
  }
  if ("onselectstart" in root2) {
    selection2.on("selectstart.drag", null);
  } else {
    root2.style.MozUserSelect = root2.__noselect;
    delete root2.__noselect;
  }
}
var constant$c = (x2) => () => x2;
function DragEvent(type2, {
  sourceEvent: sourceEvent2,
  subject,
  target,
  identifier: identifier2,
  active: active2,
  x: x2,
  y: y2,
  dx,
  dy,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent2, enumerable: true, configurable: true },
    subject: { value: subject, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    identifier: { value: identifier2, enumerable: true, configurable: true },
    active: { value: active2, enumerable: true, configurable: true },
    x: { value: x2, enumerable: true, configurable: true },
    y: { value: y2, enumerable: true, configurable: true },
    dx: { value: dx, enumerable: true, configurable: true },
    dy: { value: dy, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};
function defaultFilter$2(event) {
  return !event.ctrlKey && !event.button;
}
function defaultContainer() {
  return this.parentNode;
}
function defaultSubject(event, d2) {
  return d2 == null ? { x: event.x, y: event.y } : d2;
}
function defaultTouchable$2() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function drag() {
  var filter2 = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch$1("start", "drag", "end"), active2 = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
  function drag2(selection2) {
    selection2.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function mousedowned(event, d2) {
    if (touchending || !filter2.call(this, event, d2))
      return;
    var gesture = beforestart(this, container.call(this, event, d2), event, d2, "mouse");
    if (!gesture)
      return;
    select(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(event.view);
    nopropagation$2(event);
    mousemoving = false;
    mousedownx = event.clientX;
    mousedowny = event.clientY;
    gesture("start", event);
  }
  function mousemoved(event) {
    noevent$2(event);
    if (!mousemoving) {
      var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag", event);
  }
  function mouseupped(event) {
    select(event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(event.view, mousemoving);
    noevent$2(event);
    gestures.mouse("end", event);
  }
  function touchstarted(event, d2) {
    if (!filter2.call(this, event, d2))
      return;
    var touches = event.changedTouches, c2 = container.call(this, event, d2), n2 = touches.length, i, gesture;
    for (i = 0; i < n2; ++i) {
      if (gesture = beforestart(this, c2, event, d2, touches[i].identifier, touches[i])) {
        nopropagation$2(event);
        gesture("start", event, touches[i]);
      }
    }
  }
  function touchmoved(event) {
    var touches = event.changedTouches, n2 = touches.length, i, gesture;
    for (i = 0; i < n2; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        noevent$2(event);
        gesture("drag", event, touches[i]);
      }
    }
  }
  function touchended(event) {
    var touches = event.changedTouches, n2 = touches.length, i, gesture;
    if (touchending)
      clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, 500);
    for (i = 0; i < n2; ++i) {
      if (gesture = gestures[touches[i].identifier]) {
        nopropagation$2(event);
        gesture("end", event, touches[i]);
      }
    }
  }
  function beforestart(that, container2, event, d2, identifier2, touch) {
    var dispatch2 = listeners.copy(), p2 = pointer(touch || event, container2), dx, dy, s2;
    if ((s2 = subject.call(that, new DragEvent("beforestart", {
      sourceEvent: event,
      target: drag2,
      identifier: identifier2,
      active: active2,
      x: p2[0],
      y: p2[1],
      dx: 0,
      dy: 0,
      dispatch: dispatch2
    }), d2)) == null)
      return;
    dx = s2.x - p2[0] || 0;
    dy = s2.y - p2[1] || 0;
    return function gesture(type2, event2, touch2) {
      var p02 = p2, n2;
      switch (type2) {
        case "start":
          gestures[identifier2] = gesture, n2 = active2++;
          break;
        case "end":
          delete gestures[identifier2], --active2;
        case "drag":
          p2 = pointer(touch2 || event2, container2), n2 = active2;
          break;
      }
      dispatch2.call(
        type2,
        that,
        new DragEvent(type2, {
          sourceEvent: event2,
          subject: s2,
          target: drag2,
          identifier: identifier2,
          active: n2,
          x: p2[0] + dx,
          y: p2[1] + dy,
          dx: p2[0] - p02[0],
          dy: p2[1] - p02[1],
          dispatch: dispatch2
        }),
        d2
      );
    };
  }
  drag2.filter = function(_2) {
    return arguments.length ? (filter2 = typeof _2 === "function" ? _2 : constant$c(!!_2), drag2) : filter2;
  };
  drag2.container = function(_2) {
    return arguments.length ? (container = typeof _2 === "function" ? _2 : constant$c(_2), drag2) : container;
  };
  drag2.subject = function(_2) {
    return arguments.length ? (subject = typeof _2 === "function" ? _2 : constant$c(_2), drag2) : subject;
  };
  drag2.touchable = function(_2) {
    return arguments.length ? (touchable = typeof _2 === "function" ? _2 : constant$c(!!_2), drag2) : touchable;
  };
  drag2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag2 : value;
  };
  drag2.clickDistance = function(_2) {
    return arguments.length ? (clickDistance2 = (_2 = +_2) * _2, drag2) : Math.sqrt(clickDistance2);
  };
  return drag2;
}
function define$3(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$3(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color$3() {
}
var darker$3 = 0.7;
var brighter$3 = 1 / darker$3;
var reI$3 = "\\s*([+-]?\\d+)\\s*", reN$3 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP$3 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex$3 = /^#([0-9a-f]{3,8})$/, reRgbInteger$3 = new RegExp("^rgb\\(" + [reI$3, reI$3, reI$3] + "\\)$"), reRgbPercent$3 = new RegExp("^rgb\\(" + [reP$3, reP$3, reP$3] + "\\)$"), reRgbaInteger$3 = new RegExp("^rgba\\(" + [reI$3, reI$3, reI$3, reN$3] + "\\)$"), reRgbaPercent$3 = new RegExp("^rgba\\(" + [reP$3, reP$3, reP$3, reN$3] + "\\)$"), reHslPercent$3 = new RegExp("^hsl\\(" + [reN$3, reP$3, reP$3] + "\\)$"), reHslaPercent$3 = new RegExp("^hsla\\(" + [reN$3, reP$3, reP$3, reN$3] + "\\)$");
var named$3 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$3(Color$3, color$3, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$3,
  formatHex: color_formatHex$3,
  formatHsl: color_formatHsl$3,
  formatRgb: color_formatRgb$3,
  toString: color_formatRgb$3
});
function color_formatHex$3() {
  return this.rgb().formatHex();
}
function color_formatHsl$3() {
  return hslConvert$3(this).formatHsl();
}
function color_formatRgb$3() {
  return this.rgb().formatRgb();
}
function color$3(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex$3.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn$3(m2) : l2 === 3 ? new Rgb$3(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba$3(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba$3(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger$3.exec(format2)) ? new Rgb$3(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent$3.exec(format2)) ? new Rgb$3(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger$3.exec(format2)) ? rgba$3(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent$3.exec(format2)) ? rgba$3(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent$3.exec(format2)) ? hsla$3(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent$3.exec(format2)) ? hsla$3(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named$3.hasOwnProperty(format2) ? rgbn$3(named$3[format2]) : format2 === "transparent" ? new Rgb$3(NaN, NaN, NaN, 0) : null;
}
function rgbn$3(n2) {
  return new Rgb$3(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba$3(r2, g2, b10, a2) {
  if (a2 <= 0)
    r2 = g2 = b10 = NaN;
  return new Rgb$3(r2, g2, b10, a2);
}
function rgbConvert$3(o) {
  if (!(o instanceof Color$3))
    o = color$3(o);
  if (!o)
    return new Rgb$3();
  o = o.rgb();
  return new Rgb$3(o.r, o.g, o.b, o.opacity);
}
function rgb$5(r2, g2, b10, opacity) {
  return arguments.length === 1 ? rgbConvert$3(r2) : new Rgb$3(r2, g2, b10, opacity == null ? 1 : opacity);
}
function Rgb$3(r2, g2, b10, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$3(Rgb$3, rgb$5, extend$3(Color$3, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$3 : Math.pow(brighter$3, k2);
    return new Rgb$3(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$3 : Math.pow(darker$3, k2);
    return new Rgb$3(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$3,
  formatHex: rgb_formatHex$3,
  formatRgb: rgb_formatRgb$3,
  toString: rgb_formatRgb$3
}));
function rgb_formatHex$3() {
  return "#" + hex$3(this.r) + hex$3(this.g) + hex$3(this.b);
}
function rgb_formatRgb$3() {
  var a2 = this.opacity;
  a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
  return (a2 === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a2 === 1 ? ")" : ", " + a2 + ")");
}
function hex$3(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$3(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl$3(h2, s2, l2, a2);
}
function hslConvert$3(o) {
  if (o instanceof Hsl$3)
    return new Hsl$3(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$3))
    o = color$3(o);
  if (!o)
    return new Hsl$3();
  if (o instanceof Hsl$3)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r2, g2, b10), max2 = Math.max(r2, g2, b10), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g2 - b10) / s2 + (g2 < b10) * 6;
    else if (g2 === max2)
      h2 = (b10 - r2) / s2 + 2;
    else
      h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl$3(h2, s2, l2, o.opacity);
}
function hsl$5(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert$3(h2) : new Hsl$3(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl$3(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$3(Hsl$3, hsl$5, extend$3(Color$3, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$3 : Math.pow(brighter$3, k2);
    return new Hsl$3(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$3 : Math.pow(darker$3, k2);
    return new Hsl$3(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb$3(
      hsl2rgb$3(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb$3(h2, m1, m2),
      hsl2rgb$3(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a2 = this.opacity;
    a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
    return (a2 === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a2 === 1 ? ")" : ", " + a2 + ")");
  }
}));
function hsl2rgb$3(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
var constant$b = (x2) => () => x2;
function linear$5(a2, d2) {
  return function(t4) {
    return a2 + t4 * d2;
  };
}
function exponential$4(a2, b10, y2) {
  return a2 = Math.pow(a2, y2), b10 = Math.pow(b10, y2) - a2, y2 = 1 / y2, function(t4) {
    return Math.pow(a2 + t4 * b10, y2);
  };
}
function gamma$4(y2) {
  return (y2 = +y2) === 1 ? nogamma$3 : function(a2, b10) {
    return b10 - a2 ? exponential$4(a2, b10, y2) : constant$b(isNaN(a2) ? b10 : a2);
  };
}
function nogamma$3(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$5(a2, d2) : constant$b(isNaN(a2) ? b10 : a2);
}
var rgb$4 = function rgbGamma2(y2) {
  var color2 = gamma$4(y2);
  function rgb2(start2, end2) {
    var r2 = color2((start2 = rgb$5(start2)).r, (end2 = rgb$5(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity = nogamma$3(start2.opacity, end2.opacity);
    return function(t4) {
      start2.r = r2(t4);
      start2.g = g2(t4);
      start2.b = b10(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  }
  rgb2.gamma = rgbGamma2;
  return rgb2;
}(1);
function numberArray$1(a2, b10) {
  if (!b10)
    b10 = [];
  var n2 = a2 ? Math.min(b10.length, a2.length) : 0, c2 = b10.slice(), i;
  return function(t4) {
    for (i = 0; i < n2; ++i)
      c2[i] = a2[i] * (1 - t4) + b10[i] * t4;
    return c2;
  };
}
function isNumberArray$1(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function genericArray$1(a2, b10) {
  var nb = b10 ? b10.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i)
    x2[i] = interpolate$3(a2[i], b10[i]);
  for (; i < nb; ++i)
    c2[i] = b10[i];
  return function(t4) {
    for (i = 0; i < na; ++i)
      c2[i] = x2[i](t4);
    return c2;
  };
}
function date$2(a2, b10) {
  var d2 = new Date();
  return a2 = +a2, b10 = +b10, function(t4) {
    return d2.setTime(a2 * (1 - t4) + b10 * t4), d2;
  };
}
function number$2(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return a2 * (1 - t4) + b10 * t4;
  };
}
function object$2(a2, b10) {
  var i = {}, c2 = {}, k2;
  if (a2 === null || typeof a2 !== "object")
    a2 = {};
  if (b10 === null || typeof b10 !== "object")
    b10 = {};
  for (k2 in b10) {
    if (k2 in a2) {
      i[k2] = interpolate$3(a2[k2], b10[k2]);
    } else {
      c2[k2] = b10[k2];
    }
  }
  return function(t4) {
    for (k2 in i)
      c2[k2] = i[k2](t4);
    return c2;
  };
}
var reA$2 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB$2 = new RegExp(reA$2.source, "g");
function zero$2(b10) {
  return function() {
    return b10;
  };
}
function one$2(b10) {
  return function(t4) {
    return b10(t4) + "";
  };
}
function string$1(a2, b10) {
  var bi = reA$2.lastIndex = reB$2.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q2 = [];
  a2 = a2 + "", b10 = b10 + "";
  while ((am = reA$2.exec(a2)) && (bm = reB$2.exec(b10))) {
    if ((bs = bm.index) > bi) {
      bs = b10.slice(bi, bs);
      if (s2[i])
        s2[i] += bs;
      else
        s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i])
        s2[i] += bm;
      else
        s2[++i] = bm;
    } else {
      s2[++i] = null;
      q2.push({ i, x: number$2(am, bm) });
    }
    bi = reB$2.lastIndex;
  }
  if (bi < b10.length) {
    bs = b10.slice(bi);
    if (s2[i])
      s2[i] += bs;
    else
      s2[++i] = bs;
  }
  return s2.length < 2 ? q2[0] ? one$2(q2[0].x) : zero$2(b10) : (b10 = q2.length, function(t4) {
    for (var i2 = 0, o; i2 < b10; ++i2)
      s2[(o = q2[i2]).i] = o.x(t4);
    return s2.join("");
  });
}
function interpolate$3(a2, b10) {
  var t4 = typeof b10, c2;
  return b10 == null || t4 === "boolean" ? constant$b(b10) : (t4 === "number" ? number$2 : t4 === "string" ? (c2 = color$3(b10)) ? (b10 = c2, rgb$4) : string$1 : b10 instanceof color$3 ? rgb$4 : b10 instanceof Date ? date$2 : isNumberArray$1(b10) ? numberArray$1 : Array.isArray(b10) ? genericArray$1 : typeof b10.valueOf !== "function" && typeof b10.toString !== "function" || isNaN(b10) ? object$2 : number$2)(a2, b10);
}
var frame = 0, timeout$1 = 0, interval$1 = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f2) {
  setTimeout(f2, 17);
};
function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer() {
  this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail)
        taskTail._next = this;
      else
        taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time2;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time2) {
  var t4 = new Timer();
  t4.restart(callback, delay, time2);
  return t4;
}
function timerFlush() {
  now();
  ++frame;
  var t4 = taskHead, e3;
  while (t4) {
    if ((e3 = clockNow - t4._time) >= 0)
      t4._call.call(null, e3);
    t4 = t4._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout$1 = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay)
    clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t02, t12 = taskHead, t22, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time)
        time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t22 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t22 : taskHead = t22;
    }
  }
  taskTail = t02;
  sleep(time2);
}
function sleep(time2) {
  if (frame)
    return;
  if (timeout$1)
    timeout$1 = clearTimeout(timeout$1);
  var delay = time2 - clockNow;
  if (delay > 24) {
    if (time2 < Infinity)
      timeout$1 = setTimeout(wake, time2 - clock.now() - clockSkew);
    if (interval$1)
      interval$1 = clearInterval(interval$1);
  } else {
    if (!interval$1)
      clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
function timeout(callback, delay, time2) {
  var t4 = new Timer();
  delay = delay == null ? 0 : +delay;
  t4.restart((elapsed) => {
    t4.stop();
    callback(elapsed + delay);
  }, delay, time2);
  return t4;
}
function interval(callback, delay, time2) {
  var t4 = new Timer(), total = delay;
  if (delay == null)
    return t4.restart(callback, delay, time2), t4;
  t4._restart = t4.restart;
  t4.restart = function(callback2, delay2, time3) {
    delay2 = +delay2, time3 = time3 == null ? now() : +time3;
    t4._restart(function tick(elapsed) {
      elapsed += total;
      t4._restart(tick, total += delay2, time3);
      callback2(elapsed);
    }, delay2, time3);
  };
  t4.restart(callback, delay, time2);
  return t4;
}
var emptyOn = dispatch$1("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function schedule(node2, name, id2, index2, group2, timing) {
  var schedules = node2.__transition;
  if (!schedules)
    node2.__transition = {};
  else if (id2 in schedules)
    return;
  create(node2, id2, {
    name,
    index: index2,
    group: group2,
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
}
function init(node2, id2) {
  var schedule2 = get$1(node2, id2);
  if (schedule2.state > CREATED)
    throw new Error("too late; already scheduled");
  return schedule2;
}
function set$1(node2, id2) {
  var schedule2 = get$1(node2, id2);
  if (schedule2.state > STARTED)
    throw new Error("too late; already running");
  return schedule2;
}
function get$1(node2, id2) {
  var schedule2 = node2.__transition;
  if (!schedule2 || !(schedule2 = schedule2[id2]))
    throw new Error("transition not found");
  return schedule2;
}
function create(node2, id2, self2) {
  var schedules = node2.__transition, tween;
  schedules[id2] = self2;
  self2.timer = timer(schedule2, 0, self2.time);
  function schedule2(elapsed) {
    self2.state = SCHEDULED;
    self2.timer.restart(start2, self2.delay, self2.time);
    if (self2.delay <= elapsed)
      start2(elapsed - self2.delay);
  }
  function start2(elapsed) {
    var i, j, n2, o;
    if (self2.state !== SCHEDULED)
      return stop();
    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self2.name)
        continue;
      if (o.state === STARTED)
        return timeout(start2);
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      } else if (+i < id2) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("cancel", node2, node2.__data__, o.index, o.group);
        delete schedules[i];
      }
    }
    timeout(function() {
      if (self2.state === STARTED) {
        self2.state = RUNNING;
        self2.timer.restart(tick, self2.delay, self2.time);
        tick(elapsed);
      }
    });
    self2.state = STARTING;
    self2.on.call("start", node2, node2.__data__, self2.index, self2.group);
    if (self2.state !== STARTING)
      return;
    self2.state = STARTED;
    tween = new Array(n2 = self2.tween.length);
    for (i = 0, j = -1; i < n2; ++i) {
      if (o = self2.tween[i].value.call(node2, node2.__data__, self2.index, self2.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }
  function tick(elapsed) {
    var t4 = elapsed < self2.duration ? self2.ease.call(null, elapsed / self2.duration) : (self2.timer.restart(stop), self2.state = ENDING, 1), i = -1, n2 = tween.length;
    while (++i < n2) {
      tween[i].call(node2, t4);
    }
    if (self2.state === ENDING) {
      self2.on.call("end", node2, node2.__data__, self2.index, self2.group);
      stop();
    }
  }
  function stop() {
    self2.state = ENDED;
    self2.timer.stop();
    delete schedules[id2];
    for (var i in schedules)
      return;
    delete node2.__transition;
  }
}
function interrupt(node2, name) {
  var schedules = node2.__transition, schedule2, active2, empty2 = true, i;
  if (!schedules)
    return;
  name = name == null ? null : name + "";
  for (i in schedules) {
    if ((schedule2 = schedules[i]).name !== name) {
      empty2 = false;
      continue;
    }
    active2 = schedule2.state > STARTING && schedule2.state < ENDING;
    schedule2.state = ENDED;
    schedule2.timer.stop();
    schedule2.on.call(active2 ? "interrupt" : "cancel", node2, node2.__data__, schedule2.index, schedule2.group);
    delete schedules[i];
  }
  if (empty2)
    delete node2.__transition;
}
function selection_interrupt(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}
function define$2(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$2(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color$2() {
}
var darker$2 = 0.7;
var brighter$2 = 1 / darker$2;
var reI$2 = "\\s*([+-]?\\d+)\\s*", reN$2 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP$2 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex$2 = /^#([0-9a-f]{3,8})$/, reRgbInteger$2 = new RegExp("^rgb\\(" + [reI$2, reI$2, reI$2] + "\\)$"), reRgbPercent$2 = new RegExp("^rgb\\(" + [reP$2, reP$2, reP$2] + "\\)$"), reRgbaInteger$2 = new RegExp("^rgba\\(" + [reI$2, reI$2, reI$2, reN$2] + "\\)$"), reRgbaPercent$2 = new RegExp("^rgba\\(" + [reP$2, reP$2, reP$2, reN$2] + "\\)$"), reHslPercent$2 = new RegExp("^hsl\\(" + [reN$2, reP$2, reP$2] + "\\)$"), reHslaPercent$2 = new RegExp("^hsla\\(" + [reN$2, reP$2, reP$2, reN$2] + "\\)$");
var named$2 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$2(Color$2, color$2, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$2,
  formatHex: color_formatHex$2,
  formatHsl: color_formatHsl$2,
  formatRgb: color_formatRgb$2,
  toString: color_formatRgb$2
});
function color_formatHex$2() {
  return this.rgb().formatHex();
}
function color_formatHsl$2() {
  return hslConvert$2(this).formatHsl();
}
function color_formatRgb$2() {
  return this.rgb().formatRgb();
}
function color$2(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex$2.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn$2(m2) : l2 === 3 ? new Rgb$2(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba$2(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba$2(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger$2.exec(format2)) ? new Rgb$2(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent$2.exec(format2)) ? new Rgb$2(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger$2.exec(format2)) ? rgba$2(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent$2.exec(format2)) ? rgba$2(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent$2.exec(format2)) ? hsla$2(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent$2.exec(format2)) ? hsla$2(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named$2.hasOwnProperty(format2) ? rgbn$2(named$2[format2]) : format2 === "transparent" ? new Rgb$2(NaN, NaN, NaN, 0) : null;
}
function rgbn$2(n2) {
  return new Rgb$2(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba$2(r2, g2, b10, a2) {
  if (a2 <= 0)
    r2 = g2 = b10 = NaN;
  return new Rgb$2(r2, g2, b10, a2);
}
function rgbConvert$2(o) {
  if (!(o instanceof Color$2))
    o = color$2(o);
  if (!o)
    return new Rgb$2();
  o = o.rgb();
  return new Rgb$2(o.r, o.g, o.b, o.opacity);
}
function rgb$3(r2, g2, b10, opacity) {
  return arguments.length === 1 ? rgbConvert$2(r2) : new Rgb$2(r2, g2, b10, opacity == null ? 1 : opacity);
}
function Rgb$2(r2, g2, b10, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$2(Rgb$2, rgb$3, extend$2(Color$2, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$2 : Math.pow(brighter$2, k2);
    return new Rgb$2(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$2 : Math.pow(darker$2, k2);
    return new Rgb$2(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$2,
  formatHex: rgb_formatHex$2,
  formatRgb: rgb_formatRgb$2,
  toString: rgb_formatRgb$2
}));
function rgb_formatHex$2() {
  return "#" + hex$2(this.r) + hex$2(this.g) + hex$2(this.b);
}
function rgb_formatRgb$2() {
  var a2 = this.opacity;
  a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
  return (a2 === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a2 === 1 ? ")" : ", " + a2 + ")");
}
function hex$2(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$2(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl$2(h2, s2, l2, a2);
}
function hslConvert$2(o) {
  if (o instanceof Hsl$2)
    return new Hsl$2(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$2))
    o = color$2(o);
  if (!o)
    return new Hsl$2();
  if (o instanceof Hsl$2)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r2, g2, b10), max2 = Math.max(r2, g2, b10), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g2 - b10) / s2 + (g2 < b10) * 6;
    else if (g2 === max2)
      h2 = (b10 - r2) / s2 + 2;
    else
      h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl$2(h2, s2, l2, o.opacity);
}
function hsl$4(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert$2(h2) : new Hsl$2(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl$2(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$2(Hsl$2, hsl$4, extend$2(Color$2, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$2 : Math.pow(brighter$2, k2);
    return new Hsl$2(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$2 : Math.pow(darker$2, k2);
    return new Hsl$2(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb$2(
      hsl2rgb$2(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb$2(h2, m1, m2),
      hsl2rgb$2(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a2 = this.opacity;
    a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
    return (a2 === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a2 === 1 ? ")" : ", " + a2 + ")");
  }
}));
function hsl2rgb$2(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
var constant$a = (x2) => () => x2;
function linear$4(a2, d2) {
  return function(t4) {
    return a2 + t4 * d2;
  };
}
function exponential$3(a2, b10, y2) {
  return a2 = Math.pow(a2, y2), b10 = Math.pow(b10, y2) - a2, y2 = 1 / y2, function(t4) {
    return Math.pow(a2 + t4 * b10, y2);
  };
}
function gamma$3(y2) {
  return (y2 = +y2) === 1 ? nogamma$2 : function(a2, b10) {
    return b10 - a2 ? exponential$3(a2, b10, y2) : constant$a(isNaN(a2) ? b10 : a2);
  };
}
function nogamma$2(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$4(a2, d2) : constant$a(isNaN(a2) ? b10 : a2);
}
var interpolateRgb = function rgbGamma3(y2) {
  var color2 = gamma$3(y2);
  function rgb2(start2, end2) {
    var r2 = color2((start2 = rgb$3(start2)).r, (end2 = rgb$3(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity = nogamma$2(start2.opacity, end2.opacity);
    return function(t4) {
      start2.r = r2(t4);
      start2.g = g2(t4);
      start2.b = b10(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  }
  rgb2.gamma = rgbGamma3;
  return rgb2;
}(1);
function interpolateNumber$1(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return a2 * (1 - t4) + b10 * t4;
  };
}
var reA$1 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB$1 = new RegExp(reA$1.source, "g");
function zero$1(b10) {
  return function() {
    return b10;
  };
}
function one$1(b10) {
  return function(t4) {
    return b10(t4) + "";
  };
}
function interpolateString(a2, b10) {
  var bi = reA$1.lastIndex = reB$1.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q2 = [];
  a2 = a2 + "", b10 = b10 + "";
  while ((am = reA$1.exec(a2)) && (bm = reB$1.exec(b10))) {
    if ((bs = bm.index) > bi) {
      bs = b10.slice(bi, bs);
      if (s2[i])
        s2[i] += bs;
      else
        s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i])
        s2[i] += bm;
      else
        s2[++i] = bm;
    } else {
      s2[++i] = null;
      q2.push({ i, x: interpolateNumber$1(am, bm) });
    }
    bi = reB$1.lastIndex;
  }
  if (bi < b10.length) {
    bs = b10.slice(bi);
    if (s2[i])
      s2[i] += bs;
    else
      s2[++i] = bs;
  }
  return s2.length < 2 ? q2[0] ? one$1(q2[0].x) : zero$1(b10) : (b10 = q2.length, function(t4) {
    for (var i2 = 0, o; i2 < b10; ++i2)
      s2[(o = q2[i2]).i] = o.x(t4);
    return s2.join("");
  });
}
var degrees$4 = 180 / Math.PI;
var identity$9 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose$1(a2, b10, c2, d2, e3, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a2 * a2 + b10 * b10))
    a2 /= scaleX, b10 /= scaleX;
  if (skewX = a2 * c2 + b10 * d2)
    c2 -= a2 * skewX, d2 -= b10 * skewX;
  if (scaleY = Math.sqrt(c2 * c2 + d2 * d2))
    c2 /= scaleY, d2 /= scaleY, skewX /= scaleY;
  if (a2 * d2 < b10 * c2)
    a2 = -a2, b10 = -b10, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e3,
    translateY: f2,
    rotate: Math.atan2(b10, a2) * degrees$4,
    skewX: Math.atan(skewX) * degrees$4,
    scaleX,
    scaleY
  };
}
var svgNode$1;
function parseCss$1(value) {
  const m2 = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m2.isIdentity ? identity$9 : decompose$1(m2.a, m2.b, m2.c, m2.d, m2.e, m2.f);
}
function parseSvg$1(value) {
  if (value == null)
    return identity$9;
  if (!svgNode$1)
    svgNode$1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode$1.setAttribute("transform", value);
  if (!(value = svgNode$1.transform.baseVal.consolidate()))
    return identity$9;
  value = value.matrix;
  return decompose$1(value.a, value.b, value.c, value.d, value.e, value.f);
}
function interpolateTransform$1(parse2, pxComma, pxParen, degParen) {
  function pop(s2) {
    return s2.length ? s2.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push("translate(", null, pxComma, null, pxParen);
      q2.push({ i: i - 4, x: interpolateNumber$1(xa, xb) }, { i: i - 2, x: interpolateNumber$1(ya, yb) });
    } else if (xb || yb) {
      s2.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a2, b10, s2, q2) {
    if (a2 !== b10) {
      if (a2 - b10 > 180)
        b10 += 360;
      else if (b10 - a2 > 180)
        a2 += 360;
      q2.push({ i: s2.push(pop(s2) + "rotate(", null, degParen) - 2, x: interpolateNumber$1(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "rotate(" + b10 + degParen);
    }
  }
  function skewX(a2, b10, s2, q2) {
    if (a2 !== b10) {
      q2.push({ i: s2.push(pop(s2) + "skewX(", null, degParen) - 2, x: interpolateNumber$1(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "skewX(" + b10 + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push(pop(s2) + "scale(", null, ",", null, ")");
      q2.push({ i: i - 4, x: interpolateNumber$1(xa, xb) }, { i: i - 2, x: interpolateNumber$1(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s2.push(pop(s2) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a2, b10) {
    var s2 = [], q2 = [];
    a2 = parse2(a2), b10 = parse2(b10);
    translate(a2.translateX, a2.translateY, b10.translateX, b10.translateY, s2, q2);
    rotate(a2.rotate, b10.rotate, s2, q2);
    skewX(a2.skewX, b10.skewX, s2, q2);
    scale(a2.scaleX, a2.scaleY, b10.scaleX, b10.scaleY, s2, q2);
    a2 = b10 = null;
    return function(t4) {
      var i = -1, n2 = q2.length, o;
      while (++i < n2)
        s2[(o = q2[i]).i] = o.x(t4);
      return s2.join("");
    };
  };
}
var interpolateTransformCss$1 = interpolateTransform$1(parseCss$1, "px, ", "px)", "deg)");
var interpolateTransformSvg$1 = interpolateTransform$1(parseSvg$1, ", ", ")", ")");
function tweenRemove(id2, name) {
  var tween0, tween1;
  return function() {
    var schedule2 = set$1(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n2 = tween1.length; i < n2; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }
    schedule2.tween = tween1;
  };
}
function tweenFunction(id2, name, value) {
  var tween0, tween1;
  if (typeof value !== "function")
    throw new Error();
  return function() {
    var schedule2 = set$1(this, id2), tween = schedule2.tween;
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t4 = { name, value }, i = 0, n2 = tween1.length; i < n2; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t4;
          break;
        }
      }
      if (i === n2)
        tween1.push(t4);
    }
    schedule2.tween = tween1;
  };
}
function transition_tween(name, value) {
  var id2 = this._id;
  name += "";
  if (arguments.length < 2) {
    var tween = get$1(this.node(), id2).tween;
    for (var i = 0, n2 = tween.length, t4; i < n2; ++i) {
      if ((t4 = tween[i]).name === name) {
        return t4.value;
      }
    }
    return null;
  }
  return this.each((value == null ? tweenRemove : tweenFunction)(id2, name, value));
}
function tweenValue(transition2, name, value) {
  var id2 = transition2._id;
  transition2.each(function() {
    var schedule2 = set$1(this, id2);
    (schedule2.value || (schedule2.value = {}))[name] = value.apply(this, arguments);
  });
  return function(node2) {
    return get$1(node2, id2).value[name];
  };
}
function interpolate$2(a2, b10) {
  var c2;
  return (typeof b10 === "number" ? interpolateNumber$1 : b10 instanceof color$2 ? interpolateRgb : (c2 = color$2(b10)) ? (b10 = c2, interpolateRgb) : interpolateString)(a2, b10);
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttribute(name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrConstantNS(fullname, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = this.getAttributeNS(fullname.space, fullname.local);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function attrFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null)
      return void this.removeAttribute(name);
    string0 = this.getAttribute(name);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function attrFunctionNS(fullname, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0, value1 = value(this), string1;
    if (value1 == null)
      return void this.removeAttributeNS(fullname.space, fullname.local);
    string0 = this.getAttributeNS(fullname.space, fullname.local);
    string1 = value1 + "";
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function transition_attr(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg$1 : interpolate$2;
  return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
}
function attrInterpolate(name, i) {
  return function(t4) {
    this.setAttribute(name, i.call(this, t4));
  };
}
function attrInterpolateNS(fullname, i) {
  return function(t4) {
    this.setAttributeNS(fullname.space, fullname.local, i.call(this, t4));
  };
}
function attrTweenNS(fullname, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolateNS(fullname, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function attrTween(name, value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && attrInterpolate(name, i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_attrTween(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
}
function delayFunction(id2, value) {
  return function() {
    init(this, id2).delay = +value.apply(this, arguments);
  };
}
function delayConstant(id2, value) {
  return value = +value, function() {
    init(this, id2).delay = value;
  };
}
function transition_delay(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id2, value)) : get$1(this.node(), id2).delay;
}
function durationFunction(id2, value) {
  return function() {
    set$1(this, id2).duration = +value.apply(this, arguments);
  };
}
function durationConstant(id2, value) {
  return value = +value, function() {
    set$1(this, id2).duration = value;
  };
}
function transition_duration(value) {
  var id2 = this._id;
  return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id2, value)) : get$1(this.node(), id2).duration;
}
function easeConstant(id2, value) {
  if (typeof value !== "function")
    throw new Error();
  return function() {
    set$1(this, id2).ease = value;
  };
}
function transition_ease(value) {
  var id2 = this._id;
  return arguments.length ? this.each(easeConstant(id2, value)) : get$1(this.node(), id2).ease;
}
function easeVarying(id2, value) {
  return function() {
    var v2 = value.apply(this, arguments);
    if (typeof v2 !== "function")
      throw new Error();
    set$1(this, id2).ease = v2;
  };
}
function transition_easeVarying(value) {
  if (typeof value !== "function")
    throw new Error();
  return this.each(easeVarying(this._id, value));
}
function transition_filter(match2) {
  if (typeof match2 !== "function")
    match2 = matcher(match2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, subgroup = subgroups[j] = [], node2, i = 0; i < n2; ++i) {
      if ((node2 = group2[i]) && match2.call(node2, node2.__data__, i, group2)) {
        subgroup.push(node2);
      }
    }
  }
  return new Transition(subgroups, this._parents, this._name, this._id);
}
function transition_merge(transition2) {
  if (transition2._id !== this._id)
    throw new Error();
  for (var groups0 = this._groups, groups1 = transition2._groups, m0 = groups0.length, m1 = groups1.length, m2 = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m2; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n2 = group0.length, merge2 = merges[j] = new Array(n2), node2, i = 0; i < n2; ++i) {
      if (node2 = group0[i] || group1[i]) {
        merge2[i] = node2;
      }
    }
  }
  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }
  return new Transition(merges, this._parents, this._name, this._id);
}
function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t4) {
    var i = t4.indexOf(".");
    if (i >= 0)
      t4 = t4.slice(0, i);
    return !t4 || t4 === "start";
  });
}
function onFunction(id2, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule2 = sit(this, id2), on = schedule2.on;
    if (on !== on0)
      (on1 = (on0 = on).copy()).on(name, listener);
    schedule2.on = on1;
  };
}
function transition_on(name, listener) {
  var id2 = this._id;
  return arguments.length < 2 ? get$1(this.node(), id2).on.on(name) : this.each(onFunction(id2, name, listener));
}
function removeFunction(id2) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition)
      if (+i !== id2)
        return;
    if (parent)
      parent.removeChild(this);
  };
}
function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}
function transition_select(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selector(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, subgroup = subgroups[j] = new Array(n2), node2, subnode, i = 0; i < n2; ++i) {
      if ((node2 = group2[i]) && (subnode = select2.call(node2, node2.__data__, i, group2))) {
        if ("__data__" in node2)
          subnode.__data__ = node2.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id2, i, subgroup, get$1(node2, id2));
      }
    }
  }
  return new Transition(subgroups, this._parents, name, id2);
}
function transition_selectAll(select2) {
  var name = this._name, id2 = this._id;
  if (typeof select2 !== "function")
    select2 = selectorAll(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = [], parents = [], j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, node2, i = 0; i < n2; ++i) {
      if (node2 = group2[i]) {
        for (var children2 = select2.call(node2, node2.__data__, i, group2), child, inherit2 = get$1(node2, id2), k2 = 0, l2 = children2.length; k2 < l2; ++k2) {
          if (child = children2[k2]) {
            schedule(child, name, id2, k2, children2, inherit2);
          }
        }
        subgroups.push(children2);
        parents.push(node2);
      }
    }
  }
  return new Transition(subgroups, parents, name, id2);
}
var Selection = selection.prototype.constructor;
function transition_selection() {
  return new Selection(this._groups, this._parents);
}
function styleNull(name, interpolate2) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, string10 = string1);
  };
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, interpolate2, value1) {
  var string00, string1 = value1 + "", interpolate0;
  return function() {
    var string0 = styleValue(this, name);
    return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate2(string00 = string0, value1);
  };
}
function styleFunction(name, interpolate2, value) {
  var string00, string10, interpolate0;
  return function() {
    var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
    if (value1 == null)
      string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
    return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate2(string00 = string0, value1));
  };
}
function styleMaybeRemove(id2, name) {
  var on0, on1, listener0, key = "style." + name, event = "end." + key, remove2;
  return function() {
    var schedule2 = set$1(this, id2), on = schedule2.on, listener = schedule2.value[key] == null ? remove2 || (remove2 = styleRemove(name)) : void 0;
    if (on !== on0 || listener0 !== listener)
      (on1 = (on0 = on).copy()).on(event, listener0 = listener);
    schedule2.on = on1;
  };
}
function transition_style(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss$1 : interpolate$2;
  return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
}
function styleInterpolate(name, i, priority) {
  return function(t4) {
    this.style.setProperty(name, i.call(this, t4), priority);
  };
}
function styleTween(name, value, priority) {
  var t4, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t4 = (i0 = i) && styleInterpolate(name, i, priority);
    return t4;
  }
  tween._value = value;
  return tween;
}
function transition_styleTween(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}
function transition_text(value) {
  return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
}
function textInterpolate(i) {
  return function(t4) {
    this.textContent = i.call(this, t4);
  };
}
function textTween(value) {
  var t02, i0;
  function tween() {
    var i = value.apply(this, arguments);
    if (i !== i0)
      t02 = (i0 = i) && textInterpolate(i);
    return t02;
  }
  tween._value = value;
  return tween;
}
function transition_textTween(value) {
  var key = "text";
  if (arguments.length < 1)
    return (key = this.tween(key)) && key._value;
  if (value == null)
    return this.tween(key, null);
  if (typeof value !== "function")
    throw new Error();
  return this.tween(key, textTween(value));
}
function transition_transition() {
  var name = this._name, id0 = this._id, id1 = newId();
  for (var groups2 = this._groups, m2 = groups2.length, j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, node2, i = 0; i < n2; ++i) {
      if (node2 = group2[i]) {
        var inherit2 = get$1(node2, id0);
        schedule(node2, name, id1, i, group2, {
          time: inherit2.time + inherit2.delay + inherit2.duration,
          delay: 0,
          duration: inherit2.duration,
          ease: inherit2.ease
        });
      }
    }
  }
  return new Transition(groups2, this._parents, name, id1);
}
function transition_end() {
  var on0, on1, that = this, id2 = that._id, size = that.size();
  return new Promise(function(resolve, reject) {
    var cancel = { value: reject }, end2 = { value: function() {
      if (--size === 0)
        resolve();
    } };
    that.each(function() {
      var schedule2 = set$1(this, id2), on = schedule2.on;
      if (on !== on0) {
        on1 = (on0 = on).copy();
        on1._.cancel.push(cancel);
        on1._.interrupt.push(cancel);
        on1._.end.push(end2);
      }
      schedule2.on = on1;
    });
    if (size === 0)
      resolve();
  });
}
var id = 0;
function Transition(groups2, parents, name, id2) {
  this._groups = groups2;
  this._parents = parents;
  this._name = name;
  this._id = id2;
}
function transition(name) {
  return selection().transition(name);
}
function newId() {
  return ++id;
}
var selection_prototype = selection.prototype;
Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  textTween: transition_textTween,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  easeVarying: transition_easeVarying,
  end: transition_end,
  [Symbol.iterator]: selection_prototype[Symbol.iterator]
};
const linear$3 = (t4) => +t4;
function quadIn(t4) {
  return t4 * t4;
}
function quadOut(t4) {
  return t4 * (2 - t4);
}
function quadInOut(t4) {
  return ((t4 *= 2) <= 1 ? t4 * t4 : --t4 * (2 - t4) + 1) / 2;
}
function cubicIn(t4) {
  return t4 * t4 * t4;
}
function cubicOut(t4) {
  return --t4 * t4 * t4 + 1;
}
function cubicInOut(t4) {
  return ((t4 *= 2) <= 1 ? t4 * t4 * t4 : (t4 -= 2) * t4 * t4 + 2) / 2;
}
var exponent$1 = 3;
var polyIn = function custom8(e3) {
  e3 = +e3;
  function polyIn2(t4) {
    return Math.pow(t4, e3);
  }
  polyIn2.exponent = custom8;
  return polyIn2;
}(exponent$1);
var polyOut = function custom9(e3) {
  e3 = +e3;
  function polyOut2(t4) {
    return 1 - Math.pow(1 - t4, e3);
  }
  polyOut2.exponent = custom9;
  return polyOut2;
}(exponent$1);
var polyInOut = function custom10(e3) {
  e3 = +e3;
  function polyInOut2(t4) {
    return ((t4 *= 2) <= 1 ? Math.pow(t4, e3) : 2 - Math.pow(2 - t4, e3)) / 2;
  }
  polyInOut2.exponent = custom10;
  return polyInOut2;
}(exponent$1);
var pi$4 = Math.PI, halfPi$3 = pi$4 / 2;
function sinIn(t4) {
  return +t4 === 1 ? 1 : 1 - Math.cos(t4 * halfPi$3);
}
function sinOut(t4) {
  return Math.sin(t4 * halfPi$3);
}
function sinInOut(t4) {
  return (1 - Math.cos(pi$4 * t4)) / 2;
}
function tpmt(x2) {
  return (Math.pow(2, -10 * x2) - 9765625e-10) * 1.0009775171065494;
}
function expIn(t4) {
  return tpmt(1 - +t4);
}
function expOut(t4) {
  return 1 - tpmt(t4);
}
function expInOut(t4) {
  return ((t4 *= 2) <= 1 ? tpmt(1 - t4) : 2 - tpmt(t4 - 1)) / 2;
}
function circleIn(t4) {
  return 1 - Math.sqrt(1 - t4 * t4);
}
function circleOut(t4) {
  return Math.sqrt(1 - --t4 * t4);
}
function circleInOut(t4) {
  return ((t4 *= 2) <= 1 ? 1 - Math.sqrt(1 - t4 * t4) : Math.sqrt(1 - (t4 -= 2) * t4) + 1) / 2;
}
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t4) {
  return 1 - bounceOut(1 - t4);
}
function bounceOut(t4) {
  return (t4 = +t4) < b1 ? b0 * t4 * t4 : t4 < b3 ? b0 * (t4 -= b2) * t4 + b4 : t4 < b6 ? b0 * (t4 -= b5) * t4 + b7 : b0 * (t4 -= b8) * t4 + b9;
}
function bounceInOut(t4) {
  return ((t4 *= 2) <= 1 ? 1 - bounceOut(1 - t4) : bounceOut(t4 - 1) + 1) / 2;
}
var overshoot = 1.70158;
var backIn = function custom11(s2) {
  s2 = +s2;
  function backIn2(t4) {
    return (t4 = +t4) * t4 * (s2 * (t4 - 1) + t4);
  }
  backIn2.overshoot = custom11;
  return backIn2;
}(overshoot);
var backOut = function custom12(s2) {
  s2 = +s2;
  function backOut2(t4) {
    return --t4 * t4 * ((t4 + 1) * s2 + t4) + 1;
  }
  backOut2.overshoot = custom12;
  return backOut2;
}(overshoot);
var backInOut = function custom13(s2) {
  s2 = +s2;
  function backInOut2(t4) {
    return ((t4 *= 2) < 1 ? t4 * t4 * ((s2 + 1) * t4 - s2) : (t4 -= 2) * t4 * ((s2 + 1) * t4 + s2) + 2) / 2;
  }
  backInOut2.overshoot = custom13;
  return backInOut2;
}(overshoot);
var tau$5 = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom14(a2, p2) {
  var s2 = Math.asin(1 / (a2 = Math.max(1, a2))) * (p2 /= tau$5);
  function elasticIn2(t4) {
    return a2 * tpmt(- --t4) * Math.sin((s2 - t4) / p2);
  }
  elasticIn2.amplitude = function(a3) {
    return custom14(a3, p2 * tau$5);
  };
  elasticIn2.period = function(p3) {
    return custom14(a2, p3);
  };
  return elasticIn2;
}(amplitude, period);
var elasticOut = function custom15(a2, p2) {
  var s2 = Math.asin(1 / (a2 = Math.max(1, a2))) * (p2 /= tau$5);
  function elasticOut2(t4) {
    return 1 - a2 * tpmt(t4 = +t4) * Math.sin((t4 + s2) / p2);
  }
  elasticOut2.amplitude = function(a3) {
    return custom15(a3, p2 * tau$5);
  };
  elasticOut2.period = function(p3) {
    return custom15(a2, p3);
  };
  return elasticOut2;
}(amplitude, period);
var elasticInOut = function custom16(a2, p2) {
  var s2 = Math.asin(1 / (a2 = Math.max(1, a2))) * (p2 /= tau$5);
  function elasticInOut2(t4) {
    return ((t4 = t4 * 2 - 1) < 0 ? a2 * tpmt(-t4) * Math.sin((s2 - t4) / p2) : 2 - a2 * tpmt(t4) * Math.sin((s2 + t4) / p2)) / 2;
  }
  elasticInOut2.amplitude = function(a3) {
    return custom16(a3, p2 * tau$5);
  };
  elasticInOut2.period = function(p3) {
    return custom16(a2, p3);
  };
  return elasticInOut2;
}(amplitude, period);
var defaultTiming = {
  time: null,
  delay: 0,
  duration: 250,
  ease: cubicInOut
};
function inherit(node2, id2) {
  var timing;
  while (!(timing = node2.__transition) || !(timing = timing[id2])) {
    if (!(node2 = node2.parentNode)) {
      throw new Error(`transition ${id2} not found`);
    }
  }
  return timing;
}
function selection_transition(name) {
  var id2, timing;
  if (name instanceof Transition) {
    id2 = name._id, name = name._name;
  } else {
    id2 = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }
  for (var groups2 = this._groups, m2 = groups2.length, j = 0; j < m2; ++j) {
    for (var group2 = groups2[j], n2 = group2.length, node2, i = 0; i < n2; ++i) {
      if (node2 = group2[i]) {
        schedule(node2, name, id2, i, group2, timing || inherit(node2, id2));
      }
    }
  }
  return new Transition(groups2, this._parents, name, id2);
}
selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;
var root$2 = [null];
function active(node2, name) {
  var schedules = node2.__transition, schedule2, i;
  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule2 = schedules[i]).state > SCHEDULED && schedule2.name === name) {
        return new Transition([[node2]], root$2, name, +i);
      }
    }
  }
  return null;
}
var constant$9 = (x2) => () => x2;
function BrushEvent(type2, {
  sourceEvent: sourceEvent2,
  target,
  selection: selection2,
  mode,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent2, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    selection: { value: selection2, enumerable: true, configurable: true },
    mode: { value: mode, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
function nopropagation$1(event) {
  event.stopImmediatePropagation();
}
function noevent$1(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
var MODE_DRAG = { name: "drag" }, MODE_SPACE = { name: "space" }, MODE_HANDLE = { name: "handle" }, MODE_CENTER = { name: "center" };
const { abs: abs$3, max: max$3, min: min$1 } = Math;
function number1(e3) {
  return [+e3[0], +e3[1]];
}
function number2(e3) {
  return [number1(e3[0]), number1(e3[1])];
}
var X = {
  name: "x",
  handles: ["w", "e"].map(type),
  input: function(x2, e3) {
    return x2 == null ? null : [[+x2[0], e3[0][1]], [+x2[1], e3[1][1]]];
  },
  output: function(xy) {
    return xy && [xy[0][0], xy[1][0]];
  }
};
var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y2, e3) {
    return y2 == null ? null : [[e3[0][0], +y2[0]], [e3[1][0], +y2[1]]];
  },
  output: function(xy) {
    return xy && [xy[0][1], xy[1][1]];
  }
};
var XY = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(type),
  input: function(xy) {
    return xy == null ? null : number2(xy);
  },
  output: function(xy) {
    return xy;
  }
};
var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};
var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};
var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};
var signsX = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
};
var signsY = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function type(t4) {
  return { type: t4 };
}
function defaultFilter$1(event) {
  return !event.ctrlKey && !event.button;
}
function defaultExtent$1() {
  var svg2 = this.ownerSVGElement || this;
  if (svg2.hasAttribute("viewBox")) {
    svg2 = svg2.viewBox.baseVal;
    return [[svg2.x, svg2.y], [svg2.x + svg2.width, svg2.y + svg2.height]];
  }
  return [[0, 0], [svg2.width.baseVal.value, svg2.height.baseVal.value]];
}
function defaultTouchable$1() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function local(node2) {
  while (!node2.__brush)
    if (!(node2 = node2.parentNode))
      return;
  return node2.__brush;
}
function empty(extent2) {
  return extent2[0][0] === extent2[1][0] || extent2[0][1] === extent2[1][1];
}
function brushSelection(node2) {
  var state = node2.__brush;
  return state ? state.dim.output(state.selection) : null;
}
function brushX() {
  return brush$1(X);
}
function brushY() {
  return brush$1(Y);
}
function brush() {
  return brush$1(XY);
}
function brush$1(dim) {
  var extent2 = defaultExtent$1, filter2 = defaultFilter$1, touchable = defaultTouchable$1, keys2 = true, listeners = dispatch$1("start", "brush", "end"), handleSize = 6, touchending;
  function brush2(group2) {
    var overlay = group2.property("__brush", initialize).selectAll(".overlay").data([type("overlay")]);
    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
      var extent3 = local(this).extent;
      select(this).attr("x", extent3[0][0]).attr("y", extent3[0][1]).attr("width", extent3[1][0] - extent3[0][0]).attr("height", extent3[1][1] - extent3[0][1]);
    });
    group2.selectAll(".selection").data([type("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var handle = group2.selectAll(".handle").data(dim.handles, function(d2) {
      return d2.type;
    });
    handle.exit().remove();
    handle.enter().append("rect").attr("class", function(d2) {
      return "handle handle--" + d2.type;
    }).attr("cursor", function(d2) {
      return cursors[d2.type];
    });
    group2.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  brush2.move = function(group2, selection2) {
    if (group2.tween) {
      group2.on("start.brush", function(event) {
        emitter(this, arguments).beforestart().start(event);
      }).on("interrupt.brush end.brush", function(event) {
        emitter(this, arguments).end(event);
      }).tween("brush", function() {
        var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(this, arguments) : selection2, state.extent), i = interpolate$3(selection0, selection1);
        function tween(t4) {
          state.selection = t4 === 1 && selection1 === null ? null : i(t4);
          redraw.call(that);
          emit.brush();
        }
        return selection0 !== null && selection1 !== null ? tween : tween(1);
      });
    } else {
      group2.each(function() {
        var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection2 === "function" ? selection2.apply(that, args) : selection2, state.extent), emit = emitter(that, args).beforestart();
        interrupt(that);
        state.selection = selection1 === null ? null : selection1;
        redraw.call(that);
        emit.start().brush().end();
      });
    }
  };
  brush2.clear = function(group2) {
    brush2.move(group2, null);
  };
  function redraw() {
    var group2 = select(this), selection2 = local(this).selection;
    if (selection2) {
      group2.selectAll(".selection").style("display", null).attr("x", selection2[0][0]).attr("y", selection2[0][1]).attr("width", selection2[1][0] - selection2[0][0]).attr("height", selection2[1][1] - selection2[0][1]);
      group2.selectAll(".handle").style("display", null).attr("x", function(d2) {
        return d2.type[d2.type.length - 1] === "e" ? selection2[1][0] - handleSize / 2 : selection2[0][0] - handleSize / 2;
      }).attr("y", function(d2) {
        return d2.type[0] === "s" ? selection2[1][1] - handleSize / 2 : selection2[0][1] - handleSize / 2;
      }).attr("width", function(d2) {
        return d2.type === "n" || d2.type === "s" ? selection2[1][0] - selection2[0][0] + handleSize : handleSize;
      }).attr("height", function(d2) {
        return d2.type === "e" || d2.type === "w" ? selection2[1][1] - selection2[0][1] + handleSize : handleSize;
      });
    } else {
      group2.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
  }
  function emitter(that, args, clean) {
    var emit = that.__brush.emitter;
    return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
  }
  function Emitter(that, args, clean) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
    this.clean = clean;
  }
  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1)
        this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function(event, mode) {
      if (this.starting)
        this.starting = false, this.emit("start", event, mode);
      else
        this.emit("brush", event);
      return this;
    },
    brush: function(event, mode) {
      this.emit("brush", event, mode);
      return this;
    },
    end: function(event, mode) {
      if (--this.active === 0)
        delete this.state.emitter, this.emit("end", event, mode);
      return this;
    },
    emit: function(type2, event, mode) {
      var d2 = select(this.that).datum();
      listeners.call(
        type2,
        this.that,
        new BrushEvent(type2, {
          sourceEvent: event,
          target: brush2,
          selection: dim.output(this.state.selection),
          mode,
          dispatch: listeners
        }),
        d2
      );
    }
  };
  function started(event) {
    if (touchending && !event.touches)
      return;
    if (!filter2.apply(this, arguments))
      return;
    var that = this, type2 = event.target.__data__.type, mode = (keys2 && event.metaKey ? type2 = "overlay" : type2) === "selection" ? MODE_DRAG : keys2 && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type2], signY = dim === X ? null : signsY[type2], state = local(that), extent3 = state.extent, selection2 = state.selection, W = extent3[0][0], w0, w1, N = extent3[0][1], n0, n1, E2 = extent3[1][0], e0, e1, S = extent3[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys2 && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [event], (t4) => {
      const i = t4.identifier;
      t4 = pointer(t4, that);
      t4.point0 = t4.slice();
      t4.identifier = i;
      return t4;
    });
    if (type2 === "overlay") {
      if (selection2)
        moving = true;
      const pts = [points[0], points[1] || points[0]];
      state.selection = selection2 = [[
        w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]),
        n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])
      ], [
        e0 = dim === Y ? E2 : max$3(pts[0][0], pts[1][0]),
        s0 = dim === X ? S : max$3(pts[0][1], pts[1][1])
      ]];
      if (points.length > 1)
        move();
    } else {
      w0 = selection2[0][0];
      n0 = selection2[0][1];
      e0 = selection2[1][0];
      s0 = selection2[1][1];
    }
    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;
    var group2 = select(that).attr("pointer-events", "none");
    var overlay = group2.selectAll(".overlay").attr("cursor", cursors[type2]);
    interrupt(that);
    var emit = emitter(that, arguments, true).beforestart();
    if (event.touches) {
      emit.moved = moved;
      emit.ended = ended;
    } else {
      var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
      if (keys2)
        view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
      dragDisable(event.view);
    }
    redraw.call(that);
    emit.start(event, mode.name);
    function moved(event2) {
      for (const p2 of event2.changedTouches || [event2]) {
        for (const d2 of points)
          if (d2.identifier === p2.identifier)
            d2.cur = pointer(p2, that);
      }
      if (shifting && !lockX && !lockY && points.length === 1) {
        const point2 = points[0];
        if (abs$3(point2.cur[0] - point2[0]) > abs$3(point2.cur[1] - point2[1]))
          lockY = true;
        else
          lockX = true;
      }
      for (const point2 of points)
        if (point2.cur)
          point2[0] = point2.cur[0], point2[1] = point2.cur[1];
      moving = true;
      noevent$1(event2);
      move(event2);
    }
    function move(event2) {
      const point2 = points[0], point0 = point2.point0;
      var t4;
      dx = point2[0] - point0[0];
      dy = point2[1] - point0[1];
      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX)
            dx = max$3(W - w0, min$1(E2 - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY)
            dy = max$3(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (points[1]) {
            if (signX)
              w1 = max$3(W, min$1(E2, points[0][0])), e1 = max$3(W, min$1(E2, points[1][0])), signX = 1;
            if (signY)
              n1 = max$3(N, min$1(S, points[0][1])), s1 = max$3(N, min$1(S, points[1][1])), signY = 1;
          } else {
            if (signX < 0)
              dx = max$3(W - w0, min$1(E2 - w0, dx)), w1 = w0 + dx, e1 = e0;
            else if (signX > 0)
              dx = max$3(W - e0, min$1(E2 - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0)
              dy = max$3(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
            else if (signY > 0)
              dy = max$3(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          }
          break;
        }
        case MODE_CENTER: {
          if (signX)
            w1 = max$3(W, min$1(E2, w0 - dx * signX)), e1 = max$3(W, min$1(E2, e0 + dx * signX));
          if (signY)
            n1 = max$3(N, min$1(S, n0 - dy * signY)), s1 = max$3(N, min$1(S, s0 + dy * signY));
          break;
        }
      }
      if (e1 < w1) {
        signX *= -1;
        t4 = w0, w0 = e0, e0 = t4;
        t4 = w1, w1 = e1, e1 = t4;
        if (type2 in flipX)
          overlay.attr("cursor", cursors[type2 = flipX[type2]]);
      }
      if (s1 < n1) {
        signY *= -1;
        t4 = n0, n0 = s0, s0 = t4;
        t4 = n1, n1 = s1, s1 = t4;
        if (type2 in flipY)
          overlay.attr("cursor", cursors[type2 = flipY[type2]]);
      }
      if (state.selection)
        selection2 = state.selection;
      if (lockX)
        w1 = selection2[0][0], e1 = selection2[1][0];
      if (lockY)
        n1 = selection2[0][1], s1 = selection2[1][1];
      if (selection2[0][0] !== w1 || selection2[0][1] !== n1 || selection2[1][0] !== e1 || selection2[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush(event2, mode.name);
      }
    }
    function ended(event2) {
      nopropagation$1(event2);
      if (event2.touches) {
        if (event2.touches.length)
          return;
        if (touchending)
          clearTimeout(touchending);
        touchending = setTimeout(function() {
          touchending = null;
        }, 500);
      } else {
        yesdrag(event2.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group2.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection)
        selection2 = state.selection;
      if (empty(selection2))
        state.selection = null, redraw.call(that);
      emit.end(event2, mode.name);
    }
    function keydowned(event2) {
      switch (event2.keyCode) {
        case 16: {
          shifting = signX && signY;
          break;
        }
        case 18: {
          if (mode === MODE_HANDLE) {
            if (signX)
              e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY)
              s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: {
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0)
              e0 = e1 - dx;
            else if (signX > 0)
              w0 = w1 - dx;
            if (signY < 0)
              s0 = s1 - dy;
            else if (signY > 0)
              n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default:
          return;
      }
      noevent$1(event2);
    }
    function keyupped(event2) {
      switch (event2.keyCode) {
        case 16: {
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: {
          if (mode === MODE_CENTER) {
            if (signX < 0)
              e0 = e1;
            else if (signX > 0)
              w0 = w1;
            if (signY < 0)
              s0 = s1;
            else if (signY > 0)
              n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: {
          if (mode === MODE_SPACE) {
            if (event2.altKey) {
              if (signX)
                e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY)
                s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0)
                e0 = e1;
              else if (signX > 0)
                w0 = w1;
              if (signY < 0)
                s0 = s1;
              else if (signY > 0)
                n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type2]);
            move();
          }
          break;
        }
        default:
          return;
      }
      noevent$1(event2);
    }
  }
  function touchmoved(event) {
    emitter(this, arguments).moved(event);
  }
  function touchended(event) {
    emitter(this, arguments).ended(event);
  }
  function initialize() {
    var state = this.__brush || { selection: null };
    state.extent = number2(extent2.apply(this, arguments));
    state.dim = dim;
    return state;
  }
  brush2.extent = function(_2) {
    return arguments.length ? (extent2 = typeof _2 === "function" ? _2 : constant$9(number2(_2)), brush2) : extent2;
  };
  brush2.filter = function(_2) {
    return arguments.length ? (filter2 = typeof _2 === "function" ? _2 : constant$9(!!_2), brush2) : filter2;
  };
  brush2.touchable = function(_2) {
    return arguments.length ? (touchable = typeof _2 === "function" ? _2 : constant$9(!!_2), brush2) : touchable;
  };
  brush2.handleSize = function(_2) {
    return arguments.length ? (handleSize = +_2, brush2) : handleSize;
  };
  brush2.keyModifiers = function(_2) {
    return arguments.length ? (keys2 = !!_2, brush2) : keys2;
  };
  brush2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush2 : value;
  };
  return brush2;
}
var abs$2 = Math.abs;
var cos$2 = Math.cos;
var sin$2 = Math.sin;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var tau$4 = pi$3 * 2;
var max$2 = Math.max;
var epsilon$4 = 1e-12;
function range$2(i, j) {
  return Array.from({ length: j - i }, (_2, k2) => i + k2);
}
function compareValue(compare) {
  return function(a2, b10) {
    return compare(
      a2.source.value + a2.target.value,
      b10.source.value + b10.target.value
    );
  };
}
function chord() {
  return chord$1(false, false);
}
function chordTranspose() {
  return chord$1(false, true);
}
function chordDirected() {
  return chord$1(true, false);
}
function chord$1(directed, transpose2) {
  var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
  function chord2(matrix) {
    var n2 = matrix.length, groupSums = new Array(n2), groupIndex = range$2(0, n2), chords = new Array(n2 * n2), groups2 = new Array(n2), k2 = 0, dx;
    matrix = Float64Array.from({ length: n2 * n2 }, transpose2 ? (_2, i) => matrix[i % n2][i / n2 | 0] : (_2, i) => matrix[i / n2 | 0][i % n2]);
    for (let i = 0; i < n2; ++i) {
      let x2 = 0;
      for (let j = 0; j < n2; ++j)
        x2 += matrix[i * n2 + j] + directed * matrix[j * n2 + i];
      k2 += groupSums[i] = x2;
    }
    k2 = max$2(0, tau$4 - padAngle * n2) / k2;
    dx = k2 ? padAngle : tau$4 / n2;
    {
      let x2 = 0;
      if (sortGroups)
        groupIndex.sort((a2, b10) => sortGroups(groupSums[a2], groupSums[b10]));
      for (const i of groupIndex) {
        const x02 = x2;
        if (directed) {
          const subgroupIndex = range$2(~n2 + 1, n2).filter((j) => j < 0 ? matrix[~j * n2 + i] : matrix[i * n2 + j]);
          if (sortSubgroups)
            subgroupIndex.sort((a2, b10) => sortSubgroups(a2 < 0 ? -matrix[~a2 * n2 + i] : matrix[i * n2 + a2], b10 < 0 ? -matrix[~b10 * n2 + i] : matrix[i * n2 + b10]));
          for (const j of subgroupIndex) {
            if (j < 0) {
              const chord3 = chords[~j * n2 + i] || (chords[~j * n2 + i] = { source: null, target: null });
              chord3.target = { index: i, startAngle: x2, endAngle: x2 += matrix[~j * n2 + i] * k2, value: matrix[~j * n2 + i] };
            } else {
              const chord3 = chords[i * n2 + j] || (chords[i * n2 + j] = { source: null, target: null });
              chord3.source = { index: i, startAngle: x2, endAngle: x2 += matrix[i * n2 + j] * k2, value: matrix[i * n2 + j] };
            }
          }
          groups2[i] = { index: i, startAngle: x02, endAngle: x2, value: groupSums[i] };
        } else {
          const subgroupIndex = range$2(0, n2).filter((j) => matrix[i * n2 + j] || matrix[j * n2 + i]);
          if (sortSubgroups)
            subgroupIndex.sort((a2, b10) => sortSubgroups(matrix[i * n2 + a2], matrix[i * n2 + b10]));
          for (const j of subgroupIndex) {
            let chord3;
            if (i < j) {
              chord3 = chords[i * n2 + j] || (chords[i * n2 + j] = { source: null, target: null });
              chord3.source = { index: i, startAngle: x2, endAngle: x2 += matrix[i * n2 + j] * k2, value: matrix[i * n2 + j] };
            } else {
              chord3 = chords[j * n2 + i] || (chords[j * n2 + i] = { source: null, target: null });
              chord3.target = { index: i, startAngle: x2, endAngle: x2 += matrix[i * n2 + j] * k2, value: matrix[i * n2 + j] };
              if (i === j)
                chord3.source = chord3.target;
            }
            if (chord3.source && chord3.target && chord3.source.value < chord3.target.value) {
              const source = chord3.source;
              chord3.source = chord3.target;
              chord3.target = source;
            }
          }
          groups2[i] = { index: i, startAngle: x02, endAngle: x2, value: groupSums[i] };
        }
        x2 += dx;
      }
    }
    chords = Object.values(chords);
    chords.groups = groups2;
    return sortChords ? chords.sort(sortChords) : chords;
  }
  chord2.padAngle = function(_2) {
    return arguments.length ? (padAngle = max$2(0, _2), chord2) : padAngle;
  };
  chord2.sortGroups = function(_2) {
    return arguments.length ? (sortGroups = _2, chord2) : sortGroups;
  };
  chord2.sortSubgroups = function(_2) {
    return arguments.length ? (sortSubgroups = _2, chord2) : sortSubgroups;
  };
  chord2.sortChords = function(_2) {
    return arguments.length ? (_2 == null ? sortChords = null : (sortChords = compareValue(_2))._ = _2, chord2) : sortChords && sortChords._;
  };
  return chord2;
}
var slice$2 = Array.prototype.slice;
function constant$8(x2) {
  return function() {
    return x2;
  };
}
function defaultSource$1(d2) {
  return d2.source;
}
function defaultTarget(d2) {
  return d2.target;
}
function defaultRadius$1(d2) {
  return d2.radius;
}
function defaultStartAngle(d2) {
  return d2.startAngle;
}
function defaultEndAngle(d2) {
  return d2.endAngle;
}
function defaultPadAngle() {
  return 0;
}
function defaultArrowheadRadius() {
  return 10;
}
function ribbon(headRadius) {
  var source = defaultSource$1, target = defaultTarget, sourceRadius = defaultRadius$1, targetRadius = defaultRadius$1, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
  function ribbon2() {
    var buffer2, s2 = source.apply(this, arguments), t4 = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice$2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s2, argv)), sa0 = startAngle.apply(this, argv) - halfPi$2, sa1 = endAngle.apply(this, argv) - halfPi$2, tr = +targetRadius.apply(this, (argv[0] = t4, argv)), ta0 = startAngle.apply(this, argv) - halfPi$2, ta1 = endAngle.apply(this, argv) - halfPi$2;
    if (!context)
      context = buffer2 = path$1();
    if (ap > epsilon$4) {
      if (abs$2(sa1 - sa0) > ap * 2 + epsilon$4)
        sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
      else
        sa0 = sa1 = (sa0 + sa1) / 2;
      if (abs$2(ta1 - ta0) > ap * 2 + epsilon$4)
        ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
      else
        ta0 = ta1 = (ta0 + ta1) / 2;
    }
    context.moveTo(sr * cos$2(sa0), sr * sin$2(sa0));
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) {
      if (headRadius) {
        var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
        context.quadraticCurveTo(0, 0, tr2 * cos$2(ta0), tr2 * sin$2(ta0));
        context.lineTo(tr * cos$2(ta2), tr * sin$2(ta2));
        context.lineTo(tr2 * cos$2(ta1), tr2 * sin$2(ta1));
      } else {
        context.quadraticCurveTo(0, 0, tr * cos$2(ta0), tr * sin$2(ta0));
        context.arc(0, 0, tr, ta0, ta1);
      }
    }
    context.quadraticCurveTo(0, 0, sr * cos$2(sa0), sr * sin$2(sa0));
    context.closePath();
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  if (headRadius)
    ribbon2.headRadius = function(_2) {
      return arguments.length ? (headRadius = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : headRadius;
    };
  ribbon2.radius = function(_2) {
    return arguments.length ? (sourceRadius = targetRadius = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : sourceRadius;
  };
  ribbon2.sourceRadius = function(_2) {
    return arguments.length ? (sourceRadius = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : sourceRadius;
  };
  ribbon2.targetRadius = function(_2) {
    return arguments.length ? (targetRadius = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : targetRadius;
  };
  ribbon2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : startAngle;
  };
  ribbon2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : endAngle;
  };
  ribbon2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$8(+_2), ribbon2) : padAngle;
  };
  ribbon2.source = function(_2) {
    return arguments.length ? (source = _2, ribbon2) : source;
  };
  ribbon2.target = function(_2) {
    return arguments.length ? (target = _2, ribbon2) : target;
  };
  ribbon2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, ribbon2) : context;
  };
  return ribbon2;
}
function ribbon$1() {
  return ribbon();
}
function ribbonArrow() {
  return ribbon(defaultArrowheadRadius);
}
function define$1(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color$1() {
}
var darker$1 = 0.7;
var brighter$1 = 1 / darker$1;
var reI$1 = "\\s*([+-]?\\d+)\\s*", reN$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex$1 = /^#([0-9a-f]{3,8})$/, reRgbInteger$1 = new RegExp("^rgb\\(" + [reI$1, reI$1, reI$1] + "\\)$"), reRgbPercent$1 = new RegExp("^rgb\\(" + [reP$1, reP$1, reP$1] + "\\)$"), reRgbaInteger$1 = new RegExp("^rgba\\(" + [reI$1, reI$1, reI$1, reN$1] + "\\)$"), reRgbaPercent$1 = new RegExp("^rgba\\(" + [reP$1, reP$1, reP$1, reN$1] + "\\)$"), reHslPercent$1 = new RegExp("^hsl\\(" + [reN$1, reP$1, reP$1] + "\\)$"), reHslaPercent$1 = new RegExp("^hsla\\(" + [reN$1, reP$1, reP$1, reN$1] + "\\)$");
var named$1 = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$1(Color$1, color$1, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$1,
  formatHex: color_formatHex$1,
  formatHsl: color_formatHsl$1,
  formatRgb: color_formatRgb$1,
  toString: color_formatRgb$1
});
function color_formatHex$1() {
  return this.rgb().formatHex();
}
function color_formatHsl$1() {
  return hslConvert$1(this).formatHsl();
}
function color_formatRgb$1() {
  return this.rgb().formatRgb();
}
function color$1(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex$1.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn$1(m2) : l2 === 3 ? new Rgb$1(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba$1(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba$1(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger$1.exec(format2)) ? new Rgb$1(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent$1.exec(format2)) ? new Rgb$1(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger$1.exec(format2)) ? rgba$1(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent$1.exec(format2)) ? rgba$1(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent$1.exec(format2)) ? hsla$1(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent$1.exec(format2)) ? hsla$1(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named$1.hasOwnProperty(format2) ? rgbn$1(named$1[format2]) : format2 === "transparent" ? new Rgb$1(NaN, NaN, NaN, 0) : null;
}
function rgbn$1(n2) {
  return new Rgb$1(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba$1(r2, g2, b10, a2) {
  if (a2 <= 0)
    r2 = g2 = b10 = NaN;
  return new Rgb$1(r2, g2, b10, a2);
}
function rgbConvert$1(o) {
  if (!(o instanceof Color$1))
    o = color$1(o);
  if (!o)
    return new Rgb$1();
  o = o.rgb();
  return new Rgb$1(o.r, o.g, o.b, o.opacity);
}
function rgb$2(r2, g2, b10, opacity) {
  return arguments.length === 1 ? rgbConvert$1(r2) : new Rgb$1(r2, g2, b10, opacity == null ? 1 : opacity);
}
function Rgb$1(r2, g2, b10, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$1(Rgb$1, rgb$2, extend$1(Color$1, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$1 : Math.pow(brighter$1, k2);
    return new Rgb$1(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$1 : Math.pow(darker$1, k2);
    return new Rgb$1(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$1,
  formatHex: rgb_formatHex$1,
  formatRgb: rgb_formatRgb$1,
  toString: rgb_formatRgb$1
}));
function rgb_formatHex$1() {
  return "#" + hex$1(this.r) + hex$1(this.g) + hex$1(this.b);
}
function rgb_formatRgb$1() {
  var a2 = this.opacity;
  a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
  return (a2 === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a2 === 1 ? ")" : ", " + a2 + ")");
}
function hex$1(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla$1(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl$1(h2, s2, l2, a2);
}
function hslConvert$1(o) {
  if (o instanceof Hsl$1)
    return new Hsl$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$1))
    o = color$1(o);
  if (!o)
    return new Hsl$1();
  if (o instanceof Hsl$1)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r2, g2, b10), max2 = Math.max(r2, g2, b10), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g2 - b10) / s2 + (g2 < b10) * 6;
    else if (g2 === max2)
      h2 = (b10 - r2) / s2 + 2;
    else
      h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl$1(h2, s2, l2, o.opacity);
}
function hsl$3(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert$1(h2) : new Hsl$1(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl$1(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$1(Hsl$1, hsl$3, extend$1(Color$1, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$1 : Math.pow(brighter$1, k2);
    return new Hsl$1(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$1 : Math.pow(darker$1, k2);
    return new Hsl$1(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb$1(
      hsl2rgb$1(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb$1(h2, m1, m2),
      hsl2rgb$1(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a2 = this.opacity;
    a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
    return (a2 === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a2 === 1 ? ")" : ", " + a2 + ")");
  }
}));
function hsl2rgb$1(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const radians$2 = Math.PI / 180;
const degrees$3 = 180 / Math.PI;
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
function labConvert(o) {
  if (o instanceof Lab)
    return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl)
    return hcl2lab(o);
  if (!(o instanceof Rgb$1))
    o = rgbConvert$1(o);
  var r2 = rgb2lrgb(o.r), g2 = rgb2lrgb(o.g), b10 = rgb2lrgb(o.b), y2 = xyz2lab((0.2225045 * r2 + 0.7168786 * g2 + 0.0606169 * b10) / Yn), x2, z2;
  if (r2 === g2 && g2 === b10)
    x2 = z2 = y2;
  else {
    x2 = xyz2lab((0.4360747 * r2 + 0.3850649 * g2 + 0.1430804 * b10) / Xn);
    z2 = xyz2lab((0.0139322 * r2 + 0.0971045 * g2 + 0.7141733 * b10) / Zn);
  }
  return new Lab(116 * y2 - 16, 500 * (x2 - y2), 200 * (y2 - z2), o.opacity);
}
function gray(l2, opacity) {
  return new Lab(l2, 0, 0, opacity == null ? 1 : opacity);
}
function lab$1(l2, a2, b10, opacity) {
  return arguments.length === 1 ? labConvert(l2) : new Lab(l2, a2, b10, opacity == null ? 1 : opacity);
}
function Lab(l2, a2, b10, opacity) {
  this.l = +l2;
  this.a = +a2;
  this.b = +b10;
  this.opacity = +opacity;
}
define$1(Lab, lab$1, extend$1(Color$1, {
  brighter: function(k2) {
    return new Lab(this.l + K * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  darker: function(k2) {
    return new Lab(this.l - K * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y2 = (this.l + 16) / 116, x2 = isNaN(this.a) ? y2 : y2 + this.a / 500, z2 = isNaN(this.b) ? y2 : y2 - this.b / 200;
    x2 = Xn * lab2xyz(x2);
    y2 = Yn * lab2xyz(y2);
    z2 = Zn * lab2xyz(z2);
    return new Rgb$1(
      lrgb2rgb(3.1338561 * x2 - 1.6168667 * y2 - 0.4906146 * z2),
      lrgb2rgb(-0.9787684 * x2 + 1.9161415 * y2 + 0.033454 * z2),
      lrgb2rgb(0.0719453 * x2 - 0.2289914 * y2 + 1.4052427 * z2),
      this.opacity
    );
  }
}));
function xyz2lab(t4) {
  return t4 > t3 ? Math.pow(t4, 1 / 3) : t4 / t2 + t0$1;
}
function lab2xyz(t4) {
  return t4 > t1$1 ? t4 * t4 * t4 : t2 * (t4 - t0$1);
}
function lrgb2rgb(x2) {
  return 255 * (x2 <= 31308e-7 ? 12.92 * x2 : 1.055 * Math.pow(x2, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x2) {
  return (x2 /= 255) <= 0.04045 ? x2 / 12.92 : Math.pow((x2 + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl)
    return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab))
    o = labConvert(o);
  if (o.a === 0 && o.b === 0)
    return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h2 = Math.atan2(o.b, o.a) * degrees$3;
  return new Hcl(h2 < 0 ? h2 + 360 : h2, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l2, c2, h2, opacity) {
  return arguments.length === 1 ? hclConvert(l2) : new Hcl(h2, c2, l2, opacity == null ? 1 : opacity);
}
function hcl$2(h2, c2, l2, opacity) {
  return arguments.length === 1 ? hclConvert(h2) : new Hcl(h2, c2, l2, opacity == null ? 1 : opacity);
}
function Hcl(h2, c2, l2, opacity) {
  this.h = +h2;
  this.c = +c2;
  this.l = +l2;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h))
    return new Lab(o.l, 0, 0, o.opacity);
  var h2 = o.h * radians$2;
  return new Lab(o.l, Math.cos(h2) * o.c, Math.sin(h2) * o.c, o.opacity);
}
define$1(Hcl, hcl$2, extend$1(Color$1, {
  brighter: function(k2) {
    return new Hcl(this.h, this.c, this.l + K * (k2 == null ? 1 : k2), this.opacity);
  },
  darker: function(k2) {
    return new Hcl(this.h, this.c, this.l - K * (k2 == null ? 1 : k2), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));
var A$1 = -0.14861, B$1 = 1.78277, C$1 = -0.29227, D$1 = -0.90649, E$1 = 1.97294, ED$1 = E$1 * D$1, EB$1 = E$1 * B$1, BC_DA$1 = B$1 * C$1 - D$1 * A$1;
function cubehelixConvert$1(o) {
  if (o instanceof Cubehelix$1)
    return new Cubehelix$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb$1))
    o = rgbConvert$1(o);
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, l2 = (BC_DA$1 * b10 + ED$1 * r2 - EB$1 * g2) / (BC_DA$1 + ED$1 - EB$1), bl = b10 - l2, k2 = (E$1 * (g2 - l2) - C$1 * bl) / D$1, s2 = Math.sqrt(k2 * k2 + bl * bl) / (E$1 * l2 * (1 - l2)), h2 = s2 ? Math.atan2(k2, bl) * degrees$3 - 120 : NaN;
  return new Cubehelix$1(h2 < 0 ? h2 + 360 : h2, s2, l2, o.opacity);
}
function cubehelix$5(h2, s2, l2, opacity) {
  return arguments.length === 1 ? cubehelixConvert$1(h2) : new Cubehelix$1(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Cubehelix$1(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define$1(Cubehelix$1, cubehelix$5, extend$1(Color$1, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter$1 : Math.pow(brighter$1, k2);
    return new Cubehelix$1(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker$1 : Math.pow(darker$1, k2);
    return new Cubehelix$1(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = isNaN(this.h) ? 0 : (this.h + 120) * radians$2, l2 = +this.l, a2 = isNaN(this.s) ? 0 : this.s * l2 * (1 - l2), cosh2 = Math.cos(h2), sinh2 = Math.sin(h2);
    return new Rgb$1(
      255 * (l2 + a2 * (A$1 * cosh2 + B$1 * sinh2)),
      255 * (l2 + a2 * (C$1 * cosh2 + D$1 * sinh2)),
      255 * (l2 + a2 * (E$1 * cosh2)),
      this.opacity
    );
  }
}));
function count$1(values2, valueof) {
  let count2 = 0;
  if (valueof === void 0) {
    for (let value of values2) {
      if (value != null && (value = +value) >= value) {
        ++count2;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (value = +value) >= value) {
        ++count2;
      }
    }
  }
  return count2;
}
function extent$1(values2, valueof) {
  let min2;
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null) {
        if (min2 === void 0) {
          if (value >= value)
            min2 = max2 = value;
        } else {
          if (min2 > value)
            min2 = value;
          if (max2 < value)
            max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickStep(start2, stop, count2) {
  var step0 = Math.abs(stop - start2) / Math.max(0, count2), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
  if (error >= e10)
    step1 *= 10;
  else if (error >= e5)
    step1 *= 5;
  else if (error >= e2)
    step1 *= 2;
  return stop < start2 ? -step1 : step1;
}
function thresholdSturges(values2) {
  return Math.ceil(Math.log(count$1(values2)) / Math.LN2) + 1;
}
function max$1(values2, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values2) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values2) {
      if ((value = valueof(value, ++index2, values2)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function range$1(start2, stop, step2) {
  start2 = +start2, stop = +stop, step2 = (n2 = arguments.length) < 2 ? (stop = start2, start2 = 0, 1) : n2 < 3 ? 1 : +step2;
  var i = -1, n2 = Math.max(0, Math.ceil((stop - start2) / step2)) | 0, range2 = new Array(n2);
  while (++i < n2) {
    range2[i] = start2 + i * step2;
  }
  return range2;
}
var array$3 = Array.prototype;
var slice$1 = array$3.slice;
function ascending$1(a2, b10) {
  return a2 - b10;
}
function area$3(ring) {
  var i = 0, n2 = ring.length, area2 = ring[n2 - 1][1] * ring[0][0] - ring[n2 - 1][0] * ring[0][1];
  while (++i < n2)
    area2 += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area2;
}
var constant$7 = (x2) => () => x2;
function contains$2(ring, hole) {
  var i = -1, n2 = hole.length, c2;
  while (++i < n2)
    if (c2 = ringContains(ring, hole[i]))
      return c2;
  return 0;
}
function ringContains(ring, point2) {
  var x2 = point2[0], y2 = point2[1], contains2 = -1;
  for (var i = 0, n2 = ring.length, j = n2 - 1; i < n2; j = i++) {
    var pi2 = ring[i], xi = pi2[0], yi = pi2[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi2, pj, point2))
      return 0;
    if (yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi)
      contains2 = -contains2;
  }
  return contains2;
}
function segmentContains(a2, b10, c2) {
  var i;
  return collinear$1(a2, b10, c2) && within(a2[i = +(a2[0] === b10[0])], c2[i], b10[i]);
}
function collinear$1(a2, b10, c2) {
  return (b10[0] - a2[0]) * (c2[1] - a2[1]) === (c2[0] - a2[0]) * (b10[1] - a2[1]);
}
function within(p2, q2, r2) {
  return p2 <= q2 && q2 <= r2 || r2 <= q2 && q2 <= p2;
}
function noop$3() {
}
var cases = [
  [],
  [[[1, 1.5], [0.5, 1]]],
  [[[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [0.5, 1]]],
  [[[1, 0.5], [1.5, 1]]],
  [[[1, 1.5], [0.5, 1]], [[1, 0.5], [1.5, 1]]],
  [[[1, 0.5], [1, 1.5]]],
  [[[1, 0.5], [0.5, 1]]],
  [[[0.5, 1], [1, 0.5]]],
  [[[1, 1.5], [1, 0.5]]],
  [[[0.5, 1], [1, 0.5]], [[1.5, 1], [1, 1.5]]],
  [[[1.5, 1], [1, 0.5]]],
  [[[0.5, 1], [1.5, 1]]],
  [[[1, 1.5], [1.5, 1]]],
  [[[0.5, 1], [1, 1.5]]],
  []
];
function contours() {
  var dx = 1, dy = 1, threshold2 = thresholdSturges, smooth = smoothLinear;
  function contours2(values2) {
    var tz = threshold2(values2);
    if (!Array.isArray(tz)) {
      var domain2 = extent$1(values2), start2 = domain2[0], stop = domain2[1];
      tz = tickStep(start2, stop, tz);
      tz = range$1(Math.floor(start2 / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(ascending$1);
    }
    return tz.map(function(value) {
      return contour(values2, value);
    });
  }
  function contour(values2, value) {
    var polygons = [], holes = [];
    isorings(values2, value, function(ring) {
      smooth(ring, values2, value);
      if (area$3(ring) > 0)
        polygons.push([ring]);
      else
        holes.push(ring);
    });
    holes.forEach(function(hole) {
      for (var i = 0, n2 = polygons.length, polygon; i < n2; ++i) {
        if (contains$2((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });
    return {
      type: "MultiPolygon",
      value,
      coordinates: polygons
    };
  }
  function isorings(values2, value, callback) {
    var fragmentByStart = new Array(), fragmentByEnd = new Array(), x2, y2, t02, t12, t22, t32;
    x2 = y2 = -1;
    t12 = values2[0] >= value;
    cases[t12 << 1].forEach(stitch);
    while (++x2 < dx - 1) {
      t02 = t12, t12 = values2[x2 + 1] >= value;
      cases[t02 | t12 << 1].forEach(stitch);
    }
    cases[t12 << 0].forEach(stitch);
    while (++y2 < dy - 1) {
      x2 = -1;
      t12 = values2[y2 * dx + dx] >= value;
      t22 = values2[y2 * dx] >= value;
      cases[t12 << 1 | t22 << 2].forEach(stitch);
      while (++x2 < dx - 1) {
        t02 = t12, t12 = values2[y2 * dx + dx + x2 + 1] >= value;
        t32 = t22, t22 = values2[y2 * dx + x2 + 1] >= value;
        cases[t02 | t12 << 1 | t22 << 2 | t32 << 3].forEach(stitch);
      }
      cases[t12 | t22 << 3].forEach(stitch);
    }
    x2 = -1;
    t22 = values2[y2 * dx] >= value;
    cases[t22 << 2].forEach(stitch);
    while (++x2 < dx - 1) {
      t32 = t22, t22 = values2[y2 * dx + x2 + 1] >= value;
      cases[t22 << 2 | t32 << 3].forEach(stitch);
    }
    cases[t22 << 3].forEach(stitch);
    function stitch(line2) {
      var start2 = [line2[0][0] + x2, line2[0][1] + y2], end2 = [line2[1][0] + x2, line2[1][1] + y2], startIndex = index2(start2), endIndex = index2(end2), f2, g2;
      if (f2 = fragmentByEnd[startIndex]) {
        if (g2 = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f2.end];
          delete fragmentByStart[g2.start];
          if (f2 === g2) {
            f2.ring.push(end2);
            callback(f2.ring);
          } else {
            fragmentByStart[f2.start] = fragmentByEnd[g2.end] = { start: f2.start, end: g2.end, ring: f2.ring.concat(g2.ring) };
          }
        } else {
          delete fragmentByEnd[f2.end];
          f2.ring.push(end2);
          fragmentByEnd[f2.end = endIndex] = f2;
        }
      } else if (f2 = fragmentByStart[endIndex]) {
        if (g2 = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f2.start];
          delete fragmentByEnd[g2.end];
          if (f2 === g2) {
            f2.ring.push(end2);
            callback(f2.ring);
          } else {
            fragmentByStart[g2.start] = fragmentByEnd[f2.end] = { start: g2.start, end: f2.end, ring: g2.ring.concat(f2.ring) };
          }
        } else {
          delete fragmentByStart[f2.start];
          f2.ring.unshift(start2);
          fragmentByStart[f2.start = startIndex] = f2;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = { start: startIndex, end: endIndex, ring: [start2, end2] };
      }
    }
  }
  function index2(point2) {
    return point2[0] * 2 + point2[1] * (dx + 1) * 4;
  }
  function smoothLinear(ring, values2, value) {
    ring.forEach(function(point2) {
      var x2 = point2[0], y2 = point2[1], xt = x2 | 0, yt = y2 | 0, v0, v1 = values2[yt * dx + xt];
      if (x2 > 0 && x2 < dx && xt === x2) {
        v0 = values2[yt * dx + xt - 1];
        point2[0] = x2 + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y2 > 0 && y2 < dy && yt === y2) {
        v0 = values2[(yt - 1) * dx + xt];
        point2[1] = y2 + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }
  contours2.contour = contour;
  contours2.size = function(_2) {
    if (!arguments.length)
      return [dx, dy];
    var _0 = Math.floor(_2[0]), _1 = Math.floor(_2[1]);
    if (!(_0 >= 0 && _1 >= 0))
      throw new Error("invalid size");
    return dx = _0, dy = _1, contours2;
  };
  contours2.thresholds = function(_2) {
    return arguments.length ? (threshold2 = typeof _2 === "function" ? _2 : Array.isArray(_2) ? constant$7(slice$1.call(_2)) : constant$7(_2), contours2) : threshold2;
  };
  contours2.smooth = function(_2) {
    return arguments.length ? (smooth = _2 ? smoothLinear : noop$3, contours2) : smooth === smoothLinear;
  };
  return contours2;
}
function blurX(source, target, r2) {
  var n2 = source.width, m2 = source.height, w2 = (r2 << 1) + 1;
  for (var j = 0; j < m2; ++j) {
    for (var i = 0, sr = 0; i < n2 + r2; ++i) {
      if (i < n2) {
        sr += source.data[i + j * n2];
      }
      if (i >= r2) {
        if (i >= w2) {
          sr -= source.data[i - w2 + j * n2];
        }
        target.data[i - r2 + j * n2] = sr / Math.min(i + 1, n2 - 1 + w2 - i, w2);
      }
    }
  }
}
function blurY(source, target, r2) {
  var n2 = source.width, m2 = source.height, w2 = (r2 << 1) + 1;
  for (var i = 0; i < n2; ++i) {
    for (var j = 0, sr = 0; j < m2 + r2; ++j) {
      if (j < m2) {
        sr += source.data[i + j * n2];
      }
      if (j >= r2) {
        if (j >= w2) {
          sr -= source.data[i + (j - w2) * n2];
        }
        target.data[i + (j - r2) * n2] = sr / Math.min(j + 1, m2 - 1 + w2 - j, w2);
      }
    }
  }
}
function defaultX$1(d2) {
  return d2[0];
}
function defaultY$1(d2) {
  return d2[1];
}
function defaultWeight() {
  return 1;
}
function density() {
  var x2 = defaultX$1, y2 = defaultY$1, weight = defaultWeight, dx = 960, dy = 500, r2 = 20, k2 = 2, o = r2 * 3, n2 = dx + o * 2 >> k2, m2 = dy + o * 2 >> k2, threshold2 = constant$7(20);
  function density2(data) {
    var values0 = new Float32Array(n2 * m2), values1 = new Float32Array(n2 * m2);
    data.forEach(function(d2, i, data2) {
      var xi = +x2(d2, i, data2) + o >> k2, yi = +y2(d2, i, data2) + o >> k2, wi = +weight(d2, i, data2);
      if (xi >= 0 && xi < n2 && yi >= 0 && yi < m2) {
        values0[xi + yi * n2] += wi;
      }
    });
    blurX({ width: n2, height: m2, data: values0 }, { width: n2, height: m2, data: values1 }, r2 >> k2);
    blurY({ width: n2, height: m2, data: values1 }, { width: n2, height: m2, data: values0 }, r2 >> k2);
    blurX({ width: n2, height: m2, data: values0 }, { width: n2, height: m2, data: values1 }, r2 >> k2);
    blurY({ width: n2, height: m2, data: values1 }, { width: n2, height: m2, data: values0 }, r2 >> k2);
    blurX({ width: n2, height: m2, data: values0 }, { width: n2, height: m2, data: values1 }, r2 >> k2);
    blurY({ width: n2, height: m2, data: values1 }, { width: n2, height: m2, data: values0 }, r2 >> k2);
    var tz = threshold2(values0);
    if (!Array.isArray(tz)) {
      var stop = max$1(values0);
      tz = tickStep(0, stop, tz);
      tz = range$1(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }
    return contours().thresholds(tz).size([n2, m2])(values0).map(transform2);
  }
  function transform2(geometry) {
    geometry.value *= Math.pow(2, -2 * k2);
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }
  function transformPolygon(coordinates2) {
    coordinates2.forEach(transformRing);
  }
  function transformRing(coordinates2) {
    coordinates2.forEach(transformPoint);
  }
  function transformPoint(coordinates2) {
    coordinates2[0] = coordinates2[0] * Math.pow(2, k2) - o;
    coordinates2[1] = coordinates2[1] * Math.pow(2, k2) - o;
  }
  function resize() {
    o = r2 * 3;
    n2 = dx + o * 2 >> k2;
    m2 = dy + o * 2 >> k2;
    return density2;
  }
  density2.x = function(_2) {
    return arguments.length ? (x2 = typeof _2 === "function" ? _2 : constant$7(+_2), density2) : x2;
  };
  density2.y = function(_2) {
    return arguments.length ? (y2 = typeof _2 === "function" ? _2 : constant$7(+_2), density2) : y2;
  };
  density2.weight = function(_2) {
    return arguments.length ? (weight = typeof _2 === "function" ? _2 : constant$7(+_2), density2) : weight;
  };
  density2.size = function(_2) {
    if (!arguments.length)
      return [dx, dy];
    var _0 = +_2[0], _1 = +_2[1];
    if (!(_0 >= 0 && _1 >= 0))
      throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };
  density2.cellSize = function(_2) {
    if (!arguments.length)
      return 1 << k2;
    if (!((_2 = +_2) >= 1))
      throw new Error("invalid cell size");
    return k2 = Math.floor(Math.log(_2) / Math.LN2), resize();
  };
  density2.thresholds = function(_2) {
    return arguments.length ? (threshold2 = typeof _2 === "function" ? _2 : Array.isArray(_2) ? constant$7(slice$1.call(_2)) : constant$7(_2), density2) : threshold2;
  };
  density2.bandwidth = function(_2) {
    if (!arguments.length)
      return Math.sqrt(r2 * (r2 + 1));
    if (!((_2 = +_2) >= 0))
      throw new Error("invalid bandwidth");
    return r2 = Math.round((Math.sqrt(4 * _2 * _2 + 1) - 1) / 2), resize();
  };
  return density2;
}
const EPSILON = Math.pow(2, -52);
const EDGE_STACK = new Uint32Array(512);
class Delaunator {
  static from(points, getX = defaultGetX, getY = defaultGetY) {
    const n2 = points.length;
    const coords = new Float64Array(n2 * 2);
    for (let i = 0; i < n2; i++) {
      const p2 = points[i];
      coords[2 * i] = getX(p2);
      coords[2 * i + 1] = getY(p2);
    }
    return new Delaunator(coords);
  }
  constructor(coords) {
    const n2 = coords.length >> 1;
    if (n2 > 0 && typeof coords[0] !== "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = coords;
    const maxTriangles = Math.max(2 * n2 - 5, 0);
    this._triangles = new Uint32Array(maxTriangles * 3);
    this._halfedges = new Int32Array(maxTriangles * 3);
    this._hashSize = Math.ceil(Math.sqrt(n2));
    this._hullPrev = new Uint32Array(n2);
    this._hullNext = new Uint32Array(n2);
    this._hullTri = new Uint32Array(n2);
    this._hullHash = new Int32Array(this._hashSize).fill(-1);
    this._ids = new Uint32Array(n2);
    this._dists = new Float64Array(n2);
    this.update();
  }
  update() {
    const { coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
    const n2 = coords.length >> 1;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY2 = -Infinity;
    for (let i = 0; i < n2; i++) {
      const x2 = coords[2 * i];
      const y2 = coords[2 * i + 1];
      if (x2 < minX)
        minX = x2;
      if (y2 < minY)
        minY = y2;
      if (x2 > maxX)
        maxX = x2;
      if (y2 > maxY2)
        maxY2 = y2;
      this._ids[i] = i;
    }
    const cx2 = (minX + maxX) / 2;
    const cy = (minY + maxY2) / 2;
    let minDist = Infinity;
    let i0, i1, i2;
    for (let i = 0; i < n2; i++) {
      const d2 = dist(cx2, cy, coords[2 * i], coords[2 * i + 1]);
      if (d2 < minDist) {
        i0 = i;
        minDist = d2;
      }
    }
    const i0x = coords[2 * i0];
    const i0y = coords[2 * i0 + 1];
    minDist = Infinity;
    for (let i = 0; i < n2; i++) {
      if (i === i0)
        continue;
      const d2 = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
      if (d2 < minDist && d2 > 0) {
        i1 = i;
        minDist = d2;
      }
    }
    let i1x = coords[2 * i1];
    let i1y = coords[2 * i1 + 1];
    let minRadius = Infinity;
    for (let i = 0; i < n2; i++) {
      if (i === i0 || i === i1)
        continue;
      const r2 = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
      if (r2 < minRadius) {
        i2 = i;
        minRadius = r2;
      }
    }
    let i2x = coords[2 * i2];
    let i2y = coords[2 * i2 + 1];
    if (minRadius === Infinity) {
      for (let i = 0; i < n2; i++) {
        this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
      }
      quicksort(this._ids, this._dists, 0, n2 - 1);
      const hull2 = new Uint32Array(n2);
      let j = 0;
      for (let i = 0, d0 = -Infinity; i < n2; i++) {
        const id2 = this._ids[i];
        if (this._dists[id2] > d0) {
          hull2[j++] = id2;
          d0 = this._dists[id2];
        }
      }
      this.hull = hull2.subarray(0, j);
      this.triangles = new Uint32Array(0);
      this.halfedges = new Uint32Array(0);
      return;
    }
    if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
      const i = i1;
      const x2 = i1x;
      const y2 = i1y;
      i1 = i2;
      i1x = i2x;
      i1y = i2y;
      i2 = i;
      i2x = x2;
      i2y = y2;
    }
    const center2 = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
    this._cx = center2.x;
    this._cy = center2.y;
    for (let i = 0; i < n2; i++) {
      this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center2.x, center2.y);
    }
    quicksort(this._ids, this._dists, 0, n2 - 1);
    this._hullStart = i0;
    let hullSize = 3;
    hullNext[i0] = hullPrev[i2] = i1;
    hullNext[i1] = hullPrev[i0] = i2;
    hullNext[i2] = hullPrev[i1] = i0;
    hullTri[i0] = 0;
    hullTri[i1] = 1;
    hullTri[i2] = 2;
    hullHash.fill(-1);
    hullHash[this._hashKey(i0x, i0y)] = i0;
    hullHash[this._hashKey(i1x, i1y)] = i1;
    hullHash[this._hashKey(i2x, i2y)] = i2;
    this.trianglesLen = 0;
    this._addTriangle(i0, i1, i2, -1, -1, -1);
    for (let k2 = 0, xp, yp; k2 < this._ids.length; k2++) {
      const i = this._ids[k2];
      const x2 = coords[2 * i];
      const y2 = coords[2 * i + 1];
      if (k2 > 0 && Math.abs(x2 - xp) <= EPSILON && Math.abs(y2 - yp) <= EPSILON)
        continue;
      xp = x2;
      yp = y2;
      if (i === i0 || i === i1 || i === i2)
        continue;
      let start2 = 0;
      for (let j = 0, key = this._hashKey(x2, y2); j < this._hashSize; j++) {
        start2 = hullHash[(key + j) % this._hashSize];
        if (start2 !== -1 && start2 !== hullNext[start2])
          break;
      }
      start2 = hullPrev[start2];
      let e3 = start2, q2;
      while (q2 = hullNext[e3], !orient(x2, y2, coords[2 * e3], coords[2 * e3 + 1], coords[2 * q2], coords[2 * q2 + 1])) {
        e3 = q2;
        if (e3 === start2) {
          e3 = -1;
          break;
        }
      }
      if (e3 === -1)
        continue;
      let t4 = this._addTriangle(e3, i, hullNext[e3], -1, -1, hullTri[e3]);
      hullTri[i] = this._legalize(t4 + 2);
      hullTri[e3] = t4;
      hullSize++;
      let n3 = hullNext[e3];
      while (q2 = hullNext[n3], orient(x2, y2, coords[2 * n3], coords[2 * n3 + 1], coords[2 * q2], coords[2 * q2 + 1])) {
        t4 = this._addTriangle(n3, i, q2, hullTri[i], -1, hullTri[n3]);
        hullTri[i] = this._legalize(t4 + 2);
        hullNext[n3] = n3;
        hullSize--;
        n3 = q2;
      }
      if (e3 === start2) {
        while (q2 = hullPrev[e3], orient(x2, y2, coords[2 * q2], coords[2 * q2 + 1], coords[2 * e3], coords[2 * e3 + 1])) {
          t4 = this._addTriangle(q2, i, e3, -1, hullTri[e3], hullTri[q2]);
          this._legalize(t4 + 2);
          hullTri[q2] = t4;
          hullNext[e3] = e3;
          hullSize--;
          e3 = q2;
        }
      }
      this._hullStart = hullPrev[i] = e3;
      hullNext[e3] = hullPrev[n3] = i;
      hullNext[i] = n3;
      hullHash[this._hashKey(x2, y2)] = i;
      hullHash[this._hashKey(coords[2 * e3], coords[2 * e3 + 1])] = e3;
    }
    this.hull = new Uint32Array(hullSize);
    for (let i = 0, e3 = this._hullStart; i < hullSize; i++) {
      this.hull[i] = e3;
      e3 = hullNext[e3];
    }
    this.triangles = this._triangles.subarray(0, this.trianglesLen);
    this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(x2, y2) {
    return Math.floor(pseudoAngle(x2 - this._cx, y2 - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(a2) {
    const { _triangles: triangles, _halfedges: halfedges, coords } = this;
    let i = 0;
    let ar = 0;
    while (true) {
      const b10 = halfedges[a2];
      const a0 = a2 - a2 % 3;
      ar = a0 + (a2 + 2) % 3;
      if (b10 === -1) {
        if (i === 0)
          break;
        a2 = EDGE_STACK[--i];
        continue;
      }
      const b02 = b10 - b10 % 3;
      const al = a0 + (a2 + 1) % 3;
      const bl = b02 + (b10 + 2) % 3;
      const p02 = triangles[ar];
      const pr = triangles[a2];
      const pl = triangles[al];
      const p1 = triangles[bl];
      const illegal = inCircle(
        coords[2 * p02],
        coords[2 * p02 + 1],
        coords[2 * pr],
        coords[2 * pr + 1],
        coords[2 * pl],
        coords[2 * pl + 1],
        coords[2 * p1],
        coords[2 * p1 + 1]
      );
      if (illegal) {
        triangles[a2] = p1;
        triangles[b10] = p02;
        const hbl = halfedges[bl];
        if (hbl === -1) {
          let e3 = this._hullStart;
          do {
            if (this._hullTri[e3] === bl) {
              this._hullTri[e3] = a2;
              break;
            }
            e3 = this._hullPrev[e3];
          } while (e3 !== this._hullStart);
        }
        this._link(a2, hbl);
        this._link(b10, halfedges[ar]);
        this._link(ar, bl);
        const br = b02 + (b10 + 1) % 3;
        if (i < EDGE_STACK.length) {
          EDGE_STACK[i++] = br;
        }
      } else {
        if (i === 0)
          break;
        a2 = EDGE_STACK[--i];
      }
    }
    return ar;
  }
  _link(a2, b10) {
    this._halfedges[a2] = b10;
    if (b10 !== -1)
      this._halfedges[b10] = a2;
  }
  _addTriangle(i0, i1, i2, a2, b10, c2) {
    const t4 = this.trianglesLen;
    this._triangles[t4] = i0;
    this._triangles[t4 + 1] = i1;
    this._triangles[t4 + 2] = i2;
    this._link(t4, a2);
    this._link(t4 + 1, b10);
    this._link(t4 + 2, c2);
    this.trianglesLen += 3;
    return t4;
  }
}
function pseudoAngle(dx, dy) {
  const p2 = dx / (Math.abs(dx) + Math.abs(dy));
  return (dy > 0 ? 3 - p2 : 1 + p2) / 4;
}
function dist(ax, ay, bx, by) {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}
function orientIfSure(px, py, rx, ry, qx, qy) {
  const l2 = (ry - py) * (qx - px);
  const r2 = (rx - px) * (qy - py);
  return Math.abs(l2 - r2) >= 33306690738754716e-32 * Math.abs(l2 + r2) ? l2 - r2 : 0;
}
function orient(rx, ry, qx, qy, px, py) {
  const sign2 = orientIfSure(px, py, rx, ry, qx, qy) || orientIfSure(rx, ry, qx, qy, px, py) || orientIfSure(qx, qy, px, py, rx, ry);
  return sign2 < 0;
}
function inCircle(ax, ay, bx, by, cx2, cy, px, py) {
  const dx = ax - px;
  const dy = ay - py;
  const ex = bx - px;
  const ey = by - py;
  const fx = cx2 - px;
  const fy = cy - py;
  const ap = dx * dx + dy * dy;
  const bp = ex * ex + ey * ey;
  const cp = fx * fx + fy * fy;
  return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function circumradius(ax, ay, bx, by, cx2, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx2 - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d2 = 0.5 / (dx * ey - dy * ex);
  const x2 = (ey * bl - dy * cl) * d2;
  const y2 = (dx * cl - ex * bl) * d2;
  return x2 * x2 + y2 * y2;
}
function circumcenter(ax, ay, bx, by, cx2, cy) {
  const dx = bx - ax;
  const dy = by - ay;
  const ex = cx2 - ax;
  const ey = cy - ay;
  const bl = dx * dx + dy * dy;
  const cl = ex * ex + ey * ey;
  const d2 = 0.5 / (dx * ey - dy * ex);
  const x2 = ax + (ey * bl - dy * cl) * d2;
  const y2 = ay + (dx * cl - ex * bl) * d2;
  return { x: x2, y: y2 };
}
function quicksort(ids, dists, left2, right2) {
  if (right2 - left2 <= 20) {
    for (let i = left2 + 1; i <= right2; i++) {
      const temp = ids[i];
      const tempDist = dists[temp];
      let j = i - 1;
      while (j >= left2 && dists[ids[j]] > tempDist)
        ids[j + 1] = ids[j--];
      ids[j + 1] = temp;
    }
  } else {
    const median2 = left2 + right2 >> 1;
    let i = left2 + 1;
    let j = right2;
    swap(ids, median2, i);
    if (dists[ids[left2]] > dists[ids[right2]])
      swap(ids, left2, right2);
    if (dists[ids[i]] > dists[ids[right2]])
      swap(ids, i, right2);
    if (dists[ids[left2]] > dists[ids[i]])
      swap(ids, left2, i);
    const temp = ids[i];
    const tempDist = dists[temp];
    while (true) {
      do
        i++;
      while (dists[ids[i]] < tempDist);
      do
        j--;
      while (dists[ids[j]] > tempDist);
      if (j < i)
        break;
      swap(ids, i, j);
    }
    ids[left2 + 1] = ids[j];
    ids[j] = temp;
    if (right2 - i + 1 >= j - left2) {
      quicksort(ids, dists, i, right2);
      quicksort(ids, dists, left2, j - 1);
    } else {
      quicksort(ids, dists, left2, j - 1);
      quicksort(ids, dists, i, right2);
    }
  }
}
function swap(arr, i, j) {
  const tmp = arr[i];
  arr[i] = arr[j];
  arr[j] = tmp;
}
function defaultGetX(p2) {
  return p2[0];
}
function defaultGetY(p2) {
  return p2[1];
}
const epsilon$3 = 1e-6;
class Path$1 {
  constructor() {
    this._x0 = this._y0 = this._x1 = this._y1 = null;
    this._ = "";
  }
  moveTo(x2, y2) {
    this._ += `M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  }
  lineTo(x2, y2) {
    this._ += `L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  arc(x2, y2, r2) {
    x2 = +x2, y2 = +y2, r2 = +r2;
    const x02 = x2 + r2;
    const y02 = y2;
    if (r2 < 0)
      throw new Error("negative radius");
    if (this._x1 === null)
      this._ += `M${x02},${y02}`;
    else if (Math.abs(this._x1 - x02) > epsilon$3 || Math.abs(this._y1 - y02) > epsilon$3)
      this._ += "L" + x02 + "," + y02;
    if (!r2)
      return;
    this._ += `A${r2},${r2},0,1,1,${x2 - r2},${y2}A${r2},${r2},0,1,1,${this._x1 = x02},${this._y1 = y02}`;
  }
  rect(x2, y2, w2, h2) {
    this._ += `M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${+w2}v${+h2}h${-w2}Z`;
  }
  value() {
    return this._ || null;
  }
}
class Polygon {
  constructor() {
    this._ = [];
  }
  moveTo(x2, y2) {
    this._.push([x2, y2]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(x2, y2) {
    this._.push([x2, y2]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class Voronoi {
  constructor(delaunay, [xmin, ymin, xmax, ymax] = [0, 0, 960, 500]) {
    if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin)))
      throw new Error("invalid bounds");
    this.delaunay = delaunay;
    this._circumcenters = new Float64Array(delaunay.points.length * 2);
    this.vectors = new Float64Array(delaunay.points.length * 2);
    this.xmax = xmax, this.xmin = xmin;
    this.ymax = ymax, this.ymin = ymin;
    this._init();
  }
  update() {
    this.delaunay.update();
    this._init();
    return this;
  }
  _init() {
    const { delaunay: { points, hull: hull2, triangles }, vectors } = this;
    const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
    for (let i = 0, j = 0, n2 = triangles.length, x2, y2; i < n2; i += 3, j += 2) {
      const t12 = triangles[i] * 2;
      const t22 = triangles[i + 1] * 2;
      const t32 = triangles[i + 2] * 2;
      const x13 = points[t12];
      const y13 = points[t12 + 1];
      const x22 = points[t22];
      const y22 = points[t22 + 1];
      const x3 = points[t32];
      const y3 = points[t32 + 1];
      const dx = x22 - x13;
      const dy = y22 - y13;
      const ex = x3 - x13;
      const ey = y3 - y13;
      const bl = dx * dx + dy * dy;
      const cl = ex * ex + ey * ey;
      const ab = (dx * ey - dy * ex) * 2;
      if (!ab) {
        x2 = (x13 + x3) / 2 - 1e8 * ey;
        y2 = (y13 + y3) / 2 + 1e8 * ex;
      } else if (Math.abs(ab) < 1e-8) {
        x2 = (x13 + x3) / 2;
        y2 = (y13 + y3) / 2;
      } else {
        const d2 = 1 / ab;
        x2 = x13 + (ey * bl - dy * cl) * d2;
        y2 = y13 + (dx * cl - ex * bl) * d2;
      }
      circumcenters[j] = x2;
      circumcenters[j + 1] = y2;
    }
    let h2 = hull2[hull2.length - 1];
    let p02, p1 = h2 * 4;
    let x02, x12 = points[2 * h2];
    let y02, y12 = points[2 * h2 + 1];
    vectors.fill(0);
    for (let i = 0; i < hull2.length; ++i) {
      h2 = hull2[i];
      p02 = p1, x02 = x12, y02 = y12;
      p1 = h2 * 4, x12 = points[2 * h2], y12 = points[2 * h2 + 1];
      vectors[p02 + 2] = vectors[p1] = y02 - y12;
      vectors[p02 + 3] = vectors[p1 + 1] = x12 - x02;
    }
  }
  render(context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const { delaunay: { halfedges, inedges, hull: hull2 }, circumcenters, vectors } = this;
    if (hull2.length <= 1)
      return null;
    for (let i = 0, n2 = halfedges.length; i < n2; ++i) {
      const j = halfedges[i];
      if (j < i)
        continue;
      const ti = Math.floor(i / 3) * 2;
      const tj = Math.floor(j / 3) * 2;
      const xi = circumcenters[ti];
      const yi = circumcenters[ti + 1];
      const xj = circumcenters[tj];
      const yj = circumcenters[tj + 1];
      this._renderSegment(xi, yi, xj, yj, context);
    }
    let h0, h1 = hull2[hull2.length - 1];
    for (let i = 0; i < hull2.length; ++i) {
      h0 = h1, h1 = hull2[i];
      const t4 = Math.floor(inedges[h1] / 3) * 2;
      const x2 = circumcenters[t4];
      const y2 = circumcenters[t4 + 1];
      const v2 = h0 * 4;
      const p2 = this._project(x2, y2, vectors[v2 + 2], vectors[v2 + 3]);
      if (p2)
        this._renderSegment(x2, y2, p2[0], p2[1], context);
    }
    return buffer2 && buffer2.value();
  }
  renderBounds(context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
    return buffer2 && buffer2.value();
  }
  renderCell(i, context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const points = this._clip(i);
    if (points === null || !points.length)
      return;
    context.moveTo(points[0], points[1]);
    let n2 = points.length;
    while (points[0] === points[n2 - 2] && points[1] === points[n2 - 1] && n2 > 1)
      n2 -= 2;
    for (let i2 = 2; i2 < n2; i2 += 2) {
      if (points[i2] !== points[i2 - 2] || points[i2 + 1] !== points[i2 - 1])
        context.lineTo(points[i2], points[i2 + 1]);
    }
    context.closePath();
    return buffer2 && buffer2.value();
  }
  *cellPolygons() {
    const { delaunay: { points } } = this;
    for (let i = 0, n2 = points.length / 2; i < n2; ++i) {
      const cell = this.cellPolygon(i);
      if (cell)
        cell.index = i, yield cell;
    }
  }
  cellPolygon(i) {
    const polygon = new Polygon();
    this.renderCell(i, polygon);
    return polygon.value();
  }
  _renderSegment(x02, y02, x12, y12, context) {
    let S;
    const c0 = this._regioncode(x02, y02);
    const c1 = this._regioncode(x12, y12);
    if (c0 === 0 && c1 === 0) {
      context.moveTo(x02, y02);
      context.lineTo(x12, y12);
    } else if (S = this._clipSegment(x02, y02, x12, y12, c0, c1)) {
      context.moveTo(S[0], S[1]);
      context.lineTo(S[2], S[3]);
    }
  }
  contains(i, x2, y2) {
    if ((x2 = +x2, x2 !== x2) || (y2 = +y2, y2 !== y2))
      return false;
    return this.delaunay._step(i, x2, y2) === i;
  }
  *neighbors(i) {
    const ci = this._clip(i);
    if (ci)
      for (const j of this.delaunay.neighbors(i)) {
        const cj = this._clip(j);
        if (cj)
          loop:
            for (let ai = 0, li = ci.length; ai < li; ai += 2) {
              for (let aj = 0, lj = cj.length; aj < lj; aj += 2) {
                if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                  yield j;
                  break loop;
                }
              }
            }
      }
  }
  _cell(i) {
    const { circumcenters, delaunay: { inedges, halfedges, triangles } } = this;
    const e0 = inedges[i];
    if (e0 === -1)
      return null;
    const points = [];
    let e3 = e0;
    do {
      const t4 = Math.floor(e3 / 3);
      points.push(circumcenters[t4 * 2], circumcenters[t4 * 2 + 1]);
      e3 = e3 % 3 === 2 ? e3 - 2 : e3 + 1;
      if (triangles[e3] !== i)
        break;
      e3 = halfedges[e3];
    } while (e3 !== e0 && e3 !== -1);
    return points;
  }
  _clip(i) {
    if (i === 0 && this.delaunay.hull.length === 1) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    const points = this._cell(i);
    if (points === null)
      return null;
    const { vectors: V } = this;
    const v2 = i * 4;
    return V[v2] || V[v2 + 1] ? this._clipInfinite(i, points, V[v2], V[v2 + 1], V[v2 + 2], V[v2 + 3]) : this._clipFinite(i, points);
  }
  _clipFinite(i, points) {
    const n2 = points.length;
    let P = null;
    let x02, y02, x12 = points[n2 - 2], y12 = points[n2 - 1];
    let c0, c1 = this._regioncode(x12, y12);
    let e0, e1;
    for (let j = 0; j < n2; j += 2) {
      x02 = x12, y02 = y12, x12 = points[j], y12 = points[j + 1];
      c0 = c1, c1 = this._regioncode(x12, y12);
      if (c0 === 0 && c1 === 0) {
        e0 = e1, e1 = 0;
        if (P)
          P.push(x12, y12);
        else
          P = [x12, y12];
      } else {
        let S, sx0, sy0, sx1, sy1;
        if (c0 === 0) {
          if ((S = this._clipSegment(x02, y02, x12, y12, c0, c1)) === null)
            continue;
          [sx0, sy0, sx1, sy1] = S;
        } else {
          if ((S = this._clipSegment(x12, y12, x02, y02, c1, c0)) === null)
            continue;
          [sx1, sy1, sx0, sy0] = S;
          e0 = e1, e1 = this._edgecode(sx0, sy0);
          if (e0 && e1)
            this._edge(i, e0, e1, P, P.length);
          if (P)
            P.push(sx0, sy0);
          else
            P = [sx0, sy0];
        }
        e0 = e1, e1 = this._edgecode(sx1, sy1);
        if (e0 && e1)
          this._edge(i, e0, e1, P, P.length);
        if (P)
          P.push(sx1, sy1);
        else
          P = [sx1, sy1];
      }
    }
    if (P) {
      e0 = e1, e1 = this._edgecode(P[0], P[1]);
      if (e0 && e1)
        this._edge(i, e0, e1, P, P.length);
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    }
    return P;
  }
  _clipSegment(x02, y02, x12, y12, c0, c1) {
    while (true) {
      if (c0 === 0 && c1 === 0)
        return [x02, y02, x12, y12];
      if (c0 & c1)
        return null;
      let x2, y2, c2 = c0 || c1;
      if (c2 & 8)
        x2 = x02 + (x12 - x02) * (this.ymax - y02) / (y12 - y02), y2 = this.ymax;
      else if (c2 & 4)
        x2 = x02 + (x12 - x02) * (this.ymin - y02) / (y12 - y02), y2 = this.ymin;
      else if (c2 & 2)
        y2 = y02 + (y12 - y02) * (this.xmax - x02) / (x12 - x02), x2 = this.xmax;
      else
        y2 = y02 + (y12 - y02) * (this.xmin - x02) / (x12 - x02), x2 = this.xmin;
      if (c0)
        x02 = x2, y02 = y2, c0 = this._regioncode(x02, y02);
      else
        x12 = x2, y12 = y2, c1 = this._regioncode(x12, y12);
    }
  }
  _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
    let P = Array.from(points), p2;
    if (p2 = this._project(P[0], P[1], vx0, vy0))
      P.unshift(p2[0], p2[1]);
    if (p2 = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn))
      P.push(p2[0], p2[1]);
    if (P = this._clipFinite(i, P)) {
      for (let j = 0, n2 = P.length, c0, c1 = this._edgecode(P[n2 - 2], P[n2 - 1]); j < n2; j += 2) {
        c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
        if (c0 && c1)
          j = this._edge(i, c0, c1, P, j), n2 = P.length;
      }
    } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) {
      P = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax];
    }
    return P;
  }
  _edge(i, e0, e1, P, j) {
    while (e0 !== e1) {
      let x2, y2;
      switch (e0) {
        case 5:
          e0 = 4;
          continue;
        case 4:
          e0 = 6, x2 = this.xmax, y2 = this.ymin;
          break;
        case 6:
          e0 = 2;
          continue;
        case 2:
          e0 = 10, x2 = this.xmax, y2 = this.ymax;
          break;
        case 10:
          e0 = 8;
          continue;
        case 8:
          e0 = 9, x2 = this.xmin, y2 = this.ymax;
          break;
        case 9:
          e0 = 1;
          continue;
        case 1:
          e0 = 5, x2 = this.xmin, y2 = this.ymin;
          break;
      }
      if ((P[j] !== x2 || P[j + 1] !== y2) && this.contains(i, x2, y2)) {
        P.splice(j, 0, x2, y2), j += 2;
      }
    }
    if (P.length > 4) {
      for (let i2 = 0; i2 < P.length; i2 += 2) {
        const j2 = (i2 + 2) % P.length, k2 = (i2 + 4) % P.length;
        if (P[i2] === P[j2] && P[j2] === P[k2] || P[i2 + 1] === P[j2 + 1] && P[j2 + 1] === P[k2 + 1])
          P.splice(j2, 2), i2 -= 2;
      }
    }
    return j;
  }
  _project(x02, y02, vx, vy) {
    let t4 = Infinity, c2, x2, y2;
    if (vy < 0) {
      if (y02 <= this.ymin)
        return null;
      if ((c2 = (this.ymin - y02) / vy) < t4)
        y2 = this.ymin, x2 = x02 + (t4 = c2) * vx;
    } else if (vy > 0) {
      if (y02 >= this.ymax)
        return null;
      if ((c2 = (this.ymax - y02) / vy) < t4)
        y2 = this.ymax, x2 = x02 + (t4 = c2) * vx;
    }
    if (vx > 0) {
      if (x02 >= this.xmax)
        return null;
      if ((c2 = (this.xmax - x02) / vx) < t4)
        x2 = this.xmax, y2 = y02 + (t4 = c2) * vy;
    } else if (vx < 0) {
      if (x02 <= this.xmin)
        return null;
      if ((c2 = (this.xmin - x02) / vx) < t4)
        x2 = this.xmin, y2 = y02 + (t4 = c2) * vy;
    }
    return [x2, y2];
  }
  _edgecode(x2, y2) {
    return (x2 === this.xmin ? 1 : x2 === this.xmax ? 2 : 0) | (y2 === this.ymin ? 4 : y2 === this.ymax ? 8 : 0);
  }
  _regioncode(x2, y2) {
    return (x2 < this.xmin ? 1 : x2 > this.xmax ? 2 : 0) | (y2 < this.ymin ? 4 : y2 > this.ymax ? 8 : 0);
  }
}
const tau$3 = 2 * Math.PI, pow$2 = Math.pow;
function pointX(p2) {
  return p2[0];
}
function pointY(p2) {
  return p2[1];
}
function collinear(d2) {
  const { triangles, coords } = d2;
  for (let i = 0; i < triangles.length; i += 3) {
    const a2 = 2 * triangles[i], b10 = 2 * triangles[i + 1], c2 = 2 * triangles[i + 2], cross2 = (coords[c2] - coords[a2]) * (coords[b10 + 1] - coords[a2 + 1]) - (coords[b10] - coords[a2]) * (coords[c2 + 1] - coords[a2 + 1]);
    if (cross2 > 1e-10)
      return false;
  }
  return true;
}
function jitter(x2, y2, r2) {
  return [x2 + Math.sin(x2 + y2) * r2, y2 + Math.cos(x2 - y2) * r2];
}
class Delaunay {
  static from(points, fx = pointX, fy = pointY, that) {
    return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
  }
  constructor(points) {
    this._delaunator = new Delaunator(points);
    this.inedges = new Int32Array(points.length / 2);
    this._hullIndex = new Int32Array(points.length / 2);
    this.points = this._delaunator.coords;
    this._init();
  }
  update() {
    this._delaunator.update();
    this._init();
    return this;
  }
  _init() {
    const d2 = this._delaunator, points = this.points;
    if (d2.hull && d2.hull.length > 2 && collinear(d2)) {
      this.collinear = Int32Array.from({ length: points.length / 2 }, (_2, i) => i).sort((i, j) => points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]);
      const e3 = this.collinear[0], f2 = this.collinear[this.collinear.length - 1], bounds2 = [points[2 * e3], points[2 * e3 + 1], points[2 * f2], points[2 * f2 + 1]], r2 = 1e-8 * Math.hypot(bounds2[3] - bounds2[1], bounds2[2] - bounds2[0]);
      for (let i = 0, n2 = points.length / 2; i < n2; ++i) {
        const p2 = jitter(points[2 * i], points[2 * i + 1], r2);
        points[2 * i] = p2[0];
        points[2 * i + 1] = p2[1];
      }
      this._delaunator = new Delaunator(points);
    } else {
      delete this.collinear;
    }
    const halfedges = this.halfedges = this._delaunator.halfedges;
    const hull2 = this.hull = this._delaunator.hull;
    const triangles = this.triangles = this._delaunator.triangles;
    const inedges = this.inedges.fill(-1);
    const hullIndex = this._hullIndex.fill(-1);
    for (let e3 = 0, n2 = halfedges.length; e3 < n2; ++e3) {
      const p2 = triangles[e3 % 3 === 2 ? e3 - 2 : e3 + 1];
      if (halfedges[e3] === -1 || inedges[p2] === -1)
        inedges[p2] = e3;
    }
    for (let i = 0, n2 = hull2.length; i < n2; ++i) {
      hullIndex[hull2[i]] = i;
    }
    if (hull2.length <= 2 && hull2.length > 0) {
      this.triangles = new Int32Array(3).fill(-1);
      this.halfedges = new Int32Array(3).fill(-1);
      this.triangles[0] = hull2[0];
      this.triangles[1] = hull2[1];
      this.triangles[2] = hull2[1];
      inedges[hull2[0]] = 1;
      if (hull2.length === 2)
        inedges[hull2[1]] = 0;
    }
  }
  voronoi(bounds2) {
    return new Voronoi(this, bounds2);
  }
  *neighbors(i) {
    const { inedges, hull: hull2, _hullIndex, halfedges, triangles, collinear: collinear2 } = this;
    if (collinear2) {
      const l2 = collinear2.indexOf(i);
      if (l2 > 0)
        yield collinear2[l2 - 1];
      if (l2 < collinear2.length - 1)
        yield collinear2[l2 + 1];
      return;
    }
    const e0 = inedges[i];
    if (e0 === -1)
      return;
    let e3 = e0, p02 = -1;
    do {
      yield p02 = triangles[e3];
      e3 = e3 % 3 === 2 ? e3 - 2 : e3 + 1;
      if (triangles[e3] !== i)
        return;
      e3 = halfedges[e3];
      if (e3 === -1) {
        const p2 = hull2[(_hullIndex[i] + 1) % hull2.length];
        if (p2 !== p02)
          yield p2;
        return;
      }
    } while (e3 !== e0);
  }
  find(x2, y2, i = 0) {
    if ((x2 = +x2, x2 !== x2) || (y2 = +y2, y2 !== y2))
      return -1;
    const i0 = i;
    let c2;
    while ((c2 = this._step(i, x2, y2)) >= 0 && c2 !== i && c2 !== i0)
      i = c2;
    return c2;
  }
  _step(i, x2, y2) {
    const { inedges, hull: hull2, _hullIndex, halfedges, triangles, points } = this;
    if (inedges[i] === -1 || !points.length)
      return (i + 1) % (points.length >> 1);
    let c2 = i;
    let dc = pow$2(x2 - points[i * 2], 2) + pow$2(y2 - points[i * 2 + 1], 2);
    const e0 = inedges[i];
    let e3 = e0;
    do {
      let t4 = triangles[e3];
      const dt = pow$2(x2 - points[t4 * 2], 2) + pow$2(y2 - points[t4 * 2 + 1], 2);
      if (dt < dc)
        dc = dt, c2 = t4;
      e3 = e3 % 3 === 2 ? e3 - 2 : e3 + 1;
      if (triangles[e3] !== i)
        break;
      e3 = halfedges[e3];
      if (e3 === -1) {
        e3 = hull2[(_hullIndex[i] + 1) % hull2.length];
        if (e3 !== t4) {
          if (pow$2(x2 - points[e3 * 2], 2) + pow$2(y2 - points[e3 * 2 + 1], 2) < dc)
            return e3;
        }
        break;
      }
    } while (e3 !== e0);
    return c2;
  }
  render(context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const { points, halfedges, triangles } = this;
    for (let i = 0, n2 = halfedges.length; i < n2; ++i) {
      const j = halfedges[i];
      if (j < i)
        continue;
      const ti = triangles[i] * 2;
      const tj = triangles[j] * 2;
      context.moveTo(points[ti], points[ti + 1]);
      context.lineTo(points[tj], points[tj + 1]);
    }
    this.renderHull(context);
    return buffer2 && buffer2.value();
  }
  renderPoints(context, r2 = 2) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const { points } = this;
    for (let i = 0, n2 = points.length; i < n2; i += 2) {
      const x2 = points[i], y2 = points[i + 1];
      context.moveTo(x2 + r2, y2);
      context.arc(x2, y2, r2, 0, tau$3);
    }
    return buffer2 && buffer2.value();
  }
  renderHull(context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const { hull: hull2, points } = this;
    const h2 = hull2[0] * 2, n2 = hull2.length;
    context.moveTo(points[h2], points[h2 + 1]);
    for (let i = 1; i < n2; ++i) {
      const h3 = 2 * hull2[i];
      context.lineTo(points[h3], points[h3 + 1]);
    }
    context.closePath();
    return buffer2 && buffer2.value();
  }
  hullPolygon() {
    const polygon = new Polygon();
    this.renderHull(polygon);
    return polygon.value();
  }
  renderTriangle(i, context) {
    const buffer2 = context == null ? context = new Path$1() : void 0;
    const { points, triangles } = this;
    const t02 = triangles[i *= 3] * 2;
    const t12 = triangles[i + 1] * 2;
    const t22 = triangles[i + 2] * 2;
    context.moveTo(points[t02], points[t02 + 1]);
    context.lineTo(points[t12], points[t12 + 1]);
    context.lineTo(points[t22], points[t22 + 1]);
    context.closePath();
    return buffer2 && buffer2.value();
  }
  *trianglePolygons() {
    const { triangles } = this;
    for (let i = 0, n2 = triangles.length / 3; i < n2; ++i) {
      yield this.trianglePolygon(i);
    }
  }
  trianglePolygon(i) {
    const polygon = new Polygon();
    this.renderTriangle(i, polygon);
    return polygon.value();
  }
}
function flatArray(points, fx, fy, that) {
  const n2 = points.length;
  const array2 = new Float64Array(n2 * 2);
  for (let i = 0; i < n2; ++i) {
    const p2 = points[i];
    array2[i * 2] = fx.call(that, p2, i, points);
    array2[i * 2 + 1] = fy.call(that, p2, i, points);
  }
  return array2;
}
function* flatIterable(points, fx, fy, that) {
  let i = 0;
  for (const p2 of points) {
    yield fx.call(that, p2, i, points);
    yield fy.call(that, p2, i, points);
    ++i;
  }
}
var noop$2 = { value: () => {
} };
function dispatch() {
  for (var i = 0, n2 = arguments.length, _2 = {}, t4; i < n2; ++i) {
    if (!(t4 = arguments[i] + "") || t4 in _2 || /[\s.]/.test(t4))
      throw new Error("illegal type: " + t4);
    _2[t4] = [];
  }
  return new Dispatch(_2);
}
function Dispatch(_2) {
  this._ = _2;
}
function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t4) {
    var name = "", i = t4.indexOf(".");
    if (i >= 0)
      name = t4.slice(i + 1), t4 = t4.slice(0, i);
    if (t4 && !types.hasOwnProperty(t4))
      throw new Error("unknown type: " + t4);
    return { type: t4, name };
  });
}
Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _2 = this._, T = parseTypenames(typename + "", _2), t4, i = -1, n2 = T.length;
    if (arguments.length < 2) {
      while (++i < n2)
        if ((t4 = (typename = T[i]).type) && (t4 = get(_2[t4], typename.name)))
          return t4;
      return;
    }
    if (callback != null && typeof callback !== "function")
      throw new Error("invalid callback: " + callback);
    while (++i < n2) {
      if (t4 = (typename = T[i]).type)
        _2[t4] = set(_2[t4], typename.name, callback);
      else if (callback == null)
        for (t4 in _2)
          _2[t4] = set(_2[t4], typename.name, null);
    }
    return this;
  },
  copy: function() {
    var copy2 = {}, _2 = this._;
    for (var t4 in _2)
      copy2[t4] = _2[t4].slice();
    return new Dispatch(copy2);
  },
  call: function(type2, that) {
    if ((n2 = arguments.length - 2) > 0)
      for (var args = new Array(n2), i = 0, n2, t4; i < n2; ++i)
        args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (t4 = this._[type2], i = 0, n2 = t4.length; i < n2; ++i)
      t4[i].value.apply(that, args);
  },
  apply: function(type2, that, args) {
    if (!this._.hasOwnProperty(type2))
      throw new Error("unknown type: " + type2);
    for (var t4 = this._[type2], i = 0, n2 = t4.length; i < n2; ++i)
      t4[i].value.apply(that, args);
  }
};
function get(type2, name) {
  for (var i = 0, n2 = type2.length, c2; i < n2; ++i) {
    if ((c2 = type2[i]).name === name) {
      return c2.value;
    }
  }
}
function set(type2, name, callback) {
  for (var i = 0, n2 = type2.length; i < n2; ++i) {
    if (type2[i].name === name) {
      type2[i] = noop$2, type2 = type2.slice(0, i).concat(type2.slice(i + 1));
      break;
    }
  }
  if (callback != null)
    type2.push({ name, value: callback });
  return type2;
}
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + '] || ""';
  }).join(",") + "}");
}
function customConverter(columns, f2) {
  var object2 = objectConverter(columns);
  return function(row, i) {
    return f2(object2(row), i, columns);
  };
}
function inferColumns(rows) {
  var columnSet = /* @__PURE__ */ Object.create(null), columns = [];
  rows.forEach(function(row) {
    for (var column2 in row) {
      if (!(column2 in columnSet)) {
        columns.push(columnSet[column2] = column2);
      }
    }
  });
  return columns;
}
function pad$1(value, width2) {
  var s2 = value + "", length2 = s2.length;
  return length2 < width2 ? new Array(width2 - length2 + 1).join(0) + s2 : s2;
}
function formatYear$1(year2) {
  return year2 < 0 ? "-" + pad$1(-year2, 6) : year2 > 9999 ? "+" + pad$1(year2, 6) : pad$1(year2, 4);
}
function formatDate(date2) {
  var hours2 = date2.getUTCHours(), minutes2 = date2.getUTCMinutes(), seconds2 = date2.getUTCSeconds(), milliseconds2 = date2.getUTCMilliseconds();
  return isNaN(date2) ? "Invalid Date" : formatYear$1(date2.getUTCFullYear()) + "-" + pad$1(date2.getUTCMonth() + 1, 2) + "-" + pad$1(date2.getUTCDate(), 2) + (milliseconds2 ? "T" + pad$1(hours2, 2) + ":" + pad$1(minutes2, 2) + ":" + pad$1(seconds2, 2) + "." + pad$1(milliseconds2, 3) + "Z" : seconds2 ? "T" + pad$1(hours2, 2) + ":" + pad$1(minutes2, 2) + ":" + pad$1(seconds2, 2) + "Z" : minutes2 || hours2 ? "T" + pad$1(hours2, 2) + ":" + pad$1(minutes2, 2) + "Z" : "");
}
function dsvFormat(delimiter2) {
  var reFormat = new RegExp('["' + delimiter2 + "\n\r]"), DELIMITER = delimiter2.charCodeAt(0);
  function parse2(text2, f2) {
    var convert, columns, rows = parseRows(text2, function(row, i) {
      if (convert)
        return convert(row, i - 1);
      columns = row, convert = f2 ? customConverter(row, f2) : objectConverter(row);
    });
    rows.columns = columns || [];
    return rows;
  }
  function parseRows(text2, f2) {
    var rows = [], N = text2.length, I = 0, n2 = 0, t4, eof = N <= 0, eol = false;
    if (text2.charCodeAt(N - 1) === NEWLINE)
      --N;
    if (text2.charCodeAt(N - 1) === RETURN)
      --N;
    function token2() {
      if (eof)
        return EOF;
      if (eol)
        return eol = false, EOL;
      var i, j = I, c2;
      if (text2.charCodeAt(j) === QUOTE) {
        while (I++ < N && text2.charCodeAt(I) !== QUOTE || text2.charCodeAt(++I) === QUOTE)
          ;
        if ((i = I) >= N)
          eof = true;
        else if ((c2 = text2.charCodeAt(I++)) === NEWLINE)
          eol = true;
        else if (c2 === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE)
            ++I;
        }
        return text2.slice(j + 1, i - 1).replace(/""/g, '"');
      }
      while (I < N) {
        if ((c2 = text2.charCodeAt(i = I++)) === NEWLINE)
          eol = true;
        else if (c2 === RETURN) {
          eol = true;
          if (text2.charCodeAt(I) === NEWLINE)
            ++I;
        } else if (c2 !== DELIMITER)
          continue;
        return text2.slice(j, i);
      }
      return eof = true, text2.slice(j, N);
    }
    while ((t4 = token2()) !== EOF) {
      var row = [];
      while (t4 !== EOL && t4 !== EOF)
        row.push(t4), t4 = token2();
      if (f2 && (row = f2(row, n2++)) == null)
        continue;
      rows.push(row);
    }
    return rows;
  }
  function preformatBody(rows, columns) {
    return rows.map(function(row) {
      return columns.map(function(column2) {
        return formatValue(row[column2]);
      }).join(delimiter2);
    });
  }
  function format2(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter2)].concat(preformatBody(rows, columns)).join("\n");
  }
  function formatBody(rows, columns) {
    if (columns == null)
      columns = inferColumns(rows);
    return preformatBody(rows, columns).join("\n");
  }
  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }
  function formatRow(row) {
    return row.map(formatValue).join(delimiter2);
  }
  function formatValue(value) {
    return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? '"' + value.replace(/"/g, '""') + '"' : value;
  }
  return {
    parse: parse2,
    parseRows,
    format: format2,
    formatBody,
    formatRows,
    formatRow,
    formatValue
  };
}
var csv$1 = dsvFormat(",");
var csvParse = csv$1.parse;
var csvParseRows = csv$1.parseRows;
var csvFormat = csv$1.format;
var csvFormatBody = csv$1.formatBody;
var csvFormatRows = csv$1.formatRows;
var csvFormatRow = csv$1.formatRow;
var csvFormatValue = csv$1.formatValue;
var tsv$1 = dsvFormat("	");
var tsvParse = tsv$1.parse;
var tsvParseRows = tsv$1.parseRows;
var tsvFormat = tsv$1.format;
var tsvFormatBody = tsv$1.formatBody;
var tsvFormatRows = tsv$1.formatRows;
var tsvFormatRow = tsv$1.formatRow;
var tsvFormatValue = tsv$1.formatValue;
function autoType(object2) {
  for (var key in object2) {
    var value = object2[key].trim(), number3, m2;
    if (!value)
      value = null;
    else if (value === "true")
      value = true;
    else if (value === "false")
      value = false;
    else if (value === "NaN")
      value = NaN;
    else if (!isNaN(number3 = +value))
      value = number3;
    else if (m2 = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
      if (fixtz && !!m2[4] && !m2[7])
        value = value.replace(/-/g, "/").replace(/T/, " ");
      value = new Date(value);
    } else
      continue;
    object2[key] = value;
  }
  return object2;
}
const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
function responseBlob(response) {
  if (!response.ok)
    throw new Error(response.status + " " + response.statusText);
  return response.blob();
}
function blob(input, init2) {
  return fetch(input, init2).then(responseBlob);
}
function responseArrayBuffer(response) {
  if (!response.ok)
    throw new Error(response.status + " " + response.statusText);
  return response.arrayBuffer();
}
function buffer(input, init2) {
  return fetch(input, init2).then(responseArrayBuffer);
}
function responseText(response) {
  if (!response.ok)
    throw new Error(response.status + " " + response.statusText);
  return response.text();
}
function text(input, init2) {
  return fetch(input, init2).then(responseText);
}
function dsvParse(parse2) {
  return function(input, init2, row) {
    if (arguments.length === 2 && typeof init2 === "function")
      row = init2, init2 = void 0;
    return text(input, init2).then(function(response) {
      return parse2(response, row);
    });
  };
}
function dsv(delimiter2, input, init2, row) {
  if (arguments.length === 3 && typeof init2 === "function")
    row = init2, init2 = void 0;
  var format2 = dsvFormat(delimiter2);
  return text(input, init2).then(function(response) {
    return format2.parse(response, row);
  });
}
var csv = dsvParse(csvParse);
var tsv = dsvParse(tsvParse);
function image(input, init2) {
  return new Promise(function(resolve, reject) {
    var image2 = new Image();
    for (var key in init2)
      image2[key] = init2[key];
    image2.onerror = reject;
    image2.onload = function() {
      resolve(image2);
    };
    image2.src = input;
  });
}
function responseJson(response) {
  if (!response.ok)
    throw new Error(response.status + " " + response.statusText);
  if (response.status === 204 || response.status === 205)
    return;
  return response.json();
}
function json(input, init2) {
  return fetch(input, init2).then(responseJson);
}
function parser(type2) {
  return (input, init2) => text(input, init2).then((text2) => new DOMParser().parseFromString(text2, type2));
}
var xml = parser("application/xml");
var html = parser("text/html");
var svg = parser("image/svg+xml");
function center(x2, y2) {
  var nodes, strength = 1;
  if (x2 == null)
    x2 = 0;
  if (y2 == null)
    y2 = 0;
  function force() {
    var i, n2 = nodes.length, node2, sx = 0, sy = 0;
    for (i = 0; i < n2; ++i) {
      node2 = nodes[i], sx += node2.x, sy += node2.y;
    }
    for (sx = (sx / n2 - x2) * strength, sy = (sy / n2 - y2) * strength, i = 0; i < n2; ++i) {
      node2 = nodes[i], node2.x -= sx, node2.y -= sy;
    }
  }
  force.initialize = function(_2) {
    nodes = _2;
  };
  force.x = function(_2) {
    return arguments.length ? (x2 = +_2, force) : x2;
  };
  force.y = function(_2) {
    return arguments.length ? (y2 = +_2, force) : y2;
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = +_2, force) : strength;
  };
  return force;
}
function tree_add(d2) {
  const x2 = +this._x.call(null, d2), y2 = +this._y.call(null, d2);
  return add(this.cover(x2, y2), x2, y2, d2);
}
function add(tree2, x2, y2, d2) {
  if (isNaN(x2) || isNaN(y2))
    return tree2;
  var parent, node2 = tree2._root, leaf = { data: d2 }, x02 = tree2._x0, y02 = tree2._y0, x12 = tree2._x1, y12 = tree2._y1, xm, ym, xp, yp, right2, bottom2, i, j;
  if (!node2)
    return tree2._root = leaf, tree2;
  while (node2.length) {
    if (right2 = x2 >= (xm = (x02 + x12) / 2))
      x02 = xm;
    else
      x12 = xm;
    if (bottom2 = y2 >= (ym = (y02 + y12) / 2))
      y02 = ym;
    else
      y12 = ym;
    if (parent = node2, !(node2 = node2[i = bottom2 << 1 | right2]))
      return parent[i] = leaf, tree2;
  }
  xp = +tree2._x.call(null, node2.data);
  yp = +tree2._y.call(null, node2.data);
  if (x2 === xp && y2 === yp)
    return leaf.next = node2, parent ? parent[i] = leaf : tree2._root = leaf, tree2;
  do {
    parent = parent ? parent[i] = new Array(4) : tree2._root = new Array(4);
    if (right2 = x2 >= (xm = (x02 + x12) / 2))
      x02 = xm;
    else
      x12 = xm;
    if (bottom2 = y2 >= (ym = (y02 + y12) / 2))
      y02 = ym;
    else
      y12 = ym;
  } while ((i = bottom2 << 1 | right2) === (j = (yp >= ym) << 1 | xp >= xm));
  return parent[j] = node2, parent[i] = leaf, tree2;
}
function addAll(data) {
  var d2, i, n2 = data.length, x2, y2, xz = new Array(n2), yz = new Array(n2), x02 = Infinity, y02 = Infinity, x12 = -Infinity, y12 = -Infinity;
  for (i = 0; i < n2; ++i) {
    if (isNaN(x2 = +this._x.call(null, d2 = data[i])) || isNaN(y2 = +this._y.call(null, d2)))
      continue;
    xz[i] = x2;
    yz[i] = y2;
    if (x2 < x02)
      x02 = x2;
    if (x2 > x12)
      x12 = x2;
    if (y2 < y02)
      y02 = y2;
    if (y2 > y12)
      y12 = y2;
  }
  if (x02 > x12 || y02 > y12)
    return this;
  this.cover(x02, y02).cover(x12, y12);
  for (i = 0; i < n2; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }
  return this;
}
function tree_cover(x2, y2) {
  if (isNaN(x2 = +x2) || isNaN(y2 = +y2))
    return this;
  var x02 = this._x0, y02 = this._y0, x12 = this._x1, y12 = this._y1;
  if (isNaN(x02)) {
    x12 = (x02 = Math.floor(x2)) + 1;
    y12 = (y02 = Math.floor(y2)) + 1;
  } else {
    var z2 = x12 - x02 || 1, node2 = this._root, parent, i;
    while (x02 > x2 || x2 >= x12 || y02 > y2 || y2 >= y12) {
      i = (y2 < y02) << 1 | x2 < x02;
      parent = new Array(4), parent[i] = node2, node2 = parent, z2 *= 2;
      switch (i) {
        case 0:
          x12 = x02 + z2, y12 = y02 + z2;
          break;
        case 1:
          x02 = x12 - z2, y12 = y02 + z2;
          break;
        case 2:
          x12 = x02 + z2, y02 = y12 - z2;
          break;
        case 3:
          x02 = x12 - z2, y02 = y12 - z2;
          break;
      }
    }
    if (this._root && this._root.length)
      this._root = node2;
  }
  this._x0 = x02;
  this._y0 = y02;
  this._x1 = x12;
  this._y1 = y12;
  return this;
}
function tree_data() {
  var data = [];
  this.visit(function(node2) {
    if (!node2.length)
      do
        data.push(node2.data);
      while (node2 = node2.next);
  });
  return data;
}
function tree_extent(_2) {
  return arguments.length ? this.cover(+_2[0][0], +_2[0][1]).cover(+_2[1][0], +_2[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Quad(node2, x02, y02, x12, y12) {
  this.node = node2;
  this.x0 = x02;
  this.y0 = y02;
  this.x1 = x12;
  this.y1 = y12;
}
function tree_find(x2, y2, radius) {
  var data, x02 = this._x0, y02 = this._y0, x12, y12, x22, y22, x3 = this._x1, y3 = this._y1, quads = [], node2 = this._root, q2, i;
  if (node2)
    quads.push(new Quad(node2, x02, y02, x3, y3));
  if (radius == null)
    radius = Infinity;
  else {
    x02 = x2 - radius, y02 = y2 - radius;
    x3 = x2 + radius, y3 = y2 + radius;
    radius *= radius;
  }
  while (q2 = quads.pop()) {
    if (!(node2 = q2.node) || (x12 = q2.x0) > x3 || (y12 = q2.y0) > y3 || (x22 = q2.x1) < x02 || (y22 = q2.y1) < y02)
      continue;
    if (node2.length) {
      var xm = (x12 + x22) / 2, ym = (y12 + y22) / 2;
      quads.push(
        new Quad(node2[3], xm, ym, x22, y22),
        new Quad(node2[2], x12, ym, xm, y22),
        new Quad(node2[1], xm, y12, x22, ym),
        new Quad(node2[0], x12, y12, xm, ym)
      );
      if (i = (y2 >= ym) << 1 | x2 >= xm) {
        q2 = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q2;
      }
    } else {
      var dx = x2 - +this._x.call(null, node2.data), dy = y2 - +this._y.call(null, node2.data), d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d4 = Math.sqrt(radius = d2);
        x02 = x2 - d4, y02 = y2 - d4;
        x3 = x2 + d4, y3 = y2 + d4;
        data = node2.data;
      }
    }
  }
  return data;
}
function tree_remove(d2) {
  if (isNaN(x2 = +this._x.call(null, d2)) || isNaN(y2 = +this._y.call(null, d2)))
    return this;
  var parent, node2 = this._root, retainer, previous, next2, x02 = this._x0, y02 = this._y0, x12 = this._x1, y12 = this._y1, x2, y2, xm, ym, right2, bottom2, i, j;
  if (!node2)
    return this;
  if (node2.length)
    while (true) {
      if (right2 = x2 >= (xm = (x02 + x12) / 2))
        x02 = xm;
      else
        x12 = xm;
      if (bottom2 = y2 >= (ym = (y02 + y12) / 2))
        y02 = ym;
      else
        y12 = ym;
      if (!(parent = node2, node2 = node2[i = bottom2 << 1 | right2]))
        return this;
      if (!node2.length)
        break;
      if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3])
        retainer = parent, j = i;
    }
  while (node2.data !== d2)
    if (!(previous = node2, node2 = node2.next))
      return this;
  if (next2 = node2.next)
    delete node2.next;
  if (previous)
    return next2 ? previous.next = next2 : delete previous.next, this;
  if (!parent)
    return this._root = next2, this;
  next2 ? parent[i] = next2 : delete parent[i];
  if ((node2 = parent[0] || parent[1] || parent[2] || parent[3]) && node2 === (parent[3] || parent[2] || parent[1] || parent[0]) && !node2.length) {
    if (retainer)
      retainer[j] = node2;
    else
      this._root = node2;
  }
  return this;
}
function removeAll(data) {
  for (var i = 0, n2 = data.length; i < n2; ++i)
    this.remove(data[i]);
  return this;
}
function tree_root() {
  return this._root;
}
function tree_size() {
  var size = 0;
  this.visit(function(node2) {
    if (!node2.length)
      do
        ++size;
      while (node2 = node2.next);
  });
  return size;
}
function tree_visit(callback) {
  var quads = [], q2, node2 = this._root, child, x02, y02, x12, y12;
  if (node2)
    quads.push(new Quad(node2, this._x0, this._y0, this._x1, this._y1));
  while (q2 = quads.pop()) {
    if (!callback(node2 = q2.node, x02 = q2.x0, y02 = q2.y0, x12 = q2.x1, y12 = q2.y1) && node2.length) {
      var xm = (x02 + x12) / 2, ym = (y02 + y12) / 2;
      if (child = node2[3])
        quads.push(new Quad(child, xm, ym, x12, y12));
      if (child = node2[2])
        quads.push(new Quad(child, x02, ym, xm, y12));
      if (child = node2[1])
        quads.push(new Quad(child, xm, y02, x12, ym));
      if (child = node2[0])
        quads.push(new Quad(child, x02, y02, xm, ym));
    }
  }
  return this;
}
function tree_visitAfter(callback) {
  var quads = [], next2 = [], q2;
  if (this._root)
    quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q2 = quads.pop()) {
    var node2 = q2.node;
    if (node2.length) {
      var child, x02 = q2.x0, y02 = q2.y0, x12 = q2.x1, y12 = q2.y1, xm = (x02 + x12) / 2, ym = (y02 + y12) / 2;
      if (child = node2[0])
        quads.push(new Quad(child, x02, y02, xm, ym));
      if (child = node2[1])
        quads.push(new Quad(child, xm, y02, x12, ym));
      if (child = node2[2])
        quads.push(new Quad(child, x02, ym, xm, y12));
      if (child = node2[3])
        quads.push(new Quad(child, xm, ym, x12, y12));
    }
    next2.push(q2);
  }
  while (q2 = next2.pop()) {
    callback(q2.node, q2.x0, q2.y0, q2.x1, q2.y1);
  }
  return this;
}
function defaultX(d2) {
  return d2[0];
}
function tree_x(_2) {
  return arguments.length ? (this._x = _2, this) : this._x;
}
function defaultY(d2) {
  return d2[1];
}
function tree_y(_2) {
  return arguments.length ? (this._y = _2, this) : this._y;
}
function quadtree(nodes, x2, y2) {
  var tree2 = new Quadtree(x2 == null ? defaultX : x2, y2 == null ? defaultY : y2, NaN, NaN, NaN, NaN);
  return nodes == null ? tree2 : tree2.addAll(nodes);
}
function Quadtree(x2, y2, x02, y02, x12, y12) {
  this._x = x2;
  this._y = y2;
  this._x0 = x02;
  this._y0 = y02;
  this._x1 = x12;
  this._y1 = y12;
  this._root = void 0;
}
function leaf_copy(leaf) {
  var copy2 = { data: leaf.data }, next2 = copy2;
  while (leaf = leaf.next)
    next2 = next2.next = { data: leaf.data };
  return copy2;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
  var copy2 = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node2 = this._root, nodes, child;
  if (!node2)
    return copy2;
  if (!node2.length)
    return copy2._root = leaf_copy(node2), copy2;
  nodes = [{ source: node2, target: copy2._root = new Array(4) }];
  while (node2 = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node2.source[i]) {
        if (child.length)
          nodes.push({ source: child, target: node2.target[i] = new Array(4) });
        else
          node2.target[i] = leaf_copy(child);
      }
    }
  }
  return copy2;
};
treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;
function constant$6(x2) {
  return function() {
    return x2;
  };
}
function jiggle(random) {
  return (random() - 0.5) * 1e-6;
}
function x$3(d2) {
  return d2.x + d2.vx;
}
function y$3(d2) {
  return d2.y + d2.vy;
}
function collide(radius) {
  var nodes, radii, random, strength = 1, iterations2 = 1;
  if (typeof radius !== "function")
    radius = constant$6(radius == null ? 1 : +radius);
  function force() {
    var i, n2 = nodes.length, tree2, node2, xi, yi, ri, ri2;
    for (var k2 = 0; k2 < iterations2; ++k2) {
      tree2 = quadtree(nodes, x$3, y$3).visitAfter(prepare2);
      for (i = 0; i < n2; ++i) {
        node2 = nodes[i];
        ri = radii[node2.index], ri2 = ri * ri;
        xi = node2.x + node2.vx;
        yi = node2.y + node2.vy;
        tree2.visit(apply);
      }
    }
    function apply(quad, x02, y02, x12, y12) {
      var data = quad.data, rj = quad.r, r2 = ri + rj;
      if (data) {
        if (data.index > node2.index) {
          var x2 = xi - data.x - data.vx, y2 = yi - data.y - data.vy, l2 = x2 * x2 + y2 * y2;
          if (l2 < r2 * r2) {
            if (x2 === 0)
              x2 = jiggle(random), l2 += x2 * x2;
            if (y2 === 0)
              y2 = jiggle(random), l2 += y2 * y2;
            l2 = (r2 - (l2 = Math.sqrt(l2))) / l2 * strength;
            node2.vx += (x2 *= l2) * (r2 = (rj *= rj) / (ri2 + rj));
            node2.vy += (y2 *= l2) * r2;
            data.vx -= x2 * (r2 = 1 - r2);
            data.vy -= y2 * r2;
          }
        }
        return;
      }
      return x02 > xi + r2 || x12 < xi - r2 || y02 > yi + r2 || y12 < yi - r2;
    }
  }
  function prepare2(quad) {
    if (quad.data)
      return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length, node2;
    radii = new Array(n2);
    for (i = 0; i < n2; ++i)
      node2 = nodes[i], radii[node2.index] = +radius(node2, i, nodes);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.iterations = function(_2) {
    return arguments.length ? (iterations2 = +_2, force) : iterations2;
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = +_2, force) : strength;
  };
  force.radius = function(_2) {
    return arguments.length ? (radius = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : radius;
  };
  return force;
}
function index$3(d2) {
  return d2.index;
}
function find(nodeById, nodeId) {
  var node2 = nodeById.get(nodeId);
  if (!node2)
    throw new Error("node not found: " + nodeId);
  return node2;
}
function link$2(links) {
  var id2 = index$3, strength = defaultStrength, strengths, distance2 = constant$6(30), distances, nodes, count2, bias, random, iterations2 = 1;
  if (links == null)
    links = [];
  function defaultStrength(link2) {
    return 1 / Math.min(count2[link2.source.index], count2[link2.target.index]);
  }
  function force(alpha2) {
    for (var k2 = 0, n2 = links.length; k2 < iterations2; ++k2) {
      for (var i = 0, link2, source, target, x2, y2, l2, b10; i < n2; ++i) {
        link2 = links[i], source = link2.source, target = link2.target;
        x2 = target.x + target.vx - source.x - source.vx || jiggle(random);
        y2 = target.y + target.vy - source.y - source.vy || jiggle(random);
        l2 = Math.sqrt(x2 * x2 + y2 * y2);
        l2 = (l2 - distances[i]) / l2 * alpha2 * strengths[i];
        x2 *= l2, y2 *= l2;
        target.vx -= x2 * (b10 = bias[i]);
        target.vy -= y2 * b10;
        source.vx += x2 * (b10 = 1 - b10);
        source.vy += y2 * b10;
      }
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length, m2 = links.length, nodeById = new Map(nodes.map((d2, i2) => [id2(d2, i2, nodes), d2])), link2;
    for (i = 0, count2 = new Array(n2); i < m2; ++i) {
      link2 = links[i], link2.index = i;
      if (typeof link2.source !== "object")
        link2.source = find(nodeById, link2.source);
      if (typeof link2.target !== "object")
        link2.target = find(nodeById, link2.target);
      count2[link2.source.index] = (count2[link2.source.index] || 0) + 1;
      count2[link2.target.index] = (count2[link2.target.index] || 0) + 1;
    }
    for (i = 0, bias = new Array(m2); i < m2; ++i) {
      link2 = links[i], bias[i] = count2[link2.source.index] / (count2[link2.source.index] + count2[link2.target.index]);
    }
    strengths = new Array(m2), initializeStrength();
    distances = new Array(m2), initializeDistance();
  }
  function initializeStrength() {
    if (!nodes)
      return;
    for (var i = 0, n2 = links.length; i < n2; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }
  function initializeDistance() {
    if (!nodes)
      return;
    for (var i = 0, n2 = links.length; i < n2; ++i) {
      distances[i] = +distance2(links[i], i, links);
    }
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.links = function(_2) {
    return arguments.length ? (links = _2, initialize(), force) : links;
  };
  force.id = function(_2) {
    return arguments.length ? (id2 = _2, force) : id2;
  };
  force.iterations = function(_2) {
    return arguments.length ? (iterations2 = +_2, force) : iterations2;
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$6(+_2), initializeStrength(), force) : strength;
  };
  force.distance = function(_2) {
    return arguments.length ? (distance2 = typeof _2 === "function" ? _2 : constant$6(+_2), initializeDistance(), force) : distance2;
  };
  return force;
}
const a$1 = 1664525;
const c$3 = 1013904223;
const m = 4294967296;
function lcg$1() {
  let s2 = 1;
  return () => (s2 = (a$1 * s2 + c$3) % m) / m;
}
function x$2(d2) {
  return d2.x;
}
function y$2(d2) {
  return d2.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
function simulation(nodes) {
  var simulation2, alpha2 = 1, alphaMin = 1e-3, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = /* @__PURE__ */ new Map(), stepper = timer(step2), event = dispatch$1("tick", "end"), random = lcg$1();
  if (nodes == null)
    nodes = [];
  function step2() {
    tick();
    event.call("tick", simulation2);
    if (alpha2 < alphaMin) {
      stepper.stop();
      event.call("end", simulation2);
    }
  }
  function tick(iterations2) {
    var i, n2 = nodes.length, node2;
    if (iterations2 === void 0)
      iterations2 = 1;
    for (var k2 = 0; k2 < iterations2; ++k2) {
      alpha2 += (alphaTarget - alpha2) * alphaDecay;
      forces.forEach(function(force) {
        force(alpha2);
      });
      for (i = 0; i < n2; ++i) {
        node2 = nodes[i];
        if (node2.fx == null)
          node2.x += node2.vx *= velocityDecay;
        else
          node2.x = node2.fx, node2.vx = 0;
        if (node2.fy == null)
          node2.y += node2.vy *= velocityDecay;
        else
          node2.y = node2.fy, node2.vy = 0;
      }
    }
    return simulation2;
  }
  function initializeNodes() {
    for (var i = 0, n2 = nodes.length, node2; i < n2; ++i) {
      node2 = nodes[i], node2.index = i;
      if (node2.fx != null)
        node2.x = node2.fx;
      if (node2.fy != null)
        node2.y = node2.fy;
      if (isNaN(node2.x) || isNaN(node2.y)) {
        var radius = initialRadius * Math.sqrt(0.5 + i), angle2 = i * initialAngle;
        node2.x = radius * Math.cos(angle2);
        node2.y = radius * Math.sin(angle2);
      }
      if (isNaN(node2.vx) || isNaN(node2.vy)) {
        node2.vx = node2.vy = 0;
      }
    }
  }
  function initializeForce(force) {
    if (force.initialize)
      force.initialize(nodes, random);
    return force;
  }
  initializeNodes();
  return simulation2 = {
    tick,
    restart: function() {
      return stepper.restart(step2), simulation2;
    },
    stop: function() {
      return stepper.stop(), simulation2;
    },
    nodes: function(_2) {
      return arguments.length ? (nodes = _2, initializeNodes(), forces.forEach(initializeForce), simulation2) : nodes;
    },
    alpha: function(_2) {
      return arguments.length ? (alpha2 = +_2, simulation2) : alpha2;
    },
    alphaMin: function(_2) {
      return arguments.length ? (alphaMin = +_2, simulation2) : alphaMin;
    },
    alphaDecay: function(_2) {
      return arguments.length ? (alphaDecay = +_2, simulation2) : +alphaDecay;
    },
    alphaTarget: function(_2) {
      return arguments.length ? (alphaTarget = +_2, simulation2) : alphaTarget;
    },
    velocityDecay: function(_2) {
      return arguments.length ? (velocityDecay = 1 - _2, simulation2) : 1 - velocityDecay;
    },
    randomSource: function(_2) {
      return arguments.length ? (random = _2, forces.forEach(initializeForce), simulation2) : random;
    },
    force: function(name, _2) {
      return arguments.length > 1 ? (_2 == null ? forces.delete(name) : forces.set(name, initializeForce(_2)), simulation2) : forces.get(name);
    },
    find: function(x2, y2, radius) {
      var i = 0, n2 = nodes.length, dx, dy, d2, node2, closest;
      if (radius == null)
        radius = Infinity;
      else
        radius *= radius;
      for (i = 0; i < n2; ++i) {
        node2 = nodes[i];
        dx = x2 - node2.x;
        dy = y2 - node2.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius)
          closest = node2, radius = d2;
      }
      return closest;
    },
    on: function(name, _2) {
      return arguments.length > 1 ? (event.on(name, _2), simulation2) : event.on(name);
    }
  };
}
function manyBody() {
  var nodes, node2, random, alpha2, strength = constant$6(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
  function force(_2) {
    var i, n2 = nodes.length, tree2 = quadtree(nodes, x$2, y$2).visitAfter(accumulate);
    for (alpha2 = _2, i = 0; i < n2; ++i)
      node2 = nodes[i], tree2.visit(apply);
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length, node3;
    strengths = new Array(n2);
    for (i = 0; i < n2; ++i)
      node3 = nodes[i], strengths[node3.index] = +strength(node3, i, nodes);
  }
  function accumulate(quad) {
    var strength2 = 0, q2, c2, weight = 0, x2, y2, i;
    if (quad.length) {
      for (x2 = y2 = i = 0; i < 4; ++i) {
        if ((q2 = quad[i]) && (c2 = Math.abs(q2.value))) {
          strength2 += q2.value, weight += c2, x2 += c2 * q2.x, y2 += c2 * q2.y;
        }
      }
      quad.x = x2 / weight;
      quad.y = y2 / weight;
    } else {
      q2 = quad;
      q2.x = q2.data.x;
      q2.y = q2.data.y;
      do
        strength2 += strengths[q2.data.index];
      while (q2 = q2.next);
    }
    quad.value = strength2;
  }
  function apply(quad, x12, _2, x2) {
    if (!quad.value)
      return true;
    var x3 = quad.x - node2.x, y2 = quad.y - node2.y, w2 = x2 - x12, l2 = x3 * x3 + y2 * y2;
    if (w2 * w2 / theta2 < l2) {
      if (l2 < distanceMax2) {
        if (x3 === 0)
          x3 = jiggle(random), l2 += x3 * x3;
        if (y2 === 0)
          y2 = jiggle(random), l2 += y2 * y2;
        if (l2 < distanceMin2)
          l2 = Math.sqrt(distanceMin2 * l2);
        node2.vx += x3 * quad.value * alpha2 / l2;
        node2.vy += y2 * quad.value * alpha2 / l2;
      }
      return true;
    } else if (quad.length || l2 >= distanceMax2)
      return;
    if (quad.data !== node2 || quad.next) {
      if (x3 === 0)
        x3 = jiggle(random), l2 += x3 * x3;
      if (y2 === 0)
        y2 = jiggle(random), l2 += y2 * y2;
      if (l2 < distanceMin2)
        l2 = Math.sqrt(distanceMin2 * l2);
    }
    do
      if (quad.data !== node2) {
        w2 = strengths[quad.data.index] * alpha2 / l2;
        node2.vx += x3 * w2;
        node2.vy += y2 * w2;
      }
    while (quad = quad.next);
  }
  force.initialize = function(_nodes, _random) {
    nodes = _nodes;
    random = _random;
    initialize();
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : strength;
  };
  force.distanceMin = function(_2) {
    return arguments.length ? (distanceMin2 = _2 * _2, force) : Math.sqrt(distanceMin2);
  };
  force.distanceMax = function(_2) {
    return arguments.length ? (distanceMax2 = _2 * _2, force) : Math.sqrt(distanceMax2);
  };
  force.theta = function(_2) {
    return arguments.length ? (theta2 = _2 * _2, force) : Math.sqrt(theta2);
  };
  return force;
}
function radial$1(radius, x2, y2) {
  var nodes, strength = constant$6(0.1), strengths, radiuses;
  if (typeof radius !== "function")
    radius = constant$6(+radius);
  if (x2 == null)
    x2 = 0;
  if (y2 == null)
    y2 = 0;
  function force(alpha2) {
    for (var i = 0, n2 = nodes.length; i < n2; ++i) {
      var node2 = nodes[i], dx = node2.x - x2 || 1e-6, dy = node2.y - y2 || 1e-6, r2 = Math.sqrt(dx * dx + dy * dy), k2 = (radiuses[i] - r2) * strengths[i] * alpha2 / r2;
      node2.vx += dx * k2;
      node2.vy += dy * k2;
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length;
    strengths = new Array(n2);
    radiuses = new Array(n2);
    for (i = 0; i < n2; ++i) {
      radiuses[i] = +radius(nodes[i], i, nodes);
      strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_2) {
    nodes = _2, initialize();
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : strength;
  };
  force.radius = function(_2) {
    return arguments.length ? (radius = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : radius;
  };
  force.x = function(_2) {
    return arguments.length ? (x2 = +_2, force) : x2;
  };
  force.y = function(_2) {
    return arguments.length ? (y2 = +_2, force) : y2;
  };
  return force;
}
function x$1(x2) {
  var strength = constant$6(0.1), nodes, strengths, xz;
  if (typeof x2 !== "function")
    x2 = constant$6(x2 == null ? 0 : +x2);
  function force(alpha2) {
    for (var i = 0, n2 = nodes.length, node2; i < n2; ++i) {
      node2 = nodes[i], node2.vx += (xz[i] - node2.x) * strengths[i] * alpha2;
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length;
    strengths = new Array(n2);
    xz = new Array(n2);
    for (i = 0; i < n2; ++i) {
      strengths[i] = isNaN(xz[i] = +x2(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_2) {
    nodes = _2;
    initialize();
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : strength;
  };
  force.x = function(_2) {
    return arguments.length ? (x2 = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : x2;
  };
  return force;
}
function y$1(y2) {
  var strength = constant$6(0.1), nodes, strengths, yz;
  if (typeof y2 !== "function")
    y2 = constant$6(y2 == null ? 0 : +y2);
  function force(alpha2) {
    for (var i = 0, n2 = nodes.length, node2; i < n2; ++i) {
      node2 = nodes[i], node2.vy += (yz[i] - node2.y) * strengths[i] * alpha2;
    }
  }
  function initialize() {
    if (!nodes)
      return;
    var i, n2 = nodes.length;
    strengths = new Array(n2);
    yz = new Array(n2);
    for (i = 0; i < n2; ++i) {
      strengths[i] = isNaN(yz[i] = +y2(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }
  force.initialize = function(_2) {
    nodes = _2;
    initialize();
  };
  force.strength = function(_2) {
    return arguments.length ? (strength = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : strength;
  };
  force.y = function(_2) {
    return arguments.length ? (y2 = typeof _2 === "function" ? _2 : constant$6(+_2), initialize(), force) : y2;
  };
  return force;
}
function formatDecimal(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p2) {
  if ((i = (x2 = p2 ? x2.toExponential(p2 - 1) : x2.toExponential()).indexOf("e")) < 0)
    return null;
  var i, coefficient = x2.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i + 1)
  ];
}
function exponent(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width2) {
    var i = value.length, t4 = [], j = 0, g2 = grouping[0], length2 = 0;
    while (i > 0 && g2 > 0) {
      if (length2 + g2 + 1 > width2)
        g2 = Math.max(1, width2 - length2);
      t4.push(value.substring(i -= g2, i + g2));
      if ((length2 += g2 + 1) > width2)
        break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t4.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s2) {
  out:
    for (var n2 = s2.length, i = 1, i0 = -1, i1; i < n2; ++i) {
      switch (s2[i]) {
        case ".":
          i0 = i1 = i;
          break;
        case "0":
          if (i0 === 0)
            i0 = i;
          i1 = i;
          break;
        default:
          if (!+s2[i])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s2.slice(0, i0) + s2.slice(i1 + 1) : s2;
}
var prefixExponent;
function formatPrefixAuto(x2, p2) {
  var d2 = formatDecimalParts(x2, p2);
  if (!d2)
    return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i === n2 ? coefficient : i > n2 ? coefficient + new Array(i - n2 + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x2, Math.max(0, p2 + i - 1))[0];
}
function formatRounded(x2, p2) {
  var d2 = formatDecimalParts(x2, p2);
  if (!d2)
    return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var formatTypes = {
  "%": (x2, p2) => (x2 * 100).toFixed(p2),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal,
  "e": (x2, p2) => x2.toExponential(p2),
  "f": (x2, p2) => x2.toFixed(p2),
  "g": (x2, p2) => x2.toPrecision(p2),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p2) => formatRounded(x2 * 100, p2),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$8(x2) {
  return x2;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group2 = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$8 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$8 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "\u2212" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align2 = specifier.align, sign2 = specifier.sign, symbol2 = specifier.symbol, zero2 = specifier.zero, width2 = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type2 = specifier.type;
    if (type2 === "n")
      comma = true, type2 = "g";
    else if (!formatTypes[type2])
      precision === void 0 && (precision = 12), trim2 = true, type2 = "g";
    if (zero2 || fill === "0" && align2 === "=")
      zero2 = true, fill = "0", align2 = "=";
    var prefix2 = symbol2 === "$" ? currencyPrefix : symbol2 === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : "", suffix = symbol2 === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "";
    var formatType = formatTypes[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i, n2, c2;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2)
          value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type2 === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n2 = value.length;
          while (++i < n2) {
            if (c2 = value.charCodeAt(i), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value = group2(value, Infinity);
      var length2 = valuePrefix.length + value.length + valueSuffix.length, padding2 = length2 < width2 ? new Array(width2 - length2 + 1).join(fill) : "";
      if (comma && zero2)
        value = group2(padding2 + value, padding2.length ? width2 - valueSuffix.length : Infinity), padding2 = "";
      switch (align2) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding2;
          break;
        case "=":
          value = valuePrefix + padding2 + value + valueSuffix;
          break;
        case "^":
          value = padding2.slice(0, length2 = padding2.length >> 1) + valuePrefix + value + valueSuffix + padding2.slice(length2);
          break;
        default:
          value = padding2 + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f2 = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k2 = Math.pow(10, -e3), prefix2 = prefixes[8 + e3 / 3];
    return function(value2) {
      return f2(k2 * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$1;
var format;
var formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}
function precisionFixed(step2) {
  return Math.max(0, -exponent(Math.abs(step2)));
}
function precisionPrefix(step2, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step2)));
}
function precisionRound(step2, max2) {
  step2 = Math.abs(step2), max2 = Math.abs(max2) - step2;
  return Math.max(0, exponent(max2) - exponent(step2)) + 1;
}
var epsilon$2 = 1e-6;
var epsilon2$2 = 1e-12;
var pi$2 = Math.PI;
var halfPi$1 = pi$2 / 2;
var quarterPi = pi$2 / 4;
var tau$2 = pi$2 * 2;
var degrees$2 = 180 / pi$2;
var radians$1 = pi$2 / 180;
var abs$1 = Math.abs;
var atan = Math.atan;
var atan2$1 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var hypot = Math.hypot;
var log$1 = Math.log;
var pow$1 = Math.pow;
var sin$1 = Math.sin;
var sign$1 = Math.sign || function(x2) {
  return x2 > 0 ? 1 : x2 < 0 ? -1 : 0;
};
var sqrt$2 = Math.sqrt;
var tan = Math.tan;
function acos$1(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi$2 : Math.acos(x2);
}
function asin$1(x2) {
  return x2 > 1 ? halfPi$1 : x2 < -1 ? -halfPi$1 : Math.asin(x2);
}
function haversin(x2) {
  return (x2 = sin$1(x2 / 2)) * x2;
}
function noop$1() {
}
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}
var streamObjectType = {
  Feature: function(object2, stream) {
    streamGeometry(object2.geometry, stream);
  },
  FeatureCollection: function(object2, stream) {
    var features = object2.features, i = -1, n2 = features.length;
    while (++i < n2)
      streamGeometry(features[i].geometry, stream);
  }
};
var streamGeometryType = {
  Sphere: function(object2, stream) {
    stream.sphere();
  },
  Point: function(object2, stream) {
    object2 = object2.coordinates;
    stream.point(object2[0], object2[1], object2[2]);
  },
  MultiPoint: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      object2 = coordinates2[i], stream.point(object2[0], object2[1], object2[2]);
  },
  LineString: function(object2, stream) {
    streamLine(object2.coordinates, stream, 0);
  },
  MultiLineString: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      streamLine(coordinates2[i], stream, 0);
  },
  Polygon: function(object2, stream) {
    streamPolygon(object2.coordinates, stream);
  },
  MultiPolygon: function(object2, stream) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      streamPolygon(coordinates2[i], stream);
  },
  GeometryCollection: function(object2, stream) {
    var geometries = object2.geometries, i = -1, n2 = geometries.length;
    while (++i < n2)
      streamGeometry(geometries[i], stream);
  }
};
function streamLine(coordinates2, stream, closed) {
  var i = -1, n2 = coordinates2.length - closed, coordinate;
  stream.lineStart();
  while (++i < n2)
    coordinate = coordinates2[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}
function streamPolygon(coordinates2, stream) {
  var i = -1, n2 = coordinates2.length;
  stream.polygonStart();
  while (++i < n2)
    streamLine(coordinates2[i], stream, 1);
  stream.polygonEnd();
}
function geoStream(object2, stream) {
  if (object2 && streamObjectType.hasOwnProperty(object2.type)) {
    streamObjectType[object2.type](object2, stream);
  } else {
    streamGeometry(object2, stream);
  }
}
var areaRingSum$1 = new Adder();
var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum$1 = new Adder();
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum$1;
    areaSum$1.add(areaRing < 0 ? tau$2 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum$1.add(tau$2);
  }
};
function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}
function areaRingEnd$1() {
  areaPoint$1(lambda00$2, phi00$2);
}
function areaPointFirst$1(lambda, phi2) {
  areaStream$1.point = areaPoint$1;
  lambda00$2 = lambda, phi00$2 = phi2;
  lambda *= radians$1, phi2 *= radians$1;
  lambda0$2 = lambda, cosPhi0$1 = cos$1(phi2 = phi2 / 2 + quarterPi), sinPhi0$1 = sin$1(phi2);
}
function areaPoint$1(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  phi2 = phi2 / 2 + quarterPi;
  var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos$1(phi2), sinPhi = sin$1(phi2), k2 = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k2 * cos$1(adLambda), v2 = k2 * sdLambda * sin$1(adLambda);
  areaRingSum$1.add(atan2$1(v2, u));
  lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
}
function area$2(object2) {
  areaSum$1 = new Adder();
  geoStream(object2, areaStream$1);
  return areaSum$1 * 2;
}
function spherical(cartesian2) {
  return [atan2$1(cartesian2[1], cartesian2[0]), asin$1(cartesian2[2])];
}
function cartesian(spherical2) {
  var lambda = spherical2[0], phi2 = spherical2[1], cosPhi = cos$1(phi2);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi2)];
}
function cartesianDot(a2, b10) {
  return a2[0] * b10[0] + a2[1] * b10[1] + a2[2] * b10[2];
}
function cartesianCross(a2, b10) {
  return [a2[1] * b10[2] - a2[2] * b10[1], a2[2] * b10[0] - a2[0] * b10[2], a2[0] * b10[1] - a2[1] * b10[0]];
}
function cartesianAddInPlace(a2, b10) {
  a2[0] += b10[0], a2[1] += b10[1], a2[2] += b10[2];
}
function cartesianScale(vector, k2) {
  return [vector[0] * k2, vector[1] * k2, vector[2] * k2];
}
function cartesianNormalizeInPlace(d2) {
  var l2 = sqrt$2(d2[0] * d2[0] + d2[1] * d2[1] + d2[2] * d2[2]);
  d2[0] /= l2, d2[1] /= l2, d2[2] /= l2;
}
var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
var boundsStream$2 = {
  point: boundsPoint$1,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream$2.point = boundsRingPoint;
    boundsStream$2.lineStart = boundsRingStart;
    boundsStream$2.lineEnd = boundsRingEnd;
    deltaSum = new Adder();
    areaStream$1.polygonStart();
  },
  polygonEnd: function() {
    areaStream$1.polygonEnd();
    boundsStream$2.point = boundsPoint$1;
    boundsStream$2.lineStart = boundsLineStart;
    boundsStream$2.lineEnd = boundsLineEnd;
    if (areaRingSum$1 < 0)
      lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2)
      phi1 = 90;
    else if (deltaSum < -epsilon$2)
      phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  },
  sphere: function() {
    lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};
function boundsPoint$1(lambda, phi2) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi2 < phi0)
    phi0 = phi2;
  if (phi2 > phi1)
    phi1 = phi2;
}
function linePoint(lambda, phi2) {
  var p2 = cartesian([lambda * radians$1, phi2 * radians$1]);
  if (p0) {
    var normal2 = cartesianCross(p0, p2), equatorial = [normal2[1], -normal2[0], 0], inflection = cartesianCross(equatorial, normal2);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2, sign2 = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees$2 * sign2, phii, antimeridian = abs$1(delta) > 180;
    if (antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda)) {
      phii = inflection[1] * degrees$2;
      if (phii > phi1)
        phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign2 * lambda2 < lambdai && lambdai < sign2 * lambda)) {
      phii = -inflection[1] * degrees$2;
      if (phii < phi0)
        phi0 = phii;
    } else {
      if (phi2 < phi0)
        phi0 = phi2;
      if (phi2 > phi1)
        phi1 = phi2;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1))
          lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1))
          lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1)
          lambda0$1 = lambda;
        if (lambda > lambda1)
          lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1))
            lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1))
            lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi2 < phi0)
    phi0 = phi2;
  if (phi2 > phi1)
    phi1 = phi2;
  p0 = p2, lambda2 = lambda;
}
function boundsLineStart() {
  boundsStream$2.point = linePoint;
}
function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream$2.point = boundsPoint$1;
  p0 = null;
}
function boundsRingPoint(lambda, phi2) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi2;
  }
  areaStream$1.point(lambda, phi2);
  linePoint(lambda, phi2);
}
function boundsRingStart() {
  areaStream$1.lineStart();
}
function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream$1.lineEnd();
  if (abs$1(deltaSum) > epsilon$2)
    lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}
function angle(lambda02, lambda12) {
  return (lambda12 -= lambda02) < 0 ? lambda12 + 360 : lambda12;
}
function rangeCompare(a2, b10) {
  return a2[0] - b10[0];
}
function rangeContains(range2, x2) {
  return range2[0] <= range2[1] ? range2[0] <= x2 && x2 <= range2[1] : x2 < range2[0] || range2[1] < x2;
}
function bounds(feature) {
  var i, n2, a2, b10, merged, deltaMax, delta;
  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream$2);
  if (n2 = ranges.length) {
    ranges.sort(rangeCompare);
    for (i = 1, a2 = ranges[0], merged = [a2]; i < n2; ++i) {
      b10 = ranges[i];
      if (rangeContains(a2, b10[0]) || rangeContains(a2, b10[1])) {
        if (angle(a2[0], b10[1]) > angle(a2[0], a2[1]))
          a2[1] = b10[1];
        if (angle(b10[0], a2[1]) > angle(a2[0], a2[1]))
          a2[0] = b10[0];
      } else {
        merged.push(a2 = b10);
      }
    }
    for (deltaMax = -Infinity, n2 = merged.length - 1, i = 0, a2 = merged[n2]; i <= n2; a2 = b10, ++i) {
      b10 = merged[i];
      if ((delta = angle(a2[1], b10[0])) > deltaMax)
        deltaMax = delta, lambda0$1 = b10[0], lambda1 = a2[1];
    }
  }
  ranges = range = null;
  return lambda0$1 === Infinity || phi0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[lambda0$1, phi0], [lambda1, phi1]];
}
var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0;
var centroidStream$1 = {
  sphere: noop$1,
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  }
};
function centroidPoint$1(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  var cosPhi = cos$1(phi2);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi2));
}
function centroidPointCartesian(x2, y2, z2) {
  ++W0;
  X0$1 += (x2 - X0$1) / W0;
  Y0$1 += (y2 - Y0$1) / W0;
  Z0$1 += (z2 - Z0$1) / W0;
}
function centroidLineStart$1() {
  centroidStream$1.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  var cosPhi = cos$1(phi2);
  x0$4 = cosPhi * cos$1(lambda);
  y0$4 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi2);
  centroidStream$1.point = centroidLinePoint;
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLinePoint(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  var cosPhi = cos$1(phi2), x2 = cosPhi * cos$1(lambda), y2 = cosPhi * sin$1(lambda), z2 = sin$1(phi2), w2 = atan2$1(sqrt$2((w2 = y0$4 * z2 - z0 * y2) * w2 + (w2 = z0 * x2 - x0$4 * z2) * w2 + (w2 = x0$4 * y2 - y0$4 * x2) * w2), x0$4 * x2 + y0$4 * y2 + z0 * z2);
  W1 += w2;
  X1$1 += w2 * (x0$4 + (x0$4 = x2));
  Y1$1 += w2 * (y0$4 + (y0$4 = y2));
  Z1$1 += w2 * (z0 + (z0 = z2));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingStart$1() {
  centroidStream$1.point = centroidRingPointFirst;
}
function centroidRingEnd$1() {
  centroidRingPoint(lambda00, phi00);
  centroidStream$1.point = centroidPoint$1;
}
function centroidRingPointFirst(lambda, phi2) {
  lambda00 = lambda, phi00 = phi2;
  lambda *= radians$1, phi2 *= radians$1;
  centroidStream$1.point = centroidRingPoint;
  var cosPhi = cos$1(phi2);
  x0$4 = cosPhi * cos$1(lambda);
  y0$4 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi2);
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroidRingPoint(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  var cosPhi = cos$1(phi2), x2 = cosPhi * cos$1(lambda), y2 = cosPhi * sin$1(lambda), z2 = sin$1(phi2), cx2 = y0$4 * z2 - z0 * y2, cy = z0 * x2 - x0$4 * z2, cz = x0$4 * y2 - y0$4 * x2, m2 = hypot(cx2, cy, cz), w2 = asin$1(m2), v2 = m2 && -w2 / m2;
  X2$1.add(v2 * cx2);
  Y2$1.add(v2 * cy);
  Z2$1.add(v2 * cz);
  W1 += w2;
  X1$1 += w2 * (x0$4 + (x0$4 = x2));
  Y1$1 += w2 * (y0$4 + (y0$4 = y2));
  Z1$1 += w2 * (z0 + (z0 = z2));
  centroidPointCartesian(x0$4, y0$4, z0);
}
function centroid$1(object2) {
  W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
  X2$1 = new Adder();
  Y2$1 = new Adder();
  Z2$1 = new Adder();
  geoStream(object2, centroidStream$1);
  var x2 = +X2$1, y2 = +Y2$1, z2 = +Z2$1, m2 = hypot(x2, y2, z2);
  if (m2 < epsilon2$2) {
    x2 = X1$1, y2 = Y1$1, z2 = Z1$1;
    if (W1 < epsilon$2)
      x2 = X0$1, y2 = Y0$1, z2 = Z0$1;
    m2 = hypot(x2, y2, z2);
    if (m2 < epsilon2$2)
      return [NaN, NaN];
  }
  return [atan2$1(y2, x2) * degrees$2, asin$1(z2 / m2) * degrees$2];
}
function constant$5(x2) {
  return function() {
    return x2;
  };
}
function compose(a2, b10) {
  function compose2(x2, y2) {
    return x2 = a2(x2, y2), b10(x2[0], x2[1]);
  }
  if (a2.invert && b10.invert)
    compose2.invert = function(x2, y2) {
      return x2 = b10.invert(x2, y2), x2 && a2.invert(x2[0], x2[1]);
    };
  return compose2;
}
function rotationIdentity(lambda, phi2) {
  return [abs$1(lambda) > pi$2 ? lambda + Math.round(-lambda / tau$2) * tau$2 : lambda, phi2];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$2) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi2) {
    return lambda += deltaLambda, [lambda > pi$2 ? lambda - tau$2 : lambda < -pi$2 ? lambda + tau$2 : lambda, phi2];
  };
}
function rotationLambda(deltaLambda) {
  var rotation2 = forwardRotationLambda(deltaLambda);
  rotation2.invert = forwardRotationLambda(-deltaLambda);
  return rotation2;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi), sinDeltaPhi = sin$1(deltaPhi), cosDeltaGamma = cos$1(deltaGamma), sinDeltaGamma = sin$1(deltaGamma);
  function rotation2(lambda, phi2) {
    var cosPhi = cos$1(phi2), x2 = cos$1(lambda) * cosPhi, y2 = sin$1(lambda) * cosPhi, z2 = sin$1(phi2), k2 = z2 * cosDeltaPhi + x2 * sinDeltaPhi;
    return [
      atan2$1(y2 * cosDeltaGamma - k2 * sinDeltaGamma, x2 * cosDeltaPhi - z2 * sinDeltaPhi),
      asin$1(k2 * cosDeltaGamma + y2 * sinDeltaGamma)
    ];
  }
  rotation2.invert = function(lambda, phi2) {
    var cosPhi = cos$1(phi2), x2 = cos$1(lambda) * cosPhi, y2 = sin$1(lambda) * cosPhi, z2 = sin$1(phi2), k2 = z2 * cosDeltaGamma - y2 * sinDeltaGamma;
    return [
      atan2$1(y2 * cosDeltaGamma + z2 * sinDeltaGamma, x2 * cosDeltaPhi + k2 * sinDeltaPhi),
      asin$1(k2 * cosDeltaPhi - x2 * sinDeltaPhi)
    ];
  };
  return rotation2;
}
function rotation(rotate) {
  rotate = rotateRadians(rotate[0] * radians$1, rotate[1] * radians$1, rotate.length > 2 ? rotate[2] * radians$1 : 0);
  function forward(coordinates2) {
    coordinates2 = rotate(coordinates2[0] * radians$1, coordinates2[1] * radians$1);
    return coordinates2[0] *= degrees$2, coordinates2[1] *= degrees$2, coordinates2;
  }
  forward.invert = function(coordinates2) {
    coordinates2 = rotate.invert(coordinates2[0] * radians$1, coordinates2[1] * radians$1);
    return coordinates2[0] *= degrees$2, coordinates2[1] *= degrees$2, coordinates2;
  };
  return forward;
}
function circleStream(stream, radius, delta, direction, t02, t12) {
  if (!delta)
    return;
  var cosRadius = cos$1(radius), sinRadius = sin$1(radius), step2 = direction * delta;
  if (t02 == null) {
    t02 = radius + direction * tau$2;
    t12 = radius - step2 / 2;
  } else {
    t02 = circleRadius(cosRadius, t02);
    t12 = circleRadius(cosRadius, t12);
    if (direction > 0 ? t02 < t12 : t02 > t12)
      t02 += direction * tau$2;
  }
  for (var point2, t4 = t02; direction > 0 ? t4 > t12 : t4 < t12; t4 -= step2) {
    point2 = spherical([cosRadius, -sinRadius * cos$1(t4), -sinRadius * sin$1(t4)]);
    stream.point(point2[0], point2[1]);
  }
}
function circleRadius(cosRadius, point2) {
  point2 = cartesian(point2), point2[0] -= cosRadius;
  cartesianNormalizeInPlace(point2);
  var radius = acos$1(-point2[1]);
  return ((-point2[2] < 0 ? -radius : radius) + tau$2 - epsilon$2) % tau$2;
}
function circle$2() {
  var center2 = constant$5([0, 0]), radius = constant$5(90), precision = constant$5(6), ring, rotate, stream = { point: point2 };
  function point2(x2, y2) {
    ring.push(x2 = rotate(x2, y2));
    x2[0] *= degrees$2, x2[1] *= degrees$2;
  }
  function circle2() {
    var c2 = center2.apply(this, arguments), r2 = radius.apply(this, arguments) * radians$1, p2 = precision.apply(this, arguments) * radians$1;
    ring = [];
    rotate = rotateRadians(-c2[0] * radians$1, -c2[1] * radians$1, 0).invert;
    circleStream(stream, r2, p2, 1);
    c2 = { type: "Polygon", coordinates: [ring] };
    ring = rotate = null;
    return c2;
  }
  circle2.center = function(_2) {
    return arguments.length ? (center2 = typeof _2 === "function" ? _2 : constant$5([+_2[0], +_2[1]]), circle2) : center2;
  };
  circle2.radius = function(_2) {
    return arguments.length ? (radius = typeof _2 === "function" ? _2 : constant$5(+_2), circle2) : radius;
  };
  circle2.precision = function(_2) {
    return arguments.length ? (precision = typeof _2 === "function" ? _2 : constant$5(+_2), circle2) : precision;
  };
  return circle2;
}
function clipBuffer() {
  var lines = [], line2;
  return {
    point: function(x2, y2, m2) {
      line2.push([x2, y2, m2]);
    },
    lineStart: function() {
      lines.push(line2 = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1)
        lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line2 = null;
      return result;
    }
  };
}
function pointEqual(a2, b10) {
  return abs$1(a2[0] - b10[0]) < epsilon$2 && abs$1(a2[1] - b10[1]) < epsilon$2;
}
function Intersection(point2, points, other, entry) {
  this.x = point2;
  this.z = points;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream) {
  var subject = [], clip2 = [], i, n2;
  segments.forEach(function(segment) {
    if ((n3 = segment.length - 1) <= 0)
      return;
    var n3, p02 = segment[0], p1 = segment[n3], x2;
    if (pointEqual(p02, p1)) {
      if (!p02[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n3; ++i)
          stream.point((p02 = segment[i])[0], p02[1]);
        stream.lineEnd();
        return;
      }
      p1[0] += 2 * epsilon$2;
    }
    subject.push(x2 = new Intersection(p02, segment, null, true));
    clip2.push(x2.o = new Intersection(p02, null, x2, false));
    subject.push(x2 = new Intersection(p1, segment, null, false));
    clip2.push(x2.o = new Intersection(p1, null, x2, true));
  });
  if (!subject.length)
    return;
  clip2.sort(compareIntersection2);
  link$1(subject);
  link$1(clip2);
  for (i = 0, n2 = clip2.length; i < n2; ++i) {
    clip2[i].e = startInside = !startInside;
  }
  var start2 = subject[0], points, point2;
  while (1) {
    var current = start2, isSubject = true;
    while (current.v)
      if ((current = current.n) === start2)
        return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n2 = points.length; i < n2; ++i)
            stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i)
            stream.point((point2 = points[i])[0], point2[1]);
        } else {
          interpolate2(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
}
function link$1(array2) {
  if (!(n2 = array2.length))
    return;
  var n2, i = 0, a2 = array2[0], b10;
  while (++i < n2) {
    a2.n = b10 = array2[i];
    b10.p = a2;
    a2 = b10;
  }
  a2.n = b10 = array2[0];
  b10.p = a2;
}
function longitude(point2) {
  if (abs$1(point2[0]) <= pi$2)
    return point2[0];
  else
    return sign$1(point2[0]) * ((abs$1(point2[0]) + pi$2) % tau$2 - pi$2);
}
function polygonContains(polygon, point2) {
  var lambda = longitude(point2), phi2 = point2[1], sinPhi = sin$1(phi2), normal2 = [sin$1(lambda), -cos$1(lambda), 0], angle2 = 0, winding = 0;
  var sum2 = new Adder();
  if (sinPhi === 1)
    phi2 = halfPi$1 + epsilon$2;
  else if (sinPhi === -1)
    phi2 = -halfPi$1 - epsilon$2;
  for (var i = 0, n2 = polygon.length; i < n2; ++i) {
    if (!(m2 = (ring = polygon[i]).length))
      continue;
    var ring, m2, point0 = ring[m2 - 1], lambda02 = longitude(point0), phi02 = point0[1] / 2 + quarterPi, sinPhi02 = sin$1(phi02), cosPhi02 = cos$1(phi02);
    for (var j = 0; j < m2; ++j, lambda02 = lambda12, sinPhi02 = sinPhi1, cosPhi02 = cosPhi1, point0 = point1) {
      var point1 = ring[j], lambda12 = longitude(point1), phi12 = point1[1] / 2 + quarterPi, sinPhi1 = sin$1(phi12), cosPhi1 = cos$1(phi12), delta = lambda12 - lambda02, sign2 = delta >= 0 ? 1 : -1, absDelta = sign2 * delta, antimeridian = absDelta > pi$2, k2 = sinPhi02 * sinPhi1;
      sum2.add(atan2$1(k2 * sign2 * sin$1(absDelta), cosPhi02 * cosPhi1 + k2 * cos$1(absDelta)));
      angle2 += antimeridian ? delta + sign2 * tau$2 : delta;
      if (antimeridian ^ lambda02 >= lambda ^ lambda12 >= lambda) {
        var arc2 = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc2);
        var intersection2 = cartesianCross(normal2, arc2);
        cartesianNormalizeInPlace(intersection2);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection2[2]);
        if (phi2 > phiArc || phi2 === phiArc && (arc2[0] || arc2[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle2 < -epsilon$2 || angle2 < epsilon$2 && sum2 < -epsilon2$2) ^ winding & 1;
}
function clip(pointVisible, clipLine2, interpolate2, start2) {
  return function(sink) {
    var line2 = clipLine2(sink), ringBuffer = clipBuffer(), ringSink = clipLine2(ringBuffer), polygonStarted = false, polygon, segments, ring;
    var clip2 = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        clip2.point = pointRing;
        clip2.lineStart = ringStart;
        clip2.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip2.point = point2;
        clip2.lineStart = lineStart;
        clip2.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, start2);
        if (segments.length) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          clipRejoin(segments, compareIntersection, startInside, interpolate2, sink);
        } else if (startInside) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate2(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted)
          sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate2(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point2(lambda, phi2) {
      if (pointVisible(lambda, phi2))
        sink.point(lambda, phi2);
    }
    function pointLine(lambda, phi2) {
      line2.point(lambda, phi2);
    }
    function lineStart() {
      clip2.point = pointLine;
      line2.lineStart();
    }
    function lineEnd() {
      clip2.point = point2;
      line2.lineEnd();
    }
    function pointRing(lambda, phi2) {
      ring.push([lambda, phi2]);
      ringSink.point(lambda, phi2);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n2 = ringSegments.length, m2, segment, point3;
      ring.pop();
      polygon.push(ring);
      ring = null;
      if (!n2)
        return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m2 = segment.length - 1) > 0) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m2; ++i)
            sink.point((point3 = segment[i])[0], point3[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n2 > 1 && clean & 2)
        ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip2;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a2, b10) {
  return ((a2 = a2.x)[0] < 0 ? a2[1] - halfPi$1 - epsilon$2 : halfPi$1 - a2[1]) - ((b10 = b10.x)[0] < 0 ? b10[1] - halfPi$1 - epsilon$2 : halfPi$1 - b10[1]);
}
var clipAntimeridian = clip(
  function() {
    return true;
  },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$2, -halfPi$1]
);
function clipAntimeridianLine(stream) {
  var lambda02 = NaN, phi02 = NaN, sign0 = NaN, clean;
  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda12, phi12) {
      var sign1 = lambda12 > 0 ? pi$2 : -pi$2, delta = abs$1(lambda12 - lambda02);
      if (abs$1(delta - pi$2) < epsilon$2) {
        stream.point(lambda02, phi02 = (phi02 + phi12) / 2 > 0 ? halfPi$1 : -halfPi$1);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        stream.point(lambda12, phi02);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$2) {
        if (abs$1(lambda02 - sign0) < epsilon$2)
          lambda02 -= sign0 * epsilon$2;
        if (abs$1(lambda12 - sign1) < epsilon$2)
          lambda12 -= sign1 * epsilon$2;
        phi02 = clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12);
        stream.point(sign0, phi02);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi02);
        clean = 0;
      }
      stream.point(lambda02 = lambda12, phi02 = phi12);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda02 = phi02 = NaN;
    },
    clean: function() {
      return 2 - clean;
    }
  };
}
function clipAntimeridianIntersect(lambda02, phi02, lambda12, phi12) {
  var cosPhi02, cosPhi1, sinLambda0Lambda1 = sin$1(lambda02 - lambda12);
  return abs$1(sinLambda0Lambda1) > epsilon$2 ? atan((sin$1(phi02) * (cosPhi1 = cos$1(phi12)) * sin$1(lambda12) - sin$1(phi12) * (cosPhi02 = cos$1(phi02)) * sin$1(lambda02)) / (cosPhi02 * cosPhi1 * sinLambda0Lambda1)) : (phi02 + phi12) / 2;
}
function clipAntimeridianInterpolate(from2, to, direction, stream) {
  var phi2;
  if (from2 == null) {
    phi2 = direction * halfPi$1;
    stream.point(-pi$2, phi2);
    stream.point(0, phi2);
    stream.point(pi$2, phi2);
    stream.point(pi$2, 0);
    stream.point(pi$2, -phi2);
    stream.point(0, -phi2);
    stream.point(-pi$2, -phi2);
    stream.point(-pi$2, 0);
    stream.point(-pi$2, phi2);
  } else if (abs$1(from2[0] - to[0]) > epsilon$2) {
    var lambda = from2[0] < to[0] ? pi$2 : -pi$2;
    phi2 = direction * lambda / 2;
    stream.point(-lambda, phi2);
    stream.point(0, phi2);
    stream.point(lambda, phi2);
  } else {
    stream.point(to[0], to[1]);
  }
}
function clipCircle(radius) {
  var cr = cos$1(radius), delta = 6 * radians$1, smallRadius = cr > 0, notHemisphere = abs$1(cr) > epsilon$2;
  function interpolate2(from2, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from2, to);
  }
  function visible(lambda, phi2) {
    return cos$1(lambda) * cos$1(phi2) > cr;
  }
  function clipLine2(stream) {
    var point0, c0, v0, v00, clean;
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi2) {
        var point1 = [lambda, phi2], point2, v2 = visible(lambda, phi2), c2 = smallRadius ? v2 ? 0 : code(lambda, phi2) : v2 ? code(lambda + (lambda < 0 ? pi$2 : -pi$2), phi2) : 0;
        if (!point0 && (v00 = v0 = v2))
          stream.lineStart();
        if (v2 !== v0) {
          point2 = intersect2(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2))
            point1[2] = 1;
        }
        if (v2 !== v0) {
          clean = 0;
          if (v2) {
            stream.lineStart();
            point2 = intersect2(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            point2 = intersect2(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v2) {
          var t4;
          if (!(c2 & c0) && (t4 = intersect2(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t4[0][0], t4[0][1]);
              stream.point(t4[1][0], t4[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t4[1][0], t4[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t4[0][0], t4[0][1], 3);
            }
          }
        }
        if (v2 && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v2, c0 = c2;
      },
      lineEnd: function() {
        if (v0)
          stream.lineEnd();
        point0 = null;
      },
      clean: function() {
        return clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect2(a2, b10, two) {
    var pa = cartesian(a2), pb = cartesian(b10);
    var n1 = [1, 0, 0], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
    if (!determinant)
      return !two && a2;
    var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A5 = cartesianScale(n1, c1), B2 = cartesianScale(n2, c2);
    cartesianAddInPlace(A5, B2);
    var u = n1xn2, w2 = cartesianDot(A5, u), uu = cartesianDot(u, u), t22 = w2 * w2 - uu * (cartesianDot(A5, A5) - 1);
    if (t22 < 0)
      return;
    var t4 = sqrt$2(t22), q2 = cartesianScale(u, (-w2 - t4) / uu);
    cartesianAddInPlace(q2, A5);
    q2 = spherical(q2);
    if (!two)
      return q2;
    var lambda02 = a2[0], lambda12 = b10[0], phi02 = a2[1], phi12 = b10[1], z2;
    if (lambda12 < lambda02)
      z2 = lambda02, lambda02 = lambda12, lambda12 = z2;
    var delta2 = lambda12 - lambda02, polar = abs$1(delta2 - pi$2) < epsilon$2, meridian = polar || delta2 < epsilon$2;
    if (!polar && phi12 < phi02)
      z2 = phi02, phi02 = phi12, phi12 = z2;
    if (meridian ? polar ? phi02 + phi12 > 0 ^ q2[1] < (abs$1(q2[0] - lambda02) < epsilon$2 ? phi02 : phi12) : phi02 <= q2[1] && q2[1] <= phi12 : delta2 > pi$2 ^ (lambda02 <= q2[0] && q2[0] <= lambda12)) {
      var q1 = cartesianScale(u, (-w2 + t4) / uu);
      cartesianAddInPlace(q1, A5);
      return [q2, spherical(q1)];
    }
  }
  function code(lambda, phi2) {
    var r2 = smallRadius ? radius : pi$2 - radius, code2 = 0;
    if (lambda < -r2)
      code2 |= 1;
    else if (lambda > r2)
      code2 |= 2;
    if (phi2 < -r2)
      code2 |= 4;
    else if (phi2 > r2)
      code2 |= 8;
    return code2;
  }
  return clip(visible, clipLine2, interpolate2, smallRadius ? [0, -radius] : [-pi$2, radius - pi$2]);
}
function clipLine(a2, b10, x02, y02, x12, y12) {
  var ax = a2[0], ay = a2[1], bx = b10[0], by = b10[1], t02 = 0, t12 = 1, dx = bx - ax, dy = by - ay, r2;
  r2 = x02 - ax;
  if (!dx && r2 > 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  } else if (dx > 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  }
  r2 = x12 - ax;
  if (!dx && r2 < 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  } else if (dx > 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  }
  r2 = y02 - ay;
  if (!dy && r2 > 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  } else if (dy > 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  }
  r2 = y12 - ay;
  if (!dy && r2 < 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 > t12)
      return;
    if (r2 > t02)
      t02 = r2;
  } else if (dy > 0) {
    if (r2 < t02)
      return;
    if (r2 < t12)
      t12 = r2;
  }
  if (t02 > 0)
    a2[0] = ax + t02 * dx, a2[1] = ay + t02 * dy;
  if (t12 < 1)
    b10[0] = ax + t12 * dx, b10[1] = ay + t12 * dy;
  return true;
}
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x02, y02, x12, y12) {
  function visible(x2, y2) {
    return x02 <= x2 && x2 <= x12 && y02 <= y2 && y2 <= y12;
  }
  function interpolate2(from2, to, direction, stream) {
    var a2 = 0, a1 = 0;
    if (from2 == null || (a2 = corner(from2, direction)) !== (a1 = corner(to, direction)) || comparePoint(from2, to) < 0 ^ direction > 0) {
      do
        stream.point(a2 === 0 || a2 === 3 ? x02 : x12, a2 > 1 ? y12 : y02);
      while ((a2 = (a2 + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }
  function corner(p2, direction) {
    return abs$1(p2[0] - x02) < epsilon$2 ? direction > 0 ? 0 : 3 : abs$1(p2[0] - x12) < epsilon$2 ? direction > 0 ? 2 : 1 : abs$1(p2[1] - y02) < epsilon$2 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection2(a2, b10) {
    return comparePoint(a2.x, b10.x);
  }
  function comparePoint(a2, b10) {
    var ca = corner(a2, 1), cb = corner(b10, 1);
    return ca !== cb ? ca - cb : ca === 0 ? b10[1] - a2[1] : ca === 1 ? a2[0] - b10[0] : ca === 2 ? a2[1] - b10[1] : b10[0] - a2[0];
  }
  return function(stream) {
    var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
    var clipStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart,
      polygonEnd
    };
    function point2(x2, y2) {
      if (visible(x2, y2))
        activeStream.point(x2, y2);
    }
    function polygonInside() {
      var winding = 0;
      for (var i = 0, n2 = polygon.length; i < n2; ++i) {
        for (var ring2 = polygon[i], j = 1, m2 = ring2.length, point3 = ring2[0], a0, a1, b02 = point3[0], b12 = point3[1]; j < m2; ++j) {
          a0 = b02, a1 = b12, point3 = ring2[j], b02 = point3[0], b12 = point3[1];
          if (a1 <= y12) {
            if (b12 > y12 && (b02 - a0) * (y12 - a1) > (b12 - a1) * (x02 - a0))
              ++winding;
          } else {
            if (b12 <= y12 && (b02 - a0) * (y12 - a1) < (b12 - a1) * (x02 - a0))
              --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = merge(segments)).length;
      if (cleanInside || visible2) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate2(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible2) {
          clipRejoin(segments, compareIntersection2, startInside, interpolate2, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint2;
      if (polygon)
        polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint2(x__, y__);
        if (v__ && v_)
          bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point2;
      if (v_)
        activeStream.lineEnd();
    }
    function linePoint2(x2, y2) {
      var v2 = visible(x2, y2);
      if (polygon)
        ring.push([x2, y2]);
      if (first) {
        x__ = x2, y__ = y2, v__ = v2;
        first = false;
        if (v2) {
          activeStream.lineStart();
          activeStream.point(x2, y2);
        }
      } else {
        if (v2 && v_)
          activeStream.point(x2, y2);
        else {
          var a2 = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b10 = [x2 = Math.max(clipMin, Math.min(clipMax, x2)), y2 = Math.max(clipMin, Math.min(clipMax, y2))];
          if (clipLine(a2, b10, x02, y02, x12, y12)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a2[0], a2[1]);
            }
            activeStream.point(b10[0], b10[1]);
            if (!v2)
              activeStream.lineEnd();
            clean = false;
          } else if (v2) {
            activeStream.lineStart();
            activeStream.point(x2, y2);
            clean = false;
          }
        }
      }
      x_ = x2, y_ = y2, v_ = v2;
    }
    return clipStream;
  };
}
function extent() {
  var x02 = 0, y02 = 0, x12 = 960, y12 = 500, cache2, cacheStream, clip2;
  return clip2 = {
    stream: function(stream) {
      return cache2 && cacheStream === stream ? cache2 : cache2 = clipRectangle(x02, y02, x12, y12)(cacheStream = stream);
    },
    extent: function(_2) {
      return arguments.length ? (x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1], cache2 = cacheStream = null, clip2) : [[x02, y02], [x12, y12]];
    }
  };
}
var lengthSum$1, lambda0, sinPhi0, cosPhi0;
var lengthStream$1 = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};
function lengthLineStart() {
  lengthStream$1.point = lengthPointFirst$1;
  lengthStream$1.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
  lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
}
function lengthPointFirst$1(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  lambda0 = lambda, sinPhi0 = sin$1(phi2), cosPhi0 = cos$1(phi2);
  lengthStream$1.point = lengthPoint$1;
}
function lengthPoint$1(lambda, phi2) {
  lambda *= radians$1, phi2 *= radians$1;
  var sinPhi = sin$1(phi2), cosPhi = cos$1(phi2), delta = abs$1(lambda - lambda0), cosDelta = cos$1(delta), sinDelta = sin$1(delta), x2 = cosPhi * sinDelta, y2 = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z2 = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum$1.add(atan2$1(sqrt$2(x2 * x2 + y2 * y2), z2));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}
function length$1(object2) {
  lengthSum$1 = new Adder();
  geoStream(object2, lengthStream$1);
  return +lengthSum$1;
}
var coordinates = [null, null], object$1 = { type: "LineString", coordinates };
function distance(a2, b10) {
  coordinates[0] = a2;
  coordinates[1] = b10;
  return length$1(object$1);
}
var containsObjectType = {
  Feature: function(object2, point2) {
    return containsGeometry(object2.geometry, point2);
  },
  FeatureCollection: function(object2, point2) {
    var features = object2.features, i = -1, n2 = features.length;
    while (++i < n2)
      if (containsGeometry(features[i].geometry, point2))
        return true;
    return false;
  }
};
var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object2, point2) {
    return containsPoint(object2.coordinates, point2);
  },
  MultiPoint: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      if (containsPoint(coordinates2[i], point2))
        return true;
    return false;
  },
  LineString: function(object2, point2) {
    return containsLine(object2.coordinates, point2);
  },
  MultiLineString: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      if (containsLine(coordinates2[i], point2))
        return true;
    return false;
  },
  Polygon: function(object2, point2) {
    return containsPolygon(object2.coordinates, point2);
  },
  MultiPolygon: function(object2, point2) {
    var coordinates2 = object2.coordinates, i = -1, n2 = coordinates2.length;
    while (++i < n2)
      if (containsPolygon(coordinates2[i], point2))
        return true;
    return false;
  },
  GeometryCollection: function(object2, point2) {
    var geometries = object2.geometries, i = -1, n2 = geometries.length;
    while (++i < n2)
      if (containsGeometry(geometries[i], point2))
        return true;
    return false;
  }
};
function containsGeometry(geometry, point2) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point2) : false;
}
function containsPoint(coordinates2, point2) {
  return distance(coordinates2, point2) === 0;
}
function containsLine(coordinates2, point2) {
  var ao, bo, ab;
  for (var i = 0, n2 = coordinates2.length; i < n2; i++) {
    bo = distance(coordinates2[i], point2);
    if (bo === 0)
      return true;
    if (i > 0) {
      ab = distance(coordinates2[i], coordinates2[i - 1]);
      if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2$2 * ab)
        return true;
    }
    ao = bo;
  }
  return false;
}
function containsPolygon(coordinates2, point2) {
  return !!polygonContains(coordinates2.map(ringRadians), pointRadians(point2));
}
function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point2) {
  return [point2[0] * radians$1, point2[1] * radians$1];
}
function contains$1(object2, point2) {
  return (object2 && containsObjectType.hasOwnProperty(object2.type) ? containsObjectType[object2.type] : containsGeometry)(object2, point2);
}
function graticuleX(y02, y12, dy) {
  var y2 = sequence(y02, y12 - epsilon$2, dy).concat(y12);
  return function(x2) {
    return y2.map(function(y3) {
      return [x2, y3];
    });
  };
}
function graticuleY(x02, x12, dx) {
  var x2 = sequence(x02, x12 - epsilon$2, dx).concat(x12);
  return function(y2) {
    return x2.map(function(x3) {
      return [x3, y2];
    });
  };
}
function graticule() {
  var x12, x02, X12, X02, y12, y02, Y12, Y02, dx = 10, dy = dx, DX = 90, DY = 360, x2, y2, X3, Y3, precision = 2.5;
  function graticule2() {
    return { type: "MultiLineString", coordinates: lines() };
  }
  function lines() {
    return sequence(ceil(X02 / DX) * DX, X12, DX).map(X3).concat(sequence(ceil(Y02 / DY) * DY, Y12, DY).map(Y3)).concat(sequence(ceil(x02 / dx) * dx, x12, dx).filter(function(x3) {
      return abs$1(x3 % DX) > epsilon$2;
    }).map(x2)).concat(sequence(ceil(y02 / dy) * dy, y12, dy).filter(function(y3) {
      return abs$1(y3 % DY) > epsilon$2;
    }).map(y2));
  }
  graticule2.lines = function() {
    return lines().map(function(coordinates2) {
      return { type: "LineString", coordinates: coordinates2 };
    });
  };
  graticule2.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X3(X02).concat(
          Y3(Y12).slice(1),
          X3(X12).reverse().slice(1),
          Y3(Y02).reverse().slice(1)
        )
      ]
    };
  };
  graticule2.extent = function(_2) {
    if (!arguments.length)
      return graticule2.extentMinor();
    return graticule2.extentMajor(_2).extentMinor(_2);
  };
  graticule2.extentMajor = function(_2) {
    if (!arguments.length)
      return [[X02, Y02], [X12, Y12]];
    X02 = +_2[0][0], X12 = +_2[1][0];
    Y02 = +_2[0][1], Y12 = +_2[1][1];
    if (X02 > X12)
      _2 = X02, X02 = X12, X12 = _2;
    if (Y02 > Y12)
      _2 = Y02, Y02 = Y12, Y12 = _2;
    return graticule2.precision(precision);
  };
  graticule2.extentMinor = function(_2) {
    if (!arguments.length)
      return [[x02, y02], [x12, y12]];
    x02 = +_2[0][0], x12 = +_2[1][0];
    y02 = +_2[0][1], y12 = +_2[1][1];
    if (x02 > x12)
      _2 = x02, x02 = x12, x12 = _2;
    if (y02 > y12)
      _2 = y02, y02 = y12, y12 = _2;
    return graticule2.precision(precision);
  };
  graticule2.step = function(_2) {
    if (!arguments.length)
      return graticule2.stepMinor();
    return graticule2.stepMajor(_2).stepMinor(_2);
  };
  graticule2.stepMajor = function(_2) {
    if (!arguments.length)
      return [DX, DY];
    DX = +_2[0], DY = +_2[1];
    return graticule2;
  };
  graticule2.stepMinor = function(_2) {
    if (!arguments.length)
      return [dx, dy];
    dx = +_2[0], dy = +_2[1];
    return graticule2;
  };
  graticule2.precision = function(_2) {
    if (!arguments.length)
      return precision;
    precision = +_2;
    x2 = graticuleX(y02, y12, 90);
    y2 = graticuleY(x02, x12, precision);
    X3 = graticuleX(Y02, Y12, 90);
    Y3 = graticuleY(X02, X12, precision);
    return graticule2;
  };
  return graticule2.extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]]).extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}
function graticule10() {
  return graticule()();
}
function interpolate$1(a2, b10) {
  var x02 = a2[0] * radians$1, y02 = a2[1] * radians$1, x12 = b10[0] * radians$1, y12 = b10[1] * radians$1, cy0 = cos$1(y02), sy0 = sin$1(y02), cy1 = cos$1(y12), sy1 = sin$1(y12), kx0 = cy0 * cos$1(x02), ky0 = cy0 * sin$1(x02), kx1 = cy1 * cos$1(x12), ky1 = cy1 * sin$1(x12), d2 = 2 * asin$1(sqrt$2(haversin(y12 - y02) + cy0 * cy1 * haversin(x12 - x02))), k2 = sin$1(d2);
  var interpolate2 = d2 ? function(t4) {
    var B2 = sin$1(t4 *= d2) / k2, A5 = sin$1(d2 - t4) / k2, x2 = A5 * kx0 + B2 * kx1, y2 = A5 * ky0 + B2 * ky1, z2 = A5 * sy0 + B2 * sy1;
    return [
      atan2$1(y2, x2) * degrees$2,
      atan2$1(z2, sqrt$2(x2 * x2 + y2 * y2)) * degrees$2
    ];
  } : function() {
    return [x02 * degrees$2, y02 * degrees$2];
  };
  interpolate2.distance = d2;
  return interpolate2;
}
var identity$7 = (x2) => x2;
var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
    areaSum.add(abs$1(areaRingSum));
    areaRingSum = new Adder();
  },
  result: function() {
    var area2 = areaSum / 2;
    areaSum = new Adder();
    return area2;
  }
};
function areaRingStart() {
  areaStream.point = areaPointFirst;
}
function areaPointFirst(x2, y2) {
  areaStream.point = areaPoint;
  x00$2 = x0$3 = x2, y00$2 = y0$3 = y2;
}
function areaPoint(x2, y2) {
  areaRingSum.add(y0$3 * x2 - x0$3 * y2);
  x0$3 = x2, y0$3 = y2;
}
function areaRingEnd() {
  areaPoint(x00$2, y00$2);
}
var pathArea = areaStream;
var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds2 = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds2;
  }
};
function boundsPoint(x2, y2) {
  if (x2 < x0$2)
    x0$2 = x2;
  if (x2 > x1)
    x1 = x2;
  if (y2 < y0$2)
    y0$2 = y2;
  if (y2 > y1)
    y1 = y2;
}
var boundsStream$1 = boundsStream;
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid2 = Z2 ? [X2 / Z2, Y2 / Z2] : Z1 ? [X1 / Z1, Y1 / Z1] : Z0 ? [X0 / Z0, Y0 / Z0] : [NaN, NaN];
    X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
    return centroid2;
  }
};
function centroidPoint(x2, y2) {
  X0 += x2;
  Y0 += y2;
  ++Z0;
}
function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x2, y2) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0$1 = x2, y0$1 = y2);
}
function centroidPointLine(x2, y2) {
  var dx = x2 - x0$1, dy = y2 - y0$1, z2 = sqrt$2(dx * dx + dy * dy);
  X1 += z2 * (x0$1 + x2) / 2;
  Y1 += z2 * (y0$1 + y2) / 2;
  Z1 += z2;
  centroidPoint(x0$1 = x2, y0$1 = y2);
}
function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}
function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
  centroidPointRing(x00$1, y00$1);
}
function centroidPointFirstRing(x2, y2) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00$1 = x0$1 = x2, y00$1 = y0$1 = y2);
}
function centroidPointRing(x2, y2) {
  var dx = x2 - x0$1, dy = y2 - y0$1, z2 = sqrt$2(dx * dx + dy * dy);
  X1 += z2 * (x0$1 + x2) / 2;
  Y1 += z2 * (y0$1 + y2) / 2;
  Z1 += z2;
  z2 = y0$1 * x2 - x0$1 * y2;
  X2 += z2 * (x0$1 + x2);
  Y2 += z2 * (y0$1 + y2);
  Z2 += z2 * 3;
  centroidPoint(x0$1 = x2, y0$1 = y2);
}
var pathCentroid = centroidStream;
function PathContext(context) {
  this._context = context;
}
PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_2) {
    return this._radius = _2, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0)
      this._context.closePath();
    this._point = NaN;
  },
  point: function(x2, y2) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x2, y2);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x2, y2);
        break;
      }
      default: {
        this._context.moveTo(x2 + this._radius, y2);
        this._context.arc(x2, y2, this._radius, 0, tau$2);
        break;
      }
    }
  },
  result: noop$1
};
var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
  point: noop$1,
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing)
      lengthPoint(x00, y00);
    lengthStream.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length2 = +lengthSum;
    lengthSum = new Adder();
    return length2;
  }
};
function lengthPointFirst(x2, y2) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x2, y00 = y0 = y2;
}
function lengthPoint(x2, y2) {
  x0 -= x2, y0 -= y2;
  lengthSum.add(sqrt$2(x0 * x0 + y0 * y0));
  x0 = x2, y0 = y2;
}
var pathMeasure = lengthStream;
function PathString() {
  this._string = [];
}
PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_2) {
    if ((_2 = +_2) !== this._radius)
      this._radius = _2, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0)
      this._string.push("Z");
    this._point = NaN;
  },
  point: function(x2, y2) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x2, ",", y2);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x2, ",", y2);
        break;
      }
      default: {
        if (this._circle == null)
          this._circle = circle$1(this._radius);
        this._string.push("M", x2, ",", y2, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};
function circle$1(radius) {
  return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}
function index$2(projection2, context) {
  var pointRadius = 4.5, projectionStream, contextStream;
  function path2(object2) {
    if (object2) {
      if (typeof pointRadius === "function")
        contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object2, projectionStream(contextStream));
    }
    return contextStream.result();
  }
  path2.area = function(object2) {
    geoStream(object2, projectionStream(pathArea));
    return pathArea.result();
  };
  path2.measure = function(object2) {
    geoStream(object2, projectionStream(pathMeasure));
    return pathMeasure.result();
  };
  path2.bounds = function(object2) {
    geoStream(object2, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };
  path2.centroid = function(object2) {
    geoStream(object2, projectionStream(pathCentroid));
    return pathCentroid.result();
  };
  path2.projection = function(_2) {
    return arguments.length ? (projectionStream = _2 == null ? (projection2 = null, identity$7) : (projection2 = _2).stream, path2) : projection2;
  };
  path2.context = function(_2) {
    if (!arguments.length)
      return context;
    contextStream = _2 == null ? (context = null, new PathString()) : new PathContext(context = _2);
    if (typeof pointRadius !== "function")
      contextStream.pointRadius(pointRadius);
    return path2;
  };
  path2.pointRadius = function(_2) {
    if (!arguments.length)
      return pointRadius;
    pointRadius = typeof _2 === "function" ? _2 : (contextStream.pointRadius(+_2), +_2);
    return path2;
  };
  return path2.projection(projection2).context(context);
}
function transform$1(methods) {
  return {
    stream: transformer$3(methods)
  };
}
function transformer$3(methods) {
  return function(stream) {
    var s2 = new TransformStream();
    for (var key in methods)
      s2[key] = methods[key];
    s2.stream = stream;
    return s2;
  };
}
function TransformStream() {
}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x2, y2) {
    this.stream.point(x2, y2);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fit(projection2, fitBounds, object2) {
  var clip2 = projection2.clipExtent && projection2.clipExtent();
  projection2.scale(150).translate([0, 0]);
  if (clip2 != null)
    projection2.clipExtent(null);
  geoStream(object2, projection2.stream(boundsStream$1));
  fitBounds(boundsStream$1.result());
  if (clip2 != null)
    projection2.clipExtent(clip2);
  return projection2;
}
function fitExtent(projection2, extent2, object2) {
  return fit(projection2, function(b10) {
    var w2 = extent2[1][0] - extent2[0][0], h2 = extent2[1][1] - extent2[0][1], k2 = Math.min(w2 / (b10[1][0] - b10[0][0]), h2 / (b10[1][1] - b10[0][1])), x2 = +extent2[0][0] + (w2 - k2 * (b10[1][0] + b10[0][0])) / 2, y2 = +extent2[0][1] + (h2 - k2 * (b10[1][1] + b10[0][1])) / 2;
    projection2.scale(150 * k2).translate([x2, y2]);
  }, object2);
}
function fitSize(projection2, size, object2) {
  return fitExtent(projection2, [[0, 0], size], object2);
}
function fitWidth(projection2, width2, object2) {
  return fit(projection2, function(b10) {
    var w2 = +width2, k2 = w2 / (b10[1][0] - b10[0][0]), x2 = (w2 - k2 * (b10[1][0] + b10[0][0])) / 2, y2 = -k2 * b10[0][1];
    projection2.scale(150 * k2).translate([x2, y2]);
  }, object2);
}
function fitHeight(projection2, height2, object2) {
  return fit(projection2, function(b10) {
    var h2 = +height2, k2 = h2 / (b10[1][1] - b10[0][1]), x2 = -k2 * b10[0][0], y2 = (h2 - k2 * (b10[1][1] + b10[0][1])) / 2;
    projection2.scale(150 * k2).translate([x2, y2]);
  }, object2);
}
var maxDepth = 16, cosMinDistance = cos$1(30 * radians$1);
function resample(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
}
function resampleNone(project) {
  return transformer$3({
    point: function(x2, y2) {
      x2 = project(x2, y2);
      this.stream.point(x2[0], x2[1]);
    }
  });
}
function resample$1(project, delta2) {
  function resampleLineTo(x02, y02, lambda02, a0, b02, c0, x12, y12, lambda12, a1, b12, c1, depth, stream) {
    var dx = x12 - x02, dy = y12 - y02, d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a2 = a0 + a1, b10 = b02 + b12, c2 = c0 + c1, m2 = sqrt$2(a2 * a2 + b10 * b10 + c2 * c2), phi2 = asin$1(c2 /= m2), lambda22 = abs$1(abs$1(c2) - 1) < epsilon$2 || abs$1(lambda02 - lambda12) < epsilon$2 ? (lambda02 + lambda12) / 2 : atan2$1(b10, a2), p2 = project(lambda22, phi2), x2 = p2[0], y2 = p2[1], dx2 = x2 - x02, dy2 = y2 - y02, dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b02 * b12 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x02, y02, lambda02, a0, b02, c0, x2, y2, lambda22, a2 /= m2, b10 /= m2, c2, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda22, a2, b10, c2, x12, y12, lambda12, a1, b12, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda002, x002, y002, a00, b00, c00, lambda02, x02, y02, a0, b02, c0;
    var resampleStream = {
      point: point2,
      lineStart,
      lineEnd,
      polygonStart: function() {
        stream.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function() {
        stream.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point2(x2, y2) {
      x2 = project(x2, y2);
      stream.point(x2[0], x2[1]);
    }
    function lineStart() {
      x02 = NaN;
      resampleStream.point = linePoint2;
      stream.lineStart();
    }
    function linePoint2(lambda, phi2) {
      var c2 = cartesian([lambda, phi2]), p2 = project(lambda, phi2);
      resampleLineTo(x02, y02, lambda02, a0, b02, c0, x02 = p2[0], y02 = p2[1], lambda02 = lambda, a0 = c2[0], b02 = c2[1], c0 = c2[2], maxDepth, stream);
      stream.point(x02, y02);
    }
    function lineEnd() {
      resampleStream.point = point2;
      stream.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi2) {
      linePoint2(lambda002 = lambda, phi2), x002 = x02, y002 = y02, a00 = a0, b00 = b02, c00 = c0;
      resampleStream.point = linePoint2;
    }
    function ringEnd() {
      resampleLineTo(x02, y02, lambda02, a0, b02, c0, x002, y002, lambda002, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}
var transformRadians = transformer$3({
  point: function(x2, y2) {
    this.stream.point(x2 * radians$1, y2 * radians$1);
  }
});
function transformRotate(rotate) {
  return transformer$3({
    point: function(x2, y2) {
      var r2 = rotate(x2, y2);
      return this.stream.point(r2[0], r2[1]);
    }
  });
}
function scaleTranslate(k2, dx, dy, sx, sy) {
  function transform2(x2, y2) {
    x2 *= sx;
    y2 *= sy;
    return [dx + k2 * x2, dy - k2 * y2];
  }
  transform2.invert = function(x2, y2) {
    return [(x2 - dx) / k2 * sx, (dy - y2) / k2 * sy];
  };
  return transform2;
}
function scaleTranslateRotate(k2, dx, dy, sx, sy, alpha2) {
  if (!alpha2)
    return scaleTranslate(k2, dx, dy, sx, sy);
  var cosAlpha = cos$1(alpha2), sinAlpha = sin$1(alpha2), a2 = cosAlpha * k2, b10 = sinAlpha * k2, ai = cosAlpha / k2, bi = sinAlpha / k2, ci = (sinAlpha * dy - cosAlpha * dx) / k2, fi = (sinAlpha * dx + cosAlpha * dy) / k2;
  function transform2(x2, y2) {
    x2 *= sx;
    y2 *= sy;
    return [a2 * x2 - b10 * y2 + dx, dy - b10 * x2 - a2 * y2];
  }
  transform2.invert = function(x2, y2) {
    return [sx * (ai * x2 - bi * y2 + ci), sy * (fi - bi * x2 - ai * y2)];
  };
  return transform2;
}
function projection(project) {
  return projectionMutator(function() {
    return project;
  })();
}
function projectionMutator(projectAt) {
  var project, k2 = 150, x2 = 480, y2 = 250, lambda = 0, phi2 = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha2 = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x02 = null, y02, x12, y12, postclip = identity$7, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache2, cacheStream;
  function projection2(point2) {
    return projectRotateTransform(point2[0] * radians$1, point2[1] * radians$1);
  }
  function invert(point2) {
    point2 = projectRotateTransform.invert(point2[0], point2[1]);
    return point2 && [point2[0] * degrees$2, point2[1] * degrees$2];
  }
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };
  projection2.preclip = function(_2) {
    return arguments.length ? (preclip = _2, theta = void 0, reset()) : preclip;
  };
  projection2.postclip = function(_2) {
    return arguments.length ? (postclip = _2, x02 = y02 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipAngle = function(_2) {
    return arguments.length ? (preclip = +_2 ? clipCircle(theta = _2 * radians$1) : (theta = null, clipAntimeridian), reset()) : theta * degrees$2;
  };
  projection2.clipExtent = function(_2) {
    return arguments.length ? (postclip = _2 == null ? (x02 = y02 = x12 = y12 = null, identity$7) : clipRectangle(x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1]), reset()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_2) {
    return arguments.length ? (k2 = +_2, recenter()) : k2;
  };
  projection2.translate = function(_2) {
    return arguments.length ? (x2 = +_2[0], y2 = +_2[1], recenter()) : [x2, y2];
  };
  projection2.center = function(_2) {
    return arguments.length ? (lambda = _2[0] % 360 * radians$1, phi2 = _2[1] % 360 * radians$1, recenter()) : [lambda * degrees$2, phi2 * degrees$2];
  };
  projection2.rotate = function(_2) {
    return arguments.length ? (deltaLambda = _2[0] % 360 * radians$1, deltaPhi = _2[1] % 360 * radians$1, deltaGamma = _2.length > 2 ? _2[2] % 360 * radians$1 : 0, recenter()) : [deltaLambda * degrees$2, deltaPhi * degrees$2, deltaGamma * degrees$2];
  };
  projection2.angle = function(_2) {
    return arguments.length ? (alpha2 = _2 % 360 * radians$1, recenter()) : alpha2 * degrees$2;
  };
  projection2.reflectX = function(_2) {
    return arguments.length ? (sx = _2 ? -1 : 1, recenter()) : sx < 0;
  };
  projection2.reflectY = function(_2) {
    return arguments.length ? (sy = _2 ? -1 : 1, recenter()) : sy < 0;
  };
  projection2.precision = function(_2) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _2 * _2), reset()) : sqrt$2(delta2);
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width2, object2) {
    return fitWidth(projection2, width2, object2);
  };
  projection2.fitHeight = function(height2, object2) {
    return fitHeight(projection2, height2, object2);
  };
  function recenter() {
    var center2 = scaleTranslateRotate(k2, 0, 0, sx, sy, alpha2).apply(null, project(lambda, phi2)), transform2 = scaleTranslateRotate(k2, x2 - center2[0], y2 - center2[1], sx, sy, alpha2);
    rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = compose(project, transform2);
    projectRotateTransform = compose(rotate, projectTransform);
    projectResample = resample(projectTransform, delta2);
    return reset();
  }
  function reset() {
    cache2 = cacheStream = null;
    return projection2;
  }
  return function() {
    project = projectAt.apply(this, arguments);
    projection2.invert = project.invert && invert;
    return recenter();
  };
}
function conicProjection(projectAt) {
  var phi02 = 0, phi12 = pi$2 / 3, m2 = projectionMutator(projectAt), p2 = m2(phi02, phi12);
  p2.parallels = function(_2) {
    return arguments.length ? m2(phi02 = _2[0] * radians$1, phi12 = _2[1] * radians$1) : [phi02 * degrees$2, phi12 * degrees$2];
  };
  return p2;
}
function cylindricalEqualAreaRaw(phi02) {
  var cosPhi02 = cos$1(phi02);
  function forward(lambda, phi2) {
    return [lambda * cosPhi02, sin$1(phi2) / cosPhi02];
  }
  forward.invert = function(x2, y2) {
    return [x2 / cosPhi02, asin$1(y2 * cosPhi02)];
  };
  return forward;
}
function conicEqualAreaRaw(y02, y12) {
  var sy0 = sin$1(y02), n2 = (sy0 + sin$1(y12)) / 2;
  if (abs$1(n2) < epsilon$2)
    return cylindricalEqualAreaRaw(y02);
  var c2 = 1 + sy0 * (2 * n2 - sy0), r0 = sqrt$2(c2) / n2;
  function project(x2, y2) {
    var r2 = sqrt$2(c2 - 2 * n2 * sin$1(y2)) / n2;
    return [r2 * sin$1(x2 *= n2), r0 - r2 * cos$1(x2)];
  }
  project.invert = function(x2, y2) {
    var r0y = r0 - y2, l2 = atan2$1(x2, abs$1(r0y)) * sign$1(r0y);
    if (r0y * n2 < 0)
      l2 -= pi$2 * sign$1(x2) * sign$1(r0y);
    return [l2 / n2, asin$1((c2 - (x2 * x2 + r0y * r0y) * n2 * n2) / (2 * n2))];
  };
  return project;
}
function conicEqualArea() {
  return conicProjection(conicEqualAreaRaw).scale(155.424).center([0, 33.6442]);
}
function albers() {
  return conicEqualArea().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function multiplex(streams) {
  var n2 = streams.length;
  return {
    point: function(x2, y2) {
      var i = -1;
      while (++i < n2)
        streams[i].point(x2, y2);
    },
    sphere: function() {
      var i = -1;
      while (++i < n2)
        streams[i].sphere();
    },
    lineStart: function() {
      var i = -1;
      while (++i < n2)
        streams[i].lineStart();
    },
    lineEnd: function() {
      var i = -1;
      while (++i < n2)
        streams[i].lineEnd();
    },
    polygonStart: function() {
      var i = -1;
      while (++i < n2)
        streams[i].polygonStart();
    },
    polygonEnd: function() {
      var i = -1;
      while (++i < n2)
        streams[i].polygonEnd();
    }
  };
}
function albersUsa() {
  var cache2, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, point2, pointStream = { point: function(x2, y2) {
    point2 = [x2, y2];
  } };
  function albersUsa2(coordinates2) {
    var x2 = coordinates2[0], y2 = coordinates2[1];
    return point2 = null, (lower48Point.point(x2, y2), point2) || (alaskaPoint.point(x2, y2), point2) || (hawaiiPoint.point(x2, y2), point2);
  }
  albersUsa2.invert = function(coordinates2) {
    var k2 = lower48.scale(), t4 = lower48.translate(), x2 = (coordinates2[0] - t4[0]) / k2, y2 = (coordinates2[1] - t4[1]) / k2;
    return (y2 >= 0.12 && y2 < 0.234 && x2 >= -0.425 && x2 < -0.214 ? alaska : y2 >= 0.166 && y2 < 0.234 && x2 >= -0.214 && x2 < -0.115 ? hawaii : lower48).invert(coordinates2);
  };
  albersUsa2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };
  albersUsa2.precision = function(_2) {
    if (!arguments.length)
      return lower48.precision();
    lower48.precision(_2), alaska.precision(_2), hawaii.precision(_2);
    return reset();
  };
  albersUsa2.scale = function(_2) {
    if (!arguments.length)
      return lower48.scale();
    lower48.scale(_2), alaska.scale(_2 * 0.35), hawaii.scale(_2);
    return albersUsa2.translate(lower48.translate());
  };
  albersUsa2.translate = function(_2) {
    if (!arguments.length)
      return lower48.translate();
    var k2 = lower48.scale(), x2 = +_2[0], y2 = +_2[1];
    lower48Point = lower48.translate(_2).clipExtent([[x2 - 0.455 * k2, y2 - 0.238 * k2], [x2 + 0.455 * k2, y2 + 0.238 * k2]]).stream(pointStream);
    alaskaPoint = alaska.translate([x2 - 0.307 * k2, y2 + 0.201 * k2]).clipExtent([[x2 - 0.425 * k2 + epsilon$2, y2 + 0.12 * k2 + epsilon$2], [x2 - 0.214 * k2 - epsilon$2, y2 + 0.234 * k2 - epsilon$2]]).stream(pointStream);
    hawaiiPoint = hawaii.translate([x2 - 0.205 * k2, y2 + 0.212 * k2]).clipExtent([[x2 - 0.214 * k2 + epsilon$2, y2 + 0.166 * k2 + epsilon$2], [x2 - 0.115 * k2 - epsilon$2, y2 + 0.234 * k2 - epsilon$2]]).stream(pointStream);
    return reset();
  };
  albersUsa2.fitExtent = function(extent2, object2) {
    return fitExtent(albersUsa2, extent2, object2);
  };
  albersUsa2.fitSize = function(size, object2) {
    return fitSize(albersUsa2, size, object2);
  };
  albersUsa2.fitWidth = function(width2, object2) {
    return fitWidth(albersUsa2, width2, object2);
  };
  albersUsa2.fitHeight = function(height2, object2) {
    return fitHeight(albersUsa2, height2, object2);
  };
  function reset() {
    cache2 = cacheStream = null;
    return albersUsa2;
  }
  return albersUsa2.scale(1070);
}
function azimuthalRaw(scale) {
  return function(x2, y2) {
    var cx2 = cos$1(x2), cy = cos$1(y2), k2 = scale(cx2 * cy);
    if (k2 === Infinity)
      return [2, 0];
    return [
      k2 * cy * sin$1(x2),
      k2 * sin$1(y2)
    ];
  };
}
function azimuthalInvert(angle2) {
  return function(x2, y2) {
    var z2 = sqrt$2(x2 * x2 + y2 * y2), c2 = angle2(z2), sc = sin$1(c2), cc = cos$1(c2);
    return [
      atan2$1(x2 * sc, z2 * cc),
      asin$1(z2 && y2 * sc / z2)
    ];
  };
}
var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt$2(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z2) {
  return 2 * asin$1(z2 / 2);
});
function azimuthalEqualArea() {
  return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(180 - 1e-3);
}
var azimuthalEquidistantRaw = azimuthalRaw(function(c2) {
  return (c2 = acos$1(c2)) && c2 / sin$1(c2);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function(z2) {
  return z2;
});
function azimuthalEquidistant() {
  return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
function mercatorRaw(lambda, phi2) {
  return [lambda, log$1(tan((halfPi$1 + phi2) / 2))];
}
mercatorRaw.invert = function(x2, y2) {
  return [x2, 2 * atan(exp(y2)) - halfPi$1];
};
function mercator() {
  return mercatorProjection(mercatorRaw).scale(961 / tau$2);
}
function mercatorProjection(project) {
  var m2 = projection(project), center2 = m2.center, scale = m2.scale, translate = m2.translate, clipExtent = m2.clipExtent, x02 = null, y02, x12, y12;
  m2.scale = function(_2) {
    return arguments.length ? (scale(_2), reclip()) : scale();
  };
  m2.translate = function(_2) {
    return arguments.length ? (translate(_2), reclip()) : translate();
  };
  m2.center = function(_2) {
    return arguments.length ? (center2(_2), reclip()) : center2();
  };
  m2.clipExtent = function(_2) {
    return arguments.length ? (_2 == null ? x02 = y02 = x12 = y12 = null : (x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1]), reclip()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  function reclip() {
    var k2 = pi$2 * scale(), t4 = m2(rotation(m2.rotate()).invert([0, 0]));
    return clipExtent(x02 == null ? [[t4[0] - k2, t4[1] - k2], [t4[0] + k2, t4[1] + k2]] : project === mercatorRaw ? [[Math.max(t4[0] - k2, x02), y02], [Math.min(t4[0] + k2, x12), y12]] : [[x02, Math.max(t4[1] - k2, y02)], [x12, Math.min(t4[1] + k2, y12)]]);
  }
  return reclip();
}
function tany(y2) {
  return tan((halfPi$1 + y2) / 2);
}
function conicConformalRaw(y02, y12) {
  var cy0 = cos$1(y02), n2 = y02 === y12 ? sin$1(y02) : log$1(cy0 / cos$1(y12)) / log$1(tany(y12) / tany(y02)), f2 = cy0 * pow$1(tany(y02), n2) / n2;
  if (!n2)
    return mercatorRaw;
  function project(x2, y2) {
    if (f2 > 0) {
      if (y2 < -halfPi$1 + epsilon$2)
        y2 = -halfPi$1 + epsilon$2;
    } else {
      if (y2 > halfPi$1 - epsilon$2)
        y2 = halfPi$1 - epsilon$2;
    }
    var r2 = f2 / pow$1(tany(y2), n2);
    return [r2 * sin$1(n2 * x2), f2 - r2 * cos$1(n2 * x2)];
  }
  project.invert = function(x2, y2) {
    var fy = f2 - y2, r2 = sign$1(n2) * sqrt$2(x2 * x2 + fy * fy), l2 = atan2$1(x2, abs$1(fy)) * sign$1(fy);
    if (fy * n2 < 0)
      l2 -= pi$2 * sign$1(x2) * sign$1(fy);
    return [l2 / n2, 2 * atan(pow$1(f2 / r2, 1 / n2)) - halfPi$1];
  };
  return project;
}
function conicConformal() {
  return conicProjection(conicConformalRaw).scale(109.5).parallels([30, 30]);
}
function equirectangularRaw(lambda, phi2) {
  return [lambda, phi2];
}
equirectangularRaw.invert = equirectangularRaw;
function equirectangular() {
  return projection(equirectangularRaw).scale(152.63);
}
function conicEquidistantRaw(y02, y12) {
  var cy0 = cos$1(y02), n2 = y02 === y12 ? sin$1(y02) : (cy0 - cos$1(y12)) / (y12 - y02), g2 = cy0 / n2 + y02;
  if (abs$1(n2) < epsilon$2)
    return equirectangularRaw;
  function project(x2, y2) {
    var gy = g2 - y2, nx = n2 * x2;
    return [gy * sin$1(nx), g2 - gy * cos$1(nx)];
  }
  project.invert = function(x2, y2) {
    var gy = g2 - y2, l2 = atan2$1(x2, abs$1(gy)) * sign$1(gy);
    if (gy * n2 < 0)
      l2 -= pi$2 * sign$1(x2) * sign$1(gy);
    return [l2 / n2, g2 - sign$1(n2) * sqrt$2(x2 * x2 + gy * gy)];
  };
  return project;
}
function conicEquidistant() {
  return conicProjection(conicEquidistantRaw).scale(131.154).center([0, 13.9389]);
}
var A1 = 1.340264, A2 = -0.081106, A3 = 893e-6, A4 = 3796e-6, M = sqrt$2(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi2) {
  var l2 = asin$1(M * sin$1(phi2)), l22 = l2 * l2, l6 = l22 * l22 * l22;
  return [
    lambda * cos$1(l2) / (M * (A1 + 3 * A2 * l22 + l6 * (7 * A3 + 9 * A4 * l22))),
    l2 * (A1 + A2 * l22 + l6 * (A3 + A4 * l22))
  ];
}
equalEarthRaw.invert = function(x2, y2) {
  var l2 = y2, l22 = l2 * l2, l6 = l22 * l22 * l22;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l2 * (A1 + A2 * l22 + l6 * (A3 + A4 * l22)) - y2;
    fpy = A1 + 3 * A2 * l22 + l6 * (7 * A3 + 9 * A4 * l22);
    l2 -= delta = fy / fpy, l22 = l2 * l2, l6 = l22 * l22 * l22;
    if (abs$1(delta) < epsilon2$2)
      break;
  }
  return [
    M * x2 * (A1 + 3 * A2 * l22 + l6 * (7 * A3 + 9 * A4 * l22)) / cos$1(l2),
    asin$1(sin$1(l2) / M)
  ];
};
function equalEarth() {
  return projection(equalEarthRaw).scale(177.158);
}
function gnomonicRaw(x2, y2) {
  var cy = cos$1(y2), k2 = cos$1(x2) * cy;
  return [cy * sin$1(x2) / k2, sin$1(y2) / k2];
}
gnomonicRaw.invert = azimuthalInvert(atan);
function gnomonic() {
  return projection(gnomonicRaw).scale(144.049).clipAngle(60);
}
function identity$6() {
  var k2 = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha2 = 0, ca, sa, x02 = null, y02, x12, y12, kx2 = 1, ky2 = 1, transform2 = transformer$3({
    point: function(x2, y2) {
      var p2 = projection2([x2, y2]);
      this.stream.point(p2[0], p2[1]);
    }
  }), postclip = identity$7, cache2, cacheStream;
  function reset() {
    kx2 = k2 * sx;
    ky2 = k2 * sy;
    cache2 = cacheStream = null;
    return projection2;
  }
  function projection2(p2) {
    var x2 = p2[0] * kx2, y2 = p2[1] * ky2;
    if (alpha2) {
      var t4 = y2 * ca - x2 * sa;
      x2 = x2 * ca + y2 * sa;
      y2 = t4;
    }
    return [x2 + tx, y2 + ty];
  }
  projection2.invert = function(p2) {
    var x2 = p2[0] - tx, y2 = p2[1] - ty;
    if (alpha2) {
      var t4 = y2 * ca + x2 * sa;
      x2 = x2 * ca - y2 * sa;
      y2 = t4;
    }
    return [x2 / kx2, y2 / ky2];
  };
  projection2.stream = function(stream) {
    return cache2 && cacheStream === stream ? cache2 : cache2 = transform2(postclip(cacheStream = stream));
  };
  projection2.postclip = function(_2) {
    return arguments.length ? (postclip = _2, x02 = y02 = x12 = y12 = null, reset()) : postclip;
  };
  projection2.clipExtent = function(_2) {
    return arguments.length ? (postclip = _2 == null ? (x02 = y02 = x12 = y12 = null, identity$7) : clipRectangle(x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1]), reset()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_2) {
    return arguments.length ? (k2 = +_2, reset()) : k2;
  };
  projection2.translate = function(_2) {
    return arguments.length ? (tx = +_2[0], ty = +_2[1], reset()) : [tx, ty];
  };
  projection2.angle = function(_2) {
    return arguments.length ? (alpha2 = _2 % 360 * radians$1, sa = sin$1(alpha2), ca = cos$1(alpha2), reset()) : alpha2 * degrees$2;
  };
  projection2.reflectX = function(_2) {
    return arguments.length ? (sx = _2 ? -1 : 1, reset()) : sx < 0;
  };
  projection2.reflectY = function(_2) {
    return arguments.length ? (sy = _2 ? -1 : 1, reset()) : sy < 0;
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size, object2) {
    return fitSize(projection2, size, object2);
  };
  projection2.fitWidth = function(width2, object2) {
    return fitWidth(projection2, width2, object2);
  };
  projection2.fitHeight = function(height2, object2) {
    return fitHeight(projection2, height2, object2);
  };
  return projection2;
}
function naturalEarth1Raw(lambda, phi2) {
  var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
  return [
    lambda * (0.8707 - 0.131979 * phi22 + phi4 * (-0.013791 + phi4 * (3971e-6 * phi22 - 1529e-6 * phi4))),
    phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4)))
  ];
}
naturalEarth1Raw.invert = function(x2, y2) {
  var phi2 = y2, i = 25, delta;
  do {
    var phi22 = phi2 * phi2, phi4 = phi22 * phi22;
    phi2 -= delta = (phi2 * (1.007226 + phi22 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi22 - 5916e-6 * phi4))) - y2) / (1.007226 + phi22 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi22 - 5916e-6 * 11 * phi4)));
  } while (abs$1(delta) > epsilon$2 && --i > 0);
  return [
    x2 / (0.8707 + (phi22 = phi2 * phi2) * (-0.131979 + phi22 * (-0.013791 + phi22 * phi22 * phi22 * (3971e-6 - 1529e-6 * phi22)))),
    phi2
  ];
};
function naturalEarth1() {
  return projection(naturalEarth1Raw).scale(175.295);
}
function orthographicRaw(x2, y2) {
  return [cos$1(y2) * sin$1(x2), sin$1(y2)];
}
orthographicRaw.invert = azimuthalInvert(asin$1);
function orthographic() {
  return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$2);
}
function stereographicRaw(x2, y2) {
  var cy = cos$1(y2), k2 = 1 + cos$1(x2) * cy;
  return [cy * sin$1(x2) / k2, sin$1(y2) / k2];
}
stereographicRaw.invert = azimuthalInvert(function(z2) {
  return 2 * atan(z2);
});
function stereographic() {
  return projection(stereographicRaw).scale(250).clipAngle(142);
}
function transverseMercatorRaw(lambda, phi2) {
  return [log$1(tan((halfPi$1 + phi2) / 2)), -lambda];
}
transverseMercatorRaw.invert = function(x2, y2) {
  return [-y2, 2 * atan(exp(x2)) - halfPi$1];
};
function transverseMercator() {
  var m2 = mercatorProjection(transverseMercatorRaw), center2 = m2.center, rotate = m2.rotate;
  m2.center = function(_2) {
    return arguments.length ? center2([-_2[1], _2[0]]) : (_2 = center2(), [_2[1], -_2[0]]);
  };
  m2.rotate = function(_2) {
    return arguments.length ? rotate([_2[0], _2[1], _2.length > 2 ? _2[2] + 90 : 90]) : (_2 = rotate(), [_2[0], _2[1], _2[2] - 90]);
  };
  return rotate([0, 0, 90]).scale(159.155);
}
function defaultSeparation$1(a2, b10) {
  return a2.parent === b10.parent ? 1 : 2;
}
function meanX(children2) {
  return children2.reduce(meanXReduce, 0) / children2.length;
}
function meanXReduce(x2, c2) {
  return x2 + c2.x;
}
function maxY(children2) {
  return 1 + children2.reduce(maxYReduce, 0);
}
function maxYReduce(y2, c2) {
  return Math.max(y2, c2.y);
}
function leafLeft(node2) {
  var children2;
  while (children2 = node2.children)
    node2 = children2[0];
  return node2;
}
function leafRight(node2) {
  var children2;
  while (children2 = node2.children)
    node2 = children2[children2.length - 1];
  return node2;
}
function cluster() {
  var separation = defaultSeparation$1, dx = 1, dy = 1, nodeSize = false;
  function cluster2(root2) {
    var previousNode, x2 = 0;
    root2.eachAfter(function(node2) {
      var children2 = node2.children;
      if (children2) {
        node2.x = meanX(children2);
        node2.y = maxY(children2);
      } else {
        node2.x = previousNode ? x2 += separation(node2, previousNode) : 0;
        node2.y = 0;
        previousNode = node2;
      }
    });
    var left2 = leafLeft(root2), right2 = leafRight(root2), x02 = left2.x - separation(left2, right2) / 2, x12 = right2.x + separation(right2, left2) / 2;
    return root2.eachAfter(nodeSize ? function(node2) {
      node2.x = (node2.x - root2.x) * dx;
      node2.y = (root2.y - node2.y) * dy;
    } : function(node2) {
      node2.x = (node2.x - x02) / (x12 - x02) * dx;
      node2.y = (1 - (root2.y ? node2.y / root2.y : 1)) * dy;
    });
  }
  cluster2.separation = function(x2) {
    return arguments.length ? (separation = x2, cluster2) : separation;
  };
  cluster2.size = function(x2) {
    return arguments.length ? (nodeSize = false, dx = +x2[0], dy = +x2[1], cluster2) : nodeSize ? null : [dx, dy];
  };
  cluster2.nodeSize = function(x2) {
    return arguments.length ? (nodeSize = true, dx = +x2[0], dy = +x2[1], cluster2) : nodeSize ? [dx, dy] : null;
  };
  return cluster2;
}
function count(node2) {
  var sum2 = 0, children2 = node2.children, i = children2 && children2.length;
  if (!i)
    sum2 = 1;
  else
    while (--i >= 0)
      sum2 += children2[i].value;
  node2.value = sum2;
}
function node_count() {
  return this.eachAfter(count);
}
function node_each(callback, that) {
  let index2 = -1;
  for (const node2 of this) {
    callback.call(that, node2, ++index2, this);
  }
  return this;
}
function node_eachBefore(callback, that) {
  var node2 = this, nodes = [node2], children2, i, index2 = -1;
  while (node2 = nodes.pop()) {
    callback.call(that, node2, ++index2, this);
    if (children2 = node2.children) {
      for (i = children2.length - 1; i >= 0; --i) {
        nodes.push(children2[i]);
      }
    }
  }
  return this;
}
function node_eachAfter(callback, that) {
  var node2 = this, nodes = [node2], next2 = [], children2, i, n2, index2 = -1;
  while (node2 = nodes.pop()) {
    next2.push(node2);
    if (children2 = node2.children) {
      for (i = 0, n2 = children2.length; i < n2; ++i) {
        nodes.push(children2[i]);
      }
    }
  }
  while (node2 = next2.pop()) {
    callback.call(that, node2, ++index2, this);
  }
  return this;
}
function node_find(callback, that) {
  let index2 = -1;
  for (const node2 of this) {
    if (callback.call(that, node2, ++index2, this)) {
      return node2;
    }
  }
}
function node_sum(value) {
  return this.eachAfter(function(node2) {
    var sum2 = +value(node2.data) || 0, children2 = node2.children, i = children2 && children2.length;
    while (--i >= 0)
      sum2 += children2[i].value;
    node2.value = sum2;
  });
}
function node_sort(compare) {
  return this.eachBefore(function(node2) {
    if (node2.children) {
      node2.children.sort(compare);
    }
  });
}
function node_path(end2) {
  var start2 = this, ancestor = leastCommonAncestor(start2, end2), nodes = [start2];
  while (start2 !== ancestor) {
    start2 = start2.parent;
    nodes.push(start2);
  }
  var k2 = nodes.length;
  while (end2 !== ancestor) {
    nodes.splice(k2, 0, end2);
    end2 = end2.parent;
  }
  return nodes;
}
function leastCommonAncestor(a2, b10) {
  if (a2 === b10)
    return a2;
  var aNodes = a2.ancestors(), bNodes = b10.ancestors(), c2 = null;
  a2 = aNodes.pop();
  b10 = bNodes.pop();
  while (a2 === b10) {
    c2 = a2;
    a2 = aNodes.pop();
    b10 = bNodes.pop();
  }
  return c2;
}
function node_ancestors() {
  var node2 = this, nodes = [node2];
  while (node2 = node2.parent) {
    nodes.push(node2);
  }
  return nodes;
}
function node_descendants() {
  return Array.from(this);
}
function node_leaves() {
  var leaves = [];
  this.eachBefore(function(node2) {
    if (!node2.children) {
      leaves.push(node2);
    }
  });
  return leaves;
}
function node_links() {
  var root2 = this, links = [];
  root2.each(function(node2) {
    if (node2 !== root2) {
      links.push({ source: node2.parent, target: node2 });
    }
  });
  return links;
}
function* node_iterator() {
  var node2 = this, current, next2 = [node2], children2, i, n2;
  do {
    current = next2.reverse(), next2 = [];
    while (node2 = current.pop()) {
      yield node2;
      if (children2 = node2.children) {
        for (i = 0, n2 = children2.length; i < n2; ++i) {
          next2.push(children2[i]);
        }
      }
    }
  } while (next2.length);
}
function hierarchy(data, children2) {
  if (data instanceof Map) {
    data = [void 0, data];
    if (children2 === void 0)
      children2 = mapChildren;
  } else if (children2 === void 0) {
    children2 = objectChildren;
  }
  var root2 = new Node$1(data), node2, nodes = [root2], child, childs, i, n2;
  while (node2 = nodes.pop()) {
    if ((childs = children2(node2.data)) && (n2 = (childs = Array.from(childs)).length)) {
      node2.children = childs;
      for (i = n2 - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node$1(childs[i]));
        child.parent = node2;
        child.depth = node2.depth + 1;
      }
    }
  }
  return root2.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d2) {
  return d2.children;
}
function mapChildren(d2) {
  return Array.isArray(d2) ? d2[1] : null;
}
function copyData(node2) {
  if (node2.data.value !== void 0)
    node2.value = node2.data.value;
  node2.data = node2.data.data;
}
function computeHeight(node2) {
  var height2 = 0;
  do
    node2.height = height2;
  while ((node2 = node2.parent) && node2.height < ++height2);
}
function Node$1(data) {
  this.data = data;
  this.depth = this.height = 0;
  this.parent = null;
}
Node$1.prototype = hierarchy.prototype = {
  constructor: Node$1,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};
function array$2(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function shuffle(array2) {
  var m2 = array2.length, t4, i;
  while (m2) {
    i = Math.random() * m2-- | 0;
    t4 = array2[m2];
    array2[m2] = array2[i];
    array2[i] = t4;
  }
  return array2;
}
function enclose(circles) {
  var i = 0, n2 = (circles = shuffle(Array.from(circles))).length, B2 = [], p2, e3;
  while (i < n2) {
    p2 = circles[i];
    if (e3 && enclosesWeak(e3, p2))
      ++i;
    else
      e3 = encloseBasis(B2 = extendBasis(B2, p2)), i = 0;
  }
  return e3;
}
function extendBasis(B2, p2) {
  var i, j;
  if (enclosesWeakAll(p2, B2))
    return [p2];
  for (i = 0; i < B2.length; ++i) {
    if (enclosesNot(p2, B2[i]) && enclosesWeakAll(encloseBasis2(B2[i], p2), B2)) {
      return [B2[i], p2];
    }
  }
  for (i = 0; i < B2.length - 1; ++i) {
    for (j = i + 1; j < B2.length; ++j) {
      if (enclosesNot(encloseBasis2(B2[i], B2[j]), p2) && enclosesNot(encloseBasis2(B2[i], p2), B2[j]) && enclosesNot(encloseBasis2(B2[j], p2), B2[i]) && enclosesWeakAll(encloseBasis3(B2[i], B2[j], p2), B2)) {
        return [B2[i], B2[j], p2];
      }
    }
  }
  throw new Error();
}
function enclosesNot(a2, b10) {
  var dr = a2.r - b10.r, dx = b10.x - a2.x, dy = b10.y - a2.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a2, b10) {
  var dr = a2.r - b10.r + Math.max(a2.r, b10.r, 1) * 1e-9, dx = b10.x - a2.x, dy = b10.y - a2.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a2, B2) {
  for (var i = 0; i < B2.length; ++i) {
    if (!enclosesWeak(a2, B2[i])) {
      return false;
    }
  }
  return true;
}
function encloseBasis(B2) {
  switch (B2.length) {
    case 1:
      return encloseBasis1(B2[0]);
    case 2:
      return encloseBasis2(B2[0], B2[1]);
    case 3:
      return encloseBasis3(B2[0], B2[1], B2[2]);
  }
}
function encloseBasis1(a2) {
  return {
    x: a2.x,
    y: a2.y,
    r: a2.r
  };
}
function encloseBasis2(a2, b10) {
  var x12 = a2.x, y12 = a2.y, r1 = a2.r, x2 = b10.x, y2 = b10.y, r2 = b10.r, x21 = x2 - x12, y21 = y2 - y12, r21 = r2 - r1, l2 = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x12 + x2 + x21 / l2 * r21) / 2,
    y: (y12 + y2 + y21 / l2 * r21) / 2,
    r: (l2 + r1 + r2) / 2
  };
}
function encloseBasis3(a2, b10, c2) {
  var x12 = a2.x, y12 = a2.y, r1 = a2.r, x2 = b10.x, y2 = b10.y, r2 = b10.r, x3 = c2.x, y3 = c2.y, r3 = c2.r, a22 = x12 - x2, a3 = x12 - x3, b22 = y12 - y2, b32 = y12 - y3, c22 = r2 - r1, c3 = r3 - r1, d1 = x12 * x12 + y12 * y12 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d32 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b22 - a22 * b32, xa = (b22 * d32 - b32 * d2) / (ab * 2) - x12, xb = (b32 * c22 - b22 * c3) / ab, ya = (a3 * d2 - a22 * d32) / (ab * 2) - y12, yb = (a22 * c3 - a3 * c22) / ab, A5 = xb * xb + yb * yb - 1, B2 = 2 * (r1 + xa * xb + ya * yb), C2 = xa * xa + ya * ya - r1 * r1, r4 = -(A5 ? (B2 + Math.sqrt(B2 * B2 - 4 * A5 * C2)) / (2 * A5) : C2 / B2);
  return {
    x: x12 + xa + xb * r4,
    y: y12 + ya + yb * r4,
    r: r4
  };
}
function place(b10, a2, c2) {
  var dx = b10.x - a2.x, x2, a22, dy = b10.y - a2.y, y2, b22, d2 = dx * dx + dy * dy;
  if (d2) {
    a22 = a2.r + c2.r, a22 *= a22;
    b22 = b10.r + c2.r, b22 *= b22;
    if (a22 > b22) {
      x2 = (d2 + b22 - a22) / (2 * d2);
      y2 = Math.sqrt(Math.max(0, b22 / d2 - x2 * x2));
      c2.x = b10.x - x2 * dx - y2 * dy;
      c2.y = b10.y - x2 * dy + y2 * dx;
    } else {
      x2 = (d2 + a22 - b22) / (2 * d2);
      y2 = Math.sqrt(Math.max(0, a22 / d2 - x2 * x2));
      c2.x = a2.x + x2 * dx - y2 * dy;
      c2.y = a2.y + x2 * dy + y2 * dx;
    }
  } else {
    c2.x = a2.x + c2.r;
    c2.y = a2.y;
  }
}
function intersects(a2, b10) {
  var dr = a2.r + b10.r - 1e-6, dx = b10.x - a2.x, dy = b10.y - a2.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node2) {
  var a2 = node2._, b10 = node2.next._, ab = a2.r + b10.r, dx = (a2.x * b10.r + b10.x * a2.r) / ab, dy = (a2.y * b10.r + b10.y * a2.r) / ab;
  return dx * dx + dy * dy;
}
function Node(circle2) {
  this._ = circle2;
  this.next = null;
  this.previous = null;
}
function packEnclose(circles) {
  if (!(n2 = (circles = array$2(circles)).length))
    return 0;
  var a2, b10, c2, n2, aa, ca, i, j, k2, sj, sk;
  a2 = circles[0], a2.x = 0, a2.y = 0;
  if (!(n2 > 1))
    return a2.r;
  b10 = circles[1], a2.x = -b10.r, b10.x = a2.r, b10.y = 0;
  if (!(n2 > 2))
    return a2.r + b10.r;
  place(b10, a2, c2 = circles[2]);
  a2 = new Node(a2), b10 = new Node(b10), c2 = new Node(c2);
  a2.next = c2.previous = b10;
  b10.next = a2.previous = c2;
  c2.next = b10.previous = a2;
  pack:
    for (i = 3; i < n2; ++i) {
      place(a2._, b10._, c2 = circles[i]), c2 = new Node(c2);
      j = b10.next, k2 = a2.previous, sj = b10._.r, sk = a2._.r;
      do {
        if (sj <= sk) {
          if (intersects(j._, c2._)) {
            b10 = j, a2.next = b10, b10.previous = a2, --i;
            continue pack;
          }
          sj += j._.r, j = j.next;
        } else {
          if (intersects(k2._, c2._)) {
            a2 = k2, a2.next = b10, b10.previous = a2, --i;
            continue pack;
          }
          sk += k2._.r, k2 = k2.previous;
        }
      } while (j !== k2.next);
      c2.previous = a2, c2.next = b10, a2.next = b10.previous = b10 = c2;
      aa = score(a2);
      while ((c2 = c2.next) !== b10) {
        if ((ca = score(c2)) < aa) {
          a2 = c2, aa = ca;
        }
      }
      b10 = a2.next;
    }
  a2 = [b10._], c2 = b10;
  while ((c2 = c2.next) !== b10)
    a2.push(c2._);
  c2 = enclose(a2);
  for (i = 0; i < n2; ++i)
    a2 = circles[i], a2.x -= c2.x, a2.y -= c2.y;
  return c2.r;
}
function siblings(circles) {
  packEnclose(circles);
  return circles;
}
function optional(f2) {
  return f2 == null ? null : required(f2);
}
function required(f2) {
  if (typeof f2 !== "function")
    throw new Error();
  return f2;
}
function constantZero() {
  return 0;
}
function constant$4(x2) {
  return function() {
    return x2;
  };
}
function defaultRadius(d2) {
  return Math.sqrt(d2.value);
}
function index$1() {
  var radius = null, dx = 1, dy = 1, padding2 = constantZero;
  function pack(root2) {
    root2.x = dx / 2, root2.y = dy / 2;
    if (radius) {
      root2.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding2, 0.5)).eachBefore(translateChild(1));
    } else {
      root2.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren(constantZero, 1)).eachAfter(packChildren(padding2, root2.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root2.r)));
    }
    return root2;
  }
  pack.radius = function(x2) {
    return arguments.length ? (radius = optional(x2), pack) : radius;
  };
  pack.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], pack) : [dx, dy];
  };
  pack.padding = function(x2) {
    return arguments.length ? (padding2 = typeof x2 === "function" ? x2 : constant$4(+x2), pack) : padding2;
  };
  return pack;
}
function radiusLeaf(radius) {
  return function(node2) {
    if (!node2.children) {
      node2.r = Math.max(0, +radius(node2) || 0);
    }
  };
}
function packChildren(padding2, k2) {
  return function(node2) {
    if (children2 = node2.children) {
      var children2, i, n2 = children2.length, r2 = padding2(node2) * k2 || 0, e3;
      if (r2)
        for (i = 0; i < n2; ++i)
          children2[i].r += r2;
      e3 = packEnclose(children2);
      if (r2)
        for (i = 0; i < n2; ++i)
          children2[i].r -= r2;
      node2.r = e3 + r2;
    }
  };
}
function translateChild(k2) {
  return function(node2) {
    var parent = node2.parent;
    node2.r *= k2;
    if (parent) {
      node2.x = parent.x + k2 * node2.x;
      node2.y = parent.y + k2 * node2.y;
    }
  };
}
function roundNode(node2) {
  node2.x0 = Math.round(node2.x0);
  node2.y0 = Math.round(node2.y0);
  node2.x1 = Math.round(node2.x1);
  node2.y1 = Math.round(node2.y1);
}
function treemapDice(parent, x02, y02, x12, y12) {
  var nodes = parent.children, node2, i = -1, n2 = nodes.length, k2 = parent.value && (x12 - x02) / parent.value;
  while (++i < n2) {
    node2 = nodes[i], node2.y0 = y02, node2.y1 = y12;
    node2.x0 = x02, node2.x1 = x02 += node2.value * k2;
  }
}
function partition() {
  var dx = 1, dy = 1, padding2 = 0, round2 = false;
  function partition2(root2) {
    var n2 = root2.height + 1;
    root2.x0 = root2.y0 = padding2;
    root2.x1 = dx;
    root2.y1 = dy / n2;
    root2.eachBefore(positionNode(dy, n2));
    if (round2)
      root2.eachBefore(roundNode);
    return root2;
  }
  function positionNode(dy2, n2) {
    return function(node2) {
      if (node2.children) {
        treemapDice(node2, node2.x0, dy2 * (node2.depth + 1) / n2, node2.x1, dy2 * (node2.depth + 2) / n2);
      }
      var x02 = node2.x0, y02 = node2.y0, x12 = node2.x1 - padding2, y12 = node2.y1 - padding2;
      if (x12 < x02)
        x02 = x12 = (x02 + x12) / 2;
      if (y12 < y02)
        y02 = y12 = (y02 + y12) / 2;
      node2.x0 = x02;
      node2.y0 = y02;
      node2.x1 = x12;
      node2.y1 = y12;
    };
  }
  partition2.round = function(x2) {
    return arguments.length ? (round2 = !!x2, partition2) : round2;
  };
  partition2.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], partition2) : [dx, dy];
  };
  partition2.padding = function(x2) {
    return arguments.length ? (padding2 = +x2, partition2) : padding2;
  };
  return partition2;
}
var preroot = { depth: -1 }, ambiguous = {};
function defaultId(d2) {
  return d2.id;
}
function defaultParentId(d2) {
  return d2.parentId;
}
function stratify() {
  var id2 = defaultId, parentId = defaultParentId;
  function stratify2(data) {
    var nodes = Array.from(data), n2 = nodes.length, d2, i, root2, parent, node2, nodeId, nodeKey, nodeByKey = /* @__PURE__ */ new Map();
    for (i = 0; i < n2; ++i) {
      d2 = nodes[i], node2 = nodes[i] = new Node$1(d2);
      if ((nodeId = id2(d2, i, data)) != null && (nodeId += "")) {
        nodeKey = node2.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node2);
      }
      if ((nodeId = parentId(d2, i, data)) != null && (nodeId += "")) {
        node2.parent = nodeId;
      }
    }
    for (i = 0; i < n2; ++i) {
      node2 = nodes[i];
      if (nodeId = node2.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent)
          throw new Error("missing: " + nodeId);
        if (parent === ambiguous)
          throw new Error("ambiguous: " + nodeId);
        if (parent.children)
          parent.children.push(node2);
        else
          parent.children = [node2];
        node2.parent = parent;
      } else {
        if (root2)
          throw new Error("multiple roots");
        root2 = node2;
      }
    }
    if (!root2)
      throw new Error("no root");
    root2.parent = preroot;
    root2.eachBefore(function(node3) {
      node3.depth = node3.parent.depth + 1;
      --n2;
    }).eachBefore(computeHeight);
    root2.parent = null;
    if (n2 > 0)
      throw new Error("cycle");
    return root2;
  }
  stratify2.id = function(x2) {
    return arguments.length ? (id2 = required(x2), stratify2) : id2;
  };
  stratify2.parentId = function(x2) {
    return arguments.length ? (parentId = required(x2), stratify2) : parentId;
  };
  return stratify2;
}
function defaultSeparation(a2, b10) {
  return a2.parent === b10.parent ? 1 : 2;
}
function nextLeft(v2) {
  var children2 = v2.children;
  return children2 ? children2[0] : v2.t;
}
function nextRight(v2) {
  var children2 = v2.children;
  return children2 ? children2[children2.length - 1] : v2.t;
}
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}
function executeShifts(v2) {
  var shift = 0, change = 0, children2 = v2.children, i = children2.length, w2;
  while (--i >= 0) {
    w2 = children2[i];
    w2.z += shift;
    w2.m += shift;
    shift += w2.s + (change += w2.c);
  }
}
function nextAncestor(vim, v2, ancestor) {
  return vim.a.parent === v2.parent ? vim.a : ancestor;
}
function TreeNode(node2, i) {
  this._ = node2;
  this.parent = null;
  this.children = null;
  this.A = null;
  this.a = this;
  this.z = 0;
  this.m = 0;
  this.c = 0;
  this.s = 0;
  this.t = null;
  this.i = i;
}
TreeNode.prototype = Object.create(Node$1.prototype);
function treeRoot(root2) {
  var tree2 = new TreeNode(root2, 0), node2, nodes = [tree2], child, children2, i, n2;
  while (node2 = nodes.pop()) {
    if (children2 = node2._.children) {
      node2.children = new Array(n2 = children2.length);
      for (i = n2 - 1; i >= 0; --i) {
        nodes.push(child = node2.children[i] = new TreeNode(children2[i], i));
        child.parent = node2;
      }
    }
  }
  (tree2.parent = new TreeNode(null, 0)).children = [tree2];
  return tree2;
}
function tree() {
  var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
  function tree2(root2) {
    var t4 = treeRoot(root2);
    t4.eachAfter(firstWalk), t4.parent.m = -t4.z;
    t4.eachBefore(secondWalk);
    if (nodeSize)
      root2.eachBefore(sizeNode);
    else {
      var left2 = root2, right2 = root2, bottom2 = root2;
      root2.eachBefore(function(node2) {
        if (node2.x < left2.x)
          left2 = node2;
        if (node2.x > right2.x)
          right2 = node2;
        if (node2.depth > bottom2.depth)
          bottom2 = node2;
      });
      var s2 = left2 === right2 ? 1 : separation(left2, right2) / 2, tx = s2 - left2.x, kx2 = dx / (right2.x + s2 + tx), ky2 = dy / (bottom2.depth || 1);
      root2.eachBefore(function(node2) {
        node2.x = (node2.x + tx) * kx2;
        node2.y = node2.depth * ky2;
      });
    }
    return root2;
  }
  function firstWalk(v2) {
    var children2 = v2.children, siblings2 = v2.parent.children, w2 = v2.i ? siblings2[v2.i - 1] : null;
    if (children2) {
      executeShifts(v2);
      var midpoint = (children2[0].z + children2[children2.length - 1].z) / 2;
      if (w2) {
        v2.z = w2.z + separation(v2._, w2._);
        v2.m = v2.z - midpoint;
      } else {
        v2.z = midpoint;
      }
    } else if (w2) {
      v2.z = w2.z + separation(v2._, w2._);
    }
    v2.parent.A = apportion(v2, w2, v2.parent.A || siblings2[0]);
  }
  function secondWalk(v2) {
    v2._.x = v2.z + v2.parent.m;
    v2.m += v2.parent.m;
  }
  function apportion(v2, w2, ancestor) {
    if (w2) {
      var vip = v2, vop = v2, vim = w2, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v2;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v2, ancestor), v2, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v2;
      }
    }
    return ancestor;
  }
  function sizeNode(node2) {
    node2.x *= dx;
    node2.y = node2.depth * dy;
  }
  tree2.separation = function(x2) {
    return arguments.length ? (separation = x2, tree2) : separation;
  };
  tree2.size = function(x2) {
    return arguments.length ? (nodeSize = false, dx = +x2[0], dy = +x2[1], tree2) : nodeSize ? null : [dx, dy];
  };
  tree2.nodeSize = function(x2) {
    return arguments.length ? (nodeSize = true, dx = +x2[0], dy = +x2[1], tree2) : nodeSize ? [dx, dy] : null;
  };
  return tree2;
}
function treemapSlice(parent, x02, y02, x12, y12) {
  var nodes = parent.children, node2, i = -1, n2 = nodes.length, k2 = parent.value && (y12 - y02) / parent.value;
  while (++i < n2) {
    node2 = nodes[i], node2.x0 = x02, node2.x1 = x12;
    node2.y0 = y02, node2.y1 = y02 += node2.value * k2;
  }
}
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x02, y02, x12, y12) {
  var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n2 = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha2, beta2;
  while (i0 < n2) {
    dx = x12 - x02, dy = y12 - y02;
    do
      sumValue = nodes[i1++].value;
    while (!sumValue && i1 < n2);
    minValue = maxValue = sumValue;
    alpha2 = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta2 = sumValue * sumValue * alpha2;
    minRatio = Math.max(maxValue / beta2, beta2 / minValue);
    for (; i1 < n2; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue)
        minValue = nodeValue;
      if (nodeValue > maxValue)
        maxValue = nodeValue;
      beta2 = sumValue * sumValue * alpha2;
      newRatio = Math.max(maxValue / beta2, beta2 / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice)
      treemapDice(row, x02, y02, x12, value ? y02 += dy * sumValue / value : y12);
    else
      treemapSlice(row, x02, y02, value ? x02 += dx * sumValue / value : x12, y12);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
var squarify = function custom17(ratio) {
  function squarify2(parent, x02, y02, x12, y12) {
    squarifyRatio(ratio, parent, x02, y02, x12, y12);
  }
  squarify2.ratio = function(x2) {
    return custom17((x2 = +x2) > 1 ? x2 : 1);
  };
  return squarify2;
}(phi);
function index() {
  var tile = squarify, round2 = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
  function treemap(root2) {
    root2.x0 = root2.y0 = 0;
    root2.x1 = dx;
    root2.y1 = dy;
    root2.eachBefore(positionNode);
    paddingStack = [0];
    if (round2)
      root2.eachBefore(roundNode);
    return root2;
  }
  function positionNode(node2) {
    var p2 = paddingStack[node2.depth], x02 = node2.x0 + p2, y02 = node2.y0 + p2, x12 = node2.x1 - p2, y12 = node2.y1 - p2;
    if (x12 < x02)
      x02 = x12 = (x02 + x12) / 2;
    if (y12 < y02)
      y02 = y12 = (y02 + y12) / 2;
    node2.x0 = x02;
    node2.y0 = y02;
    node2.x1 = x12;
    node2.y1 = y12;
    if (node2.children) {
      p2 = paddingStack[node2.depth + 1] = paddingInner(node2) / 2;
      x02 += paddingLeft(node2) - p2;
      y02 += paddingTop(node2) - p2;
      x12 -= paddingRight(node2) - p2;
      y12 -= paddingBottom(node2) - p2;
      if (x12 < x02)
        x02 = x12 = (x02 + x12) / 2;
      if (y12 < y02)
        y02 = y12 = (y02 + y12) / 2;
      tile(node2, x02, y02, x12, y12);
    }
  }
  treemap.round = function(x2) {
    return arguments.length ? (round2 = !!x2, treemap) : round2;
  };
  treemap.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], treemap) : [dx, dy];
  };
  treemap.tile = function(x2) {
    return arguments.length ? (tile = required(x2), treemap) : tile;
  };
  treemap.padding = function(x2) {
    return arguments.length ? treemap.paddingInner(x2).paddingOuter(x2) : treemap.paddingInner();
  };
  treemap.paddingInner = function(x2) {
    return arguments.length ? (paddingInner = typeof x2 === "function" ? x2 : constant$4(+x2), treemap) : paddingInner;
  };
  treemap.paddingOuter = function(x2) {
    return arguments.length ? treemap.paddingTop(x2).paddingRight(x2).paddingBottom(x2).paddingLeft(x2) : treemap.paddingTop();
  };
  treemap.paddingTop = function(x2) {
    return arguments.length ? (paddingTop = typeof x2 === "function" ? x2 : constant$4(+x2), treemap) : paddingTop;
  };
  treemap.paddingRight = function(x2) {
    return arguments.length ? (paddingRight = typeof x2 === "function" ? x2 : constant$4(+x2), treemap) : paddingRight;
  };
  treemap.paddingBottom = function(x2) {
    return arguments.length ? (paddingBottom = typeof x2 === "function" ? x2 : constant$4(+x2), treemap) : paddingBottom;
  };
  treemap.paddingLeft = function(x2) {
    return arguments.length ? (paddingLeft = typeof x2 === "function" ? x2 : constant$4(+x2), treemap) : paddingLeft;
  };
  return treemap;
}
function binary(parent, x02, y02, x12, y12) {
  var nodes = parent.children, i, n2 = nodes.length, sum2, sums = new Array(n2 + 1);
  for (sums[0] = sum2 = i = 0; i < n2; ++i) {
    sums[i + 1] = sum2 += nodes[i].value;
  }
  partition2(0, n2, parent.value, x02, y02, x12, y12);
  function partition2(i2, j, value, x03, y03, x13, y13) {
    if (i2 >= j - 1) {
      var node2 = nodes[i2];
      node2.x0 = x03, node2.y0 = y03;
      node2.x1 = x13, node2.y1 = y13;
      return;
    }
    var valueOffset = sums[i2], valueTarget = value / 2 + valueOffset, k2 = i2 + 1, hi = j - 1;
    while (k2 < hi) {
      var mid = k2 + hi >>> 1;
      if (sums[mid] < valueTarget)
        k2 = mid + 1;
      else
        hi = mid;
    }
    if (valueTarget - sums[k2 - 1] < sums[k2] - valueTarget && i2 + 1 < k2)
      --k2;
    var valueLeft = sums[k2] - valueOffset, valueRight = value - valueLeft;
    if (x13 - x03 > y13 - y03) {
      var xk = value ? (x03 * valueRight + x13 * valueLeft) / value : x13;
      partition2(i2, k2, valueLeft, x03, y03, xk, y13);
      partition2(k2, j, valueRight, xk, y03, x13, y13);
    } else {
      var yk = value ? (y03 * valueRight + y13 * valueLeft) / value : y13;
      partition2(i2, k2, valueLeft, x03, y03, x13, yk);
      partition2(k2, j, valueRight, x03, yk, x13, y13);
    }
  }
}
function sliceDice(parent, x02, y02, x12, y12) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x02, y02, x12, y12);
}
var resquarify = function custom18(ratio) {
  function resquarify2(parent, x02, y02, x12, y12) {
    if ((rows = parent._squarify) && rows.ratio === ratio) {
      var rows, row, nodes, i, j = -1, n2, m2 = rows.length, value = parent.value;
      while (++j < m2) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n2 = nodes.length; i < n2; ++i)
          row.value += nodes[i].value;
        if (row.dice)
          treemapDice(row, x02, y02, x12, value ? y02 += (y12 - y02) * row.value / value : y12);
        else
          treemapSlice(row, x02, y02, value ? x02 += (x12 - x02) * row.value / value : x12, y12);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x02, y02, x12, y12);
      rows.ratio = ratio;
    }
  }
  resquarify2.ratio = function(x2) {
    return custom18((x2 = +x2) > 1 ? x2 : 1);
  };
  return resquarify2;
}(phi);
function basis$3(t12, v0, v1, v2, v3) {
  var t22 = t12 * t12, t32 = t22 * t12;
  return ((1 - 3 * t12 + 3 * t22 - t32) * v0 + (4 - 6 * t22 + 3 * t32) * v1 + (1 + 3 * t12 + 3 * t22 - 3 * t32) * v2 + t32 * v3) / 6;
}
function basis$4(values2) {
  var n2 = values2.length - 1;
  return function(t4) {
    var i = t4 <= 0 ? t4 = 0 : t4 >= 1 ? (t4 = 1, n2 - 1) : Math.floor(t4 * n2), v1 = values2[i], v2 = values2[i + 1], v0 = i > 0 ? values2[i - 1] : 2 * v1 - v2, v3 = i < n2 - 1 ? values2[i + 2] : 2 * v2 - v1;
    return basis$3((t4 - i / n2) * n2, v0, v1, v2, v3);
  };
}
function basisClosed$1(values2) {
  var n2 = values2.length;
  return function(t4) {
    var i = Math.floor(((t4 %= 1) < 0 ? ++t4 : t4) * n2), v0 = values2[(i + n2 - 1) % n2], v1 = values2[i % n2], v2 = values2[(i + 1) % n2], v3 = values2[(i + 2) % n2];
    return basis$3((t4 - i / n2) * n2, v0, v1, v2, v3);
  };
}
var constant$3 = (x2) => () => x2;
function linear$2(a2, d2) {
  return function(t4) {
    return a2 + t4 * d2;
  };
}
function exponential$2(a2, b10, y2) {
  return a2 = Math.pow(a2, y2), b10 = Math.pow(b10, y2) - a2, y2 = 1 / y2, function(t4) {
    return Math.pow(a2 + t4 * b10, y2);
  };
}
function hue$2(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$2(a2, d2 > 180 || d2 < -180 ? d2 - 360 * Math.round(d2 / 360) : d2) : constant$3(isNaN(a2) ? b10 : a2);
}
function gamma$2(y2) {
  return (y2 = +y2) === 1 ? nogamma$1 : function(a2, b10) {
    return b10 - a2 ? exponential$2(a2, b10, y2) : constant$3(isNaN(a2) ? b10 : a2);
  };
}
function nogamma$1(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear$2(a2, d2) : constant$3(isNaN(a2) ? b10 : a2);
}
var rgb$1 = function rgbGamma4(y2) {
  var color2 = gamma$2(y2);
  function rgb2(start2, end2) {
    var r2 = color2((start2 = rgb$2(start2)).r, (end2 = rgb$2(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity = nogamma$1(start2.opacity, end2.opacity);
    return function(t4) {
      start2.r = r2(t4);
      start2.g = g2(t4);
      start2.b = b10(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  }
  rgb2.gamma = rgbGamma4;
  return rgb2;
}(1);
function rgbSpline$1(spline) {
  return function(colors2) {
    var n2 = colors2.length, r2 = new Array(n2), g2 = new Array(n2), b10 = new Array(n2), i, color2;
    for (i = 0; i < n2; ++i) {
      color2 = rgb$2(colors2[i]);
      r2[i] = color2.r || 0;
      g2[i] = color2.g || 0;
      b10[i] = color2.b || 0;
    }
    r2 = spline(r2);
    g2 = spline(g2);
    b10 = spline(b10);
    color2.opacity = 1;
    return function(t4) {
      color2.r = r2(t4);
      color2.g = g2(t4);
      color2.b = b10(t4);
      return color2 + "";
    };
  };
}
var rgbBasis$1 = rgbSpline$1(basis$4);
var rgbBasisClosed = rgbSpline$1(basisClosed$1);
function numberArray(a2, b10) {
  if (!b10)
    b10 = [];
  var n2 = a2 ? Math.min(b10.length, a2.length) : 0, c2 = b10.slice(), i;
  return function(t4) {
    for (i = 0; i < n2; ++i)
      c2[i] = a2[i] * (1 - t4) + b10[i] * t4;
    return c2;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function array$1(a2, b10) {
  return (isNumberArray(b10) ? numberArray : genericArray)(a2, b10);
}
function genericArray(a2, b10) {
  var nb = b10 ? b10.length : 0, na = a2 ? Math.min(nb, a2.length) : 0, x2 = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i)
    x2[i] = interpolate(a2[i], b10[i]);
  for (; i < nb; ++i)
    c2[i] = b10[i];
  return function(t4) {
    for (i = 0; i < na; ++i)
      c2[i] = x2[i](t4);
    return c2;
  };
}
function date$1(a2, b10) {
  var d2 = new Date();
  return a2 = +a2, b10 = +b10, function(t4) {
    return d2.setTime(a2 * (1 - t4) + b10 * t4), d2;
  };
}
function interpolateNumber(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return a2 * (1 - t4) + b10 * t4;
  };
}
function object(a2, b10) {
  var i = {}, c2 = {}, k2;
  if (a2 === null || typeof a2 !== "object")
    a2 = {};
  if (b10 === null || typeof b10 !== "object")
    b10 = {};
  for (k2 in b10) {
    if (k2 in a2) {
      i[k2] = interpolate(a2[k2], b10[k2]);
    } else {
      c2[k2] = b10[k2];
    }
  }
  return function(t4) {
    for (k2 in i)
      c2[k2] = i[k2](t4);
    return c2;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b10) {
  return function() {
    return b10;
  };
}
function one(b10) {
  return function(t4) {
    return b10(t4) + "";
  };
}
function string(a2, b10) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s2 = [], q2 = [];
  a2 = a2 + "", b10 = b10 + "";
  while ((am = reA.exec(a2)) && (bm = reB.exec(b10))) {
    if ((bs = bm.index) > bi) {
      bs = b10.slice(bi, bs);
      if (s2[i])
        s2[i] += bs;
      else
        s2[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s2[i])
        s2[i] += bm;
      else
        s2[++i] = bm;
    } else {
      s2[++i] = null;
      q2.push({ i, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b10.length) {
    bs = b10.slice(bi);
    if (s2[i])
      s2[i] += bs;
    else
      s2[++i] = bs;
  }
  return s2.length < 2 ? q2[0] ? one(q2[0].x) : zero(b10) : (b10 = q2.length, function(t4) {
    for (var i2 = 0, o; i2 < b10; ++i2)
      s2[(o = q2[i2]).i] = o.x(t4);
    return s2.join("");
  });
}
function interpolate(a2, b10) {
  var t4 = typeof b10, c2;
  return b10 == null || t4 === "boolean" ? constant$3(b10) : (t4 === "number" ? interpolateNumber : t4 === "string" ? (c2 = color$1(b10)) ? (b10 = c2, rgb$1) : string : b10 instanceof color$1 ? rgb$1 : b10 instanceof Date ? date$1 : isNumberArray(b10) ? numberArray : Array.isArray(b10) ? genericArray : typeof b10.valueOf !== "function" && typeof b10.toString !== "function" || isNaN(b10) ? object : interpolateNumber)(a2, b10);
}
function discrete(range2) {
  var n2 = range2.length;
  return function(t4) {
    return range2[Math.max(0, Math.min(n2 - 1, Math.floor(t4 * n2)))];
  };
}
function hue$1(a2, b10) {
  var i = hue$2(+a2, +b10);
  return function(t4) {
    var x2 = i(t4);
    return x2 - 360 * Math.floor(x2 / 360);
  };
}
function interpolateRound(a2, b10) {
  return a2 = +a2, b10 = +b10, function(t4) {
    return Math.round(a2 * (1 - t4) + b10 * t4);
  };
}
var degrees$1 = 180 / Math.PI;
var identity$5 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function decompose(a2, b10, c2, d2, e3, f2) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a2 * a2 + b10 * b10))
    a2 /= scaleX, b10 /= scaleX;
  if (skewX = a2 * c2 + b10 * d2)
    c2 -= a2 * skewX, d2 -= b10 * skewX;
  if (scaleY = Math.sqrt(c2 * c2 + d2 * d2))
    c2 /= scaleY, d2 /= scaleY, skewX /= scaleY;
  if (a2 * d2 < b10 * c2)
    a2 = -a2, b10 = -b10, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e3,
    translateY: f2,
    rotate: Math.atan2(b10, a2) * degrees$1,
    skewX: Math.atan(skewX) * degrees$1,
    scaleX,
    scaleY
  };
}
var svgNode;
function parseCss(value) {
  const m2 = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m2.isIdentity ? identity$5 : decompose(m2.a, m2.b, m2.c, m2.d, m2.e, m2.f);
}
function parseSvg(value) {
  if (value == null)
    return identity$5;
  if (!svgNode)
    svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate()))
    return identity$5;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}
function interpolateTransform(parse2, pxComma, pxParen, degParen) {
  function pop(s2) {
    return s2.length ? s2.pop() + " " : "";
  }
  function translate(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push("translate(", null, pxComma, null, pxParen);
      q2.push({ i: i - 4, x: interpolateNumber(xa, xb) }, { i: i - 2, x: interpolateNumber(ya, yb) });
    } else if (xb || yb) {
      s2.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }
  function rotate(a2, b10, s2, q2) {
    if (a2 !== b10) {
      if (a2 - b10 > 180)
        b10 += 360;
      else if (b10 - a2 > 180)
        a2 += 360;
      q2.push({ i: s2.push(pop(s2) + "rotate(", null, degParen) - 2, x: interpolateNumber(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "rotate(" + b10 + degParen);
    }
  }
  function skewX(a2, b10, s2, q2) {
    if (a2 !== b10) {
      q2.push({ i: s2.push(pop(s2) + "skewX(", null, degParen) - 2, x: interpolateNumber(a2, b10) });
    } else if (b10) {
      s2.push(pop(s2) + "skewX(" + b10 + degParen);
    }
  }
  function scale(xa, ya, xb, yb, s2, q2) {
    if (xa !== xb || ya !== yb) {
      var i = s2.push(pop(s2) + "scale(", null, ",", null, ")");
      q2.push({ i: i - 4, x: interpolateNumber(xa, xb) }, { i: i - 2, x: interpolateNumber(ya, yb) });
    } else if (xb !== 1 || yb !== 1) {
      s2.push(pop(s2) + "scale(" + xb + "," + yb + ")");
    }
  }
  return function(a2, b10) {
    var s2 = [], q2 = [];
    a2 = parse2(a2), b10 = parse2(b10);
    translate(a2.translateX, a2.translateY, b10.translateX, b10.translateY, s2, q2);
    rotate(a2.rotate, b10.rotate, s2, q2);
    skewX(a2.skewX, b10.skewX, s2, q2);
    scale(a2.scaleX, a2.scaleY, b10.scaleX, b10.scaleY, s2, q2);
    a2 = b10 = null;
    return function(t4) {
      var i = -1, n2 = q2.length, o;
      while (++i < n2)
        s2[(o = q2[i]).i] = o.x(t4);
      return s2.join("");
    };
  };
}
var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
var epsilon2$1 = 1e-12;
function cosh$1(x2) {
  return ((x2 = Math.exp(x2)) + 1 / x2) / 2;
}
function sinh$1(x2) {
  return ((x2 = Math.exp(x2)) - 1 / x2) / 2;
}
function tanh$1(x2) {
  return ((x2 = Math.exp(2 * x2)) - 1) / (x2 + 1);
}
var zoom$1 = function zoomRho2(rho, rho2, rho4) {
  function zoom2(p02, p1) {
    var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < epsilon2$1) {
      S = Math.log(w1 / w0) / rho;
      i = function(t4) {
        return [
          ux0 + t4 * dx,
          uy0 + t4 * dy,
          w0 * Math.exp(rho * t4 * S)
        ];
      };
    } else {
      var d1 = Math.sqrt(d2), b02 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b12 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b02 * b02 + 1) - b02), r1 = Math.log(Math.sqrt(b12 * b12 + 1) - b12);
      S = (r1 - r0) / rho;
      i = function(t4) {
        var s2 = t4 * S, coshr0 = cosh$1(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh$1(rho * s2 + r0) - sinh$1(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh$1(rho * s2 + r0)
        ];
      };
    }
    i.duration = S * 1e3 * rho / Math.SQRT2;
    return i;
  }
  zoom2.rho = function(_2) {
    var _1 = Math.max(1e-3, +_2), _22 = _1 * _1, _4 = _22 * _22;
    return zoomRho2(_1, _22, _4);
  };
  return zoom2;
}(Math.SQRT2, 2, 4);
function hsl$1(hue2) {
  return function(start2, end2) {
    var h2 = hue2((start2 = hsl$3(start2)).h, (end2 = hsl$3(end2)).h), s2 = nogamma$1(start2.s, end2.s), l2 = nogamma$1(start2.l, end2.l), opacity = nogamma$1(start2.opacity, end2.opacity);
    return function(t4) {
      start2.h = h2(t4);
      start2.s = s2(t4);
      start2.l = l2(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  };
}
var hsl$2 = hsl$1(hue$2);
var hslLong = hsl$1(nogamma$1);
function lab(start2, end2) {
  var l2 = nogamma$1((start2 = lab$1(start2)).l, (end2 = lab$1(end2)).l), a2 = nogamma$1(start2.a, end2.a), b10 = nogamma$1(start2.b, end2.b), opacity = nogamma$1(start2.opacity, end2.opacity);
  return function(t4) {
    start2.l = l2(t4);
    start2.a = a2(t4);
    start2.b = b10(t4);
    start2.opacity = opacity(t4);
    return start2 + "";
  };
}
function hcl(hue2) {
  return function(start2, end2) {
    var h2 = hue2((start2 = hcl$2(start2)).h, (end2 = hcl$2(end2)).h), c2 = nogamma$1(start2.c, end2.c), l2 = nogamma$1(start2.l, end2.l), opacity = nogamma$1(start2.opacity, end2.opacity);
    return function(t4) {
      start2.h = h2(t4);
      start2.c = c2(t4);
      start2.l = l2(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  };
}
var hcl$1 = hcl(hue$2);
var hclLong = hcl(nogamma$1);
function cubehelix$3(hue2) {
  return function cubehelixGamma(y2) {
    y2 = +y2;
    function cubehelix2(start2, end2) {
      var h2 = hue2((start2 = cubehelix$5(start2)).h, (end2 = cubehelix$5(end2)).h), s2 = nogamma$1(start2.s, end2.s), l2 = nogamma$1(start2.l, end2.l), opacity = nogamma$1(start2.opacity, end2.opacity);
      return function(t4) {
        start2.h = h2(t4);
        start2.s = s2(t4);
        start2.l = l2(Math.pow(t4, y2));
        start2.opacity = opacity(t4);
        return start2 + "";
      };
    }
    cubehelix2.gamma = cubehelixGamma;
    return cubehelix2;
  }(1);
}
var cubehelix$4 = cubehelix$3(hue$2);
var cubehelixLong$1 = cubehelix$3(nogamma$1);
function piecewise(interpolate$12, values2) {
  if (values2 === void 0)
    values2 = interpolate$12, interpolate$12 = interpolate;
  var i = 0, n2 = values2.length - 1, v2 = values2[0], I = new Array(n2 < 0 ? 0 : n2);
  while (i < n2)
    I[i] = interpolate$12(v2, v2 = values2[++i]);
  return function(t4) {
    var i2 = Math.max(0, Math.min(n2 - 1, Math.floor(t4 *= n2)));
    return I[i2](t4 - i2);
  };
}
function quantize$1(interpolator, n2) {
  var samples = new Array(n2);
  for (var i = 0; i < n2; ++i)
    samples[i] = interpolator(i / (n2 - 1));
  return samples;
}
const pi$1 = Math.PI, tau$1 = 2 * pi$1, epsilon$1 = 1e-6, tauEpsilon = tau$1 - epsilon$1;
function Path() {
  this._x0 = this._y0 = this._x1 = this._y1 = null;
  this._ = "";
}
function path() {
  return new Path();
}
Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x2, y2) {
    this._ += "M" + (this._x0 = this._x1 = +x2) + "," + (this._y0 = this._y1 = +y2);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x2, y2) {
    this._ += "L" + (this._x1 = +x2) + "," + (this._y1 = +y2);
  },
  quadraticCurveTo: function(x12, y12, x2, y2) {
    this._ += "Q" + +x12 + "," + +y12 + "," + (this._x1 = +x2) + "," + (this._y1 = +y2);
  },
  bezierCurveTo: function(x12, y12, x2, y2, x3, y3) {
    this._ += "C" + +x12 + "," + +y12 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x3) + "," + (this._y1 = +y3);
  },
  arcTo: function(x12, y12, x2, y2, r2) {
    x12 = +x12, y12 = +y12, x2 = +x2, y2 = +y2, r2 = +r2;
    var x02 = this._x1, y02 = this._y1, x21 = x2 - x12, y21 = y2 - y12, x01 = x02 - x12, y01 = y02 - y12, l01_2 = x01 * x01 + y01 * y01;
    if (r2 < 0)
      throw new Error("negative radius: " + r2);
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x12) + "," + (this._y1 = y12);
    } else if (!(l01_2 > epsilon$1))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r2) {
      this._ += "L" + (this._x1 = x12) + "," + (this._y1 = y12);
    } else {
      var x20 = x2 - x02, y20 = y2 - y02, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x12 + t01 * x01) + "," + (y12 + t01 * y01);
      }
      this._ += "A" + r2 + "," + r2 + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x12 + t21 * x21) + "," + (this._y1 = y12 + t21 * y21);
    }
  },
  arc: function(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    var dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x02 = x2 + dx, y02 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (r2 < 0)
      throw new Error("negative radius: " + r2);
    if (this._x1 === null) {
      this._ += "M" + x02 + "," + y02;
    } else if (Math.abs(this._x1 - x02) > epsilon$1 || Math.abs(this._y1 - y02) > epsilon$1) {
      this._ += "L" + x02 + "," + y02;
    }
    if (!r2)
      return;
    if (da < 0)
      da = da % tau$1 + tau$1;
    if (da > tauEpsilon) {
      this._ += "A" + r2 + "," + r2 + ",0,1," + cw + "," + (x2 - dx) + "," + (y2 - dy) + "A" + r2 + "," + r2 + ",0,1," + cw + "," + (this._x1 = x02) + "," + (this._y1 = y02);
    } else if (da > epsilon$1) {
      this._ += "A" + r2 + "," + r2 + ",0," + +(da >= pi$1) + "," + cw + "," + (this._x1 = x2 + r2 * Math.cos(a1)) + "," + (this._y1 = y2 + r2 * Math.sin(a1));
    }
  },
  rect: function(x2, y2, w2, h2) {
    this._ += "M" + (this._x0 = this._x1 = +x2) + "," + (this._y0 = this._y1 = +y2) + "h" + +w2 + "v" + +h2 + "h" + -w2 + "Z";
  },
  toString: function() {
    return this._;
  }
};
function area$1(polygon) {
  var i = -1, n2 = polygon.length, a2, b10 = polygon[n2 - 1], area2 = 0;
  while (++i < n2) {
    a2 = b10;
    b10 = polygon[i];
    area2 += a2[1] * b10[0] - a2[0] * b10[1];
  }
  return area2 / 2;
}
function centroid(polygon) {
  var i = -1, n2 = polygon.length, x2 = 0, y2 = 0, a2, b10 = polygon[n2 - 1], c2, k2 = 0;
  while (++i < n2) {
    a2 = b10;
    b10 = polygon[i];
    k2 += c2 = a2[0] * b10[1] - b10[0] * a2[1];
    x2 += (a2[0] + b10[0]) * c2;
    y2 += (a2[1] + b10[1]) * c2;
  }
  return k2 *= 3, [x2 / k2, y2 / k2];
}
function cross$1(a2, b10, c2) {
  return (b10[0] - a2[0]) * (c2[1] - a2[1]) - (b10[1] - a2[1]) * (c2[0] - a2[0]);
}
function lexicographicOrder(a2, b10) {
  return a2[0] - b10[0] || a2[1] - b10[1];
}
function computeUpperHullIndexes(points) {
  const n2 = points.length, indexes2 = [0, 1];
  let size = 2, i;
  for (i = 2; i < n2; ++i) {
    while (size > 1 && cross$1(points[indexes2[size - 2]], points[indexes2[size - 1]], points[i]) <= 0)
      --size;
    indexes2[size++] = i;
  }
  return indexes2.slice(0, size);
}
function hull(points) {
  if ((n2 = points.length) < 3)
    return null;
  var i, n2, sortedPoints = new Array(n2), flippedPoints = new Array(n2);
  for (i = 0; i < n2; ++i)
    sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n2; ++i)
    flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
  var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
  var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull2 = [];
  for (i = upperIndexes.length - 1; i >= 0; --i)
    hull2.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)
    hull2.push(points[sortedPoints[lowerIndexes[i]][2]]);
  return hull2;
}
function contains(polygon, point2) {
  var n2 = polygon.length, p2 = polygon[n2 - 1], x2 = point2[0], y2 = point2[1], x02 = p2[0], y02 = p2[1], x12, y12, inside = false;
  for (var i = 0; i < n2; ++i) {
    p2 = polygon[i], x12 = p2[0], y12 = p2[1];
    if (y12 > y2 !== y02 > y2 && x2 < (x02 - x12) * (y2 - y12) / (y02 - y12) + x12)
      inside = !inside;
    x02 = x12, y02 = y12;
  }
  return inside;
}
function length(polygon) {
  var i = -1, n2 = polygon.length, b10 = polygon[n2 - 1], xa, ya, xb = b10[0], yb = b10[1], perimeter = 0;
  while (++i < n2) {
    xa = xb;
    ya = yb;
    b10 = polygon[i];
    xb = b10[0];
    yb = b10[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.hypot(xa, ya);
  }
  return perimeter;
}
var defaultSource = Math.random;
var uniform = function sourceRandomUniform(source) {
  function randomUniform(min2, max2) {
    min2 = min2 == null ? 0 : +min2;
    max2 = max2 == null ? 1 : +max2;
    if (arguments.length === 1)
      max2 = min2, min2 = 0;
    else
      max2 -= min2;
    return function() {
      return source() * max2 + min2;
    };
  }
  randomUniform.source = sourceRandomUniform;
  return randomUniform;
}(defaultSource);
var int = function sourceRandomInt(source) {
  function randomInt(min2, max2) {
    if (arguments.length < 2)
      max2 = min2, min2 = 0;
    min2 = Math.floor(min2);
    max2 = Math.floor(max2) - min2;
    return function() {
      return Math.floor(source() * max2 + min2);
    };
  }
  randomInt.source = sourceRandomInt;
  return randomInt;
}(defaultSource);
var normal = function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x2, r2;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y2;
      if (x2 != null)
        y2 = x2, x2 = null;
      else
        do {
          x2 = source() * 2 - 1;
          y2 = source() * 2 - 1;
          r2 = x2 * x2 + y2 * y2;
        } while (!r2 || r2 > 1);
      return mu + sigma * y2 * Math.sqrt(-2 * Math.log(r2) / r2);
    };
  }
  randomNormal.source = sourceRandomNormal;
  return randomNormal;
}(defaultSource);
var logNormal = function sourceRandomLogNormal(source) {
  var N = normal.source(source);
  function randomLogNormal() {
    var randomNormal = N.apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }
  randomLogNormal.source = sourceRandomLogNormal;
  return randomLogNormal;
}(defaultSource);
var irwinHall = function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n2) {
    if ((n2 = +n2) <= 0)
      return () => 0;
    return function() {
      for (var sum2 = 0, i = n2; i > 1; --i)
        sum2 += source();
      return sum2 + i * source();
    };
  }
  randomIrwinHall.source = sourceRandomIrwinHall;
  return randomIrwinHall;
}(defaultSource);
var bates = function sourceRandomBates(source) {
  var I = irwinHall.source(source);
  function randomBates(n2) {
    if ((n2 = +n2) === 0)
      return source;
    var randomIrwinHall = I(n2);
    return function() {
      return randomIrwinHall() / n2;
    };
  }
  randomBates.source = sourceRandomBates;
  return randomBates;
}(defaultSource);
var exponential$1 = function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log1p(-source()) / lambda;
    };
  }
  randomExponential.source = sourceRandomExponential;
  return randomExponential;
}(defaultSource);
var pareto = function sourceRandomPareto(source) {
  function randomPareto(alpha2) {
    if ((alpha2 = +alpha2) < 0)
      throw new RangeError("invalid alpha");
    alpha2 = 1 / -alpha2;
    return function() {
      return Math.pow(1 - source(), alpha2);
    };
  }
  randomPareto.source = sourceRandomPareto;
  return randomPareto;
}(defaultSource);
var bernoulli = function sourceRandomBernoulli(source) {
  function randomBernoulli(p2) {
    if ((p2 = +p2) < 0 || p2 > 1)
      throw new RangeError("invalid p");
    return function() {
      return Math.floor(source() + p2);
    };
  }
  randomBernoulli.source = sourceRandomBernoulli;
  return randomBernoulli;
}(defaultSource);
var geometric = function sourceRandomGeometric(source) {
  function randomGeometric(p2) {
    if ((p2 = +p2) < 0 || p2 > 1)
      throw new RangeError("invalid p");
    if (p2 === 0)
      return () => Infinity;
    if (p2 === 1)
      return () => 1;
    p2 = Math.log1p(-p2);
    return function() {
      return 1 + Math.floor(Math.log1p(-source()) / p2);
    };
  }
  randomGeometric.source = sourceRandomGeometric;
  return randomGeometric;
}(defaultSource);
var gamma$1 = function sourceRandomGamma(source) {
  var randomNormal = normal.source(source)();
  function randomGamma(k2, theta) {
    if ((k2 = +k2) < 0)
      throw new RangeError("invalid k");
    if (k2 === 0)
      return () => 0;
    theta = theta == null ? 1 : +theta;
    if (k2 === 1)
      return () => -Math.log1p(-source()) * theta;
    var d2 = (k2 < 1 ? k2 + 1 : k2) - 1 / 3, c2 = 1 / (3 * Math.sqrt(d2)), multiplier = k2 < 1 ? () => Math.pow(source(), 1 / k2) : () => 1;
    return function() {
      do {
        do {
          var x2 = randomNormal(), v2 = 1 + c2 * x2;
        } while (v2 <= 0);
        v2 *= v2 * v2;
        var u = 1 - source();
      } while (u >= 1 - 0.0331 * x2 * x2 * x2 * x2 && Math.log(u) >= 0.5 * x2 * x2 + d2 * (1 - v2 + Math.log(v2)));
      return d2 * v2 * multiplier() * theta;
    };
  }
  randomGamma.source = sourceRandomGamma;
  return randomGamma;
}(defaultSource);
var beta = function sourceRandomBeta(source) {
  var G = gamma$1.source(source);
  function randomBeta(alpha2, beta2) {
    var X3 = G(alpha2), Y3 = G(beta2);
    return function() {
      var x2 = X3();
      return x2 === 0 ? 0 : x2 / (x2 + Y3());
    };
  }
  randomBeta.source = sourceRandomBeta;
  return randomBeta;
}(defaultSource);
var binomial = function sourceRandomBinomial(source) {
  var G = geometric.source(source), B2 = beta.source(source);
  function randomBinomial(n2, p2) {
    n2 = +n2;
    if ((p2 = +p2) >= 1)
      return () => n2;
    if (p2 <= 0)
      return () => 0;
    return function() {
      var acc = 0, nn = n2, pp = p2;
      while (nn * pp > 16 && nn * (1 - pp) > 16) {
        var i = Math.floor((nn + 1) * pp), y2 = B2(i, nn - i + 1)();
        if (y2 <= pp) {
          acc += i;
          nn -= i;
          pp = (pp - y2) / (1 - y2);
        } else {
          nn = i - 1;
          pp /= y2;
        }
      }
      var sign2 = pp < 0.5, pFinal = sign2 ? pp : 1 - pp, g2 = G(pFinal);
      for (var s2 = g2(), k2 = 0; s2 <= nn; ++k2)
        s2 += g2();
      return acc + (sign2 ? k2 : nn - k2);
    };
  }
  randomBinomial.source = sourceRandomBinomial;
  return randomBinomial;
}(defaultSource);
var weibull = function sourceRandomWeibull(source) {
  function randomWeibull(k2, a2, b10) {
    var outerFunc;
    if ((k2 = +k2) === 0) {
      outerFunc = (x2) => -Math.log(x2);
    } else {
      k2 = 1 / k2;
      outerFunc = (x2) => Math.pow(x2, k2);
    }
    a2 = a2 == null ? 0 : +a2;
    b10 = b10 == null ? 1 : +b10;
    return function() {
      return a2 + b10 * outerFunc(-Math.log1p(-source()));
    };
  }
  randomWeibull.source = sourceRandomWeibull;
  return randomWeibull;
}(defaultSource);
var cauchy = function sourceRandomCauchy(source) {
  function randomCauchy(a2, b10) {
    a2 = a2 == null ? 0 : +a2;
    b10 = b10 == null ? 1 : +b10;
    return function() {
      return a2 + b10 * Math.tan(Math.PI * source());
    };
  }
  randomCauchy.source = sourceRandomCauchy;
  return randomCauchy;
}(defaultSource);
var logistic = function sourceRandomLogistic(source) {
  function randomLogistic(a2, b10) {
    a2 = a2 == null ? 0 : +a2;
    b10 = b10 == null ? 1 : +b10;
    return function() {
      var u = source();
      return a2 + b10 * Math.log(u / (1 - u));
    };
  }
  randomLogistic.source = sourceRandomLogistic;
  return randomLogistic;
}(defaultSource);
var poisson = function sourceRandomPoisson(source) {
  var G = gamma$1.source(source), B2 = binomial.source(source);
  function randomPoisson(lambda) {
    return function() {
      var acc = 0, l2 = lambda;
      while (l2 > 16) {
        var n2 = Math.floor(0.875 * l2), t4 = G(n2)();
        if (t4 > l2)
          return acc + B2(n2 - 1, l2 / t4)();
        acc += n2;
        l2 -= t4;
      }
      for (var s2 = -Math.log1p(-source()), k2 = 0; s2 <= l2; ++k2)
        s2 -= Math.log1p(-source());
      return acc + k2;
    };
  }
  randomPoisson.source = sourceRandomPoisson;
  return randomPoisson;
}(defaultSource);
const mul = 1664525;
const inc = 1013904223;
const eps = 1 / 4294967296;
function lcg(seed = Math.random()) {
  let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
  return () => (state = mul * state + inc | 0, eps * (state >>> 0));
}
function initRange(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function")
        this.interpolator(domain2);
      else
        this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function")
        this.interpolator(interpolator);
      else
        this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = /* @__PURE__ */ new Map(), domain2 = [], range2 = [], unknown2 = implicit;
  function scale(d2) {
    var key = d2 + "", i = index2.get(key);
    if (!i) {
      if (unknown2 !== implicit)
        return unknown2;
      index2.set(key, i = domain2.push(d2));
    }
    return range2[(i - 1) % range2.length];
  }
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [], index2 = /* @__PURE__ */ new Map();
    for (const value of _2) {
      const key = value + "";
      if (index2.has(key))
        continue;
      index2.set(key, domain2.push(value));
    }
    return scale;
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), scale) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return ordinal(domain2, range2).unknown(unknown2);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step2, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align2 = 0.5;
  delete scale.unknown;
  function rescale() {
    var n2 = domain2().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop = reverse2 ? r0 : r1;
    step2 = (stop - start2) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round2)
      step2 = Math.floor(step2);
    start2 += (stop - start2 - step2 * (n2 - paddingInner)) * align2;
    bandwidth = step2 * (1 - paddingInner);
    if (round2)
      start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values2 = sequence(n2).map(function(i) {
      return start2 + step2 * i;
    });
    return ordinalRange(reverse2 ? values2.reverse() : values2);
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.range = function(_2) {
    return arguments.length ? ([r0, r1] = _2, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_2) {
    return [r0, r1] = _2, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step2;
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, rescale()) : round2;
  };
  scale.padding = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_2), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, _2), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_2) {
    return arguments.length ? (paddingOuter = +_2, rescale()) : paddingOuter;
  };
  scale.align = function(_2) {
    return arguments.length ? (align2 = Math.max(0, Math.min(1, _2)), rescale()) : align2;
  };
  scale.copy = function() {
    return band(domain2(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align2);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish(copy2());
  };
  return scale;
}
function point$4() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function constants(x2) {
  return function() {
    return x2;
  };
}
function number$1(x2) {
  return +x2;
}
var unit = [0, 1];
function identity$4(x2) {
  return x2;
}
function normalize(a2, b10) {
  return (b10 -= a2 = +a2) ? function(x2) {
    return (x2 - a2) / b10;
  } : constants(isNaN(b10) ? NaN : 0.5);
}
function clamper(a2, b10) {
  var t4;
  if (a2 > b10)
    t4 = a2, a2 = b10, b10 = t4;
  return function(x2) {
    return Math.max(a2, Math.min(b10, x2));
  };
}
function bimap(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0)
    d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain2, range2, interpolate2) {
  var j = Math.min(domain2.length, range2.length) - 1, d2 = new Array(j), r2 = new Array(j), i = -1;
  if (domain2[j] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i < j) {
    d2[i] = normalize(domain2[i], domain2[i + 1]);
    r2[i] = interpolate2(range2[i], range2[i + 1]);
  }
  return function(x2) {
    var i2 = bisect(domain2, x2, 1, j) - 1;
    return r2[i2](d2[i2](x2));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$2() {
  var domain2 = unit, range2 = unit, interpolate$12 = interpolate, transform2, untransform, unknown2, clamp2 = identity$4, piecewise2, output, input;
  function rescale() {
    var n2 = Math.min(domain2.length, range2.length);
    if (clamp2 !== identity$4)
      clamp2 = clamper(domain2[0], domain2[n2 - 1]);
    piecewise2 = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : (output || (output = piecewise2(domain2.map(transform2), range2, interpolate$12)))(transform2(clamp2(x2)));
  }
  scale.invert = function(y2) {
    return clamp2(untransform((input || (input = piecewise2(range2, domain2.map(transform2), interpolateNumber)))(y2)));
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$1), rescale()) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return range2 = Array.from(_2), interpolate$12 = interpolateRound, rescale();
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = _2 ? true : identity$4, rescale()) : clamp2 !== identity$4;
  };
  scale.interpolate = function(_2) {
    return arguments.length ? (interpolate$12 = _2, rescale()) : interpolate$12;
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4, u) {
    transform2 = t4, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer$2()(identity$4, identity$4);
}
function tickFormat(start2, stop, count2, specifier) {
  var step2 = tickStep$1(start2, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step2, value)))
        specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step2, Math.max(Math.abs(start2), Math.abs(stop)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step2)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d2 = domain2();
    return ticks(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d2 = domain2();
    return tickFormat(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null)
      count2 = 10;
    var d2 = domain2();
    var i0 = 0;
    var i1 = d2.length - 1;
    var start2 = d2[i0];
    var stop = d2[i1];
    var prestep;
    var step2;
    var maxIter = 10;
    if (stop < start2) {
      step2 = start2, start2 = stop, stop = step2;
      step2 = i0, i0 = i1, i1 = step2;
    }
    while (maxIter-- > 0) {
      step2 = tickIncrement(start2, stop, count2);
      if (step2 === prestep) {
        d2[i0] = start2;
        d2[i1] = stop;
        return domain2(d2);
      } else if (step2 > 0) {
        start2 = Math.floor(start2 / step2) * step2;
        stop = Math.ceil(stop / step2) * step2;
      } else if (step2 < 0) {
        start2 = Math.ceil(start2 * step2) / step2;
        stop = Math.floor(stop * step2) / step2;
      } else {
        break;
      }
      prestep = step2;
    }
    return scale;
  };
  return scale;
}
function linear$1() {
  var scale = continuous();
  scale.copy = function() {
    return copy$1(scale, linear$1());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function identity$3(domain2) {
  var unknown2;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : x2;
  }
  scale.invert = scale;
  scale.domain = scale.range = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$1), scale) : domain2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return identity$3(domain2).unknown(unknown2);
  };
  domain2 = arguments.length ? Array.from(domain2, number$1) : [0, 1];
  return linearish(scale);
}
function nice(domain2, interval2) {
  domain2 = domain2.slice();
  var i0 = 0, i1 = domain2.length - 1, x02 = domain2[i0], x12 = domain2[i1], t4;
  if (x12 < x02) {
    t4 = i0, i0 = i1, i1 = t4;
    t4 = x02, x02 = x12, x12 = t4;
  }
  domain2[i0] = interval2.floor(x02);
  domain2[i1] = interval2.ceil(x12);
  return domain2;
}
function transformLog(x2) {
  return Math.log(x2);
}
function transformExp(x2) {
  return Math.exp(x2);
}
function transformLogn(x2) {
  return -Math.log(-x2);
}
function transformExpn(x2) {
  return -Math.exp(-x2);
}
function pow10(x2) {
  return isFinite(x2) ? +("1e" + x2) : x2 < 0 ? 0 : x2;
}
function powp(base2) {
  return base2 === 10 ? pow10 : base2 === Math.E ? Math.exp : function(x2) {
    return Math.pow(base2, x2);
  };
}
function logp(base2) {
  return base2 === Math.E ? Math.log : base2 === 10 && Math.log10 || base2 === 2 && Math.log2 || (base2 = Math.log(base2), function(x2) {
    return Math.log(x2) / base2;
  });
}
function reflect(f2) {
  return function(x2) {
    return -f2(-x2);
  };
}
function loggish(transform2) {
  var scale = transform2(transformLog, transformExp), domain2 = scale.domain, base2 = 10, logs, pows;
  function rescale() {
    logs = logp(base2), pows = powp(base2);
    if (domain2()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform2(transformLogn, transformExpn);
    } else {
      transform2(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function(_2) {
    return arguments.length ? (base2 = +_2, rescale()) : base2;
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.ticks = function(count2) {
    var d2 = domain2(), u = d2[0], v2 = d2[d2.length - 1], r2;
    if (r2 = v2 < u)
      i = u, u = v2, v2 = i;
    var i = logs(u), j = logs(v2), p2, k2, t4, n2 = count2 == null ? 10 : +count2, z2 = [];
    if (!(base2 % 1) && j - i < n2) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0)
        for (; i <= j; ++i) {
          for (k2 = 1, p2 = pows(i); k2 < base2; ++k2) {
            t4 = p2 * k2;
            if (t4 < u)
              continue;
            if (t4 > v2)
              break;
            z2.push(t4);
          }
        }
      else
        for (; i <= j; ++i) {
          for (k2 = base2 - 1, p2 = pows(i); k2 >= 1; --k2) {
            t4 = p2 * k2;
            if (t4 < u)
              continue;
            if (t4 > v2)
              break;
            z2.push(t4);
          }
        }
      if (z2.length * 2 < n2)
        z2 = ticks(u, v2, n2);
    } else {
      z2 = ticks(i, j, Math.min(j - i, n2)).map(pows);
    }
    return r2 ? z2.reverse() : z2;
  };
  scale.tickFormat = function(count2, specifier) {
    if (specifier == null)
      specifier = base2 === 10 ? ".0e" : ",";
    if (typeof specifier !== "function")
      specifier = format(specifier);
    if (count2 === Infinity)
      return specifier;
    if (count2 == null)
      count2 = 10;
    var k2 = Math.max(1, base2 * count2 / scale.ticks().length);
    return function(d2) {
      var i = d2 / pows(Math.round(logs(d2)));
      if (i * base2 < base2 - 0.5)
        i *= base2;
      return i <= k2 ? specifier(d2) : "";
    };
  };
  scale.nice = function() {
    return domain2(nice(domain2(), {
      floor: function(x2) {
        return pows(Math.floor(logs(x2)));
      },
      ceil: function(x2) {
        return pows(Math.ceil(logs(x2)));
      }
    }));
  };
  return scale;
}
function log() {
  var scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = function() {
    return copy$1(scale, log()).base(scale.base());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function transformSymlog(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.log1p(Math.abs(x2 / c2));
  };
}
function transformSymexp(c2) {
  return function(x2) {
    return Math.sign(x2) * Math.expm1(Math.abs(x2)) * c2;
  };
}
function symlogish(transform2) {
  var c2 = 1, scale = transform2(transformSymlog(c2), transformSymexp(c2));
  scale.constant = function(_2) {
    return arguments.length ? transform2(transformSymlog(c2 = +_2), transformSymexp(c2)) : c2;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}
function transformPow(exponent2) {
  return function(x2) {
    return x2 < 0 ? -Math.pow(-x2, exponent2) : Math.pow(x2, exponent2);
  };
}
function transformSqrt(x2) {
  return x2 < 0 ? -Math.sqrt(-x2) : Math.sqrt(x2);
}
function transformSquare(x2) {
  return x2 < 0 ? -x2 * x2 : x2 * x2;
}
function powish(transform2) {
  var scale = transform2(identity$4, identity$4), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform2(identity$4, identity$4) : exponent2 === 0.5 ? transform2(transformSqrt, transformSquare) : transform2(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale.exponent = function(_2) {
    return arguments.length ? (exponent2 = +_2, rescale()) : exponent2;
  };
  return linearish(scale);
}
function pow() {
  var scale = powish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, pow()).exponent(scale.exponent());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function sqrt$1() {
  return pow.apply(null, arguments).exponent(0.5);
}
function square$1(x2) {
  return Math.sign(x2) * x2 * x2;
}
function unsquare(x2) {
  return Math.sign(x2) * Math.sqrt(Math.abs(x2));
}
function radial() {
  var squared = continuous(), range2 = [0, 1], round2 = false, unknown2;
  function scale(x2) {
    var y2 = unsquare(squared(x2));
    return isNaN(y2) ? unknown2 : round2 ? Math.round(y2) : y2;
  }
  scale.invert = function(y2) {
    return squared.invert(square$1(y2));
  };
  scale.domain = function(_2) {
    return arguments.length ? (squared.domain(_2), scale) : squared.domain();
  };
  scale.range = function(_2) {
    return arguments.length ? (squared.range((range2 = Array.from(_2, number$1)).map(square$1)), scale) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return scale.range(_2).round(true);
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, scale) : round2;
  };
  scale.clamp = function(_2) {
    return arguments.length ? (squared.clamp(_2), scale) : squared.clamp();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return radial(squared.domain(), range2).round(round2).clamp(squared.clamp()).unknown(unknown2);
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function quantile() {
  var domain2 = [], range2 = [], thresholds = [], unknown2;
  function rescale() {
    var i = 0, n2 = Math.max(1, range2.length);
    thresholds = new Array(n2 - 1);
    while (++i < n2)
      thresholds[i - 1] = quantileSorted(domain2, i / n2);
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : range2[bisect(thresholds, x2)];
  }
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain2[0],
      i < thresholds.length ? thresholds[i] : domain2[domain2.length - 1]
    ];
  };
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d2 of _2)
      if (d2 != null && !isNaN(d2 = +d2))
        domain2.push(d2);
    domain2.sort(ascending$3);
    return rescale();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.quantiles = function() {
    return thresholds.slice();
  };
  scale.copy = function() {
    return quantile().domain(domain2).range(range2).unknown(unknown2);
  };
  return initRange.apply(scale, arguments);
}
function quantize() {
  var x02 = 0, x12 = 1, n2 = 1, domain2 = [0.5], range2 = [0, 1], unknown2;
  function scale(x2) {
    return x2 != null && x2 <= x2 ? range2[bisect(domain2, x2, 0, n2)] : unknown2;
  }
  function rescale() {
    var i = -1;
    domain2 = new Array(n2);
    while (++i < n2)
      domain2[i] = ((i + 1) * x12 - (i - n2) * x02) / (n2 + 1);
    return scale;
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12] = _2, x02 = +x02, x12 = +x12, rescale()) : [x02, x12];
  };
  scale.range = function(_2) {
    return arguments.length ? (n2 = (range2 = Array.from(_2)).length - 1, rescale()) : range2.slice();
  };
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x02, domain2[0]] : i >= n2 ? [domain2[n2 - 1], x12] : [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : scale;
  };
  scale.thresholds = function() {
    return domain2.slice();
  };
  scale.copy = function() {
    return quantize().domain([x02, x12]).range(range2).unknown(unknown2);
  };
  return initRange.apply(linearish(scale), arguments);
}
function threshold() {
  var domain2 = [0.5], range2 = [0, 1], unknown2, n2 = 1;
  function scale(x2) {
    return x2 != null && x2 <= x2 ? range2[bisect(domain2, x2, 0, n2)] : unknown2;
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2), n2 = Math.min(domain2.length, range2.length - 1), scale) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), n2 = Math.min(domain2.length, range2.length - 1), scale) : range2.slice();
  };
  scale.invertExtent = function(y2) {
    var i = range2.indexOf(y2);
    return [domain2[i - 1], domain2[i]];
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  scale.copy = function() {
    return threshold().domain(domain2).range(range2).unknown(unknown2);
  };
  return initRange.apply(scale, arguments);
}
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count2, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? new Date() : new Date(+date2)), date2;
  }
  interval2.floor = function(date2) {
    return floori(date2 = new Date(+date2)), date2;
  };
  interval2.ceil = function(date2) {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = function(date2) {
    var d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = function(date2, step2) {
    return offseti(date2 = new Date(+date2), step2 == null ? 1 : Math.floor(step2)), date2;
  };
  interval2.range = function(start2, stop, step2) {
    var range2 = [], previous;
    start2 = interval2.ceil(start2);
    step2 = step2 == null ? 1 : Math.floor(step2);
    if (!(start2 < stop) || !(step2 > 0))
      return range2;
    do
      range2.push(previous = new Date(+start2)), offseti(start2, step2), floori(start2);
    while (previous < start2 && start2 < stop);
    return range2;
  };
  interval2.filter = function(test) {
    return newInterval(function(date2) {
      if (date2 >= date2)
        while (floori(date2), !test(date2))
          date2.setTime(date2 - 1);
    }, function(date2, step2) {
      if (date2 >= date2) {
        if (step2 < 0)
          while (++step2 <= 0) {
            while (offseti(date2, -1), !test(date2)) {
            }
          }
        else
          while (--step2 >= 0) {
            while (offseti(date2, 1), !test(date2)) {
            }
          }
      }
    });
  };
  if (count2) {
    interval2.count = function(start2, end2) {
      t0.setTime(+start2), t1.setTime(+end2);
      floori(t0), floori(t1);
      return Math.floor(count2(t0, t1));
    };
    interval2.every = function(step2) {
      step2 = Math.floor(step2);
      return !isFinite(step2) || !(step2 > 0) ? null : !(step2 > 1) ? interval2 : interval2.filter(field ? function(d2) {
        return field(d2) % step2 === 0;
      } : function(d2) {
        return interval2.count(0, d2) % step2 === 0;
      });
    };
  }
  return interval2;
}
var millisecond = newInterval(function() {
}, function(date2, step2) {
  date2.setTime(+date2 + step2);
}, function(start2, end2) {
  return end2 - start2;
});
millisecond.every = function(k2) {
  k2 = Math.floor(k2);
  if (!isFinite(k2) || !(k2 > 0))
    return null;
  if (!(k2 > 1))
    return millisecond;
  return newInterval(function(date2) {
    date2.setTime(Math.floor(date2 / k2) * k2);
  }, function(date2, step2) {
    date2.setTime(+date2 + step2 * k2);
  }, function(start2, end2) {
    return (end2 - start2) / k2;
  });
};
var millisecond$1 = millisecond;
var milliseconds = millisecond.range;
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
var second = newInterval(function(date2) {
  date2.setTime(date2 - date2.getMilliseconds());
}, function(date2, step2) {
  date2.setTime(+date2 + step2 * durationSecond);
}, function(start2, end2) {
  return (end2 - start2) / durationSecond;
}, function(date2) {
  return date2.getUTCSeconds();
});
var utcSecond = second;
var seconds = second.range;
var minute = newInterval(function(date2) {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, function(date2, step2) {
  date2.setTime(+date2 + step2 * durationMinute);
}, function(start2, end2) {
  return (end2 - start2) / durationMinute;
}, function(date2) {
  return date2.getMinutes();
});
var timeMinute = minute;
var minutes = minute.range;
var hour = newInterval(function(date2) {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, function(date2, step2) {
  date2.setTime(+date2 + step2 * durationHour);
}, function(start2, end2) {
  return (end2 - start2) / durationHour;
}, function(date2) {
  return date2.getHours();
});
var timeHour = hour;
var hours = hour.range;
var day = newInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step2) => date2.setDate(date2.getDate() + step2),
  (start2, end2) => (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationDay,
  (date2) => date2.getDate() - 1
);
var timeDay = day;
var days = day.range;
function weekday(i) {
  return newInterval(function(date2) {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i) % 7);
    date2.setHours(0, 0, 0, 0);
  }, function(date2, step2) {
    date2.setDate(date2.getDate() + step2 * 7);
  }, function(start2, end2) {
    return (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;
var month = newInterval(function(date2) {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, function(date2, step2) {
  date2.setMonth(date2.getMonth() + step2);
}, function(start2, end2) {
  return end2.getMonth() - start2.getMonth() + (end2.getFullYear() - start2.getFullYear()) * 12;
}, function(date2) {
  return date2.getMonth();
});
var timeMonth = month;
var months = month.range;
var year = newInterval(function(date2) {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, function(date2, step2) {
  date2.setFullYear(date2.getFullYear() + step2);
}, function(start2, end2) {
  return end2.getFullYear() - start2.getFullYear();
}, function(date2) {
  return date2.getFullYear();
});
year.every = function(k2) {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : newInterval(function(date2) {
    date2.setFullYear(Math.floor(date2.getFullYear() / k2) * k2);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, function(date2, step2) {
    date2.setFullYear(date2.getFullYear() + step2 * k2);
  });
};
var timeYear = year;
var years = year.range;
var utcMinute = newInterval(function(date2) {
  date2.setUTCSeconds(0, 0);
}, function(date2, step2) {
  date2.setTime(+date2 + step2 * durationMinute);
}, function(start2, end2) {
  return (end2 - start2) / durationMinute;
}, function(date2) {
  return date2.getUTCMinutes();
});
var utcMinute$1 = utcMinute;
var utcMinutes = utcMinute.range;
var utcHour = newInterval(function(date2) {
  date2.setUTCMinutes(0, 0, 0);
}, function(date2, step2) {
  date2.setTime(+date2 + step2 * durationHour);
}, function(start2, end2) {
  return (end2 - start2) / durationHour;
}, function(date2) {
  return date2.getUTCHours();
});
var utcHour$1 = utcHour;
var utcHours = utcHour.range;
var utcDay = newInterval(function(date2) {
  date2.setUTCHours(0, 0, 0, 0);
}, function(date2, step2) {
  date2.setUTCDate(date2.getUTCDate() + step2);
}, function(start2, end2) {
  return (end2 - start2) / durationDay;
}, function(date2) {
  return date2.getUTCDate() - 1;
});
var utcDay$1 = utcDay;
var utcDays = utcDay.range;
function utcWeekday(i) {
  return newInterval(function(date2) {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, function(date2, step2) {
    date2.setUTCDate(date2.getUTCDate() + step2 * 7);
  }, function(start2, end2) {
    return (end2 - start2) / durationWeek;
  });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;
var utcMonth = newInterval(function(date2) {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, function(date2, step2) {
  date2.setUTCMonth(date2.getUTCMonth() + step2);
}, function(start2, end2) {
  return end2.getUTCMonth() - start2.getUTCMonth() + (end2.getUTCFullYear() - start2.getUTCFullYear()) * 12;
}, function(date2) {
  return date2.getUTCMonth();
});
var utcMonth$1 = utcMonth;
var utcMonths = utcMonth.range;
var utcYear = newInterval(function(date2) {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, function(date2, step2) {
  date2.setUTCFullYear(date2.getUTCFullYear() + step2);
}, function(start2, end2) {
  return end2.getUTCFullYear() - start2.getUTCFullYear();
}, function(date2) {
  return date2.getUTCFullYear();
});
utcYear.every = function(k2) {
  return !isFinite(k2 = Math.floor(k2)) || !(k2 > 0) ? null : newInterval(function(date2) {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k2) * k2);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, function(date2, step2) {
    date2.setUTCFullYear(date2.getUTCFullYear() + step2 * k2);
  });
};
var utcYear$1 = utcYear;
var utcYears = utcYear.range;
function ticker(year2, month2, week, day2, hour2, minute2) {
  const tickIntervals = [
    [utcSecond, 1, durationSecond],
    [utcSecond, 5, 5 * durationSecond],
    [utcSecond, 15, 15 * durationSecond],
    [utcSecond, 30, 30 * durationSecond],
    [minute2, 1, durationMinute],
    [minute2, 5, 5 * durationMinute],
    [minute2, 15, 15 * durationMinute],
    [minute2, 30, 30 * durationMinute],
    [hour2, 1, durationHour],
    [hour2, 3, 3 * durationHour],
    [hour2, 6, 6 * durationHour],
    [hour2, 12, 12 * durationHour],
    [day2, 1, durationDay],
    [day2, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month2, 1, durationMonth],
    [month2, 3, 3 * durationMonth],
    [year2, 1, durationYear]
  ];
  function ticks2(start2, stop, count2) {
    const reverse2 = stop < start2;
    if (reverse2)
      [start2, stop] = [stop, start2];
    const interval2 = count2 && typeof count2.range === "function" ? count2 : tickInterval(start2, stop, count2);
    const ticks3 = interval2 ? interval2.range(start2, +stop + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop, count2) {
    const target = Math.abs(stop - start2) / count2;
    const i = bisector(([, , step3]) => step3).right(tickIntervals, target);
    if (i === tickIntervals.length)
      return year2.every(tickStep$1(start2 / durationYear, stop / durationYear, count2));
    if (i === 0)
      return millisecond$1.every(Math.max(tickStep$1(start2, stop, count2), 1));
    const [t4, step2] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t4.every(step2);
  }
  return [ticks2, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear$1, utcMonth$1, utcSunday, utcDay$1, utcHour$1, utcMinute$1);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, sunday, timeDay, timeHour, timeMinute);
function localDate(d2) {
  if (0 <= d2.y && d2.y < 100) {
    var date2 = new Date(-1, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L);
    date2.setFullYear(d2.y);
    return date2;
  }
  return new Date(d2.y, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L);
}
function utcDate(d2) {
  if (0 <= d2.y && d2.y < 100) {
    var date2 = new Date(Date.UTC(-1, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L));
    date2.setUTCFullYear(d2.y);
    return date2;
  }
  return new Date(Date.UTC(d2.y, d2.m, d2.d, d2.H, d2.M, d2.S, d2.L));
}
function newDate(y2, m2, d2) {
  return { y: y2, m: m2, d: d2, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string2 = [], i = -1, j = 0, n2 = specifier.length, c2, pad2, format2;
      if (!(date2 instanceof Date))
        date2 = new Date(+date2);
      while (++i < n2) {
        if (specifier.charCodeAt(i) === 37) {
          string2.push(specifier.slice(j, i));
          if ((pad2 = pads[c2 = specifier.charAt(++i)]) != null)
            c2 = specifier.charAt(++i);
          else
            pad2 = c2 === "e" ? " " : "0";
          if (format2 = formats2[c2])
            c2 = format2(date2, pad2);
          string2.push(c2);
          j = i + 1;
        }
      }
      string2.push(specifier.slice(j, i));
      return string2.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string2) {
      var d2 = newDate(1900, void 0, 1), i = parseSpecifier(d2, specifier, string2 += "", 0), week, day2;
      if (i != string2.length)
        return null;
      if ("Q" in d2)
        return new Date(d2.Q);
      if ("s" in d2)
        return new Date(d2.s * 1e3 + ("L" in d2 ? d2.L : 0));
      if (Z && !("Z" in d2))
        d2.Z = 0;
      if ("p" in d2)
        d2.H = d2.H % 12 + d2.p * 12;
      if (d2.m === void 0)
        d2.m = "q" in d2 ? d2.q : 0;
      if ("V" in d2) {
        if (d2.V < 1 || d2.V > 53)
          return null;
        if (!("w" in d2))
          d2.w = 1;
        if ("Z" in d2) {
          week = utcDate(newDate(d2.y, 0, 1)), day2 = week.getUTCDay();
          week = day2 > 4 || day2 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d2.V - 1) * 7);
          d2.y = week.getUTCFullYear();
          d2.m = week.getUTCMonth();
          d2.d = week.getUTCDate() + (d2.w + 6) % 7;
        } else {
          week = localDate(newDate(d2.y, 0, 1)), day2 = week.getDay();
          week = day2 > 4 || day2 === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d2.V - 1) * 7);
          d2.y = week.getFullYear();
          d2.m = week.getMonth();
          d2.d = week.getDate() + (d2.w + 6) % 7;
        }
      } else if ("W" in d2 || "U" in d2) {
        if (!("w" in d2))
          d2.w = "u" in d2 ? d2.u % 7 : "W" in d2 ? 1 : 0;
        day2 = "Z" in d2 ? utcDate(newDate(d2.y, 0, 1)).getUTCDay() : localDate(newDate(d2.y, 0, 1)).getDay();
        d2.m = 0;
        d2.d = "W" in d2 ? (d2.w + 6) % 7 + d2.W * 7 - (day2 + 5) % 7 : d2.w + d2.U * 7 - (day2 + 6) % 7;
      }
      if ("Z" in d2) {
        d2.H += d2.Z / 100 | 0;
        d2.M += d2.Z % 100;
        return utcDate(d2);
      }
      return localDate(d2);
    };
  }
  function parseSpecifier(d2, specifier, string2, j) {
    var i = 0, n2 = specifier.length, m2 = string2.length, c2, parse2;
    while (i < n2) {
      if (j >= m2)
        return -1;
      c2 = specifier.charCodeAt(i++);
      if (c2 === 37) {
        c2 = specifier.charAt(i++);
        parse2 = parses[c2 in pads ? specifier.charAt(i++) : c2];
        if (!parse2 || (j = parse2(d2, string2, j)) < 0)
          return -1;
      } else if (c2 != string2.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d2, string2, i) {
    var n2 = periodRe.exec(string2.slice(i));
    return n2 ? (d2.p = periodLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortWeekday(d2, string2, i) {
    var n2 = shortWeekdayRe.exec(string2.slice(i));
    return n2 ? (d2.w = shortWeekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseWeekday(d2, string2, i) {
    var n2 = weekdayRe.exec(string2.slice(i));
    return n2 ? (d2.w = weekdayLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseShortMonth(d2, string2, i) {
    var n2 = shortMonthRe.exec(string2.slice(i));
    return n2 ? (d2.m = shortMonthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseMonth(d2, string2, i) {
    var n2 = monthRe.exec(string2.slice(i));
    return n2 ? (d2.m = monthLookup.get(n2[0].toLowerCase()), i + n2[0].length) : -1;
  }
  function parseLocaleDateTime(d2, string2, i) {
    return parseSpecifier(d2, locale_dateTime, string2, i);
  }
  function parseLocaleDate(d2, string2, i) {
    return parseSpecifier(d2, locale_date, string2, i);
  }
  function parseLocaleTime(d2, string2, i) {
    return parseSpecifier(d2, locale_time, string2, i);
  }
  function formatShortWeekday(d2) {
    return locale_shortWeekdays[d2.getDay()];
  }
  function formatWeekday(d2) {
    return locale_weekdays[d2.getDay()];
  }
  function formatShortMonth(d2) {
    return locale_shortMonths[d2.getMonth()];
  }
  function formatMonth(d2) {
    return locale_months[d2.getMonth()];
  }
  function formatPeriod(d2) {
    return locale_periods[+(d2.getHours() >= 12)];
  }
  function formatQuarter(d2) {
    return 1 + ~~(d2.getMonth() / 3);
  }
  function formatUTCShortWeekday(d2) {
    return locale_shortWeekdays[d2.getUTCDay()];
  }
  function formatUTCWeekday(d2) {
    return locale_weekdays[d2.getUTCDay()];
  }
  function formatUTCShortMonth(d2) {
    return locale_shortMonths[d2.getUTCMonth()];
  }
  function formatUTCMonth(d2) {
    return locale_months[d2.getUTCMonth()];
  }
  function formatUTCPeriod(d2) {
    return locale_periods[+(d2.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d2) {
    return 1 + ~~(d2.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f2 = newFormat(specifier += "", formats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    parse: function(specifier) {
      var p2 = newParse(specifier += "", false);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    },
    utcFormat: function(specifier) {
      var f2 = newFormat(specifier += "", utcFormats);
      f2.toString = function() {
        return specifier;
      };
      return f2;
    },
    utcParse: function(specifier) {
      var p2 = newParse(specifier += "", true);
      p2.toString = function() {
        return specifier;
      };
      return p2;
    }
  };
}
var pads = { "-": "", "_": " ", "0": "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width2) {
  var sign2 = value < 0 ? "-" : "", string2 = (sign2 ? -value : value) + "", length2 = string2.length;
  return sign2 + (length2 < width2 ? new Array(width2 - length2 + 1).join(fill) + string2 : string2);
}
function requote(s2) {
  return s2.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}
function parseWeekdayNumberSunday(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 1));
  return n2 ? (d2.w = +n2[0], i + n2[0].length) : -1;
}
function parseWeekdayNumberMonday(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 1));
  return n2 ? (d2.u = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberSunday(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.U = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberISO(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.V = +n2[0], i + n2[0].length) : -1;
}
function parseWeekNumberMonday(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.W = +n2[0], i + n2[0].length) : -1;
}
function parseFullYear(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 4));
  return n2 ? (d2.y = +n2[0], i + n2[0].length) : -1;
}
function parseYear(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.y = +n2[0] + (+n2[0] > 68 ? 1900 : 2e3), i + n2[0].length) : -1;
}
function parseZone(d2, string2, i) {
  var n2 = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string2.slice(i, i + 6));
  return n2 ? (d2.Z = n2[1] ? 0 : -(n2[2] + (n2[3] || "00")), i + n2[0].length) : -1;
}
function parseQuarter(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 1));
  return n2 ? (d2.q = n2[0] * 3 - 3, i + n2[0].length) : -1;
}
function parseMonthNumber(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.m = n2[0] - 1, i + n2[0].length) : -1;
}
function parseDayOfMonth(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.d = +n2[0], i + n2[0].length) : -1;
}
function parseDayOfYear(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 3));
  return n2 ? (d2.m = 0, d2.d = +n2[0], i + n2[0].length) : -1;
}
function parseHour24(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.H = +n2[0], i + n2[0].length) : -1;
}
function parseMinutes(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.M = +n2[0], i + n2[0].length) : -1;
}
function parseSeconds(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 2));
  return n2 ? (d2.S = +n2[0], i + n2[0].length) : -1;
}
function parseMilliseconds(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 3));
  return n2 ? (d2.L = +n2[0], i + n2[0].length) : -1;
}
function parseMicroseconds(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i, i + 6));
  return n2 ? (d2.L = Math.floor(n2[0] / 1e3), i + n2[0].length) : -1;
}
function parseLiteralPercent(d2, string2, i) {
  var n2 = percentRe.exec(string2.slice(i, i + 1));
  return n2 ? i + n2[0].length : -1;
}
function parseUnixTimestamp(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i));
  return n2 ? (d2.Q = +n2[0], i + n2[0].length) : -1;
}
function parseUnixTimestampSeconds(d2, string2, i) {
  var n2 = numberRe.exec(string2.slice(i));
  return n2 ? (d2.s = +n2[0], i + n2[0].length) : -1;
}
function formatDayOfMonth(d2, p2) {
  return pad(d2.getDate(), p2, 2);
}
function formatHour24(d2, p2) {
  return pad(d2.getHours(), p2, 2);
}
function formatHour12(d2, p2) {
  return pad(d2.getHours() % 12 || 12, p2, 2);
}
function formatDayOfYear(d2, p2) {
  return pad(1 + timeDay.count(timeYear(d2), d2), p2, 3);
}
function formatMilliseconds(d2, p2) {
  return pad(d2.getMilliseconds(), p2, 3);
}
function formatMicroseconds(d2, p2) {
  return formatMilliseconds(d2, p2) + "000";
}
function formatMonthNumber(d2, p2) {
  return pad(d2.getMonth() + 1, p2, 2);
}
function formatMinutes(d2, p2) {
  return pad(d2.getMinutes(), p2, 2);
}
function formatSeconds(d2, p2) {
  return pad(d2.getSeconds(), p2, 2);
}
function formatWeekdayNumberMonday(d2) {
  var day2 = d2.getDay();
  return day2 === 0 ? 7 : day2;
}
function formatWeekNumberSunday(d2, p2) {
  return pad(sunday.count(timeYear(d2) - 1, d2), p2, 2);
}
function dISO(d2) {
  var day2 = d2.getDay();
  return day2 >= 4 || day2 === 0 ? thursday(d2) : thursday.ceil(d2);
}
function formatWeekNumberISO(d2, p2) {
  d2 = dISO(d2);
  return pad(thursday.count(timeYear(d2), d2) + (timeYear(d2).getDay() === 4), p2, 2);
}
function formatWeekdayNumberSunday(d2) {
  return d2.getDay();
}
function formatWeekNumberMonday(d2, p2) {
  return pad(monday.count(timeYear(d2) - 1, d2), p2, 2);
}
function formatYear(d2, p2) {
  return pad(d2.getFullYear() % 100, p2, 2);
}
function formatYearISO(d2, p2) {
  d2 = dISO(d2);
  return pad(d2.getFullYear() % 100, p2, 2);
}
function formatFullYear(d2, p2) {
  return pad(d2.getFullYear() % 1e4, p2, 4);
}
function formatFullYearISO(d2, p2) {
  var day2 = d2.getDay();
  d2 = day2 >= 4 || day2 === 0 ? thursday(d2) : thursday.ceil(d2);
  return pad(d2.getFullYear() % 1e4, p2, 4);
}
function formatZone(d2) {
  var z2 = d2.getTimezoneOffset();
  return (z2 > 0 ? "-" : (z2 *= -1, "+")) + pad(z2 / 60 | 0, "0", 2) + pad(z2 % 60, "0", 2);
}
function formatUTCDayOfMonth(d2, p2) {
  return pad(d2.getUTCDate(), p2, 2);
}
function formatUTCHour24(d2, p2) {
  return pad(d2.getUTCHours(), p2, 2);
}
function formatUTCHour12(d2, p2) {
  return pad(d2.getUTCHours() % 12 || 12, p2, 2);
}
function formatUTCDayOfYear(d2, p2) {
  return pad(1 + utcDay$1.count(utcYear$1(d2), d2), p2, 3);
}
function formatUTCMilliseconds(d2, p2) {
  return pad(d2.getUTCMilliseconds(), p2, 3);
}
function formatUTCMicroseconds(d2, p2) {
  return formatUTCMilliseconds(d2, p2) + "000";
}
function formatUTCMonthNumber(d2, p2) {
  return pad(d2.getUTCMonth() + 1, p2, 2);
}
function formatUTCMinutes(d2, p2) {
  return pad(d2.getUTCMinutes(), p2, 2);
}
function formatUTCSeconds(d2, p2) {
  return pad(d2.getUTCSeconds(), p2, 2);
}
function formatUTCWeekdayNumberMonday(d2) {
  var dow = d2.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d2, p2) {
  return pad(utcSunday.count(utcYear$1(d2) - 1, d2), p2, 2);
}
function UTCdISO(d2) {
  var day2 = d2.getUTCDay();
  return day2 >= 4 || day2 === 0 ? utcThursday(d2) : utcThursday.ceil(d2);
}
function formatUTCWeekNumberISO(d2, p2) {
  d2 = UTCdISO(d2);
  return pad(utcThursday.count(utcYear$1(d2), d2) + (utcYear$1(d2).getUTCDay() === 4), p2, 2);
}
function formatUTCWeekdayNumberSunday(d2) {
  return d2.getUTCDay();
}
function formatUTCWeekNumberMonday(d2, p2) {
  return pad(utcMonday.count(utcYear$1(d2) - 1, d2), p2, 2);
}
function formatUTCYear(d2, p2) {
  return pad(d2.getUTCFullYear() % 100, p2, 2);
}
function formatUTCYearISO(d2, p2) {
  d2 = UTCdISO(d2);
  return pad(d2.getUTCFullYear() % 100, p2, 2);
}
function formatUTCFullYear(d2, p2) {
  return pad(d2.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCFullYearISO(d2, p2) {
  var day2 = d2.getUTCDay();
  d2 = day2 >= 4 || day2 === 0 ? utcThursday(d2) : utcThursday.ceil(d2);
  return pad(d2.getUTCFullYear() % 1e4, p2, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d2) {
  return +d2;
}
function formatUnixTimestampSeconds(d2) {
  return Math.floor(+d2 / 1e3);
}
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date2) {
  return date2.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : utcFormat(isoSpecifier);
var formatIso$1 = formatIso;
function parseIsoNative(string2) {
  var date2 = new Date(string2);
  return isNaN(date2) ? null : date2;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : utcParse(isoSpecifier);
var parseIso$1 = parseIso;
function date(t4) {
  return new Date(t4);
}
function number(t4) {
  return t4 instanceof Date ? +t4 : +new Date(+t4);
}
function calendar(ticks2, tickInterval, year2, month2, week, day2, hour2, minute2, second2, format2) {
  var scale = continuous(), invert = scale.invert, domain2 = scale.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute2(date2) < date2 ? formatSecond : hour2(date2) < date2 ? formatMinute : day2(date2) < date2 ? formatHour : month2(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year2(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale.invert = function(y2) {
    return new Date(invert(y2));
  };
  scale.domain = function(_2) {
    return arguments.length ? domain2(Array.from(_2, number)) : domain2().map(date);
  };
  scale.ticks = function(interval2) {
    var d2 = domain2();
    return ticks2(d2[0], d2[d2.length - 1], interval2 == null ? 10 : interval2);
  };
  scale.tickFormat = function(count2, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale.nice = function(interval2) {
    var d2 = domain2();
    if (!interval2 || typeof interval2.range !== "function")
      interval2 = tickInterval(d2[0], d2[d2.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain2(nice(d2, interval2)) : scale;
  };
  scale.copy = function() {
    return copy$1(scale, calendar(ticks2, tickInterval, year2, month2, week, day2, hour2, minute2, second2, format2));
  };
  return scale;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, sunday, timeDay, timeHour, timeMinute, utcSecond, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear$1, utcMonth$1, utcSunday, utcDay$1, utcHour$1, utcMinute$1, utcSecond, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$1() {
  var x02 = 0, x12 = 1, t02, t12, k10, transform2, interpolator = identity$4, clamp2 = false, unknown2;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown2 : interpolator(k10 === 0 ? 0.5 : (x2 = (transform2(x2) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x2)) : x2));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12] = _2, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x02, x12];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _2, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4) {
    transform2 = t4, t02 = t4(x02), t12 = t4(x12), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer$1()(identity$4));
  scale.copy = function() {
    return copy(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
  var scale = loggish(transformer$1()).domain([1, 10]);
  scale.copy = function() {
    return copy(scale, sequentialLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
  var scale = symlogish(transformer$1());
  scale.copy = function() {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
  var scale = powish(transformer$1());
  scale.copy = function() {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var domain2 = [], interpolator = identity$4;
  function scale(x2) {
    if (x2 != null && !isNaN(x2 = +x2))
      return interpolator((bisect(domain2, x2, 1) - 1) / (domain2.length - 1));
  }
  scale.domain = function(_2) {
    if (!arguments.length)
      return domain2.slice();
    domain2 = [];
    for (let d2 of _2)
      if (d2 != null && !isNaN(d2 = +d2))
        domain2.push(d2);
    domain2.sort(ascending$3);
    return scale;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  scale.range = function() {
    return domain2.map((d2, i) => interpolator(i / (domain2.length - 1)));
  };
  scale.quantiles = function(n2) {
    return Array.from({ length: n2 + 1 }, (_2, i) => quantile$1(domain2, i / n2));
  };
  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain2);
  };
  return initInterpolator.apply(scale, arguments);
}
function transformer() {
  var x02 = 0, x12 = 0.5, x2 = 1, s2 = 1, t02, t12, t22, k10, k21, interpolator = identity$4, transform2, clamp2 = false, unknown2;
  function scale(x3) {
    return isNaN(x3 = +x3) ? unknown2 : (x3 = 0.5 + ((x3 = +transform2(x3)) - t12) * (s2 * x3 < s2 * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x02, x12, x2] = _2, t02 = transform2(x02 = +x02), t12 = transform2(x12 = +x12), t22 = transform2(x2 = +x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s2 = t12 < t02 ? -1 : 1, scale) : [x02, x12, x2];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _2, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown2 = _2, scale) : unknown2;
  };
  return function(t4) {
    transform2 = t4, t02 = t4(x02), t12 = t4(x12), t22 = t4(x2), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t22 ? 0 : 0.5 / (t22 - t12), s2 = t12 < t02 ? -1 : 1;
    return scale;
  };
}
function diverging$1() {
  var scale = linearish(transformer()(identity$4));
  scale.copy = function() {
    return copy(scale, diverging$1());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingLog() {
  var scale = loggish(transformer()).domain([0.1, 1, 10]);
  scale.copy = function() {
    return copy(scale, divergingLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
  var scale = symlogish(transformer());
  scale.copy = function() {
    return copy(scale, divergingSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingPow() {
  var scale = powish(transformer());
  scale.copy = function() {
    return copy(scale, divergingPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
function colors(specifier) {
  var n2 = specifier.length / 6 | 0, colors2 = new Array(n2), i = 0;
  while (i < n2)
    colors2[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors2;
}
var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition)
    prototype[key] = definition[key];
  return prototype;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m2, l2;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex.exec(format2)) ? (l2 = m2[1].length, m2 = parseInt(m2[1], 16), l2 === 6 ? rgbn(m2) : l2 === 3 ? new Rgb(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l2 === 8 ? rgba(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l2 === 4 ? rgba(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger.exec(format2)) ? new Rgb(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent.exec(format2)) ? new Rgb(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger.exec(format2)) ? rgba(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent.exec(format2)) ? rgba(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba(r2, g2, b10, a2) {
  if (a2 <= 0)
    r2 = g2 = b10 = NaN;
  return new Rgb(r2, g2, b10, a2);
}
function rgbConvert(o) {
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r2, g2, b10, opacity) {
  return arguments.length === 1 ? rgbConvert(r2) : new Rgb(r2, g2, b10, opacity == null ? 1 : opacity);
}
function Rgb(r2, g2, b10, opacity) {
  this.r = +r2;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
  var a2 = this.opacity;
  a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
  return (a2 === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a2 === 1 ? ")" : ", " + a2 + ")");
}
function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h2, s2, l2, a2) {
  if (a2 <= 0)
    h2 = s2 = l2 = NaN;
  else if (l2 <= 0 || l2 >= 1)
    h2 = s2 = NaN;
  else if (s2 <= 0)
    h2 = NaN;
  return new Hsl(h2, s2, l2, a2);
}
function hslConvert(o) {
  if (o instanceof Hsl)
    return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Hsl();
  if (o instanceof Hsl)
    return o;
  o = o.rgb();
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r2, g2, b10), max2 = Math.max(r2, g2, b10), h2 = NaN, s2 = max2 - min2, l2 = (max2 + min2) / 2;
  if (s2) {
    if (r2 === max2)
      h2 = (g2 - b10) / s2 + (g2 < b10) * 6;
    else if (g2 === max2)
      h2 = (b10 - r2) / s2 + 2;
    else
      h2 = (r2 - g2) / s2 + 4;
    s2 /= l2 < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s2 = l2 > 0 && l2 < 1 ? 0 : h2;
  }
  return new Hsl(h2, s2, l2, o.opacity);
}
function hsl(h2, s2, l2, opacity) {
  return arguments.length === 1 ? hslConvert(h2) : new Hsl(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Hsl(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s2 = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l2 = this.l, m2 = l2 + (l2 < 0.5 ? l2 : 1 - l2) * s2, m1 = 2 * l2 - m2;
    return new Rgb(
      hsl2rgb(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb(h2, m1, m2),
      hsl2rgb(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a2 = this.opacity;
    a2 = isNaN(a2) ? 1 : Math.max(0, Math.min(1, a2));
    return (a2 === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a2 === 1 ? ")" : ", " + a2 + ")");
  }
}));
function hsl2rgb(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
  if (o instanceof Cubehelix)
    return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb))
    o = rgbConvert(o);
  var r2 = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, l2 = (BC_DA * b10 + ED * r2 - EB * g2) / (BC_DA + ED - EB), bl = b10 - l2, k2 = (E * (g2 - l2) - C * bl) / D, s2 = Math.sqrt(k2 * k2 + bl * bl) / (E * l2 * (1 - l2)), h2 = s2 ? Math.atan2(k2, bl) * degrees - 120 : NaN;
  return new Cubehelix(h2 < 0 ? h2 + 360 : h2, s2, l2, o.opacity);
}
function cubehelix$2(h2, s2, l2, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h2) : new Cubehelix(h2, s2, l2, opacity == null ? 1 : opacity);
}
function Cubehelix(h2, s2, l2, opacity) {
  this.h = +h2;
  this.s = +s2;
  this.l = +l2;
  this.opacity = +opacity;
}
define(Cubehelix, cubehelix$2, extend(Color, {
  brighter: function(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Cubehelix(this.h, this.s, this.l * k2, this.opacity);
  },
  darker: function(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Cubehelix(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb: function() {
    var h2 = isNaN(this.h) ? 0 : (this.h + 120) * radians, l2 = +this.l, a2 = isNaN(this.s) ? 0 : this.s * l2 * (1 - l2), cosh2 = Math.cos(h2), sinh2 = Math.sin(h2);
    return new Rgb(
      255 * (l2 + a2 * (A * cosh2 + B * sinh2)),
      255 * (l2 + a2 * (C * cosh2 + D * sinh2)),
      255 * (l2 + a2 * (E * cosh2)),
      this.opacity
    );
  }
}));
function basis$1(t12, v0, v1, v2, v3) {
  var t22 = t12 * t12, t32 = t22 * t12;
  return ((1 - 3 * t12 + 3 * t22 - t32) * v0 + (4 - 6 * t22 + 3 * t32) * v1 + (1 + 3 * t12 + 3 * t22 - 3 * t32) * v2 + t32 * v3) / 6;
}
function basis$2(values2) {
  var n2 = values2.length - 1;
  return function(t4) {
    var i = t4 <= 0 ? t4 = 0 : t4 >= 1 ? (t4 = 1, n2 - 1) : Math.floor(t4 * n2), v1 = values2[i], v2 = values2[i + 1], v0 = i > 0 ? values2[i - 1] : 2 * v1 - v2, v3 = i < n2 - 1 ? values2[i + 2] : 2 * v2 - v1;
    return basis$1((t4 - i / n2) * n2, v0, v1, v2, v3);
  };
}
var constant$2 = (x2) => () => x2;
function linear(a2, d2) {
  return function(t4) {
    return a2 + t4 * d2;
  };
}
function exponential(a2, b10, y2) {
  return a2 = Math.pow(a2, y2), b10 = Math.pow(b10, y2) - a2, y2 = 1 / y2, function(t4) {
    return Math.pow(a2 + t4 * b10, y2);
  };
}
function hue(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear(a2, d2 > 180 || d2 < -180 ? d2 - 360 * Math.round(d2 / 360) : d2) : constant$2(isNaN(a2) ? b10 : a2);
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a2, b10) {
    return b10 - a2 ? exponential(a2, b10, y2) : constant$2(isNaN(a2) ? b10 : a2);
  };
}
function nogamma(a2, b10) {
  var d2 = b10 - a2;
  return d2 ? linear(a2, d2) : constant$2(isNaN(a2) ? b10 : a2);
}
(function rgbGamma5(y2) {
  var color2 = gamma(y2);
  function rgb$12(start2, end2) {
    var r2 = color2((start2 = rgb(start2)).r, (end2 = rgb(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity = nogamma(start2.opacity, end2.opacity);
    return function(t4) {
      start2.r = r2(t4);
      start2.g = g2(t4);
      start2.b = b10(t4);
      start2.opacity = opacity(t4);
      return start2 + "";
    };
  }
  rgb$12.gamma = rgbGamma5;
  return rgb$12;
})(1);
function rgbSpline(spline) {
  return function(colors2) {
    var n2 = colors2.length, r2 = new Array(n2), g2 = new Array(n2), b10 = new Array(n2), i, color2;
    for (i = 0; i < n2; ++i) {
      color2 = rgb(colors2[i]);
      r2[i] = color2.r || 0;
      g2[i] = color2.g || 0;
      b10[i] = color2.b || 0;
    }
    r2 = spline(r2);
    g2 = spline(g2);
    b10 = spline(b10);
    color2.opacity = 1;
    return function(t4) {
      color2.r = r2(t4);
      color2.g = g2(t4);
      color2.b = b10(t4);
      return color2 + "";
    };
  };
}
var rgbBasis = rgbSpline(basis$2);
function cubehelix$1(hue2) {
  return function cubehelixGamma(y2) {
    y2 = +y2;
    function cubehelix2(start2, end2) {
      var h2 = hue2((start2 = cubehelix$2(start2)).h, (end2 = cubehelix$2(end2)).h), s2 = nogamma(start2.s, end2.s), l2 = nogamma(start2.l, end2.l), opacity = nogamma(start2.opacity, end2.opacity);
      return function(t4) {
        start2.h = h2(t4);
        start2.s = s2(t4);
        start2.l = l2(Math.pow(t4, y2));
        start2.opacity = opacity(t4);
        return start2 + "";
      };
    }
    cubehelix2.gamma = cubehelixGamma;
    return cubehelix2;
  }(1);
}
cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);
var ramp$1 = (scheme2) => rgbBasis(scheme2[scheme2.length - 1]);
var scheme$q = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(colors);
var BrBG = ramp$1(scheme$q);
var scheme$p = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(colors);
var PRGn = ramp$1(scheme$p);
var scheme$o = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(colors);
var PiYG = ramp$1(scheme$o);
var scheme$n = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(colors);
var PuOr = ramp$1(scheme$n);
var scheme$m = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(colors);
var RdBu = ramp$1(scheme$m);
var scheme$l = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(colors);
var RdGy = ramp$1(scheme$l);
var scheme$k = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(colors);
var RdYlBu = ramp$1(scheme$k);
var scheme$j = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(colors);
var RdYlGn = ramp$1(scheme$j);
var scheme$i = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(colors);
var Spectral = ramp$1(scheme$i);
var scheme$h = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(colors);
var BuGn = ramp$1(scheme$h);
var scheme$g = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(colors);
var BuPu = ramp$1(scheme$g);
var scheme$f = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(colors);
var GnBu = ramp$1(scheme$f);
var scheme$e = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(colors);
var OrRd = ramp$1(scheme$e);
var scheme$d = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(colors);
var PuBuGn = ramp$1(scheme$d);
var scheme$c = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(colors);
var PuBu = ramp$1(scheme$c);
var scheme$b = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(colors);
var PuRd = ramp$1(scheme$b);
var scheme$a = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(colors);
var RdPu = ramp$1(scheme$a);
var scheme$9 = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(colors);
var YlGnBu = ramp$1(scheme$9);
var scheme$8 = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(colors);
var YlGn = ramp$1(scheme$8);
var scheme$7 = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(colors);
var YlOrBr = ramp$1(scheme$7);
var scheme$6 = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(colors);
var YlOrRd = ramp$1(scheme$6);
var scheme$5 = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(colors);
var Blues = ramp$1(scheme$5);
var scheme$4 = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(colors);
var Greens = ramp$1(scheme$4);
var scheme$3 = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(colors);
var Greys = ramp$1(scheme$3);
var scheme$2 = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(colors);
var Purples = ramp$1(scheme$2);
var scheme$1 = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(colors);
var Reds = ramp$1(scheme$1);
var scheme = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(colors);
var Oranges = ramp$1(scheme);
function cividis(t4) {
  t4 = Math.max(0, Math.min(1, t4));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t4 * (35.34 - t4 * (2381.73 - t4 * (6402.7 - t4 * (7024.72 - t4 * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t4 * (170.73 + t4 * (52.82 - t4 * (131.46 - t4 * (176.58 - t4 * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t4 * (442.36 - t4 * (2482.43 - t4 * (6167.24 - t4 * (6614.94 - t4 * 2475.67))))))) + ")";
}
var cubehelix = cubehelixLong(cubehelix$2(300, 0.5, 0), cubehelix$2(-240, 0.5, 1));
var warm = cubehelixLong(cubehelix$2(-100, 0.75, 0.35), cubehelix$2(80, 1.5, 0.8));
var cool = cubehelixLong(cubehelix$2(260, 0.75, 0.35), cubehelix$2(80, 1.5, 0.8));
var c$2 = cubehelix$2();
function rainbow(t4) {
  if (t4 < 0 || t4 > 1)
    t4 -= Math.floor(t4);
  var ts = Math.abs(t4 - 0.5);
  c$2.h = 360 * t4 - 100;
  c$2.s = 1.5 - 1.5 * ts;
  c$2.l = 0.8 - 0.9 * ts;
  return c$2 + "";
}
var c$1 = rgb(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;
function sinebow(t4) {
  var x2;
  t4 = (0.5 - t4) * Math.PI;
  c$1.r = 255 * (x2 = Math.sin(t4)) * x2;
  c$1.g = 255 * (x2 = Math.sin(t4 + pi_1_3)) * x2;
  c$1.b = 255 * (x2 = Math.sin(t4 + pi_2_3)) * x2;
  return c$1 + "";
}
function turbo(t4) {
  t4 = Math.max(0, Math.min(1, t4));
  return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t4 * (1172.33 - t4 * (10793.56 - t4 * (33300.12 - t4 * (38394.49 - t4 * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t4 * (557.33 + t4 * (1225.33 - t4 * (3574.96 - t4 * (1073.77 + t4 * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t4 * (3211.1 - t4 * (15327.97 - t4 * (27814 - t4 * (22569.18 - t4 * 6838.66))))))) + ")";
}
function ramp(range2) {
  var n2 = range2.length;
  return function(t4) {
    return range2[Math.max(0, Math.min(n2 - 1, Math.floor(t4 * n2)))];
  };
}
var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function constant$1(x2) {
  return function constant2() {
    return x2;
  };
}
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi : Math.acos(x2);
}
function asin(x2) {
  return x2 >= 1 ? halfPi : x2 <= -1 ? -halfPi : Math.asin(x2);
}
function arcInnerRadius(d2) {
  return d2.innerRadius;
}
function arcOuterRadius(d2) {
  return d2.outerRadius;
}
function arcStartAngle(d2) {
  return d2.startAngle;
}
function arcEndAngle(d2) {
  return d2.endAngle;
}
function arcPadAngle(d2) {
  return d2 && d2.padAngle;
}
function intersect(x02, y02, x12, y12, x2, y2, x3, y3) {
  var x10 = x12 - x02, y10 = y12 - y02, x32 = x3 - x2, y32 = y3 - y2, t4 = y32 * x10 - x32 * y10;
  if (t4 * t4 < epsilon)
    return;
  t4 = (x32 * (y02 - y2) - y32 * (x02 - x2)) / t4;
  return [x02 + t4 * x10, y02 + t4 * y10];
}
function cornerTangents(x02, y02, x12, y12, r1, rc, cw) {
  var x01 = x02 - x12, y01 = y02 - y12, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x02 + ox, y11 = y02 + oy, x10 = x12 + ox, y10 = y12 + oy, x002 = (x11 + x10) / 2, y002 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r2 = r1 - rc, D2 = x11 * y10 - x10 * y11, d4 = (dy < 0 ? -1 : 1) * sqrt(max(0, r2 * r2 * d2 - D2 * D2)), cx0 = (D2 * dy - dx * d4) / d2, cy0 = (-D2 * dx - dy * d4) / d2, cx1 = (D2 * dy + dx * d4) / d2, cy1 = (-D2 * dx + dy * d4) / d2, dx0 = cx0 - x002, dy0 = cy0 - y002, dx1 = cx1 - x002, dy1 = cy1 - y002;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
    cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r2 - 1),
    y11: cy0 * (r1 / r2 - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$1(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
  function arc2() {
    var buffer2, r2, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
    if (!context)
      context = buffer2 = path();
    if (r1 < r0)
      r2 = r1, r1 = r0, r0 = r2;
    if (!(r1 > epsilon))
      context.moveTo(0, 0);
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t02, t12;
      if (rp > epsilon) {
        var p02 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p02 * 2) > epsilon)
          p02 *= cw ? 1 : -1, a00 += p02, a10 -= p02;
        else
          da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon)
          p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else
          da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
      if (rc > epsilon) {
        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x002 = r0 * cos(a00), y002 = r0 * sin(a00), oc;
        if (da < pi && (oc = intersect(x01, y01, x002, y002, x11, y11, x10, y10))) {
          var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }
      if (!(da1 > epsilon))
        context.moveTo(x01, y01);
      else if (rc1 > epsilon) {
        t02 = cornerTangents(x002, y002, x01, y01, r1, rc1, cw);
        t12 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc1 < rc)
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r1, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), !cw);
          context.arc(t12.cx, t12.cy, rc1, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else
        context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon) || !(da0 > epsilon))
        context.lineTo(x10, y10);
      else if (rc0 > epsilon) {
        t02 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t12 = cornerTangents(x01, y01, x002, y002, r0, -rc0, cw);
        context.lineTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc0 < rc)
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r0, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), cw);
          context.arc(t12.cx, t12.cy, rc0, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else
        context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  arc2.centroid = function() {
    var r2 = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a2 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a2) * r2, sin(a2) * r2];
  };
  arc2.innerRadius = function(_2) {
    return arguments.length ? (innerRadius = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_2) {
    return arguments.length ? (outerRadius = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_2) {
    return arguments.length ? (cornerRadius = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_2) {
    return arguments.length ? (padRadius = _2 == null ? null : typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : padRadius;
  };
  arc2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : startAngle;
  };
  arc2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : endAngle;
  };
  arc2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$1(+_2), arc2) : padAngle;
  };
  arc2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, arc2) : context;
  };
  return arc2;
}
var slice = Array.prototype.slice;
function array(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x(p2) {
  return p2[0];
}
function y(p2) {
  return p2[1];
}
function line(x$12, y$12) {
  var defined = constant$1(true), context = null, curve = curveLinear, output = null;
  x$12 = typeof x$12 === "function" ? x$12 : x$12 === void 0 ? x : constant$1(x$12);
  y$12 = typeof y$12 === "function" ? y$12 : y$12 === void 0 ? y : constant$1(y$12);
  function line2(data) {
    var i, n2 = (data = array(data)).length, d2, defined0 = false, buffer2;
    if (context == null)
      output = curve(buffer2 = path());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data[i], i, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x$12(d2, i, data), +y$12(d2, i, data));
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  line2.x = function(_2) {
    return arguments.length ? (x$12 = typeof _2 === "function" ? _2 : constant$1(+_2), line2) : x$12;
  };
  line2.y = function(_2) {
    return arguments.length ? (y$12 = typeof _2 === "function" ? _2 : constant$1(+_2), line2) : y$12;
  };
  line2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$1(!!_2), line2) : defined;
  };
  line2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), line2) : context;
  };
  return line2;
}
function area(x02, y02, y12) {
  var x12 = null, defined = constant$1(true), context = null, curve = curveLinear, output = null;
  x02 = typeof x02 === "function" ? x02 : x02 === void 0 ? x : constant$1(+x02);
  y02 = typeof y02 === "function" ? y02 : y02 === void 0 ? constant$1(0) : constant$1(+y02);
  y12 = typeof y12 === "function" ? y12 : y12 === void 0 ? y : constant$1(+y12);
  function area2(data) {
    var i, j, k2, n2 = (data = array(data)).length, d2, defined0 = false, buffer2, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null)
      output = curve(buffer2 = path());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i - 1; k2 >= j; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x02(d2, i, data), y0z[i] = +y02(d2, i, data);
        output.point(x12 ? +x12(d2, i, data) : x0z[i], y12 ? +y12(d2, i, data) : y0z[i]);
      }
    }
    if (buffer2)
      return output = null, buffer2 + "" || null;
  }
  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_2) {
    return arguments.length ? (x02 = typeof _2 === "function" ? _2 : constant$1(+_2), x12 = null, area2) : x02;
  };
  area2.x0 = function(_2) {
    return arguments.length ? (x02 = typeof _2 === "function" ? _2 : constant$1(+_2), area2) : x02;
  };
  area2.x1 = function(_2) {
    return arguments.length ? (x12 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$1(+_2), area2) : x12;
  };
  area2.y = function(_2) {
    return arguments.length ? (y02 = typeof _2 === "function" ? _2 : constant$1(+_2), y12 = null, area2) : y02;
  };
  area2.y0 = function(_2) {
    return arguments.length ? (y02 = typeof _2 === "function" ? _2 : constant$1(+_2), area2) : y02;
  };
  area2.y1 = function(_2) {
    return arguments.length ? (y12 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$1(+_2), area2) : y12;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x02).y(y02);
  };
  area2.lineY1 = function() {
    return arealine().x(x02).y(y12);
  };
  area2.lineX1 = function() {
    return arealine().x(x12).y(y02);
  };
  area2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$1(!!_2), area2) : defined;
  };
  area2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), area2) : context;
  };
  return area2;
}
function descending$1(a2, b10) {
  return b10 < a2 ? -1 : b10 > a2 ? 1 : b10 >= a2 ? 0 : NaN;
}
function identity$2(d2) {
  return d2;
}
function pie() {
  var value = identity$2, sortValues = descending$1, sort2 = null, startAngle = constant$1(0), endAngle = constant$1(tau), padAngle = constant$1(0);
  function pie2(data) {
    var i, n2 = (data = array(data)).length, j, k2, sum2 = 0, index2 = new Array(n2), arcs = new Array(n2), a0 = +startAngle.apply(this, arguments), da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)), a1, p2 = Math.min(Math.abs(da) / n2, padAngle.apply(this, arguments)), pa = p2 * (da < 0 ? -1 : 1), v2;
    for (i = 0; i < n2; ++i) {
      if ((v2 = arcs[index2[i] = i] = +value(data[i], i, data)) > 0) {
        sum2 += v2;
      }
    }
    if (sortValues != null)
      index2.sort(function(i2, j2) {
        return sortValues(arcs[i2], arcs[j2]);
      });
    else if (sort2 != null)
      index2.sort(function(i2, j2) {
        return sort2(data[i2], data[j2]);
      });
    for (i = 0, k2 = sum2 ? (da - n2 * pa) / sum2 : 0; i < n2; ++i, a0 = a1) {
      j = index2[i], v2 = arcs[j], a1 = a0 + (v2 > 0 ? v2 * k2 : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v2,
        startAngle: a0,
        endAngle: a1,
        padAngle: p2
      };
    }
    return arcs;
  }
  pie2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$1(+_2), pie2) : value;
  };
  pie2.sortValues = function(_2) {
    return arguments.length ? (sortValues = _2, sort2 = null, pie2) : sortValues;
  };
  pie2.sort = function(_2) {
    return arguments.length ? (sort2 = _2, sortValues = null, pie2) : sort2;
  };
  pie2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$1(+_2), pie2) : startAngle;
  };
  pie2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$1(+_2), pie2) : endAngle;
  };
  pie2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$1(+_2), pie2) : padAngle;
  };
  return pie2;
}
var curveRadialLinear = curveRadial$1(curveLinear);
function Radial(curve) {
  this._curve = curve;
}
Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a2, r2) {
    this._curve.point(r2 * Math.sin(a2), r2 * -Math.cos(a2));
  }
};
function curveRadial$1(curve) {
  function radial2(context) {
    return new Radial(curve(context));
  }
  radial2._curve = curve;
  return radial2;
}
function lineRadial(l2) {
  var c2 = l2.curve;
  l2.angle = l2.x, delete l2.x;
  l2.radius = l2.y, delete l2.y;
  l2.curve = function(_2) {
    return arguments.length ? c2(curveRadial$1(_2)) : c2()._curve;
  };
  return l2;
}
function lineRadial$1() {
  return lineRadial(line().curve(curveRadialLinear));
}
function areaRadial() {
  var a2 = area().curve(curveRadialLinear), c2 = a2.curve, x02 = a2.lineX0, x12 = a2.lineX1, y02 = a2.lineY0, y12 = a2.lineY1;
  a2.angle = a2.x, delete a2.x;
  a2.startAngle = a2.x0, delete a2.x0;
  a2.endAngle = a2.x1, delete a2.x1;
  a2.radius = a2.y, delete a2.y;
  a2.innerRadius = a2.y0, delete a2.y0;
  a2.outerRadius = a2.y1, delete a2.y1;
  a2.lineStartAngle = function() {
    return lineRadial(x02());
  }, delete a2.lineX0;
  a2.lineEndAngle = function() {
    return lineRadial(x12());
  }, delete a2.lineX1;
  a2.lineInnerRadius = function() {
    return lineRadial(y02());
  }, delete a2.lineY0;
  a2.lineOuterRadius = function() {
    return lineRadial(y12());
  }, delete a2.lineY1;
  a2.curve = function(_2) {
    return arguments.length ? c2(curveRadial$1(_2)) : c2()._curve;
  };
  return a2;
}
function pointRadial(x2, y2) {
  return [(y2 = +y2) * Math.cos(x2 -= Math.PI / 2), y2 * Math.sin(x2)];
}
function linkSource(d2) {
  return d2.source;
}
function linkTarget(d2) {
  return d2.target;
}
function link(curve) {
  var source = linkSource, target = linkTarget, x$12 = x, y$12 = y, context = null;
  function link2() {
    var buffer2, argv = slice.call(arguments), s2 = source.apply(this, argv), t4 = target.apply(this, argv);
    if (!context)
      context = buffer2 = path();
    curve(context, +x$12.apply(this, (argv[0] = s2, argv)), +y$12.apply(this, argv), +x$12.apply(this, (argv[0] = t4, argv)), +y$12.apply(this, argv));
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  link2.source = function(_2) {
    return arguments.length ? (source = _2, link2) : source;
  };
  link2.target = function(_2) {
    return arguments.length ? (target = _2, link2) : target;
  };
  link2.x = function(_2) {
    return arguments.length ? (x$12 = typeof _2 === "function" ? _2 : constant$1(+_2), link2) : x$12;
  };
  link2.y = function(_2) {
    return arguments.length ? (y$12 = typeof _2 === "function" ? _2 : constant$1(+_2), link2) : y$12;
  };
  link2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, link2) : context;
  };
  return link2;
}
function curveHorizontal(context, x02, y02, x12, y12) {
  context.moveTo(x02, y02);
  context.bezierCurveTo(x02 = (x02 + x12) / 2, y02, x02, y12, x12, y12);
}
function curveVertical(context, x02, y02, x12, y12) {
  context.moveTo(x02, y02);
  context.bezierCurveTo(x02, y02 = (y02 + y12) / 2, x12, y02, x12, y12);
}
function curveRadial(context, x02, y02, x12, y12) {
  var p02 = pointRadial(x02, y02), p1 = pointRadial(x02, y02 = (y02 + y12) / 2), p2 = pointRadial(x12, y02), p3 = pointRadial(x12, y12);
  context.moveTo(p02[0], p02[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function linkHorizontal() {
  return link(curveHorizontal);
}
function linkVertical() {
  return link(curveVertical);
}
function linkRadial() {
  var l2 = link(curveRadial);
  l2.angle = l2.x, delete l2.x;
  l2.radius = l2.y, delete l2.y;
  return l2;
}
var circle = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / pi);
    context.moveTo(r2, 0);
    context.arc(0, 0, r2, 0, tau);
  }
};
var cross = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r2, -r2);
    context.lineTo(-r2, -r2);
    context.lineTo(-r2, -3 * r2);
    context.lineTo(r2, -3 * r2);
    context.lineTo(r2, -r2);
    context.lineTo(3 * r2, -r2);
    context.lineTo(3 * r2, r2);
    context.lineTo(r2, r2);
    context.lineTo(r2, 3 * r2);
    context.lineTo(-r2, 3 * r2);
    context.lineTo(-r2, r2);
    context.lineTo(-3 * r2, r2);
    context.closePath();
  }
};
var tan30 = Math.sqrt(1 / 3), tan30_2 = tan30 * 2;
var diamond = {
  draw: function(context, size) {
    var y2 = Math.sqrt(size / tan30_2), x2 = y2 * tan30;
    context.moveTo(0, -y2);
    context.lineTo(x2, 0);
    context.lineTo(0, y2);
    context.lineTo(-x2, 0);
    context.closePath();
  }
};
var ka = 0.8908130915292852, kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10), kx = Math.sin(tau / 10) * kr, ky = -Math.cos(tau / 10) * kr;
var star = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size * ka), x2 = kx * r2, y2 = ky * r2;
    context.moveTo(0, -r2);
    context.lineTo(x2, y2);
    for (var i = 1; i < 5; ++i) {
      var a2 = tau * i / 5, c2 = Math.cos(a2), s2 = Math.sin(a2);
      context.lineTo(s2 * r2, -c2 * r2);
      context.lineTo(c2 * x2 - s2 * y2, s2 * x2 + c2 * y2);
    }
    context.closePath();
  }
};
var square = {
  draw: function(context, size) {
    var w2 = Math.sqrt(size), x2 = -w2 / 2;
    context.rect(x2, x2, w2, w2);
  }
};
var sqrt3 = Math.sqrt(3);
var triangle = {
  draw: function(context, size) {
    var y2 = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y2 * 2);
    context.lineTo(-sqrt3 * y2, -y2);
    context.lineTo(sqrt3 * y2, -y2);
    context.closePath();
  }
};
var c = -0.5, s = Math.sqrt(3) / 2, k = 1 / Math.sqrt(12), a = (k / 2 + 1) * 3;
var wye = {
  draw: function(context, size) {
    var r2 = Math.sqrt(size / a), x02 = r2 / 2, y02 = r2 * k, x12 = x02, y12 = r2 * k + r2, x2 = -x12, y2 = y12;
    context.moveTo(x02, y02);
    context.lineTo(x12, y12);
    context.lineTo(x2, y2);
    context.lineTo(c * x02 - s * y02, s * x02 + c * y02);
    context.lineTo(c * x12 - s * y12, s * x12 + c * y12);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x02 + s * y02, c * y02 - s * x02);
    context.lineTo(c * x12 + s * y12, c * y12 - s * x12);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};
var symbols = [
  circle,
  cross,
  diamond,
  square,
  star,
  triangle,
  wye
];
function symbol(type2, size) {
  var context = null;
  type2 = typeof type2 === "function" ? type2 : constant$1(type2 || circle);
  size = typeof size === "function" ? size : constant$1(size === void 0 ? 64 : +size);
  function symbol2() {
    var buffer2;
    if (!context)
      context = buffer2 = path();
    type2.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer2)
      return context = null, buffer2 + "" || null;
  }
  symbol2.type = function(_2) {
    return arguments.length ? (type2 = typeof _2 === "function" ? _2 : constant$1(_2), symbol2) : type2;
  };
  symbol2.size = function(_2) {
    return arguments.length ? (size = typeof _2 === "function" ? _2 : constant$1(+_2), symbol2) : size;
  };
  symbol2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, symbol2) : context;
  };
  return symbol2;
}
function noop() {
}
function point$3(that, x2, y2) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x2) / 6,
    (that._y0 + 4 * that._y1 + y2) / 6
  );
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$3(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point$3(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basis(context) {
  return new Basis(context);
}
function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x2, this._y2 = y2;
        break;
      case 1:
        this._point = 2;
        this._x3 = x2, this._y3 = y2;
        break;
      case 2:
        this._point = 3;
        this._x4 = x2, this._y4 = y2;
        this._context.moveTo((this._x0 + 4 * this._x1 + x2) / 6, (this._y0 + 4 * this._y1 + y2) / 6);
        break;
      default:
        point$3(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisClosed(context) {
  return new BasisClosed(context);
}
function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x02 = (this._x0 + 4 * this._x1 + x2) / 6, y02 = (this._y0 + 4 * this._y1 + y2) / 6;
        this._line ? this._context.lineTo(x02, y02) : this._context.moveTo(x02, y02);
        break;
      case 3:
        this._point = 4;
      default:
        point$3(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
  }
};
function basisOpen(context) {
  return new BasisOpen(context);
}
class Bump {
  constructor(context, x2) {
    this._context = context;
    this._x = x2;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  }
  point(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0: {
        this._point = 1;
        if (this._line)
          this._context.lineTo(x2, y2);
        else
          this._context.moveTo(x2, y2);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        if (this._x)
          this._context.bezierCurveTo(this._x0 = (this._x0 + x2) / 2, this._y0, this._x0, y2, x2, y2);
        else
          this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y2) / 2, x2, this._y0, x2, y2);
        break;
      }
    }
    this._x0 = x2, this._y0 = y2;
  }
}
function bumpX(context) {
  return new Bump(context, true);
}
function bumpY(context) {
  return new Bump(context, false);
}
function Bundle(context, beta2) {
  this._basis = new Basis(context);
  this._beta = beta2;
}
Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, j = x2.length - 1;
    if (j > 0) {
      var x02 = x2[0], y02 = y2[0], dx = x2[j] - x02, dy = y2[j] - y02, i = -1, t4;
      while (++i <= j) {
        t4 = i / j;
        this._basis.point(
          this._beta * x2[i] + (1 - this._beta) * (x02 + t4 * dx),
          this._beta * y2[i] + (1 - this._beta) * (y02 + t4 * dy)
        );
      }
    }
    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
var bundle = function custom19(beta2) {
  function bundle2(context) {
    return beta2 === 1 ? new Basis(context) : new Bundle(context, beta2);
  }
  bundle2.beta = function(beta3) {
    return custom19(+beta3);
  };
  return bundle2;
}(0.85);
function point$2(that, x2, y2) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x2),
    that._y2 + that._k * (that._y1 - y2),
    that._x2,
    that._y2
  );
}
function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$2(this, this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        this._x1 = x2, this._y1 = y2;
        break;
      case 2:
        this._point = 3;
      default:
        point$2(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinal = function custom20(tension) {
  function cardinal2(context) {
    return new Cardinal(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom20(+tension2);
  };
  return cardinal2;
}(0);
function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x2, this._y3 = y2;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x2, this._y4 = y2);
        break;
      case 2:
        this._point = 3;
        this._x5 = x2, this._y5 = y2;
        break;
      default:
        point$2(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinalClosed = function custom21(tension) {
  function cardinal2(context) {
    return new CardinalClosed(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom21(+tension2);
  };
  return cardinal2;
}(0);
function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$2(this, x2, y2);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var cardinalOpen = function custom22(tension) {
  function cardinal2(context) {
    return new CardinalOpen(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom22(+tension2);
  };
  return cardinal2;
}(0);
function point$1(that, x2, y2) {
  var x12 = that._x1, y12 = that._y1, x22 = that._x2, y22 = that._y2;
  if (that._l01_a > epsilon) {
    var a2 = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n2 = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x12 = (x12 * a2 - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n2;
    y12 = (y12 * a2 - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n2;
  }
  if (that._l23_a > epsilon) {
    var b10 = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m2 = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x22 = (x22 * b10 + that._x1 * that._l23_2a - x2 * that._l12_2a) / m2;
    y22 = (y22 * b10 + that._y1 * that._l23_2a - y2 * that._l12_2a) / m2;
  }
  that._context.bezierCurveTo(x12, y12, x22, y22, that._x2, that._y2);
}
function CatmullRom(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        point$1(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRom = function custom23(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRom(context, alpha2) : new Cardinal(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom23(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomClosed(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x2, this._y3 = y2;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x2, this._y4 = y2);
        break;
      case 2:
        this._point = 3;
        this._x5 = x2, this._y5 = y2;
        break;
      default:
        point$1(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRomClosed = function custom24(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomClosed(context, alpha2) : new CardinalClosed(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom24(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomOpen(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point) {
      var x23 = this._x2 - x2, y23 = this._y2 - y2;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$1(this, x2, y2);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x2;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y2;
  }
};
var catmullRomOpen = function custom25(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomOpen(context, alpha2) : new CardinalOpen(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom25(+alpha3);
  };
  return catmullRom2;
}(0.5);
function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop,
  areaEnd: noop,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point)
      this._context.closePath();
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    if (this._point)
      this._context.lineTo(x2, y2);
    else
      this._point = 1, this._context.moveTo(x2, y2);
  }
};
function linearClosed(context) {
  return new LinearClosed(context);
}
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p2 = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p2)) || 0;
}
function slope2(that, t4) {
  var h2 = that._x1 - that._x0;
  return h2 ? (3 * (that._y1 - that._y0) / h2 - t4) / 2 : t4;
}
function point(that, t02, t12) {
  var x02 = that._x0, y02 = that._y0, x12 = that._x1, y12 = that._y1, dx = (x12 - x02) / 3;
  that._context.bezierCurveTo(x02 + dx, y02 + dx * t02, x12 - dx, y12 - dx * t12, x12, y12);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t12 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1)
      return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point(this, slope2(this, t12 = slope3(this, x2, y2)), t12);
        break;
      default:
        point(this, this._t0, t12 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x2, y2) {
  MonotoneX.prototype.point.call(this, y2, x2);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x12, y12, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y12, x12, y2, x2, y3, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, n2 = x2.length;
    if (n2) {
      this._line ? this._context.lineTo(x2[0], y2[0]) : this._context.moveTo(x2[0], y2[0]);
      if (n2 === 2) {
        this._context.lineTo(x2[1], y2[1]);
      } else {
        var px = controlPoints(x2), py = controlPoints(y2);
        for (var i0 = 0, i1 = 1; i1 < n2; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x2[i1], y2[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n2 === 1)
      this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
function controlPoints(x2) {
  var i, n2 = x2.length - 1, m2, a2 = new Array(n2), b10 = new Array(n2), r2 = new Array(n2);
  a2[0] = 0, b10[0] = 2, r2[0] = x2[0] + 2 * x2[1];
  for (i = 1; i < n2 - 1; ++i)
    a2[i] = 1, b10[i] = 4, r2[i] = 4 * x2[i] + 2 * x2[i + 1];
  a2[n2 - 1] = 2, b10[n2 - 1] = 7, r2[n2 - 1] = 8 * x2[n2 - 1] + x2[n2];
  for (i = 1; i < n2; ++i)
    m2 = a2[i] / b10[i - 1], b10[i] -= m2, r2[i] -= m2 * r2[i - 1];
  a2[n2 - 1] = r2[n2 - 1] / b10[n2 - 1];
  for (i = n2 - 2; i >= 0; --i)
    a2[i] = (r2[i] - a2[i + 1]) / b10[i];
  b10[n2 - 1] = (x2[n2] + a2[n2 - 1]) / 2;
  for (i = 0; i < n2 - 1; ++i)
    b10[i] = 2 * x2[i + 1] - a2[i + 1];
  return [a2, b10];
}
function natural(context) {
  return new Natural(context);
}
function Step(context, t4) {
  this._context = context;
  this._t = t4;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2)
      this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    if (this._line >= 0)
      this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x12 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x12, this._y);
          this._context.lineTo(x12, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function step(context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}
function none$1(series, order2) {
  if (!((n2 = series.length) > 1))
    return;
  for (var i = 1, j, s0, s1 = series[order2[0]], n2, m2 = s1.length; i < n2; ++i) {
    s0 = s1, s1 = series[order2[i]];
    for (j = 0; j < m2; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
function none(series) {
  var n2 = series.length, o = new Array(n2);
  while (--n2 >= 0)
    o[n2] = n2;
  return o;
}
function stackValue(d2, key) {
  return d2[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function stack() {
  var keys2 = constant$1([]), order2 = none, offset2 = none$1, value = stackValue;
  function stack2(data) {
    var sz = Array.from(keys2.apply(this, arguments), stackSeries), i, n2 = sz.length, j = -1, oz;
    for (const d2 of data) {
      for (i = 0, ++j; i < n2; ++i) {
        (sz[i][j] = [0, +value(d2, sz[i].key, j, data)]).data = d2;
      }
    }
    for (i = 0, oz = array(order2(sz)); i < n2; ++i) {
      sz[oz[i]].index = i;
    }
    offset2(sz, oz);
    return sz;
  }
  stack2.keys = function(_2) {
    return arguments.length ? (keys2 = typeof _2 === "function" ? _2 : constant$1(Array.from(_2)), stack2) : keys2;
  };
  stack2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$1(+_2), stack2) : value;
  };
  stack2.order = function(_2) {
    return arguments.length ? (order2 = _2 == null ? none : typeof _2 === "function" ? _2 : constant$1(Array.from(_2)), stack2) : order2;
  };
  stack2.offset = function(_2) {
    return arguments.length ? (offset2 = _2 == null ? none$1 : _2, stack2) : offset2;
  };
  return stack2;
}
function expand(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var i, n2, j = 0, m2 = series[0].length, y2; j < m2; ++j) {
    for (y2 = i = 0; i < n2; ++i)
      y2 += series[i][j][1] || 0;
    if (y2)
      for (i = 0; i < n2; ++i)
        series[i][j][1] /= y2;
  }
  none$1(series, order2);
}
function diverging(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var i, j = 0, d2, dy, yp, yn, n2, m2 = series[order2[0]].length; j < m2; ++j) {
    for (yp = yn = 0, i = 0; i < n2; ++i) {
      if ((dy = (d2 = series[order2[i]][j])[1] - d2[0]) > 0) {
        d2[0] = yp, d2[1] = yp += dy;
      } else if (dy < 0) {
        d2[1] = yn, d2[0] = yn += dy;
      } else {
        d2[0] = 0, d2[1] = dy;
      }
    }
  }
}
function silhouette(series, order2) {
  if (!((n2 = series.length) > 0))
    return;
  for (var j = 0, s0 = series[order2[0]], n2, m2 = s0.length; j < m2; ++j) {
    for (var i = 0, y2 = 0; i < n2; ++i)
      y2 += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y2 / 2;
  }
  none$1(series, order2);
}
function wiggle(series, order2) {
  if (!((n2 = series.length) > 0) || !((m2 = (s0 = series[order2[0]]).length) > 0))
    return;
  for (var y2 = 0, j = 1, s0, m2, n2; j < m2; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n2; ++i) {
      var si = series[order2[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
      for (var k2 = 0; k2 < i; ++k2) {
        var sk = series[order2[k2]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y2;
    if (s1)
      y2 -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y2;
  none$1(series, order2);
}
function appearance(series) {
  var peaks = series.map(peak);
  return none(series).sort(function(a2, b10) {
    return peaks[a2] - peaks[b10];
  });
}
function peak(series) {
  var i = -1, j = 0, n2 = series.length, vi, vj = -Infinity;
  while (++i < n2)
    if ((vi = +series[i][1]) > vj)
      vj = vi, j = i;
  return j;
}
function ascending(series) {
  var sums = series.map(sum$2);
  return none(series).sort(function(a2, b10) {
    return sums[a2] - sums[b10];
  });
}
function sum$2(series) {
  var s2 = 0, i = -1, n2 = series.length, v2;
  while (++i < n2)
    if (v2 = +series[i][1])
      s2 += v2;
  return s2;
}
function descending(series) {
  return ascending(series).reverse();
}
function insideOut(series) {
  var n2 = series.length, i, j, sums = series.map(sum$2), order2 = appearance(series), top2 = 0, bottom2 = 0, tops = [], bottoms = [];
  for (i = 0; i < n2; ++i) {
    j = order2[i];
    if (top2 < bottom2) {
      top2 += sums[j];
      tops.push(j);
    } else {
      bottom2 += sums[j];
      bottoms.push(j);
    }
  }
  return bottoms.reverse().concat(tops);
}
function reverse(series) {
  return none(series).reverse();
}
var epsilon2 = 1e-12;
function cosh(x2) {
  return ((x2 = Math.exp(x2)) + 1 / x2) / 2;
}
function sinh(x2) {
  return ((x2 = Math.exp(x2)) - 1 / x2) / 2;
}
function tanh(x2) {
  return ((x2 = Math.exp(2 * x2)) - 1) / (x2 + 1);
}
var interpolateZoom = function zoomRho3(rho, rho2, rho4) {
  function zoom2(p02, p1) {
    var ux0 = p02[0], uy0 = p02[1], w0 = p02[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function(t4) {
        return [
          ux0 + t4 * dx,
          uy0 + t4 * dy,
          w0 * Math.exp(rho * t4 * S)
        ];
      };
    } else {
      var d1 = Math.sqrt(d2), b02 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b12 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b02 * b02 + 1) - b02), r1 = Math.log(Math.sqrt(b12 * b12 + 1) - b12);
      S = (r1 - r0) / rho;
      i = function(t4) {
        var s2 = t4 * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s2 + r0) - sinh(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh(rho * s2 + r0)
        ];
      };
    }
    i.duration = S * 1e3 * rho / Math.SQRT2;
    return i;
  }
  zoom2.rho = function(_2) {
    var _1 = Math.max(1e-3, +_2), _22 = _1 * _1, _4 = _22 * _22;
    return zoomRho3(_1, _22, _4);
  };
  return zoom2;
}(Math.SQRT2, 2, 4);
var constant = (x2) => () => x2;
function ZoomEvent(type2, {
  sourceEvent: sourceEvent2,
  target,
  transform: transform2,
  dispatch: dispatch2
}) {
  Object.defineProperties(this, {
    type: { value: type2, enumerable: true, configurable: true },
    sourceEvent: { value: sourceEvent2, enumerable: true, configurable: true },
    target: { value: target, enumerable: true, configurable: true },
    transform: { value: transform2, enumerable: true, configurable: true },
    _: { value: dispatch2 }
  });
}
function Transform(k2, x2, y2) {
  this.k = k2;
  this.x = x2;
  this.y = y2;
}
Transform.prototype = {
  constructor: Transform,
  scale: function(k2) {
    return k2 === 1 ? this : new Transform(this.k * k2, this.x, this.y);
  },
  translate: function(x2, y2) {
    return x2 === 0 & y2 === 0 ? this : new Transform(this.k, this.x + this.k * x2, this.y + this.k * y2);
  },
  apply: function(point2) {
    return [point2[0] * this.k + this.x, point2[1] * this.k + this.y];
  },
  applyX: function(x2) {
    return x2 * this.k + this.x;
  },
  applyY: function(y2) {
    return y2 * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x2) {
    return (x2 - this.x) / this.k;
  },
  invertY: function(y2) {
    return (y2 - this.y) / this.k;
  },
  rescaleX: function(x2) {
    return x2.copy().domain(x2.range().map(this.invertX, this).map(x2.invert, x2));
  },
  rescaleY: function(y2) {
    return y2.copy().domain(y2.range().map(this.invertY, this).map(y2.invert, y2));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var identity$1 = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node2) {
  while (!node2.__zoom)
    if (!(node2 = node2.parentNode))
      return identity$1;
  return node2.__zoom;
}
function nopropagation(event) {
  event.stopImmediatePropagation();
}
function noevent(event) {
  event.preventDefault();
  event.stopImmediatePropagation();
}
function defaultFilter(event) {
  return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function defaultExtent() {
  var e3 = this;
  if (e3 instanceof SVGElement) {
    e3 = e3.ownerSVGElement || e3;
    if (e3.hasAttribute("viewBox")) {
      e3 = e3.viewBox.baseVal;
      return [[e3.x, e3.y], [e3.x + e3.width, e3.y + e3.height]];
    }
    return [[0, 0], [e3.width.baseVal.value, e3.height.baseVal.value]];
  }
  return [[0, 0], [e3.clientWidth, e3.clientHeight]];
}
function defaultTransform() {
  return this.__zoom || identity$1;
}
function defaultWheelDelta(event) {
  return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 2e-3) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform2, extent2, translateExtent) {
  var dx0 = transform2.invertX(extent2[0][0]) - translateExtent[0][0], dx1 = transform2.invertX(extent2[1][0]) - translateExtent[1][0], dy0 = transform2.invertY(extent2[0][1]) - translateExtent[0][1], dy1 = transform2.invertY(extent2[1][1]) - translateExtent[1][1];
  return transform2.translate(
    dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
    dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
  );
}
function zoom() {
  var filter2 = defaultFilter, extent2 = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [0, Infinity], translateExtent = [[-Infinity, -Infinity], [Infinity, Infinity]], duration2 = 250, interpolate2 = interpolateZoom, listeners = dispatch$1("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
  function zoom2(selection2) {
    selection2.property("__zoom", defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  zoom2.transform = function(collection, transform2, point2, event) {
    var selection2 = collection.selection ? collection.selection() : collection;
    selection2.property("__zoom", defaultTransform);
    if (collection !== selection2) {
      schedule2(collection, transform2, point2, event);
    } else {
      selection2.interrupt().each(function() {
        gesture(this, arguments).event(event).start().zoom(null, typeof transform2 === "function" ? transform2.apply(this, arguments) : transform2).end();
      });
    }
  };
  zoom2.scaleBy = function(selection2, k2, p2, event) {
    zoom2.scaleTo(selection2, function() {
      var k0 = this.__zoom.k, k1 = typeof k2 === "function" ? k2.apply(this, arguments) : k2;
      return k0 * k1;
    }, p2, event);
  };
  zoom2.scaleTo = function(selection2, k2, p2, event) {
    zoom2.transform(selection2, function() {
      var e3 = extent2.apply(this, arguments), t02 = this.__zoom, p02 = p2 == null ? centroid2(e3) : typeof p2 === "function" ? p2.apply(this, arguments) : p2, p1 = t02.invert(p02), k1 = typeof k2 === "function" ? k2.apply(this, arguments) : k2;
      return constrain(translate(scale(t02, k1), p02, p1), e3, translateExtent);
    }, p2, event);
  };
  zoom2.translateBy = function(selection2, x2, y2, event) {
    zoom2.transform(selection2, function() {
      return constrain(this.__zoom.translate(
        typeof x2 === "function" ? x2.apply(this, arguments) : x2,
        typeof y2 === "function" ? y2.apply(this, arguments) : y2
      ), extent2.apply(this, arguments), translateExtent);
    }, null, event);
  };
  zoom2.translateTo = function(selection2, x2, y2, p2, event) {
    zoom2.transform(selection2, function() {
      var e3 = extent2.apply(this, arguments), t4 = this.__zoom, p02 = p2 == null ? centroid2(e3) : typeof p2 === "function" ? p2.apply(this, arguments) : p2;
      return constrain(identity$1.translate(p02[0], p02[1]).scale(t4.k).translate(
        typeof x2 === "function" ? -x2.apply(this, arguments) : -x2,
        typeof y2 === "function" ? -y2.apply(this, arguments) : -y2
      ), e3, translateExtent);
    }, p2, event);
  };
  function scale(transform2, k2) {
    k2 = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k2));
    return k2 === transform2.k ? transform2 : new Transform(k2, transform2.x, transform2.y);
  }
  function translate(transform2, p02, p1) {
    var x2 = p02[0] - p1[0] * transform2.k, y2 = p02[1] - p1[1] * transform2.k;
    return x2 === transform2.x && y2 === transform2.y ? transform2 : new Transform(transform2.k, x2, y2);
  }
  function centroid2(extent3) {
    return [(+extent3[0][0] + +extent3[1][0]) / 2, (+extent3[0][1] + +extent3[1][1]) / 2];
  }
  function schedule2(transition2, transform2, point2, event) {
    transition2.on("start.zoom", function() {
      gesture(this, arguments).event(event).start();
    }).on("interrupt.zoom end.zoom", function() {
      gesture(this, arguments).event(event).end();
    }).tween("zoom", function() {
      var that = this, args = arguments, g2 = gesture(that, args).event(event), e3 = extent2.apply(that, args), p2 = point2 == null ? centroid2(e3) : typeof point2 === "function" ? point2.apply(that, args) : point2, w2 = Math.max(e3[1][0] - e3[0][0], e3[1][1] - e3[0][1]), a2 = that.__zoom, b10 = typeof transform2 === "function" ? transform2.apply(that, args) : transform2, i = interpolate2(a2.invert(p2).concat(w2 / a2.k), b10.invert(p2).concat(w2 / b10.k));
      return function(t4) {
        if (t4 === 1)
          t4 = b10;
        else {
          var l2 = i(t4), k2 = w2 / l2[2];
          t4 = new Transform(k2, p2[0] - l2[0] * k2, p2[1] - l2[1] * k2);
        }
        g2.zoom(null, t4);
      };
    });
  }
  function gesture(that, args, clean) {
    return !clean && that.__zooming || new Gesture(that, args);
  }
  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.active = 0;
    this.sourceEvent = null;
    this.extent = extent2.apply(that, args);
    this.taps = 0;
  }
  Gesture.prototype = {
    event: function(event) {
      if (event)
        this.sourceEvent = event;
      return this;
    },
    start: function() {
      if (++this.active === 1) {
        this.that.__zooming = this;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform2) {
      if (this.mouse && key !== "mouse")
        this.mouse[1] = transform2.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch")
        this.touch0[1] = transform2.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch")
        this.touch1[1] = transform2.invert(this.touch1[0]);
      this.that.__zoom = transform2;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        delete this.that.__zooming;
        this.emit("end");
      }
      return this;
    },
    emit: function(type2) {
      var d2 = select(this.that).datum();
      listeners.call(
        type2,
        this.that,
        new ZoomEvent(type2, {
          sourceEvent: this.sourceEvent,
          target: zoom2,
          type: type2,
          transform: this.that.__zoom,
          dispatch: listeners
        }),
        d2
      );
    }
  };
  function wheeled(event, ...args) {
    if (!filter2.apply(this, arguments))
      return;
    var g2 = gesture(this, args).event(event), t4 = this.__zoom, k2 = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t4.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p2 = pointer(event);
    if (g2.wheel) {
      if (g2.mouse[0][0] !== p2[0] || g2.mouse[0][1] !== p2[1]) {
        g2.mouse[1] = t4.invert(g2.mouse[0] = p2);
      }
      clearTimeout(g2.wheel);
    } else if (t4.k === k2)
      return;
    else {
      g2.mouse = [p2, t4.invert(p2)];
      interrupt(this);
      g2.start();
    }
    noevent(event);
    g2.wheel = setTimeout(wheelidled, wheelDelay);
    g2.zoom("mouse", constrain(translate(scale(t4, k2), g2.mouse[0], g2.mouse[1]), g2.extent, translateExtent));
    function wheelidled() {
      g2.wheel = null;
      g2.end();
    }
  }
  function mousedowned(event, ...args) {
    if (touchending || !filter2.apply(this, arguments))
      return;
    var g2 = gesture(this, args, true).event(event), v2 = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p2 = pointer(event, currentTarget), currentTarget = event.currentTarget, x02 = event.clientX, y02 = event.clientY;
    dragDisable(event.view);
    nopropagation(event);
    g2.mouse = [p2, this.__zoom.invert(p2)];
    interrupt(this);
    g2.start();
    function mousemoved(event2) {
      noevent(event2);
      if (!g2.moved) {
        var dx = event2.clientX - x02, dy = event2.clientY - y02;
        g2.moved = dx * dx + dy * dy > clickDistance2;
      }
      g2.event(event2).zoom("mouse", constrain(translate(g2.that.__zoom, g2.mouse[0] = pointer(event2, currentTarget), g2.mouse[1]), g2.extent, translateExtent));
    }
    function mouseupped(event2) {
      v2.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(event2.view, g2.moved);
      noevent(event2);
      g2.event(event2).end();
    }
  }
  function dblclicked(event, ...args) {
    if (!filter2.apply(this, arguments))
      return;
    var t02 = this.__zoom, p02 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t02.invert(p02), k1 = t02.k * (event.shiftKey ? 0.5 : 2), t12 = constrain(translate(scale(t02, k1), p02, p1), extent2.apply(this, args), translateExtent);
    noevent(event);
    if (duration2 > 0)
      select(this).transition().duration(duration2).call(schedule2, t12, p02, event);
    else
      select(this).call(zoom2.transform, t12, p02, event);
  }
  function touchstarted(event, ...args) {
    if (!filter2.apply(this, arguments))
      return;
    var touches = event.touches, n2 = touches.length, g2 = gesture(this, args, event.changedTouches.length === n2).event(event), started, i, t4, p2;
    nopropagation(event);
    for (i = 0; i < n2; ++i) {
      t4 = touches[i], p2 = pointer(t4, this);
      p2 = [p2, this.__zoom.invert(p2), t4.identifier];
      if (!g2.touch0)
        g2.touch0 = p2, started = true, g2.taps = 1 + !!touchstarting;
      else if (!g2.touch1 && g2.touch0[2] !== p2[2])
        g2.touch1 = p2, g2.taps = 0;
    }
    if (touchstarting)
      touchstarting = clearTimeout(touchstarting);
    if (started) {
      if (g2.taps < 2)
        touchfirst = p2[0], touchstarting = setTimeout(function() {
          touchstarting = null;
        }, touchDelay);
      interrupt(this);
      g2.start();
    }
  }
  function touchmoved(event, ...args) {
    if (!this.__zooming)
      return;
    var g2 = gesture(this, args).event(event), touches = event.changedTouches, n2 = touches.length, i, t4, p2, l2;
    noevent(event);
    for (i = 0; i < n2; ++i) {
      t4 = touches[i], p2 = pointer(t4, this);
      if (g2.touch0 && g2.touch0[2] === t4.identifier)
        g2.touch0[0] = p2;
      else if (g2.touch1 && g2.touch1[2] === t4.identifier)
        g2.touch1[0] = p2;
    }
    t4 = g2.that.__zoom;
    if (g2.touch1) {
      var p02 = g2.touch0[0], l0 = g2.touch0[1], p1 = g2.touch1[0], l1 = g2.touch1[1], dp = (dp = p1[0] - p02[0]) * dp + (dp = p1[1] - p02[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t4 = scale(t4, Math.sqrt(dp / dl));
      p2 = [(p02[0] + p1[0]) / 2, (p02[1] + p1[1]) / 2];
      l2 = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    } else if (g2.touch0)
      p2 = g2.touch0[0], l2 = g2.touch0[1];
    else
      return;
    g2.zoom("touch", constrain(translate(t4, p2, l2), g2.extent, translateExtent));
  }
  function touchended(event, ...args) {
    if (!this.__zooming)
      return;
    var g2 = gesture(this, args).event(event), touches = event.changedTouches, n2 = touches.length, i, t4;
    nopropagation(event);
    if (touchending)
      clearTimeout(touchending);
    touchending = setTimeout(function() {
      touchending = null;
    }, touchDelay);
    for (i = 0; i < n2; ++i) {
      t4 = touches[i];
      if (g2.touch0 && g2.touch0[2] === t4.identifier)
        delete g2.touch0;
      else if (g2.touch1 && g2.touch1[2] === t4.identifier)
        delete g2.touch1;
    }
    if (g2.touch1 && !g2.touch0)
      g2.touch0 = g2.touch1, delete g2.touch1;
    if (g2.touch0)
      g2.touch0[1] = this.__zoom.invert(g2.touch0[0]);
    else {
      g2.end();
      if (g2.taps === 2) {
        t4 = pointer(t4, this);
        if (Math.hypot(touchfirst[0] - t4[0], touchfirst[1] - t4[1]) < tapDistance) {
          var p2 = select(this).on("dblclick.zoom");
          if (p2)
            p2.apply(this, arguments);
        }
      }
    }
  }
  zoom2.wheelDelta = function(_2) {
    return arguments.length ? (wheelDelta = typeof _2 === "function" ? _2 : constant(+_2), zoom2) : wheelDelta;
  };
  zoom2.filter = function(_2) {
    return arguments.length ? (filter2 = typeof _2 === "function" ? _2 : constant(!!_2), zoom2) : filter2;
  };
  zoom2.touchable = function(_2) {
    return arguments.length ? (touchable = typeof _2 === "function" ? _2 : constant(!!_2), zoom2) : touchable;
  };
  zoom2.extent = function(_2) {
    return arguments.length ? (extent2 = typeof _2 === "function" ? _2 : constant([[+_2[0][0], +_2[0][1]], [+_2[1][0], +_2[1][1]]]), zoom2) : extent2;
  };
  zoom2.scaleExtent = function(_2) {
    return arguments.length ? (scaleExtent[0] = +_2[0], scaleExtent[1] = +_2[1], zoom2) : [scaleExtent[0], scaleExtent[1]];
  };
  zoom2.translateExtent = function(_2) {
    return arguments.length ? (translateExtent[0][0] = +_2[0][0], translateExtent[1][0] = +_2[1][0], translateExtent[0][1] = +_2[0][1], translateExtent[1][1] = +_2[1][1], zoom2) : [[translateExtent[0][0], translateExtent[0][1]], [translateExtent[1][0], translateExtent[1][1]]];
  };
  zoom2.constrain = function(_2) {
    return arguments.length ? (constrain = _2, zoom2) : constrain;
  };
  zoom2.duration = function(_2) {
    return arguments.length ? (duration2 = +_2, zoom2) : duration2;
  };
  zoom2.interpolate = function(_2) {
    return arguments.length ? (interpolate2 = _2, zoom2) : interpolate2;
  };
  zoom2.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom2 : value;
  };
  zoom2.clickDistance = function(_2) {
    return arguments.length ? (clickDistance2 = (_2 = +_2) * _2, zoom2) : Math.sqrt(clickDistance2);
  };
  zoom2.tapDistance = function(_2) {
    return arguments.length ? (tapDistance = +_2, zoom2) : tapDistance;
  };
  return zoom2;
}
var d3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  version,
  bisect,
  bisectRight,
  bisectLeft,
  bisectCenter,
  ascending: ascending$3,
  bisector,
  count: count$2,
  cross: cross$2,
  cumsum,
  descending: descending$2,
  deviation,
  extent: extent$2,
  Adder,
  fsum,
  fcumsum,
  group,
  groups,
  index: index$4,
  indexes,
  rollup,
  rollups,
  groupSort,
  bin,
  histogram: bin,
  thresholdFreedmanDiaconis: freedmanDiaconis,
  thresholdScott: scott,
  thresholdSturges: sturges,
  max: max$4,
  maxIndex,
  mean,
  median,
  merge,
  min: min$2,
  minIndex,
  nice: nice$1,
  pairs,
  permute,
  quantile: quantile$1,
  quantileSorted,
  quickselect,
  range: sequence,
  least,
  leastIndex,
  greatest,
  greatestIndex,
  scan,
  shuffle: shuffle$1,
  shuffler,
  sum: sum$3,
  ticks,
  tickIncrement,
  tickStep: tickStep$1,
  transpose,
  variance,
  zip,
  every,
  some,
  filter: filter$1,
  map: map$1,
  reduce,
  reverse: reverse$1,
  sort,
  difference,
  disjoint,
  intersection,
  subset,
  superset,
  union,
  InternMap,
  InternSet,
  axisTop,
  axisRight,
  axisBottom,
  axisLeft,
  brush,
  brushX,
  brushY,
  brushSelection,
  chord,
  chordTranspose,
  chordDirected,
  ribbon: ribbon$1,
  ribbonArrow,
  color: color$1,
  rgb: rgb$2,
  hsl: hsl$3,
  lab: lab$1,
  hcl: hcl$2,
  lch,
  gray,
  cubehelix: cubehelix$5,
  contours,
  contourDensity: density,
  Delaunay,
  Voronoi,
  dispatch,
  drag,
  dragDisable,
  dragEnable: yesdrag,
  dsvFormat,
  csvParse,
  csvParseRows,
  csvFormat,
  csvFormatBody,
  csvFormatRows,
  csvFormatRow,
  csvFormatValue,
  tsvParse,
  tsvParseRows,
  tsvFormat,
  tsvFormatBody,
  tsvFormatRows,
  tsvFormatRow,
  tsvFormatValue,
  autoType,
  easeLinear: linear$3,
  easeQuad: quadInOut,
  easeQuadIn: quadIn,
  easeQuadOut: quadOut,
  easeQuadInOut: quadInOut,
  easeCubic: cubicInOut,
  easeCubicIn: cubicIn,
  easeCubicOut: cubicOut,
  easeCubicInOut: cubicInOut,
  easePoly: polyInOut,
  easePolyIn: polyIn,
  easePolyOut: polyOut,
  easePolyInOut: polyInOut,
  easeSin: sinInOut,
  easeSinIn: sinIn,
  easeSinOut: sinOut,
  easeSinInOut: sinInOut,
  easeExp: expInOut,
  easeExpIn: expIn,
  easeExpOut: expOut,
  easeExpInOut: expInOut,
  easeCircle: circleInOut,
  easeCircleIn: circleIn,
  easeCircleOut: circleOut,
  easeCircleInOut: circleInOut,
  easeBounce: bounceOut,
  easeBounceIn: bounceIn,
  easeBounceOut: bounceOut,
  easeBounceInOut: bounceInOut,
  easeBack: backInOut,
  easeBackIn: backIn,
  easeBackOut: backOut,
  easeBackInOut: backInOut,
  easeElastic: elasticOut,
  easeElasticIn: elasticIn,
  easeElasticOut: elasticOut,
  easeElasticInOut: elasticInOut,
  blob,
  buffer,
  dsv,
  csv,
  tsv,
  image,
  json,
  text,
  xml,
  html,
  svg,
  forceCenter: center,
  forceCollide: collide,
  forceLink: link$2,
  forceManyBody: manyBody,
  forceRadial: radial$1,
  forceSimulation: simulation,
  forceX: x$1,
  forceY: y$1,
  formatDefaultLocale: defaultLocale$1,
  get format() {
    return format;
  },
  get formatPrefix() {
    return formatPrefix;
  },
  formatLocale: formatLocale$1,
  formatSpecifier,
  FormatSpecifier,
  precisionFixed,
  precisionPrefix,
  precisionRound,
  geoArea: area$2,
  geoBounds: bounds,
  geoCentroid: centroid$1,
  geoCircle: circle$2,
  geoClipAntimeridian: clipAntimeridian,
  geoClipCircle: clipCircle,
  geoClipExtent: extent,
  geoClipRectangle: clipRectangle,
  geoContains: contains$1,
  geoDistance: distance,
  geoGraticule: graticule,
  geoGraticule10: graticule10,
  geoInterpolate: interpolate$1,
  geoLength: length$1,
  geoPath: index$2,
  geoAlbers: albers,
  geoAlbersUsa: albersUsa,
  geoAzimuthalEqualArea: azimuthalEqualArea,
  geoAzimuthalEqualAreaRaw: azimuthalEqualAreaRaw,
  geoAzimuthalEquidistant: azimuthalEquidistant,
  geoAzimuthalEquidistantRaw: azimuthalEquidistantRaw,
  geoConicConformal: conicConformal,
  geoConicConformalRaw: conicConformalRaw,
  geoConicEqualArea: conicEqualArea,
  geoConicEqualAreaRaw: conicEqualAreaRaw,
  geoConicEquidistant: conicEquidistant,
  geoConicEquidistantRaw: conicEquidistantRaw,
  geoEqualEarth: equalEarth,
  geoEqualEarthRaw: equalEarthRaw,
  geoEquirectangular: equirectangular,
  geoEquirectangularRaw: equirectangularRaw,
  geoGnomonic: gnomonic,
  geoGnomonicRaw: gnomonicRaw,
  geoIdentity: identity$6,
  geoProjection: projection,
  geoProjectionMutator: projectionMutator,
  geoMercator: mercator,
  geoMercatorRaw: mercatorRaw,
  geoNaturalEarth1: naturalEarth1,
  geoNaturalEarth1Raw: naturalEarth1Raw,
  geoOrthographic: orthographic,
  geoOrthographicRaw: orthographicRaw,
  geoStereographic: stereographic,
  geoStereographicRaw: stereographicRaw,
  geoTransverseMercator: transverseMercator,
  geoTransverseMercatorRaw: transverseMercatorRaw,
  geoRotation: rotation,
  geoStream,
  geoTransform: transform$1,
  cluster,
  hierarchy,
  pack: index$1,
  packSiblings: siblings,
  packEnclose: enclose,
  partition,
  stratify,
  tree,
  treemap: index,
  treemapBinary: binary,
  treemapDice,
  treemapSlice,
  treemapSliceDice: sliceDice,
  treemapSquarify: squarify,
  treemapResquarify: resquarify,
  interpolate,
  interpolateArray: array$1,
  interpolateBasis: basis$4,
  interpolateBasisClosed: basisClosed$1,
  interpolateDate: date$1,
  interpolateDiscrete: discrete,
  interpolateHue: hue$1,
  interpolateNumber,
  interpolateNumberArray: numberArray,
  interpolateObject: object,
  interpolateRound,
  interpolateString: string,
  interpolateTransformCss,
  interpolateTransformSvg,
  interpolateZoom: zoom$1,
  interpolateRgb: rgb$1,
  interpolateRgbBasis: rgbBasis$1,
  interpolateRgbBasisClosed: rgbBasisClosed,
  interpolateHsl: hsl$2,
  interpolateHslLong: hslLong,
  interpolateLab: lab,
  interpolateHcl: hcl$1,
  interpolateHclLong: hclLong,
  interpolateCubehelix: cubehelix$4,
  interpolateCubehelixLong: cubehelixLong$1,
  piecewise,
  quantize: quantize$1,
  path,
  polygonArea: area$1,
  polygonCentroid: centroid,
  polygonHull: hull,
  polygonContains: contains,
  polygonLength: length,
  quadtree,
  randomUniform: uniform,
  randomInt: int,
  randomNormal: normal,
  randomLogNormal: logNormal,
  randomBates: bates,
  randomIrwinHall: irwinHall,
  randomExponential: exponential$1,
  randomPareto: pareto,
  randomBernoulli: bernoulli,
  randomGeometric: geometric,
  randomBinomial: binomial,
  randomGamma: gamma$1,
  randomBeta: beta,
  randomWeibull: weibull,
  randomCauchy: cauchy,
  randomLogistic: logistic,
  randomPoisson: poisson,
  randomLcg: lcg,
  scaleBand: band,
  scalePoint: point$4,
  scaleIdentity: identity$3,
  scaleLinear: linear$1,
  scaleLog: log,
  scaleSymlog: symlog,
  scaleOrdinal: ordinal,
  scaleImplicit: implicit,
  scalePow: pow,
  scaleSqrt: sqrt$1,
  scaleRadial: radial,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSequentialQuantile: sequentialQuantile,
  scaleDiverging: diverging$1,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  tickFormat,
  schemeCategory10: category10,
  schemeAccent: Accent,
  schemeDark2: Dark2,
  schemePaired: Paired,
  schemePastel1: Pastel1,
  schemePastel2: Pastel2,
  schemeSet1: Set1,
  schemeSet2: Set2,
  schemeSet3: Set3,
  schemeTableau10: Tableau10,
  interpolateBrBG: BrBG,
  schemeBrBG: scheme$q,
  interpolatePRGn: PRGn,
  schemePRGn: scheme$p,
  interpolatePiYG: PiYG,
  schemePiYG: scheme$o,
  interpolatePuOr: PuOr,
  schemePuOr: scheme$n,
  interpolateRdBu: RdBu,
  schemeRdBu: scheme$m,
  interpolateRdGy: RdGy,
  schemeRdGy: scheme$l,
  interpolateRdYlBu: RdYlBu,
  schemeRdYlBu: scheme$k,
  interpolateRdYlGn: RdYlGn,
  schemeRdYlGn: scheme$j,
  interpolateSpectral: Spectral,
  schemeSpectral: scheme$i,
  interpolateBuGn: BuGn,
  schemeBuGn: scheme$h,
  interpolateBuPu: BuPu,
  schemeBuPu: scheme$g,
  interpolateGnBu: GnBu,
  schemeGnBu: scheme$f,
  interpolateOrRd: OrRd,
  schemeOrRd: scheme$e,
  interpolatePuBuGn: PuBuGn,
  schemePuBuGn: scheme$d,
  interpolatePuBu: PuBu,
  schemePuBu: scheme$c,
  interpolatePuRd: PuRd,
  schemePuRd: scheme$b,
  interpolateRdPu: RdPu,
  schemeRdPu: scheme$a,
  interpolateYlGnBu: YlGnBu,
  schemeYlGnBu: scheme$9,
  interpolateYlGn: YlGn,
  schemeYlGn: scheme$8,
  interpolateYlOrBr: YlOrBr,
  schemeYlOrBr: scheme$7,
  interpolateYlOrRd: YlOrRd,
  schemeYlOrRd: scheme$6,
  interpolateBlues: Blues,
  schemeBlues: scheme$5,
  interpolateGreens: Greens,
  schemeGreens: scheme$4,
  interpolateGreys: Greys,
  schemeGreys: scheme$3,
  interpolatePurples: Purples,
  schemePurples: scheme$2,
  interpolateReds: Reds,
  schemeReds: scheme$1,
  interpolateOranges: Oranges,
  schemeOranges: scheme,
  interpolateCividis: cividis,
  interpolateCubehelixDefault: cubehelix,
  interpolateRainbow: rainbow,
  interpolateWarm: warm,
  interpolateCool: cool,
  interpolateSinebow: sinebow,
  interpolateTurbo: turbo,
  interpolateViridis: viridis,
  interpolateMagma: magma,
  interpolateInferno: inferno,
  interpolatePlasma: plasma,
  create: create$1,
  creator,
  local: local$1,
  matcher,
  namespace,
  namespaces,
  pointer,
  pointers,
  select,
  selectAll,
  selection,
  selector,
  selectorAll,
  style: styleValue,
  window: defaultView,
  arc,
  area,
  line,
  pie,
  areaRadial,
  radialArea: areaRadial,
  lineRadial: lineRadial$1,
  radialLine: lineRadial$1,
  pointRadial,
  linkHorizontal,
  linkVertical,
  linkRadial,
  symbol,
  symbols,
  symbolCircle: circle,
  symbolCross: cross,
  symbolDiamond: diamond,
  symbolSquare: square,
  symbolStar: star,
  symbolTriangle: triangle,
  symbolWye: wye,
  curveBasisClosed: basisClosed,
  curveBasisOpen: basisOpen,
  curveBasis: basis,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveBundle: bundle,
  curveCardinalClosed: cardinalClosed,
  curveCardinalOpen: cardinalOpen,
  curveCardinal: cardinal,
  curveCatmullRomClosed: catmullRomClosed,
  curveCatmullRomOpen: catmullRomOpen,
  curveCatmullRom: catmullRom,
  curveLinearClosed: linearClosed,
  curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: natural,
  curveStep: step,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore,
  stack,
  stackOffsetExpand: expand,
  stackOffsetDiverging: diverging,
  stackOffsetNone: none$1,
  stackOffsetSilhouette: silhouette,
  stackOffsetWiggle: wiggle,
  stackOrderAppearance: appearance,
  stackOrderAscending: ascending,
  stackOrderDescending: descending,
  stackOrderInsideOut: insideOut,
  stackOrderNone: none,
  stackOrderReverse: reverse,
  timeInterval: newInterval,
  timeMillisecond: millisecond$1,
  timeMilliseconds: milliseconds,
  utcMillisecond: millisecond$1,
  utcMilliseconds: milliseconds,
  timeSecond: utcSecond,
  timeSeconds: seconds,
  utcSecond,
  utcSeconds: seconds,
  timeMinute,
  timeMinutes: minutes,
  timeHour,
  timeHours: hours,
  timeDay,
  timeDays: days,
  timeWeek: sunday,
  timeWeeks: sundays,
  timeSunday: sunday,
  timeSundays: sundays,
  timeMonday: monday,
  timeMondays: mondays,
  timeTuesday: tuesday,
  timeTuesdays: tuesdays,
  timeWednesday: wednesday,
  timeWednesdays: wednesdays,
  timeThursday: thursday,
  timeThursdays: thursdays,
  timeFriday: friday,
  timeFridays: fridays,
  timeSaturday: saturday,
  timeSaturdays: saturdays,
  timeMonth,
  timeMonths: months,
  timeYear,
  timeYears: years,
  utcMinute: utcMinute$1,
  utcMinutes,
  utcHour: utcHour$1,
  utcHours,
  utcDay: utcDay$1,
  utcDays,
  utcWeek: utcSunday,
  utcWeeks: utcSundays,
  utcSunday,
  utcSundays,
  utcMonday,
  utcMondays,
  utcTuesday,
  utcTuesdays,
  utcWednesday,
  utcWednesdays,
  utcThursday,
  utcThursdays,
  utcFriday,
  utcFridays,
  utcSaturday,
  utcSaturdays,
  utcMonth: utcMonth$1,
  utcMonths,
  utcYear: utcYear$1,
  utcYears,
  utcTicks,
  utcTickInterval,
  timeTicks,
  timeTickInterval,
  timeFormatDefaultLocale: defaultLocale,
  get timeFormat() {
    return timeFormat;
  },
  get timeParse() {
    return timeParse;
  },
  get utcFormat() {
    return utcFormat;
  },
  get utcParse() {
    return utcParse;
  },
  timeFormatLocale: formatLocale,
  isoFormat: formatIso$1,
  isoParse: parseIso$1,
  now,
  timer,
  timerFlush,
  timeout,
  interval,
  transition,
  active,
  interrupt,
  zoom,
  zoomTransform: transform,
  zoomIdentity: identity$1
}, Symbol.toStringTag, { value: "Module" }));
var require$$11 = /* @__PURE__ */ getAugmentedNamespace(d3);
var config = {};
var util = {};
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
var nativeObjectToString$1 = objectProto$6.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$5 = Object.prototype;
var nativeObjectToString = objectProto$5.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var numberTag$1 = "[object Number]";
function isNumber(value) {
  return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag$1;
}
var isNumber$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": isNumber
}, Symbol.toStringTag, { value: "Module" }));
var require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(isNumber$1);
function baseSum(array2, iteratee) {
  var result, index2 = -1, length2 = array2.length;
  while (++index2 < length2) {
    var current = iteratee(array2[index2]);
    if (current !== void 0) {
      result = result === void 0 ? current : result + current;
    }
  }
  return result;
}
function identity(value) {
  return value;
}
function sum(array2) {
  return array2 && array2.length ? baseSum(array2, identity) : 0;
}
var sum$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": sum
}, Symbol.toStringTag, { value: "Module" }));
var require$$2$1 = /* @__PURE__ */ getAugmentedNamespace(sum$1);
var objectProto$4 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$4;
  return value === proto;
}
function overArg(func, transform2) {
  return function(arg) {
    return func(transform2(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys$1(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$3.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function isObject(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$2 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var DataView$1 = getNative(root$1, "DataView");
var DataView$2 = DataView$1;
var Map$1 = getNative(root$1, "Map");
var Map$2 = Map$1;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
var Set$2 = Set$1;
var WeakMap$1 = getNative(root$1, "WeakMap");
var WeakMap$2 = WeakMap$1;
var mapTag$2 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$2 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$2), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$2 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;
var argsTag$1 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$1;
}
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$1.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments$1 = isArguments;
var isArray = Array.isArray;
var isArray$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": isArray
}, Symbol.toStringTag, { value: "Module" }));
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer = moduleExports$1 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e3) {
  }
}();
var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}
var isEmpty$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": isEmpty
}, Symbol.toStringTag, { value: "Module" }));
var require$$2 = /* @__PURE__ */ getAugmentedNamespace(isEmpty$1);
var require$$3 = /* @__PURE__ */ getAugmentedNamespace(isArray$1);
function head(array2) {
  return array2 && array2.length ? array2[0] : void 0;
}
var head$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": head
}, Symbol.toStringTag, { value: "Module" }));
var require$$5 = /* @__PURE__ */ getAugmentedNamespace(head$1);
function last(array2) {
  var length2 = array2 == null ? 0 : array2.length;
  return length2 ? array2[length2 - 1] : void 0;
}
var last$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": last
}, Symbol.toStringTag, { value: "Module" }));
var require$$6 = /* @__PURE__ */ getAugmentedNamespace(last$1);
function baseSlice(array2, start2, end2) {
  var index2 = -1, length2 = array2.length;
  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }
  end2 = end2 > length2 ? length2 : end2;
  if (end2 < 0) {
    end2 += length2;
  }
  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);
  while (++index2 < length2) {
    result[index2] = array2[index2 + start2];
  }
  return result;
}
var reWhitespace = /\s/;
function trimmedEndIndex(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign2 = value < 0 ? -1 : 1;
    return sign2 * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
function drop(array2, n2, guard) {
  var length2 = array2 == null ? 0 : array2.length;
  if (!length2) {
    return [];
  }
  n2 = guard || n2 === void 0 ? 1 : toInteger(n2);
  return baseSlice(array2, n2 < 0 ? 0 : n2, length2);
}
var drop$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": drop
}, Symbol.toStringTag, { value: "Module" }));
var require$$7 = /* @__PURE__ */ getAugmentedNamespace(drop$1);
function baseTimes(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
function castFunction(value) {
  return typeof value == "function" ? value : identity;
}
var MAX_SAFE_INTEGER = 9007199254740991;
var MAX_ARRAY_LENGTH = 4294967295;
var nativeMin = Math.min;
function times(n2, iteratee) {
  n2 = toInteger(n2);
  if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
    return [];
  }
  var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin(n2, MAX_ARRAY_LENGTH);
  iteratee = castFunction(iteratee);
  n2 -= MAX_ARRAY_LENGTH;
  var result = baseTimes(length2, iteratee);
  while (++index2 < n2) {
    iteratee(index2);
  }
  return result;
}
var times$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": times
}, Symbol.toStringTag, { value: "Module" }));
var require$$8 = /* @__PURE__ */ getAugmentedNamespace(times$1);
function take(array2, n2, guard) {
  if (!(array2 && array2.length)) {
    return [];
  }
  n2 = guard || n2 === void 0 ? 1 : toInteger(n2);
  return baseSlice(array2, 0, n2 < 0 ? 0 : n2);
}
var take$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": take
}, Symbol.toStringTag, { value: "Module" }));
var require$$9 = /* @__PURE__ */ getAugmentedNamespace(take$1);
(function(exports2) {
  var _interopRequireDefault2 = interopRequireDefault.exports;
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2.sumArrayTill = sumArrayTill, exports2.calculateSegmentStops = calculateSegmentStops, exports2.calculateNeedleHeight = calculateNeedleHeight, exports2.calculateSegmentLabelCount = calculateSegmentLabelCount, exports2.calculateScale = calculateScale, exports2.calculateTicks = calculateTicks, exports2.formatCurrentValueText = formatCurrentValueText, exports2.deg2rad = deg2rad, exports2.centerTranslation = centerTranslation, exports2.getRadius = getRadius;
  var _isNumber2 = _interopRequireDefault2(require$$1$1), _sum2 = _interopRequireDefault2(require$$2$1), _isEmpty = _interopRequireDefault2(require$$2), _isArray = _interopRequireDefault2(require$$3), _head2 = _interopRequireDefault2(require$$5), _last2 = _interopRequireDefault2(require$$6), _drop2 = _interopRequireDefault2(require$$7), _times2 = _interopRequireDefault2(require$$8), _take2 = _interopRequireDefault2(require$$9), _d = require$$11;
  function sumArrayTill(a2, b10) {
    return (0, _sum2["default"])((0, _take2["default"])(a2, b10));
  }
  function calculateSegmentStops(a2) {
    var b10 = a2.tickData, c2 = a2.customSegmentStops, d2 = a2.min, e3 = a2.max;
    if (!(0, _isArray["default"])(c2) || (0, _isEmpty["default"])(c2))
      return b10;
    if ((0, _head2["default"])(c2) !== d2)
      throw new Error("First value should be equivalent to min value given. Current min value - ".concat(d2));
    if ((0, _last2["default"])(c2) !== e3)
      throw new Error("Last value should be equivalent to max value given. Current min value - ".concat(e3));
    var f2 = c2.map(function(a3, b11) {
      return 0 === b11 ? void 0 : (a3 - c2[b11 - 1]) / (e3 - d2);
    });
    return (0, _drop2["default"])(f2);
  }
  function calculateNeedleHeight(a2) {
    var b10 = a2.heightRatio, c2 = a2.radius;
    if (0 > b10 || 1 < b10)
      throw new Error("Invalid needleHeightRatio given - ".concat(b10));
    return Math.round(c2 * b10);
  }
  function calculateSegmentLabelCount(a2) {
    var b10 = a2.maxSegmentLabelCount, c2 = a2.segmentCount, d2 = parseInt(b10, 10), e3 = parseInt(c2, 10);
    return (0, _isNumber2["default"])(d2) && 0 <= d2 && d2 <= e3 ? d2 : e3;
  }
  function calculateScale(a2) {
    var b10 = a2.min, c2 = a2.max;
    a2.segments;
    return (0, _d.scaleLinear)().range([0, 1]).domain([b10, c2]);
  }
  function calculateTicks(a2, b10) {
    var c2 = b10.min, d2 = b10.max, e3 = b10.segments, f2 = [];
    f2 = a2.ticks(e3);
    var g2 = ((0, _last2["default"])(f2) !== d2 || e3 < f2.length) && 1 < f2.length;
    if (g2) {
      f2 = [c2], (0, _times2["default"])(e3, function(a3) {
        f2.push(c2 + (a3 + 1) * ((d2 - c2) / e3));
      });
    }
    return 1 === f2.length && (f2 = [c2, d2]), f2;
  }
  function formatCurrentValueText(a2, b10) {
    var c2 = b10.labelFormat(a2), d2 = b10.currentValuePlaceholderStyle;
    return b10.currentValueText.replace(d2, c2);
  }
  function deg2rad(a2) {
    return a2 * Math.PI / 180;
  }
  function centerTranslation(a2, b10, c2) {
    return "translate(".concat(a2 + b10, ", ").concat(a2 + c2, ")");
  }
  function getRadius(a2) {
    return a2.width / 2;
  }
})(util);
var enums = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2.Transition = exports2.CustomSegmentLabelPosition = void 0;
  var CustomSegmentLabelPosition = { Inside: "INSIDE", Outside: "OUTSIDE" };
  exports2.CustomSegmentLabelPosition = CustomSegmentLabelPosition;
  var Transition2 = { easeLinear: "easeLinear", easeQuadIn: "easeQuadIn", easeQuadOut: "easeQuadOut", easeQuadInOut: "easeQuadInOut", easeCubicIn: "easeCubicIn", easeCubicOut: "easeCubicOut", easeCubicInOut: "easeCubicInOut", easePolyIn: "easePolyIn", easePolyOut: "easePolyOut", easePolyInOut: "easePolyInOut", easeSinIn: "easeSinIn", easeSinOut: "easeSinOut", easeSinInOut: "easeSinInOut", easeExpIn: "easeExpIn", easeExpOut: "easeExpOut", easeExpInOut: "easeExpInOut", easeCircleIn: "easeCircleIn", easeCircleOut: "easeCircleOut", easeCircleInOut: "easeCircleInOut", easeBounceIn: "easeBounceIn", easeBounceOut: "easeBounceOut", easeBounceInOut: "easeBounceInOut", easeBackIn: "easeBackIn", easeBackOut: "easeBackOut", easeBackInOut: "easeBackInOut", easeElasticIn: "easeElasticIn", easeElasticOut: "easeElasticOut", easeElasticInOut: "easeElasticInOut", easeElastic: "easeElastic" };
  exports2.Transition = Transition2;
})(enums);
(function(exports2) {
  var _interopRequireDefault2 = interopRequireDefault.exports;
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2.updateConfig = exports2.getConfig = exports2.DEFAULT_PROPS = exports2.defaultSegmentValueFormatter = void 0;
  var _defineProperty2 = _interopRequireDefault2(defineProperty.exports), _d = require$$11, _util = util, _enums = enums;
  function ownKeys(a2, b10) {
    var c2 = Object.keys(a2);
    if (Object.getOwnPropertySymbols) {
      var d2 = Object.getOwnPropertySymbols(a2);
      b10 && (d2 = d2.filter(function(b11) {
        return Object.getOwnPropertyDescriptor(a2, b11).enumerable;
      })), c2.push.apply(c2, d2);
    }
    return c2;
  }
  function _objectSpread(a2) {
    for (var b10, c2 = 1; c2 < arguments.length; c2++)
      b10 = null == arguments[c2] ? {} : arguments[c2], c2 % 2 ? ownKeys(Object(b10), true).forEach(function(c3) {
        (0, _defineProperty2["default"])(a2, c3, b10[c3]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a2, Object.getOwnPropertyDescriptors(b10)) : ownKeys(Object(b10)).forEach(function(c3) {
        Object.defineProperty(a2, c3, Object.getOwnPropertyDescriptor(b10, c3));
      });
    return a2;
  }
  var defaultSegmentValueFormatter = function(a2) {
    return a2;
  };
  exports2.defaultSegmentValueFormatter = defaultSegmentValueFormatter;
  var DEFAULT_PROPS = { value: 0, minValue: 0, maxValue: 1e3, forceRender: false, width: 300, height: 300, paddingHorizontal: 0, paddingVertical: 0, fluidWidth: false, dimensionUnit: "px", segments: 5, maxSegmentLabels: -1, customSegmentStops: [], customSegmentLabels: [], needleColor: "steelblue", startColor: "#FF471A", endColor: "#33CC33", segmentColors: [], needleTransition: _enums.Transition.easeQuadInOut, needleTransitionDuration: 500, needleHeightRatio: 0.9, ringWidth: 60, textColor: "#666", valueFormat: "", segmentValueFormatter: defaultSegmentValueFormatter, currentValueText: "${value}", currentValuePlaceholderStyle: "${value}", labelFontSize: "14px", valueTextFontSize: "16px", valueTextFontWeight: "bold", svgAriaLabel: "React d3 speedometer" };
  exports2.DEFAULT_PROPS = DEFAULT_PROPS;
  var DEFAULT_CONFIG = { ringInset: 20, pointerWidth: 10, pointerTailLength: 5, minAngle: -90, maxAngle: 90, labelInset: 10 }, getConfig = function(a2) {
    var b10 = a2.PROPS, c2 = a2.parentWidth, d2 = a2.parentHeight, e3 = { width: b10.fluidWidth ? c2 : b10.width, height: b10.fluidWidth ? d2 : b10.height, paddingHorizontal: b10.paddingHorizontal, paddingVertical: b10.paddingVertical, dimensionUnit: b10.dimensionUnit, ringWidth: b10.ringWidth, minValue: b10.minValue, maxValue: b10.maxValue, needleColor: b10.needleColor, majorTicks: b10.segments, customSegmentStops: b10.customSegmentStops, customSegmentLabels: b10.customSegmentLabels, maxSegmentLabels: (0, _util.calculateSegmentLabelCount)({ maxSegmentLabelCount: b10.maxSegmentLabels, segmentCount: b10.segments }), segmentColors: b10.segmentColors, arcColorFn: 0 < b10.segmentColors.length ? (0, _d.scaleQuantize)(b10.segmentColors) : (0, _d.interpolateHsl)((0, _d.rgb)(b10.startColor), (0, _d.rgb)(b10.endColor)), needleTransition: b10.needleTransition, needleTransitionDuration: b10.needleTransitionDuration, needleHeightRatio: b10.needleHeightRatio, textColor: b10.textColor, labelFormat: (0, _d.format)(b10.valueFormat), segmentValueFormatter: b10.segmentValueFormatter, currentValueText: b10.currentValueText, currentValuePlaceholderStyle: b10.currentValuePlaceholderStyle, labelFontSize: b10.labelFontSize, valueTextFontSize: b10.valueTextFontSize, valueTextFontWeight: b10.valueTextFontWeight, svgAriaLabel: b10.svgAriaLabel };
    return Object.assign({}, DEFAULT_CONFIG, e3);
  };
  exports2.getConfig = getConfig;
  var updateConfig = function(a2, b10) {
    return _objectSpread(_objectSpread({}, a2), b10);
  };
  exports2.updateConfig = updateConfig;
})(config);
var render = {};
var getNeedleTransition = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2.getNeedleTransition = getNeedleTransition2;
  var _d = require$$11, _enums = enums;
  function getNeedleTransition2(a2) {
    return a2 === _enums.Transition.easeLinear ? _d.easeLinear : a2 === _enums.Transition.easeQuadIn ? _d.easeQuadIn : a2 === _enums.Transition.easeQuadOut ? _d.easeQuadOut : a2 === _enums.Transition.easeQuadInOut ? _d.easeQuadInOut : a2 === _enums.Transition.easeCubicIn ? _d.easeCubicIn : a2 === _enums.Transition.easeCubicOut ? _d.easeCubicOut : a2 === _enums.Transition.easeCubicInOut ? _d.easeCubicInOut : a2 === _enums.Transition.easePolyIn ? _d.easePolyIn : a2 === _enums.Transition.easePolyOut ? _d.easePolyOut : a2 === _enums.Transition.easePolyInOut ? _d.easePolyInOut : a2 === _enums.Transition.easeSinIn ? _d.easeSinIn : a2 === _enums.Transition.easeSinOut ? _d.easeSinOut : a2 === _enums.Transition.easeSinInOut ? _d.easeSinInOut : a2 === _enums.Transition.easeExpIn ? _d.easeExpIn : a2 === _enums.Transition.easeExpOut ? _d.easeExpOut : a2 === _enums.Transition.easeExpInOut ? _d.easeExpInOut : a2 === _enums.Transition.easeCircleIn ? _d.easeCircleIn : a2 === _enums.Transition.easeCircleOut ? _d.easeCircleOut : a2 === _enums.Transition.easeCircleInOut ? _d.easeCircleInOut : a2 === _enums.Transition.easeBounceIn ? _d.easeBounceIn : a2 === _enums.Transition.easeBounceOut ? _d.easeBounceOut : a2 === _enums.Transition.easeBounceInOut ? _d.easeBounceInOut : a2 === _enums.Transition.easeBackIn ? _d.easeBackIn : a2 === _enums.Transition.easeBackOut ? _d.easeBackOut : a2 === _enums.Transition.easeBackInOut ? _d.easeBackInOut : a2 === _enums.Transition.easeElasticIn ? _d.easeElasticIn : a2 === _enums.Transition.easeElasticOut ? _d.easeElasticOut : a2 === _enums.Transition.easeElasticInOut ? _d.easeElasticInOut : a2 === _enums.Transition.easeElastic ? _d.easeElastic : _d.easeQuadInOut;
  }
})(getNeedleTransition);
var configure = {};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second2) {
  if (first === second2) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second2)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (calledOnce && lastThis === this && isEqual2(newArgs, lastArgs)) {
      return lastResult;
    }
    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }
  return memoized;
}
var memoizeOne_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": memoizeOne
}, Symbol.toStringTag, { value: "Module" }));
var require$$1 = /* @__PURE__ */ getAugmentedNamespace(memoizeOne_esm);
(function(exports2) {
  var _interopRequireDefault2 = interopRequireDefault.exports;
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2.configureArc = exports2.configureTickData = exports2.configureTicks = exports2.configureScale = void 0;
  var _memoizeOne = _interopRequireDefault2(require$$1), _d = require$$11, _util = util, configureScale = (0, _memoizeOne["default"])(_configureScale);
  exports2.configureScale = configureScale;
  var configureTicks = (0, _memoizeOne["default"])(_configureTicks);
  exports2.configureTicks = configureTicks;
  var configureTickData = (0, _memoizeOne["default"])(_configureTickData);
  exports2.configureTickData = configureTickData;
  var configureArc = (0, _memoizeOne["default"])(_configureArc);
  exports2.configureArc = configureArc;
  function _configureScale(a2) {
    return (0, _util.calculateScale)({ min: a2.minValue, max: a2.maxValue, segments: a2.maxSegmentLabels });
  }
  function _configureTicks(a2) {
    var b10 = configureScale(a2), c2 = (0, _util.calculateTicks)(b10, { min: a2.minValue, max: a2.maxValue, segments: a2.maxSegmentLabels });
    return 0 < a2.customSegmentStops.length && 0 !== a2.maxSegmentLabels && (c2 = a2.customSegmentStops), c2;
  }
  function _configureTickData(a2) {
    var b10 = (0, _d.range)(a2.majorTicks).map(function() {
      return 1 / a2.majorTicks;
    }), c2 = (0, _util.calculateSegmentStops)({ tickData: b10, customSegmentStops: a2.customSegmentStops, min: a2.minValue, max: a2.maxValue });
    return c2;
  }
  function _configureArc(a2) {
    var b10 = configureTickData(a2), c2 = a2.maxAngle - a2.minAngle, d2 = a2.width / 2, e3 = (0, _d.arc)().innerRadius(d2 - a2.ringWidth - a2.ringInset).outerRadius(d2 - a2.ringInset).startAngle(function(e4, d4) {
      var f2 = (0, _util.sumArrayTill)(b10, d4);
      return (0, _util.deg2rad)(a2.minAngle + f2 * c2);
    }).endAngle(function(e4, d4) {
      var f2 = (0, _util.sumArrayTill)(b10, d4 + 1);
      return (0, _util.deg2rad)(a2.minAngle + f2 * c2);
    });
    return e3;
  }
})(configure);
(function(exports2) {
  var _interopRequireDefault2 = interopRequireDefault.exports;
  Object.defineProperty(exports2, "__esModule", { value: true }), exports2._renderLabels = _renderLabels, exports2.render = exports2.update = void 0;
  var _d = require$$11, _isEmpty = _interopRequireDefault2(require$$2), _isArray = _interopRequireDefault2(require$$3), _util = util, _getNeedleTransition = getNeedleTransition, _configure = configure, update = function(a2) {
    var b10 = a2.d3_refs, c2 = a2.newValue, d2 = a2.config, e3 = (0, _configure.configureScale)(d2), f2 = e3(c2), g2 = d2.maxAngle - d2.minAngle, h2 = d2.minAngle + f2 * g2;
    b10.pointer.transition().duration(d2.needleTransitionDuration).ease((0, _getNeedleTransition.getNeedleTransition)(d2.needleTransition)).attr("transform", "rotate(".concat(h2, ")")), b10.current_value_text.text((0, _util.formatCurrentValueText)(c2, d2));
  };
  exports2.update = update;
  var render2 = function(a2) {
    var b10 = a2.container, c2 = a2.config, d2 = (0, _util.getRadius)(c2), e3 = (0, _util.centerTranslation)(d2, c2.paddingHorizontal, c2.paddingVertical), f2 = _renderSVG({ container: b10, config: c2 });
    return _renderArcs({ config: c2, svg: f2, centerTx: e3 }), _renderLabels({ config: c2, svg: f2, centerTx: e3, r: d2 }), { current_value_text: _renderCurrentValueText({ config: c2, svg: f2 }), pointer: _renderNeedle({ config: c2, svg: f2, r: d2, centerTx: e3 }) };
  };
  exports2.render = render2;
  function _renderSVG(a2) {
    var b10 = a2.container, c2 = a2.config, d2 = c2.width + 2 * c2.paddingHorizontal, e3 = c2.height + 2 * c2.paddingVertical;
    return (0, _d.select)(b10).append("svg:svg").attr("class", "speedometer").attr("width", "".concat(d2).concat(c2.dimensionUnit)).attr("height", "".concat(e3).concat(c2.dimensionUnit)).attr("role", "img").attr("focusable", "false").attr("aria-label", c2.svgAriaLabel).style("width", "".concat(d2).concat(c2.dimensionUnit)).style("height", "".concat(e3).concat(c2.dimensionUnit));
  }
  function _renderArcs(a2) {
    var b10 = a2.config, c2 = a2.svg, d2 = a2.centerTx, e3 = (0, _configure.configureTickData)(b10), f2 = (0, _configure.configureArc)(b10), g2 = c2.append("g").attr("class", "arc").attr("transform", d2);
    g2.selectAll("path").data(e3).enter().append("path").attr("class", "speedo-segment").attr("fill", function(a3, c3) {
      return !(0, _isEmpty["default"])(b10.segmentColors) && b10.segmentColors[c3] ? b10.segmentColors[c3] : b10.arcColorFn(a3 * c3);
    }).attr("d", f2);
  }
  function _renderLabels(a2) {
    var b10 = a2.config, c2 = a2.svg, d2 = a2.centerTx, e3 = a2.r, f2 = (0, _configure.configureTicks)(b10), g2 = (0, _configure.configureTickData)(b10), h2 = (0, _configure.configureScale)(b10), j = b10.maxAngle - b10.minAngle, k2 = b10.customSegmentLabels, l2 = (0, _isArray["default"])(k2) && !(0, _isEmpty["default"])(k2), m2 = l2 && k2.length === g2.length;
    if (l2 && !m2)
      throw new Error("Custom Segment Labels should be an array with length of ".concat(g2.length));
    if (l2 && m2)
      return void _renderCustomSegmentLabels({ config: b10, svg: c2, centerTx: d2, r: e3, ticks: f2, tickData: g2, scale: h2, range: j });
    var n2 = c2.append("g").attr("class", "label").attr("transform", d2);
    n2.selectAll("text").data(f2).enter().append("text").attr("transform", function(a3, c3) {
      var d4 = 0 === b10.customSegmentStops.length ? h2(a3) : (0, _util.sumArrayTill)(g2, c3), f3 = b10.minAngle + d4 * j;
      return "rotate(".concat(f3, ") translate(0, ").concat(b10.labelInset - e3, ")");
    }).text(function(a3) {
      return b10.segmentValueFormatter(b10.labelFormat(a3));
    }).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", b10.labelFontSize).style("font-weight", "bold").style("fill", b10.textColor);
  }
  function _renderCustomSegmentLabels(a2) {
    function b10(a3, b11) {
      var d4 = 0 === l2.length ? j(a3) : (0, _util.sumArrayTill)(h2, b11), e4 = c2.minAngle + d4 * k2;
      return e4;
    }
    var c2 = a2.config, d2 = a2.svg, e3 = a2.centerTx, f2 = a2.r, g2 = a2.ticks, h2 = a2.tickData, j = a2.scale, k2 = a2.range, l2 = c2.customSegmentStops, m2 = c2.customSegmentLabels, n2 = m2.map(function(a3, c3) {
      var d4 = c3, e4 = c3 + 1, f3 = g2[d4], h3 = b10(f3, d4), i = g2[e4], j2 = b10(i, e4);
      return (j2 + h3) / 2;
    }), o = f2 - c2.ringWidth - c2.ringInset, p2 = f2 - c2.ringInset, q2 = d2.append("g").attr("class", "label").attr("transform", e3);
    q2.selectAll("text").data(m2).enter().append("text").attr("transform", function(a3, b11) {
      var d4 = n2[b11], e4 = "rotate(".concat(d4, ") translate(0, ").concat(c2.labelInset - f2, ")"), g3 = "rotate(".concat(d4, ") translate(0, ").concat(c2.labelInset / 2 - (p2 - (p2 - o) / 2), ")");
      return "OUTSIDE" === a3.position ? e4 : g3;
    }).text(function(a3) {
      return a3.text || "";
    }).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", function(a3) {
      return a3.fontSize || c2.labelFontSize;
    }).style("font-weight", "bold").style("fill", function(a3) {
      return a3.color || c2.textColor;
    });
  }
  function _renderCurrentValueText(a2) {
    var b10 = a2.config, c2 = a2.svg, d2 = (b10.width + 2 * b10.paddingHorizontal) / 2, e3 = (b10.width + 4 * b10.paddingVertical) / 2;
    return c2.append("g").attr("transform", "translate(".concat(d2, ", ").concat(e3, ")")).append("text").attr("class", "current-value").attr("text-anchor", "middle").attr("y", 23).text(b10.currentValue).style("font-size", b10.valueTextFontSize).style("font-weight", b10.valueTextFontWeight).style("fill", b10.textColor);
  }
  function _renderNeedle(a2) {
    var b10 = a2.config, c2 = a2.svg, d2 = a2.r, e3 = a2.centerTx, f2 = (0, _util.calculateNeedleHeight)({ heightRatio: b10.needleHeightRatio, radius: d2 }), g2 = [[b10.pointerWidth / 2, 0], [0, -f2], [-(b10.pointerWidth / 2), 0], [0, b10.pointerTailLength], [b10.pointerWidth / 2, 0]], h2 = (0, _d.line)().curve(_d.curveMonotoneX), i = c2.append("g").data([g2]).attr("class", "pointer").attr("transform", e3).style("fill", b10.needleColor);
    return i.append("path").attr("d", h2).attr("transform", "rotate(".concat(b10.minAngle, ")"));
  }
})(render);
(function(exports2) {
  var _interopRequireWildcard2 = interopRequireWildcard.exports, _interopRequireDefault2 = interopRequireDefault.exports;
  Object.defineProperty(exports2, "__esModule", { value: true }), Object.defineProperty(exports2, "CustomSegmentLabelPosition", { enumerable: true, get: function get2() {
    return _enums.CustomSegmentLabelPosition;
  } }), Object.defineProperty(exports2, "Transition", { enumerable: true, get: function get2() {
    return _enums.Transition;
  } }), exports2["default"] = void 0;
  var _classCallCheck2 = _interopRequireDefault2(classCallCheck.exports), _createClass2 = _interopRequireDefault2(createClass.exports), _assertThisInitialized2 = _interopRequireDefault2(assertThisInitialized.exports), _inherits2 = _interopRequireDefault2(inherits.exports), _possibleConstructorReturn2 = _interopRequireDefault2(possibleConstructorReturn.exports), _getPrototypeOf2 = _interopRequireDefault2(getPrototypeOf.exports), _defineProperty2 = _interopRequireDefault2(defineProperty.exports), _react2 = _interopRequireWildcard2(React__default), _propTypes2 = _interopRequireDefault2(propTypes.exports), _d = require$$11, _config = config, _render = render, _enums = enums;
  function _createSuper(a2) {
    var b10 = _isNativeReflectConstruct();
    return function() {
      var c2, d2 = (0, _getPrototypeOf2["default"])(a2);
      if (b10) {
        var e3 = (0, _getPrototypeOf2["default"])(this).constructor;
        c2 = Reflect.construct(d2, arguments, e3);
      } else
        c2 = d2.apply(this, arguments);
      return (0, _possibleConstructorReturn2["default"])(this, c2);
    };
  }
  function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if ("function" == typeof Proxy)
      return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (a2) {
      return false;
    }
  }
  var ReactSpeedometer2 = function(a2) {
    function b10(a3) {
      var d2;
      return (0, _classCallCheck2["default"])(this, b10), d2 = c2.call(this, a3), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d2), "render", function() {
        return _react2["default"].createElement("div", { ref: function ref(a4) {
          return d2.gaugeDiv = a4;
        } });
      }), d2.d3_refs = { pointer: false, current_value_text: false }, d2;
    }
    (0, _inherits2["default"])(b10, a2);
    var c2 = _createSuper(b10);
    return (0, _createClass2["default"])(b10, [{ key: "componentDidMount", value: function componentDidMount() {
      this.renderGauge();
    } }, { key: "componentDidUpdate", value: function componentDidUpdate() {
      this.props.forceRender ? this.renderGauge() : this.updateReadings();
    } }, { key: "renderGauge", value: function renderGauge() {
      this.config = (0, _config.getConfig)({ PROPS: this.props, parentWidth: this.gaugeDiv.parentNode.clientWidth, parentHeight: this.gaugeDiv.parentNode.clientHeight }), (0, _d.select)(this.gaugeDiv).select("svg").remove(), this.d3_refs = (0, _render.render)({ container: this.gaugeDiv, config: this.config }), (0, _render.update)({ d3_refs: this.d3_refs, newValue: this.props.value, config: this.config });
    } }, { key: "updateReadings", value: function updateReadings() {
      this.config = (0, _config.updateConfig)(this.config, { labelFormat: (0, _d.format)(this.props.valueFormat || ""), segmentValueFormatter: this.props.segmentValueFormatter || _config.defaultSegmentValueFormatter, currentValueText: this.props.currentValueText || "${value}" }), (0, _render.update)({ d3_refs: this.d3_refs, newValue: this.props.value || 0, config: this.config });
    } }]), b10;
  }(_react2.PureComponent);
  (0, _defineProperty2["default"])(ReactSpeedometer2, "displayName", "ReactSpeedometer"), ReactSpeedometer2.propTypes = { value: _propTypes2["default"].number.isRequired, minValue: _propTypes2["default"].number.isRequired, maxValue: _propTypes2["default"].number.isRequired, forceRender: _propTypes2["default"].bool.isRequired, width: _propTypes2["default"].number.isRequired, height: _propTypes2["default"].number.isRequired, paddingHorizontal: _propTypes2["default"].number.isRequired, paddingVertical: _propTypes2["default"].number.isRequired, dimensionUnit: _propTypes2["default"].string.isRequired, fluidWidth: _propTypes2["default"].bool.isRequired, segments: _propTypes2["default"].number.isRequired, maxSegmentLabels: _propTypes2["default"].number, customSegmentStops: _propTypes2["default"].array, customSegmentLabels: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({ text: _propTypes2["default"].string, position: _propTypes2["default"].oneOf(["OUTSIDE", "INSIDE"]), fontSize: _propTypes2["default"].string, color: _propTypes2["default"].string })), needleColor: _propTypes2["default"].string.isRequired, startColor: _propTypes2["default"].string.isRequired, endColor: _propTypes2["default"].string.isRequired, segmentColors: _propTypes2["default"].array.isRequired, needleTransition: _propTypes2["default"].string.isRequired, needleTransitionDuration: _propTypes2["default"].number.isRequired, needleHeightRatio: _propTypes2["default"].number.isRequired, ringWidth: _propTypes2["default"].number.isRequired, textColor: _propTypes2["default"].string.isRequired, valueFormat: _propTypes2["default"].string.isRequired, segmentValueFormatter: _propTypes2["default"].func, currentValueText: _propTypes2["default"].string.isRequired, currentValuePlaceholderStyle: _propTypes2["default"].string.isRequired, labelFontSize: _propTypes2["default"].string.isRequired, valueTextFontSize: _propTypes2["default"].string.isRequired, valueTextFontWeight: _propTypes2["default"].string.isRequired, svgAriaLabel: _propTypes2["default"].string }, ReactSpeedometer2.defaultProps = _config.DEFAULT_PROPS;
  var _default2 = ReactSpeedometer2;
  exports2["default"] = _default2;
})(dist$1);
var ReactSpeedometer = /* @__PURE__ */ getDefaultExportFromCjs(dist$1);
const SpeedoMeter = ({
  value,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t5, _u, _v, _w;
  return /* @__PURE__ */ jsxs("div", {
    style: {
      ...(_a = value == null ? void 0 : value.style) == null ? void 0 : _a.containerStyle,
      background: theme.palette.secondary.main
    },
    children: [((_b = value == null ? void 0 : value.main) == null ? void 0 : _b.header) && /* @__PURE__ */ jsx$1("div", {
      style: {
        fontWeight: 700,
        textAlign: "left",
        fontFamily: "inherit",
        fontSize: "18px",
        color: theme.palette.text.primary || "#121926",
        ...(_c = value == null ? void 0 : value.style) == null ? void 0 : _c.headerStyle
      },
      children: value.main.header
    }), /* @__PURE__ */ jsx$1("div", {
      style: {
        width: "100%",
        minWidth: 500,
        display: "flex",
        justifyContent: "center",
        overflow: "auto"
      },
      children: /* @__PURE__ */ jsx$1(ReactSpeedometer, {
        forceRender: true,
        segmentColors: (_d = value == null ? void 0 : value.style) == null ? void 0 : _d.segmentColors,
        maxValue: ((_f = (_e = value == null ? void 0 : value.main) == null ? void 0 : _e.data) == null ? void 0 : _f.maxValue) || 500,
        width: ((_g = value == null ? void 0 : value.style) == null ? void 0 : _g.width) || 500,
        needleHeightRatio: ((_h = value == null ? void 0 : value.style) == null ? void 0 : _h.needleHeightRatio) || 0.7,
        currentValueText: (_i = value == null ? void 0 : value.main) == null ? void 0 : _i.currentValueText,
        customSegmentLabels: (_j = value == null ? void 0 : value.main) == null ? void 0 : _j.customSegmentLabel,
        ringWidth: ((_k = value == null ? void 0 : value.style) == null ? void 0 : _k.ringWidth) || 37,
        needleTransitionDuration: ((_l = value == null ? void 0 : value.style) == null ? void 0 : _l.needleTransitionDuration) || 5333,
        height: (_m = value == null ? void 0 : value.style) == null ? void 0 : _m.height,
        needleTransition: ((_n = value == null ? void 0 : value.style) == null ? void 0 : _n.needleTransition) || "easeElastic",
        value: ((_p = (_o = value == null ? void 0 : value.main) == null ? void 0 : _o.data) == null ? void 0 : _p.value) || 473,
        needleColor: ((_q = value == null ? void 0 : value.style) == null ? void 0 : _q.needleColor) || "red",
        minValue: ((_s = (_r = value == null ? void 0 : value.main) == null ? void 0 : _r.data) == null ? void 0 : _s.minValue) || 0,
        startColor: ((_t5 = value == null ? void 0 : value.style) == null ? void 0 : _t5.startColor) || "red",
        segments: ((_u = value == null ? void 0 : value.main) == null ? void 0 : _u.segments) || 5,
        endColor: ((_v = value == null ? void 0 : value.style) == null ? void 0 : _v.endColor) || "green",
        textColor: ((_w = value == null ? void 0 : value.style) == null ? void 0 : _w.textColor) || "black"
      })
    })]
  });
};
function ImpaktAppsCard({
  value
}) {
  var _a, _b;
  const {
    uischema
  } = value;
  const uischemaData = (_a = uischema == null ? void 0 : uischema.config) == null ? void 0 : _a.main;
  const uischemaStyle = (_b = uischema == null ? void 0 : uischema.config) == null ? void 0 : _b.style;
  const rankStyle = {
    position: "absolute",
    top: "0px",
    right: "0px",
    color: "#0DF3C2",
    backgroundColor: "#333333",
    padding: "4px 8px",
    borderRadius: "3px 12px 4px 14px",
    fontWeight: "bold",
    ...uischemaStyle == null ? void 0 : uischemaStyle.rank
  };
  const descriptionStyle = {
    paddingBottom: "10px",
    textAlign: "center",
    maxHeight: 100,
    fontSize: "15px",
    fontWeight: "400",
    color: "gray",
    overflow: "auto",
    wordWrap: "break-word",
    "&::-webkit-scrollbar": {
      display: "none"
    },
    ...uischemaStyle == null ? void 0 : uischemaStyle.description
  };
  const nameStyle = {
    color: "#3747A6",
    backgroundColor: "#eae9e9",
    marginTop: "8px",
    padding: "0px 12px",
    textAlign: "center",
    borderRadius: "8px",
    fontWeight: "700",
    ...uischemaStyle == null ? void 0 : uischemaStyle.name
  };
  const cardStyle = {
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    minWidth: 280,
    maxWidth: 280,
    minHeight: 290,
    maxHeight: 290,
    position: "relative",
    borderRadius: "12px",
    ...uischemaStyle == null ? void 0 : uischemaStyle.card
  };
  const containerStyle = {
    backgroundColor: "#ebebff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    padding: "5px"
  };
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1(Box$1, {
      sx: containerStyle,
      children: /* @__PURE__ */ jsx$1(Card$1, {
        sx: cardStyle,
        children: /* @__PURE__ */ jsxs(CardActionArea$1, {
          children: [/* @__PURE__ */ jsx$1(CardMedia$1, {
            component: "img",
            height: "140",
            image: "https://cdn.onlinewebfonts.com/svg/img_296570.png",
            style: {
              objectFit: "contain",
              paddingTop: "15px"
            },
            alt: "green iguana"
          }), /* @__PURE__ */ jsxs(CardContent$1, {
            children: [/* @__PURE__ */ jsx$1(Typography$1, {
              sx: rankStyle,
              children: "# " + (uischemaData == null ? void 0 : uischemaData.rank) || "#"
            }), /* @__PURE__ */ jsx$1(Typography$1, {
              gutterBottom: true,
              variant: "h6",
              component: "div",
              sx: nameStyle,
              children: uischemaData == null ? void 0 : uischemaData.name
            }), /* @__PURE__ */ jsx$1(Typography$1, {
              variant: "body2",
              color: "text.secondary",
              sx: descriptionStyle,
              children: uischemaData == null ? void 0 : uischemaData.description
            })]
          })]
        })
      })
    })
  });
}
const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};
const describeArc = (x2, y2, radius, startAngle, endAngle) => {
  const start2 = polarToCartesian(x2, y2, radius, endAngle);
  const end2 = polarToCartesian(x2, y2, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
  return ["M", start2.x, start2.y, "A", radius, radius, 0, largeArcFlag, 0, end2.x, end2.y].join(" ");
};
const CircleArcRing = ({
  strokeWidth = 10,
  startAngle = 0,
  endAngle = 180,
  style: style2 = {},
  theme
}) => {
  const size = 100;
  const radius = (size - strokeWidth) / 2;
  const arcPath = describeArc(size / 2, size / 2, radius, startAngle, endAngle);
  return /* @__PURE__ */ jsx$1("div", {
    style: {
      ...style2,
      position: "relative"
    },
    children: /* @__PURE__ */ jsxs("svg", {
      viewBox: `0 0 ${size} ${size}`,
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        width: "100%",
        height: "100%"
      },
      children: [/* @__PURE__ */ jsx$1("circle", {
        cx: size / 2,
        cy: size / 2,
        r: radius,
        fill: "none",
        stroke: theme.palette.grey[300],
        strokeWidth
      }), /* @__PURE__ */ jsx$1("path", {
        d: arcPath,
        fill: "none",
        stroke: theme.palette.primary.main,
        strokeWidth
      })]
    })
  });
};
const CustomTimer = ({
  value,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const {
    uischema,
    data
  } = value;
  const startDate = new Date((data == null ? void 0 : data.startDate) || 0).getTime();
  const endDate = new Date((data == null ? void 0 : data.endDate) || 0).getTime();
  const currentDate = new Date().getTime();
  const Total_Days = Math.floor((endDate - startDate) / (1e3 * 3600 * 24));
  const uischemaStyle = (_a = uischema == null ? void 0 : uischema.config) == null ? void 0 : _a.style;
  const [remainingDays, setRemainingDays] = useState(0);
  const [remainingMin, setRemainingMin] = useState(0);
  const [remainingSec, setRemainingSec] = useState(0);
  const [remainingHour, setRemainingHour] = useState(0);
  const [interval2, setInter] = useState();
  useEffect(() => {
    if (startDate < currentDate && endDate > currentDate) {
      const currentDate2 = new Date();
      const Difference_In_Time = endDate - currentDate2.getTime();
      const Difference_In_Days = Difference_In_Time / (1e3 * 3600 * 24);
      setRemainingDays(Math.floor(Difference_In_Days));
      setInter(setInterval(() => {
        const currdate = new Date();
        setRemainingHour(currdate.getHours());
        setRemainingMin(currdate.getMinutes());
        setRemainingSec(currdate.getSeconds());
      }, 1e3));
      return () => {
        clearInterval(interval2);
      };
    } else {
      setRemainingDays(0);
      setRemainingHour(0);
      setRemainingMin(0);
      setRemainingSec(0);
    }
  }, [startDate, endDate, data]);
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transport",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    height: "100%",
    ...uischemaStyle == null ? void 0 : uischemaStyle.container
  };
  const digitStyle = {
    position: "absolute",
    textAlign: "center",
    color: theme.palette.grey[600],
    fontWeight: "bold",
    fontSize: "clamp(1rem, 5cqw, 2rem)",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -60%)",
    lineHeight: 1,
    ...uischemaStyle == null ? void 0 : uischemaStyle.digit
  };
  const digitLabelStyle = {
    fontSize: "0.8rem",
    textAlign: "center",
    fontWeight: "bold",
    color: theme.palette.grey[600],
    textTransform: "uppercase",
    ...uischemaStyle == null ? void 0 : uischemaStyle.digitLabel
  };
  const containerLabelStyle = {
    margin: 0,
    fontSize: theme.typography.fontSize * 1.5,
    fontWeight: "bold",
    ...uischemaStyle == null ? void 0 : uischemaStyle.containerLabelStyle
  };
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsxs(Box$1, {
      component: "div",
      sx: containerStyle,
      children: [/* @__PURE__ */ jsx$1(Box$1, {
        style: containerLabelStyle,
        children: currentDate >= startDate && currentDate <= endDate ? (_d = (_c = (_b = uischema.config) == null ? void 0 : _b.main) == null ? void 0 : _c.ongoingMsg) != null ? _d : "Program ends in..." : currentDate < startDate ? (_g = (_f = (_e = uischema.config) == null ? void 0 : _e.main) == null ? void 0 : _f.notStartedMsg) != null ? _g : "Program Not Started Yet" : (_j = (_i = (_h = uischema.config) == null ? void 0 : _h.main) == null ? void 0 : _i.endedMsg) != null ? _j : "Program Over"
      }), /* @__PURE__ */ jsxs(Box$1, {
        style: {
          display: "flex",
          gap: "15px",
          width: "80%",
          maxWidth: "650px",
          marginLeft: "auto",
          marginRight: "auto",
          justifyContent: "center"
        },
        children: [/* @__PURE__ */ jsxs(Box$1, {
          sx: {
            width: "20%",
            height: "auto"
          },
          children: [/* @__PURE__ */ jsxs(Box$1, {
            sx: {
              width: "100%",
              height: "auto",
              position: "relative"
            },
            children: [/* @__PURE__ */ jsx$1(CircleArcRing, {
              strokeWidth: 10,
              startAngle: 0,
              endAngle: remainingDays / Total_Days * 360,
              style: {
                width: "100%",
                height: "auto"
              },
              theme
            }), /* @__PURE__ */ jsxs(Box$1, {
              sx: digitStyle,
              children: [remainingDays === 0 ? 0 : remainingDays < 10 ? 0 : Math.floor(remainingDays / 10), remainingDays === 0 ? 0 : remainingDays % 10]
            })]
          }), /* @__PURE__ */ jsx$1(Box$1, {
            sx: digitLabelStyle,
            children: "Days"
          })]
        }), /* @__PURE__ */ jsxs(Box$1, {
          sx: {
            width: "20%",
            height: "auto"
          },
          children: [/* @__PURE__ */ jsxs(Box$1, {
            sx: {
              width: "100%",
              height: "auto",
              position: "relative"
            },
            children: [/* @__PURE__ */ jsx$1(CircleArcRing, {
              strokeWidth: 10,
              startAngle: 0,
              endAngle: (24 - remainingHour) * 15,
              style: {
                width: "100%",
                height: "auto"
              },
              theme
            }), /* @__PURE__ */ jsxs(Box$1, {
              sx: digitStyle,
              children: [remainingHour === 0 ? 0 : 24 - remainingHour < 10 ? 0 : Math.floor((24 - remainingHour) / 10), remainingHour === 0 ? 0 : (24 - remainingHour) % 10]
            })]
          }), /* @__PURE__ */ jsx$1(Box$1, {
            sx: digitLabelStyle,
            children: "Hours"
          })]
        }), /* @__PURE__ */ jsxs(Box$1, {
          sx: {
            width: "20%",
            height: "auto"
          },
          children: [/* @__PURE__ */ jsxs(Box$1, {
            sx: {
              width: "100%",
              height: "auto",
              position: "relative"
            },
            children: [/* @__PURE__ */ jsx$1(CircleArcRing, {
              strokeWidth: 10,
              startAngle: 0,
              endAngle: (60 - remainingMin) * 6,
              style: {
                width: "100%",
                height: "auto"
              },
              theme
            }), /* @__PURE__ */ jsxs(Box$1, {
              sx: digitStyle,
              children: [remainingMin === 0 ? 0 : 60 - remainingMin < 10 ? 0 : Math.floor((60 - remainingMin) / 10), remainingMin === 0 ? 0 : (60 - remainingMin) % 10]
            })]
          }), /* @__PURE__ */ jsx$1(Box$1, {
            sx: digitLabelStyle,
            children: "Minutes"
          })]
        }), /* @__PURE__ */ jsxs(Box$1, {
          sx: {
            width: "20%",
            height: "auto"
          },
          children: [/* @__PURE__ */ jsxs(Box$1, {
            sx: {
              width: "100%",
              height: "auto",
              position: "relative"
            },
            children: [/* @__PURE__ */ jsx$1(CircleArcRing, {
              strokeWidth: 10,
              startAngle: 0,
              endAngle: (60 - remainingSec) * 6,
              style: {
                width: "100%",
                height: "auto"
              },
              theme
            }), /* @__PURE__ */ jsxs(Box$1, {
              sx: digitStyle,
              children: [remainingSec === 0 ? 0 : 60 - remainingSec < 10 ? 0 : Math.floor((60 - remainingSec) / 10), remainingSec === 0 ? 0 : (60 - remainingSec) % 10]
            })]
          }), /* @__PURE__ */ jsx$1(Box$1, {
            sx: digitLabelStyle,
            children: "Seconds"
          })]
        })]
      })]
    })
  });
};
const LeftBordersSVG = ({
  theme
}) => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    viewBox: "0 0 300 450",
    style: {
      overflow: "visible",
      position: "absolute",
      top: "-5px",
      right: "-10px",
      width: "100px"
    },
    children: [/* @__PURE__ */ jsx$1("defs", {
      children: /* @__PURE__ */ jsx$1("style", {
        children: `
            .totdcls-3 {
              fill: ${theme.palette.primary.dark};
            }`
      })
    }), /* @__PURE__ */ jsx$1("g", {
      children: /* @__PURE__ */ jsx$1("g", {
        id: "Layer_1",
        children: /* @__PURE__ */ jsx$1("path", {
          className: "totdcls-3",
          d: "M200,450h-180.8c-1.1,0-2-1-2-2.2s.9-2.2,2-2.2h230.8c7.4,0,14.4-3.2,19.6-9s8.1-13.5,8.1-21.7v-354.9c0-8.2-2.9-15.9-8.1-21.7-5.2-5.8-12.2-9-19.6-9h-55.7c-1.1,0-2-1-2-2.2s.9-2.2,2-2.2h55.7c8.5,0,16.4,3.6,22.4,10.3s9.3,15.5,9.3,24.9v354.9c0,9.4-3.3,18.2-9.3,24.9-6,6.6-13.9,10.3-22.4,10.3Z"
        })
      })
    })]
  });
};
const RightBordersSVG = ({
  theme
}) => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    viewBox: "0 0 300 450",
    style: {
      overflow: "visible",
      position: "absolute",
      top: "-5px",
      left: "-5px",
      width: "100px"
    },
    children: [/* @__PURE__ */ jsx$1("defs", {
      children: /* @__PURE__ */ jsx$1("style", {
        children: `
            .totdcls-3 {
              fill: ${theme.palette.primary.dark};
            }`
      })
    }), /* @__PURE__ */ jsx$1("g", {
      children: /* @__PURE__ */ jsx$1("g", {
        id: "Layer_1",
        children: /* @__PURE__ */ jsx$1("path", {
          className: "totdcls-3",
          d: "M0,450h273.3c.8,0,1.4-.8,1.5-2,0-1.3-.6-2.4-1.4-2.4h-223c-5.3,0-10.5-3-14.4-8.6-4-5.8-6.1-13.7-6.1-22.1v-377.1c0-8.1,2-16.1,5.7-21.9,3.8-6,9-9.4,14.5-9.4h212.2c1.5-1.9.6-4.4-.7-4.4h-211.1c-6.2,0-12.2,3.6-16.7,10.2-4.4,6.6-6.8,15.5-6.8,24.9v377.1c0,9.5,2.3,18.7,6.7,25.4,4.4,6.7,10.2,10.4,16.3,10.4Z"
        })
      })
    })]
  });
};
const BulbSVG = ({
  theme
}) => {
  return /* @__PURE__ */ jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    viewBox: "0 0 65 100",
    style: {
      position: "absolute",
      top: "0px",
      overflow: "visible",
      width: "50px"
    },
    children: [/* @__PURE__ */ jsxs("defs", {
      children: [/* @__PURE__ */ jsx$1("style", {
        children: `.totdcls-1 {
              fill: url(#totd-linear-gradient-2);
            }
      
            .totdcls-2 {
              stroke: ${theme.palette.common.white};
              stroke-width: 2px;
              fill: transparent
            }

            .gtotdcls-2 {
              fill: transparent;
            }

            .gtotdcls-1:hover ~ .gtotdcls-2 {
              fill: ${theme.palette.common.white};
            }
      
            .totdcls-3 {
              fill: ${theme.palette.primary.dark};
            }
      
            .totdcls-4 {
              fill: none;
            }`
      }), /* @__PURE__ */ jsxs("linearGradient", {
        id: "totd-linear-gradient-2",
        x1: "0",
        y1: "1",
        x2: "0",
        y2: "0",
        gradientUnits: "objectBoundingBox",
        children: [/* @__PURE__ */ jsx$1("stop", {
          offset: "0",
          "stop-color": "#fbf5a5"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: "0",
          "stop-color": "#fbf4a1"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".2",
          "stop-color": "#fbf193"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".3",
          "stop-color": "#fcec7d"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".3",
          "stop-color": "#fce65e"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".4",
          "stop-color": "#fddd36"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".5",
          "stop-color": "#fed306"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".6",
          "stop-color": "#fed305"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".7",
          "stop-color": "#fcce0a"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".8",
          "stop-color": "#f8c119"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: ".9",
          "stop-color": "#f0ab32"
        }), /* @__PURE__ */ jsx$1("stop", {
          offset: "1",
          "stop-color": "#e68c54"
        })]
      })]
    }), /* @__PURE__ */ jsx$1("g", {
      children: /* @__PURE__ */ jsxs("g", {
        id: "Layer_1",
        children: [/* @__PURE__ */ jsxs("g", {
          className: "gtotdcls-1",
          children: [/* @__PURE__ */ jsx$1("path", {
            className: "totdcls-3",
            d: "M40,0.5h-15.3c-.2,0-.3-.1-.3-.2v-.2c-.1-.1,0-.3,0-.3,0,0,.1-.1.3-.1h12.5c.9,0,1.8-.6,2.2-1.4v-.2c.4-.7.3-1.6,0-2.2s-1.2-1.1-2-1.1h-9.8c-.2,0-.3-.1-.3-.3h0c0-.2,0-.3,0-.4,0,0,.1-.1.3-.1h6c.9,0,1.7-.5,2.1-1.3.4-.8.3-1.7-.2-2.4-.4-.6-1.1-.9-1.9-.9h-1.8v-31h-2v32c0,.6.4,1,1,1h2.8c.1,0,.2,0,.3.2.1.2,0,.3,0,.4,0,0-.1.2-.3.2h-6c-.7,0-1.4.3-1.9.9-.4.6-.6,1.3-.4,2.1h0c.3,1.1,1.2,1.8,2.3,1.8h9.8c.2,0,.3.1.3.2s0,.2,0,.3v.2c-.2.1-.3.2-.4.2h-12.5c-.8,0-1.5.4-1.9,1-.4.6-.6,1.4-.3,2.1v.2c.4,1,1.3,1.6,2.3,1.6h15.3c.6,0,1-.4,1-1s-.5-1-1-1Z"
          }), /* @__PURE__ */ jsx$1("path", {
            id: "SVGID",
            className: "totdcls-1",
            d: "M7.9,46.9c0,12.8,10.2,23.2,22.9,23.7,13.6.5,24.8-10.5,24.5-24.1-.2-7.9-4.2-14.9-10.3-19.1h0c-1.5-3.4-1.2-9.4-1.2-12,0-3.2-2.6-5.8-5.7-5.9h-12.7c-1.7,0-3.3.7-4.4,2-2.9,3.3-.3,11.1-2.3,15.6,0,0,0,0,0,0-6.4,4.2-10.7,11.5-10.7,19.8Z"
          }), /* @__PURE__ */ jsx$1("path", {
            className: "totdcls-2",
            d: "M37.1,40.8h0c-1.4,0-2.7-1-2.8-2.8l-1.1-7.5h-5.2l-1.1,7.5c0,1.8-1.4,2.7-2.8,2.8-1.4,0-2.8-.9-2.9-2.7,0-.4,0-.6,0-.7,0-.4-.1-4.9,2.1-7.2.8-.9,1.8-1.3,3.1-1.3h.4l3.9-26.4,3.9,26.4h.4c1.2,0,2.2.4,3.1,1.3,2.2,2.3,2.1,6.8,2.1,7.2,0,0,0,.3,0,.7,0,1.8-1.5,2.7-2.8,2.7ZM1494.7,165.5l1.1,7.4h0c0,1,.7,1.4,1.3,1.4.6,0,1.3-.3,1.3-1.2,0-.4,0-.6,0-.6h0c0,0,0-1.1-.2-2.5-.2-1.7-.8-2.9-1.5-3.7-.5-.6-1.2-.8-2-.8h-.2ZM1486.3,165.5c-.8,0-1.4.3-2,.8-.7.7-1.2,2-1.5,3.7-.2,1.3-.2,2.4-.2,2.4h0s0,.3,0,.6c0,.9.8,1.3,1.3,1.2.6,0,1.3-.4,1.3-1.3h0c0,0,1.1-7.5,1.1-7.5h-.2ZM1488.2,164h4.7l-2.4-16-2.4,16Z"
          })]
        }), /* @__PURE__ */ jsxs("g", {
          className: "gtotdcls-2",
          children: [/* @__PURE__ */ jsx$1("path", {
            d: "M30.6,75.4c.8,0,1.4.6,1.4,1.4,0,11.6.5,12.7-1.4,12.7s-1.4-.6-1.4-1.4c0-11.6-.5-12.7,1.4-12.7Z"
          }), /* @__PURE__ */ jsx$1("path", {
            d: "M58.6,46.8c0-.8.6-1.4,1.4-1.4,11.6,0,12.7-.5,12.7,1.4s-.6,1.4-1.4,1.4c-11.6,0-12.7.5-12.7-1.4Z"
          }), /* @__PURE__ */ jsx$1("path", {
            d: "M51.6,67.5c0-.2,1.1-.9,1.9-.2,9.1,7.1,10.3,7.4,9.2,8.9,0,.2-1.1.9-1.9.2-9.1-7.1-10.3-7.4-9.2-8.9Z"
          }), /* @__PURE__ */ jsx$1("path", {
            d: "M2.6,46.8c0-.8-.6-1.4-1.4-1.4-11.6,0-12.7-.5-12.7,1.4s.6,1.4,1.4,1.4c11.6,0,12.7.5,12.7-1.4Z"
          }), /* @__PURE__ */ jsx$1("path", {
            d: "M9.6,67.5c0-.2-1.1-.9-1.9-.2-9.1,7.1-10.3,7.4-9.2,8.9,0,.2,1.1.9,1.9.2,9.1-7.1,10.3-7.4,9.2-8.9Z"
          })]
        })]
      })
    })]
  });
};
const ThoughtOfTheDay = ({
  data,
  uischema,
  theme
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return /* @__PURE__ */ jsxs(Grid$3, {
    container: true,
    sx: {
      background: `linear-gradient(to bottom, ${theme.myTheme.palette.primary.dark},${theme.myTheme.palette.common.white})`,
      backgroundPosition: "center top -40px",
      backgroundSize: "100% 140%",
      overflow: "visible",
      justifyContent: "center",
      height: "150px",
      width: {
        xs: "97.6%",
        md: "99%"
      },
      borderRadius: theme.myTheme.shape.borderRadius,
      position: "relative",
      margin: `0px`,
      marginTop: theme.myTheme.spacing(4),
      ...(_a = uischema.config) == null ? void 0 : _a.style
    },
    children: [/* @__PURE__ */ jsx$1(LeftBordersSVG, {
      theme: theme.myTheme
    }), /* @__PURE__ */ jsx$1(RightBordersSVG, {
      theme: theme.myTheme
    }), /* @__PURE__ */ jsx$1(BulbSVG, {
      theme: theme.myTheme
    }), /* @__PURE__ */ jsx$1(Typography$1, {
      sx: {
        position: "absolute",
        top: "45%",
        fontWeight: "bolder",
        ...(_c = (_b = uischema.config) == null ? void 0 : _b.style) == null ? void 0 : _c.labelStyle
      },
      children: (_f = (_e = (_d = uischema.config) == null ? void 0 : _d.main) == null ? void 0 : _e.label) != null ? _f : "Thought of the day"
    }), /* @__PURE__ */ jsx$1(Typography$1, {
      sx: {
        position: "absolute",
        top: "60%",
        textAlign: "center",
        ...(_h = (_g = uischema.config) == null ? void 0 : _g.style) == null ? void 0 : _h.thoughtStyle
      },
      children: (data == null ? void 0 : data.thought) || ((_i = uischema.config.main) == null ? void 0 : _i.thought)
    })]
  });
};
export { AreaGraph, BarGraph, ImpaktAppsCard as Card, HorizontalBarGraph, LineGraph, PieGraph, ProgressBar, SpeedoMeter, StackBarLineGraph, ThoughtOfTheDay, CustomTimer as Timer };
//# sourceMappingURL=impaktapps-design.es.js.map
